// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%2332325d%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.6%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27><path fill=%27#fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27#fff%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27><path stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;utf8,<svg width=%276%27 height=%2710%27 viewBox=%270 0 6 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z%27 fill=%27%234d7bca%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml;utf8,<svg width=%276%27 height=%2710%27 viewBox=%270 0 6 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z%27 fill=%27%238898aa%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2RiZGJkYiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlOGU4ZTgiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZlZmVmZSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmNWY1ZjUiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*******************************************************************************
 *              bootstrap-rtl (version 3.3.4)
 *      Author: Morteza Ansarinia (http://github.com/morteza)
 *  Created on: August 13,2015
 *     Project: bootstrap-rtl
 *   Copyright: Unlicensed Public Domain
 *******************************************************************************/
html.rtl {
  direction: rtl;
}

.rtl {
  /*# sourceMappingURL=bootstrap-rtl.css.map */
}

.rtl body {
  direction: rtl;
}

.rtl .flip.text-left {
  text-align: right;
}

.rtl .flip.text-right {
  text-align: left;
}

.rtl .list-unstyled {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}

.rtl .list-inline {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
  margin-right: -5px;
  margin-left: 0;
}

.rtl dd {
  margin-right: 0;
  margin-left: 0;
  margin-left: initial;
}

@media (min-width: 768px) {
  .rtl .dl-horizontal dt {
    float: right;
    clear: right;
    text-align: left;
  }

  .rtl .dl-horizontal dd {
    margin-right: 180px;
    margin-left: 0;
  }
}

.rtl blockquote {
  border-right: 5px solid #eeeeee;
  border-left: 0;
}

.rtl .blockquote-reverse,
.rtl blockquote.pull-left {
  padding-left: 15px;
  padding-right: 0;
  border-left: 5px solid #eeeeee;
  border-right: 0;
  text-align: left;
}

.rtl .col-xs-1,
.rtl .col-sm-1,
.rtl .col-md-1,
.rtl .col-lg-1,
.rtl .col-xs-2,
.rtl .col-sm-2,
.rtl .col-md-2,
.rtl .col-lg-2,
.rtl .col-xs-3,
.rtl .col-sm-3,
.rtl .col-md-3,
.rtl .col-lg-3,
.rtl .col-xs-4,
.rtl .col-sm-4,
.rtl .col-md-4,
.rtl .col-lg-4,
.rtl .col-xs-5,
.rtl .col-sm-5,
.rtl .col-md-5,
.rtl .col-lg-5,
.rtl .col-xs-6,
.rtl .col-sm-6,
.rtl .col-md-6,
.rtl .col-lg-6,
.rtl .col-xs-7,
.rtl .col-sm-7,
.rtl .col-md-7,
.rtl .col-lg-7,
.rtl .col-xs-8,
.rtl .col-sm-8,
.rtl .col-md-8,
.rtl .col-lg-8,
.rtl .col-xs-9,
.rtl .col-sm-9,
.rtl .col-md-9,
.rtl .col-lg-9,
.rtl .col-xs-10,
.rtl .col-sm-10,
.rtl .col-md-10,
.rtl .col-lg-10,
.rtl .col-xs-11,
.rtl .col-sm-11,
.rtl .col-md-11,
.rtl .col-lg-11,
.rtl .col-xs-12,
.rtl .col-sm-12,
.rtl .col-md-12,
.rtl .col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  padding-right: 15px;
}

.rtl .col-xs-1,
.rtl .col-xs-2,
.rtl .col-xs-3,
.rtl .col-xs-4,
.rtl .col-xs-5,
.rtl .col-xs-6,
.rtl .col-xs-7,
.rtl .col-xs-8,
.rtl .col-xs-9,
.rtl .col-xs-10,
.rtl .col-xs-11,
.rtl .col-xs-12 {
  float: right;
}

.rtl .col-xs-12 {
  width: 100%;
}

.rtl .col-xs-11 {
  width: 91.66666667%;
}

.rtl .col-xs-10 {
  width: 83.33333333%;
}

.rtl .col-xs-9 {
  width: 75%;
}

.rtl .col-xs-8 {
  width: 66.66666667%;
}

.rtl .col-xs-7 {
  width: 58.33333333%;
}

.rtl .col-xs-6 {
  width: 50%;
}

.rtl .col-xs-5 {
  width: 41.66666667%;
}

.rtl .col-xs-4 {
  width: 33.33333333%;
}

.rtl .col-xs-3 {
  width: 25%;
}

.rtl .col-xs-2 {
  width: 16.66666667%;
}

.rtl .col-xs-1 {
  width: 8.33333333%;
}

.rtl .col-xs-pull-12 {
  left: 100%;
  right: auto;
}

.rtl .col-xs-pull-11 {
  left: 91.66666667%;
  right: auto;
}

.rtl .col-xs-pull-10 {
  left: 83.33333333%;
  right: auto;
}

.rtl .col-xs-pull-9 {
  left: 75%;
  right: auto;
}

.rtl .col-xs-pull-8 {
  left: 66.66666667%;
  right: auto;
}

.rtl .col-xs-pull-7 {
  left: 58.33333333%;
  right: auto;
}

.rtl .col-xs-pull-6 {
  left: 50%;
  right: auto;
}

.rtl .col-xs-pull-5 {
  left: 41.66666667%;
  right: auto;
}

.rtl .col-xs-pull-4 {
  left: 33.33333333%;
  right: auto;
}

.rtl .col-xs-pull-3 {
  left: 25%;
  right: auto;
}

.rtl .col-xs-pull-2 {
  left: 16.66666667%;
  right: auto;
}

.rtl .col-xs-pull-1 {
  left: 8.33333333%;
  right: auto;
}

.rtl .col-xs-pull-0 {
  left: auto;
  right: auto;
}

.rtl .col-xs-push-12 {
  right: 100%;
  left: 0;
}

.rtl .col-xs-push-11 {
  right: 91.66666667%;
  left: 0;
}

.rtl .col-xs-push-10 {
  right: 83.33333333%;
  left: 0;
}

.rtl .col-xs-push-9 {
  right: 75%;
  left: 0;
}

.rtl .col-xs-push-8 {
  right: 66.66666667%;
  left: 0;
}

.rtl .col-xs-push-7 {
  right: 58.33333333%;
  left: 0;
}

.rtl .col-xs-push-6 {
  right: 50%;
  left: 0;
}

.rtl .col-xs-push-5 {
  right: 41.66666667%;
  left: 0;
}

.rtl .col-xs-push-4 {
  right: 33.33333333%;
  left: 0;
}

.rtl .col-xs-push-3 {
  right: 25%;
  left: 0;
}

.rtl .col-xs-push-2 {
  right: 16.66666667%;
  left: 0;
}

.rtl .col-xs-push-1 {
  right: 8.33333333%;
  left: 0;
}

.rtl .col-xs-push-0 {
  right: auto;
  left: 0;
}

.rtl .col-xs-offset-12 {
  margin-right: 100%;
  margin-left: 0;
}

.rtl .col-xs-offset-11 {
  margin-right: 91.66666667%;
  margin-left: 0;
}

.rtl .col-xs-offset-10 {
  margin-right: 83.33333333%;
  margin-left: 0;
}

.rtl .col-xs-offset-9 {
  margin-right: 75%;
  margin-left: 0;
}

.rtl .col-xs-offset-8 {
  margin-right: 66.66666667%;
  margin-left: 0;
}

.rtl .col-xs-offset-7 {
  margin-right: 58.33333333%;
  margin-left: 0;
}

.rtl .col-xs-offset-6 {
  margin-right: 50%;
  margin-left: 0;
}

.rtl .col-xs-offset-5 {
  margin-right: 41.66666667%;
  margin-left: 0;
}

.rtl .col-xs-offset-4 {
  margin-right: 33.33333333%;
  margin-left: 0;
}

.rtl .col-xs-offset-3 {
  margin-right: 25%;
  margin-left: 0;
}

.rtl .col-xs-offset-2 {
  margin-right: 16.66666667%;
  margin-left: 0;
}

.rtl .col-xs-offset-1 {
  margin-right: 8.33333333%;
  margin-left: 0;
}

.rtl .col-xs-offset-0 {
  margin-right: 0%;
  margin-left: 0;
}

@media (min-width: 768px) {

  .rtl .col-sm-1,
  .rtl .col-sm-2,
  .rtl .col-sm-3,
  .rtl .col-sm-4,
  .rtl .col-sm-5,
  .rtl .col-sm-6,
  .rtl .col-sm-7,
  .rtl .col-sm-8,
  .rtl .col-sm-9,
  .rtl .col-sm-10,
  .rtl .col-sm-11,
  .rtl .col-sm-12 {
    float: right;
  }

  .rtl .col-sm-12 {
    width: 100%;
  }

  .rtl .col-sm-11 {
    width: 91.66666667%;
  }

  .rtl .col-sm-10 {
    width: 83.33333333%;
  }

  .rtl .col-sm-9 {
    width: 75%;
  }

  .rtl .col-sm-8 {
    width: 66.66666667%;
  }

  .rtl .col-sm-7 {
    width: 58.33333333%;
  }

  .rtl .col-sm-6 {
    width: 50%;
  }

  .rtl .col-sm-5 {
    width: 41.66666667%;
  }

  .rtl .col-sm-4 {
    width: 33.33333333%;
  }

  .rtl .col-sm-3 {
    width: 25%;
  }

  .rtl .col-sm-2 {
    width: 16.66666667%;
  }

  .rtl .col-sm-1 {
    width: 8.33333333%;
  }

  .rtl .col-sm-pull-12 {
    left: 100%;
    right: auto;
  }

  .rtl .col-sm-pull-11 {
    left: 91.66666667%;
    right: auto;
  }

  .rtl .col-sm-pull-10 {
    left: 83.33333333%;
    right: auto;
  }

  .rtl .col-sm-pull-9 {
    left: 75%;
    right: auto;
  }

  .rtl .col-sm-pull-8 {
    left: 66.66666667%;
    right: auto;
  }

  .rtl .col-sm-pull-7 {
    left: 58.33333333%;
    right: auto;
  }

  .rtl .col-sm-pull-6 {
    left: 50%;
    right: auto;
  }

  .rtl .col-sm-pull-5 {
    left: 41.66666667%;
    right: auto;
  }

  .rtl .col-sm-pull-4 {
    left: 33.33333333%;
    right: auto;
  }

  .rtl .col-sm-pull-3 {
    left: 25%;
    right: auto;
  }

  .rtl .col-sm-pull-2 {
    left: 16.66666667%;
    right: auto;
  }

  .rtl .col-sm-pull-1 {
    left: 8.33333333%;
    right: auto;
  }

  .rtl .col-sm-pull-0 {
    left: auto;
    right: auto;
  }

  .rtl .col-sm-push-12 {
    right: 100%;
    left: 0;
  }

  .rtl .col-sm-push-11 {
    right: 91.66666667%;
    left: 0;
  }

  .rtl .col-sm-push-10 {
    right: 83.33333333%;
    left: 0;
  }

  .rtl .col-sm-push-9 {
    right: 75%;
    left: 0;
  }

  .rtl .col-sm-push-8 {
    right: 66.66666667%;
    left: 0;
  }

  .rtl .col-sm-push-7 {
    right: 58.33333333%;
    left: 0;
  }

  .rtl .col-sm-push-6 {
    right: 50%;
    left: 0;
  }

  .rtl .col-sm-push-5 {
    right: 41.66666667%;
    left: 0;
  }

  .rtl .col-sm-push-4 {
    right: 33.33333333%;
    left: 0;
  }

  .rtl .col-sm-push-3 {
    right: 25%;
    left: 0;
  }

  .rtl .col-sm-push-2 {
    right: 16.66666667%;
    left: 0;
  }

  .rtl .col-sm-push-1 {
    right: 8.33333333%;
    left: 0;
  }

  .rtl .col-sm-push-0 {
    right: auto;
    left: 0;
  }

  .rtl .col-sm-offset-12 {
    margin-right: 100%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-11 {
    margin-right: 91.66666667%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-10 {
    margin-right: 83.33333333%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-8 {
    margin-right: 66.66666667%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-7 {
    margin-right: 58.33333333%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-5 {
    margin-right: 41.66666667%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-4 {
    margin-right: 33.33333333%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-2 {
    margin-right: 16.66666667%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-1 {
    margin-right: 8.33333333%;
    margin-left: 0;
  }

  .rtl .col-sm-offset-0 {
    margin-right: 0%;
    margin-left: 0;
  }
}

@media (min-width: 992px) {

  .rtl .col-md-1,
  .rtl .col-md-2,
  .rtl .col-md-3,
  .rtl .col-md-4,
  .rtl .col-md-5,
  .rtl .col-md-6,
  .rtl .col-md-7,
  .rtl .col-md-8,
  .rtl .col-md-9,
  .rtl .col-md-10,
  .rtl .col-md-11,
  .rtl .col-md-12 {
    float: right;
  }

  .rtl .col-md-12 {
    width: 100%;
  }

  .rtl .col-md-11 {
    width: 91.66666667%;
  }

  .rtl .col-md-10 {
    width: 83.33333333%;
  }

  .rtl .col-md-9 {
    width: 75%;
  }

  .rtl .col-md-8 {
    width: 66.66666667%;
  }

  .rtl .col-md-7 {
    width: 58.33333333%;
  }

  .rtl .col-md-6 {
    width: 50%;
  }

  .rtl .col-md-5 {
    width: 41.66666667%;
  }

  .rtl .col-md-4 {
    width: 33.33333333%;
  }

  .rtl .col-md-3 {
    width: 25%;
  }

  .rtl .col-md-2 {
    width: 16.66666667%;
  }

  .rtl .col-md-1 {
    width: 8.33333333%;
  }

  .rtl .col-md-pull-12 {
    left: 100%;
    right: auto;
  }

  .rtl .col-md-pull-11 {
    left: 91.66666667%;
    right: auto;
  }

  .rtl .col-md-pull-10 {
    left: 83.33333333%;
    right: auto;
  }

  .rtl .col-md-pull-9 {
    left: 75%;
    right: auto;
  }

  .rtl .col-md-pull-8 {
    left: 66.66666667%;
    right: auto;
  }

  .rtl .col-md-pull-7 {
    left: 58.33333333%;
    right: auto;
  }

  .rtl .col-md-pull-6 {
    left: 50%;
    right: auto;
  }

  .rtl .col-md-pull-5 {
    left: 41.66666667%;
    right: auto;
  }

  .rtl .col-md-pull-4 {
    left: 33.33333333%;
    right: auto;
  }

  .rtl .col-md-pull-3 {
    left: 25%;
    right: auto;
  }

  .rtl .col-md-pull-2 {
    left: 16.66666667%;
    right: auto;
  }

  .rtl .col-md-pull-1 {
    left: 8.33333333%;
    right: auto;
  }

  .rtl .col-md-pull-0 {
    left: auto;
    right: auto;
  }

  .rtl .col-md-push-12 {
    right: 100%;
    left: 0;
  }

  .rtl .col-md-push-11 {
    right: 91.66666667%;
    left: 0;
  }

  .rtl .col-md-push-10 {
    right: 83.33333333%;
    left: 0;
  }

  .rtl .col-md-push-9 {
    right: 75%;
    left: 0;
  }

  .rtl .col-md-push-8 {
    right: 66.66666667%;
    left: 0;
  }

  .rtl .col-md-push-7 {
    right: 58.33333333%;
    left: 0;
  }

  .rtl .col-md-push-6 {
    right: 50%;
    left: 0;
  }

  .rtl .col-md-push-5 {
    right: 41.66666667%;
    left: 0;
  }

  .rtl .col-md-push-4 {
    right: 33.33333333%;
    left: 0;
  }

  .rtl .col-md-push-3 {
    right: 25%;
    left: 0;
  }

  .rtl .col-md-push-2 {
    right: 16.66666667%;
    left: 0;
  }

  .rtl .col-md-push-1 {
    right: 8.33333333%;
    left: 0;
  }

  .rtl .col-md-push-0 {
    right: auto;
    left: 0;
  }

  .rtl .col-md-offset-12 {
    margin-right: 100%;
    margin-left: 0;
  }

  .rtl .col-md-offset-11 {
    margin-right: 91.66666667%;
    margin-left: 0;
  }

  .rtl .col-md-offset-10 {
    margin-right: 83.33333333%;
    margin-left: 0;
  }

  .rtl .col-md-offset-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .col-md-offset-8 {
    margin-right: 66.66666667%;
    margin-left: 0;
  }

  .rtl .col-md-offset-7 {
    margin-right: 58.33333333%;
    margin-left: 0;
  }

  .rtl .col-md-offset-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .col-md-offset-5 {
    margin-right: 41.66666667%;
    margin-left: 0;
  }

  .rtl .col-md-offset-4 {
    margin-right: 33.33333333%;
    margin-left: 0;
  }

  .rtl .col-md-offset-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .col-md-offset-2 {
    margin-right: 16.66666667%;
    margin-left: 0;
  }

  .rtl .col-md-offset-1 {
    margin-right: 8.33333333%;
    margin-left: 0;
  }

  .rtl .col-md-offset-0 {
    margin-right: 0%;
    margin-left: 0;
  }
}

@media (min-width: 1200px) {

  .rtl .col-lg-1,
  .rtl .col-lg-2,
  .rtl .col-lg-3,
  .rtl .col-lg-4,
  .rtl .col-lg-5,
  .rtl .col-lg-6,
  .rtl .col-lg-7,
  .rtl .col-lg-8,
  .rtl .col-lg-9,
  .rtl .col-lg-10,
  .rtl .col-lg-11,
  .rtl .col-lg-12 {
    float: right;
  }

  .rtl .col-lg-12 {
    width: 100%;
  }

  .rtl .col-lg-11 {
    width: 91.66666667%;
  }

  .rtl .col-lg-10 {
    width: 83.33333333%;
  }

  .rtl .col-lg-9 {
    width: 75%;
  }

  .rtl .col-lg-8 {
    width: 66.66666667%;
  }

  .rtl .col-lg-7 {
    width: 58.33333333%;
  }

  .rtl .col-lg-6 {
    width: 50%;
  }

  .rtl .col-lg-5 {
    width: 41.66666667%;
  }

  .rtl .col-lg-4 {
    width: 33.33333333%;
  }

  .rtl .col-lg-3 {
    width: 25%;
  }

  .rtl .col-lg-2 {
    width: 16.66666667%;
  }

  .rtl .col-lg-1 {
    width: 8.33333333%;
  }

  .rtl .col-lg-pull-12 {
    left: 100%;
    right: auto;
  }

  .rtl .col-lg-pull-11 {
    left: 91.66666667%;
    right: auto;
  }

  .rtl .col-lg-pull-10 {
    left: 83.33333333%;
    right: auto;
  }

  .rtl .col-lg-pull-9 {
    left: 75%;
    right: auto;
  }

  .rtl .col-lg-pull-8 {
    left: 66.66666667%;
    right: auto;
  }

  .rtl .col-lg-pull-7 {
    left: 58.33333333%;
    right: auto;
  }

  .rtl .col-lg-pull-6 {
    left: 50%;
    right: auto;
  }

  .rtl .col-lg-pull-5 {
    left: 41.66666667%;
    right: auto;
  }

  .rtl .col-lg-pull-4 {
    left: 33.33333333%;
    right: auto;
  }

  .rtl .col-lg-pull-3 {
    left: 25%;
    right: auto;
  }

  .rtl .col-lg-pull-2 {
    left: 16.66666667%;
    right: auto;
  }

  .rtl .col-lg-pull-1 {
    left: 8.33333333%;
    right: auto;
  }

  .rtl .col-lg-pull-0 {
    left: auto;
    right: auto;
  }

  .rtl .col-lg-push-12 {
    right: 100%;
    left: 0;
  }

  .rtl .col-lg-push-11 {
    right: 91.66666667%;
    left: 0;
  }

  .rtl .col-lg-push-10 {
    right: 83.33333333%;
    left: 0;
  }

  .rtl .col-lg-push-9 {
    right: 75%;
    left: 0;
  }

  .rtl .col-lg-push-8 {
    right: 66.66666667%;
    left: 0;
  }

  .rtl .col-lg-push-7 {
    right: 58.33333333%;
    left: 0;
  }

  .rtl .col-lg-push-6 {
    right: 50%;
    left: 0;
  }

  .rtl .col-lg-push-5 {
    right: 41.66666667%;
    left: 0;
  }

  .rtl .col-lg-push-4 {
    right: 33.33333333%;
    left: 0;
  }

  .rtl .col-lg-push-3 {
    right: 25%;
    left: 0;
  }

  .rtl .col-lg-push-2 {
    right: 16.66666667%;
    left: 0;
  }

  .rtl .col-lg-push-1 {
    right: 8.33333333%;
    left: 0;
  }

  .rtl .col-lg-push-0 {
    right: auto;
    left: 0;
  }

  .rtl .col-lg-offset-12 {
    margin-right: 100%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-11 {
    margin-right: 91.66666667%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-10 {
    margin-right: 83.33333333%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-9 {
    margin-right: 75%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-8 {
    margin-right: 66.66666667%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-7 {
    margin-right: 58.33333333%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-6 {
    margin-right: 50%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-5 {
    margin-right: 41.66666667%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-4 {
    margin-right: 33.33333333%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-3 {
    margin-right: 25%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-2 {
    margin-right: 16.66666667%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-1 {
    margin-right: 8.33333333%;
    margin-left: 0;
  }

  .rtl .col-lg-offset-0 {
    margin-right: 0%;
    margin-left: 0;
  }
}

.rtl caption {
  text-align: right;
}

.rtl th {
  text-align: right;
}

@media screen and (max-width: 767px) {
  .rtl .table-responsive>.table-bordered {
    border: 0;
  }

  .rtl .table-responsive>.table-bordered>thead>tr>th:first-child,
  .rtl .table-responsive>.table-bordered>tbody>tr>th:first-child,
  .rtl .table-responsive>.table-bordered>tfoot>tr>th:first-child,
  .rtl .table-responsive>.table-bordered>thead>tr>td:first-child,
  .rtl .table-responsive>.table-bordered>tbody>tr>td:first-child,
  .rtl .table-responsive>.table-bordered>tfoot>tr>td:first-child {
    border-right: 0;
    border-left: 0;
    border-left: initial;
  }

  .rtl .table-responsive>.table-bordered>thead>tr>th:last-child,
  .rtl .table-responsive>.table-bordered>tbody>tr>th:last-child,
  .rtl .table-responsive>.table-bordered>tfoot>tr>th:last-child,
  .rtl .table-responsive>.table-bordered>thead>tr>td:last-child,
  .rtl .table-responsive>.table-bordered>tbody>tr>td:last-child,
  .rtl .table-responsive>.table-bordered>tfoot>tr>td:last-child {
    border-left: 0;
    border-right: 0;
    border-right: initial;
  }
}

.rtl .radio label,
.rtl .checkbox label {
  padding-right: 20px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .radio input[type="radio"],
.rtl .radio-inline input[type="radio"],
.rtl .checkbox input[type="checkbox"],
.rtl .checkbox-inline input[type="checkbox"] {
  margin-right: -20px;
  margin-left: auto;
}

.rtl .radio-inline,
.rtl .checkbox-inline {
  padding-right: 20px;
  padding-left: 0;
}

.rtl .radio-inline+.radio-inline,
.rtl .checkbox-inline+.checkbox-inline {
  margin-right: 10px;
  margin-left: 0;
}

.rtl .has-feedback .form-control {
  padding-left: 42.5px;
  padding-right: 12px;
}

.rtl .form-control-feedback {
  left: 0;
  right: auto;
}

@media (min-width: 768px) {
  .rtl .form-inline label {
    padding-right: 0;
    padding-left: 0;
    padding-left: initial;
  }

  .rtl .form-inline .radio input[type="radio"],
  .rtl .form-inline .checkbox input[type="checkbox"] {
    margin-right: 0;
    margin-left: auto;
  }
}

@media (min-width: 768px) {
  .rtl .form-horizontal .control-label {
    text-align: left;
  }
}

.rtl .form-horizontal .has-feedback .form-control-feedback {
  left: 15px;
  right: auto;
}

.rtl .caret {
  margin-right: 2px;
  margin-left: 0;
}

.rtl .dropdown-menu {
  right: 0;
  left: auto;
  float: left;
  text-align: right;
}

.rtl .dropdown-menu.pull-right {
  left: 0;
  right: auto;
  float: right;
}

.rtl .dropdown-menu-right {
  left: auto;
  right: 0;
}

.rtl .dropdown-menu-left {
  left: 0;
  right: auto;
}

@media (min-width: 768px) {
  .rtl .navbar-right .dropdown-menu {
    left: auto;
    right: 0;
  }

  .rtl .navbar-right .dropdown-menu-left {
    left: 0;
    right: auto;
  }
}

.rtl .btn-group>.btn,
.rtl .btn-group-vertical>.btn {
  float: right;
}

.rtl .btn-group .btn+.btn,
.rtl .btn-group .btn+.btn-group,
.rtl .btn-group .btn-group+.btn,
.rtl .btn-group .btn-group+.btn-group {
  margin-right: -1px;
  margin-left: 0px;
}

.rtl .btn-toolbar {
  margin-right: -5px;
  margin-left: 0px;
}

.rtl .btn-toolbar .btn-group,
.rtl .btn-toolbar .input-group {
  float: right;
}

.rtl .btn-toolbar>.btn,
.rtl .btn-toolbar>.btn-group,
.rtl .btn-toolbar>.input-group {
  margin-right: 5px;
  margin-left: 0px;
}

.rtl .btn-group>.btn:first-child {
  margin-right: 0;
}

.rtl .btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.rtl .btn-group>.btn:last-child:not(:first-child),
.rtl .btn-group>.dropdown-toggle:not(:first-child) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.rtl .btn-group>.btn-group {
  float: right;
}

.rtl .btn-group.btn-group-justified>.btn,
.rtl .btn-group.btn-group-justified>.btn-group {
  float: none;
}

.rtl .btn-group>.btn-group:not(:first-child):not(:last-child)>.btn {
  border-radius: 0;
}

.rtl .btn-group>.btn-group:first-child>.btn:last-child,
.rtl .btn-group>.btn-group:first-child>.dropdown-toggle {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.rtl .btn-group>.btn-group:last-child>.btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.rtl .btn .caret {
  margin-right: 0;
}

.rtl .btn-group-vertical>.btn+.btn,
.rtl .btn-group-vertical>.btn+.btn-group,
.rtl .btn-group-vertical>.btn-group+.btn,
.rtl .btn-group-vertical>.btn-group+.btn-group {
  margin-top: -1px;
  margin-right: 0;
}

.rtl .input-group .form-control {
  float: right;
}

.rtl .input-group .form-control:first-child,
.rtl .input-group-addon:first-child,
.rtl .input-group-btn:first-child>.btn,
.rtl .input-group-btn:first-child>.btn-group>.btn,
.rtl .input-group-btn:first-child>.dropdown-toggle,
.rtl .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.rtl .input-group-btn:last-child>.btn-group:not(:last-child)>.btn {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.rtl .input-group-addon:first-child {
  border-left: 0px;
  border-right: 1px solid;
}

.rtl .input-group .form-control:last-child,
.rtl .input-group-addon:last-child,
.rtl .input-group-btn:last-child>.btn,
.rtl .input-group-btn:last-child>.btn-group>.btn,
.rtl .input-group-btn:last-child>.dropdown-toggle,
.rtl .input-group-btn:first-child>.btn:not(:first-child),
.rtl .input-group-btn:first-child>.btn-group:not(:first-child)>.btn {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.rtl .input-group-addon:last-child {
  border-left-width: 1px;
  border-left-style: solid;
  border-right: 0px;
}

.rtl .input-group-btn>.btn+.btn {
  margin-right: -1px;
  margin-left: auto;
}

.rtl .input-group-btn:first-child>.btn,
.rtl .input-group-btn:first-child>.btn-group {
  margin-left: -1px;
  margin-right: auto;
}

.rtl .input-group-btn:last-child>.btn,
.rtl .input-group-btn:last-child>.btn-group {
  margin-right: -1px;
  margin-left: auto;
}

.rtl .nav {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}

.rtl .nav-tabs>li {
  float: right;
}

.rtl .nav-tabs>li>a {
  margin-left: auto;
  margin-right: -2px;
  border-radius: 4px 4px 0 0;
}

.rtl .nav-pills>li {
  float: right;
}

.rtl .nav-pills>li>a {
  border-radius: 4px;
}

.rtl .nav-pills>li+li {
  margin-right: 2px;
  margin-left: auto;
}

.rtl .nav-stacked>li {
  float: none;
}

.rtl .nav-stacked>li+li {
  margin-right: 0;
  margin-left: auto;
}

.rtl .nav-justified>.dropdown .dropdown-menu {
  right: auto;
}

.rtl .nav-tabs-justified>li>a {
  margin-left: 0;
  margin-right: auto;
}

@media (min-width: 768px) {
  .rtl .nav-tabs-justified>li>a {
    border-radius: 4px 4px 0 0;
  }
}

@media (min-width: 768px) {
  .rtl .navbar-header {
    float: right;
  }
}

.rtl .navbar-collapse {
  padding-right: 15px;
  padding-left: 15px;
}

.rtl .navbar-brand {
  float: right;
}

@media (min-width: 768px) {

  .rtl .navbar>.container .navbar-brand,
  .rtl .navbar>.container-fluid .navbar-brand,
  .rtl .navbar>.container-sm .navbar-brand,
  .rtl .navbar>.container-md .navbar-brand,
  .rtl .navbar>.container-lg .navbar-brand,
  .rtl .navbar>.container-xl .navbar-brand {
    margin-right: -15px;
    margin-left: auto;
  }
}

.rtl .navbar-toggle {
  float: left;
  margin-left: 15px;
  margin-right: auto;
}

@media (max-width: 767px) {

  .rtl .navbar-nav .open .dropdown-menu>li>a,
  .rtl .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 25px 5px 15px;
  }
}

@media (min-width: 768px) {
  .rtl .navbar-nav {
    float: right;
  }

  .rtl .navbar-right {
    float: left !important;
  }

  .rtl .navbar-left {
    float: right !important;
  }

  .rtl .navbar-nav>li {
    float: right !important;
  }
}

@media (min-width: 768px) {
  .rtl .navbar-left.flip {
    float: right !important;
  }

  .rtl .navbar-right:last-child {
    margin-left: -15px;
    margin-right: auto;
  }

  .rtl .navbar-right.flip {
    float: left !important;
    margin-left: -15px;
    margin-right: auto;
  }

  .rtl .navbar-right .dropdown-menu {
    left: 0;
    right: auto;
  }
}

@media (min-width: 768px) {
  .rtl .navbar-text {
    float: right;
  }

  .rtl .navbar-text.navbar-right:last-child {
    margin-left: 0;
    margin-right: auto;
  }
}

.rtl .pagination {
  padding-right: 0;
}

.rtl .pagination>li>a,
.rtl .pagination>li>span {
  float: right;
  margin-right: -1px;
  margin-left: 0px;
}

.rtl .pagination>li:first-child>a,
.rtl .pagination>li:first-child>span {
  margin-left: 0;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.rtl .pagination>li:last-child>a,
.rtl .pagination>li:last-child>span {
  margin-right: -1px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.rtl .pager {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}

.rtl .pager .next>a,
.rtl .pager .next>span {
  float: left;
}

.rtl .pager .previous>a,
.rtl .pager .previous>span {
  float: right;
}

.rtl .nav-pills>li>a>.badge {
  margin-left: 0px;
  margin-right: 3px;
}

.rtl .list-group-item>.badge {
  float: left;
}

.rtl .list-group-item>.badge+.badge {
  margin-left: 5px;
  margin-right: auto;
}

.rtl .alert-dismissable,
.rtl .alert-dismissible {
  padding-left: 35px;
  padding-right: 15px;
}

.rtl .alert-dismissable .close,
.rtl .alert-dismissible .close {
  right: auto;
  left: -21px;
}

.rtl .progress-bar {
  float: right;
}

.rtl .media>.pull-left {
  margin-right: 10px;
}

.rtl .media>.pull-left.flip {
  margin-right: 0;
  margin-left: 10px;
}

.rtl .media>.pull-right {
  margin-left: 10px;
}

.rtl .media>.pull-right.flip {
  margin-left: 0;
  margin-right: 10px;
}

.rtl .media-right,
.rtl .media>.pull-right {
  padding-right: 10px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .media-left,
.rtl .media>.pull-left {
  padding-left: 10px;
  padding-right: 0;
  padding-right: initial;
}

.rtl .media-list {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
  list-style: none;
}

.rtl .list-group {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}

.rtl .panel>.table:first-child>thead:first-child>tr:first-child td:first-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,
.rtl .panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,
.rtl .panel>.table:first-child>thead:first-child>tr:first-child th:first-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,
.rtl .panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child {
  border-top-right-radius: 3px;
  border-top-left-radius: 0;
}

.rtl .panel>.table:first-child>thead:first-child>tr:first-child td:last-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,
.rtl .panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,
.rtl .panel>.table:first-child>thead:first-child>tr:first-child th:last-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,
.rtl .panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,
.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 0;
}

.rtl .panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,
.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,
.rtl .panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,
.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child {
  border-bottom-left-radius: 3px;
  border-top-right-radius: 0;
}

.rtl .panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,
.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,
.rtl .panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,
.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child,
.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child {
  border-bottom-right-radius: 3px;
  border-top-left-radius: 0;
}

.rtl .panel>.table-bordered>thead>tr>th:first-child,
.rtl .panel>.table-responsive>.table-bordered>thead>tr>th:first-child,
.rtl .panel>.table-bordered>tbody>tr>th:first-child,
.rtl .panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,
.rtl .panel>.table-bordered>tfoot>tr>th:first-child,
.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,
.rtl .panel>.table-bordered>thead>tr>td:first-child,
.rtl .panel>.table-responsive>.table-bordered>thead>tr>td:first-child,
.rtl .panel>.table-bordered>tbody>tr>td:first-child,
.rtl .panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,
.rtl .panel>.table-bordered>tfoot>tr>td:first-child,
.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child {
  border-right: 0;
  border-left: none;
}

.rtl .panel>.table-bordered>thead>tr>th:last-child,
.rtl .panel>.table-responsive>.table-bordered>thead>tr>th:last-child,
.rtl .panel>.table-bordered>tbody>tr>th:last-child,
.rtl .panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,
.rtl .panel>.table-bordered>tfoot>tr>th:last-child,
.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,
.rtl .panel>.table-bordered>thead>tr>td:last-child,
.rtl .panel>.table-responsive>.table-bordered>thead>tr>td:last-child,
.rtl .panel>.table-bordered>tbody>tr>td:last-child,
.rtl .panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,
.rtl .panel>.table-bordered>tfoot>tr>td:last-child,
.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child {
  border-right: none;
  border-left: 0;
}

.rtl .embed-responsive .embed-responsive-item,
.rtl .embed-responsive iframe,
.rtl .embed-responsive embed,
.rtl .embed-responsive object {
  right: 0;
  left: auto;
}

.rtl .close {
  float: left;
}

.rtl .modal-footer {
  text-align: left;
}

.rtl .modal-footer.flip {
  text-align: right;
}

.rtl .modal-footer .btn+.btn {
  margin-left: auto;
  margin-right: 5px;
}

.rtl .modal-footer .btn-group .btn+.btn {
  margin-right: -1px;
  margin-left: auto;
}

.rtl .modal-footer .btn-block+.btn-block {
  margin-right: 0;
  margin-left: auto;
}

.rtl .popover {
  left: auto;
  text-align: right;
}

.rtl .popover.top>.arrow {
  right: 50%;
  left: auto;
  margin-right: -11px;
  margin-left: auto;
}

.rtl .popover.top>.arrow:after {
  margin-right: -10px;
  margin-left: auto;
}

.rtl .popover.bottom>.arrow {
  right: 50%;
  left: auto;
  margin-right: -11px;
  margin-left: auto;
}

.rtl .popover.bottom>.arrow:after {
  margin-right: -10px;
  margin-left: auto;
}

.rtl .carousel-control {
  right: 0;
  bottom: 0;
}

.rtl .carousel-control.left {
  right: auto;
  left: 0;
  background-image: linear-gradient(to right,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.0001) 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
}

.rtl .carousel-control.right {
  left: auto;
  right: 0;
  background-image: linear-gradient(to right,
      rgba(0, 0, 0, 0.0001) 0%,
      rgba(0, 0, 0, 0.5) 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
}

.rtl .carousel-control .icon-prev,
.rtl .carousel-control .glyphicon-chevron-left {
  left: 50%;
  right: auto;
  margin-right: -10px;
}

.rtl .carousel-control .icon-next,
.rtl .carousel-control .glyphicon-chevron-right {
  right: 50%;
  left: auto;
  margin-left: -10px;
}

.rtl .carousel-indicators {
  right: 50%;
  left: 0;
  margin-right: -30%;
  margin-left: 0;
  padding-left: 0;
}

@media screen and (min-width: 768px) {

  .rtl .carousel-control .glyphicon-chevron-left,
  .rtl .carousel-control .icon-prev {
    margin-left: 0;
    margin-right: -15px;
  }

  .rtl .carousel-control .glyphicon-chevron-right,
  .rtl .carousel-control .icon-next {
    margin-left: 0;
    margin-right: -15px;
  }

  .rtl .carousel-caption {
    left: 20%;
    right: 20%;
    padding-bottom: 30px;
  }
}

.rtl .pull-right.flip {
  float: left !important;
}

.rtl .pull-left.flip {
  float: right !important;
}

:root {
  --blue: #5e72e4;
  --indigo: #5603ad;
  --purple: #8965e0;
  --pink: #f3a4b5;
  --red: #f5365c;
  --orange: #fb6340;
  --yellow: #ffd600;
  --green: #2dce89;
  --teal: #11cdef;
  --cyan: #2bffc6;
  --white: #fff;
  --gray: #8898aa;
  --gray-dark: #32325d;
  --light: #ced4da;
  --lighter: #e9ecef;
  --primary: #5e72e4;
  --secondary: #f7fafc;
  --success: #2dce89;
  --info: #11cdef;
  --warning: #fb6340;
  --danger: #f5365c;
  --light: #adb5bd;
  --dark: #212529;
  --default: #172b4d;
  --white: #fff;
  --neutral: #fff;
  --darker: black;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: Open Sans, sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;
  text-align: left;
  background-color: #f8f9fe;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #ffffff;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #233dd2;
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #8898aa;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role="button"] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="file"]::-webkit-file-upload-button {
  cursor: pointer;
}

input[type="file"]::file-selector-button {
  cursor: pointer;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

@media (max-width: 1200px) {
  legend {
    font-size: calc(1.275rem + 0.3vw);
  }
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  color: #32325d;
}

h1,
.h1 {
  font-size: 1.625rem;
}

@media (max-width: 1200px) {

  h1,
  .h1 {
    font-size: calc(1.2875rem + 0.45vw);
  }
}

h2,
.h2 {
  font-size: 1.25rem;
}

h3,
.h3 {
  font-size: 1.0625rem;
}

h4,
.h4 {
  font-size: 0.9375rem;
}

h5,
.h5 {
  font-size: 0.8125rem;
}

h6,
.h6 {
  font-size: 0.625rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.5;
}

@media (max-width: 1200px) {
  .display-1 {
    font-size: calc(1.455rem + 2.46vw);
  }
}

.display-2 {
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.5;
}

@media (max-width: 1200px) {
  .display-2 {
    font-size: calc(1.4rem + 1.8vw);
  }
}

.display-3 {
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 1.5;
}

@media (max-width: 1200px) {
  .display-3 {
    font-size: calc(1.34375rem + 1.125vw);
  }
}

.display-4 {
  font-size: 1.6275rem;
  font-weight: 600;
  line-height: 1.5;
}

@media (max-width: 1200px) {
  .display-4 {
    font-size: calc(1.28775rem + 0.453vw);
  }
}

hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8898aa;
}

.blockquote-footer::before {
  content: "\\2014\\00A0";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f8f9fe;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #8898aa;
}

code {
  font-size: 87.5%;
  color: #f3a4b5;
  word-wrap: break-word;
}

a>code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {

  .container,
  .container-sm {
    max-width: 540px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 992px) {

  .container,
  .container-sm,
  .container-md,
  .container-lg {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {

  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters>.col,
.no-gutters>[class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col,
.col-auto,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm,
.col-sm-auto,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md,
.col-md-auto,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg,
.col-lg-auto,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1>* {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2>* {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3>* {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.row-cols-4>* {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5>* {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6>* {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
}

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%;
}

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333%;
}

.offset-2 {
  margin-left: 16.66667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333%;
}

.offset-5 {
  margin-left: 41.66667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333%;
}

.offset-8 {
  margin-left: 66.66667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333%;
}

.offset-11 {
  margin-left: 91.66667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-sm-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-sm-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-sm-3>* {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .row-cols-sm-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-sm-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-sm-6>* {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-sm-first {
    order: -1;
  }

  .order-sm-last {
    order: 13;
  }

  .order-sm-0 {
    order: 0;
  }

  .order-sm-1 {
    order: 1;
  }

  .order-sm-2 {
    order: 2;
  }

  .order-sm-3 {
    order: 3;
  }

  .order-sm-4 {
    order: 4;
  }

  .order-sm-5 {
    order: 5;
  }

  .order-sm-6 {
    order: 6;
  }

  .order-sm-7 {
    order: 7;
  }

  .order-sm-8 {
    order: 8;
  }

  .order-sm-9 {
    order: 9;
  }

  .order-sm-10 {
    order: 10;
  }

  .order-sm-11 {
    order: 11;
  }

  .order-sm-12 {
    order: 12;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333%;
  }

  .offset-sm-2 {
    margin-left: 16.66667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333%;
  }

  .offset-sm-5 {
    margin-left: 41.66667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333%;
  }

  .offset-sm-8 {
    margin-left: 66.66667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333%;
  }

  .offset-sm-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-md-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-md-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-md-3>* {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .row-cols-md-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-md-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-md-6>* {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-md-first {
    order: -1;
  }

  .order-md-last {
    order: 13;
  }

  .order-md-0 {
    order: 0;
  }

  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }

  .order-md-3 {
    order: 3;
  }

  .order-md-4 {
    order: 4;
  }

  .order-md-5 {
    order: 5;
  }

  .order-md-6 {
    order: 6;
  }

  .order-md-7 {
    order: 7;
  }

  .order-md-8 {
    order: 8;
  }

  .order-md-9 {
    order: 9;
  }

  .order-md-10 {
    order: 10;
  }

  .order-md-11 {
    order: 11;
  }

  .order-md-12 {
    order: 12;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333%;
  }

  .offset-md-2 {
    margin-left: 16.66667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333%;
  }

  .offset-md-5 {
    margin-left: 41.66667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333%;
  }

  .offset-md-8 {
    margin-left: 66.66667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333%;
  }

  .offset-md-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-lg-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-lg-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-lg-3>* {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .row-cols-lg-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-lg-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-lg-6>* {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-lg-first {
    order: -1;
  }

  .order-lg-last {
    order: 13;
  }

  .order-lg-0 {
    order: 0;
  }

  .order-lg-1 {
    order: 1;
  }

  .order-lg-2 {
    order: 2;
  }

  .order-lg-3 {
    order: 3;
  }

  .order-lg-4 {
    order: 4;
  }

  .order-lg-5 {
    order: 5;
  }

  .order-lg-6 {
    order: 6;
  }

  .order-lg-7 {
    order: 7;
  }

  .order-lg-8 {
    order: 8;
  }

  .order-lg-9 {
    order: 9;
  }

  .order-lg-10 {
    order: 10;
  }

  .order-lg-11 {
    order: 11;
  }

  .order-lg-12 {
    order: 12;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333%;
  }

  .offset-lg-2 {
    margin-left: 16.66667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333%;
  }

  .offset-lg-5 {
    margin-left: 41.66667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333%;
  }

  .offset-lg-8 {
    margin-left: 66.66667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333%;
  }

  .offset-lg-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-xl-1>* {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-xl-2>* {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-xl-3>* {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .row-cols-xl-4>* {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-xl-5>* {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-xl-6>* {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xl-first {
    order: -1;
  }

  .order-xl-last {
    order: 13;
  }

  .order-xl-0 {
    order: 0;
  }

  .order-xl-1 {
    order: 1;
  }

  .order-xl-2 {
    order: 2;
  }

  .order-xl-3 {
    order: 3;
  }

  .order-xl-4 {
    order: 4;
  }

  .order-xl-5 {
    order: 5;
  }

  .order-xl-6 {
    order: 6;
  }

  .order-xl-7 {
    order: 7;
  }

  .order-xl-8 {
    order: 8;
  }

  .order-xl-9 {
    order: 9;
  }

  .order-xl-10 {
    order: 10;
  }

  .order-xl-11 {
    order: 11;
  }

  .order-xl-12 {
    order: 12;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333%;
  }

  .offset-xl-2 {
    margin-left: 16.66667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333%;
  }

  .offset-xl-5 {
    margin-left: 41.66667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333%;
  }

  .offset-xl-8 {
    margin-left: 66.66667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333%;
  }

  .offset-xl-11 {
    margin-left: 91.66667%;
  }
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: rgb(33, 37, 41);
  background-color: transparent;
}

.table th,
.table td {
  padding: 1rem;
  vertical-align: top;
  border-top: 1px solid #e9ecef;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
}

.table tbody+tbody {
  border-top: 2px solid #e9ecef;
}

.table-sm th,
.table-sm td {
  padding: 0.5rem;
}

.table-bordered {
  border: 1px solid #e9ecef;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #e9ecef;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody+tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(246, 249, 252, 0.3);
}

.table-hover tbody tr:hover {
  color: #525f7f;
  background-color: #f6f9fc;
}

.table-primary,
.table-primary>th,
.table-primary>td {
  background-color: #d2d8f7;
}

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody+tbody {
  border-color: #abb6f1;
}

.table-hover .table-primary:hover {
  background-color: #bcc5f3;
}

.table-hover .table-primary:hover>td,
.table-hover .table-primary:hover>th {
  background-color: #bcc5f3;
}

.table-secondary,
.table-secondary>th,
.table-secondary>td {
  background-color: #fdfefe;
}

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody+tbody {
  border-color: #fbfcfd;
}

.table-hover .table-secondary:hover {
  background-color: #ecf6f6;
}

.table-hover .table-secondary:hover>td,
.table-hover .table-secondary:hover>th {
  background-color: #ecf6f6;
}

.table-success,
.table-success>th,
.table-success>td {
  background-color: #c4f1de;
}

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody+tbody {
  border-color: #92e6c2;
}

.table-hover .table-success:hover {
  background-color: #afecd2;
}

.table-hover .table-success:hover>td,
.table-hover .table-success:hover>th {
  background-color: #afecd2;
}

.table-info,
.table-info>th,
.table-info>td {
  background-color: #bcf1fb;
}

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody+tbody {
  border-color: #83e5f7;
}

.table-hover .table-info:hover {
  background-color: #a4ecfa;
}

.table-hover .table-info:hover>td,
.table-hover .table-info:hover>th {
  background-color: #a4ecfa;
}

.table-warning,
.table-warning>th,
.table-warning>td {
  background-color: #fed3ca;
}

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody+tbody {
  border-color: #fdae9c;
}

.table-hover .table-warning:hover {
  background-color: #febeb1;
}

.table-hover .table-warning:hover>td,
.table-hover .table-warning:hover>th {
  background-color: #febeb1;
}

.table-danger,
.table-danger>th,
.table-danger>td {
  background-color: #fcc7d1;
}

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody+tbody {
  border-color: #fa96aa;
}

.table-hover .table-danger:hover {
  background-color: #fbafbd;
}

.table-hover .table-danger:hover>td,
.table-hover .table-danger:hover>th {
  background-color: #fbafbd;
}

.table-light,
.table-light>th,
.table-light>td {
  background-color: #e8eaed;
}

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody+tbody {
  border-color: #d4d9dd;
}

.table-hover .table-light:hover {
  background-color: #dadde2;
}

.table-hover .table-light:hover>td,
.table-hover .table-light:hover>th {
  background-color: #dadde2;
}

.table-dark,
.table-dark>th,
.table-dark>td {
  background-color: #c1c2c3;
}

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody+tbody {
  border-color: #8c8e90;
}

/* Light mode Salto rows */
tr.salto-synced-row > td {
  background-color: #f7f7f8 !important;
}

/* Dark mode Salto rows */
body[data-theme="dark"] tr.salto-synced-row > td {
  background-color: #252932 !important;
  color: #f8f9fa;
}

/* Keep the Salto row visibly different on hover */
body[data-theme="dark"] tr.salto-synced-row:hover > td {
  background-color: #323946 !important;
}

/* Light mode hover */
tr.salto-synced-row:hover > td {
  background-color: #eeeeef !important;
}

.table-hover .table-dark:hover {
  background-color: #b4b5b6;
}

.table-hover .table-dark:hover>td,
.table-hover .table-dark:hover>th {
  background-color: #b4b5b6;
}

.table-default,
.table-default>th,
.table-default>td {
  background-color: #bec4cd;
}

.table-default th,
.table-default td,
.table-default thead th,
.table-default tbody+tbody {
  border-color: #8691a2;
}

.table-hover .table-default:hover {
  background-color: #b0b7c2;
}

.table-hover .table-default:hover>td,
.table-hover .table-default:hover>th {
  background-color: #b0b7c2;
}

.table-white,
.table-white>th,
.table-white>td {
  background-color: white;
}

.table-white th,
.table-white td,
.table-white thead th,
.table-white tbody+tbody {
  border-color: white;
}

.table-hover .table-white:hover {
  background-color: #f2f2f2;
}

.table-hover .table-white:hover>td,
.table-hover .table-white:hover>th {
  background-color: #f2f2f2;
}

.table-neutral,
.table-neutral>th,
.table-neutral>td {
  background-color: white;
}

.table-neutral th,
.table-neutral td,
.table-neutral thead th,
.table-neutral tbody+tbody {
  border-color: white;
}

.table-hover .table-neutral:hover {
  background-color: #f2f2f2;
}

.table-hover .table-neutral:hover>td,
.table-hover .table-neutral:hover>th {
  background-color: #f2f2f2;
}

.table-darker,
.table-darker>th,
.table-darker>td {
  background-color: #b8b8b8;
}

.table-darker th,
.table-darker td,
.table-darker thead th,
.table-darker tbody+tbody {
  border-color: #7a7a7a;
}

.table-hover .table-darker:hover {
  background-color: #ababab;
}

.table-hover .table-darker:hover>td,
.table-hover .table-darker:hover>th {
  background-color: #ababab;
}

.table-active,
.table-active>th,
.table-active>td {
  background-color: #f6f9fc;
}

.table-hover .table-active:hover {
  background-color: #e3ecf6;
}

.table-hover .table-active:hover>td,
.table-hover .table-active:hover>th {
  background-color: #e3ecf6;
}

.table .thead-dark th {
  color: #f8f9fe;
  background-color: #172b4d;
  border-color: #1f3a68;
}

.table .thead-light th {
  color: #8898aa;
  background-color: #f6f9fc;
  border-color: #e9ecef;
}

.table-dark {
  color: #f8f9fe;
  background-color: #172b4d;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #1f3a68;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #f8f9fe;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-sm>.table-bordered {
    border: 0;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-md>.table-bordered {
    border: 0;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-lg>.table-bordered {
    border: 0;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xl>.table-bordered {
    border: 0;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive>.table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}

.form-control:focus {
  color: #000000;
  background-color: #fff;
  border-color: #5e72e4;
  outline: 0;
  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);
}

.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  -webkit-appearance: none;
          appearance: none;
}

select.form-control:focus::-ms-value {
  color: #000000;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.625rem + 1px);
  padding-bottom: calc(0.625rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.625rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

select.form-control[size],
select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row>.col,
.form-row>[class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
  color: #8898aa;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #2dce89;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(45, 206, 137, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:valid,
.form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #2dce89;
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #2dce89;
}

.was-validated .form-control:valid~.valid-feedback,
.was-validated .form-control:valid~.valid-tooltip,
.form-control.is-valid~.valid-feedback,
.form-control.is-valid~.valid-tooltip,
.was-validated .custom-select:valid~.valid-feedback,
.was-validated .custom-select:valid~.valid-tooltip,
.custom-select.is-valid~.valid-feedback,
.custom-select.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
  color: #2dce89;
}

.was-validated .form-check-input:valid~.valid-feedback,
.was-validated .form-check-input:valid~.valid-tooltip,
.form-check-input.is-valid~.valid-feedback,
.form-check-input.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid~.custom-control-label,
.custom-control-input.is-valid~.custom-control-label {
  color: #2dce89;
}

.was-validated .custom-control-input:valid~.custom-control-label::before,
.custom-control-input.is-valid~.custom-control-label::before {
  background-color: #93e7c3;
  border-color: #93e7c3;
}

.was-validated .custom-control-input:valid~.valid-feedback,
.was-validated .custom-control-input:valid~.valid-tooltip,
.custom-control-input.is-valid~.valid-feedback,
.custom-control-input.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid:checked~.custom-control-label::before,
.custom-control-input.is-valid:checked~.custom-control-label::before {
  background-color: #54daa1;
  border-color: #93e7c3;
}

.was-validated .custom-control-input:valid:focus~.custom-control-label::before,
.custom-control-input.is-valid:focus~.custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(45, 206, 137, 0.25);
}

.custom-file-input {
  opacity: 1 !important;
  width: 60% !important;
  margin: 8px !important;
}

.was-validated .custom-file-input:valid~.custom-file-label,
.custom-file-input.is-valid~.custom-file-label {
  border-color: #2dce89;
}

.was-validated .custom-file-input:valid~.custom-file-label::before,
.custom-file-input.is-valid~.custom-file-label::before {
  border-color: inherit;
}

.was-validated .custom-file-input:valid~.valid-feedback,
.was-validated .custom-file-input:valid~.valid-tooltip,
.custom-file-input.is-valid~.valid-feedback,
.custom-file-input.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .custom-file-input:valid:focus~.custom-file-label,
.custom-file-input.is-valid:focus~.custom-file-label {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.25);
}

.custom-file-input:focus {
  outline: none;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #fb6340;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(251, 99, 64, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:invalid,
.form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #fb6340;
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #fb6340;
}

.was-validated .form-control:invalid~.invalid-feedback,
.was-validated .form-control:invalid~.invalid-tooltip,
.form-control.is-invalid~.invalid-feedback,
.form-control.is-invalid~.invalid-tooltip,
.was-validated .custom-select:invalid~.invalid-feedback,
.was-validated .custom-select:invalid~.invalid-tooltip,
.custom-select.is-invalid~.invalid-feedback,
.custom-select.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
  color: #fb6340;
}

.was-validated .form-check-input:invalid~.invalid-feedback,
.was-validated .form-check-input:invalid~.invalid-tooltip,
.form-check-input.is-invalid~.invalid-feedback,
.form-check-input.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid~.custom-control-label,
.custom-control-input.is-invalid~.custom-control-label {
  color: #fb6340;
}

.was-validated .custom-control-input:invalid~.custom-control-label::before,
.custom-control-input.is-invalid~.custom-control-label::before {
  background-color: #fec9bd;
  border-color: #fec9bd;
}

.was-validated .custom-control-input:invalid~.invalid-feedback,
.was-validated .custom-control-input:invalid~.invalid-tooltip,
.custom-control-input.is-invalid~.invalid-feedback,
.custom-control-input.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid:checked~.custom-control-label::before,
.custom-control-input.is-invalid:checked~.custom-control-label::before {
  background-color: #fc8c72;
  border-color: #fec9bd;
}

.was-validated .custom-control-input:invalid:focus~.custom-control-label::before,
.custom-control-input.is-invalid:focus~.custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.custom-file-input {
  opacity: 1 !important;
  width: 60% !important;
  margin: 8px !important;
}

.was-validated .custom-file-input:invalid~.custom-file-label,
.custom-file-input.is-invalid~.custom-file-label {
  border-color: #fb6340;
}

.was-validated .custom-file-input:invalid~.custom-file-label::before,
.custom-file-input.is-invalid~.custom-file-label::before {
  border-color: inherit;
}

.was-validated .custom-file-input:invalid~.invalid-feedback,
.was-validated .custom-file-input:invalid~.invalid-tooltip,
.custom-file-input.is-invalid~.invalid-feedback,
.custom-file-input.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .custom-file-input:invalid:focus~.custom-file-label,
.custom-file-input.is-invalid:focus~.custom-file-label {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.custom-file-input:focus {
  outline: none;
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline .form-check {
  width: 100%;
}

@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }

  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }

  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }

  .form-inline .form-control-plaintext {
    display: inline-block;
  }

  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }

  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }

  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }

  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }

  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  color: #525f7f;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: #525f7f;
  text-decoration: none;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.btn.disabled,
.btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.btn:not(:disabled):not(.disabled):active,
.btn:not(:disabled):not(.disabled).active {
  box-shadow: none;
}

.btn:not(:disabled):not(.disabled):active:focus,
.btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-primary:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.btn-primary:focus,
.btn-primary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #324cdd;
  border-color: #5e72e4;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-primary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}

.btn-secondary:focus,
.btn-secondary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show>.btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: #d2e3ee;
  border-color: #f7fafc;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show>.btn-secondary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-success:hover {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}

.btn-success:focus,
.btn-success.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-success.disabled,
.btn-success:disabled {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}

.btn-success:not(:disabled):not(.disabled):active,
.btn-success:not(:disabled):not(.disabled).active,
.show>.btn-success.dropdown-toggle {
  color: #fff;
  background-color: #24a46d;
  border-color: #2dce89;
}

.btn-success:not(:disabled):not(.disabled):active:focus,
.btn-success:not(:disabled):not(.disabled).active:focus,
.show>.btn-success.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-info:hover {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}

.btn-info:focus,
.btn-info.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-info.disabled,
.btn-info:disabled {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}

.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show>.btn-info.dropdown-toggle {
  color: #fff;
  background-color: #0da5c0;
  border-color: #11cdef;
}

.btn-info:not(:disabled):not(.disabled):active:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.show>.btn-info.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-warning {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}

.btn-warning:focus,
.btn-warning.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}

.btn-warning:not(:disabled):not(.disabled):active,
.btn-warning:not(:disabled):not(.disabled).active,
.show>.btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #fa3a0e;
  border-color: #fb6340;
}

.btn-warning:not(:disabled):not(.disabled):active:focus,
.btn-warning:not(:disabled):not(.disabled).active:focus,
.show>.btn-warning.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}

.btn-danger:focus,
.btn-danger.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-danger.disabled,
.btn-danger:disabled {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}

.btn-danger:not(:disabled):not(.disabled):active,
.btn-danger:not(:disabled):not(.disabled).active,
.show>.btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #ec0c38;
  border-color: #f5365c;
}

.btn-danger:not(:disabled):not(.disabled):active:focus,
.btn-danger:not(:disabled):not(.disabled).active:focus,
.show>.btn-danger.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-light {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}

.btn-light:focus,
.btn-light.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-light.disabled,
.btn-light:disabled {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}

.btn-light:not(:disabled):not(.disabled):active,
.btn-light:not(:disabled):not(.disabled).active,
.show>.btn-light.dropdown-toggle {
  color: #fff;
  background-color: #919ca6;
  border-color: #adb5bd;
}

.btn-light:not(:disabled):not(.disabled):active:focus,
.btn-light:not(:disabled):not(.disabled).active:focus,
.show>.btn-light.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

.btn-dark:focus,
.btn-dark.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-dark.disabled,
.btn-dark:disabled {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

.btn-dark:not(:disabled):not(.disabled):active,
.btn-dark:not(:disabled):not(.disabled).active,
.show>.btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #0a0c0d;
  border-color: #212529;
}

.btn-dark:not(:disabled):not(.disabled):active:focus,
.btn-dark:not(:disabled):not(.disabled).active:focus,
.show>.btn-dark.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-default {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-default:hover {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}

.btn-default:focus,
.btn-default.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-default.disabled,
.btn-default:disabled {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}

.btn-default:not(:disabled):not(.disabled):active,
.btn-default:not(:disabled):not(.disabled).active,
.show>.btn-default.dropdown-toggle {
  color: #fff;
  background-color: #0b1526;
  border-color: #172b4d;
}

.btn-default:not(:disabled):not(.disabled):active:focus,
.btn-default:not(:disabled):not(.disabled).active:focus,
.show>.btn-default.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-white {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-white:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}

.btn-white:focus,
.btn-white.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-white.disabled,
.btn-white:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-white:not(:disabled):not(.disabled):active,
.btn-white:not(:disabled):not(.disabled).active,
.show>.btn-white.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}

.btn-white:not(:disabled):not(.disabled):active:focus,
.btn-white:not(:disabled):not(.disabled).active:focus,
.show>.btn-white.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.static-text-btn {
  color: #007bff !important;
  /* normal text */
  background-color: #fff !important;
  /* keep original background */
  border-color: #fff !important;
  /* keep original border */
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.static-text-btn:hover,
.static-text-btn:focus,
.static-text-btn:active,
.static-text-btn.active {
  color: #007bff !important;
  /* prevent hover/focus/active color change */
  background-color: #fff !important;
  border-color: #fff !important;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.static-text-btn:disabled,
.static-text-btn.disabled {
  color: #007bff !important;
  /* prevent disabled color change */
  background-color: #fff !important;
  border-color: #fff !important;
}

.btn-neutral {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-neutral:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}

.btn-neutral:focus,
.btn-neutral.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-neutral.disabled,
.btn-neutral:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-neutral:not(:disabled):not(.disabled):active,
.btn-neutral:not(:disabled):not(.disabled).active,
.show>.btn-neutral.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}

.btn-neutral:not(:disabled):not(.disabled):active:focus,
.btn-neutral:not(:disabled):not(.disabled).active:focus,
.show>.btn-neutral.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-darker {
  color: #fff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}

.btn-darker:focus,
.btn-darker.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-darker.disabled,
.btn-darker:disabled {
  color: #fff;
  background-color: black;
  border-color: black;
}

.btn-darker:not(:disabled):not(.disabled):active,
.btn-darker:not(:disabled):not(.disabled).active,
.show>.btn-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}

.btn-darker:not(:disabled):not(.disabled):active:focus,
.btn-darker:not(:disabled):not(.disabled).active:focus,
.show>.btn-darker.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-primary {
  color: #5e72e4;
  background-color: transparent;
  background-image: none;
  border-color: #5e72e4;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: #5e72e4;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-outline-secondary {
  color: #f7fafc;
  background-color: transparent;
  background-image: none;
  border-color: #f7fafc;
}

.btn-outline-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}

.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
  color: #f7fafc;
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-outline-success {
  color: #2dce89;
  background-color: transparent;
  background-image: none;
  border-color: #2dce89;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}

.btn-outline-success:focus,
.btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: #2dce89;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show>.btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-outline-info {
  color: #11cdef;
  background-color: transparent;
  background-image: none;
  border-color: #11cdef;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}

.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
  color: #11cdef;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled):active,
.btn-outline-info:not(:disabled):not(.disabled).active,
.show>.btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-outline-warning {
  color: #fb6340;
  background-color: transparent;
  background-image: none;
  border-color: #fb6340;
}

.btn-outline-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}

.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  color: #fb6340;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled):active,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show>.btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-outline-danger {
  color: #f5365c;
  background-color: transparent;
  background-image: none;
  border-color: #f5365c;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  color: #f5365c;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled):active,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show>.btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-outline-light {
  color: #adb5bd;
  background-color: transparent;
  background-image: none;
  border-color: #adb5bd;
}

.btn-outline-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}

.btn-outline-light:focus,
.btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #adb5bd;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show>.btn-outline-light.dropdown-toggle {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

.btn-outline-dark:focus,
.btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled):active,
.btn-outline-dark:not(:disabled):not(.disabled).active,
.show>.btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-default {
  color: #172b4d;
  background-color: transparent;
  background-image: none;
  border-color: #172b4d;
}

.btn-outline-default:hover {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}

.btn-outline-default:focus,
.btn-outline-default.focus {
  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-outline-default.disabled,
.btn-outline-default:disabled {
  color: #172b4d;
  background-color: transparent;
}

.btn-outline-default:not(:disabled):not(.disabled):active,
.btn-outline-default:not(:disabled):not(.disabled).active,
.show>.btn-outline-default.dropdown-toggle {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}

.btn-outline-default:not(:disabled):not(.disabled):active:focus,
.btn-outline-default:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-outline-white {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}

.btn-outline-white:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-outline-white:focus,
.btn-outline-white.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-white.disabled,
.btn-outline-white:disabled {
  color: #fff;
  background-color: transparent;
}

.btn-outline-white:not(:disabled):not(.disabled):active,
.btn-outline-white:not(:disabled):not(.disabled).active,
.show>.btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-outline-white:not(:disabled):not(.disabled):active:focus,
.btn-outline-white:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}

.btn-outline-neutral:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-outline-neutral:focus,
.btn-outline-neutral.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral.disabled,
.btn-outline-neutral:disabled {
  color: #fff;
  background-color: transparent;
}

.btn-outline-neutral:not(:disabled):not(.disabled):active,
.btn-outline-neutral:not(:disabled):not(.disabled).active,
.show>.btn-outline-neutral.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.btn-outline-neutral:not(:disabled):not(.disabled):active:focus,
.btn-outline-neutral:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-darker {
  color: black;
  background-color: transparent;
  background-image: none;
  border-color: black;
}

.btn-outline-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}

.btn-outline-darker:focus,
.btn-outline-darker.focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-darker.disabled,
.btn-outline-darker:disabled {
  color: black;
  background-color: transparent;
}

.btn-outline-darker:not(:disabled):not(.disabled):active,
.btn-outline-darker:not(:disabled):not(.disabled).active,
.show>.btn-outline-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}

.btn-outline-darker:not(:disabled):not(.disabled):active:focus,
.btn-outline-darker:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #5e72e4;
  text-decoration: none;
}

.btn-link:hover {
  color: #233dd2;
  text-decoration: none;
}

.btn-link:focus,
.btn-link.focus {
  text-decoration: none;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #8898aa;
  pointer-events: none;
}

.btn-lg,
.btn-group-lg>.btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.btn-sm,
.btn-group-sm>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block+.btn-block {
  margin-top: 0.5rem;
}

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.4375rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropleft .dropdown-toggle::after {
  display: none;
}

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^="top"],
.dropdown-menu[x-placement^="right"],
.dropdown-menu[x-placement^="bottom"],
.dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f6f9fc;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #16181b;
  text-decoration: none;
  background-color: transparent;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #8898aa;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.5rem 1rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group>.btn:hover,
.btn-group-vertical>.btn:hover {
  z-index: 1;
}

.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group>.btn:not(:first-child),
.btn-group>.btn-group:not(:first-child) {
  margin-left: -1px;
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn-group:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group>.btn:not(:first-child),
.btn-group>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}

.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
  width: 100%;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle>.btn,
.btn-group-toggle>.btn-group>.btn {
  margin-bottom: 0;
}

.btn-group-toggle>.btn input[type="radio"],
.btn-group-toggle>.btn input[type="checkbox"],
.btn-group-toggle>.btn-group>.btn input[type="radio"],
.btn-group-toggle>.btn-group>.btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group>.form-control,
.input-group>.form-control-plaintext,
.input-group>.custom-select,
.input-group>.custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}

.input-group>.form-control+.form-control,
.input-group>.form-control+.custom-select,
.input-group>.form-control+.custom-file,
.input-group>.form-control-plaintext+.form-control,
.input-group>.form-control-plaintext+.custom-select,
.input-group>.form-control-plaintext+.custom-file,
.input-group>.custom-select+.form-control,
.input-group>.custom-select+.custom-select,
.input-group>.custom-select+.custom-file,
.input-group>.custom-file+.form-control,
.input-group>.custom-file+.custom-select,
.input-group>.custom-file+.custom-file {
  margin-left: -1px;
}

.input-group>.form-control:focus,
.input-group>.custom-select:focus,
.input-group>.custom-file .custom-file-input:focus~.custom-file-label {
  z-index: 3;
}

.input-group>.custom-file .custom-file-input:focus {
  z-index: 4;
}

.input-group>.form-control:not(:first-child),
.input-group>.custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group>.custom-file {
  display: flex;
  align-items: center;
}

.input-group>.custom-file:not(:last-child) .custom-file-label,
.input-group>.custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group:not(.has-validation)>.form-control:not(:last-child),
.input-group:not(.has-validation)>.custom-select:not(:last-child),
.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation>.form-control:nth-last-child(n + 3),
.input-group.has-validation>.custom-select:nth-last-child(n + 3),
.input-group.has-validation>.custom-file:nth-last-child(n + 3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}

.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}

.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}

.input-group-prepend .btn+.btn,
.input-group-prepend .btn+.input-group-text,
.input-group-prepend .input-group-text+.input-group-text,
.input-group-prepend .input-group-text+.btn,
.input-group-append .btn+.btn,
.input-group-append .btn+.input-group-text,
.input-group-append .input-group-text+.input-group-text,
.input-group-append .input-group-text+.btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.625rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.input-group-text input[type="radio"],
.input-group-text input[type="checkbox"] {
  margin-top: 0;
}

.input-group-lg>.form-control:not(textarea),
.input-group-lg>.custom-select {
  height: calc(1.5em + 1.75rem + 2px);
}

.input-group-lg>.form-control,
.input-group-lg>.custom-select,
.input-group-lg>.input-group-prepend>.input-group-text,
.input-group-lg>.input-group-append>.input-group-text,
.input-group-lg>.input-group-prepend>.btn,
.input-group-lg>.input-group-append>.btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.input-group-sm>.form-control:not(textarea),
.input-group-sm>.custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm>.form-control,
.input-group-sm>.custom-select,
.input-group-sm>.input-group-prepend>.input-group-text,
.input-group-sm>.input-group-append>.input-group-text,
.input-group-sm>.input-group-prepend>.btn,
.input-group-sm>.input-group-append>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.input-group-lg>.custom-select,
.input-group-sm>.custom-select {
  padding-right: 1.75rem;
}

.input-group>.input-group-prepend>.btn,
.input-group>.input-group-prepend>.input-group-text,
.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,
.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,
.input-group.has-validation>.input-group-append:nth-last-child(n + 3)>.btn,
.input-group.has-validation>.input-group-append:nth-last-child(n + 3)>.input-group-text,
.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append:last-child>.input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.cards-header-icon-img {
  width: 3.0rem;
  height: 3.0rem;
  object-fit: contain;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 2.75rem;
  -webkit-print-color-adjust: exact;
          color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #5e72e4;
  background-color: #5e72e4;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
}

.custom-control-input:focus~.custom-control-label::before {
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05),
    0 3px 2px rgba(233, 236, 239, 0.05);
}

.custom-control-input:focus:not(:checked)~.custom-control-label::before {
  border-color: #5e72e4;
}

.custom-control-input:not(:disabled):active~.custom-control-label::before {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
}

.custom-control-input[disabled]~.custom-control-label,
.custom-control-input:disabled~.custom-control-label {
  color: #8898aa;
}

.custom-control-input[disabled]~.custom-control-label::before,
.custom-control-input:disabled~.custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -2.75rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #dee2e6 solid 1px;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -2.75rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50% / 50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
  border-color: #5e72e4;
  background-color: #5e72e4;
  box-shadow: ;
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-switch {
  padding-left: 3.5rem;
}

.custom-switch .custom-control-label::before {
  left: -3.5rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-3.5rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #dee2e6;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}

.custom-switch .custom-control-input:checked~.custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 1.75rem 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  -webkit-appearance: none;
          appearance: none;
}

.custom-select:focus {
  border-color: #5e72e4;
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #5e72e4;
}

.custom-select:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}

.custom-select:disabled {
  color: #8898aa;
  background-color: #e9ecef;
}

.custom-select::-ms-expand {
  display: none;
}

.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}

.custom-file-input:focus~.custom-file-label {
  border-color: #5e72e4;
  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);
}

.custom-file-input[disabled]~.custom-file-label,
.custom-file-input:disabled~.custom-file-label {
  background-color: #e9ecef;
}

.custom-file-input:lang(en)~.custom-file-label::after {
  content: "Browse";
}

.custom-file-input~.custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: 0.625rem 0.75rem;
  line-height: 1.5;
  color: #8898aa;
  content: "Browse";
  background-color: #fff;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}

.custom-range:focus {
  outline: 0;
}

.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, 0 3px 9px rgba(50, 50, 9, 0),
    3px 4px 8px rgba(94, 114, 228, 0.1);
}

.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, 0 3px 9px rgba(50, 50, 9, 0),
    3px 4px 8px rgba(94, 114, 228, 0.1);
}

.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, 0 3px 9px rgba(50, 50, 9, 0),
    3px 4px 8px rgba(94, 114, 228, 0.1);
}

.custom-range::-moz-focus-outer {
  border: 0;
}

.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.custom-range::-webkit-slider-thumb:active {
  background-color: #f7f8fe;
}

.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}

.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.custom-range::-moz-range-thumb:active {
  background-color: #f7f8fe;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}

.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}

.custom-range::-ms-thumb:active {
  background-color: #f7f8fe;
}

.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}

.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}

.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}

.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.custom-range:disabled::-moz-range-track {
  cursor: default;
}

.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {

  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.25rem 0.75rem;
}

.nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}

.nav-link.disabled {
  color: #8898aa;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  border: 1px solid transparent;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
  color: #8898aa;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #f8f9fe;
  border-color: #dee2e6 #dee2e6 #f8f9fe;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.375rem;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff;
  background-color: #5e72e4;
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content>.tab-pane {
  display: none;
}

.tab-content>.active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}

.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.0625rem;
  padding-bottom: 0.0625rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.navbar-toggler:hover,
.navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50% / 100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {

  .navbar-expand-sm>.container,
  .navbar-expand-sm>.container-fluid,
  .navbar-expand-sm>.container-sm,
  .navbar-expand-sm>.container-md,
  .navbar-expand-sm>.container-lg,
  .navbar-expand-sm>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .navbar-expand-sm>.container,
  .navbar-expand-sm>.container-fluid,
  .navbar-expand-sm>.container-sm,
  .navbar-expand-sm>.container-md,
  .navbar-expand-sm>.container-lg,
  .navbar-expand-sm>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (max-width: 767.98px) {

  .navbar-expand-md>.container,
  .navbar-expand-md>.container-fluid,
  .navbar-expand-md>.container-sm,
  .navbar-expand-md>.container-md,
  .navbar-expand-md>.container-lg,
  .navbar-expand-md>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .navbar-expand-md>.container,
  .navbar-expand-md>.container-fluid,
  .navbar-expand-md>.container-sm,
  .navbar-expand-md>.container-md,
  .navbar-expand-md>.container-lg,
  .navbar-expand-md>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (max-width: 991.98px) {

  .navbar-expand-lg>.container,
  .navbar-expand-lg>.container-fluid,
  .navbar-expand-lg>.container-sm,
  .navbar-expand-lg>.container-md,
  .navbar-expand-lg>.container-lg,
  .navbar-expand-lg>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .navbar-expand-lg>.container,
  .navbar-expand-lg>.container-fluid,
  .navbar-expand-lg>.container-sm,
  .navbar-expand-lg>.container-md,
  .navbar-expand-lg>.container-lg,
  .navbar-expand-lg>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1199.98px) {

  .navbar-expand-xl>.container,
  .navbar-expand-xl>.container-fluid,
  .navbar-expand-xl>.container-sm,
  .navbar-expand-xl>.container-md,
  .navbar-expand-xl>.container-lg,
  .navbar-expand-xl>.container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }

  .navbar-expand-xl>.container,
  .navbar-expand-xl>.container-fluid,
  .navbar-expand-xl>.container-sm,
  .navbar-expand-xl>.container-md,
  .navbar-expand-xl>.container-lg,
  .navbar-expand-xl>.container-xl {
    flex-wrap: nowrap;
  }

  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-sm,
.navbar-expand>.container-md,
.navbar-expand>.container-lg,
.navbar-expand>.container-xl {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}

.navbar-expand>.container,
.navbar-expand>.container-fluid,
.navbar-expand>.container-sm,
.navbar-expand>.container-md,
.navbar-expand>.container-lg,
.navbar-expand>.container-xl {
  flex-wrap: nowrap;
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.6);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show>.nav-link,
.navbar-light .navbar-nav .active>.nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.6);
  border-color: transparent;
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.6);
}

.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}

.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show>.nav-link,
.navbar-dark .navbar-nav .active>.nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}

.navbar-dark .navbar-text a {
  color: rgba(255, 255, 255, 0.65);
}

.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card>.list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card>.list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}

.card>.list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.25rem;
}

.card-subtitle {
  margin-top: -0.625rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link+.card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.card-header:first-child {
  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.card-footer {
  padding: 1.25rem 1.5rem;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.25rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group>.card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }

  .card-group>.card {
    flex: 1 0;
    margin-bottom: 0;
  }

  .card-group>.card+.card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group>.card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-top,
  .card-group>.card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-bottom,
  .card-group>.card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-top,
  .card-group>.card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-bottom,
  .card-group>.card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.25rem;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }

  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}

.accordion>.card {
  overflow: hidden;
}

.accordion>.card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion>.card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion>.card>.card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
}

.breadcrumb-item+.breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #8898aa;
  content: "-";
}

.breadcrumb-item+.breadcrumb-item:hover::before {
  text-decoration: underline;
}

.breadcrumb-item+.breadcrumb-item:hover::before {
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #ffffff;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.375rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  z-index: 2;
  color: #8898aa;
  text-decoration: none;
  background-color: #dee2e6;
  border-color: #dee2e6;
}

.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.page-item.disabled .page-link {
  color: #8898aa;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4375rem;
  border-bottom-right-radius: 0.4375rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

/* ===============================
   Pagination – Dark Mode Fix
   =============================== */

.table-dark-mode .page-link {
  color: #8898aa;
  background-color: #ffffff;
  border-color: #374151;
}

.table-dark-mode .page-link:hover {
  color: #ffffff;
  background-color: #374151;
  border-color: #4b5563;
}

.table-dark-mode .page-item.disabled .page-link {
  color: #6b7280;
  background-color: #1f2937;
  border-color: #374151;
}

.table-dark-mode .page-item.active .page-link {
  color: #ffffff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.badge {
  display: inline-block;
  padding: 0.35rem 0.375rem;
  font-size: 66%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}

a.badge:hover,
a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.875em;
  padding-left: 0.875em;
  border-radius: 10rem;
}

.badge-primary {
  color: #2643e9;
  background-color: #eaecfb;
}

.badge-primary[href]:hover,
.badge-primary[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #2a44db;
}

.badge-secondary {
  color: #cfe3f1;
  background-color: white;
}

.badge-secondary[href]:hover,
.badge-secondary[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #cadeeb;
}

.badge-success {
  color: #1aae6f;
  background-color: #b0eed3;
}

.badge-success[href]:hover,
.badge-success[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #229c68;
}

.badge-info {
  color: #03acca;
  background-color: #aaedf9;
}

.badge-info[href]:hover,
.badge-info[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0c9cb7;
}

.badge-warning {
  color: #ff3709;
  background-color: #fee6e0;
}

.badge-warning[href]:hover,
.badge-warning[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #f93305;
}

.badge-danger {
  color: #f80031;
  background-color: #fdd1da;
}

.badge-danger[href]:hover,
.badge-danger[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #e30b36;
}

.badge-light {
  color: #879cb0;
  background-color: white;
}

.badge-light[href]:hover,
.badge-light[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #8b96a2;
}

.badge-dark {
  color: #090c0e;
  background-color: #6a7783;
}

.badge-dark[href]:hover,
.badge-dark[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #060607;
}

.badge-default {
  color: #091428;
  background-color: #4172c6;
}

.badge-default[href]:hover,
.badge-default[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #09111e;
}

.badge-white {
  color: #e8e3e3;
  background-color: white;
}

.badge-white[href]:hover,
.badge-white[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #e0e0e0;
}

.badge-neutral {
  color: #e8e3e3;
  background-color: white;
}

.badge-neutral[href]:hover,
.badge-neutral[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #e0e0e0;
}

.badge-darker {
  color: black;
  background-color: #525252;
}

.badge-darker[href]:hover,
.badge-darker[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: black;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.4375rem;
}

@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 4.5rem;
}

.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1.5rem;
  color: inherit;
}

.alert-primary {
  color: #fff;
  border-color: #7889e8;
  background-color: #7889e8;
}

.alert-primary a {
  color: #1d32aa;
  font-weight: 600;
}

.alert-primary a:hover {
  color: #fff;
}

.alert-primary hr {
  border-top-color: #6276e4;
}

.alert-primary .alert-link {
  color: #324cdd;
}

.alert-secondary {
  color: #212529;
  border-color: #f8fbfc;
  background-color: #f8fbfc;
}

.alert-secondary a {
  color: #8dbece;
  font-weight: 600;
}

.alert-secondary a:hover {
  color: #212529;
}

.alert-secondary hr {
  border-top-color: #e6f1f4;
}

.alert-secondary .alert-link {
  color: #d2e3ee;
}

.alert-success {
  color: #fff;
  border-color: #4fd69c;
  background-color: #4fd69c;
}

.alert-success a {
  color: #1a724c;
  font-weight: 600;
}

.alert-success a:hover {
  color: #fff;
}

.alert-success hr {
  border-top-color: #3ad190;
}

.alert-success .alert-link {
  color: #24a46d;
}

.alert-info {
  color: #fff;
  border-color: #37d5f2;
  background-color: #37d5f2;
}

.alert-info a {
  color: #097487;
  font-weight: 600;
}

.alert-info a:hover {
  color: #fff;
}

.alert-info hr {
  border-top-color: #1fd0f0;
}

.alert-info .alert-link {
  color: #0da5c0;
}

.alert-warning {
  color: #fff;
  border-color: #fc7c5f;
  background-color: #fc7c5f;
}

.alert-warning a {
  color: #be2604;
  font-weight: 600;
}

.alert-warning a:hover {
  color: #fff;
}

.alert-warning hr {
  border-top-color: #fc6846;
}

.alert-warning .alert-link {
  color: #fa3a0e;
}

.alert-danger {
  color: #fff;
  border-color: #f75676;
  background-color: #f75676;
}

.alert-danger a {
  color: #ac0829;
  font-weight: 600;
}

.alert-danger a:hover {
  color: #fff;
}

.alert-danger hr {
  border-top-color: #f63e62;
}

.alert-danger .alert-link {
  color: #ec0c38;
}

.alert-light {
  color: #fff;
  border-color: #bac1c8;
  background-color: #bac1c8;
}

.alert-light a {
  color: #677582;
  font-weight: 600;
}

.alert-light a:hover {
  color: #fff;
}

.alert-light hr {
  border-top-color: #acb4bd;
}

.alert-light .alert-link {
  color: #919ca6;
}

.alert-dark {
  color: #fff;
  border-color: #45484b;
  background-color: #45484b;
}

.alert-dark a {
  color: black;
  font-weight: 600;
}

.alert-dark a:hover {
  color: #fff;
}

.alert-dark hr {
  border-top-color: #393b3e;
}

.alert-dark .alert-link {
  color: #0a0c0d;
}

.alert-default {
  color: #fff;
  border-color: #3c4d69;
  background-color: #3c4d69;
}

.alert-default a {
  color: #040608;
  font-weight: 600;
}

.alert-default a:hover {
  color: #fff;
}

.alert-default hr {
  border-top-color: #334159;
}

.alert-default .alert-link {
  color: #0b1526;
}

.alert-white {
  color: #212529;
  border-color: white;
  background-color: white;
}

.alert-white a {
  color: #b3b3b3;
  font-weight: 600;
}

.alert-white a:hover {
  color: #212529;
}

.alert-white hr {
  border-top-color: #f2f2f2;
}

.alert-white .alert-link {
  color: #e6e6e6;
}

.alert-neutral {
  color: #212529;
  border-color: white;
  background-color: white;
}

.alert-neutral a {
  color: #b3b3b3;
  font-weight: 600;
}

.alert-neutral a:hover {
  color: #212529;
}

.alert-neutral hr {
  border-top-color: #f2f2f2;
}

.alert-neutral .alert-link {
  color: #e6e6e6;
}

.alert-darker {
  color: #fff;
  border-color: #292929;
  background-color: #292929;
}

.alert-darker a {
  color: black;
  font-weight: 600;
}

.alert-darker a:hover {
  color: #fff;
}

.alert-darker hr {
  border-top-color: #1c1c1c;
}

.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }

  to {
    background-position: 0 0;
  }
}

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.375rem;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #5e72e4;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.375rem;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}

.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  background-color: #fff;
  border: 1px solid #e9ecef;
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #8898aa;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.list-group-item+.list-group-item {
  border-top-width: 0;
}

.list-group-item+.list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal>.list-group-item:first-child {
  border-bottom-left-radius: 0.375rem;
  border-top-right-radius: 0;
}

.list-group-horizontal>.list-group-item:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal>.list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm>.list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md>.list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg>.list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl>.list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush>.list-group-item {
  border-width: 0 0 1px;
}

.list-group-flush>.list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #313b77;
  background-color: #d2d8f7;
}

.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
  color: #313b77;
  background-color: #bcc5f3;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #313b77;
  border-color: #313b77;
}

.list-group-item-secondary {
  color: #808283;
  background-color: #fdfefe;
}

.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
  color: #808283;
  background-color: #ecf6f6;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #808283;
  border-color: #808283;
}

.list-group-item-success {
  color: #176b47;
  background-color: #c4f1de;
}

.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
  color: #176b47;
  background-color: #afecd2;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #176b47;
  border-color: #176b47;
}

.list-group-item-info {
  color: #096b7c;
  background-color: #bcf1fb;
}

.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
  color: #096b7c;
  background-color: #a4ecfa;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #096b7c;
  border-color: #096b7c;
}

.list-group-item-warning {
  color: #833321;
  background-color: #fed3ca;
}

.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
  color: #833321;
  background-color: #febeb1;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #833321;
  border-color: #833321;
}

.list-group-item-danger {
  color: #7f1c30;
  background-color: #fcc7d1;
}

.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
  color: #7f1c30;
  background-color: #fbafbd;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #7f1c30;
  border-color: #7f1c30;
}

.list-group-item-light {
  color: #5a5e62;
  background-color: #e8eaed;
}

.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
  color: #5a5e62;
  background-color: #dadde2;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #5a5e62;
  border-color: #5a5e62;
}

.list-group-item-dark {
  color: #111315;
  background-color: #c1c2c3;
}

.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
  color: #111315;
  background-color: #b4b5b6;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #111315;
  border-color: #111315;
}

.list-group-item-default {
  color: #0c1628;
  background-color: #bec4cd;
}

.list-group-item-default.list-group-item-action:hover,
.list-group-item-default.list-group-item-action:focus {
  color: #0c1628;
  background-color: #b0b7c2;
}

.list-group-item-default.list-group-item-action.active {
  color: #fff;
  background-color: #0c1628;
  border-color: #0c1628;
}

.list-group-item-white {
  color: #858585;
  background-color: white;
}

.list-group-item-white.list-group-item-action:hover,
.list-group-item-white.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}

.list-group-item-white.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-neutral {
  color: #858585;
  background-color: white;
}

.list-group-item-neutral.list-group-item-action:hover,
.list-group-item-neutral.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}

.list-group-item-neutral.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-darker {
  color: black;
  background-color: #b8b8b8;
}

.list-group-item-darker.list-group-item-action:hover,
.list-group-item-darker.list-group-item-action:focus {
  color: black;
  background-color: #ababab;
}

.list-group-item-darker.list-group-item-action.active {
  color: #fff;
  background-color: black;
  border-color: black;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
}

@media (max-width: 1200px) {
  .close {
    font-size: calc(1.275rem + 0.3vw);
  }
}

.close:hover {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
}

.close:not(:disabled):not(.disabled):hover,
.close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: -webkit-min-content;
  height: min-content;
  content: "";
}

.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}

.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.2);
  border-radius: 0.4375rem;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.16;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem;
  border-bottom: 0 solid #e9ecef;
  border-top-left-radius: 0.4375rem;
  border-top-right-radius: 0.4375rem;
}

.modal-header .close {
  padding: 1.25rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.1;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 1.25rem;
  border-top: 0 solid #e9ecef;
  border-bottom-right-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}

.modal-footer>* {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }

  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }

  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: -webkit-min-content;
    height: min-content;
  }

  .modal-content {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2),
      0 5px 15px rgba(0, 0, 0, 0.17);
  }

  .modal-sm {
    max-width: 380px;
  }
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .arrow,
.bs-tooltip-auto[x-placement^="top"] .arrow {
  bottom: 0;
}

.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right,
.bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem;
}

.bs-tooltip-right .arrow,
.bs-tooltip-auto[x-placement^="right"] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^="right"] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .arrow,
.bs-tooltip-auto[x-placement^="bottom"] .arrow {
  top: 0;
}

.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left,
.bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem;
}

.bs-tooltip-left .arrow,
.bs-tooltip-auto[x-placement^="left"] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^="left"] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.375rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.4375rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);
}

.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.4375rem;
}

.popover .arrow::before,
.popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top,
.bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem;
}

.bs-popover-top>.arrow,
.bs-popover-auto[x-placement^="top"]>.arrow {
  bottom: calc(-0.5rem - 1px);
}

.bs-popover-top>.arrow::before,
.bs-popover-auto[x-placement^="top"]>.arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: transparent;
}

.bs-popover-top>.arrow::after,
.bs-popover-auto[x-placement^="top"]>.arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right,
.bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem;
}

.bs-popover-right>.arrow,
.bs-popover-auto[x-placement^="right"]>.arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.4375rem 0;
}

.bs-popover-right>.arrow::before,
.bs-popover-auto[x-placement^="right"]>.arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: transparent;
}

.bs-popover-right>.arrow::after,
.bs-popover-auto[x-placement^="right"]>.arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom,
.bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem;
}

.bs-popover-bottom>.arrow,
.bs-popover-auto[x-placement^="bottom"]>.arrow {
  top: calc(-0.5rem - 1px);
}

.bs-popover-bottom>.arrow::before,
.bs-popover-auto[x-placement^="bottom"]>.arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: transparent;
}

.bs-popover-bottom>.arrow::after,
.bs-popover-auto[x-placement^="bottom"]>.arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-left,
.bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem;
}

.bs-popover-left>.arrow,
.bs-popover-auto[x-placement^="left"]>.arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.4375rem 0;
}

.bs-popover-left>.arrow::before,
.bs-popover-auto[x-placement^="left"]>.arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: transparent;
}

.bs-popover-left>.arrow::after,
.bs-popover-auto[x-placement^="left"]>.arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.95rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #32325d;
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
  border-top-left-radius: calc(0.4375rem - 1px);
  border-top-right-radius: calc(0.4375rem - 1px);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.95rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50% / 100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #5e72e4 !important;
}

a.bg-primary:hover,
a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #324cdd !important;
}

.bg-secondary {
  background-color: #f7fafc !important;
}

a.bg-secondary:hover,
a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #d2e3ee !important;
}

.bg-success {
  background-color: #2dce89 !important;
}

a.bg-success:hover,
a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #24a46d !important;
}

.bg-info {
  background-color: #11cdef !important;
}

a.bg-info:hover,
a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0da5c0 !important;
}

.bg-warning {
  background-color: #fb6340 !important;
}

a.bg-warning:hover,
a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #fa3a0e !important;
}

.bg-danger {
  background-color: #f5365c !important;
}

a.bg-danger:hover,
a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #ec0c38 !important;
}

.bg-light {
  background-color: #adb5bd !important;
}

a.bg-light:hover,
a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #919ca6 !important;
}

.bg-dark {
  background-color: #212529 !important;
}

a.bg-dark:hover,
a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #0a0c0d !important;
}

.bg-default {
  background-color: #172b4d !important;
}

a.bg-default:hover,
a.bg-default:focus,
button.bg-default:hover,
button.bg-default:focus {
  background-color: #0b1526 !important;
}

.bg-white {
  background-color: #fff !important;
}

a.bg-white:hover,
a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-neutral {
  background-color: #fff !important;
}

a.bg-neutral:hover,
a.bg-neutral:focus,
button.bg-neutral:hover,
button.bg-neutral:focus {
  background-color: #e6e6e6 !important;
}

.bg-darker {
  background-color: black !important;
}

a.bg-darker:hover,
a.bg-darker:focus,
button.bg-darker:hover,
button.bg-darker:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #e9ecef !important;
}

.border-top {
  border-top: 1px solid #e9ecef !important;
}

.border-right {
  border-right: 1px solid #e9ecef !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.border-left {
  border-left: 1px solid #e9ecef !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #5e72e4 !important;
}

.border-secondary {
  border-color: #f7fafc !important;
}

.border-success {
  border-color: #2dce89 !important;
}

.border-info {
  border-color: #11cdef !important;
}

.border-warning {
  border-color: #fb6340 !important;
}

.border-danger {
  border-color: #f5365c !important;
}

.border-light {
  border-color: #adb5bd !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-default {
  border-color: #172b4d !important;
}

.border-white {
  border-color: #fff !important;
}

.border-neutral {
  border-color: #fff !important;
}

.border-darker {
  border-color: black !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.25rem !important;
}

.rounded {
  border-radius: 0.375rem !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-right-radius: 0.375rem !important;
}

.rounded-right {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-left {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-lg {
  border-radius: 0.4375rem !important;
}

.rounded-circle,
.avatar.rounded-circle img {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}

@media print {
  .d-print-none {
    display: none !important;
  }

  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }
}

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}

.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }

  .float-sm-right {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }

  .float-md-right {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }

  .float-lg-right {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }

  .float-xl-right {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sticky-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.m--9 {
  margin: -10rem !important;
}

.mt--9,
.my--9 {
  margin-top: -10rem !important;
}

.mr--9,
.mx--9 {
  margin-right: -10rem !important;
}

.mb--9,
.my--9 {
  margin-bottom: -10rem !important;
}

.ml--9,
.mx--9 {
  margin-left: -10rem !important;
}

.m--8 {
  margin: -8rem !important;
}

.mt--8,
.my--8 {
  margin-top: -8rem !important;
}

.mr--8,
.mx--8 {
  margin-right: -8rem !important;
}

.mb--8,
.my--8 {
  margin-bottom: -8rem !important;
}

.ml--8,
.mx--8 {
  margin-left: -8rem !important;
}

.m--7 {
  margin: -6rem !important;
}

.mt--7,
.my--7 {
  margin-top: -6rem !important;
}

.mr--7,
.mx--7 {
  margin-right: -6rem !important;
}

.mb--7,
.my--7 {
  margin-bottom: -6rem !important;
}

.ml--7,
.mx--7 {
  margin-left: -6rem !important;
}

.m--6 {
  margin: -4.5rem !important;
}

.mt--6,
.my--6 {
  margin-top: -4.5rem !important;
}

.mr--6,
.mx--6 {
  margin-right: -4.5rem !important;
}

.mb--6,
.my--6 {
  margin-bottom: -4.5rem !important;
}

.ml--6,
.mx--6 {
  margin-left: -4.5rem !important;
}

.m--5 {
  margin: -3rem !important;
}

.mt--5,
.my--5 {
  margin-top: -3rem !important;
}

.mr--5,
.mx--5 {
  margin-right: -3rem !important;
}

.mb--5,
.my--5 {
  margin-bottom: -3rem !important;
}

.ml--5,
.mx--5 {
  margin-left: -3rem !important;
}

.m--4 {
  margin: -1.5rem !important;
}

.mt--4,
.my--4 {
  margin-top: -1.5rem !important;
}

.mr--4,
.mx--4 {
  margin-right: -1.5rem !important;
}

.mb--4,
.my--4 {
  margin-bottom: -1.5rem !important;
}

.ml--4,
.mx--4 {
  margin-left: -1.5rem !important;
}

.m--3 {
  margin: -1rem !important;
}

.mt--3,
.my--3 {
  margin-top: -1rem !important;
}

.mr--3,
.mx--3 {
  margin-right: -1rem !important;
}

.mb--3,
.my--3 {
  margin-bottom: -1rem !important;
}

.ml--3,
.mx--3 {
  margin-left: -1rem !important;
}

.m--2 {
  margin: -0.5rem !important;
}

.mt--2,
.my--2 {
  margin-top: -0.5rem !important;
}

.mr--2,
.mx--2 {
  margin-right: -0.5rem !important;
}

.mb--2,
.my--2 {
  margin-bottom: -0.5rem !important;
}

.ml--2,
.mx--2 {
  margin-left: -0.5rem !important;
}

.m--1 {
  margin: -0.25rem !important;
}

.mt--1,
.my--1 {
  margin-top: -0.25rem !important;
}

.mr--1,
.mx--1 {
  margin-right: -0.25rem !important;
}

.mb--1,
.my--1 {
  margin-bottom: -0.25rem !important;
}

.ml--1,
.mx--1 {
  margin-left: -0.25rem !important;
}

.m-6 {
  margin: 4.5rem !important;
}

.mt-6,
.my-6 {
  margin-top: 4.5rem !important;
}

.mr-6,
.mx-6 {
  margin-right: 4.5rem !important;
}

.mb-6,
.my-6 {
  margin-bottom: 4.5rem !important;
}

.ml-6,
.mx-6 {
  margin-left: 4.5rem !important;
}

.m-7 {
  margin: 6rem !important;
}

.mt-7,
.my-7 {
  margin-top: 6rem !important;
}

.mr-7,
.mx-7 {
  margin-right: 6rem !important;
}

.mb-7,
.my-7 {
  margin-bottom: 6rem !important;
}

.ml-7,
.mx-7 {
  margin-left: 6rem !important;
}

.m-8 {
  margin: 8rem !important;
}

.mt-8,
.my-8 {
  margin-top: 8rem !important;
}

.mr-8,
.mx-8 {
  margin-right: 8rem !important;
}

.mb-8,
.my-8 {
  margin-bottom: 8rem !important;
}

.ml-8,
.mx-8 {
  margin-left: 8rem !important;
}

.m-9 {
  margin: 10rem !important;
}

.mt-9,
.my-9 {
  margin-top: 10rem !important;
}

.mr-9,
.mx-9 {
  margin-right: 10rem !important;
}

.mb-9,
.my-9 {
  margin-bottom: 10rem !important;
}

.ml-9,
.mx-9 {
  margin-left: 10rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.p--9 {
  padding: -10rem !important;
}

.pt--9,
.py--9 {
  padding-top: -10rem !important;
}

.pr--9,
.px--9 {
  padding-right: -10rem !important;
}

.pb--9,
.py--9 {
  padding-bottom: -10rem !important;
}

.pl--9,
.px--9 {
  padding-left: -10rem !important;
}

.p--8 {
  padding: -8rem !important;
}

.pt--8,
.py--8 {
  padding-top: -8rem !important;
}

.pr--8,
.px--8 {
  padding-right: -8rem !important;
}

.pb--8,
.py--8 {
  padding-bottom: -8rem !important;
}

.pl--8,
.px--8 {
  padding-left: -8rem !important;
}

.p--7 {
  padding: -6rem !important;
}

.pt--7,
.py--7 {
  padding-top: -6rem !important;
}

.pr--7,
.px--7 {
  padding-right: -6rem !important;
}

.pb--7,
.py--7 {
  padding-bottom: -6rem !important;
}

.pl--7,
.px--7 {
  padding-left: -6rem !important;
}

.p--6 {
  padding: -4.5rem !important;
}

.pt--6,
.py--6 {
  padding-top: -4.5rem !important;
}

.pr--6,
.px--6 {
  padding-right: -4.5rem !important;
}

.pb--6,
.py--6 {
  padding-bottom: -4.5rem !important;
}

.pl--6,
.px--6 {
  padding-left: -4.5rem !important;
}

.p--5 {
  padding: -3rem !important;
}

.pt--5,
.py--5 {
  padding-top: -3rem !important;
}

.pr--5,
.px--5 {
  padding-right: -3rem !important;
}

.pb--5,
.py--5 {
  padding-bottom: -3rem !important;
}

.pl--5,
.px--5 {
  padding-left: -3rem !important;
}

.p--4 {
  padding: -1.5rem !important;
}

.pt--4,
.py--4 {
  padding-top: -1.5rem !important;
}

.pr--4,
.px--4 {
  padding-right: -1.5rem !important;
}

.pb--4,
.py--4 {
  padding-bottom: -1.5rem !important;
}

.pl--4,
.px--4 {
  padding-left: -1.5rem !important;
}

.p--3 {
  padding: -1rem !important;
}

.pt--3,
.py--3 {
  padding-top: -1rem !important;
}

.pr--3,
.px--3 {
  padding-right: -1rem !important;
}

.pb--3,
.py--3 {
  padding-bottom: -1rem !important;
}

.pl--3,
.px--3 {
  padding-left: -1rem !important;
}

.p--2 {
  padding: -0.5rem !important;
}

.pt--2,
.py--2 {
  padding-top: -0.5rem !important;
}

.pr--2,
.px--2 {
  padding-right: -0.5rem !important;
}

.pb--2,
.py--2 {
  padding-bottom: -0.5rem !important;
}

.pl--2,
.px--2 {
  padding-left: -0.5rem !important;
}

.p--1 {
  padding: -0.25rem !important;
}

.pt--1,
.py--1 {
  padding-top: -0.25rem !important;
}

.pr--1,
.px--1 {
  padding-right: -0.25rem !important;
}

.pb--1,
.py--1 {
  padding-bottom: -0.25rem !important;
}

.pl--1,
.px--1 {
  padding-left: -0.25rem !important;
}

.p-6 {
  padding: 4.5rem !important;
}

.pt-6,
.py-6 {
  padding-top: 4.5rem !important;
}

.pr-6,
.px-6 {
  padding-right: 4.5rem !important;
}

.pb-6,
.py-6 {
  padding-bottom: 4.5rem !important;
}

.pl-6,
.px-6 {
  padding-left: 4.5rem !important;
}

.p-7 {
  padding: 6rem !important;
}

.pt-7,
.py-7 {
  padding-top: 6rem !important;
}

.pr-7,
.px-7 {
  padding-right: 6rem !important;
}

.pb-7,
.py-7 {
  padding-bottom: 6rem !important;
}

.pl-7,
.px-7 {
  padding-left: 6rem !important;
}

.p-8 {
  padding: 8rem !important;
}

.pt-8,
.py-8 {
  padding-top: 8rem !important;
}

.pr-8,
.px-8 {
  padding-right: 8rem !important;
}

.pb-8,
.py-8 {
  padding-bottom: 8rem !important;
}

.pl-8,
.px-8 {
  padding-left: 8rem !important;
}

.p-9 {
  padding: 10rem !important;
}

.pt-9,
.py-9 {
  padding-top: 10rem !important;
}

.pr-9,
.px-9 {
  padding-right: 10rem !important;
}

.pb-9,
.py-9 {
  padding-bottom: 10rem !important;
}

.pl-9,
.px-9 {
  padding-left: 10rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-n-9 {
  margin: 10rem !important;
}

.mt-n-9,
.my-n-9 {
  margin-top: 10rem !important;
}

.mr-n-9,
.mx-n-9 {
  margin-right: 10rem !important;
}

.mb-n-9,
.my-n-9 {
  margin-bottom: 10rem !important;
}

.ml-n-9,
.mx-n-9 {
  margin-left: 10rem !important;
}

.m-n-8 {
  margin: 8rem !important;
}

.mt-n-8,
.my-n-8 {
  margin-top: 8rem !important;
}

.mr-n-8,
.mx-n-8 {
  margin-right: 8rem !important;
}

.mb-n-8,
.my-n-8 {
  margin-bottom: 8rem !important;
}

.ml-n-8,
.mx-n-8 {
  margin-left: 8rem !important;
}

.m-n-7 {
  margin: 6rem !important;
}

.mt-n-7,
.my-n-7 {
  margin-top: 6rem !important;
}

.mr-n-7,
.mx-n-7 {
  margin-right: 6rem !important;
}

.mb-n-7,
.my-n-7 {
  margin-bottom: 6rem !important;
}

.ml-n-7,
.mx-n-7 {
  margin-left: 6rem !important;
}

.m-n-6 {
  margin: 4.5rem !important;
}

.mt-n-6,
.my-n-6 {
  margin-top: 4.5rem !important;
}

.mr-n-6,
.mx-n-6 {
  margin-right: 4.5rem !important;
}

.mb-n-6,
.my-n-6 {
  margin-bottom: 4.5rem !important;
}

.ml-n-6,
.mx-n-6 {
  margin-left: 4.5rem !important;
}

.m-n-5 {
  margin: 3rem !important;
}

.mt-n-5,
.my-n-5 {
  margin-top: 3rem !important;
}

.mr-n-5,
.mx-n-5 {
  margin-right: 3rem !important;
}

.mb-n-5,
.my-n-5 {
  margin-bottom: 3rem !important;
}

.ml-n-5,
.mx-n-5 {
  margin-left: 3rem !important;
}

.m-n-4 {
  margin: 1.5rem !important;
}

.mt-n-4,
.my-n-4 {
  margin-top: 1.5rem !important;
}

.mr-n-4,
.mx-n-4 {
  margin-right: 1.5rem !important;
}

.mb-n-4,
.my-n-4 {
  margin-bottom: 1.5rem !important;
}

.ml-n-4,
.mx-n-4 {
  margin-left: 1.5rem !important;
}

.m-n-3 {
  margin: 1rem !important;
}

.mt-n-3,
.my-n-3 {
  margin-top: 1rem !important;
}

.mr-n-3,
.mx-n-3 {
  margin-right: 1rem !important;
}

.mb-n-3,
.my-n-3 {
  margin-bottom: 1rem !important;
}

.ml-n-3,
.mx-n-3 {
  margin-left: 1rem !important;
}

.m-n-2 {
  margin: 0.5rem !important;
}

.mt-n-2,
.my-n-2 {
  margin-top: 0.5rem !important;
}

.mr-n-2,
.mx-n-2 {
  margin-right: 0.5rem !important;
}

.mb-n-2,
.my-n-2 {
  margin-bottom: 0.5rem !important;
}

.ml-n-2,
.mx-n-2 {
  margin-left: 0.5rem !important;
}

.m-n-1 {
  margin: 0.25rem !important;
}

.mt-n-1,
.my-n-1 {
  margin-top: 0.25rem !important;
}

.mr-n-1,
.mx-n-1 {
  margin-right: 0.25rem !important;
}

.mb-n-1,
.my-n-1 {
  margin-bottom: 0.25rem !important;
}

.ml-n-1,
.mx-n-1 {
  margin-left: 0.25rem !important;
}

.m-n6 {
  margin: -4.5rem !important;
}

.mt-n6,
.my-n6 {
  margin-top: -4.5rem !important;
}

.mr-n6,
.mx-n6 {
  margin-right: -4.5rem !important;
}

.mb-n6,
.my-n6 {
  margin-bottom: -4.5rem !important;
}

.ml-n6,
.mx-n6 {
  margin-left: -4.5rem !important;
}

.m-n7 {
  margin: -6rem !important;
}

.mt-n7,
.my-n7 {
  margin-top: -6rem !important;
}

.mr-n7,
.mx-n7 {
  margin-right: -6rem !important;
}

.mb-n7,
.my-n7 {
  margin-bottom: -6rem !important;
}

.ml-n7,
.mx-n7 {
  margin-left: -6rem !important;
}

.m-n8 {
  margin: -8rem !important;
}

.mt-n8,
.my-n8 {
  margin-top: -8rem !important;
}

.mr-n8,
.mx-n8 {
  margin-right: -8rem !important;
}

.mb-n8,
.my-n8 {
  margin-bottom: -8rem !important;
}

.ml-n8,
.mx-n8 {
  margin-left: -8rem !important;
}

.m-n9 {
  margin: -10rem !important;
}

.mt-n9,
.my-n9 {
  margin-top: -10rem !important;
}

.mr-n9,
.mx-n9 {
  margin-right: -10rem !important;
}

.mb-n9,
.my-n9 {
  margin-bottom: -10rem !important;
}

.ml-n9,
.mx-n9 {
  margin-left: -10rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }

  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }

  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }

  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }

  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }

  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }

  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }

  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }

  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }

  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }

  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }

  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }

  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }

  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }

  .m-sm--9 {
    margin: -10rem !important;
  }

  .mt-sm--9,
  .my-sm--9 {
    margin-top: -10rem !important;
  }

  .mr-sm--9,
  .mx-sm--9 {
    margin-right: -10rem !important;
  }

  .mb-sm--9,
  .my-sm--9 {
    margin-bottom: -10rem !important;
  }

  .ml-sm--9,
  .mx-sm--9 {
    margin-left: -10rem !important;
  }

  .m-sm--8 {
    margin: -8rem !important;
  }

  .mt-sm--8,
  .my-sm--8 {
    margin-top: -8rem !important;
  }

  .mr-sm--8,
  .mx-sm--8 {
    margin-right: -8rem !important;
  }

  .mb-sm--8,
  .my-sm--8 {
    margin-bottom: -8rem !important;
  }

  .ml-sm--8,
  .mx-sm--8 {
    margin-left: -8rem !important;
  }

  .m-sm--7 {
    margin: -6rem !important;
  }

  .mt-sm--7,
  .my-sm--7 {
    margin-top: -6rem !important;
  }

  .mr-sm--7,
  .mx-sm--7 {
    margin-right: -6rem !important;
  }

  .mb-sm--7,
  .my-sm--7 {
    margin-bottom: -6rem !important;
  }

  .ml-sm--7,
  .mx-sm--7 {
    margin-left: -6rem !important;
  }

  .m-sm--6 {
    margin: -4.5rem !important;
  }

  .mt-sm--6,
  .my-sm--6 {
    margin-top: -4.5rem !important;
  }

  .mr-sm--6,
  .mx-sm--6 {
    margin-right: -4.5rem !important;
  }

  .mb-sm--6,
  .my-sm--6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-sm--6,
  .mx-sm--6 {
    margin-left: -4.5rem !important;
  }

  .m-sm--5 {
    margin: -3rem !important;
  }

  .mt-sm--5,
  .my-sm--5 {
    margin-top: -3rem !important;
  }

  .mr-sm--5,
  .mx-sm--5 {
    margin-right: -3rem !important;
  }

  .mb-sm--5,
  .my-sm--5 {
    margin-bottom: -3rem !important;
  }

  .ml-sm--5,
  .mx-sm--5 {
    margin-left: -3rem !important;
  }

  .m-sm--4 {
    margin: -1.5rem !important;
  }

  .mt-sm--4,
  .my-sm--4 {
    margin-top: -1.5rem !important;
  }

  .mr-sm--4,
  .mx-sm--4 {
    margin-right: -1.5rem !important;
  }

  .mb-sm--4,
  .my-sm--4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-sm--4,
  .mx-sm--4 {
    margin-left: -1.5rem !important;
  }

  .m-sm--3 {
    margin: -1rem !important;
  }

  .mt-sm--3,
  .my-sm--3 {
    margin-top: -1rem !important;
  }

  .mr-sm--3,
  .mx-sm--3 {
    margin-right: -1rem !important;
  }

  .mb-sm--3,
  .my-sm--3 {
    margin-bottom: -1rem !important;
  }

  .ml-sm--3,
  .mx-sm--3 {
    margin-left: -1rem !important;
  }

  .m-sm--2 {
    margin: -0.5rem !important;
  }

  .mt-sm--2,
  .my-sm--2 {
    margin-top: -0.5rem !important;
  }

  .mr-sm--2,
  .mx-sm--2 {
    margin-right: -0.5rem !important;
  }

  .mb-sm--2,
  .my-sm--2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-sm--2,
  .mx-sm--2 {
    margin-left: -0.5rem !important;
  }

  .m-sm--1 {
    margin: -0.25rem !important;
  }

  .mt-sm--1,
  .my-sm--1 {
    margin-top: -0.25rem !important;
  }

  .mr-sm--1,
  .mx-sm--1 {
    margin-right: -0.25rem !important;
  }

  .mb-sm--1,
  .my-sm--1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-sm--1,
  .mx-sm--1 {
    margin-left: -0.25rem !important;
  }

  .m-sm-6 {
    margin: 4.5rem !important;
  }

  .mt-sm-6,
  .my-sm-6 {
    margin-top: 4.5rem !important;
  }

  .mr-sm-6,
  .mx-sm-6 {
    margin-right: 4.5rem !important;
  }

  .mb-sm-6,
  .my-sm-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-sm-6,
  .mx-sm-6 {
    margin-left: 4.5rem !important;
  }

  .m-sm-7 {
    margin: 6rem !important;
  }

  .mt-sm-7,
  .my-sm-7 {
    margin-top: 6rem !important;
  }

  .mr-sm-7,
  .mx-sm-7 {
    margin-right: 6rem !important;
  }

  .mb-sm-7,
  .my-sm-7 {
    margin-bottom: 6rem !important;
  }

  .ml-sm-7,
  .mx-sm-7 {
    margin-left: 6rem !important;
  }

  .m-sm-8 {
    margin: 8rem !important;
  }

  .mt-sm-8,
  .my-sm-8 {
    margin-top: 8rem !important;
  }

  .mr-sm-8,
  .mx-sm-8 {
    margin-right: 8rem !important;
  }

  .mb-sm-8,
  .my-sm-8 {
    margin-bottom: 8rem !important;
  }

  .ml-sm-8,
  .mx-sm-8 {
    margin-left: 8rem !important;
  }

  .m-sm-9 {
    margin: 10rem !important;
  }

  .mt-sm-9,
  .my-sm-9 {
    margin-top: 10rem !important;
  }

  .mr-sm-9,
  .mx-sm-9 {
    margin-right: 10rem !important;
  }

  .mb-sm-9,
  .my-sm-9 {
    margin-bottom: 10rem !important;
  }

  .ml-sm-9,
  .mx-sm-9 {
    margin-left: 10rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }

  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }

  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }

  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }

  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }

  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }

  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }

  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }

  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }

  .p-sm--9 {
    padding: -10rem !important;
  }

  .pt-sm--9,
  .py-sm--9 {
    padding-top: -10rem !important;
  }

  .pr-sm--9,
  .px-sm--9 {
    padding-right: -10rem !important;
  }

  .pb-sm--9,
  .py-sm--9 {
    padding-bottom: -10rem !important;
  }

  .pl-sm--9,
  .px-sm--9 {
    padding-left: -10rem !important;
  }

  .p-sm--8 {
    padding: -8rem !important;
  }

  .pt-sm--8,
  .py-sm--8 {
    padding-top: -8rem !important;
  }

  .pr-sm--8,
  .px-sm--8 {
    padding-right: -8rem !important;
  }

  .pb-sm--8,
  .py-sm--8 {
    padding-bottom: -8rem !important;
  }

  .pl-sm--8,
  .px-sm--8 {
    padding-left: -8rem !important;
  }

  .p-sm--7 {
    padding: -6rem !important;
  }

  .pt-sm--7,
  .py-sm--7 {
    padding-top: -6rem !important;
  }

  .pr-sm--7,
  .px-sm--7 {
    padding-right: -6rem !important;
  }

  .pb-sm--7,
  .py-sm--7 {
    padding-bottom: -6rem !important;
  }

  .pl-sm--7,
  .px-sm--7 {
    padding-left: -6rem !important;
  }

  .p-sm--6 {
    padding: -4.5rem !important;
  }

  .pt-sm--6,
  .py-sm--6 {
    padding-top: -4.5rem !important;
  }

  .pr-sm--6,
  .px-sm--6 {
    padding-right: -4.5rem !important;
  }

  .pb-sm--6,
  .py-sm--6 {
    padding-bottom: -4.5rem !important;
  }

  .pl-sm--6,
  .px-sm--6 {
    padding-left: -4.5rem !important;
  }

  .p-sm--5 {
    padding: -3rem !important;
  }

  .pt-sm--5,
  .py-sm--5 {
    padding-top: -3rem !important;
  }

  .pr-sm--5,
  .px-sm--5 {
    padding-right: -3rem !important;
  }

  .pb-sm--5,
  .py-sm--5 {
    padding-bottom: -3rem !important;
  }

  .pl-sm--5,
  .px-sm--5 {
    padding-left: -3rem !important;
  }

  .p-sm--4 {
    padding: -1.5rem !important;
  }

  .pt-sm--4,
  .py-sm--4 {
    padding-top: -1.5rem !important;
  }

  .pr-sm--4,
  .px-sm--4 {
    padding-right: -1.5rem !important;
  }

  .pb-sm--4,
  .py-sm--4 {
    padding-bottom: -1.5rem !important;
  }

  .pl-sm--4,
  .px-sm--4 {
    padding-left: -1.5rem !important;
  }

  .p-sm--3 {
    padding: -1rem !important;
  }

  .pt-sm--3,
  .py-sm--3 {
    padding-top: -1rem !important;
  }

  .pr-sm--3,
  .px-sm--3 {
    padding-right: -1rem !important;
  }

  .pb-sm--3,
  .py-sm--3 {
    padding-bottom: -1rem !important;
  }

  .pl-sm--3,
  .px-sm--3 {
    padding-left: -1rem !important;
  }

  .p-sm--2 {
    padding: -0.5rem !important;
  }

  .pt-sm--2,
  .py-sm--2 {
    padding-top: -0.5rem !important;
  }

  .pr-sm--2,
  .px-sm--2 {
    padding-right: -0.5rem !important;
  }

  .pb-sm--2,
  .py-sm--2 {
    padding-bottom: -0.5rem !important;
  }

  .pl-sm--2,
  .px-sm--2 {
    padding-left: -0.5rem !important;
  }

  .p-sm--1 {
    padding: -0.25rem !important;
  }

  .pt-sm--1,
  .py-sm--1 {
    padding-top: -0.25rem !important;
  }

  .pr-sm--1,
  .px-sm--1 {
    padding-right: -0.25rem !important;
  }

  .pb-sm--1,
  .py-sm--1 {
    padding-bottom: -0.25rem !important;
  }

  .pl-sm--1,
  .px-sm--1 {
    padding-left: -0.25rem !important;
  }

  .p-sm-6 {
    padding: 4.5rem !important;
  }

  .pt-sm-6,
  .py-sm-6 {
    padding-top: 4.5rem !important;
  }

  .pr-sm-6,
  .px-sm-6 {
    padding-right: 4.5rem !important;
  }

  .pb-sm-6,
  .py-sm-6 {
    padding-bottom: 4.5rem !important;
  }

  .pl-sm-6,
  .px-sm-6 {
    padding-left: 4.5rem !important;
  }

  .p-sm-7 {
    padding: 6rem !important;
  }

  .pt-sm-7,
  .py-sm-7 {
    padding-top: 6rem !important;
  }

  .pr-sm-7,
  .px-sm-7 {
    padding-right: 6rem !important;
  }

  .pb-sm-7,
  .py-sm-7 {
    padding-bottom: 6rem !important;
  }

  .pl-sm-7,
  .px-sm-7 {
    padding-left: 6rem !important;
  }

  .p-sm-8 {
    padding: 8rem !important;
  }

  .pt-sm-8,
  .py-sm-8 {
    padding-top: 8rem !important;
  }

  .pr-sm-8,
  .px-sm-8 {
    padding-right: 8rem !important;
  }

  .pb-sm-8,
  .py-sm-8 {
    padding-bottom: 8rem !important;
  }

  .pl-sm-8,
  .px-sm-8 {
    padding-left: 8rem !important;
  }

  .p-sm-9 {
    padding: 10rem !important;
  }

  .pt-sm-9,
  .py-sm-9 {
    padding-top: 10rem !important;
  }

  .pr-sm-9,
  .px-sm-9 {
    padding-right: 10rem !important;
  }

  .pb-sm-9,
  .py-sm-9 {
    padding-bottom: 10rem !important;
  }

  .pl-sm-9,
  .px-sm-9 {
    padding-left: 10rem !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -1rem !important;
  }

  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }

  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }

  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }

  .m-sm-n4 {
    margin: -1.5rem !important;
  }

  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }

  .m-sm-n5 {
    margin: -3rem !important;
  }

  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }

  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }

  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }

  .m-sm-n-9 {
    margin: 10rem !important;
  }

  .mt-sm-n-9,
  .my-sm-n-9 {
    margin-top: 10rem !important;
  }

  .mr-sm-n-9,
  .mx-sm-n-9 {
    margin-right: 10rem !important;
  }

  .mb-sm-n-9,
  .my-sm-n-9 {
    margin-bottom: 10rem !important;
  }

  .ml-sm-n-9,
  .mx-sm-n-9 {
    margin-left: 10rem !important;
  }

  .m-sm-n-8 {
    margin: 8rem !important;
  }

  .mt-sm-n-8,
  .my-sm-n-8 {
    margin-top: 8rem !important;
  }

  .mr-sm-n-8,
  .mx-sm-n-8 {
    margin-right: 8rem !important;
  }

  .mb-sm-n-8,
  .my-sm-n-8 {
    margin-bottom: 8rem !important;
  }

  .ml-sm-n-8,
  .mx-sm-n-8 {
    margin-left: 8rem !important;
  }

  .m-sm-n-7 {
    margin: 6rem !important;
  }

  .mt-sm-n-7,
  .my-sm-n-7 {
    margin-top: 6rem !important;
  }

  .mr-sm-n-7,
  .mx-sm-n-7 {
    margin-right: 6rem !important;
  }

  .mb-sm-n-7,
  .my-sm-n-7 {
    margin-bottom: 6rem !important;
  }

  .ml-sm-n-7,
  .mx-sm-n-7 {
    margin-left: 6rem !important;
  }

  .m-sm-n-6 {
    margin: 4.5rem !important;
  }

  .mt-sm-n-6,
  .my-sm-n-6 {
    margin-top: 4.5rem !important;
  }

  .mr-sm-n-6,
  .mx-sm-n-6 {
    margin-right: 4.5rem !important;
  }

  .mb-sm-n-6,
  .my-sm-n-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-sm-n-6,
  .mx-sm-n-6 {
    margin-left: 4.5rem !important;
  }

  .m-sm-n-5 {
    margin: 3rem !important;
  }

  .mt-sm-n-5,
  .my-sm-n-5 {
    margin-top: 3rem !important;
  }

  .mr-sm-n-5,
  .mx-sm-n-5 {
    margin-right: 3rem !important;
  }

  .mb-sm-n-5,
  .my-sm-n-5 {
    margin-bottom: 3rem !important;
  }

  .ml-sm-n-5,
  .mx-sm-n-5 {
    margin-left: 3rem !important;
  }

  .m-sm-n-4 {
    margin: 1.5rem !important;
  }

  .mt-sm-n-4,
  .my-sm-n-4 {
    margin-top: 1.5rem !important;
  }

  .mr-sm-n-4,
  .mx-sm-n-4 {
    margin-right: 1.5rem !important;
  }

  .mb-sm-n-4,
  .my-sm-n-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-sm-n-4,
  .mx-sm-n-4 {
    margin-left: 1.5rem !important;
  }

  .m-sm-n-3 {
    margin: 1rem !important;
  }

  .mt-sm-n-3,
  .my-sm-n-3 {
    margin-top: 1rem !important;
  }

  .mr-sm-n-3,
  .mx-sm-n-3 {
    margin-right: 1rem !important;
  }

  .mb-sm-n-3,
  .my-sm-n-3 {
    margin-bottom: 1rem !important;
  }

  .ml-sm-n-3,
  .mx-sm-n-3 {
    margin-left: 1rem !important;
  }

  .m-sm-n-2 {
    margin: 0.5rem !important;
  }

  .mt-sm-n-2,
  .my-sm-n-2 {
    margin-top: 0.5rem !important;
  }

  .mr-sm-n-2,
  .mx-sm-n-2 {
    margin-right: 0.5rem !important;
  }

  .mb-sm-n-2,
  .my-sm-n-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-sm-n-2,
  .mx-sm-n-2 {
    margin-left: 0.5rem !important;
  }

  .m-sm-n-1 {
    margin: 0.25rem !important;
  }

  .mt-sm-n-1,
  .my-sm-n-1 {
    margin-top: 0.25rem !important;
  }

  .mr-sm-n-1,
  .mx-sm-n-1 {
    margin-right: 0.25rem !important;
  }

  .mb-sm-n-1,
  .my-sm-n-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-sm-n-1,
  .mx-sm-n-1 {
    margin-left: 0.25rem !important;
  }

  .m-sm-n6 {
    margin: -4.5rem !important;
  }

  .mt-sm-n6,
  .my-sm-n6 {
    margin-top: -4.5rem !important;
  }

  .mr-sm-n6,
  .mx-sm-n6 {
    margin-right: -4.5rem !important;
  }

  .mb-sm-n6,
  .my-sm-n6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-sm-n6,
  .mx-sm-n6 {
    margin-left: -4.5rem !important;
  }

  .m-sm-n7 {
    margin: -6rem !important;
  }

  .mt-sm-n7,
  .my-sm-n7 {
    margin-top: -6rem !important;
  }

  .mr-sm-n7,
  .mx-sm-n7 {
    margin-right: -6rem !important;
  }

  .mb-sm-n7,
  .my-sm-n7 {
    margin-bottom: -6rem !important;
  }

  .ml-sm-n7,
  .mx-sm-n7 {
    margin-left: -6rem !important;
  }

  .m-sm-n8 {
    margin: -8rem !important;
  }

  .mt-sm-n8,
  .my-sm-n8 {
    margin-top: -8rem !important;
  }

  .mr-sm-n8,
  .mx-sm-n8 {
    margin-right: -8rem !important;
  }

  .mb-sm-n8,
  .my-sm-n8 {
    margin-bottom: -8rem !important;
  }

  .ml-sm-n8,
  .mx-sm-n8 {
    margin-left: -8rem !important;
  }

  .m-sm-n9 {
    margin: -10rem !important;
  }

  .mt-sm-n9,
  .my-sm-n9 {
    margin-top: -10rem !important;
  }

  .mr-sm-n9,
  .mx-sm-n9 {
    margin-right: -10rem !important;
  }

  .mb-sm-n9,
  .my-sm-n9 {
    margin-bottom: -10rem !important;
  }

  .ml-sm-n9,
  .mx-sm-n9 {
    margin-left: -10rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }

  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }

  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }

  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }

  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }

  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }

  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }

  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }

  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }

  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }

  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }

  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }

  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }

  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }

  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }

  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }

  .m-md--9 {
    margin: -10rem !important;
  }

  .mt-md--9,
  .my-md--9 {
    margin-top: -10rem !important;
  }

  .mr-md--9,
  .mx-md--9 {
    margin-right: -10rem !important;
  }

  .mb-md--9,
  .my-md--9 {
    margin-bottom: -10rem !important;
  }

  .ml-md--9,
  .mx-md--9 {
    margin-left: -10rem !important;
  }

  .m-md--8 {
    margin: -8rem !important;
  }

  .mt-md--8,
  .my-md--8 {
    margin-top: -8rem !important;
  }

  .mr-md--8,
  .mx-md--8 {
    margin-right: -8rem !important;
  }

  .mb-md--8,
  .my-md--8 {
    margin-bottom: -8rem !important;
  }

  .ml-md--8,
  .mx-md--8 {
    margin-left: -8rem !important;
  }

  .m-md--7 {
    margin: -6rem !important;
  }

  .mt-md--7,
  .my-md--7 {
    margin-top: -6rem !important;
  }

  .mr-md--7,
  .mx-md--7 {
    margin-right: -6rem !important;
  }

  .mb-md--7,
  .my-md--7 {
    margin-bottom: -6rem !important;
  }

  .ml-md--7,
  .mx-md--7 {
    margin-left: -6rem !important;
  }

  .m-md--6 {
    margin: -4.5rem !important;
  }

  .mt-md--6,
  .my-md--6 {
    margin-top: -4.5rem !important;
  }

  .mr-md--6,
  .mx-md--6 {
    margin-right: -4.5rem !important;
  }

  .mb-md--6,
  .my-md--6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-md--6,
  .mx-md--6 {
    margin-left: -4.5rem !important;
  }

  .m-md--5 {
    margin: -3rem !important;
  }

  .mt-md--5,
  .my-md--5 {
    margin-top: -3rem !important;
  }

  .mr-md--5,
  .mx-md--5 {
    margin-right: -3rem !important;
  }

  .mb-md--5,
  .my-md--5 {
    margin-bottom: -3rem !important;
  }

  .ml-md--5,
  .mx-md--5 {
    margin-left: -3rem !important;
  }

  .m-md--4 {
    margin: -1.5rem !important;
  }

  .mt-md--4,
  .my-md--4 {
    margin-top: -1.5rem !important;
  }

  .mr-md--4,
  .mx-md--4 {
    margin-right: -1.5rem !important;
  }

  .mb-md--4,
  .my-md--4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-md--4,
  .mx-md--4 {
    margin-left: -1.5rem !important;
  }

  .m-md--3 {
    margin: -1rem !important;
  }

  .mt-md--3,
  .my-md--3 {
    margin-top: -1rem !important;
  }

  .mr-md--3,
  .mx-md--3 {
    margin-right: -1rem !important;
  }

  .mb-md--3,
  .my-md--3 {
    margin-bottom: -1rem !important;
  }

  .ml-md--3,
  .mx-md--3 {
    margin-left: -1rem !important;
  }

  .m-md--2 {
    margin: -0.5rem !important;
  }

  .mt-md--2,
  .my-md--2 {
    margin-top: -0.5rem !important;
  }

  .mr-md--2,
  .mx-md--2 {
    margin-right: -0.5rem !important;
  }

  .mb-md--2,
  .my-md--2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-md--2,
  .mx-md--2 {
    margin-left: -0.5rem !important;
  }

  .m-md--1 {
    margin: -0.25rem !important;
  }

  .mt-md--1,
  .my-md--1 {
    margin-top: -0.25rem !important;
  }

  .mr-md--1,
  .mx-md--1 {
    margin-right: -0.25rem !important;
  }

  .mb-md--1,
  .my-md--1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-md--1,
  .mx-md--1 {
    margin-left: -0.25rem !important;
  }

  .m-md-6 {
    margin: 4.5rem !important;
  }

  .mt-md-6,
  .my-md-6 {
    margin-top: 4.5rem !important;
  }

  .mr-md-6,
  .mx-md-6 {
    margin-right: 4.5rem !important;
  }

  .mb-md-6,
  .my-md-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-md-6,
  .mx-md-6 {
    margin-left: 4.5rem !important;
  }

  .m-md-7 {
    margin: 6rem !important;
  }

  .mt-md-7,
  .my-md-7 {
    margin-top: 6rem !important;
  }

  .mr-md-7,
  .mx-md-7 {
    margin-right: 6rem !important;
  }

  .mb-md-7,
  .my-md-7 {
    margin-bottom: 6rem !important;
  }

  .ml-md-7,
  .mx-md-7 {
    margin-left: 6rem !important;
  }

  .m-md-8 {
    margin: 8rem !important;
  }

  .mt-md-8,
  .my-md-8 {
    margin-top: 8rem !important;
  }

  .mr-md-8,
  .mx-md-8 {
    margin-right: 8rem !important;
  }

  .mb-md-8,
  .my-md-8 {
    margin-bottom: 8rem !important;
  }

  .ml-md-8,
  .mx-md-8 {
    margin-left: 8rem !important;
  }

  .m-md-9 {
    margin: 10rem !important;
  }

  .mt-md-9,
  .my-md-9 {
    margin-top: 10rem !important;
  }

  .mr-md-9,
  .mx-md-9 {
    margin-right: 10rem !important;
  }

  .mb-md-9,
  .my-md-9 {
    margin-bottom: 10rem !important;
  }

  .ml-md-9,
  .mx-md-9 {
    margin-left: 10rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }

  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }

  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }

  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }

  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }

  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }

  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }

  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }

  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }

  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }

  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }

  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }

  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }

  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }

  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }

  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }

  .p-md--9 {
    padding: -10rem !important;
  }

  .pt-md--9,
  .py-md--9 {
    padding-top: -10rem !important;
  }

  .pr-md--9,
  .px-md--9 {
    padding-right: -10rem !important;
  }

  .pb-md--9,
  .py-md--9 {
    padding-bottom: -10rem !important;
  }

  .pl-md--9,
  .px-md--9 {
    padding-left: -10rem !important;
  }

  .p-md--8 {
    padding: -8rem !important;
  }

  .pt-md--8,
  .py-md--8 {
    padding-top: -8rem !important;
  }

  .pr-md--8,
  .px-md--8 {
    padding-right: -8rem !important;
  }

  .pb-md--8,
  .py-md--8 {
    padding-bottom: -8rem !important;
  }

  .pl-md--8,
  .px-md--8 {
    padding-left: -8rem !important;
  }

  .p-md--7 {
    padding: -6rem !important;
  }

  .pt-md--7,
  .py-md--7 {
    padding-top: -6rem !important;
  }

  .pr-md--7,
  .px-md--7 {
    padding-right: -6rem !important;
  }

  .pb-md--7,
  .py-md--7 {
    padding-bottom: -6rem !important;
  }

  .pl-md--7,
  .px-md--7 {
    padding-left: -6rem !important;
  }

  .p-md--6 {
    padding: -4.5rem !important;
  }

  .pt-md--6,
  .py-md--6 {
    padding-top: -4.5rem !important;
  }

  .pr-md--6,
  .px-md--6 {
    padding-right: -4.5rem !important;
  }

  .pb-md--6,
  .py-md--6 {
    padding-bottom: -4.5rem !important;
  }

  .pl-md--6,
  .px-md--6 {
    padding-left: -4.5rem !important;
  }

  .p-md--5 {
    padding: -3rem !important;
  }

  .pt-md--5,
  .py-md--5 {
    padding-top: -3rem !important;
  }

  .pr-md--5,
  .px-md--5 {
    padding-right: -3rem !important;
  }

  .pb-md--5,
  .py-md--5 {
    padding-bottom: -3rem !important;
  }

  .pl-md--5,
  .px-md--5 {
    padding-left: -3rem !important;
  }

  .p-md--4 {
    padding: -1.5rem !important;
  }

  .pt-md--4,
  .py-md--4 {
    padding-top: -1.5rem !important;
  }

  .pr-md--4,
  .px-md--4 {
    padding-right: -1.5rem !important;
  }

  .pb-md--4,
  .py-md--4 {
    padding-bottom: -1.5rem !important;
  }

  .pl-md--4,
  .px-md--4 {
    padding-left: -1.5rem !important;
  }

  .p-md--3 {
    padding: -1rem !important;
  }

  .pt-md--3,
  .py-md--3 {
    padding-top: -1rem !important;
  }

  .pr-md--3,
  .px-md--3 {
    padding-right: -1rem !important;
  }

  .pb-md--3,
  .py-md--3 {
    padding-bottom: -1rem !important;
  }

  .pl-md--3,
  .px-md--3 {
    padding-left: -1rem !important;
  }

  .p-md--2 {
    padding: -0.5rem !important;
  }

  .pt-md--2,
  .py-md--2 {
    padding-top: -0.5rem !important;
  }

  .pr-md--2,
  .px-md--2 {
    padding-right: -0.5rem !important;
  }

  .pb-md--2,
  .py-md--2 {
    padding-bottom: -0.5rem !important;
  }

  .pl-md--2,
  .px-md--2 {
    padding-left: -0.5rem !important;
  }

  .p-md--1 {
    padding: -0.25rem !important;
  }

  .pt-md--1,
  .py-md--1 {
    padding-top: -0.25rem !important;
  }

  .pr-md--1,
  .px-md--1 {
    padding-right: -0.25rem !important;
  }

  .pb-md--1,
  .py-md--1 {
    padding-bottom: -0.25rem !important;
  }

  .pl-md--1,
  .px-md--1 {
    padding-left: -0.25rem !important;
  }

  .p-md-6 {
    padding: 4.5rem !important;
  }

  .pt-md-6,
  .py-md-6 {
    padding-top: 4.5rem !important;
  }

  .pr-md-6,
  .px-md-6 {
    padding-right: 4.5rem !important;
  }

  .pb-md-6,
  .py-md-6 {
    padding-bottom: 4.5rem !important;
  }

  .pl-md-6,
  .px-md-6 {
    padding-left: 4.5rem !important;
  }

  .p-md-7 {
    padding: 6rem !important;
  }

  .pt-md-7,
  .py-md-7 {
    padding-top: 6rem !important;
  }

  .pr-md-7,
  .px-md-7 {
    padding-right: 6rem !important;
  }

  .pb-md-7,
  .py-md-7 {
    padding-bottom: 6rem !important;
  }

  .pl-md-7,
  .px-md-7 {
    padding-left: 6rem !important;
  }

  .p-md-8 {
    padding: 8rem !important;
  }

  .pt-md-8,
  .py-md-8 {
    padding-top: 8rem !important;
  }

  .pr-md-8,
  .px-md-8 {
    padding-right: 8rem !important;
  }

  .pb-md-8,
  .py-md-8 {
    padding-bottom: 8rem !important;
  }

  .pl-md-8,
  .px-md-8 {
    padding-left: 8rem !important;
  }

  .p-md-9 {
    padding: 10rem !important;
  }

  .pt-md-9,
  .py-md-9 {
    padding-top: 10rem !important;
  }

  .pr-md-9,
  .px-md-9 {
    padding-right: 10rem !important;
  }

  .pb-md-9,
  .py-md-9 {
    padding-bottom: 10rem !important;
  }

  .pl-md-9,
  .px-md-9 {
    padding-left: 10rem !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -1rem !important;
  }

  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }

  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }

  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }

  .m-md-n4 {
    margin: -1.5rem !important;
  }

  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }

  .m-md-n5 {
    margin: -3rem !important;
  }

  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }

  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }

  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }

  .m-md-n-9 {
    margin: 10rem !important;
  }

  .mt-md-n-9,
  .my-md-n-9 {
    margin-top: 10rem !important;
  }

  .mr-md-n-9,
  .mx-md-n-9 {
    margin-right: 10rem !important;
  }

  .mb-md-n-9,
  .my-md-n-9 {
    margin-bottom: 10rem !important;
  }

  .ml-md-n-9,
  .mx-md-n-9 {
    margin-left: 10rem !important;
  }

  .m-md-n-8 {
    margin: 8rem !important;
  }

  .mt-md-n-8,
  .my-md-n-8 {
    margin-top: 8rem !important;
  }

  .mr-md-n-8,
  .mx-md-n-8 {
    margin-right: 8rem !important;
  }

  .mb-md-n-8,
  .my-md-n-8 {
    margin-bottom: 8rem !important;
  }

  .ml-md-n-8,
  .mx-md-n-8 {
    margin-left: 8rem !important;
  }

  .m-md-n-7 {
    margin: 6rem !important;
  }

  .mt-md-n-7,
  .my-md-n-7 {
    margin-top: 6rem !important;
  }

  .mr-md-n-7,
  .mx-md-n-7 {
    margin-right: 6rem !important;
  }

  .mb-md-n-7,
  .my-md-n-7 {
    margin-bottom: 6rem !important;
  }

  .ml-md-n-7,
  .mx-md-n-7 {
    margin-left: 6rem !important;
  }

  .m-md-n-6 {
    margin: 4.5rem !important;
  }

  .mt-md-n-6,
  .my-md-n-6 {
    margin-top: 4.5rem !important;
  }

  .mr-md-n-6,
  .mx-md-n-6 {
    margin-right: 4.5rem !important;
  }

  .mb-md-n-6,
  .my-md-n-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-md-n-6,
  .mx-md-n-6 {
    margin-left: 4.5rem !important;
  }

  .m-md-n-5 {
    margin: 3rem !important;
  }

  .mt-md-n-5,
  .my-md-n-5 {
    margin-top: 3rem !important;
  }

  .mr-md-n-5,
  .mx-md-n-5 {
    margin-right: 3rem !important;
  }

  .mb-md-n-5,
  .my-md-n-5 {
    margin-bottom: 3rem !important;
  }

  .ml-md-n-5,
  .mx-md-n-5 {
    margin-left: 3rem !important;
  }

  .m-md-n-4 {
    margin: 1.5rem !important;
  }

  .mt-md-n-4,
  .my-md-n-4 {
    margin-top: 1.5rem !important;
  }

  .mr-md-n-4,
  .mx-md-n-4 {
    margin-right: 1.5rem !important;
  }

  .mb-md-n-4,
  .my-md-n-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-md-n-4,
  .mx-md-n-4 {
    margin-left: 1.5rem !important;
  }

  .m-md-n-3 {
    margin: 1rem !important;
  }

  .mt-md-n-3,
  .my-md-n-3 {
    margin-top: 1rem !important;
  }

  .mr-md-n-3,
  .mx-md-n-3 {
    margin-right: 1rem !important;
  }

  .mb-md-n-3,
  .my-md-n-3 {
    margin-bottom: 1rem !important;
  }

  .ml-md-n-3,
  .mx-md-n-3 {
    margin-left: 1rem !important;
  }

  .m-md-n-2 {
    margin: 0.5rem !important;
  }

  .mt-md-n-2,
  .my-md-n-2 {
    margin-top: 0.5rem !important;
  }

  .mr-md-n-2,
  .mx-md-n-2 {
    margin-right: 0.5rem !important;
  }

  .mb-md-n-2,
  .my-md-n-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-md-n-2,
  .mx-md-n-2 {
    margin-left: 0.5rem !important;
  }

  .m-md-n-1 {
    margin: 0.25rem !important;
  }

  .mt-md-n-1,
  .my-md-n-1 {
    margin-top: 0.25rem !important;
  }

  .mr-md-n-1,
  .mx-md-n-1 {
    margin-right: 0.25rem !important;
  }

  .mb-md-n-1,
  .my-md-n-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-md-n-1,
  .mx-md-n-1 {
    margin-left: 0.25rem !important;
  }

  .m-md-n6 {
    margin: -4.5rem !important;
  }

  .mt-md-n6,
  .my-md-n6 {
    margin-top: -4.5rem !important;
  }

  .mr-md-n6,
  .mx-md-n6 {
    margin-right: -4.5rem !important;
  }

  .mb-md-n6,
  .my-md-n6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-md-n6,
  .mx-md-n6 {
    margin-left: -4.5rem !important;
  }

  .m-md-n7 {
    margin: -6rem !important;
  }

  .mt-md-n7,
  .my-md-n7 {
    margin-top: -6rem !important;
  }

  .mr-md-n7,
  .mx-md-n7 {
    margin-right: -6rem !important;
  }

  .mb-md-n7,
  .my-md-n7 {
    margin-bottom: -6rem !important;
  }

  .ml-md-n7,
  .mx-md-n7 {
    margin-left: -6rem !important;
  }

  .m-md-n8 {
    margin: -8rem !important;
  }

  .mt-md-n8,
  .my-md-n8 {
    margin-top: -8rem !important;
  }

  .mr-md-n8,
  .mx-md-n8 {
    margin-right: -8rem !important;
  }

  .mb-md-n8,
  .my-md-n8 {
    margin-bottom: -8rem !important;
  }

  .ml-md-n8,
  .mx-md-n8 {
    margin-left: -8rem !important;
  }

  .m-md-n9 {
    margin: -10rem !important;
  }

  .mt-md-n9,
  .my-md-n9 {
    margin-top: -10rem !important;
  }

  .mr-md-n9,
  .mx-md-n9 {
    margin-right: -10rem !important;
  }

  .mb-md-n9,
  .my-md-n9 {
    margin-bottom: -10rem !important;
  }

  .ml-md-n9,
  .mx-md-n9 {
    margin-left: -10rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }

  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }

  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }

  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }

  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }

  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }

  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }

  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }

  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }

  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }

  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }

  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }

  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }

  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }

  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }

  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }

  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }

  .m-lg--9 {
    margin: -10rem !important;
  }

  .mt-lg--9,
  .my-lg--9 {
    margin-top: -10rem !important;
  }

  .mr-lg--9,
  .mx-lg--9 {
    margin-right: -10rem !important;
  }

  .mb-lg--9,
  .my-lg--9 {
    margin-bottom: -10rem !important;
  }

  .ml-lg--9,
  .mx-lg--9 {
    margin-left: -10rem !important;
  }

  .m-lg--8 {
    margin: -8rem !important;
  }

  .mt-lg--8,
  .my-lg--8 {
    margin-top: -8rem !important;
  }

  .mr-lg--8,
  .mx-lg--8 {
    margin-right: -8rem !important;
  }

  .mb-lg--8,
  .my-lg--8 {
    margin-bottom: -8rem !important;
  }

  .ml-lg--8,
  .mx-lg--8 {
    margin-left: -8rem !important;
  }

  .m-lg--7 {
    margin: -6rem !important;
  }

  .mt-lg--7,
  .my-lg--7 {
    margin-top: -6rem !important;
  }

  .mr-lg--7,
  .mx-lg--7 {
    margin-right: -6rem !important;
  }

  .mb-lg--7,
  .my-lg--7 {
    margin-bottom: -6rem !important;
  }

  .ml-lg--7,
  .mx-lg--7 {
    margin-left: -6rem !important;
  }

  .m-lg--6 {
    margin: -4.5rem !important;
  }

  .mt-lg--6,
  .my-lg--6 {
    margin-top: -4.5rem !important;
  }

  .mr-lg--6,
  .mx-lg--6 {
    margin-right: -4.5rem !important;
  }

  .mb-lg--6,
  .my-lg--6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-lg--6,
  .mx-lg--6 {
    margin-left: -4.5rem !important;
  }

  .m-lg--5 {
    margin: -3rem !important;
  }

  .mt-lg--5,
  .my-lg--5 {
    margin-top: -3rem !important;
  }

  .mr-lg--5,
  .mx-lg--5 {
    margin-right: -3rem !important;
  }

  .mb-lg--5,
  .my-lg--5 {
    margin-bottom: -3rem !important;
  }

  .ml-lg--5,
  .mx-lg--5 {
    margin-left: -3rem !important;
  }

  .m-lg--4 {
    margin: -1.5rem !important;
  }

  .mt-lg--4,
  .my-lg--4 {
    margin-top: -1.5rem !important;
  }

  .mr-lg--4,
  .mx-lg--4 {
    margin-right: -1.5rem !important;
  }

  .mb-lg--4,
  .my-lg--4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-lg--4,
  .mx-lg--4 {
    margin-left: -1.5rem !important;
  }

  .m-lg--3 {
    margin: -1rem !important;
  }

  .mt-lg--3,
  .my-lg--3 {
    margin-top: -1rem !important;
  }

  .mr-lg--3,
  .mx-lg--3 {
    margin-right: -1rem !important;
  }

  .mb-lg--3,
  .my-lg--3 {
    margin-bottom: -1rem !important;
  }

  .ml-lg--3,
  .mx-lg--3 {
    margin-left: -1rem !important;
  }

  .m-lg--2 {
    margin: -0.5rem !important;
  }

  .mt-lg--2,
  .my-lg--2 {
    margin-top: -0.5rem !important;
  }

  .mr-lg--2,
  .mx-lg--2 {
    margin-right: -0.5rem !important;
  }

  .mb-lg--2,
  .my-lg--2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-lg--2,
  .mx-lg--2 {
    margin-left: -0.5rem !important;
  }

  .m-lg--1 {
    margin: -0.25rem !important;
  }

  .mt-lg--1,
  .my-lg--1 {
    margin-top: -0.25rem !important;
  }

  .mr-lg--1,
  .mx-lg--1 {
    margin-right: -0.25rem !important;
  }

  .mb-lg--1,
  .my-lg--1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-lg--1,
  .mx-lg--1 {
    margin-left: -0.25rem !important;
  }

  .m-lg-6 {
    margin: 4.5rem !important;
  }

  .mt-lg-6,
  .my-lg-6 {
    margin-top: 4.5rem !important;
  }

  .mr-lg-6,
  .mx-lg-6 {
    margin-right: 4.5rem !important;
  }

  .mb-lg-6,
  .my-lg-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-lg-6,
  .mx-lg-6 {
    margin-left: 4.5rem !important;
  }

  .m-lg-7 {
    margin: 6rem !important;
  }

  .mt-lg-7,
  .my-lg-7 {
    margin-top: 6rem !important;
  }

  .mr-lg-7,
  .mx-lg-7 {
    margin-right: 6rem !important;
  }

  .mb-lg-7,
  .my-lg-7 {
    margin-bottom: 6rem !important;
  }

  .ml-lg-7,
  .mx-lg-7 {
    margin-left: 6rem !important;
  }

  .m-lg-8 {
    margin: 8rem !important;
  }

  .mt-lg-8,
  .my-lg-8 {
    margin-top: 8rem !important;
  }

  .mr-lg-8,
  .mx-lg-8 {
    margin-right: 8rem !important;
  }

  .mb-lg-8,
  .my-lg-8 {
    margin-bottom: 8rem !important;
  }

  .ml-lg-8,
  .mx-lg-8 {
    margin-left: 8rem !important;
  }

  .m-lg-9 {
    margin: 10rem !important;
  }

  .mt-lg-9,
  .my-lg-9 {
    margin-top: 10rem !important;
  }

  .mr-lg-9,
  .mx-lg-9 {
    margin-right: 10rem !important;
  }

  .mb-lg-9,
  .my-lg-9 {
    margin-bottom: 10rem !important;
  }

  .ml-lg-9,
  .mx-lg-9 {
    margin-left: 10rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }

  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }

  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }

  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }

  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }

  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }

  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }

  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }

  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }

  .p-lg--9 {
    padding: -10rem !important;
  }

  .pt-lg--9,
  .py-lg--9 {
    padding-top: -10rem !important;
  }

  .pr-lg--9,
  .px-lg--9 {
    padding-right: -10rem !important;
  }

  .pb-lg--9,
  .py-lg--9 {
    padding-bottom: -10rem !important;
  }

  .pl-lg--9,
  .px-lg--9 {
    padding-left: -10rem !important;
  }

  .p-lg--8 {
    padding: -8rem !important;
  }

  .pt-lg--8,
  .py-lg--8 {
    padding-top: -8rem !important;
  }

  .pr-lg--8,
  .px-lg--8 {
    padding-right: -8rem !important;
  }

  .pb-lg--8,
  .py-lg--8 {
    padding-bottom: -8rem !important;
  }

  .pl-lg--8,
  .px-lg--8 {
    padding-left: -8rem !important;
  }

  .p-lg--7 {
    padding: -6rem !important;
  }

  .pt-lg--7,
  .py-lg--7 {
    padding-top: -6rem !important;
  }

  .pr-lg--7,
  .px-lg--7 {
    padding-right: -6rem !important;
  }

  .pb-lg--7,
  .py-lg--7 {
    padding-bottom: -6rem !important;
  }

  .pl-lg--7,
  .px-lg--7 {
    padding-left: -6rem !important;
  }

  .p-lg--6 {
    padding: -4.5rem !important;
  }

  .pt-lg--6,
  .py-lg--6 {
    padding-top: -4.5rem !important;
  }

  .pr-lg--6,
  .px-lg--6 {
    padding-right: -4.5rem !important;
  }

  .pb-lg--6,
  .py-lg--6 {
    padding-bottom: -4.5rem !important;
  }

  .pl-lg--6,
  .px-lg--6 {
    padding-left: -4.5rem !important;
  }

  .p-lg--5 {
    padding: -3rem !important;
  }

  .pt-lg--5,
  .py-lg--5 {
    padding-top: -3rem !important;
  }

  .pr-lg--5,
  .px-lg--5 {
    padding-right: -3rem !important;
  }

  .pb-lg--5,
  .py-lg--5 {
    padding-bottom: -3rem !important;
  }

  .pl-lg--5,
  .px-lg--5 {
    padding-left: -3rem !important;
  }

  .p-lg--4 {
    padding: -1.5rem !important;
  }

  .pt-lg--4,
  .py-lg--4 {
    padding-top: -1.5rem !important;
  }

  .pr-lg--4,
  .px-lg--4 {
    padding-right: -1.5rem !important;
  }

  .pb-lg--4,
  .py-lg--4 {
    padding-bottom: -1.5rem !important;
  }

  .pl-lg--4,
  .px-lg--4 {
    padding-left: -1.5rem !important;
  }

  .p-lg--3 {
    padding: -1rem !important;
  }

  .pt-lg--3,
  .py-lg--3 {
    padding-top: -1rem !important;
  }

  .pr-lg--3,
  .px-lg--3 {
    padding-right: -1rem !important;
  }

  .pb-lg--3,
  .py-lg--3 {
    padding-bottom: -1rem !important;
  }

  .pl-lg--3,
  .px-lg--3 {
    padding-left: -1rem !important;
  }

  .p-lg--2 {
    padding: -0.5rem !important;
  }

  .pt-lg--2,
  .py-lg--2 {
    padding-top: -0.5rem !important;
  }

  .pr-lg--2,
  .px-lg--2 {
    padding-right: -0.5rem !important;
  }

  .pb-lg--2,
  .py-lg--2 {
    padding-bottom: -0.5rem !important;
  }

  .pl-lg--2,
  .px-lg--2 {
    padding-left: -0.5rem !important;
  }

  .p-lg--1 {
    padding: -0.25rem !important;
  }

  .pt-lg--1,
  .py-lg--1 {
    padding-top: -0.25rem !important;
  }

  .pr-lg--1,
  .px-lg--1 {
    padding-right: -0.25rem !important;
  }

  .pb-lg--1,
  .py-lg--1 {
    padding-bottom: -0.25rem !important;
  }

  .pl-lg--1,
  .px-lg--1 {
    padding-left: -0.25rem !important;
  }

  .p-lg-6 {
    padding: 4.5rem !important;
  }

  .pt-lg-6,
  .py-lg-6 {
    padding-top: 4.5rem !important;
  }

  .pr-lg-6,
  .px-lg-6 {
    padding-right: 4.5rem !important;
  }

  .pb-lg-6,
  .py-lg-6 {
    padding-bottom: 4.5rem !important;
  }

  .pl-lg-6,
  .px-lg-6 {
    padding-left: 4.5rem !important;
  }

  .p-lg-7 {
    padding: 6rem !important;
  }

  .pt-lg-7,
  .py-lg-7 {
    padding-top: 6rem !important;
  }

  .pr-lg-7,
  .px-lg-7 {
    padding-right: 6rem !important;
  }

  .pb-lg-7,
  .py-lg-7 {
    padding-bottom: 6rem !important;
  }

  .pl-lg-7,
  .px-lg-7 {
    padding-left: 6rem !important;
  }

  .p-lg-8 {
    padding: 8rem !important;
  }

  .pt-lg-8,
  .py-lg-8 {
    padding-top: 8rem !important;
  }

  .pr-lg-8,
  .px-lg-8 {
    padding-right: 8rem !important;
  }

  .pb-lg-8,
  .py-lg-8 {
    padding-bottom: 8rem !important;
  }

  .pl-lg-8,
  .px-lg-8 {
    padding-left: 8rem !important;
  }

  .p-lg-9 {
    padding: 10rem !important;
  }

  .pt-lg-9,
  .py-lg-9 {
    padding-top: 10rem !important;
  }

  .pr-lg-9,
  .px-lg-9 {
    padding-right: 10rem !important;
  }

  .pb-lg-9,
  .py-lg-9 {
    padding-bottom: 10rem !important;
  }

  .pl-lg-9,
  .px-lg-9 {
    padding-left: 10rem !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -1rem !important;
  }

  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }

  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }

  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }

  .m-lg-n4 {
    margin: -1.5rem !important;
  }

  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }

  .m-lg-n5 {
    margin: -3rem !important;
  }

  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }

  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }

  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }

  .m-lg-n-9 {
    margin: 10rem !important;
  }

  .mt-lg-n-9,
  .my-lg-n-9 {
    margin-top: 10rem !important;
  }

  .mr-lg-n-9,
  .mx-lg-n-9 {
    margin-right: 10rem !important;
  }

  .mb-lg-n-9,
  .my-lg-n-9 {
    margin-bottom: 10rem !important;
  }

  .ml-lg-n-9,
  .mx-lg-n-9 {
    margin-left: 10rem !important;
  }

  .m-lg-n-8 {
    margin: 8rem !important;
  }

  .mt-lg-n-8,
  .my-lg-n-8 {
    margin-top: 8rem !important;
  }

  .mr-lg-n-8,
  .mx-lg-n-8 {
    margin-right: 8rem !important;
  }

  .mb-lg-n-8,
  .my-lg-n-8 {
    margin-bottom: 8rem !important;
  }

  .ml-lg-n-8,
  .mx-lg-n-8 {
    margin-left: 8rem !important;
  }

  .m-lg-n-7 {
    margin: 6rem !important;
  }

  .mt-lg-n-7,
  .my-lg-n-7 {
    margin-top: 6rem !important;
  }

  .mr-lg-n-7,
  .mx-lg-n-7 {
    margin-right: 6rem !important;
  }

  .mb-lg-n-7,
  .my-lg-n-7 {
    margin-bottom: 6rem !important;
  }

  .ml-lg-n-7,
  .mx-lg-n-7 {
    margin-left: 6rem !important;
  }

  .m-lg-n-6 {
    margin: 4.5rem !important;
  }

  .mt-lg-n-6,
  .my-lg-n-6 {
    margin-top: 4.5rem !important;
  }

  .mr-lg-n-6,
  .mx-lg-n-6 {
    margin-right: 4.5rem !important;
  }

  .mb-lg-n-6,
  .my-lg-n-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-lg-n-6,
  .mx-lg-n-6 {
    margin-left: 4.5rem !important;
  }

  .m-lg-n-5 {
    margin: 3rem !important;
  }

  .mt-lg-n-5,
  .my-lg-n-5 {
    margin-top: 3rem !important;
  }

  .mr-lg-n-5,
  .mx-lg-n-5 {
    margin-right: 3rem !important;
  }

  .mb-lg-n-5,
  .my-lg-n-5 {
    margin-bottom: 3rem !important;
  }

  .ml-lg-n-5,
  .mx-lg-n-5 {
    margin-left: 3rem !important;
  }

  .m-lg-n-4 {
    margin: 1.5rem !important;
  }

  .mt-lg-n-4,
  .my-lg-n-4 {
    margin-top: 1.5rem !important;
  }

  .mr-lg-n-4,
  .mx-lg-n-4 {
    margin-right: 1.5rem !important;
  }

  .mb-lg-n-4,
  .my-lg-n-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-lg-n-4,
  .mx-lg-n-4 {
    margin-left: 1.5rem !important;
  }

  .m-lg-n-3 {
    margin: 1rem !important;
  }

  .mt-lg-n-3,
  .my-lg-n-3 {
    margin-top: 1rem !important;
  }

  .mr-lg-n-3,
  .mx-lg-n-3 {
    margin-right: 1rem !important;
  }

  .mb-lg-n-3,
  .my-lg-n-3 {
    margin-bottom: 1rem !important;
  }

  .ml-lg-n-3,
  .mx-lg-n-3 {
    margin-left: 1rem !important;
  }

  .m-lg-n-2 {
    margin: 0.5rem !important;
  }

  .mt-lg-n-2,
  .my-lg-n-2 {
    margin-top: 0.5rem !important;
  }

  .mr-lg-n-2,
  .mx-lg-n-2 {
    margin-right: 0.5rem !important;
  }

  .mb-lg-n-2,
  .my-lg-n-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-lg-n-2,
  .mx-lg-n-2 {
    margin-left: 0.5rem !important;
  }

  .m-lg-n-1 {
    margin: 0.25rem !important;
  }

  .mt-lg-n-1,
  .my-lg-n-1 {
    margin-top: 0.25rem !important;
  }

  .mr-lg-n-1,
  .mx-lg-n-1 {
    margin-right: 0.25rem !important;
  }

  .mb-lg-n-1,
  .my-lg-n-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-lg-n-1,
  .mx-lg-n-1 {
    margin-left: 0.25rem !important;
  }

  .m-lg-n6 {
    margin: -4.5rem !important;
  }

  .mt-lg-n6,
  .my-lg-n6 {
    margin-top: -4.5rem !important;
  }

  .mr-lg-n6,
  .mx-lg-n6 {
    margin-right: -4.5rem !important;
  }

  .mb-lg-n6,
  .my-lg-n6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-lg-n6,
  .mx-lg-n6 {
    margin-left: -4.5rem !important;
  }

  .m-lg-n7 {
    margin: -6rem !important;
  }

  .mt-lg-n7,
  .my-lg-n7 {
    margin-top: -6rem !important;
  }

  .mr-lg-n7,
  .mx-lg-n7 {
    margin-right: -6rem !important;
  }

  .mb-lg-n7,
  .my-lg-n7 {
    margin-bottom: -6rem !important;
  }

  .ml-lg-n7,
  .mx-lg-n7 {
    margin-left: -6rem !important;
  }

  .m-lg-n8 {
    margin: -8rem !important;
  }

  .mt-lg-n8,
  .my-lg-n8 {
    margin-top: -8rem !important;
  }

  .mr-lg-n8,
  .mx-lg-n8 {
    margin-right: -8rem !important;
  }

  .mb-lg-n8,
  .my-lg-n8 {
    margin-bottom: -8rem !important;
  }

  .ml-lg-n8,
  .mx-lg-n8 {
    margin-left: -8rem !important;
  }

  .m-lg-n9 {
    margin: -10rem !important;
  }

  .mt-lg-n9,
  .my-lg-n9 {
    margin-top: -10rem !important;
  }

  .mr-lg-n9,
  .mx-lg-n9 {
    margin-right: -10rem !important;
  }

  .mb-lg-n9,
  .my-lg-n9 {
    margin-bottom: -10rem !important;
  }

  .ml-lg-n9,
  .mx-lg-n9 {
    margin-left: -10rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }

  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }

  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }

  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }

  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }

  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }

  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }

  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }

  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }

  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }

  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }

  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }

  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }

  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }

  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }

  .m-xl--9 {
    margin: -10rem !important;
  }

  .mt-xl--9,
  .my-xl--9 {
    margin-top: -10rem !important;
  }

  .mr-xl--9,
  .mx-xl--9 {
    margin-right: -10rem !important;
  }

  .mb-xl--9,
  .my-xl--9 {
    margin-bottom: -10rem !important;
  }

  .ml-xl--9,
  .mx-xl--9 {
    margin-left: -10rem !important;
  }

  .m-xl--8 {
    margin: -8rem !important;
  }

  .mt-xl--8,
  .my-xl--8 {
    margin-top: -8rem !important;
  }

  .mr-xl--8,
  .mx-xl--8 {
    margin-right: -8rem !important;
  }

  .mb-xl--8,
  .my-xl--8 {
    margin-bottom: -8rem !important;
  }

  .ml-xl--8,
  .mx-xl--8 {
    margin-left: -8rem !important;
  }

  .m-xl--7 {
    margin: -6rem !important;
  }

  .mt-xl--7,
  .my-xl--7 {
    margin-top: -6rem !important;
  }

  .mr-xl--7,
  .mx-xl--7 {
    margin-right: -6rem !important;
  }

  .mb-xl--7,
  .my-xl--7 {
    margin-bottom: -6rem !important;
  }

  .ml-xl--7,
  .mx-xl--7 {
    margin-left: -6rem !important;
  }

  .m-xl--6 {
    margin: -4.5rem !important;
  }

  .mt-xl--6,
  .my-xl--6 {
    margin-top: -4.5rem !important;
  }

  .mr-xl--6,
  .mx-xl--6 {
    margin-right: -4.5rem !important;
  }

  .mb-xl--6,
  .my-xl--6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-xl--6,
  .mx-xl--6 {
    margin-left: -4.5rem !important;
  }

  .m-xl--5 {
    margin: -3rem !important;
  }

  .mt-xl--5,
  .my-xl--5 {
    margin-top: -3rem !important;
  }

  .mr-xl--5,
  .mx-xl--5 {
    margin-right: -3rem !important;
  }

  .mb-xl--5,
  .my-xl--5 {
    margin-bottom: -3rem !important;
  }

  .ml-xl--5,
  .mx-xl--5 {
    margin-left: -3rem !important;
  }

  .m-xl--4 {
    margin: -1.5rem !important;
  }

  .mt-xl--4,
  .my-xl--4 {
    margin-top: -1.5rem !important;
  }

  .mr-xl--4,
  .mx-xl--4 {
    margin-right: -1.5rem !important;
  }

  .mb-xl--4,
  .my-xl--4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-xl--4,
  .mx-xl--4 {
    margin-left: -1.5rem !important;
  }

  .m-xl--3 {
    margin: -1rem !important;
  }

  .mt-xl--3,
  .my-xl--3 {
    margin-top: -1rem !important;
  }

  .mr-xl--3,
  .mx-xl--3 {
    margin-right: -1rem !important;
  }

  .mb-xl--3,
  .my-xl--3 {
    margin-bottom: -1rem !important;
  }

  .ml-xl--3,
  .mx-xl--3 {
    margin-left: -1rem !important;
  }

  .m-xl--2 {
    margin: -0.5rem !important;
  }

  .mt-xl--2,
  .my-xl--2 {
    margin-top: -0.5rem !important;
  }

  .mr-xl--2,
  .mx-xl--2 {
    margin-right: -0.5rem !important;
  }

  .mb-xl--2,
  .my-xl--2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-xl--2,
  .mx-xl--2 {
    margin-left: -0.5rem !important;
  }

  .m-xl--1 {
    margin: -0.25rem !important;
  }

  .mt-xl--1,
  .my-xl--1 {
    margin-top: -0.25rem !important;
  }

  .mr-xl--1,
  .mx-xl--1 {
    margin-right: -0.25rem !important;
  }

  .mb-xl--1,
  .my-xl--1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-xl--1,
  .mx-xl--1 {
    margin-left: -0.25rem !important;
  }

  .m-xl-6 {
    margin: 4.5rem !important;
  }

  .mt-xl-6,
  .my-xl-6 {
    margin-top: 4.5rem !important;
  }

  .mr-xl-6,
  .mx-xl-6 {
    margin-right: 4.5rem !important;
  }

  .mb-xl-6,
  .my-xl-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-xl-6,
  .mx-xl-6 {
    margin-left: 4.5rem !important;
  }

  .m-xl-7 {
    margin: 6rem !important;
  }

  .mt-xl-7,
  .my-xl-7 {
    margin-top: 6rem !important;
  }

  .mr-xl-7,
  .mx-xl-7 {
    margin-right: 6rem !important;
  }

  .mb-xl-7,
  .my-xl-7 {
    margin-bottom: 6rem !important;
  }

  .ml-xl-7,
  .mx-xl-7 {
    margin-left: 6rem !important;
  }

  .m-xl-8 {
    margin: 8rem !important;
  }

  .mt-xl-8,
  .my-xl-8 {
    margin-top: 8rem !important;
  }

  .mr-xl-8,
  .mx-xl-8 {
    margin-right: 8rem !important;
  }

  .mb-xl-8,
  .my-xl-8 {
    margin-bottom: 8rem !important;
  }

  .ml-xl-8,
  .mx-xl-8 {
    margin-left: 8rem !important;
  }

  .m-xl-9 {
    margin: 10rem !important;
  }

  .mt-xl-9,
  .my-xl-9 {
    margin-top: 10rem !important;
  }

  .mr-xl-9,
  .mx-xl-9 {
    margin-right: 10rem !important;
  }

  .mb-xl-9,
  .my-xl-9 {
    margin-bottom: 10rem !important;
  }

  .ml-xl-9,
  .mx-xl-9 {
    margin-left: 10rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }

  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }

  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }

  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }

  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }

  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }

  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }

  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }

  .p-xl--9 {
    padding: -10rem !important;
  }

  .pt-xl--9,
  .py-xl--9 {
    padding-top: -10rem !important;
  }

  .pr-xl--9,
  .px-xl--9 {
    padding-right: -10rem !important;
  }

  .pb-xl--9,
  .py-xl--9 {
    padding-bottom: -10rem !important;
  }

  .pl-xl--9,
  .px-xl--9 {
    padding-left: -10rem !important;
  }

  .p-xl--8 {
    padding: -8rem !important;
  }

  .pt-xl--8,
  .py-xl--8 {
    padding-top: -8rem !important;
  }

  .pr-xl--8,
  .px-xl--8 {
    padding-right: -8rem !important;
  }

  .pb-xl--8,
  .py-xl--8 {
    padding-bottom: -8rem !important;
  }

  .pl-xl--8,
  .px-xl--8 {
    padding-left: -8rem !important;
  }

  .p-xl--7 {
    padding: -6rem !important;
  }

  .pt-xl--7,
  .py-xl--7 {
    padding-top: -6rem !important;
  }

  .pr-xl--7,
  .px-xl--7 {
    padding-right: -6rem !important;
  }

  .pb-xl--7,
  .py-xl--7 {
    padding-bottom: -6rem !important;
  }

  .pl-xl--7,
  .px-xl--7 {
    padding-left: -6rem !important;
  }

  .p-xl--6 {
    padding: -4.5rem !important;
  }

  .pt-xl--6,
  .py-xl--6 {
    padding-top: -4.5rem !important;
  }

  .pr-xl--6,
  .px-xl--6 {
    padding-right: -4.5rem !important;
  }

  .pb-xl--6,
  .py-xl--6 {
    padding-bottom: -4.5rem !important;
  }

  .pl-xl--6,
  .px-xl--6 {
    padding-left: -4.5rem !important;
  }

  .p-xl--5 {
    padding: -3rem !important;
  }

  .pt-xl--5,
  .py-xl--5 {
    padding-top: -3rem !important;
  }

  .pr-xl--5,
  .px-xl--5 {
    padding-right: -3rem !important;
  }

  .pb-xl--5,
  .py-xl--5 {
    padding-bottom: -3rem !important;
  }

  .pl-xl--5,
  .px-xl--5 {
    padding-left: -3rem !important;
  }

  .p-xl--4 {
    padding: -1.5rem !important;
  }

  .pt-xl--4,
  .py-xl--4 {
    padding-top: -1.5rem !important;
  }

  .pr-xl--4,
  .px-xl--4 {
    padding-right: -1.5rem !important;
  }

  .pb-xl--4,
  .py-xl--4 {
    padding-bottom: -1.5rem !important;
  }

  .pl-xl--4,
  .px-xl--4 {
    padding-left: -1.5rem !important;
  }

  .p-xl--3 {
    padding: -1rem !important;
  }

  .pt-xl--3,
  .py-xl--3 {
    padding-top: -1rem !important;
  }

  .pr-xl--3,
  .px-xl--3 {
    padding-right: -1rem !important;
  }

  .pb-xl--3,
  .py-xl--3 {
    padding-bottom: -1rem !important;
  }

  .pl-xl--3,
  .px-xl--3 {
    padding-left: -1rem !important;
  }

  .p-xl--2 {
    padding: -0.5rem !important;
  }

  .pt-xl--2,
  .py-xl--2 {
    padding-top: -0.5rem !important;
  }

  .pr-xl--2,
  .px-xl--2 {
    padding-right: -0.5rem !important;
  }

  .pb-xl--2,
  .py-xl--2 {
    padding-bottom: -0.5rem !important;
  }

  .pl-xl--2,
  .px-xl--2 {
    padding-left: -0.5rem !important;
  }

  .p-xl--1 {
    padding: -0.25rem !important;
  }

  .pt-xl--1,
  .py-xl--1 {
    padding-top: -0.25rem !important;
  }

  .pr-xl--1,
  .px-xl--1 {
    padding-right: -0.25rem !important;
  }

  .pb-xl--1,
  .py-xl--1 {
    padding-bottom: -0.25rem !important;
  }

  .pl-xl--1,
  .px-xl--1 {
    padding-left: -0.25rem !important;
  }

  .p-xl-6 {
    padding: 4.5rem !important;
  }

  .pt-xl-6,
  .py-xl-6 {
    padding-top: 4.5rem !important;
  }

  .pr-xl-6,
  .px-xl-6 {
    padding-right: 4.5rem !important;
  }

  .pb-xl-6,
  .py-xl-6 {
    padding-bottom: 4.5rem !important;
  }

  .pl-xl-6,
  .px-xl-6 {
    padding-left: 4.5rem !important;
  }

  .p-xl-7 {
    padding: 6rem !important;
  }

  .pt-xl-7,
  .py-xl-7 {
    padding-top: 6rem !important;
  }

  .pr-xl-7,
  .px-xl-7 {
    padding-right: 6rem !important;
  }

  .pb-xl-7,
  .py-xl-7 {
    padding-bottom: 6rem !important;
  }

  .pl-xl-7,
  .px-xl-7 {
    padding-left: 6rem !important;
  }

  .p-xl-8 {
    padding: 8rem !important;
  }

  .pt-xl-8,
  .py-xl-8 {
    padding-top: 8rem !important;
  }

  .pr-xl-8,
  .px-xl-8 {
    padding-right: 8rem !important;
  }

  .pb-xl-8,
  .py-xl-8 {
    padding-bottom: 8rem !important;
  }

  .pl-xl-8,
  .px-xl-8 {
    padding-left: 8rem !important;
  }

  .p-xl-9 {
    padding: 10rem !important;
  }

  .pt-xl-9,
  .py-xl-9 {
    padding-top: 10rem !important;
  }

  .pr-xl-9,
  .px-xl-9 {
    padding-right: 10rem !important;
  }

  .pb-xl-9,
  .py-xl-9 {
    padding-bottom: 10rem !important;
  }

  .pl-xl-9,
  .px-xl-9 {
    padding-left: 10rem !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -1rem !important;
  }

  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }

  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }

  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }

  .m-xl-n4 {
    margin: -1.5rem !important;
  }

  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }

  .m-xl-n5 {
    margin: -3rem !important;
  }

  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }

  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }

  .m-xl-n-9 {
    margin: 10rem !important;
  }

  .mt-xl-n-9,
  .my-xl-n-9 {
    margin-top: 10rem !important;
  }

  .mr-xl-n-9,
  .mx-xl-n-9 {
    margin-right: 10rem !important;
  }

  .mb-xl-n-9,
  .my-xl-n-9 {
    margin-bottom: 10rem !important;
  }

  .ml-xl-n-9,
  .mx-xl-n-9 {
    margin-left: 10rem !important;
  }

  .m-xl-n-8 {
    margin: 8rem !important;
  }

  .mt-xl-n-8,
  .my-xl-n-8 {
    margin-top: 8rem !important;
  }

  .mr-xl-n-8,
  .mx-xl-n-8 {
    margin-right: 8rem !important;
  }

  .mb-xl-n-8,
  .my-xl-n-8 {
    margin-bottom: 8rem !important;
  }

  .ml-xl-n-8,
  .mx-xl-n-8 {
    margin-left: 8rem !important;
  }

  .m-xl-n-7 {
    margin: 6rem !important;
  }

  .mt-xl-n-7,
  .my-xl-n-7 {
    margin-top: 6rem !important;
  }

  .mr-xl-n-7,
  .mx-xl-n-7 {
    margin-right: 6rem !important;
  }

  .mb-xl-n-7,
  .my-xl-n-7 {
    margin-bottom: 6rem !important;
  }

  .ml-xl-n-7,
  .mx-xl-n-7 {
    margin-left: 6rem !important;
  }

  .m-xl-n-6 {
    margin: 4.5rem !important;
  }

  .mt-xl-n-6,
  .my-xl-n-6 {
    margin-top: 4.5rem !important;
  }

  .mr-xl-n-6,
  .mx-xl-n-6 {
    margin-right: 4.5rem !important;
  }

  .mb-xl-n-6,
  .my-xl-n-6 {
    margin-bottom: 4.5rem !important;
  }

  .ml-xl-n-6,
  .mx-xl-n-6 {
    margin-left: 4.5rem !important;
  }

  .m-xl-n-5 {
    margin: 3rem !important;
  }

  .mt-xl-n-5,
  .my-xl-n-5 {
    margin-top: 3rem !important;
  }

  .mr-xl-n-5,
  .mx-xl-n-5 {
    margin-right: 3rem !important;
  }

  .mb-xl-n-5,
  .my-xl-n-5 {
    margin-bottom: 3rem !important;
  }

  .ml-xl-n-5,
  .mx-xl-n-5 {
    margin-left: 3rem !important;
  }

  .m-xl-n-4 {
    margin: 1.5rem !important;
  }

  .mt-xl-n-4,
  .my-xl-n-4 {
    margin-top: 1.5rem !important;
  }

  .mr-xl-n-4,
  .mx-xl-n-4 {
    margin-right: 1.5rem !important;
  }

  .mb-xl-n-4,
  .my-xl-n-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-xl-n-4,
  .mx-xl-n-4 {
    margin-left: 1.5rem !important;
  }

  .m-xl-n-3 {
    margin: 1rem !important;
  }

  .mt-xl-n-3,
  .my-xl-n-3 {
    margin-top: 1rem !important;
  }

  .mr-xl-n-3,
  .mx-xl-n-3 {
    margin-right: 1rem !important;
  }

  .mb-xl-n-3,
  .my-xl-n-3 {
    margin-bottom: 1rem !important;
  }

  .ml-xl-n-3,
  .mx-xl-n-3 {
    margin-left: 1rem !important;
  }

  .m-xl-n-2 {
    margin: 0.5rem !important;
  }

  .mt-xl-n-2,
  .my-xl-n-2 {
    margin-top: 0.5rem !important;
  }

  .mr-xl-n-2,
  .mx-xl-n-2 {
    margin-right: 0.5rem !important;
  }

  .mb-xl-n-2,
  .my-xl-n-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-xl-n-2,
  .mx-xl-n-2 {
    margin-left: 0.5rem !important;
  }

  .m-xl-n-1 {
    margin: 0.25rem !important;
  }

  .mt-xl-n-1,
  .my-xl-n-1 {
    margin-top: 0.25rem !important;
  }

  .mr-xl-n-1,
  .mx-xl-n-1 {
    margin-right: 0.25rem !important;
  }

  .mb-xl-n-1,
  .my-xl-n-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-xl-n-1,
  .mx-xl-n-1 {
    margin-left: 0.25rem !important;
  }

  .m-xl-n6 {
    margin: -4.5rem !important;
  }

  .mt-xl-n6,
  .my-xl-n6 {
    margin-top: -4.5rem !important;
  }

  .mr-xl-n6,
  .mx-xl-n6 {
    margin-right: -4.5rem !important;
  }

  .mb-xl-n6,
  .my-xl-n6 {
    margin-bottom: -4.5rem !important;
  }

  .ml-xl-n6,
  .mx-xl-n6 {
    margin-left: -4.5rem !important;
  }

  .m-xl-n7 {
    margin: -6rem !important;
  }

  .mt-xl-n7,
  .my-xl-n7 {
    margin-top: -6rem !important;
  }

  .mr-xl-n7,
  .mx-xl-n7 {
    margin-right: -6rem !important;
  }

  .mb-xl-n7,
  .my-xl-n7 {
    margin-bottom: -6rem !important;
  }

  .ml-xl-n7,
  .mx-xl-n7 {
    margin-left: -6rem !important;
  }

  .m-xl-n8 {
    margin: -8rem !important;
  }

  .mt-xl-n8,
  .my-xl-n8 {
    margin-top: -8rem !important;
  }

  .mr-xl-n8,
  .mx-xl-n8 {
    margin-right: -8rem !important;
  }

  .mb-xl-n8,
  .my-xl-n8 {
    margin-bottom: -8rem !important;
  }

  .ml-xl-n8,
  .mx-xl-n8 {
    margin-left: -8rem !important;
  }

  .m-xl-n9 {
    margin: -10rem !important;
  }

  .mt-xl-n9,
  .my-xl-n9 {
    margin-top: -10rem !important;
  }

  .mr-xl-n9,
  .mx-xl-n9 {
    margin-right: -10rem !important;
  }

  .mb-xl-n9,
  .my-xl-n9 {
    margin-bottom: -10rem !important;
  }

  .ml-xl-n9,
  .mx-xl-n9 {
    margin-left: -10rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }

  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }

  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }

  .text-sm-right {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }

  .text-md-right {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }

  .text-lg-right {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }

  .text-xl-right {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #5e72e4 !important;
}

a.text-primary:hover,
a.text-primary:focus {
  color: #233dd2 !important;
}

.text-secondary {
  color: #f7fafc !important;
}

a.text-secondary:hover,
a.text-secondary:focus {
  color: #bfd7e7 !important;
}

.text-success {
  color: #2dce89 !important;
}

a.text-success:hover,
a.text-success:focus {
  color: #1f8f5f !important;
}

.text-info {
  color: #11cdef !important;
}

a.text-info:hover,
a.text-info:focus {
  color: #0b90a8 !important;
}

.text-warning {
  color: #fb6340 !important;
}

a.text-warning:hover,
a.text-warning:focus {
  color: #ea3005 !important;
}

.text-danger {
  color: #f5365c !important;
}

a.text-danger:hover,
a.text-danger:focus {
  color: #d40b33 !important;
}

.text-light {
  color: #adb5bd !important;
}

a.text-light:hover,
a.text-light:focus {
  color: #838f9b !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:hover,
a.text-dark:focus {
  color: black !important;
}

.text-default {
  color: #172b4d !important;
}

a.text-default:hover,
a.text-default:focus {
  color: #050a12 !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover,
a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-neutral {
  color: #fff !important;
}

a.text-neutral:hover,
a.text-neutral:focus {
  color: #d9d9d9 !important;
}

.text-darker {
  color: black !important;
}

a.text-darker:hover,
a.text-darker:focus {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #8898aa !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {

  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}

@media print {

  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }

  a:not(.btn) {
    text-decoration: underline;
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
  }

  pre {
    white-space: pre-wrap !important;
  }

  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }

  @page {
    size: a3;
  }

  body {
    min-width: 992px !important;
  }

  .container {
    min-width: 992px !important;
  }

  .navbar {
    display: none;
  }

  .badge {
    border: 1px solid #000;
  }

  .table {
    border-collapse: collapse !important;
  }

  .table td,
  .table th {
    background-color: #fff !important;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }

  .table-dark {
    color: inherit;
  }

  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody+tbody {
    border-color: #e9ecef;
  }

  .table .thead-dark th {
    color: inherit;
    border-color: #e9ecef;
  }
}

.alert {
  font-size: 0.875rem;
}

.alert-heading {
  font-weight: 600;
  font-size: 0.9375rem;
  margin-top: 0.15rem;
}

.alert-icon {
  font-size: 1.25rem;
  margin-right: 1.25rem;
  display: inline-block;
  vertical-align: middle;
}

.alert-icon i.ni {
  position: relative;
  top: 2px;
}

.alert-text {
  display: inline-block;
  vertical-align: middle;
}

[class*="alert-"] .alert-link {
  color: #fff;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);
}

.alert-dismissible .close {
  top: 50%;
  right: 1.5rem;
  transform: translateY(-50%);
  padding: 0;
  opacity: 1;
}

@media (max-width: 575.98px) {
  .alert-dismissible .close {
    top: 1rem;
    right: 0.5rem;
  }
}

.alert-dismissible .close>span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}

.alert-dismissible .close:hover>span:not(.sr-only),
.alert-dismissible .close:focus>span:not(.sr-only) {
  background-color: transparent;
  color: white;
}

.alert-secondary .close>span:not(.sr-only) {
  color: rgba(23, 43, 77, 0.6);
}

.alert-secondary .close:hover>span:not(.sr-only),
.alert-secondary .close:focus>span:not(.sr-only) {
  color: #172b4d;
}

.alert-notify {
  display: flex !important;
  max-width: 600px;
  width: calc(100% - 30px);
  padding-right: 80px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.85);
}

.alert-notify:hover {
  z-index: 1081 !important;
}

.alert-notify:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) {
  background-color: rgba(0, 0, 0, 0.95);
}

.alert-notify:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close {
  color: #ffd600;
}

.alert-notify:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close:hover {
  opacity: 0.8;
}

.alert-notify .alert-icon.ni {
  position: relative;
  top: 4px;
}

.alert-notify .alert-title {
  display: block;
  font-size: 1rem;
  font-weight: 600;
}

.alert-notify .close {
  top: 1rem !important;
  right: 1.5rem !important;
  transform: translateY(0);
}

.avatar {
  color: #fff;
  background-color: #adb5bd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  border-radius: 0.375rem;
  height: 48px;
  width: 48px;
}

.avatar img {
  width: 100%;
  border-radius: 0.375rem;
}

.avatar+.avatar-content {
  display: inline-block;
  margin-left: 0.75rem;
}

.avatar-xl {
  width: 74px;
  height: 74px;
}

.avatar-lg {
  width: 58px;
  height: 58px;
  font-size: 0.875rem;
}

.avatar-sm {
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.avatar-xs {
  width: 24px;
  height: 24px;
  font-size: 0.75rem;
}

.avatar-group .avatar {
  position: relative;
  z-index: 2;
  border: 2px solid #fff;
}

.avatar-group .avatar:hover {
  z-index: 3;
}

.avatar-group .avatar+.avatar {
  margin-left: -1rem;
}

.badge {
  text-transform: uppercase;
}

.badge a {
  color: #fff;
}

.badge-md {
  padding: 0.65em 1em;
}

.badge-lg {
  padding: 0.85em 1.375em;
}

.badge-inline {
  margin-right: 0.625rem;
}

.badge-inline+span {
  top: 2px;
  position: relative;
}

.badge-inline+span>a {
  text-decoration: underline;
}

.badge-default {
  color: #fff;
}

.badge-secondary {
  background-color: #f7fafc;
  color: #212529;
}

.btn .badge:not(:first-child) {
  margin-left: 0.5rem;
}

.btn .badge:not(:last-child) {
  margin-right: 0.5rem;
}

.badge-circle {
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 0 !important;
  width: 1.25rem;
  height: 1.25rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-circle.badge-md {
  width: 1.5rem;
  height: 1.5rem;
}

.badge-circle.badge-lg {
  width: 2rem;
  height: 2rem;
}

.badge-dot {
  padding-left: 0;
  padding-right: 0;
  background: transparent;
  font-weight: 400;
  font-size: 0.875rem;
  text-transform: none;
}

.badge-dot strong {
  color: #32325d;
}

.badge-dot i {
  display: inline-block;
  vertical-align: middle;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  margin-right: 0.375rem;
}

.badge-dot.badge-md i {
  width: 0.5rem;
  height: 0.5rem;
}

.badge-dot.badge-lg i {
  width: 0.625rem;
  height: 0.625rem;
}

.btn .badge-floating {
  position: absolute;
  top: -50%;
  transform: translateY(50%);
  border: 3px solid;
}

.btn .badge-floating.badge:not(.badge-circle) {
  transform: translate(147%, 50%);
}

.breadcrumb-item {
  font-size: 0.875rem;
}

.breadcrumb-dark {
  background-color: #172b4d;
}

.breadcrumb-dark .breadcrumb-item {
  font-weight: 600;
}

.breadcrumb-dark .breadcrumb-item a {
  color: #f6f9fc;
}

.breadcrumb-dark .breadcrumb-item a:hover {
  color: #fff;
}

.breadcrumb-dark .breadcrumb-item+.breadcrumb-item::before {
  color: #adb5bd;
}

.breadcrumb-dark .breadcrumb-item.active {
  color: #f8f9fa;
}

.breadcrumb-links {
  padding: 0;
  margin: 0;
  background: transparent;
}

.btn {
  position: relative;
  text-transform: none;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  font-size: 0.875rem;
  will-change: transform;
}

.btn:hover {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.btn:not(:last-child) {
  margin-right: 0.5rem;
}

.btn i:not(:first-child),
.btn svg:not(:first-child) {
  margin-left: 0.5rem;
}

.btn i:not(:last-child),
.btn svg:not(:last-child) {
  margin-right: 0.5rem;
}

.btn-group .btn,
.input-group .btn {
  margin-right: 0;
  transform: translateY(0);
}

.btn-sm,
.btn-group-sm>.btn {
  font-size: 0.75rem;
}

.btn-lg,
.btn-group-lg>.btn {
  font-size: 0.875rem;
}

[class*="btn-outline-"] {
  border-width: 1px;
}

.btn-outline-secondary {
  color: #4385b1;
}

.btn-inner--icon i:not(.fas):not(.fab) {
  position: relative;
  top: 2px;
}

.btn-link {
  font-weight: 600;
  box-shadow: none;
}

.btn-link:hover {
  box-shadow: none;
  transform: none;
}

.btn-neutral {
  color: #5e72e4;
}

.btn-facebook {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-facebook:hover {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}

.btn-facebook:focus,
.btn-facebook.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(59, 89, 153, 0.5);
}

.btn-facebook.disabled,
.btn-facebook:disabled {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}

.btn-facebook:not(:disabled):not(.disabled):active,
.btn-facebook:not(:disabled):not(.disabled).active,
.show>.btn-facebook.dropdown-toggle {
  color: #fff;
  background-color: #2d4474;
  border-color: #3b5999;
}

.btn-facebook:not(:disabled):not(.disabled):active:focus,
.btn-facebook:not(:disabled):not(.disabled).active:focus,
.show>.btn-facebook.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);
}

.btn-twitter {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-twitter:hover {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}

.btn-twitter:focus,
.btn-twitter.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(29, 161, 242, 0.5);
}

.btn-twitter.disabled,
.btn-twitter:disabled {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}

.btn-twitter:not(:disabled):not(.disabled):active,
.btn-twitter:not(:disabled):not(.disabled).active,
.show>.btn-twitter.dropdown-toggle {
  color: #fff;
  background-color: #0c85d0;
  border-color: #1da1f2;
}

.btn-twitter:not(:disabled):not(.disabled):active:focus,
.btn-twitter:not(:disabled):not(.disabled).active:focus,
.show>.btn-twitter.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);
}

.btn-google-plus {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-google-plus:hover {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}

.btn-google-plus:focus,
.btn-google-plus.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(221, 75, 57, 0.5);
}

.btn-google-plus.disabled,
.btn-google-plus:disabled {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}

.btn-google-plus:not(:disabled):not(.disabled):active,
.btn-google-plus:not(:disabled):not(.disabled).active,
.show>.btn-google-plus.dropdown-toggle {
  color: #fff;
  background-color: #c23321;
  border-color: #dd4b39;
}

.btn-google-plus:not(:disabled):not(.disabled):active:focus,
.btn-google-plus:not(:disabled):not(.disabled).active:focus,
.show>.btn-google-plus.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);
}

.btn-instagram {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-instagram:hover {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}

.btn-instagram:focus,
.btn-instagram.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(228, 64, 95, 0.5);
}

.btn-instagram.disabled,
.btn-instagram:disabled {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}

.btn-instagram:not(:disabled):not(.disabled):active,
.btn-instagram:not(:disabled):not(.disabled).active,
.show>.btn-instagram.dropdown-toggle {
  color: #fff;
  background-color: #d31e40;
  border-color: #e4405f;
}

.btn-instagram:not(:disabled):not(.disabled):active:focus,
.btn-instagram:not(:disabled):not(.disabled).active:focus,
.show>.btn-instagram.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);
}

.btn-pinterest {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-pinterest:hover {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}

.btn-pinterest:focus,
.btn-pinterest.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(189, 8, 28, 0.5);
}

.btn-pinterest.disabled,
.btn-pinterest:disabled {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}

.btn-pinterest:not(:disabled):not(.disabled):active,
.btn-pinterest:not(:disabled):not(.disabled).active,
.show>.btn-pinterest.dropdown-toggle {
  color: #fff;
  background-color: #8c0615;
  border-color: #bd081c;
}

.btn-pinterest:not(:disabled):not(.disabled):active:focus,
.btn-pinterest:not(:disabled):not(.disabled).active:focus,
.show>.btn-pinterest.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);
}

.btn-youtube {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-youtube:hover {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}

.btn-youtube:focus,
.btn-youtube.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(205, 32, 31, 0.5);
}

.btn-youtube.disabled,
.btn-youtube:disabled {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}

.btn-youtube:not(:disabled):not(.disabled):active,
.btn-youtube:not(:disabled):not(.disabled).active,
.show>.btn-youtube.dropdown-toggle {
  color: #fff;
  background-color: #a11918;
  border-color: #cd201f;
}

.btn-youtube:not(:disabled):not(.disabled):active:focus,
.btn-youtube:not(:disabled):not(.disabled).active:focus,
.show>.btn-youtube.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);
}

.btn-slack {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-slack:hover {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}

.btn-slack:focus,
.btn-slack.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(58, 175, 133, 0.5);
}

.btn-slack.disabled,
.btn-slack:disabled {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}

.btn-slack:not(:disabled):not(.disabled):active,
.btn-slack:not(:disabled):not(.disabled).active,
.show>.btn-slack.dropdown-toggle {
  color: #fff;
  background-color: #2d8968;
  border-color: #3aaf85;
}

.btn-slack:not(:disabled):not(.disabled):active:focus,
.btn-slack:not(:disabled):not(.disabled).active:focus,
.show>.btn-slack.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);
}

.btn-dribbble {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-dribbble:hover {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}

.btn-dribbble:focus,
.btn-dribbble.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(234, 76, 137, 0.5);
}

.btn-dribbble.disabled,
.btn-dribbble:disabled {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}

.btn-dribbble:not(:disabled):not(.disabled):active,
.btn-dribbble:not(:disabled):not(.disabled).active,
.show>.btn-dribbble.dropdown-toggle {
  color: #fff;
  background-color: #e51e6b;
  border-color: #ea4c89;
}

.btn-dribbble:not(:disabled):not(.disabled):active:focus,
.btn-dribbble:not(:disabled):not(.disabled).active:focus,
.show>.btn-dribbble.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);
}

.btn-github {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-github:hover {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}

.btn-github:focus,
.btn-github.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(34, 34, 34, 0.5);
}

.btn-github.disabled,
.btn-github:disabled {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}

.btn-github:not(:disabled):not(.disabled):active,
.btn-github:not(:disabled):not(.disabled).active,
.show>.btn-github.dropdown-toggle {
  color: #fff;
  background-color: #090909;
  border-color: #222222;
}

.btn-github:not(:disabled):not(.disabled):active:focus,
.btn-github:not(:disabled):not(.disabled).active:focus,
.show>.btn-github.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);
}

.btn-vimeo {
  color: #fff;
  background-color: #04a0f0;
  border-color: #04a0f0;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.btn-vimeo:hover {
  color: #fff;
  background-color: #04a0f0;
  border-color: #04a0f0;
}

.btn-vimeo:focus,
.btn-vimeo.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(4, 160, 240, 0.5);
}

.btn-vimeo.disabled,
.btn-vimeo:disabled {
  color: #fff;
  background-color: #04a0f0;
  border-color: #04a0f0;
}

.btn-vimeo:not(:disabled):not(.disabled):active,
.btn-vimeo:not(:disabled):not(.disabled).active,
.show>.btn-vimeo.dropdown-toggle {
  color: #fff;
  background-color: #037fbe;
  border-color: #04a0f0;
}

.btn-vimeo:not(:disabled):not(.disabled):active:focus,
.btn-vimeo:not(:disabled):not(.disabled).active:focus,
.show>.btn-vimeo.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(4, 160, 240, 0.5);
}

.btn-group .btn {
  box-shadow: none;
}

[data-toggle="buttons"]:not(.btn-group-colors)>.btn {
  background-color: #f6f9fc;
  cursor: pointer;
  box-shadow: none;
  border: 0;
  margin: 0;
}

[data-toggle="buttons"]:not(.btn-group-colors)>.btn:not(.active) {
  color: #525f7f;
}

[data-toggle="buttons"]:not(.btn-group-colors)>.btn.active {
  background-color: #5e72e4;
  color: #fff;
}

.btn-group-colors>.btn {
  box-shadow: none;
  border-radius: 50% !important;
  width: 30px;
  height: 30px;
  padding: 0;
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  position: relative;
}

.btn-group-colors>.btn:not([class*="bg-"]) {
  border-color: #f6f9fc !important;
}

.btn-group-colors>.btn:before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  line-height: 28px;
  color: #fff;
  transform: scale(0);
  opacity: 0;
  content: "";
  font-family: NucleoIcons, sans-serif;
  font-size: 14px;
  transition: transform 200ms, opacity 200ms;
}

@media (prefers-reduced-motion: reduce) {
  .btn-group-colors>.btn:before {
    transition: none;
  }
}

.btn-group-colors>.btn.btn:not([class*="bg-"]) {
  border: 1px solid #cfd5db;
}

.btn-group-colors>.btn.btn:not([class*="bg-"]):before {
  color: #525f7f;
}

.btn-group-colors>.btn.active:before {
  transform: scale(1);
  opacity: 1;
}

.btn-icon .btn-inner--icon img {
  width: 20px;
}

.btn-icon .btn-inner--text:not(:first-child) {
  margin-left: 0.75em;
}

.btn-icon .btn-inner--text:not(:last-child) {
  margin-right: 0.75em;
}

.btn-icon-only {
  width: 2.375rem;
  height: 2.375rem;
  padding: 0;
}

a.btn-icon-only {
  line-height: 2.5;
}

.btn-icon-only.btn-sm,
.btn-group-sm>.btn-icon-only.btn {
  width: 2rem;
  height: 2rem;
}

.btn-icon-clipboard {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}

.btn-icon-clipboard:hover {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
}

.btn-icon-clipboard>div {
  align-items: center;
  display: flex;
}

.btn-icon-clipboard i {
  box-sizing: content-box;
  color: #5e72e4;
  vertical-align: middle;
  font-size: 1.5rem;
}

.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.card {
  margin-bottom: 30px;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  border: 0;
}

.card-translucent {
  background-color: rgba(18, 91, 152, 0.08);
}

.card-deck .card {
  margin-bottom: 30px;
}

.card.shadow {
  border: 0 !important;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 1;
  }
}

@media (min-width: 768px) {
  .card-columns {
    column-count: 2;
  }
}

@media (min-width: 1200px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
  }
}

.card-lift--hover:hover {
  transform: translateY(-20px);
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .card-lift--hover:hover {
    transition: none;
  }
}

.card-blockquote {
  padding: 2rem;
  position: relative;
}

.card-blockquote .svg-bg {
  display: block;
  width: 100%;
  height: 95px;
  position: absolute;
  top: -94px;
  left: 0;
}

.card-serial-number {
  display: flex;
  justify-content: space-between;
  font-size: 1.625rem;
}

.card-serial-number>div:not(:last-child) {
  display: flex;
  flex: 1 1 auto;
}

.card-serial-number>div:not(:last-child):after {
  content: "-";
  flex: 1 1 auto;
  text-align: center;
  position: relative;
  left: -2px;
}

@media (max-width: 575.98px) {
  .card-serial-number {
    font-size: 1.0625rem;
  }
}

.card-pricing .card-header {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.card-pricing .list-unstyled li {
  padding: 0.5rem 0;
  color: #8898aa;
}

.card-pricing.popular {
  z-index: 1;
  border: 3px solid #5e72e4 !important;
}

@media (min-width: 768px) {
  .card-pricing.zoom-in {
    z-index: 1;
    transform: scale(1.1);
  }
}

.card-profile-image {
  position: relative;
}

.card-profile-image img {
  max-width: 140px;
  border-radius: 0.375rem;
  border: 3px solid #fff;
  transform: translate(-50%, -50%) scale(1);
  position: absolute;
  left: 50%;
  transition: all 0.15s ease;
}

.card-profile-image img:hover {
  transform: translate(-50%, -50%) scale(1.03);
}

.card-profile-stats {
  padding: 1rem 0;
}

.card-profile-stats>div {
  text-align: center;
  margin-right: 1rem;
  padding: 0.875rem;
}

.card-profile-stats>div:last-child {
  margin-right: 0;
}

.card-profile-stats>div .heading {
  font-size: 1.1rem;
  font-weight: bold;
  display: block;
}

.card-profile-stats>div .description {
  font-size: 0.875rem;
  color: #adb5bd;
}

.card-profile-actions {
  padding: 0.875rem;
}

.card-stats .card-body {
  padding: 1rem 1.5rem;
}

.card-stats .card-status-bullet {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.chart {
  position: relative;
  height: 350px;
}

.chart-sm {
  height: 230px;
}

.chart-legend {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  font-size: 0.875rem;
  text-align: center;
  color: #8898aa;
}

.chart-legend-item {
  display: inline-flex;
  align-items: center;
}

.chart-legend-item+.chart-legend-item {
  margin-left: 1rem;
}

.chart-legend-indicator {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.375rem;
  border-radius: 50%;
}

#chart-tooltip {
  z-index: 0;
}

#chart-tooltip .arrow {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateX(-0.5rem);
}

.chart-info-overlay {
  position: absolute;
  top: 0;
  left: 5%;
  max-width: 350px;
  padding: 20px;
  z-index: 1;
}

.close {
  transition: all 0.15s ease;
}

.close>span:not(.sr-only) {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  font-size: 1.25rem;
  display: block;
  transition: all 0.15s ease;
}

.close:hover,
.close:focus {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.9);
  outline: none;
}

.close:hover span:not(.sr-only),
.close:focus span:not(.sr-only) {
  background-color: transparent;
}

.close-dark>span:not(.sr-only) {
  color: rgba(255, 255, 255, 0.8);
}

.close-dark:hover>span:not(.sr-only),
.close-dark:focus>span:not(.sr-only) {
  color: white;
}

.accordion .card-header {
  position: relative;
  cursor: pointer;
}

.accordion .card-header:after {
  content: "\\ea0f";
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  font: normal normal normal 14px/1 NucleoIcons;
  line-height: 0;
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .accordion .card-header:after {
    transition: none;
  }
}

.accordion .card-header[aria-expanded="false"]:after {
  content: "\\ea0f";
}

.accordion .card-header[aria-expanded="true"]:after {
  transform: rotate(180deg);
}

.accordion .card-header[aria-expanded="true"] .heading {
  color: #5e72e4;
}

.main-content {
  position: relative;
}

.main-content .navbar-top {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (min-width: 768px) {

  .main-content .container-fluid,
  .main-content .container-sm,
  .main-content .container-md,
  .main-content .container-lg,
  .main-content .container-xl {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
}

.custom-checkbox .custom-control-input~.custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
  border-color: #5e72e4;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {
  border-color: #e9ecef;
}

.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-control-label::before {
  border: 1px solid #dee2e6;
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  top: 0.25rem;
  left: -1.75rem;
}

@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before {
    transition: none;
  }
}

.custom-control-label::after {
  top: 0.25rem;
  left: -1.75rem;
}

.custom-control-label span {
  position: relative;
  top: 2px;
}

.custom-control-label {
  margin-bottom: 0;
}

.custom-control-alternative .custom-control-label::before {
  border: 0;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}

.custom-control-alternative .custom-control-input:checked~.custom-control-label::before {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.custom-control-alternative .custom-control-input:active~.custom-control-label::before,
.custom-control-alternative .custom-control-input:focus~.custom-control-label::before {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}

.custom-checkbox .custom-control-input~.custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
  height: 1rem;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
  border-color: #5e72e4;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {
  border-color: #e9ecef;
}

.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-checkbox-primary .custom-control-input:checked~.custom-control-label::before {
  border-color: #5e72e4;
  background-color: #5e72e4;
}

.custom-checkbox-primary .custom-control-input:checked~.custom-control-label::after {
  background-image: #5e72e4;
}

.custom-checkbox-secondary .custom-control-input:checked~.custom-control-label::before {
  border-color: #f7fafc;
  background-color: #f7fafc;
}

.custom-checkbox-secondary .custom-control-input:checked~.custom-control-label::after {
  background-image: #f7fafc;
}

.custom-checkbox-success .custom-control-input:checked~.custom-control-label::before {
  border-color: #2dce89;
  background-color: #2dce89;
}

.custom-checkbox-success .custom-control-input:checked~.custom-control-label::after {
  background-image: #2dce89;
}

.custom-checkbox-info .custom-control-input:checked~.custom-control-label::before {
  border-color: #11cdef;
  background-color: #11cdef;
}

.custom-checkbox-info .custom-control-input:checked~.custom-control-label::after {
  background-image: #11cdef;
}

.custom-checkbox-warning .custom-control-input:checked~.custom-control-label::before {
  border-color: #fb6340;
  background-color: #fb6340;
}

.custom-checkbox-warning .custom-control-input:checked~.custom-control-label::after {
  background-image: #fb6340;
}

.custom-checkbox-danger .custom-control-input:checked~.custom-control-label::before {
  border-color: #f5365c;
  background-color: #f5365c;
}

.custom-checkbox-danger .custom-control-input:checked~.custom-control-label::after {
  background-image: #f5365c;
}

.custom-checkbox-light .custom-control-input:checked~.custom-control-label::before {
  border-color: #adb5bd;
  background-color: #adb5bd;
}

.custom-checkbox-light .custom-control-input:checked~.custom-control-label::after {
  background-image: #adb5bd;
}

.custom-checkbox-dark .custom-control-input:checked~.custom-control-label::before {
  border-color: #212529;
  background-color: #212529;
}

.custom-checkbox-dark .custom-control-input:checked~.custom-control-label::after {
  background-image: #212529;
}

.custom-checkbox-default .custom-control-input:checked~.custom-control-label::before {
  border-color: #172b4d;
  background-color: #172b4d;
}

.custom-checkbox-default .custom-control-input:checked~.custom-control-label::after {
  background-image: #172b4d;
}

.custom-checkbox-white .custom-control-input:checked~.custom-control-label::before {
  border-color: #fff;
  background-color: #fff;
}

.custom-checkbox-white .custom-control-input:checked~.custom-control-label::after {
  background-image: #fff;
}

.custom-checkbox-neutral .custom-control-input:checked~.custom-control-label::before {
  border-color: #fff;
  background-color: #fff;
}

.custom-checkbox-neutral .custom-control-input:checked~.custom-control-label::after {
  background-image: #fff;
}

.custom-checkbox-darker .custom-control-input:checked~.custom-control-label::before {
  border-color: black;
  background-color: black;
}

.custom-checkbox-darker .custom-control-input:checked~.custom-control-label::after {
  background-image: black;
}

.custom-radio .custom-control-input~.custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
  height: 1rem;
}

.custom-radio .custom-control-input:checked~.custom-control-label::before {
  border-color: #5e72e4;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.custom-radio .custom-control-input:disabled~.custom-control-label::before {
  border-color: #e9ecef;
}

.custom-radio .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-toggle {
  position: relative;
  display: inherit;
  width: 52px;
  height: 1.5rem;
  margin: 0;
  display: inline-block;
}

.custom-toggle input {
  display: none;
}

.custom-toggle input:checked+.custom-toggle-slider {
  border: 1px solid #5e72e4;
}

.custom-toggle input:checked+.custom-toggle-slider:before {
  background: #5e72e4;
  transform: translateX(28px);
}

.custom-toggle input:disabled+.custom-toggle-slider {
  border: 1px solid #e9ecef;
}

.custom-toggle input:disabled:checked+.custom-toggle-slider {
  border: 1px solid #e9ecef;
}

.custom-toggle input:disabled:checked+.custom-toggle-slider:before {
  background-color: #8a98eb;
}

.custom-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #ced4da;
  border-radius: 34px !important;
  background-color: transparent;
}

.custom-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  border-radius: 50% !important;
  background-color: #e9ecef;
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.custom-toggle-wrapper .custom-toggle+.custom-toggle {
  margin-left: 1rem !important;
}

.custom-toggle input:checked+.custom-toggle-slider:after {
  content: attr(data-label-on);
  color: #5e72e4;
  right: auto;
  left: 0;
}

.custom-toggle-slider:after {
  color: #ced4da;
  content: attr(data-label-off);
  display: block;
  font-family: inherit;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 24px;
  position: absolute;
  right: 0;
  margin: 0 0.21667rem;
  top: 0;
  text-align: center;
  min-width: 1.66667rem;
  overflow: hidden;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .custom-toggle-slider:after {
    transition: none;
  }
}

/* Checkbox column cells (light mode) */
.table-flush thead th.selection-cell,
.table-flush tbody td.selection-cell {
  width: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;

  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;

  text-align: center;
  white-space: nowrap;

  background-color: #f5f5f5;
  border-right: 1px solid #dee2e6;
}

/* All table checkbox inputs */
.table-flush tbody td.selection-cell input[type="checkbox"],
.table-flush thead th.selection-cell input[type="checkbox"] {
  cursor: pointer;
  transform: scale(0.9);
  /* slightly smaller */
  margin: 0 !important;
}

/* Select-all header cell */
.table-flush thead th.selection-cell-header {
  cursor: pointer;
}

/* Select-all checkbox itself */
.table-flush thead th.selection-cell-header input[type="checkbox"] {
  cursor: pointer !important;
}

/* Optional: row checkbox cells too */
.table-flush tbody td.selection-cell,
.table-flush tbody td.selection-cell input[type="checkbox"] {
  cursor: pointer !important;
}

.custom-toggle-primary input:checked+.custom-toggle-slider {
  border-color: #5e72e4;
}

.custom-toggle-primary input:checked+.custom-toggle-slider:before {
  background: #5e72e4;
}

.custom-toggle-primary input:checked+.custom-toggle-slider:after {
  color: #5e72e4;
}

.custom-toggle-primary input:disabled:checked+.custom-toggle-slider {
  border-color: #5e72e4;
}

.custom-toggle-primary input:disabled:checked+.custom-toggle-slider:before {
  background-color: #8a98eb;
}

.custom-toggle-secondary input:checked+.custom-toggle-slider {
  border-color: #f7fafc;
}

.custom-toggle-secondary input:checked+.custom-toggle-slider:before {
  background: #f7fafc;
}

.custom-toggle-secondary input:checked+.custom-toggle-slider:after {
  color: #f7fafc;
}

.custom-toggle-secondary input:disabled:checked+.custom-toggle-slider {
  border-color: #f7fafc;
}

.custom-toggle-secondary input:disabled:checked+.custom-toggle-slider:before {
  background-color: white;
}

.custom-toggle-success input:checked+.custom-toggle-slider {
  border-color: #2dce89;
}

.custom-toggle-success input:checked+.custom-toggle-slider:before {
  background: #2dce89;
}

.custom-toggle-success input:checked+.custom-toggle-slider:after {
  color: #2dce89;
}

.custom-toggle-success input:disabled:checked+.custom-toggle-slider {
  border-color: #2dce89;
}

.custom-toggle-success input:disabled:checked+.custom-toggle-slider:before {
  background-color: #54daa1;
}

.custom-toggle-info input:checked+.custom-toggle-slider {
  border-color: #11cdef;
}

.custom-toggle-info input:checked+.custom-toggle-slider:before {
  background: #11cdef;
}

.custom-toggle-info input:checked+.custom-toggle-slider:after {
  color: #11cdef;
}

.custom-toggle-info input:disabled:checked+.custom-toggle-slider {
  border-color: #11cdef;
}

.custom-toggle-info input:disabled:checked+.custom-toggle-slider:before {
  background-color: #41d7f2;
}

.custom-toggle-warning input:checked+.custom-toggle-slider {
  border-color: #fb6340;
}

.custom-toggle-warning input:checked+.custom-toggle-slider:before {
  background: #fb6340;
}

.custom-toggle-warning input:checked+.custom-toggle-slider:after {
  color: #fb6340;
}

.custom-toggle-warning input:disabled:checked+.custom-toggle-slider {
  border-color: #fb6340;
}

.custom-toggle-warning input:disabled:checked+.custom-toggle-slider:before {
  background-color: #fc8c72;
}

.custom-toggle-danger input:checked+.custom-toggle-slider {
  border-color: #f5365c;
}

.custom-toggle-danger input:checked+.custom-toggle-slider:before {
  background: #f5365c;
}

.custom-toggle-danger input:checked+.custom-toggle-slider:after {
  color: #f5365c;
}

.custom-toggle-danger input:disabled:checked+.custom-toggle-slider {
  border-color: #f5365c;
}

.custom-toggle-danger input:disabled:checked+.custom-toggle-slider:before {
  background-color: #f76783;
}

.custom-toggle-light input:checked+.custom-toggle-slider {
  border-color: #adb5bd;
}

.custom-toggle-light input:checked+.custom-toggle-slider:before {
  background: #adb5bd;
}

.custom-toggle-light input:checked+.custom-toggle-slider:after {
  color: #adb5bd;
}

.custom-toggle-light input:disabled:checked+.custom-toggle-slider {
  border-color: #adb5bd;
}

.custom-toggle-light input:disabled:checked+.custom-toggle-slider:before {
  background-color: #c9cfd4;
}

.custom-toggle-dark input:checked+.custom-toggle-slider {
  border-color: #212529;
}

.custom-toggle-dark input:checked+.custom-toggle-slider:before {
  background: #212529;
}

.custom-toggle-dark input:checked+.custom-toggle-slider:after {
  color: #212529;
}

.custom-toggle-dark input:disabled:checked+.custom-toggle-slider {
  border-color: #212529;
}

.custom-toggle-dark input:disabled:checked+.custom-toggle-slider:before {
  background-color: #383f45;
}

.custom-toggle-default input:checked+.custom-toggle-slider {
  border-color: #172b4d;
}

.custom-toggle-default input:checked+.custom-toggle-slider:before {
  background: #172b4d;
}

.custom-toggle-default input:checked+.custom-toggle-slider:after {
  color: #172b4d;
}

.custom-toggle-default input:disabled:checked+.custom-toggle-slider {
  border-color: #172b4d;
}

.custom-toggle-default input:disabled:checked+.custom-toggle-slider:before {
  background-color: #234174;
}

.custom-toggle-white input:checked+.custom-toggle-slider {
  border-color: #fff;
}

.custom-toggle-white input:checked+.custom-toggle-slider:before {
  background: #fff;
}

.custom-toggle-white input:checked+.custom-toggle-slider:after {
  color: #fff;
}

.custom-toggle-white input:disabled:checked+.custom-toggle-slider {
  border-color: #fff;
}

.custom-toggle-white input:disabled:checked+.custom-toggle-slider:before {
  background-color: white;
}

.custom-toggle-neutral input:checked+.custom-toggle-slider {
  border-color: #fff;
}

.custom-toggle-neutral input:checked+.custom-toggle-slider:before {
  background: #fff;
}

.custom-toggle-neutral input:checked+.custom-toggle-slider:after {
  color: #fff;
}

.custom-toggle-neutral input:disabled:checked+.custom-toggle-slider {
  border-color: #fff;
}

.custom-toggle-neutral input:disabled:checked+.custom-toggle-slider:before {
  background-color: white;
}

.custom-toggle-darker input:checked+.custom-toggle-slider {
  border-color: black;
}

.custom-toggle-darker input:checked+.custom-toggle-slider:before {
  background: black;
}

.custom-toggle-darker input:checked+.custom-toggle-slider:after {
  color: black;
}

.custom-toggle-darker input:disabled:checked+.custom-toggle-slider {
  border-color: black;
}

.custom-toggle-darker input:disabled:checked+.custom-toggle-slider:before {
  background-color: #1a1a1a;
}

.dropdown,
.dropup,
.dropright,
.dropleft {
  display: inline-block;
}

.dropdown-menu {
  min-width: 12rem;
}

.dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

.dropdown-menu .dropdown-item>i,
.dropdown-menu .dropdown-item>svg {
  margin-right: 1rem;
  font-size: 1rem;
  vertical-align: -17%;
}

.dropdown-menu .dropdown-item img {
  margin-right: 0.5rem;
}

.dropdown-header {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.625rem;
  text-transform: uppercase;
  font-weight: 700;
}

.dropdown-menu a.media>div:first-child {
  line-height: 1;
}

.dropdown-menu a.media p {
  color: #8898aa;
}

.dropdown-menu a.media:hover .heading,
.dropdown-menu a.media:hover p {
  color: #172b4d !important;
}

.dropdown-menu-dark .h1,
.dropdown-menu-dark .h2,
.dropdown-menu-dark .h3,
.dropdown-menu-dark .h4,
.dropdown-menu-dark .h5,
.dropdown-menu-dark .h6,
.dropdown-menu-dark a {
  color: white;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4375rem;
}

.dropdown-menu-lg {
  min-width: 320px;
  border-radius: 0.4375rem;
}

.dropdown-menu-xl {
  min-width: 420px;
  border-radius: 0.4375rem;
}

.footer {
  background: #f8f9fe;
  padding: 30px 0;
}

.footer .col-footer .heading {
  color: #8898aa;
  letter-spacing: 0;
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 1rem;
}

.footer .nav .nav-item .nav-link,
.footer .footer-link {
  color: #8898aa !important;
}

.footer .nav .nav-item .nav-link:hover,
.footer .footer-link:hover {
  color: #525f7f !important;
}

.footer .list-unstyled li a {
  display: inline-block;
  padding: 0.125rem 0;
  color: #8898aa;
  font-size: 0.85rem;
}

.footer .list-unstyled li a:hover {
  color: #525f7f;
}

.footer .copyright {
  font-size: 0.875rem;
}

.footer-dark .col-footer .heading {
  color: #fff;
}

.nav-footer .nav-link {
  font-size: 0.875rem;
}

.nav-footer .nav-item:last-child .nav-link {
  padding-right: 0;
}

.footer.has-cards {
  overflow: hidden;
  padding-top: 500px;
  margin-top: -420px;
  position: relative;
  background: transparent;
  pointer-events: none;
}

.footer.has-cards:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 600px;
  height: 2000px;
  background: #f7fafc;
  transform: skew(0, -8deg);
}

.footer.has-cards .container {
  pointer-events: auto;
  position: relative;
}

.footer-auto-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.form-control-label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}

.form-control {
  font-size: 0.875rem;
  transition: all 0.15s ease-in-out;
  height: calc(1.5em + 1.25rem + 5px);
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control:focus::placeholder {
  color: #adb5bd;
}

.form-control-lg {
  height: calc(2.25em + 1.25rem + 5px);
}

.form-control-sm {
  height: calc(0.45em + 1.25rem + 5px);
}

.form-control-flush {
  padding: 0;
  border-width: 0;
  background-color: transparent;
  box-shadow: none;
}

.form-control-flush:focus {
  background-color: transparent;
  box-shadow: none;
  border-width: 0;
}

textarea[resize="none"] {
  resize: none !important;
}

textarea[resize="both"] {
  resize: both !important;
}

textarea[resize="vertical"] {
  resize: vertical !important;
}

textarea[resize="horizontal"] {
  resize: horizontal !important;
}

.form-control-muted {
  background-color: #f7fafe;
  border-color: #f7fafe;
  box-shadow: none;
}

.form-control-muted:focus {
  background-color: #fcfdff;
}

.form-control-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}

.form-control-alternative:focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.form-control-lg,
.input-group-lg .form-control,
.input-group-text {
  font-size: 1rem !important;
}

.custom-control {
  padding-left: 1.75rem;
}

.input-group {
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  border-radius: 0.25rem;
  transition: all 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .input-group {
    transition: none;
  }
}

.input-group .form-control {
  box-shadow: none;
}

.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .input-group-text {
    transition: none;
  }
}

.input-group-text i {
  font-size: 0.875rem;
}

.input-group-text .custom-control {
  line-height: 1;
}

.input-group-prepend .input-group-text {
  border-right: 0;
}

.input-group-append .input-group-text {
  border-left: 0;
}

.input-group-merge .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}

.input-group-merge .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}

.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.input-group-flush {
  box-shadow: none;
}

.input-group-flush>.form-control {
  padding: 0;
  border-width: 0;
  background-color: transparent;
}

.input-group-flush>.input-group-prepend>.input-group-text,
.input-group-flush>.input-group-append>.input-group-text {
  padding: 0;
  padding-right: 1rem;
  border-width: 0;
  background-color: transparent;
}

.focused .input-group {
  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);
}

.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: #5e72e4;
}

.focused .form-control {
  border-color: #5e72e4;
}

.focused .input-group-flush {
  box-shadow: none;
}

.form-primary .form-control {
  color: #fff;
  background-color: rgba(50, 76, 221, 0.5);
  border-color: #324cdd;
}

.form-primary .form-control:focus {
  background-color: rgba(42, 68, 219, 0.7);
  border: 1px solid #2a44db;
}

.form-primary .form-control::placeholder {
  color: rgba(255, 255, 255, 0.8);
}

.form-primary .input-group-text {
  color: #fff;
  background-color: rgba(50, 76, 221, 0.5);
  border-color: #324cdd;
}

.form-primary .focused .input-group-text {
  color: #fff;
  background-color: rgba(42, 68, 219, 0.7);
  border-color: #2a44db;
}

.has-success,
.has-danger {
  position: relative;
}

.has-success:after,
.has-danger:after {
  display: none;
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.has-success .input-group-prepend .input-group-text,
.has-danger .input-group-prepend .input-group-text {
  border-color: red;
}

.has-success:after {
  content: "\\ea26";
  color: #1d8357;
  background-color: #69deac;
}

.has-success .form-control {
  background-color: #fff;
}

.has-success .form-control::placeholder {
  color: #2dce89;
}

.has-danger:after {
  content: "\\ea53";
  color: #db2d05;
  background-color: #fda08b;
}

.has-danger .form-control {
  background-color: #fff;
}

.has-danger .form-control::placeholder {
  color: #fb6340;
}

.row-example>.col span,
.row-example>[class^="col-"] span {
  display: block;
  padding: 0.75rem;
  color: #393f49;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,
    rgba(0, 0, 0, 0.1) 0px 4px 16px;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  margin: 1rem 0;
}

.no-gutters>.col span,
.no-gutters>[class^="col-"] span {
  border-radius: 0;
}

.header {
  position: relative;
}

.icon {
  width: 3rem;
  height: 3rem;
}

.icon i,
.icon svg {
  font-size: 2.25rem;
}

.icon+.icon-text {
  padding-left: 1rem;
  width: calc(100% - 3rem - 1);
}

.icon-xl {
  width: 5rem;
  height: 5rem;
}

.icon-xl i,
.icon-xl svg {
  font-size: 4.25rem;
}

.icon-xl+.icon-text {
  width: calc(100% - 5rem - 1);
}

.icon-lg {
  width: 4rem;
  height: 4rem;
}

.icon-lg i,
.icon-lg svg {
  font-size: 3.25rem;
}

.icon-lg+.icon-text {
  width: calc(100% - 4rem - 1);
}

.icon-sm {
  width: 2rem;
  height: 2rem;
}

.icon-sm i,
.icon-sm svg {
  font-size: 1.25rem;
}

.icon-sm+.icon-text {
  width: calc(100% - 2rem - 1);
}

.icon-xs {
  width: 1.25rem;
  height: 1.25rem;
}

.icon-xs i,
.icon-xs svg {
  font-size: 0.5rem;
}

.icon-xs+.icon-text {
  width: calc(100% - 1.25rem - 1);
}

.icon-actions>a {
  display: inline-block;
  margin-right: 0.75rem;
  color: #8898aa;
  font-size: 0.875rem;
}

.icon-actions>a:last-of-type {
  margin-right: 0;
}

.icon-actions>a span {
  margin-left: 0.1875rem;
  font-weight: 600;
  color: #8898aa;
}

.icon-actions>a:hover span {
  color: #6a7e95;
}

.icon-actions>a,
.icon-actions>a:hover,
.icon-actions>a.active {
  color: #32325d;
}

.icon-actions>.favorite:hover,
.icon-actions>.favorite.active {
  color: #ffd600;
}

.icon-actions>.love:hover,
.icon-actions>.love.active {
  color: #f5365c;
}

.icon-actions>.like:hover,
.icon-actions>.like.active {
  color: #5e72e4;
}

.icon-actions-lg a {
  font-size: 1.25rem;
  margin-right: 0.875rem;
}

.icon-shape {
  padding: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.icon-shape i,
.icon-shape svg {
  font-size: 1.25rem;
}

.icon-shape.icon-lg i,
.icon-shape.icon-lg svg {
  font-size: 1.625rem;
}

.icon-shape.icon-sm i,
.icon-shape.icon-sm svg {
  font-size: 0.875rem;
}

.icon-shape.icon-xs i,
.icon-shape.icon-xs svg {
  font-size: 0.6rem;
}

.icon-shape svg {
  width: 30px;
  height: 30px;
}

.icon-shape-primary {
  color: #2643e9;
  background-color: rgba(138, 152, 235, 0.5);
}

.icon-shape-secondary {
  color: #cfe3f1;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-success {
  color: #1aae6f;
  background-color: rgba(84, 218, 161, 0.5);
}

.icon-shape-info {
  color: #03acca;
  background-color: rgba(65, 215, 242, 0.5);
}

.icon-shape-warning {
  color: #ff3709;
  background-color: rgba(252, 140, 114, 0.5);
}

.icon-shape-danger {
  color: #f80031;
  background-color: rgba(247, 103, 131, 0.5);
}

.icon-shape-light {
  color: #879cb0;
  background-color: rgba(201, 207, 212, 0.5);
}

.icon-shape-dark {
  color: #090c0e;
  background-color: rgba(56, 63, 69, 0.5);
}

.icon-shape-default {
  color: #091428;
  background-color: rgba(35, 65, 116, 0.5);
}

.icon-shape-white {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-neutral {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-darker {
  color: black;
  background-color: rgba(26, 26, 26, 0.5);
}

.list-group-space .list-group-item {
  margin-bottom: 1.5rem;
  border-radius: 0.375rem;
}

.list-group-img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  vertical-align: top;
  margin: -0.1rem 1.2rem 0 -0.2rem;
}

.list-group-content {
  flex: 1 1;
  min-width: 0;
}

.list-group-content>p {
  color: #adb5bd;
  line-height: 1.5;
  margin: 0.2rem 0 0;
}

.list-group-heading {
  font-size: 1rem;
  color: #32325d;
}

.list-group-heading>small {
  float: right;
  color: #adb5bd;
  font-weight: 500;
}

.checklist-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-left: 0.75rem;
}

.checklist-item:before {
  content: "";
  position: absolute;
  width: 3px;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #5e72e4;
  border-radius: 8px;
}

.checklist-item-checked .checklist-info * {
  text-decoration: line-through;
}

.checklist-item-primary:before {
  background-color: #5e72e4;
}

.checklist-item-secondary:before {
  background-color: #f7fafc;
}

.checklist-item-success:before {
  background-color: #2dce89;
}

.checklist-item-info:before {
  background-color: #11cdef;
}

.checklist-item-warning:before {
  background-color: #fb6340;
}

.checklist-item-danger:before {
  background-color: #f5365c;
}

.checklist-item-light:before {
  background-color: #adb5bd;
}

.checklist-item-dark:before {
  background-color: #212529;
}

.checklist-item-default:before {
  background-color: #172b4d;
}

.checklist-item-white:before {
  background-color: #fff;
}

.checklist-item-neutral:before {
  background-color: #fff;
}

.checklist-item-darker:before {
  background-color: black;
}

.map-canvas {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 0.375rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .mask {
    transition: none;
  }
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 1040;
}

.backdrop-dark {
  background: rgba(0, 0, 0, 0.3);
}

.backdrop-light {
  background: rgba(255, 255, 255, 0.3);
}

.media-comment {
  margin-top: 2rem;
}

.media-comment-avatar {
  margin-top: -1rem;
  margin-right: -2rem;
  position: relative;
  z-index: 1;
  border: 4px solid #fff;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .media-comment-avatar {
    transition: none;
  }
}

.media-comment-text {
  border-radius: 0.4375rem;
  border-top-left-radius: 0;
  position: relative;
  background-color: #f6f9fc;
  padding: 1rem 1.25rem 1rem 2.5rem;
}

.media-comment:hover .media-comment-avatar {
  transform: scale(1.1);
}

.metric-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-card-icon-img {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
}

.modal-title {
  font-size: 1.0625rem;
}

.modal-fluid .modal-dialog {
  margin-top: 0;
  margin-bottom: 0;
}

.modal-fluid .modal-content {
  border-radius: 0;
}

.modal-primary .modal-title {
  color: #fff;
}

.modal-primary .modal-header,
.modal-primary .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-primary .modal-content {
  background-color: #5e72e4;
  color: #fff;
}

.modal-primary .modal-content .heading {
  color: #fff;
}

.modal-primary .close>span:not(.sr-only) {
  color: #fff;
}

.modal-secondary .modal-title {
  color: #212529;
}

.modal-secondary .modal-header,
.modal-secondary .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}

.modal-secondary .modal-content {
  background-color: #f7fafc;
  color: #212529;
}

.modal-secondary .modal-content .heading {
  color: #212529;
}

.modal-secondary .close>span:not(.sr-only) {
  color: #fff;
}

.modal-success .modal-title {
  color: #fff;
}

.modal-success .modal-header,
.modal-success .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-success .modal-content {
  background-color: #2dce89;
  color: #fff;
}

.modal-success .modal-content .heading {
  color: #fff;
}

.modal-success .close>span:not(.sr-only) {
  color: #fff;
}

.modal-info .modal-title {
  color: #fff;
}

.modal-info .modal-header,
.modal-info .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-info .modal-content {
  background-color: #11cdef;
  color: #fff;
}

.modal-info .modal-content .heading {
  color: #fff;
}

.modal-info .close>span:not(.sr-only) {
  color: #fff;
}

.modal-warning .modal-title {
  color: #fff;
}

.modal-warning .modal-header,
.modal-warning .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-warning .modal-content {
  background-color: #fb6340;
  color: #fff;
}

.modal-warning .modal-content .heading {
  color: #fff;
}

.modal-warning .close>span:not(.sr-only) {
  color: #fff;
}

.modal-danger .modal-title {
  color: #fff;
}

.modal-danger .modal-header,
.modal-danger .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-danger .modal-content {
  background-color: #f5365c;
  color: #fff;
}

.modal-danger .modal-content .heading {
  color: #fff;
}

.modal-danger .close>span:not(.sr-only) {
  color: #fff;
}

.modal-light .modal-title {
  color: #fff;
}

.modal-light .modal-header,
.modal-light .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-light .modal-content {
  background-color: #adb5bd;
  color: #fff;
}

.modal-light .modal-content .heading {
  color: #fff;
}

.modal-light .close>span:not(.sr-only) {
  color: #fff;
}

.modal-dark .modal-title {
  color: #fff;
}

.modal-dark .modal-header,
.modal-dark .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-dark .modal-content {
  background-color: #212529;
  color: #fff;
}

.modal-dark .modal-content .heading {
  color: #fff;
}

.modal-dark .close>span:not(.sr-only) {
  color: #fff;
}

.modal-default .modal-title {
  color: #fff;
}

.modal-default .modal-header,
.modal-default .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-default .modal-content {
  background-color: #172b4d;
  color: #fff;
}

.modal-default .modal-content .heading {
  color: #fff;
}

.modal-default .close>span:not(.sr-only) {
  color: #fff;
}

.modal-white .modal-title {
  color: #212529;
}

.modal-white .modal-header,
.modal-white .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}

.modal-white .modal-content {
  background-color: #fff;
  color: #212529;
}

.modal-white .modal-content .heading {
  color: #212529;
}

.modal-white .close>span:not(.sr-only) {
  color: #fff;
}

.modal-neutral .modal-title {
  color: #212529;
}

.modal-neutral .modal-header,
.modal-neutral .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}

.modal-neutral .modal-content {
  background-color: #fff;
  color: #212529;
}

.modal-neutral .modal-content .heading {
  color: #212529;
}

.modal-neutral .close>span:not(.sr-only) {
  color: #fff;
}

.modal-darker .modal-title {
  color: #fff;
}

.modal-darker .modal-header,
.modal-darker .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}

.modal-darker .modal-content {
  background-color: black;
  color: #fff;
}

.modal-darker .modal-content .heading {
  color: #fff;
}

.modal-darker .close>span:not(.sr-only) {
  color: #fff;
}

.navbar-horizontal .navbar-nav .nav-link {
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: normal;
  letter-spacing: 0;
}

.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {
  margin-left: 0.25rem;
}

.navbar-horizontal .navbar-brand {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.05px;
}

.navbar-horizontal .navbar-brand img {
  height: 30px;
}

.navbar-horizontal .navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-horizontal .navbar-light .navbar-brand {
  color: #32325d;
}

.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {
  margin-bottom: 1.5rem;
}

@media (min-width: 992px) {
  .navbar-horizontal .navbar-nav .nav-item {
    margin-right: 0.5rem;
  }

  .navbar-horizontal .navbar-nav .nav-item [data-toggle="dropdown"]::after {
    transition: all 0.15s ease;
  }

  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle="dropdown"]::after {
    transform: rotate(180deg);
  }

  .navbar-horizontal .navbar-nav .nav-link {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-horizontal .navbar-nav .nav-link i {
    margin-right: 0.625rem;
  }

  .navbar-horizontal .navbar-nav .nav-link-icon {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    font-size: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-horizontal .navbar-nav .nav-link-icon i {
    margin-right: 0;
  }

  .navbar-horizontal .navbar-nav .dropdown-menu {
    opacity: 0;
    pointer-events: none;
    margin: 0;
  }

  .navbar-horizontal .navbar-nav .dropdown-menu:before {
    background: #fff;
    box-shadow: none;
    content: "";
    display: block;
    height: 16px;
    width: 16px;
    left: 20px;
    position: absolute;
    bottom: 100%;
    transform: rotate(-45deg) translateY(1rem);
    z-index: -5;
    border-radius: 0.25rem;
  }

  .navbar-horizontal .navbar-nav .dropdown-menu-right:before {
    right: 20px;
    left: auto;
  }

  .navbar-horizontal .navbar-nav:not(.navbar-nav-hover) .dropdown-menu.show {
    opacity: 1;
    pointer-events: auto;
    animation: show-navbar-dropdown 0.25s ease forwards;
  }

  .navbar-horizontal .navbar-nav:not(.navbar-nav-hover) .dropdown-menu.close {
    display: block;
    animation: hide-navbar-dropdown 0.15s ease backwards;
  }

  .navbar-horizontal .navbar-nav.navbar-nav-hover .dropdown-menu {
    opacity: 0;
    display: block;
    pointer-events: none;
    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  }

  .navbar-horizontal .navbar-nav.navbar-nav-hover .nav-item.dropdown:hover>.dropdown-menu {
    display: block;
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    transform: translate(0, 0);
    animation: none;
  }

  .navbar-horizontal .navbar-nav .dropdown-menu-inner {
    position: relative;
    padding: 1rem;
  }
}

.navbar-horizontal.navbar-transparent {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  background-color: transparent;
  border: 0;
  box-shadow: none;
}

.navbar-horizontal.navbar-transparent .navbar-brand {
  color: white;
}

.navbar-horizontal.navbar-transparent .navbar-toggler {
  color: white;
}

.navbar-horizontal.navbar-transparent .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

@media (min-width: 768px) {
  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.95);
  }

  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link:hover,
  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.65);
  }

  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25);
  }

  .navbar-horizontal.navbar-transparent .navbar-nav .show>.nav-link,
  .navbar-horizontal.navbar-transparent .navbar-nav .active>.nav-link,
  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link.show,
  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link.active {
    color: rgba(255, 255, 255, 0.65);
  }

  .navbar-horizontal.navbar-transparent .navbar-brand {
    color: rgba(255, 255, 255, 0.95);
  }

  .navbar-horizontal.navbar-transparent .navbar-brand:hover,
  .navbar-horizontal.navbar-transparent .navbar-brand:focus {
    color: rgba(255, 255, 255, 0.95);
  }
}

.navbar-horizontal .navbar-collapse-header {
  display: none;
}

@media (max-width: 991.98px) {
  .navbar-horizontal .navbar-nav .nav-link {
    padding: 0.625rem 0;
    color: #172b4d !important;
  }

  .navbar-horizontal .navbar-nav .dropdown-menu {
    box-shadow: none;
    min-width: auto;
  }

  .navbar-horizontal .navbar-nav .dropdown-menu .media svg {
    width: 30px;
  }

  .navbar-horizontal .navbar-collapse {
    width: calc(100% - 1.4rem);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    margin: 0.7rem;
    overflow-y: auto;
    height: auto !important;
    opacity: 0;
  }

  .navbar-horizontal .navbar-collapse .navbar-toggler {
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    display: inline-block;
    padding: 0;
  }

  .navbar-horizontal .navbar-collapse .navbar-toggler span {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    opacity: 1;
    background: #283448;
  }

  .navbar-horizontal .navbar-collapse .navbar-toggler :nth-child(1) {
    transform: rotate(135deg);
  }

  .navbar-horizontal .navbar-collapse .navbar-toggler :nth-child(2) {
    transform: rotate(-135deg);
  }

  .navbar-horizontal .navbar-collapse .navbar-collapse-header {
    display: block;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .navbar-horizontal .navbar-collapse .collapse-brand img {
    height: 36px;
  }

  .navbar-horizontal .navbar-collapse .collapse-close {
    text-align: right;
  }

  .navbar-horizontal .navbar-collapse.collapsing,
  .navbar-horizontal .navbar-collapse.show {
    padding: 1.5rem;
    border-radius: 0.375rem;
    background: #fff;
    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
      0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
    animation: show-navbar-collapse 0.2s ease forwards;
  }

  .navbar-horizontal .navbar-collapse.collapsing-out {
    animation: hide-navbar-collapse 0.2s ease forwards;
  }
}

@keyframes show-navbar-collapse {
  0% {
    opacity: 0;
    transform: scale(0.95);
    transform-origin: 100% 0;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes hide-navbar-collapse {
  from {
    opacity: 1;
    transform: scale(1);
    transform-origin: 100% 0;
  }

  to {
    opacity: 0;
    transform: scale(0.95);
  }
}

@keyframes show-navbar-dropdown {
  0% {
    opacity: 0;
    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  }

  100% {
    transform: translate(0, 0);
    opacity: 1;
  }
}

@keyframes hide-navbar-dropdown {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate(0, 10px);
  }
}

.navbar-floating-wrapper {
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
}

.navbar-floating-wrapper .navbar {
  border-radius: 0.375rem;
}

.navbar-vertical {
  padding-top: 0;
  border-width: 0 0 1px 0;
  border-style: solid;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
}

.navbar-vertical.navbar-light {
  background-color: #f6f9fc;
  border-color: rgba(0, 0, 0, 0.05);
}

.navbar-vertical.navbar-dark {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-vertical .navbar-brand {
  margin-right: 0;
}

.navbar-vertical .navbar-brand-img,
.navbar-vertical .navbar-brand>img {
  max-width: 100%;
  max-height: 2rem;
}

@media (min-width: 768px) {
  .navbar-vertical .navbar-collapse {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .navbar-vertical .navbar-collapse:before {
    content: "";
    display: block;
    margin: 0.5rem;
  }
}

.navbar-vertical .navbar-nav {
  margin-left: -1rem;
  margin-right: -1rem;
}

.navbar-vertical .navbar-nav .nav-link {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.navbar-vertical .navbar-nav .sidebar-icon.home-icon i {
  font-size: 0.9375rem;
}

.navbar-vertical .navbar-nav .nav-link.active {
  position: relative;
}

.navbar-vertical .navbar-nav .nav-link>i {
  min-width: 2rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
}

.navbar-vertical .navbar-nav .nav-link .dropdown-menu {
  border: none;
}

.navbar-vertical .navbar-nav .nav-link .dropdown-menu .dropdown-menu {
  margin-left: 0.5rem;
}

.navbar-vertical .navbar-nav .nav-sm .nav-link {
  font-size: 0.8125rem;
}

.navbar-vertical .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.navbar-vertical .navbar-nav .nav-link[data-toggle="collapse"]:after {
  display: inline-block;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  content: "\\f105";
  margin-left: auto;
  color: #ced4da;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .navbar-vertical .navbar-nav .nav-link[data-toggle="collapse"]:after {
    transition: none;
  }
}

.navbar-vertical .navbar-nav .nav-link[data-toggle="collapse"][aria-expanded="true"]:after {
  color: #5e72e4;
  transform: rotate(90deg);
}

.navbar-vertical .navbar-nav .nav .nav-link {
  padding-left: 3rem;
}

.navbar-vertical .navbar-nav .nav .nav .nav-link {
  padding-left: 3.5rem;
}

.navbar-vertical .navbar-heading {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.navbar-vertical.navbar-expand-xs {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: 62px;
  overflow-y: auto;
  padding-left: 0;
  padding-right: 0;
}

.navbar-vertical.navbar-expand-xs .navbar-inner {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.navbar-vertical.navbar-expand-xs>[class*="container"] {
  flex-direction: column;
  align-items: stretch;
  min-height: 100%;
  padding-left: 0;
  padding-right: 0;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-xs>[class*="container"] {
    min-height: none;
    height: 100%;
  }
}

.navbar-vertical.navbar-expand-xs.fixed-left {
  left: 0;
  border-width: 0 1px 0 0;
}

.navbar-vertical.navbar-expand-xs.fixed-right {
  right: 0;
  border-width: 0 0 0 1px;
}

.navbar-vertical.navbar-expand-xs .navbar-collapse {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.navbar-vertical.navbar-expand-xs .navbar-collapse>* {
  min-width: 100%;
}

.navbar-vertical.navbar-expand-xs .navbar-nav {
  flex-direction: column;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
  padding: 0.675rem 1.5rem;
}

.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item {
  margin-top: 2px;
}

/*.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item>.nav-link.active {
  background: #f6f9fc;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 0.375rem;
}*/

.navbar-vertical.navbar-expand-xs .lavalamp-object {
  width: calc(100% - 1rem) !important;
  background: #5e72e4;
  color: #fff;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 0.375rem;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link {
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
  padding-left: 15px;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-normal {
  padding-left: 8px;
  transition: all 0.1s ease 0s;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-mini-icon {
  width: 34px;
  text-align: center;
  transition: all 0.1s ease 0s;
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav .nav-link {
  padding-left: 4.25rem;
}

@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 62px;
    overflow-y: auto;
    padding-left: 0;
    padding-right: 0;
  }

  .navbar-vertical.navbar-expand-sm .navbar-inner {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-sm>[class*="container"] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}

@media all and (min-width: 576px) and (-ms-high-contrast: none),
(min-width: 576px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-sm>[class*="container"] {
    min-height: none;
    height: 100%;
  }
}

@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }

  .navbar-vertical.navbar-expand-sm.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }

  .navbar-vertical.navbar-expand-sm .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-sm .navbar-collapse>* {
    min-width: 100%;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link {
    padding: 0.675rem 1.5rem;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav>.nav-item {
    margin-top: 2px;
  }

  /*.navbar-vertical.navbar-expand-sm .navbar-nav>.nav-item>.nav-link.active {
    background: #f6f9fc;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }*/

  .navbar-vertical.navbar-expand-sm .lavalamp-object {
    width: calc(100% - 1rem) !important;
    background: #5e72e4;
    color: #fff;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link {
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
    padding-left: 15px;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link span.sidenav-normal {
    padding-left: 8px;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link span.sidenav-mini-icon {
    width: 34px;
    text-align: center;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav .nav-link {
    padding-left: 4.25rem;
  }
}

@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 62px;
    overflow-y: auto;
    padding-left: 0;
    padding-right: 0;
  }

  .navbar-vertical.navbar-expand-md .navbar-inner {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-md>[class*="container"] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}

@media all and (min-width: 768px) and (-ms-high-contrast: none),
(min-width: 768px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-md>[class*="container"] {
    min-height: none;
    height: 100%;
  }
}

@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }

  .navbar-vertical.navbar-expand-md.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }

  .navbar-vertical.navbar-expand-md .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-md .navbar-collapse>* {
    min-width: 100%;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link {
    padding: 0.675rem 1.5rem;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav>.nav-item {
    margin-top: 2px;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav>.nav-item>.nav-link.active {
    background: #f6f9fc;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-md .lavalamp-object {
    width: calc(100% - 1rem) !important;
    background: #5e72e4;
    color: #fff;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link {
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
    padding-left: 15px;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link span.sidenav-normal {
    padding-left: 8px;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link span.sidenav-mini-icon {
    width: 34px;
    text-align: center;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav .nav-link {
    padding-left: 4.25rem;
  }
}

@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 62px;
    overflow-y: auto;
    padding-left: 0;
    padding-right: 0;
  }

  .navbar-vertical.navbar-expand-lg .navbar-inner {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-lg>[class*="container"] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}

@media all and (min-width: 992px) and (-ms-high-contrast: none),
(min-width: 992px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-lg>[class*="container"] {
    min-height: none;
    height: 100%;
  }
}

@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }

  .navbar-vertical.navbar-expand-lg.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }

  .navbar-vertical.navbar-expand-lg .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-lg .navbar-collapse>* {
    min-width: 100%;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link {
    padding: 0.675rem 1.5rem;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav>.nav-item {
    margin-top: 2px;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav>.nav-item>.nav-link.active {
    background: #f6f9fc;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-lg .lavalamp-object {
    width: calc(100% - 1rem) !important;
    background: #5e72e4;
    color: #fff;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link {
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
    padding-left: 15px;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link span.sidenav-normal {
    padding-left: 8px;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link span.sidenav-mini-icon {
    width: 34px;
    text-align: center;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav .nav-link {
    padding-left: 4.25rem;
  }
}

@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 62px;
    overflow-y: auto;
    padding-left: 0;
    padding-right: 0;
  }

  .navbar-vertical.navbar-expand-xl .navbar-inner {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-xl>[class*="container"] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}

@media all and (min-width: 1200px) and (-ms-high-contrast: none),
(min-width: 1200px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-xl>[class*="container"] {
    min-height: none;
    height: 100%;
  }
}

@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }

  .navbar-vertical.navbar-expand-xl.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }

  .navbar-vertical.navbar-expand-xl .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-vertical.navbar-expand-xl .navbar-collapse>* {
    min-width: 100%;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link {
    padding: 0.675rem 1.5rem;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav>.nav-item {
    margin-top: 2px;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav>.nav-item>.nav-link.active {
    background: #f6f9fc;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-xl .lavalamp-object {
    width: calc(100% - 1rem) !important;
    background: #5e72e4;
    color: #fff;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.375rem;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link {
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
    padding-left: 15px;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link span.sidenav-normal {
    padding-left: 8px;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link span.sidenav-mini-icon {
    width: 34px;
    text-align: center;
    transition: all 0.1s ease 0s;
  }

  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav .nav-link {
    padding-left: 4.25rem;
  }
}

.navbar-vertical.navbar-expand-xs.fixed-left+.main-content {
  margin-left: 62px;
}

.navbar-vertical.navbar-expand-xs.fixed-right+.main-content {
  margin-right: 62px;
}

@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm.fixed-left+.main-content {
    margin-left: 62px;
  }

  .navbar-vertical.navbar-expand-sm.fixed-right+.main-content {
    margin-right: 62px;
  }
}

@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md.fixed-left+.main-content {
    margin-left: 62px;
  }

  .navbar-vertical.navbar-expand-md.fixed-right+.main-content {
    margin-right: 62px;
  }
}

@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg.fixed-left+.main-content {
    margin-left: 62px;
  }

  .navbar-vertical.navbar-expand-lg.fixed-right+.main-content {
    margin-right: 62px;
  }
}

@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl.fixed-left+.main-content {
    margin-left: 62px;
  }

  .navbar-vertical.navbar-expand-xl.fixed-right+.main-content {
    margin-right: 62px;
  }
}

.sidenav.fixed-left+.main-content {
  margin-left: 62px;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .sidenav.fixed-left+.main-content {
    transition: none;
  }
}

.sidenav.fixed-right+.main-content {
  margin-right: 62px;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .sidenav.fixed-right+.main-content {
    transition: none;
  }
}

@media (min-width: 1200px) {
  .g-sidenav-pinned .sidenav.fixed-left+.main-content {
    margin-left: 250px;
  }

  .g-sidenav-pinned .sidenav.fixed-right+.main-content {
    margin-right: 250px;
  }
}

.sidenav {
  z-index: 1050;
  transition: all 0.4s ease;
}

@media (min-width: 1200px) {
  .sidenav:hover {
    max-width: 250px;
  }

  .sidenav .sidenav-toggler {
    padding: 1.5rem;
  }
}

.sidenav .navbar-brand,
.sidenav .navbar-heading .docs-normal {
  display: none;
}

.sidenav .navbar-heading .docs-mini {
  padding-left: 3px;
}

.sidenav .navbar-heading {
  transition: all 0.1s ease;
}

.sidenav .navbar-brand {
  padding: 1.5rem;
}

.sidenav-header {
  height: 78px;
}

.g-sidenav-show .sidenav .navbar-brand,
.g-sidenav-show .sidenav .navbar-heading .docs-normal {
  display: block;
}

.g-sidenav-show .sidenav .navbar-heading .docs-mini {
  display: none;
}

.g-sidenav-show .sidenav .nav-item .collapse {
  height: auto;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .g-sidenav-show .sidenav .nav-item .collapse {
    transition: none;
  }
}

.g-sidenav-show .sidenav .nav-link-text {
  transition: 0.3s ease;
  opacity: 1;
}

.g-sidenav-show .sidenav .nav-item .sidenav-mini-icon {
  opacity: 0;
}

.g-sidenav-pinned .sidenav {
  max-width: 250px !important;
}

.g-sidenav-pinned .sidenav .navbar-brand,
.g-sidenav-pinned .sidenav .navbar-heading {
  display: block;
}

.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .navbar-nav>.nav-item>.nav-link:after {
  content: "";
}

.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .nav-item .collapse .sidenav-normal {
  display: none !important;
}

.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .nav-link-text {
  opacity: 0;
}

.g-sidenav-hide .sidenav .navbar-nav>.nav-item>.nav-link:after {
  content: "";
}

.g-sidenav-hide .sidenav .nav-item .collapse .sidenav-normal {
  display: none !important;
}

.g-sidenav-hide .sidenav .nav-link-text {
  opacity: 0;
}

@media (max-width: 1199.98px) {
  .sidenav {
    transform: translateX(-62px);
  }

  .sidenav.fixed-left+.main-content {
    margin-left: 0 !important;
  }

  .g-sidenav-pinned .sidenav {
    transform: translateX(0);
  }
}

.sidenav-toggler-inner,
.sidenav-toggler-line {
  width: 18px;
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

  .sidenav-toggler-inner,
  .sidenav-toggler-line {
    transition: none;
  }
}

.sidenav-toggler-inner {
  position: relative;
}

.sidenav-toggler-inner:before {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  left: -11px;
  top: -14px;
  border-radius: 50%;
  transform: scale(0);
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .sidenav-toggler-inner:before {
    transition: none;
  }
}

.sidenav-toggler-line {
  height: 2px;
  background-color: #172b4d;
  display: block;
  position: relative;
}

.sidenav-toggler-line:not(:last-child) {
  margin-bottom: 3px;
}

.sidenav-toggler-dark .sidenav-toggler-line {
  background-color: #fff;
}

.sidenav-toggler {
  cursor: pointer;
}

.sidenav-toggler.active .sidenav-toggler-inner:before {
  transform: scale(1);
}

.sidenav-toggler.active .sidenav-toggler-line:first-child {
  width: 13px;
  transform: translateX(5px);
}

.sidenav-toggler.active .sidenav-toggler-line:last-child {
  width: 13px;
  transform: translateX(5px);
}

.navbar-search .input-group {
  border-radius: 2rem;
  border: 0 solid;
  transition: background-color 0.3s linear;
  transition-delay: 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .navbar-search .input-group {
    transition: none;
  }
}

.navbar-search .input-group .input-group-text {
  background-color: transparent;
  padding-left: 1rem;
  border: 0;
}

.navbar-search .form-control {
  width: 250px;
  background-color: transparent;
  border: 0;
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-search .form-control {
    transition: none;
  }
}

.navbar-search .focused .input-group .form-control {
  width: 380px;
}

.navbar-search .close {
  display: none;
}

.navbar-search-dark .input-group {
  background-color: rgba(23, 43, 77, 0.8);
  border-color: rgba(255, 255, 255, 0.6);
}

.navbar-search-dark .input-group-text {
  color: rgba(255, 255, 255, 0.6);
}

.navbar-search-dark .form-control {
  color: rgba(255, 255, 255, 0.9);
}

.navbar-search-dark .form-control::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.navbar-search-dark .focused .input-group {
  background-color: rgba(23, 43, 77, 0.9);
  border-color: rgba(255, 255, 255, 0.9);
}

.navbar-search-light .input-group {
  background-color: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 0, 0, 0.6);
}

.navbar-search-light .input-group-text {
  color: rgba(0, 0, 0, 0.6);
}

.navbar-search-light .form-control {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-search-light .form-control::placeholder {
  color: rgba(0, 0, 0, 0.6);
}

.navbar-search-light .focused .input-group {
  background-color: white;
  border-color: rgba(0, 0, 0, 0.9);
}

@media (max-width: 575.98px) {
  .navbar-search {
    display: none;
    width: 100%;
    transform: translateX(-150%);
    transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .navbar-search {
    transition: none;
  }
}

@media (max-width: 575.98px) {
  .navbar-search .form-group {
    width: 100%;
  }

  .navbar-search .form-control {
    width: auto;
  }

  .navbar-search .focused .input-group .form-control {
    width: auto;
  }

  .navbar-search .close {
    display: none;
    opacity: 0;
  }

  .navbar-search .close span {
    width: auto;
    height: auto;
  }

  .navbar-top .navbar-nav {
    transition: all 0.15s ease;
  }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .navbar-top .navbar-nav {
    transition: none;
  }
}

@media (max-width: 575.98px) {
  .g-navbar-search-showing .navbar-search .close {
    display: block;
  }

  .g-navbar-search-showing .navbar-top .navbar-nav {
    display: flex;
    opacity: 1;
    transform: translateX(150%);
  }

  .g-navbar-search-show .navbar-search {
    display: block;
  }

  .g-navbar-search-show .navbar-search .form-control {
    width: auto;
  }

  .g-navbar-search-show .navbar-search .close {
    color: white;
    position: absolute;
    top: 0;
    right: 0;
    width: 46px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
  }

  .g-navbar-search-show .navbar-top .navbar-nav {
    display: none;
  }

  .g-navbar-search-show .navbar-top .navbar-collapse {
    width: 100%;
  }

  .g-navbar-search-shown .navbar-search {
    transform: translateX(0);
  }

  .g-navbar-search-shown .navbar-search .close {
    display: block;
    opacity: 1;
  }

  .g-navbar-search-hiding .navbar-top .navbar-nav {
    display: flex;
    opacity: 0;
    transform: translateX(150%);
  }

  .g-navbar-search-hidden .navbar-top .navbar-nav {
    opacity: 1;
    transform: translateX(0);
  }
}

.navbar .dropdown-menu {
  opacity: 0;
  pointer-events: none;
  margin: 0;
}

.navbar .dropdown-menu-arrow:before {
  background: #fff;
  box-shadow: none;
  content: "";
  display: block;
  height: 12px;
  width: 12px;
  left: 20px;
  position: absolute;
  bottom: 100%;
  transform: rotate(-45deg) translateY(12px);
  z-index: -5;
  border-radius: 2px;
}

.navbar .dropdown-menu-right:before {
  right: 20px;
  left: auto;
}

.navbar:not(.navbar-nav-hover) .dropdown-menu.show {
  opacity: 1;
  pointer-events: auto;
  animation: show-navbar-dropdown 0.25s ease forwards;
}

.navbar:not(.navbar-nav-hover) .dropdown-menu.close {
  display: block;
  animation: hide-navbar-dropdown 0.15s ease backwards;
}

.navbar.navbar-nav-hover .dropdown-menu {
  opacity: 0;
  display: block;
  pointer-events: none;
  transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
  transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
}

.navbar.navbar-nav-hover .nav-item.dropdown:hover>.dropdown-menu {
  display: block;
  opacity: 1;
  pointer-events: auto;
  visibility: visible;
  transform: translate(0, 0);
  animation: none;
}

.navbar .dropdown-menu-inner {
  position: relative;
  padding: 1rem;
}

@keyframes show-navbar-dropdown {
  0% {
    opacity: 0;
    transform: translate(0, 10px) perspective(200px);
    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  }

  100% {
    transform: translate(0, 0);
    opacity: 1;
  }
}

@keyframes hide-navbar-dropdown {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate(0, 10px);
  }
}

.navbar-collapse-header {
  display: none;
}

@keyframes show-navbar-collapse {
  0% {
    opacity: 0;
    transform: scale(0.95);
    transform-origin: 100% 0;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes hide-navbar-collapse {
  from {
    opacity: 1;
    transform: scale(1);
    transform-origin: 100% 0;
  }

  to {
    opacity: 0;
    transform: scale(0.95);
  }
}

.navbar-top {
  border: 0;
  padding-left: 1rem;
  padding-right: 1rem;
}

.navbar-top .container,
.navbar-top .container-fluid,
.navbar-top .container-sm,
.navbar-top .container-md,
.navbar-top .container-lg,
.navbar-top .container-xl {
  padding-left: 15px;
  padding-right: 15px;
}

@media (min-width: 576px) {
  .navbar-top .navbar-brand {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .navbar-top .navbar-collapse {
    width: 100%;
  }

  .navbar-top .nav-item {
    position: static;
  }

  .navbar-top .nav-item .dropdown-menu {
    position: absolute;
    width: 94%;
    min-width: auto;
    left: 3%;
    right: auto;
  }
}

.navbar-top.border-bottom.navbar-dark {
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.navbar-top.border-bottom.navbar-light {
  border-color: rgba(0, 0, 0, 0.04) !important;
}

.sidenav-pinned .navbar-top .navbar-brand {
  display: none;
}

.nav-wrapper {
  padding: 1rem 0;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.nav-wrapper+.card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.nav-link {
  color: #525f7f;
}

.nav-link:hover {
  color: #5e72e4;
}

.nav-link i.ni {
  position: relative;
  top: 2px;
}

.nav-pills .nav-item:not(:last-child) {
  padding-right: 1rem;
}

.nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #5e72e4;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  transition: all 0.15s ease;
}

.nav-pills .nav-link:hover {
  color: #485fe0;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff;
  background-color: #5e72e4;
}

@media (max-width: 575.98px) {
  .nav-pills .nav-item {
    margin-bottom: 1rem;
  }
}

@media (max-width: 767.98px) {
  .nav-pills:not(.nav-pills-circle) .nav-item {
    padding-right: 0;
  }
}

.nav-pills-circle .nav-link {
  text-align: center;
  height: 60px;
  width: 60px;
  padding: 0;
  line-height: 60px;
  border-radius: 50%;
}

.nav-pills-circle .nav-link-icon i,
.nav-pills-circle .nav-link-icon svg {
  font-size: 1rem;
}

.page-item.active .page-link {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.page-item .page-link,
.page-item span {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 3px;
  border-radius: 50% !important;
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.pagination-lg .page-item .page-link,
.pagination-lg .page-item span {
  width: 46px;
  height: 46px;
  line-height: 46px;
}

.pagination-sm .page-item .page-link,
.pagination-sm .page-item span {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.popover {
  border: 0;
}

.popover-header {
  font-weight: 600;
}

.popover-primary {
  background-color: #5e72e4;
}

.popover-primary .popover-header {
  background-color: #5e72e4;
  color: #fff;
}

.popover-primary .popover-body {
  color: #fff;
}

.popover-primary .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-primary.bs-popover-top .arrow::after,
.popover-primary.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #5e72e4;
}

.popover-primary.bs-popover-right .arrow::after,
.popover-primary.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #5e72e4;
}

.popover-primary.bs-popover-bottom .arrow::after,
.popover-primary.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #5e72e4;
}

.popover-primary.bs-popover-left .arrow::after,
.popover-primary.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #5e72e4;
}

.popover-secondary {
  background-color: #f7fafc;
}

.popover-secondary .popover-header {
  background-color: #f7fafc;
  color: #212529;
}

.popover-secondary .popover-body {
  color: #212529;
}

.popover-secondary .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}

.popover-secondary.bs-popover-top .arrow::after,
.popover-secondary.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #f7fafc;
}

.popover-secondary.bs-popover-right .arrow::after,
.popover-secondary.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #f7fafc;
}

.popover-secondary.bs-popover-bottom .arrow::after,
.popover-secondary.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #f7fafc;
}

.popover-secondary.bs-popover-left .arrow::after,
.popover-secondary.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #f7fafc;
}

.popover-success {
  background-color: #2dce89;
}

.popover-success .popover-header {
  background-color: #2dce89;
  color: #fff;
}

.popover-success .popover-body {
  color: #fff;
}

.popover-success .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-success.bs-popover-top .arrow::after,
.popover-success.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #2dce89;
}

.popover-success.bs-popover-right .arrow::after,
.popover-success.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #2dce89;
}

.popover-success.bs-popover-bottom .arrow::after,
.popover-success.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #2dce89;
}

.popover-success.bs-popover-left .arrow::after,
.popover-success.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #2dce89;
}

.popover-info {
  background-color: #11cdef;
}

.popover-info .popover-header {
  background-color: #11cdef;
  color: #fff;
}

.popover-info .popover-body {
  color: #fff;
}

.popover-info .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-info.bs-popover-top .arrow::after,
.popover-info.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #11cdef;
}

.popover-info.bs-popover-right .arrow::after,
.popover-info.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #11cdef;
}

.popover-info.bs-popover-bottom .arrow::after,
.popover-info.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #11cdef;
}

.popover-info.bs-popover-left .arrow::after,
.popover-info.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #11cdef;
}

.popover-warning {
  background-color: #fb6340;
}

.popover-warning .popover-header {
  background-color: #fb6340;
  color: #fff;
}

.popover-warning .popover-body {
  color: #fff;
}

.popover-warning .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-warning.bs-popover-top .arrow::after,
.popover-warning.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #fb6340;
}

.popover-warning.bs-popover-right .arrow::after,
.popover-warning.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #fb6340;
}

.popover-warning.bs-popover-bottom .arrow::after,
.popover-warning.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #fb6340;
}

.popover-warning.bs-popover-left .arrow::after,
.popover-warning.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #fb6340;
}

.popover-danger {
  background-color: #f5365c;
}

.popover-danger .popover-header {
  background-color: #f5365c;
  color: #fff;
}

.popover-danger .popover-body {
  color: #fff;
}

.popover-danger .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-danger.bs-popover-top .arrow::after,
.popover-danger.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #f5365c;
}

.popover-danger.bs-popover-right .arrow::after,
.popover-danger.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #f5365c;
}

.popover-danger.bs-popover-bottom .arrow::after,
.popover-danger.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #f5365c;
}

.popover-danger.bs-popover-left .arrow::after,
.popover-danger.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #f5365c;
}

.popover-light {
  background-color: #adb5bd;
}

.popover-light .popover-header {
  background-color: #adb5bd;
  color: #fff;
}

.popover-light .popover-body {
  color: #fff;
}

.popover-light .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-light.bs-popover-top .arrow::after,
.popover-light.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #adb5bd;
}

.popover-light.bs-popover-right .arrow::after,
.popover-light.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #adb5bd;
}

.popover-light.bs-popover-bottom .arrow::after,
.popover-light.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #adb5bd;
}

.popover-light.bs-popover-left .arrow::after,
.popover-light.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #adb5bd;
}

.popover-dark {
  background-color: #212529;
}

.popover-dark .popover-header {
  background-color: #212529;
  color: #fff;
}

.popover-dark .popover-body {
  color: #fff;
}

.popover-dark .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-dark.bs-popover-top .arrow::after,
.popover-dark.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #212529;
}

.popover-dark.bs-popover-right .arrow::after,
.popover-dark.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #212529;
}

.popover-dark.bs-popover-bottom .arrow::after,
.popover-dark.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #212529;
}

.popover-dark.bs-popover-left .arrow::after,
.popover-dark.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #212529;
}

.popover-default {
  background-color: #172b4d;
}

.popover-default .popover-header {
  background-color: #172b4d;
  color: #fff;
}

.popover-default .popover-body {
  color: #fff;
}

.popover-default .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-default.bs-popover-top .arrow::after,
.popover-default.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #172b4d;
}

.popover-default.bs-popover-right .arrow::after,
.popover-default.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #172b4d;
}

.popover-default.bs-popover-bottom .arrow::after,
.popover-default.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #172b4d;
}

.popover-default.bs-popover-left .arrow::after,
.popover-default.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #172b4d;
}

.popover-white {
  background-color: #fff;
}

.popover-white .popover-header {
  background-color: #fff;
  color: #212529;
}

.popover-white .popover-body {
  color: #212529;
}

.popover-white .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}

.popover-white.bs-popover-top .arrow::after,
.popover-white.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #fff;
}

.popover-white.bs-popover-right .arrow::after,
.popover-white.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #fff;
}

.popover-white.bs-popover-bottom .arrow::after,
.popover-white.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #fff;
}

.popover-white.bs-popover-left .arrow::after,
.popover-white.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #fff;
}

.popover-neutral {
  background-color: #fff;
}

.popover-neutral .popover-header {
  background-color: #fff;
  color: #212529;
}

.popover-neutral .popover-body {
  color: #212529;
}

.popover-neutral .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}

.popover-neutral.bs-popover-top .arrow::after,
.popover-neutral.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #fff;
}

.popover-neutral.bs-popover-right .arrow::after,
.popover-neutral.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: #fff;
}

.popover-neutral.bs-popover-bottom .arrow::after,
.popover-neutral.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: #fff;
}

.popover-neutral.bs-popover-left .arrow::after,
.popover-neutral.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: #fff;
}

.popover-darker {
  background-color: black;
}

.popover-darker .popover-header {
  background-color: black;
  color: #fff;
}

.popover-darker .popover-body {
  color: #fff;
}

.popover-darker .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}

.popover-darker.bs-popover-top .arrow::after,
.popover-darker.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: black;
}

.popover-darker.bs-popover-right .arrow::after,
.popover-darker.bs-popover-auto[x-placement^="right"] .arrow::after {
  border-right-color: black;
}

.popover-darker.bs-popover-bottom .arrow::after,
.popover-darker.bs-popover-auto[x-placement^="bottom"] .arrow::after {
  border-bottom-color: black;
}

.popover-darker.bs-popover-left .arrow::after,
.popover-darker.bs-popover-auto[x-placement^="left"] .arrow::after {
  border-left-color: black;
}

.progress-wrapper {
  position: relative;
  padding-top: 1.5rem;
}

.progress {
  height: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.progress .sr-only {
  width: auto;
  height: 20px;
  margin: 0 0 0 30px;
  left: 0;
  clip: auto;
  line-height: 20px;
  font-size: 13px;
}

.progress-sm {
  height: 5px;
}

.progress-xs {
  height: 3px;
}

.progress-heading {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px;
  padding: 0;
}

.progress-bar {
  box-shadow: none;
  border-radius: 0;
  height: auto;
}

.progress-info {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.progress-label span {
  display: inline-block;
  color: #5e72e4;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  background: rgba(94, 114, 228, 0.1);
  padding: 0.25rem 1rem;
  border-radius: 30px;
}

.progress-percentage {
  text-align: right;
}

.progress-percentage span {
  display: inline-block;
  color: #8898aa;
  font-size: 0.875rem;
  font-weight: 600;
}

.rtl.g-sidenav-pinned .sidenav+.main-content {
  margin-right: 250px;
}

.rtl .sidenav+.main-content {
  margin-right: 62px;
}

.rtl .sidenav .navbar-nav {
  padding-right: 0;
}

.rtl .sidenav .navbar-nav .nav-link>i {
  min-width: auto;
  margin-left: 1rem;
}

.rtl .sidenav .navbar-nav .nav-link[data-toggle="collapse"]:after {
  margin-right: auto;
  margin-left: 0;
  margin-left: initial;
  transform: rotate(180deg);
}

.rtl .sidenav .navbar-nav .nav-link[data-toggle="collapse"][aria-expanded="true"]:after {
  transform: rotate(90deg) !important;
}

.rtl .sidenav .navbar-nav .nav .nav-link {
  padding-right: 15px;
}

.rtl .sidenav .sidenav-toggler.active .sidenav-toggler-line:first-child {
  transform: translateX(0);
}

.rtl .sidenav .sidenav-toggler.active .sidenav-toggler-line:last-child {
  transform: translateX(0);
}

.rtl .sidenav .navbar-heading {
  text-align: right;
}

.rtl .sidenav .scrollbar-inner {
  direction: ltr;
  direction: initial;
}

.rtl .sidenav .scrollbar-inner .navbar-nav {
  direction: rtl;
}

.rtl .sidenav .navbar-heading .docs-mini {
  padding-left: 0;
  padding-right: 3px;
}

.rtl .navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-normal {
  padding-right: 8px;
}

.rtl .dropdown-menu-left {
  text-align: right;
}

.rtl .card .card-body {
  text-align: right;
}

@media (max-width: 1199.98px) {
  .rtl .sidenav {
    transform: translateX(62px);
  }

  .rtl .sidenav+.main-content {
    margin-right: 0 !important;
  }

  .rtl .sidenav-toggler.active .sidenav-toggler-line:first-child {
    transform: translateX(0);
  }

  .rtl .sidenav-toggler.active .sidenav-toggler-line:last-child {
    transform: translateX(0);
  }

  .rtl.g-sidenav-pinned .sidenav {
    transform: translateX(0) !important;
  }
}

@media (max-width: 576px) {
  .rtl .navbar-expand .navbar-nav .nav-link {
    padding-left: 0;
  }

  .rtl.g-navbar-search-show .navbar-search .close {
    left: 0;
    right: auto;
  }

  .rtl .navbar-search {
    transform: translateX(150%);
  }

  .rtl.g-navbar-search-shown .navbar-search {
    transform: translateX(0);
  }
}

.separator {
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  width: 100%;
  height: 150px;
  transform: translateZ(0);
  overflow: hidden;
  pointer-events: none;
}

.separator svg {
  position: absolute;
  pointer-events: none;
}

.separator-top {
  top: 0;
  bottom: auto;
}

.separator-top svg {
  top: 0;
}

.separator-bottom {
  top: auto;
  bottom: 0;
}

.separator-bottom svg {
  bottom: 0;
}

.separator-inverse {
  transform: rotate(180deg);
}

.separator-skew {
  height: 60px;
}

@media (min-width: 1200px) {
  .separator-skew {
    height: 70px;
  }
}

.section-nucleo-icons {
  --icon-size: 5rem;
  --icon-sm-size: 3.75rem;
  --gutter: 7rem;
}

.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 100%;
  height: 360px;
  margin: 0 auto;
  z-index: 1;
}

.section-nucleo-icons .icons-container i {
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  z-index: 1;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  transition: all 0.2s cubic-bezier(0.25, 0.65, 0.9, 0.75);
}

.section-nucleo-icons .icons-container i.icon {
  width: var(--icon-size);
  height: var(--icon-size);
  font-size: 1.7em;
}

.section-nucleo-icons .icons-container i.icon-sm {
  width: var(--icon-sm-size);
  height: var(--icon-sm-size);
  font-size: 1.5em;
}

.section-nucleo-icons .icons-container i:nth-child(1) {
  font-size: 42px;
  color: #fb6340;
  z-index: 2;
}

.section-nucleo-icons .icons-container i {
  opacity: 1;
}

.section-nucleo-icons .icons-container i:nth-child(1) {
  left: 50%;
  top: 50%;
  font-size: 42px;
  color: #fb6340;
}

.section-nucleo-icons .icons-container i:nth-child(2) {
  left: calc(50% + (var(--gutter) * 1.7));
  top: 50%;
}

.section-nucleo-icons .icons-container i:nth-child(3) {
  left: calc(50% + var(--gutter));
  top: calc(50% + var(--gutter));
}

.section-nucleo-icons .icons-container i:nth-child(4) {
  left: calc(50% + var(--gutter));
  top: calc(50% - var(--gutter));
}

.section-nucleo-icons .icons-container i:nth-child(5) {
  left: calc(50% + (var(--gutter) * 4));
  top: 50%;
}

.section-nucleo-icons .icons-container i:nth-child(6) {
  left: calc(50% + (var(--gutter) * 2.7));
  top: calc(50% + (var(--gutter) * 1.5));
}

.section-nucleo-icons .icons-container i:nth-child(7) {
  left: calc(50% + (var(--gutter) * 2.7));
  top: calc(50% - (var(--gutter) * 1.5));
}

.section-nucleo-icons .icons-container i:nth-child(8) {
  left: calc(50% - (var(--gutter) * 1.7));
  top: 50%;
}

.section-nucleo-icons .icons-container i:nth-child(9) {
  left: calc(50% - var(--gutter));
  top: calc(50% + var(--gutter));
}

.section-nucleo-icons .icons-container i:nth-child(10) {
  left: calc(50% - var(--gutter));
  top: calc(50% - var(--gutter));
}

.section-nucleo-icons .icons-container i:nth-child(11) {
  left: calc(50% - (var(--gutter) * 4));
  top: 50%;
}

.section-nucleo-icons .icons-container i:nth-child(12) {
  left: calc(50% - (var(--gutter) * 2.7));
  top: calc(50% + (var(--gutter) * 1.5));
}

.section-nucleo-icons .icons-container i:nth-child(13) {
  left: calc(50% - (var(--gutter) * 2.7));
  top: calc(50% - (var(--gutter) * 1.5));
}

.home-child .sidebar-icon i {
  font-size: 1.3rem;
}

.sidebar-icon-img {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
  object-fit: contain;
  flex-shrink: 0;
}

.navbar-dark .sidebar-icon-img {
  filter: none;
  opacity: 0.85;
}

.sidebar-icon {
  width: 1.75rem;
  /* matches Argon nav icon column */
  min-width: 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
}

.sidebar-icon-img {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
}

.shortcut-media {
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .shortcut-media {
    transition: none;
  }
}

.shortcut-item {
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
}

.shortcut-item small {
  display: block;
  margin-top: 0.75rem;
  font-size: 0.8125rem;
  font-weight: 600;
}

.shortcut-item:hover .shortcut-media {
  transform: scale(1.1);
}

.table thead th {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid #e9ecef;
}

.table th {
  font-weight: 600;
}

.table td .progress {
  height: 3px;
  width: 120px;
  margin: 0;
}

.table td,
.table th {
  font-size: 0.8125rem;
  white-space: nowrap;
}

.table.align-items-center td,
.table.align-items-center th {
  vertical-align: middle;
}

.table .thead-dark th {
  background-color: #1c345d;
  color: #4d7bca;
}

.table .thead-dark th a {
  color: #4d7bca;
}

.table .thead-light th {
  background-color: #f6f9fc;
  color: #000000;
}

.table .thead-light th a {
  color: #8898aa;
}

.table-hover tr {
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .table-hover tr {
    transition: none;
  }
}

.table-flush td,
.table-flush th {
  border-left: 0;
  border-right: 0;
}

.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
  border-top: 0;
}

.table-flush tbody tr:last-child td,
.table-flush tbody tr:last-child th {
  border-bottom: 0;
}

.card .table {
  margin-bottom: 0;
}

.card .table td,
.card .table th {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.table .custom-toggle {
  display: block;
}

.table-action {
  font-size: 0.875rem;
  color: #adb5bd;
  margin: 0 0.25rem;
}

.table-action:hover {
  color: #919ca6;
}

.table-action-delete:hover {
  color: #f5365c;
}

.table-dark .table-action {
  color: #4d7bca;
}

.table [data-sort] {
  cursor: pointer;
}

.table .thead-dark [data-sort]::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  margin-left: 0.25rem;
}

.table .thead-light [data-sort]::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  margin-left: 0.25rem;
}

.timeline {
  position: relative;
}

.timeline:before {
  content: "";
  position: absolute;
  top: 0;
  left: 1rem;
  height: 100%;
  border-right: 2px solid #e9ecef;
}

[data-timeline-axis-style="dashed"]:before {
  border-right-style: dashed !important;
}

[data-timeline-axis-style="dotted"]:before {
  border-right-style: dotted !important;
}

.timeline-block {
  position: relative;
  margin: 2em 0;
}

.timeline-block:after {
  content: "";
  display: table;
  clear: both;
}

.timeline-block:first-child {
  margin-top: 0;
}

.timeline-block:last-child {
  margin-bottom: 0;
}

.timeline-step {
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  left: 0;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  text-align: center;
  transform: translateX(-50%);
  font-size: 1rem;
  font-weight: 600;
  z-index: 1;
}

.timeline-step svg,
.timeline-step i {
  line-height: 1.4;
}

.timeline-step-icon {
  background: #fff;
  border: 2px solid #e9ecef;
}

.timeline-step-xs {
  width: 17px;
  height: 17px;
  font-size: 0.75rem;
}

.timeline-step-sm {
  width: 23px;
  height: 23px;
  font-size: 0.75rem;
}

.timeline-step-lg {
  width: 47px;
  height: 47px;
  font-size: 1.75rem;
}

.timeline-content {
  position: relative;
  margin-left: 60px;
  padding-top: 0.5rem;
  position: relative;
  top: -6px;
}

.timeline-content:after {
  content: "";
  display: table;
  clear: both;
}

.timeline-body {
  padding: 1.5rem;
}

@media (min-width: 992px) {
  .timeline:before {
    left: 50%;
    margin-left: -2px;
  }

  .timeline-step {
    left: 50%;
  }

  .timeline-content {
    width: 38%;
  }

  .timeline-body {
    padding: 1.5rem;
  }

  .timeline-block:nth-child(even) .timeline-content {
    float: right;
  }

  [data-timeline-axis-color="primary"]:before {
    border-color: #5e72e4;
  }

  [data-timeline-axis-color="secondary"]:before {
    border-color: #f7fafc;
  }

  [data-timeline-axis-color="success"]:before {
    border-color: #2dce89;
  }

  [data-timeline-axis-color="info"]:before {
    border-color: #11cdef;
  }

  [data-timeline-axis-color="warning"]:before {
    border-color: #fb6340;
  }

  [data-timeline-axis-color="danger"]:before {
    border-color: #f5365c;
  }

  [data-timeline-axis-color="light"]:before {
    border-color: #adb5bd;
  }

  [data-timeline-axis-color="dark"]:before {
    border-color: #212529;
  }

  [data-timeline-axis-color="default"]:before {
    border-color: #172b4d;
  }

  [data-timeline-axis-color="white"]:before {
    border-color: #fff;
  }

  [data-timeline-axis-color="neutral"]:before {
    border-color: #fff;
  }

  [data-timeline-axis-color="darker"]:before {
    border-color: black;
  }
}

.timeline-one-side:before {
  left: 1rem;
}

.timeline-one-side .timeline-step {
  left: 1rem;
}

.timeline-one-side .timeline-content {
  width: auto;
}

@media (min-width: 992px) {
  .timeline-one-side .timeline-content {
    max-width: 30rem;
  }
}

.timeline-one-side .timeline-block:nth-child(even) .timeline-content {
  float: none;
}

p {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.7;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.7;
  margin-top: 1.5rem;
}

.lead+.btn-wrapper {
  margin-top: 3rem;
}

.description {
  font-size: 0.875rem;
}

article h4:not(:first-child),
article h5:not(:first-child) {
  margin-top: 3rem;
}

article h4,
article h5 {
  margin-bottom: 1.5rem;
}

article figure {
  margin: 3rem 0;
}

article h5+figure {
  margin-top: 0;
}

.display-1 span,
.display-2 span,
.display-3 span,
.display-4 span {
  display: block;
  font-weight: 300;
}

h1>a,
h2>a,
h3>a,
h4>a,
h5>a,
h6>a {
  color: inherit;
}

.heading {
  letter-spacing: 0.025em;
  font-size: 0.95rem;
  text-transform: uppercase;
  font-weight: 600;
}

.heading-small {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.heading-title {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}

.heading-section {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}

.heading-section img {
  display: block;
  width: 72px;
  height: 72px;
  margin-bottom: 1.5rem;
}

.heading-section.text-center img {
  margin-left: auto;
  margin-right: auto;
}

.surtitle {
  text-transform: uppercase;
  color: #8898aa;
  letter-spacing: 2px;
  margin-bottom: 0;
}

.bg-blue {
  background-color: #5e72e4 !important;
}

a.bg-blue:hover,
a.bg-blue:focus,
button.bg-blue:hover,
button.bg-blue:focus {
  background-color: #324cdd !important;
}

.bg-indigo {
  background-color: #5603ad !important;
}

a.bg-indigo:hover,
a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  background-color: #3d027b !important;
}

.bg-purple {
  background-color: #8965e0 !important;
}

a.bg-purple:hover,
a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  background-color: #683bd7 !important;
}

.bg-pink {
  background-color: #f3a4b5 !important;
}

a.bg-pink:hover,
a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  background-color: #ed7790 !important;
}

.bg-red {
  background-color: #f5365c !important;
}

a.bg-red:hover,
a.bg-red:focus,
button.bg-red:hover,
button.bg-red:focus {
  background-color: #ec0c38 !important;
}

.bg-orange {
  background-color: #fb6340 !important;
}

a.bg-orange:hover,
a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  background-color: #fa3a0e !important;
}

.bg-yellow {
  background-color: #ffd600 !important;
}

a.bg-yellow:hover,
a.bg-yellow:focus,
button.bg-yellow:hover,
button.bg-yellow:focus {
  background-color: #ccab00 !important;
}

.bg-green {
  background-color: #2dce89 !important;
}

a.bg-green:hover,
a.bg-green:focus,
button.bg-green:hover,
button.bg-green:focus {
  background-color: #24a46d !important;
}

.bg-teal {
  background-color: #11cdef !important;
}

a.bg-teal:hover,
a.bg-teal:focus,
button.bg-teal:hover,
button.bg-teal:focus {
  background-color: #0da5c0 !important;
}

.bg-cyan {
  background-color: #2bffc6 !important;
}

a.bg-cyan:hover,
a.bg-cyan:focus,
button.bg-cyan:hover,
button.bg-cyan:focus {
  background-color: #00f7b5 !important;
}

.bg-white {
  background-color: #fff !important;
}

a.bg-white:hover,
a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-gray {
  background-color: #8898aa !important;
}

a.bg-gray:hover,
a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  background-color: #6a7e95 !important;
}

.bg-gray-dark {
  background-color: #32325d !important;
}

a.bg-gray-dark:hover,
a.bg-gray-dark:focus,
button.bg-gray-dark:hover,
button.bg-gray-dark:focus {
  background-color: #20203c !important;
}

.bg-light {
  background-color: #ced4da !important;
}

a.bg-light:hover,
a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #b1bbc4 !important;
}

.bg-lighter {
  background-color: #e9ecef !important;
}

a.bg-lighter:hover,
a.bg-lighter:focus,
button.bg-lighter:hover,
button.bg-lighter:focus {
  background-color: #cbd3da !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.bg-gradient-blue {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-indigo {
  background: linear-gradient(87deg, #5603ad 0, #9d03ad 100%) !important;
}

.bg-gradient-purple {
  background: linear-gradient(87deg, #8965e0 0, #bc65e0 100%) !important;
}

.bg-gradient-pink {
  background: linear-gradient(87deg, #f3a4b5 0, #f3b4a4 100%) !important;
}

.bg-gradient-red {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-orange {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-yellow {
  background: linear-gradient(87deg, #ffd600 0, #beff00 100%) !important;
}

.bg-gradient-green {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-teal {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-cyan {
  background: linear-gradient(87deg, #2bffc6 0, #2be0ff 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-gray {
  background: linear-gradient(87deg, #8898aa 0, #888aaa 100%) !important;
}

.bg-gradient-gray-dark {
  background: linear-gradient(87deg, #32325d 0, #44325d 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #ced4da 0, #cecfda 100%) !important;
}

.bg-gradient-lighter {
  background: linear-gradient(87deg, #e9ecef 0, #e9eaef 100%) !important;
}

.bg-translucent-primary {
  background-color: rgba(63, 87, 223, 0.6) !important;
}

a.bg-translucent-primary:hover,
a.bg-translucent-primary:focus,
button.bg-translucent-primary:hover,
button.bg-translucent-primary:focus {
  background-color: rgba(42, 68, 219, 0.6) !important;
}

.bg-translucent-secondary {
  background-color: rgba(221, 234, 242, 0.6) !important;
}

a.bg-translucent-secondary:hover,
a.bg-translucent-secondary:focus,
button.bg-translucent-secondary:hover,
button.bg-translucent-secondary:focus {
  background-color: rgba(202, 222, 235, 0.6) !important;
}

.bg-translucent-success {
  background-color: rgba(39, 177, 118, 0.6) !important;
}

a.bg-translucent-success:hover,
a.bg-translucent-success:focus,
button.bg-translucent-success:hover,
button.bg-translucent-success:focus {
  background-color: rgba(34, 156, 104, 0.6) !important;
}

.bg-translucent-info {
  background-color: rgba(14, 177, 206, 0.6) !important;
}

a.bg-translucent-info:hover,
a.bg-translucent-info:focus,
button.bg-translucent-info:hover,
button.bg-translucent-info:focus {
  background-color: rgba(12, 156, 183, 0.6) !important;
}

.bg-translucent-warning {
  background-color: rgba(250, 70, 29, 0.6) !important;
}

a.bg-translucent-warning:hover,
a.bg-translucent-warning:focus,
button.bg-translucent-warning:hover,
button.bg-translucent-warning:focus {
  background-color: rgba(249, 51, 5, 0.6) !important;
}

.bg-translucent-danger {
  background-color: rgba(243, 20, 64, 0.6) !important;
}

a.bg-translucent-danger:hover,
a.bg-translucent-danger:focus,
button.bg-translucent-danger:hover,
button.bg-translucent-danger:focus {
  background-color: rgba(227, 11, 54, 0.6) !important;
}

.bg-translucent-light {
  background-color: rgba(153, 163, 173, 0.6) !important;
}

a.bg-translucent-light:hover,
a.bg-translucent-light:focus,
button.bg-translucent-light:hover,
button.bg-translucent-light:focus {
  background-color: rgba(139, 150, 162, 0.6) !important;
}

.bg-translucent-dark {
  background-color: rgba(17, 19, 21, 0.6) !important;
}

a.bg-translucent-dark:hover,
a.bg-translucent-dark:focus,
button.bg-translucent-dark:hover,
button.bg-translucent-dark:focus {
  background-color: rgba(6, 6, 7, 0.6) !important;
}

.bg-translucent-default {
  background-color: rgba(15, 28, 50, 0.6) !important;
}

a.bg-translucent-default:hover,
a.bg-translucent-default:focus,
button.bg-translucent-default:hover,
button.bg-translucent-default:focus {
  background-color: rgba(9, 17, 30, 0.6) !important;
}

.bg-translucent-white {
  background-color: rgba(237, 237, 237, 0.6) !important;
}

a.bg-translucent-white:hover,
a.bg-translucent-white:focus,
button.bg-translucent-white:hover,
button.bg-translucent-white:focus {
  background-color: rgba(224, 224, 224, 0.6) !important;
}

.bg-translucent-neutral {
  background-color: rgba(237, 237, 237, 0.6) !important;
}

a.bg-translucent-neutral:hover,
a.bg-translucent-neutral:focus,
button.bg-translucent-neutral:hover,
button.bg-translucent-neutral:focus {
  background-color: rgba(224, 224, 224, 0.6) !important;
}

.bg-translucent-darker {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

a.bg-translucent-darker:hover,
a.bg-translucent-darker:focus,
button.bg-translucent-darker:hover,
button.bg-translucent-darker:focus {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.section-primary {
  background-color: #f8f9fe !important;
}

a.section-primary:hover,
a.section-primary:focus,
button.section-primary:hover,
button.section-primary:focus {
  background-color: #cbd3f8 !important;
}

.section-secondary {
  background-color: #f7fafc !important;
}

a.section-secondary:hover,
a.section-secondary:focus,
button.section-secondary:hover,
button.section-secondary:focus {
  background-color: #d2e3ee !important;
}

.section-light {
  background-color: #ced4da !important;
}

a.section-light:hover,
a.section-light:focus,
button.section-light:hover,
button.section-light:focus {
  background-color: #b1bbc4 !important;
}

.section-dark {
  background-color: #212529 !important;
}

a.section-dark:hover,
a.section-dark:focus,
button.section-dark:hover,
button.section-dark:focus {
  background-color: #0a0c0d !important;
}

.section-darker {
  background-color: black !important;
}

a.section-darker:hover,
a.section-darker:focus,
button.section-darker:hover,
button.section-darker:focus {
  background-color: black !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.fill-primary {
  fill: #5e72e4;
}

.stroke-primary {
  stroke: #5e72e4;
}

.fill-secondary {
  fill: #f7fafc;
}

.stroke-secondary {
  stroke: #f7fafc;
}

.fill-success {
  fill: #2dce89;
}

.stroke-success {
  stroke: #2dce89;
}

.fill-info {
  fill: #11cdef;
}

.stroke-info {
  stroke: #11cdef;
}

.fill-warning {
  fill: #fb6340;
}

.stroke-warning {
  stroke: #fb6340;
}

.fill-danger {
  fill: #f5365c;
}

.stroke-danger {
  stroke: #f5365c;
}

.fill-light {
  fill: #adb5bd;
}

.stroke-light {
  stroke: #adb5bd;
}

.fill-dark {
  fill: #212529;
}

.stroke-dark {
  stroke: #212529;
}

.fill-default {
  fill: #172b4d;
}

.stroke-default {
  stroke: #172b4d;
}

.fill-white {
  fill: #fff;
}

.stroke-white {
  stroke: #fff;
}

.fill-neutral {
  fill: #fff;
}

.stroke-neutral {
  stroke: #fff;
}

.fill-darker {
  fill: black;
}

.stroke-darker {
  stroke: black;
}

.fill-opacity-8 {
  fill-opacity: 0.8;
}

.blur--hover {
  position: relative;
}

.blur--hover .blur-item {
  transition: 1s cubic-bezier(0.19, 1, 0.22, 1);
  will-change: transform;
  filter: blur(0);
  opacity: 1;
}

.blur--hover .blur-hidden {
  position: absolute;
  top: calc(50% + 7px);
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.15s ease;
  z-index: 100;
}

.blur--hover:hover .blur-item {
  opacity: 0.8;
  filter: blur(10px);
  transform: scale(0.95);
  z-index: 1;
}

.blur--hover:hover .blur-hidden {
  opacity: 1;
  top: 50%;
}

.floating {
  animation: floating 3s ease infinite;
  will-change: transform;
}

.floating:hover {
  animation-play-state: paused;
}

.floating-lg {
  animation: floating-lg 3s ease infinite;
}

.floating-sm {
  animation: floating-sm 3s ease infinite;
}

@keyframes floating-lg {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(15px);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes floating {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes floating-sm {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(5px);
  }

  100% {
    transform: translateY(0px);
  }
}

.floatfix:before,
.floatfix:after {
  content: "";
  display: table;
}

.floatfix:after {
  clear: both;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-8 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-1 {
  top: 0.25rem;
}

.right-1 {
  right: 0.25rem;
}

.bottom-1 {
  bottom: 0.25rem;
}

.left-1 {
  left: 0.25rem;
}

.top-2 {
  top: 0.5rem;
}

.right-2 {
  right: 0.5rem;
}

.bottom-2 {
  bottom: 0.5rem;
}

.left-2 {
  left: 0.5rem;
}

.top-3 {
  top: 1rem;
}

.right-3 {
  right: 1rem;
}

.bottom-3 {
  bottom: 1rem;
}

.left-3 {
  left: 1rem;
}

.top-4 {
  top: 1.5rem;
}

.right-4 {
  right: 1.5rem;
}

.bottom-4 {
  bottom: 1.5rem;
}

.left-4 {
  left: 1.5rem;
}

.top-5 {
  top: 3rem;
}

.right-5 {
  right: 3rem;
}

.bottom-5 {
  bottom: 3rem;
}

.left-5 {
  left: 3rem;
}

.top--9 {
  top: -10rem;
}

.right--9 {
  right: -10rem;
}

.bottom--9 {
  bottom: -10rem;
}

.left--9 {
  left: -10rem;
}

.top--8 {
  top: -8rem;
}

.right--8 {
  right: -8rem;
}

.bottom--8 {
  bottom: -8rem;
}

.left--8 {
  left: -8rem;
}

.top--7 {
  top: -6rem;
}

.right--7 {
  right: -6rem;
}

.bottom--7 {
  bottom: -6rem;
}

.left--7 {
  left: -6rem;
}

.top--6 {
  top: -4.5rem;
}

.right--6 {
  right: -4.5rem;
}

.bottom--6 {
  bottom: -4.5rem;
}

.left--6 {
  left: -4.5rem;
}

.top--5 {
  top: -3rem;
}

.right--5 {
  right: -3rem;
}

.bottom--5 {
  bottom: -3rem;
}

.left--5 {
  left: -3rem;
}

.top--4 {
  top: -1.5rem;
}

.right--4 {
  right: -1.5rem;
}

.bottom--4 {
  bottom: -1.5rem;
}

.left--4 {
  left: -1.5rem;
}

.top--3 {
  top: -1rem;
}

.right--3 {
  right: -1rem;
}

.bottom--3 {
  bottom: -1rem;
}

.left--3 {
  left: -1rem;
}

.top--2 {
  top: -0.5rem;
}

.right--2 {
  right: -0.5rem;
}

.bottom--2 {
  bottom: -0.5rem;
}

.left--2 {
  left: -0.5rem;
}

.top--1 {
  top: -0.25rem;
}

.right--1 {
  right: -0.25rem;
}

.bottom--1 {
  bottom: -0.25rem;
}

.left--1 {
  left: -0.25rem;
}

.top-6 {
  top: 4.5rem;
}

.right-6 {
  right: 4.5rem;
}

.bottom-6 {
  bottom: 4.5rem;
}

.left-6 {
  left: 4.5rem;
}

.top-7 {
  top: 6rem;
}

.right-7 {
  right: 6rem;
}

.bottom-7 {
  bottom: 6rem;
}

.left-7 {
  left: 6rem;
}

.top-8 {
  top: 8rem;
}

.right-8 {
  right: 8rem;
}

.bottom-8 {
  bottom: 8rem;
}

.left-8 {
  left: 8rem;
}

.top-9 {
  top: 10rem;
}

.right-9 {
  right: 10rem;
}

.bottom-9 {
  bottom: 10rem;
}

.left-9 {
  left: 10rem;
}

.center {
  left: 50%;
  transform: translateX(-50%);
}

[class*="shadow"] {
  transition: all 0.15s ease;
}

.shadow-sm--hover:hover {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow--hover:hover {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg--hover:hover {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none--hover:hover {
  box-shadow: none !important;
}

.h-100vh {
  height: 100vh !important;
}

.row.row-grid>[class*="col-"]+[class*="col-"] {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .row.row-grid>[class*="col-lg-"]+[class*="col-lg-"] {
    margin-top: 0;
  }
}

@media (min-width: 768px) {
  .row.row-grid>[class*="col-md-"]+[class*="col-md-"] {
    margin-top: 0;
  }
}

@media (min-width: 576px) {
  .row.row-grid>[class*="col-sm-"]+[class*="col-sm-"] {
    margin-top: 0;
  }
}

.row-grid+.row-grid {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .mt--100 {
    margin-top: -100px !important;
  }

  .mr--100 {
    margin-right: -100px !important;
  }

  .mb--100 {
    margin-bottom: -100px !important;
  }

  .ml--100 {
    margin-left: -100px !important;
  }

  .mt--150 {
    margin-top: -150px !important;
  }

  .mb--150 {
    margin-bottom: -150px !important;
  }

  .mt--200 {
    margin-top: -200px !important;
  }

  .mb--200 {
    margin-bottom: -200px !important;
  }

  .mt--300 {
    margin-top: -300px !important;
  }

  .mb--300 {
    margin-bottom: -300px !important;
  }

  .pt-100 {
    padding-top: 100px !important;
  }

  .pb-100 {
    padding-bottom: 100px !important;
  }

  .pt-150 {
    padding-top: 150px !important;
  }

  .pb-150 {
    padding-bottom: 150px !important;
  }

  .pt-200 {
    padding-top: 200px !important;
  }

  .pb-200 {
    padding-bottom: 200px !important;
  }

  .pt-250 {
    padding-top: 250px !important;
  }

  .pb-250 {
    padding-bottom: 250px !important;
  }

  .pt-300 {
    padding-top: 300px !important;
  }

  .pb-300 {
    padding-bottom: 300px !important;
  }
}

.font-weight-300 {
  font-weight: 300 !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.text-underline {
  text-decoration: underline;
}

.text-through {
  text-decoration: line-through;
}

.text-xs {
  font-size: 0.75rem !important;
}

.text-sm {
  font-size: 0.875rem !important;
}

.text-lg {
  font-size: 1.25rem !important;
}

.text-xl {
  font-size: 1.5rem !important;
}

.lh-100 {
  line-height: 1;
}

.lh-110 {
  line-height: 1.1;
}

.lh-120 {
  line-height: 1.2;
}

.lh-130 {
  line-height: 1.3;
}

.lh-140 {
  line-height: 1.4;
}

.lh-150 {
  line-height: 1.5;
}

.lh-160 {
  line-height: 1.6;
}

.lh-170 {
  line-height: 1.7;
}

.lh-180 {
  line-height: 1.8;
}

.ls-1 {
  letter-spacing: 0.0625rem;
}

.ls-15 {
  letter-spacing: 0.09375rem;
}

.ls-2 {
  letter-spacing: 0.125rem;
}

.text-blue {
  color: #5e72e4 !important;
}

a.text-blue:hover,
a.text-blue:focus {
  color: #233dd2 !important;
}

.text-indigo {
  color: #5603ad !important;
}

a.text-indigo:hover,
a.text-indigo:focus {
  color: #310262 !important;
}

.text-purple {
  color: #8965e0 !important;
}

a.text-purple:hover,
a.text-purple:focus {
  color: #5a2acf !important;
}

.text-pink {
  color: #f3a4b5 !important;
}

a.text-pink:hover,
a.text-pink:focus {
  color: #ea607e !important;
}

.text-red {
  color: #f5365c !important;
}

a.text-red:hover,
a.text-red:focus {
  color: #d40b33 !important;
}

.text-orange {
  color: #fb6340 !important;
}

a.text-orange:hover,
a.text-orange:focus {
  color: #ea3005 !important;
}

.text-yellow {
  color: #ffd600 !important;
}

a.text-yellow:hover,
a.text-yellow:focus {
  color: #b39600 !important;
}

.text-green {
  color: #2dce89 !important;
}

a.text-green:hover,
a.text-green:focus {
  color: #1f8f5f !important;
}

.text-teal {
  color: #11cdef !important;
}

a.text-teal:hover,
a.text-teal:focus {
  color: #0b90a8 !important;
}

.text-cyan {
  color: #2bffc6 !important;
}

a.text-cyan:hover,
a.text-cyan:focus {
  color: #00dea2 !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover,
a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-gray {
  color: #8898aa !important;
}

a.text-gray:hover,
a.text-gray:focus {
  color: #607286 !important;
}

.text-gray-dark {
  color: #32325d !important;
}

a.text-gray-dark:hover,
a.text-gray-dark:focus {
  color: #17172b !important;
}

.text-light {
  color: #ced4da !important;
}

a.text-light:hover,
a.text-light:focus {
  color: #a2aeb9 !important;
}

.text-lighter {
  color: #e9ecef !important;
}

a.text-lighter:hover,
a.text-lighter:focus {
  color: #bdc6cf !important;
}

@media (min-width: 992px) {
  .transform-perspective-right {
    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);
  }

  .transform-perspective-left {
    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);
  }
}

.datepicker {
  border-radius: 0.375rem;
  direction: ltr;
}

.datepicker-inline {
  width: 220px;
}

.datepicker-rtl {
  direction: rtl;
}

.datepicker-rtl.dropdown-menu {
  left: auto;
}

.datepicker-rtl table tr td span {
  float: right;
}

.datepicker-dropdown {
  top: 0;
  left: 0;
  padding: 20px 22px;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.datepicker-dropdown.datepicker-orient-left:before {
  left: 6px;
}

.datepicker-dropdown.datepicker-orient-left:after {
  left: 7px;
}

.datepicker-dropdown.datepicker-orient-right:before {
  right: 6px;
}

.datepicker-dropdown.datepicker-orient-right:after {
  right: 7px;
}

.datepicker-dropdown.datepicker-orient-bottom:before {
  top: -7px;
}

.datepicker-dropdown.datepicker-orient-bottom:after {
  top: -6px;
}

.datepicker-dropdown.datepicker-orient-top:before {
  bottom: -7px;
  border-bottom: 0;
  border-top: 7px solid white;
}

.datepicker-dropdown.datepicker-orient-top:after {
  bottom: -6px;
  border-bottom: 0;
  border-top: 6px solid #fff;
}

.datepicker table {
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}

.datepicker table tr td {
  border-radius: 50%;
}

.datepicker table tr th {
  border-radius: 0.375rem;
  font-weight: 500;
}

.datepicker table tr td,
.datepicker table tr th {
  transition: all 0.15s ease;
  width: 36px;
  height: 36px;
  border: none;
  text-align: center;
  font-size: 0.875rem;
}

.table-striped .datepicker table tr td,
.table-striped .datepicker table tr th {
  background-color: transparent;
}

.datepicker table tr td.old,
.datepicker table tr td.new {
  color: #adb5bd;
}

.datepicker table tr td.day:hover,
.datepicker table tr td.focused {
  background: white;
  cursor: pointer;
}

.datepicker table tr td.disabled,
.datepicker table tr td.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}

.datepicker table tr td.highlighted {
  border-radius: 0;
}

.datepicker table tr td.highlighted.focused {
  background: #5e72e4;
}

.datepicker table tr td.highlighted.disabled,
.datepicker table tr td.highlighted.disabled:active {
  background: #5e72e4;
  color: #ced4da;
}

.datepicker table tr td.today {
  background: white;
}

.datepicker table tr td.today.focused {
  background: white;
}

.datepicker table tr td.today.disabled,
.datepicker table tr td.today.disabled:active {
  background: white;
  color: #8898aa;
}

.datepicker table tr td.range {
  background: #5e72e4;
  color: #fff;
  border-radius: 0;
}

.datepicker table tr td.range.focused {
  background: #3b53de;
}

.datepicker table tr td.range.disabled,
.datepicker table tr td.range.disabled:active,
.datepicker table tr td.range.day.disabled:hover {
  background: #324cdd;
  color: #8a98eb;
}

.datepicker table tr td.range.highlighted.focused {
  background: #cbd3da;
}

.datepicker table tr td.range.highlighted.disabled,
.datepicker table tr td.range.highlighted.disabled:active {
  background: #e9ecef;
  color: #dee2e6;
}

.datepicker table tr td.range.today.disabled,
.datepicker table tr td.range.today.disabled:active {
  background: #5e72e4;
  color: #fff;
}

.datepicker table tr td.day.range-start {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.datepicker table tr td.day.range-end {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.datepicker table tr td.day.range-start.range-end {
  border-radius: 50%;
}

.datepicker table tr td.selected,
.datepicker table tr td.selected.highlighted,
.datepicker table tr td.selected:hover,
.datepicker table tr td.selected.highlighted:hover,
.datepicker table tr td.day.range:hover {
  background: #5e72e4;
  color: #fff;
}

.datepicker table tr td.active,
.datepicker table tr td.active.highlighted,
.datepicker table tr td.active:hover,
.datepicker table tr td.active.highlighted:hover {
  background: #5e72e4;
  color: #fff;
  box-shadow: none;
}

.datepicker table tr td span {
  display: block;
  width: 23%;
  height: 54px;
  line-height: 54px;
  float: left;
  margin: 1%;
  cursor: pointer;
  border-radius: 4px;
}

.datepicker table tr td span:hover,
.datepicker table tr td span.focused {
  background: #e9ecef;
}

.datepicker table tr td span.disabled,
.datepicker table tr td span.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}

.datepicker table tr td span.active,
.datepicker table tr td span.active:hover,
.datepicker table tr td span.active.disabled,
.datepicker table tr td span.active.disabled:hover {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}

.datepicker table tr td span.old,
.datepicker table tr td span.new {
  color: #8898aa;
}

.datepicker .datepicker-switch {
  width: 145px;
}

.datepicker .datepicker-switch,
.datepicker .prev,
.datepicker .next,
.datepicker tfoot tr th {
  cursor: pointer;
}

.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
  background: #e9ecef;
}

.datepicker .prev.disabled,
.datepicker .next.disabled {
  visibility: hidden;
}

.datepicker .cw {
  font-size: 10px;
  width: 12px;
  padding: 0 2px 0 5px;
  vertical-align: middle;
}

.bootstrap-tagsinput {
  background-color: #fff;
  border: 0 solid transparent;
  display: inline-block;
  padding: 0.25rem;
  color: #8898aa;
  vertical-align: middle;
  border-radius: 0.25rem;
  max-width: 100%;
  cursor: text;
}

.bootstrap-tagsinput input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;
}

.bootstrap-tagsinput input::placeholder {
  color: #adb5bd;
  opacity: 1;
}

.bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}

.bootstrap-tagsinput .badge {
  position: relative;
  padding: 0.625rem 0.625rem 0.5rem;
  margin: 0.125rem;
  border-radius: 0.25rem;
  background: #172b4d;
  color: #fff;
  line-height: 1.5;
  box-shadow: 0 1px 2px rgba(68, 68, 68, 0.25);
  transition: all 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .bootstrap-tagsinput .badge {
    transition: none;
  }
}

.bootstrap-tagsinput .badge:hover {
  padding-right: 1.5rem;
}

.bootstrap-tagsinput [data-role="remove"] {
  margin-left: 10px;
  cursor: pointer;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.bootstrap-tagsinput [data-role="remove"]:after {
  content: "×";
  font-size: 16px;
}

#chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  transition: all 0.1s ease;
  pointer-events: none;
  transform: translate(-50%, 0);
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
}

.dataTables_wrapper {
  font-size: 0.875rem;
}

table.dataTable {
  margin-bottom: 1.25rem !important;
  border-bottom: 1px solid #e9ecef;
}

table.dataTable tbody>tr.selected {
  background-color: #5e72e4;
}

.dataTables_length,
.dataTables_info,
.dt-buttons {
  padding-left: 1.5rem;
}

.dataTables_length .form-control {
  margin: 0 0.375rem;
}

.dataTables_filter {
  padding-right: 1.5rem;
  display: inline-block;
  float: right;
}

.dataTables_paginate {
  padding-right: 1.5rem;
}

.dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
}

.dz-message {
  padding: 5rem 1rem;
  background-color: #fff;
  border: 1px dashed #dee2e6;
  border-radius: 0.375rem;
  text-align: center;
  color: #8898aa;
  transition: all 0.15s ease;
  order: -1;
  cursor: pointer;
  z-index: 999;
}

.dz-message:hover {
  border-color: #8898aa;
  color: #525f7f;
}

.dz-drag-hover .dz-message {
  border-color: #5e72e4;
  color: #5e72e4;
}

.dropzone-multiple .dz-message {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.dropzone-single.dz-max-files-reached .dz-message {
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  opacity: 0;
}

.dropzone-single.dz-max-files-reached .dz-message:hover {
  opacity: 1;
}

.dz-preview-single {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 0.375rem;
}

.dz-preview-cover {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 0.375rem;
}

.dz-preview-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
}

.dz-preview-multiple .list-group-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

[data-dz-size] strong {
  font-weight: 400;
}

.fc-header-toolbar {
  display: none;
}

.fc-scroller {
  height: auto !important;
}

.fc th {
  padding: 0.75rem 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #8898aa;
  text-transform: uppercase;
}

.fc div.fc-row {
  margin-right: 0;
  border: 0;
}

.fc button .fc-icon {
  top: -5px;
}

.fc-unthemed td.fc-today {
  background-color: transparent;
}

.fc-unthemed td.fc-today span {
  color: #fb6340;
}

.fc-event {
  padding: 0;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  border: 0;
}

.fc-event .fc-title {
  padding: 0.4rem 0.5rem;
  display: block;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.fc-event .fc-time {
  float: left;
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 6px;
  margin: 0 0 0 -1px;
}

.fc-view,
.fc-view>table {
  border: 0;
  overflow: hidden;
}

.fc-view>table>tbody>tr .ui-widget-content {
  border-top: 0;
}

.fc-body {
  border: 0;
}

.fc-icon {
  font-family: NucleoIcons, sans-serif;
  font-size: 1rem;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  line-height: 35px;
}

.fc-icon:hover {
  color: #5e72e4;
}

.fc-button {
  border: 0;
  background: transparent;
  box-shadow: none;
}

.fc-button:focus,
.fc-button:active {
  outline: 0;
}

.calendar {
  z-index: 0;
}

.calendar td,
.calendar th {
  border-color: #eff1f3;
}

.calendar .fc-toolbar {
  height: 250px;
  background-color: #fff;
  border-radius: 0.375rem 0.375rem 0 0;
  position: relative;
  margin-bottom: -2px;
  z-index: 2;
}

@media (max-width: 575.98px) {
  .calendar .fc-toolbar {
    height: 135px;
  }
}

.calendar .fc-day-number {
  padding: 0.5rem 1rem;
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 576px) {
  .calendar .fc-day-number {
    font-size: 0.875rem;
    font-weight: 600;
    color: #67779d;
  }
}

.calendar .fc-day-header {
  text-align: left;
}

.calendar .fc-day-grid-event {
  margin: 1px 9px;
}

[data-calendar-month] {
  background-size: contain;
  transition: background-image 300ms;
}

@media (prefers-reduced-motion: reduce) {
  [data-calendar-month] {
    transition: none;
  }
}

.card-calendar .card-header {
  border-bottom: 0;
}

.card-calendar table {
  background: transparent;
}

.card-calendar table tr>td:first-child {
  border-left-width: 0;
}

.card-calendar table tr>td:last-child {
  border-right-width: 0;
}

.widget-calendar {
  position: relative;
  z-index: 0;
}

.widget-calendar td,
.widget-calendar th {
  border-color: transparent;
  text-align: center;
}

.widget-calendar .fc-toolbar {
  margin-top: 1.25rem;
}

.widget-calendar .fc-toolbar h2 {
  font-size: 1rem;
}

.widget-calendar .fc-day-number {
  text-align: center;
  width: 100%;
  padding: 0;
}

.widget-calendar .fc table {
  font-size: 0.875rem;
}

.widget-calendar .fc th {
  padding: 0.75rem 0.5rem;
  font-size: 0.75rem;
}

.vector-map {
  position: relative;
  height: 600px;
}

.vector-map-sm {
  height: 280px;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
}

.jvectormap-zoomin,
.jvectormap-zoomout {
  position: absolute;
  left: 0;
  bottom: 0;
}

.jvectormap-zoomin {
  bottom: 4.25rem;
}

.jvectormap-zoomout {
  bottom: 2rem;
}

/*!
 * Lavalamp
 * http://lavalamp.magicmediamuse.com/
 */
.lavalamp {
  position: relative;
}

.lavalamp-item {
  z-index: 5;
  position: relative;
}

.lavalamp-object {
  position: absolute;
  top: 0;
  left: 0;
}

/* Custom easing transitions */
.lavalamp .lavalamp-object {
  transition-property: transform, width, height;
}

.lavalamp .lavalamp-object.ease {
  transition-timing-function: ease;
}

.lavalamp .lavalamp-object.ease-in {
  transition-timing-function: ease-in;
}

.lavalamp .lavalamp-object.ease-out {
  transition-timing-function: ease-out;
}

.lavalamp .lavalamp-object.ease-in-out {
  transition-timing-function: ease-in-out;
}

.lavalamp .lavalamp-object.linear {
  transition-timing-function: linear;
}

.lavalamp .lavalamp-object.easeInQuad {
  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.lavalamp .lavalamp-object.easeInCubic {
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.lavalamp .lavalamp-object.easeInQuart {
  transition-timing-function: cubic-bezier(0.895, 0.03, 0.685, 0.22);
}

.lavalamp .lavalamp-object.easeInQuint {
  transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.lavalamp .lavalamp-object.easeInSine {
  transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
}

.lavalamp .lavalamp-object.easeInExpo {
  transition-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);
}

.lavalamp .lavalamp-object.easeInCirc {
  transition-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.335);
}

.lavalamp .lavalamp-object.easeInBack {
  transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

.lavalamp .lavalamp-object.easeOutQuad {
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.lavalamp .lavalamp-object.easeOutCubic {
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}

.lavalamp .lavalamp-object.easeOutQuart {
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.lavalamp .lavalamp-object.easeOutQuint {
  transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.lavalamp .lavalamp-object.easeOutSine {
  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
}

.lavalamp .lavalamp-object.easeOutExpo {
  transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
}

.lavalamp .lavalamp-object.easeOutCirc {
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}

.lavalamp .lavalamp-object.easeOutBack {
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.lavalamp .lavalamp-object.easeInOutQuad {
  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.lavalamp .lavalamp-object.easeInOutCubic {
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}

.lavalamp .lavalamp-object.easeInOutQuart {
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}

.lavalamp .lavalamp-object.easeInOutQuint {
  transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}

.lavalamp .lavalamp-object.easeInOutSine {
  transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.lavalamp .lavalamp-object.easeInOutExpo {
  transition-timing-function: cubic-bezier(1, 0, 0, 1);
}

.lavalamp .lavalamp-object.easeInOutCirc {
  transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.lavalamp .lavalamp-object.easeInOutBack {
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform-origin: 0 0;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  position: absolute;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

.noUi-horizontal {
  height: 5px;
}

.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  left: -17px;
  top: -6px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
  right: -17px;
  left: auto;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #5e72e4;
}

.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
  outline: none;
}

.noUi-active {
  outline: none;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #ccc;
}

.noUi-marker-sub {
  background: #aaa;
}

.noUi-marker-large {
  background: #aaa;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%, 0);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-target {
  background: #eceeef;
  border-radius: 5px;
  border: 0;
  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);
  margin: 15px 0;
  cursor: pointer;
}

.noUi-horizontal {
  height: 5px;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
  right: -10px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-connect {
  background: #5e72e4;
  box-shadow: none;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  top: -5px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  box-shadow: none;
  cursor: pointer;
  background-color: #5e72e4;
  border: 0;
  transition: box-shadow 0.15s, transform 0.15s;
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
  box-shadow: 0px 0px 0px 2px #5e72e4;
}

.input-slider--cyan .noUi-connect {
  background: #2bffc6;
}

/* Disabled state */
[disabled] .noUi-connect,
[disabled].noUi-connect {
  background: #b2b2b2;
}

[disabled] .noUi-handle,
[disabled].noUi-origin {
  cursor: not-allowed;
}

/* Range slider value labels */
.range-slider-value {
  font-size: 0.75rem;
  font-weight: 500;
  background-color: rgba(33, 37, 41, 0.7);
  color: #fff;
  border-radius: 10px;
  padding: 0.4em 0.8em 0.3em 0.85em;
}

.range-slider-wrapper .upper-info {
  font-weight: 400;
  margin-bottom: 5px;
}

.input-slider-value-output {
  background: #333;
  color: #fff;
  padding: 4px 8px;
  position: relative;
  top: 12px;
  font-size: 11px;
  border-radius: 2px;
}

.input-slider-value-output:after {
  bottom: 100%;
  left: 10px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #333;
  border-width: 4px;
  margin-left: -4px;
}

.input-slider-value-output.left:after {
  left: 10px;
  right: auto;
}

.input-slider-value-output.right:after {
  right: 10px;
  left: auto;
}

.ql-container {
  font-family: Open Sans, sans-serif;
}

.ql-toolbar {
  position: relative;
  padding: 0.625rem 0.75rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem 0.25rem 0 0;
  color: #8898aa;
}

.ql-toolbar+.ql-container {
  margin-top: -1px;
}

.ql-toolbar+.ql-container .ql-editor {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.ql-editor {
  min-height: 6rem;
  display: block;
  width: 100%;
  padding: 0.625rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {
  .ql-editor {
    transition: none;
  }
}

.ql-editor::-ms-expand {
  background-color: transparent;
  border: 0;
}

.ql-editor:focus {
  color: #8898aa;
  background-color: #fff;
  border-color: #5e72e4;
  outline: 0;
  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);
}

.ql-editor:focus {
  border-color: #dee2e6;
}

.ql-hidden {
  position: absolute;
  transform: scale(0);
}

.ql-editor.ql-blank::before {
  top: 0.625rem;
  left: 0.75rem;
  font-style: normal;
  color: #adb5bd;
}

.ql-editor:focus::before {
  display: none;
}

.ql-formats {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.ql-formats:first-child {
  padding-left: 0;
}

.ql-formats:last-child {
  padding-right: 0;
}

.ql-toolbar button {
  padding: 0 0.25rem;
  background: none;
  border: none;
  color: #525f7f;
  cursor: pointer;
  transition: all 0.15s ease;
}

.ql-toolbar button:hover {
  color: #5e72e4;
}

.ql-toolbar button:first-child {
  margin-left: -0.25rem;
}

.ql-toolbar .ql-active {
  color: #5e72e4;
}

.ql-toolbar button svg {
  height: 1.25rem;
  width: 1.25rem;
}

.ql-toolbar .ql-stroke {
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.ql-toolbar .ql-thin {
  stroke-width: 1;
}

.ql-toolbar .ql-fill {
  fill: currentColor;
}

.ql-toolbar input.ql-image {
  position: absolute;
  transform: scale(0);
}

.ql-tooltip {
  position: absolute;
  display: flex;
  flex-wrap: nowrap;
  width: 18.5rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.4375rem;
  padding: 0.625rem 0.75rem;
  margin-top: 0.6rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);
}

.ql-tooltip:before,
.ql-tooltip:after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%);
}

.ql-tooltip:before {
  border-bottom: 0.6rem solid rgba(0, 0, 0, 0.05);
  border-left: 0.6rem solid transparent;
  border-right: 0.6rem solid transparent;
}

.ql-tooltip:after {
  border-bottom: 0.5rem solid #fff;
  border-left: 0.5rem solid transparent;
  border-right: 0.5rem solid transparent;
}

.ql-container .ql-tooltip:hover {
  display: flex !important;
}

.ql-tooltip .ql-preview {
  width: 100%;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .ql-tooltip .ql-preview {
    transition: none;
  }
}

.ql-tooltip.ql-editing .ql-preview {
  display: none;
}

.ql-tooltip input {
  display: none;
  width: 100%;
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  background-color: transparent;
  font-size: 0.875rem;
  line-height: 1.5;
  border: none;
  color: #8898aa;
}

.ql-tooltip input:focus {
  outline: none;
}

.ql-tooltip.ql-editing input {
  display: block;
}

.ql-tooltip .ql-action,
.ql-tooltip .ql-remove {
  margin-left: 0.25rem;
}

.ql-tooltip .ql-action::before,
.ql-tooltip .ql-remove::before {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {

  .ql-tooltip .ql-action::before,
  .ql-tooltip .ql-remove::before {
    transition: none;
  }
}

.ql-tooltip .ql-action::before:hover,
.ql-tooltip .ql-action::before:focus,
.ql-tooltip .ql-remove::before:hover,
.ql-tooltip .ql-remove::before:focus {
  text-decoration: none;
}

.ql-tooltip .ql-action::before:focus,
.ql-tooltip .ql-action::before.focus,
.ql-tooltip .ql-remove::before:focus,
.ql-tooltip .ql-remove::before.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

.ql-tooltip .ql-action::before,
.ql-tooltip.ql-editing .ql-action::before {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.ql-tooltip .ql-action::before:hover,
.ql-tooltip.ql-editing .ql-action::before:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.ql-tooltip .ql-action::before:focus,
.ql-tooltip .ql-action::before.focus,
.ql-tooltip.ql-editing .ql-action::before:focus,
.ql-tooltip.ql-editing .ql-action::before.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(94, 114, 228, 0.5);
}

.ql-tooltip .ql-action::before.disabled,
.ql-tooltip .ql-action::before:disabled,
.ql-tooltip.ql-editing .ql-action::before.disabled,
.ql-tooltip.ql-editing .ql-action::before:disabled {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}

.ql-tooltip .ql-action::before:not(:disabled):not(.disabled):active,
.ql-tooltip .ql-action::before:not(:disabled):not(.disabled).active,
.show>.ql-tooltip .ql-action::before.dropdown-toggle,
.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled):active,
.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled).active,
.show>.ql-tooltip.ql-editing .ql-action::before.dropdown-toggle {
  color: #fff;
  background-color: #324cdd;
  border-color: #5e72e4;
}

.ql-tooltip .ql-action::before:not(:disabled):not(.disabled):active:focus,
.ql-tooltip .ql-action::before:not(:disabled):not(.disabled).active:focus,
.show>.ql-tooltip .ql-action::before.dropdown-toggle:focus,
.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled):active:focus,
.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled).active:focus,
.show>.ql-tooltip.ql-editing .ql-action::before.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.ql-tooltip .ql-action::before {
  content: "Edit";
}

.ql-tooltip.ql-editing .ql-action::before {
  content: "Save";
}

.ql-tooltip .ql-remove::before {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  content: "Remove";
  border-color: #dee2e6;
}

.ql-tooltip .ql-remove::before:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}

.ql-tooltip .ql-remove::before:focus,
.ql-tooltip .ql-remove::before.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),
    0 0 0 0 rgba(255, 255, 255, 0.5);
}

.ql-tooltip .ql-remove::before.disabled,
.ql-tooltip .ql-remove::before:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}

.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled):active,
.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled).active,
.show>.ql-tooltip .ql-remove::before.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}

.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled):active:focus,
.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled).active:focus,
.show>.ql-tooltip .ql-remove::before.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.ql-tooltip.ql-editing .ql-remove::before {
  display: none;
}

.ql-editor blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.ql-editor img {
  max-width: 100%;
  height: auto;
}

.scroll-wrapper {
  overflow: hidden !important;
  padding: 0 !important;
  position: relative;
}

.scroll-wrapper>.scroll-content {
  border: none !important;
  box-sizing: content-box !important;
  height: auto;
  left: 0;
  margin: 0;
  max-height: none;
  max-width: none !important;
  overflow: scroll !important;
  padding: 0;
  position: relative !important;
  top: 0;
  width: auto !important;
}

.scroll-wrapper>.scroll-content::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.scroll-wrapper.scroll--rtl {
  direction: rtl;
}

.scroll-element {
  box-sizing: content-box;
  display: none;
}

.scroll-element div {
  box-sizing: content-box;
}

.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
  cursor: default;
}

.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
  display: block;
}

.scroll-textarea {
  border: 1px solid #cccccc;
  border-top-color: #999999;
}

.scroll-textarea>.scroll-content {
  overflow: hidden !important;
}

.scroll-textarea>.scroll-content>textarea {
  border: none !important;
  box-sizing: border-box;
  height: 100% !important;
  margin: 0;
  max-height: none !important;
  max-width: none !important;
  overflow: scroll !important;
  outline: none;
  padding: 2px;
  position: relative !important;
  top: 0;
  width: 100% !important;
}

.scroll-textarea>.scroll-content>textarea::-webkit-scrollbar {
  height: 0;
  width: 0;
}

/*************** SIMPLE INNER SCROLLBAR ***************/
.scrollbar-inner>.scroll-element,
.scrollbar-inner>.scroll-element div {
  border: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-inner>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-inner>.scroll-element.scroll-x {
  bottom: 2px;
  height: 8px;
  left: 0;
  width: 100%;
}

.scrollbar-inner>.scroll-element.scroll-y {
  height: 100%;
  right: 2px;
  top: 0;
  width: 8px;
}

.scrollbar-inner>.scroll-element .scroll-element_outer {
  overflow: hidden;
}

.scrollbar-inner>.scroll-element .scroll-element_outer,
.scrollbar-inner>.scroll-element .scroll-element_track,
.scrollbar-inner>.scroll-element .scroll-bar {
  border-radius: 8px;
}

.scrollbar-inner>.scroll-element .scroll-element_track,
.scrollbar-inner>.scroll-element .scroll-bar {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  filter: alpha(opacity=40);
  opacity: 0.4;
}

.scrollbar-inner>.scroll-element .scroll-element_track {
  background-color: #e0e0e0;
}

.scrollbar-inner>.scroll-element .scroll-bar {
  background-color: #c2c2c2;
}

.scrollbar-inner>.scroll-element:hover .scroll-bar {
  background-color: #919191;
}

.scrollbar-inner>.scroll-element.scroll-draggable .scroll-bar {
  background-color: #919191;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-inner>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {
  left: -12px;
}

.scrollbar-inner>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {
  top: -12px;
}

.scrollbar-inner>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -12px;
}

.scrollbar-inner>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -12px;
}

/*************** SIMPLE OUTER SCROLLBAR ***************/
.scrollbar-outer>.scroll-element,
.scrollbar-outer>.scroll-element div {
  border: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-outer>.scroll-element {
  background-color: #ffffff;
}

.scrollbar-outer>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-outer>.scroll-element.scroll-x {
  bottom: 0;
  height: 12px;
  left: 0;
  width: 100%;
}

.scrollbar-outer>.scroll-element.scroll-y {
  height: 100%;
  right: 0;
  top: 0;
  width: 12px;
}

.scrollbar-outer>.scroll-element.scroll-x .scroll-element_outer {
  height: 8px;
  top: 2px;
}

.scrollbar-outer>.scroll-element.scroll-y .scroll-element_outer {
  left: 2px;
  width: 8px;
}

.scrollbar-outer>.scroll-element .scroll-element_outer {
  overflow: hidden;
}

.scrollbar-outer>.scroll-element .scroll-element_track {
  background-color: #eeeeee;
}

.scrollbar-outer>.scroll-element .scroll-element_outer,
.scrollbar-outer>.scroll-element .scroll-element_track,
.scrollbar-outer>.scroll-element .scroll-bar {
  border-radius: 8px;
}

.scrollbar-outer>.scroll-element .scroll-bar {
  background-color: #d9d9d9;
}

.scrollbar-outer>.scroll-element .scroll-bar:hover {
  background-color: #c2c2c2;
}

.scrollbar-outer>.scroll-element.scroll-draggable .scroll-bar {
  background-color: #919191;
}

/* scrollbar height/width & offset from container borders */
.scrollbar-outer>.scroll-content.scroll-scrolly_visible {
  left: -12px;
  margin-left: 12px;
}

.scrollbar-outer>.scroll-content.scroll-scrollx_visible {
  top: -12px;
  margin-top: 12px;
}

.scrollbar-outer>.scroll-element.scroll-x .scroll-bar {
  min-width: 10px;
}

.scrollbar-outer>.scroll-element.scroll-y .scroll-bar {
  min-height: 10px;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-outer>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {
  left: -14px;
}

.scrollbar-outer>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {
  top: -14px;
}

.scrollbar-outer>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -14px;
}

.scrollbar-outer>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -14px;
}

/*************** SCROLLBAR MAC OS X ***************/
.scrollbar-macosx>.scroll-element,
.scrollbar-macosx>.scroll-element div {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-macosx>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-macosx>.scroll-element .scroll-element_track {
  display: none;
}

.scrollbar-macosx>.scroll-element .scroll-bar {
  background-color: #6c6e71;
  display: block;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  opacity: 0;
  border-radius: 7px;
  transition: opacity 0.2s linear;
}

.scrollbar-macosx:hover>.scroll-element .scroll-bar,
.scrollbar-macosx>.scroll-element.scroll-draggable .scroll-bar {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
  filter: alpha(opacity=70);
  opacity: 0.7;
}

.scrollbar-macosx>.scroll-element.scroll-x {
  bottom: 0px;
  height: 0px;
  left: 0;
  min-width: 100%;
  overflow: visible;
  width: 100%;
}

.scrollbar-macosx>.scroll-element.scroll-y {
  height: 100%;
  min-height: 100%;
  right: 0px;
  top: 0;
  width: 0px;
}

/* scrollbar height/width & offset from container borders */
.scrollbar-macosx>.scroll-element.scroll-x .scroll-bar {
  height: 7px;
  min-width: 10px;
  top: -9px;
}

.scrollbar-macosx>.scroll-element.scroll-y .scroll-bar {
  left: -9px;
  min-height: 10px;
  width: 7px;
}

.scrollbar-macosx>.scroll-element.scroll-x .scroll-element_outer {
  left: 2px;
}

.scrollbar-macosx>.scroll-element.scroll-x .scroll-element_size {
  left: -4px;
}

.scrollbar-macosx>.scroll-element.scroll-y .scroll-element_outer {
  top: 2px;
}

.scrollbar-macosx>.scroll-element.scroll-y .scroll-element_size {
  top: -4px;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-macosx>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -11px;
}

.scrollbar-macosx>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -11px;
}

/*************** SCROLLBAR LIGHT ***************/
.scrollbar-light>.scroll-element,
.scrollbar-light>.scroll-element div {
  border: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-light>.scroll-element {
  background-color: #ffffff;
}

.scrollbar-light>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-light>.scroll-element .scroll-element_outer {
  border-radius: 10px;
}

.scrollbar-light>.scroll-element .scroll-element_size {
  background: #dbdbdb;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background: linear-gradient(to right, #dbdbdb 0%, #e8e8e8 100%);
  border-radius: 10px;
}

.scrollbar-light>.scroll-element.scroll-x {
  bottom: 0;
  height: 17px;
  left: 0;
  min-width: 100%;
  width: 100%;
}

.scrollbar-light>.scroll-element.scroll-y {
  height: 100%;
  min-height: 100%;
  right: 0;
  top: 0;
  width: 17px;
}

.scrollbar-light>.scroll-element .scroll-bar {
  background: #fefefe;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background: linear-gradient(to right, #fefefe 0%, #f5f5f5 100%);
  border: 1px solid #dbdbdb;
  border-radius: 10px;
}

/* scrollbar height/width & offset from container borders */
.scrollbar-light>.scroll-content.scroll-scrolly_visible {
  left: -17px;
  margin-left: 17px;
}

.scrollbar-light>.scroll-content.scroll-scrollx_visible {
  top: -17px;
  margin-top: 17px;
}

.scrollbar-light>.scroll-element.scroll-x .scroll-bar {
  height: 10px;
  min-width: 10px;
  top: 0px;
}

.scrollbar-light>.scroll-element.scroll-y .scroll-bar {
  left: 0px;
  min-height: 10px;
  width: 10px;
}

.scrollbar-light>.scroll-element.scroll-x .scroll-element_outer {
  height: 12px;
  left: 2px;
  top: 2px;
}

.scrollbar-light>.scroll-element.scroll-x .scroll-element_size {
  left: -4px;
}

.scrollbar-light>.scroll-element.scroll-y .scroll-element_outer {
  left: 2px;
  top: 2px;
  width: 12px;
}

.scrollbar-light>.scroll-element.scroll-y .scroll-element_size {
  top: -4px;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-light>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -19px;
}

.scrollbar-light>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -19px;
}

.scrollbar-light>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {
  left: -19px;
}

.scrollbar-light>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {
  top: -19px;
}

/*************** SCROLLBAR RAIL ***************/
.scrollbar-rail>.scroll-element,
.scrollbar-rail>.scroll-element div {
  border: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-rail>.scroll-element {
  background-color: #ffffff;
}

.scrollbar-rail>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-rail>.scroll-element .scroll-element_size {
  background-color: #999;
  background-color: rgba(0, 0, 0, 0.3);
}

.scrollbar-rail>.scroll-element .scroll-element_outer:hover .scroll-element_size {
  background-color: #666;
  background-color: rgba(0, 0, 0, 0.5);
}

.scrollbar-rail>.scroll-element.scroll-x {
  bottom: 0;
  height: 12px;
  left: 0;
  min-width: 100%;
  padding: 3px 0 2px;
  width: 100%;
}

.scrollbar-rail>.scroll-element.scroll-y {
  height: 100%;
  min-height: 100%;
  padding: 0 2px 0 3px;
  right: 0;
  top: 0;
  width: 12px;
}

.scrollbar-rail>.scroll-element .scroll-bar {
  background-color: #d0b9a0;
  border-radius: 2px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.scrollbar-rail>.scroll-element .scroll-element_outer:hover .scroll-bar {
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
}

/* scrollbar height/width & offset from container borders */
.scrollbar-rail>.scroll-content.scroll-scrolly_visible {
  left: -17px;
  margin-left: 17px;
}

.scrollbar-rail>.scroll-content.scroll-scrollx_visible {
  margin-top: 17px;
  top: -17px;
}

.scrollbar-rail>.scroll-element.scroll-x .scroll-bar {
  height: 10px;
  min-width: 10px;
  top: 1px;
}

.scrollbar-rail>.scroll-element.scroll-y .scroll-bar {
  left: 1px;
  min-height: 10px;
  width: 10px;
}

.scrollbar-rail>.scroll-element.scroll-x .scroll-element_outer {
  height: 15px;
  left: 5px;
}

.scrollbar-rail>.scroll-element.scroll-x .scroll-element_size {
  height: 2px;
  left: -10px;
  top: 5px;
}

.scrollbar-rail>.scroll-element.scroll-y .scroll-element_outer {
  top: 5px;
  width: 15px;
}

.scrollbar-rail>.scroll-element.scroll-y .scroll-element_size {
  left: 5px;
  top: -10px;
  width: 2px;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-rail>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -25px;
}

.scrollbar-rail>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -25px;
}

.scrollbar-rail>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {
  left: -25px;
}

.scrollbar-rail>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {
  top: -25px;
}

/*************** SCROLLBAR DYNAMIC ***************/
.scrollbar-dynamic>.scroll-element,
.scrollbar-dynamic>.scroll-element div {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-dynamic>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-dynamic>.scroll-element.scroll-x {
  bottom: 2px;
  height: 7px;
  left: 0;
  min-width: 100%;
  width: 100%;
}

.scrollbar-dynamic>.scroll-element.scroll-y {
  height: 100%;
  min-height: 100%;
  right: 2px;
  top: 0;
  width: 7px;
}

.scrollbar-dynamic>.scroll-element .scroll-element_outer {
  opacity: 0.3;
  border-radius: 12px;
}

.scrollbar-dynamic>.scroll-element .scroll-element_size {
  background-color: #cccccc;
  opacity: 0;
  border-radius: 12px;
  transition: opacity 0.2s;
}

.scrollbar-dynamic>.scroll-element .scroll-bar {
  background-color: #6c6e71;
  border-radius: 7px;
}

/* scrollbar height/width & offset from container borders */
.scrollbar-dynamic>.scroll-element.scroll-x .scroll-bar {
  bottom: 0;
  height: 7px;
  min-width: 24px;
  top: auto;
}

.scrollbar-dynamic>.scroll-element.scroll-y .scroll-bar {
  left: auto;
  min-height: 24px;
  right: 0;
  width: 7px;
}

.scrollbar-dynamic>.scroll-element.scroll-x .scroll-element_outer {
  bottom: 0;
  top: auto;
  left: 2px;
  transition: height 0.2s;
}

.scrollbar-dynamic>.scroll-element.scroll-y .scroll-element_outer {
  left: auto;
  right: 0;
  top: 2px;
  transition: width 0.2s;
}

.scrollbar-dynamic>.scroll-element.scroll-x .scroll-element_size {
  left: -4px;
}

.scrollbar-dynamic>.scroll-element.scroll-y .scroll-element_size {
  top: -4px;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-dynamic>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -11px;
}

.scrollbar-dynamic>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -11px;
}

/* hover & drag */
.scrollbar-dynamic>.scroll-element:hover .scroll-element_outer,
.scrollbar-dynamic>.scroll-element.scroll-draggable .scroll-element_outer {
  overflow: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
  filter: alpha(opacity=70);
  opacity: 0.7;
}

.scrollbar-dynamic>.scroll-element:hover .scroll-element_outer .scroll-element_size,
.scrollbar-dynamic>.scroll-element.scroll-draggable .scroll-element_outer .scroll-element_size {
  opacity: 1;
}

.scrollbar-dynamic>.scroll-element:hover .scroll-element_outer .scroll-bar,
.scrollbar-dynamic>.scroll-element.scroll-draggable .scroll-element_outer .scroll-bar {
  height: 100%;
  width: 100%;
  border-radius: 12px;
}

.scrollbar-dynamic>.scroll-element.scroll-x:hover .scroll-element_outer,
.scrollbar-dynamic>.scroll-element.scroll-x.scroll-draggable .scroll-element_outer {
  height: 20px;
  min-height: 7px;
}

.scrollbar-dynamic>.scroll-element.scroll-y:hover .scroll-element_outer,
.scrollbar-dynamic>.scroll-element.scroll-y.scroll-draggable .scroll-element_outer {
  min-width: 7px;
  width: 20px;
}

/*************** SCROLLBAR GOOGLE CHROME ***************/
.scrollbar-chrome>.scroll-element,
.scrollbar-chrome>.scroll-element div {
  border: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  z-index: 10;
}

.scrollbar-chrome>.scroll-element {
  background-color: #ffffff;
}

.scrollbar-chrome>.scroll-element div {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}

.scrollbar-chrome>.scroll-element .scroll-element_track {
  background: #f1f1f1;
  border: 1px solid #dbdbdb;
}

.scrollbar-chrome>.scroll-element.scroll-x {
  bottom: 0;
  height: 16px;
  left: 0;
  min-width: 100%;
  width: 100%;
}

.scrollbar-chrome>.scroll-element.scroll-y {
  height: 100%;
  min-height: 100%;
  right: 0;
  top: 0;
  width: 16px;
}

.scrollbar-chrome>.scroll-element .scroll-bar {
  background-color: #d9d9d9;
  border: 1px solid #bdbdbd;
  cursor: default;
  border-radius: 2px;
}

.scrollbar-chrome>.scroll-element .scroll-bar:hover {
  background-color: #c2c2c2;
  border-color: #a9a9a9;
}

.scrollbar-chrome>.scroll-element.scroll-draggable .scroll-bar {
  background-color: #919191;
  border-color: #7e7e7e;
}

/* scrollbar height/width & offset from container borders */
.scrollbar-chrome>.scroll-content.scroll-scrolly_visible {
  left: -16px;
  margin-left: 16px;
}

.scrollbar-chrome>.scroll-content.scroll-scrollx_visible {
  top: -16px;
  margin-top: 16px;
}

.scrollbar-chrome>.scroll-element.scroll-x .scroll-bar {
  height: 8px;
  min-width: 10px;
  top: 3px;
}

.scrollbar-chrome>.scroll-element.scroll-y .scroll-bar {
  left: 3px;
  min-height: 10px;
  width: 8px;
}

.scrollbar-chrome>.scroll-element.scroll-x .scroll-element_outer {
  border-left: 1px solid #dbdbdb;
}

.scrollbar-chrome>.scroll-element.scroll-x .scroll-element_track {
  height: 14px;
  left: -3px;
}

.scrollbar-chrome>.scroll-element.scroll-x .scroll-element_size {
  height: 14px;
  left: -4px;
}

.scrollbar-chrome>.scroll-element.scroll-y .scroll-element_outer {
  border-top: 1px solid #dbdbdb;
}

.scrollbar-chrome>.scroll-element.scroll-y .scroll-element_track {
  top: -3px;
  width: 14px;
}

.scrollbar-chrome>.scroll-element.scroll-y .scroll-element_size {
  top: -4px;
  width: 14px;
}

/* update scrollbar offset if both scrolls are visible */
.scrollbar-chrome>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {
  left: -19px;
}

.scrollbar-chrome>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {
  top: -19px;
}

.scrollbar-chrome>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {
  left: -19px;
}

.scrollbar-chrome>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {
  top: -19px;
}

.scrollbar-inner {
  height: 100%;
}

.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}

.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}

.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}

.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}

.scrollbar-inner .scroll-element:hover {
  width: 4px;
}

.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}

.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.select2-selection__arrow {
  display: none;
}

.select2.select2-container {
  width: 100% !important;
}

.select2-container .select2-selection--single,
.select2-container--default.select2-container--focus .select2-selection--multiple,
.select2-container--default .select2-selection--multiple,
.select2-container--default .select2-search--dropdown .select2-search__field {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media (prefers-reduced-motion: reduce) {

  .select2-container .select2-selection--single,
  .select2-container--default.select2-container--focus .select2-selection--multiple,
  .select2-container--default .select2-selection--multiple,
  .select2-container--default .select2-search--dropdown .select2-search__field {
    transition: none;
  }
}

.select2-container .select2-selection--single::-ms-expand,
.select2-container--default.select2-container--focus .select2-selection--multiple::-ms-expand,
.select2-container--default .select2-selection--multiple::-ms-expand,
.select2-container--default .select2-search--dropdown .select2-search__field::-ms-expand {
  background-color: transparent;
  border: 0;
}

.select2-container .select2-selection--single:focus,
.select2-container--default.select2-container--focus .select2-selection--multiple:focus,
.select2-container--default .select2-selection--multiple:focus,
.select2-container--default .select2-search--dropdown .select2-search__field:focus {
  color: #8898aa;
  background-color: #fff;
  border-color: #5e72e4;
  outline: 0;
  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);
}

.select2-container .select2-selection--single::placeholder,
.select2-container--default.select2-container--focus .select2-selection--multiple::placeholder,
.select2-container--default .select2-selection--multiple::placeholder,
.select2-container--default .select2-search--dropdown .select2-search__field::placeholder {
  color: #adb5bd;
  opacity: 1;
}

.select2-container .select2-selection--single:disabled,
.select2-container .select2-selection--single[readonly],
.select2-container--default.select2-container--focus .select2-selection--multiple:disabled,
.select2-container--default.select2-container--focus .select2-selection--multiple[readonly],
.select2-container--default .select2-selection--multiple:disabled,
.select2-container--default .select2-selection--multiple[readonly],
.select2-container--default .select2-search--dropdown .select2-search__field:disabled,
.select2-container--default .select2-search--dropdown .select2-search__field[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  padding: 0;
  overflow: inherit;
  text-overflow: inherit;
  white-space: inherit;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: inherit;
  line-height: inherit;
}

.select2-dropdown {
  padding: 0.5rem 0;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.4375rem;
}

.select2-results__option {
  padding: 0.5rem 0.75rem;
  background-color: #fff;
  color: #212529;
  font-size: 0.875rem;
}

.select2-results__option:hover,
.select2-results__option:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f6f9fc;
}

.select2-container--default .select2-results__option--highlighted[aria-selected],
.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: transparent;
  color: #16181b;
}

.select2-container--default .select2-results__option[aria-disabled="true"] {
  color: #adb5bd;
}

.select2-container--default.select2-container--focus .select2-selection--multiple,
.select2-container--default .select2-selection--multiple {
  height: auto;
  min-height: calc(1.5em + 1.25rem + 2px);
}

.select2-container--default .select2-selection--multiple .select2-selection__rendered {
  display: block;
  margin: 0 0 -0.25rem -0.25rem;
  padding: 0;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  display: inline-flex;
  padding: 0 0.5rem;
  margin: 0 0 0.25rem 0.25rem;
  background-color: #adb5bd;
  border: none;
  border-radius: 0.25rem;
  line-height: 1.5rem;
  font-size: 0.875rem;
  color: #8898aa;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  order: 2;
  margin-left: 0.5rem;
  color: #8898aa;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {
  color: #525f7f;
}

.select2-container .select2-search--inline {
  display: none;
}

.select2-selection[aria-expanded="true"] {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.select2-search--dropdown {
  padding: 0.5rem 0.75rem;
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-sm+.select2-container .select2-selection--single,
.form-control-sm+.select2-container--default.select2-container--focus .select2-selection--multiple,
.form-control-sm+.select2-container--default .select2-selection--multiple {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-sm+.select2-container--default.select2-container--focus .select2-selection--multiple,
.form-control-sm+.select2-container--default .select2-selection--multiple {
  min-height: calc(1.5em + 0.5rem + 2px);
}

.form-control-sm+.select2-container--default .select2-selection--multiple .select2-selection__choice {
  line-height: 1.3125rem;
}

.form-control-lg+.select2-container .select2-selection--single,
.form-control-lg+.select2-container--default.select2-container--focus .select2-selection--multiple,
.form-control-lg+.select2-container--default .select2-selection--multiple {
  height: calc(1.5em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.form-control-lg+.select2-container--default.select2-container--focus .select2-selection--multiple,
.form-control-lg+.select2-container--default .select2-selection--multiple {
  min-height: calc(1.5em + 1.75rem + 2px);
}

.form-control-lg+.select2-container--default .select2-selection--multiple .select2-selection__choice {
  line-height: 1.875rem;
}

.swal2-popup {
  padding: 1.5rem;
}

.swal2-popup .swal2-title {
  font-size: 1.5rem;
}

.swal2-popup .swal2-content {
  font-size: 0.875rem;
}

.swal2-popup .swal2-image {
  max-width: 200px;
}

.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="clear"]::after,
.bootstrap-datetimepicker-widget .btn[data-action="today"]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 8px 6px;
  width: 254px;
  max-width: 254px;
}

.bootstrap-datetimepicker-widget.dropdown-menu .tim-icons {
  opacity: 1;
}

.bootstrap-datetimepicker-widget.dropdown-menu .picker-switch .table-condensed:hover {
  background: #eee;
  border-radius: 3px;
}

.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed {
  margin-top: 10px;
  margin-bottom: 5px;
}

.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed .btn[data-action="togglePeriod"]:hover,
.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed .separator {
  color: #9a9a9a !important;
}

.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .month,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .year,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .decade {
  color: #9a9a9a;
}

.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .month.active,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .year.active,
.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .decade.active {
  color: #fff;
}

@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}

@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}

@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}

.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  right: auto;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top:before {
  display: none;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -6px;
  right: auto;
  left: 10px;
  color: #fff;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
  padding: 0;
  border-width: 0;
  color: #fff;
}

.bootstrap-datetimepicker-widget a[data-action="togglePicker"],
.bootstrap-datetimepicker-widget a[data-action="togglePicker"]:hover {
  color: #5e72e4;
}

.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 300;
  font-size: 1.5em;
  margin: 3px;
  border-radius: 50%;
  color: #9a9a9a;
}

.bootstrap-datetimepicker-widget button[data-action] {
  width: 38px;
  height: 38px;
  padding: 0;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.bootstrap-datetimepicker-widget .btn {
  margin: 0 !important;
}

.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]::after {
  content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]::after {
  content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]::after {
  content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]::after {
  content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="showHours"]::after {
  content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]::after {
  content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]::after {
  content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action="clear"]::after {
  content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action="today"]::after {
  content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 3px;
  color: #5e72e4;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 3px;
  margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td>div,
.bootstrap-datetimepicker-widget table th>div {
  text-align: center;
}

.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
  font-weight: 300;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled,
.bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span,
.bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
  color: #5e72e4;
}

.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  color: #5e72e4;
  padding-bottom: 5px;
  padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,
.bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #eee;
}

.bootstrap-datetimepicker-widget table td.cw>div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day>div,
.bootstrap-datetimepicker-widget table td.minute>div,
.bootstrap-datetimepicker-widget table td.hour>div {
  height: 30px;
  line-height: 2.2;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  color: #9a9a9a;
  position: relative;
  font-weight: 300;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: all 300ms ease 0s;
}

.bootstrap-datetimepicker-widget table td.day:hover>div,
.bootstrap-datetimepicker-widget table td.hour:hover>div,
.bootstrap-datetimepicker-widget table td.minute:hover>div,
.bootstrap-datetimepicker-widget table td.second:hover>div {
  background: #eee;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old>div,
.bootstrap-datetimepicker-widget table td.new>div {
  color: #172b4d;
}

.bootstrap-datetimepicker-widget table td.today,
.bootstrap-datetimepicker-widget table td.day {
  background: transparent !important;
}

.bootstrap-datetimepicker-widget table td.today>div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #68b3c8;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.bootstrap-datetimepicker-widget table td.active>div,
.bootstrap-datetimepicker-widget table td.active:hover>div {
  background-color: #5e72e4;
  color: #fff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.bootstrap-datetimepicker-widget table td.active.today:before>div {
  border-bottom-color: #fff;
}

.bootstrap-datetimepicker-widget table td.disabled>div,
.bootstrap-datetimepicker-widget table td.disabled:hover>div {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 0 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td span.active {
  background-color: #5e72e4;
  color: #ffffff;
}

.bootstrap-datetimepicker-widget table td span.old {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled,
.bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed>tbody>tr>td,
.table-condensed>tbody>tr>th,
.table-condensed>tfoot>tr>td,
.table-condensed>tfoot>tr>th,
.table-condensed>thead>tr>td,
.table-condensed>thead>tr>th {
  padding: 1px;
  text-align: center;
  z-index: 1;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget .separator {
  position: relative;
  color: red;
  width: auto;
  height: auto;
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .picker-switch,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table th.prev span,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table th.next span,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.day>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget a[data-action="togglePicker"],
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget a[data-action="togglePicker"]:hover,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget span,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .timepicker-hours span,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .timepicker-minutes span,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .separator,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.minute>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.hour>div {
  color: #9a9a9a;
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table th.dow {
  color: rgba(255, 255, 255, 0.8);
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.old>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.new>div {
  color: rgba(255, 255, 255, 0.4);
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget button[data-action] {
  background-color: #fff;
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.active>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.active:hover>div {
  background-color: #fff;
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td:not(.active).day:hover>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.hour:hover>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.minute:hover>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.second:hover>div,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td span:hover {
  background: rgba(255, 255, 255, 0.2);
}

input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,
input.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

input.datetimepicker[data-color="orange"]+.bootstrap-datetimepicker-widget {
  background-color: #5e72e4;
}

input.datetimepicker[data-color="orange"]+.bootstrap-datetimepicker-widget table td.active>div,
input.datetimepicker[data-color="orange"]+.bootstrap-datetimepicker-widget table td.active:hover>div,
input.datetimepicker[data-color="orange"]+.bootstrap-datetimepicker-widget button[data-action],
input.datetimepicker[data-color="orange"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,
input.datetimepicker[data-color="orange"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #5e72e4;
}

input.datetimepicker[data-color="blue"]+.bootstrap-datetimepicker-widget {
  background-color: #11cdef;
}

input.datetimepicker[data-color="blue"]+.bootstrap-datetimepicker-widget table td.active>div,
input.datetimepicker[data-color="blue"]+.bootstrap-datetimepicker-widget table td.active:hover>div,
input.datetimepicker[data-color="blue"]+.bootstrap-datetimepicker-widget button[data-action],
input.datetimepicker[data-color="blue"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,
input.datetimepicker[data-color="blue"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #11cdef;
}

input.datetimepicker[data-color="green"]+.bootstrap-datetimepicker-widget {
  background-color: #2dce89;
}

input.datetimepicker[data-color="green"]+.bootstrap-datetimepicker-widget table td.active>div,
input.datetimepicker[data-color="green"]+.bootstrap-datetimepicker-widget table td.active:hover>div,
input.datetimepicker[data-color="green"]+.bootstrap-datetimepicker-widget button[data-action],
input.datetimepicker[data-color="green"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,
input.datetimepicker[data-color="green"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #2dce89;
}

input.datetimepicker[data-color="red"]+.bootstrap-datetimepicker-widget {
  background-color: #f5365c;
}

input.datetimepicker[data-color="red"]+.bootstrap-datetimepicker-widget table td.active>div,
input.datetimepicker[data-color="red"]+.bootstrap-datetimepicker-widget table td.active:hover>div,
input.datetimepicker[data-color="red"]+.bootstrap-datetimepicker-widget button[data-action],
input.datetimepicker[data-color="red"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,
input.datetimepicker[data-color="red"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #f5365c;
}

input.datetimepicker[data-color="yellow"]+.bootstrap-datetimepicker-widget {
  background-color: #fb6340;
}

input.datetimepicker[data-color="yellow"]+.bootstrap-datetimepicker-widget table td.active>div,
input.datetimepicker[data-color="yellow"]+.bootstrap-datetimepicker-widget table td.active:hover>div,
input.datetimepicker[data-color="yellow"]+.bootstrap-datetimepicker-widget button[data-action],
input.datetimepicker[data-color="yellow"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,
input.datetimepicker[data-color="yellow"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #fb6340;
}

.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .day,
.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .minute {
  color: rgba(255, 255, 255, 0.7);
}

.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .day:hover,
.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .minute:hover {
  color: #212529;
}

.bootstrap-datetimepicker-widget.dropdown-black table td span,
.bootstrap-datetimepicker-widget.dropdown-black table td.minute,
.bootstrap-datetimepicker-widget.dropdown-black table td.hour {
  color: rgba(255, 255, 255, 0.7);
}

.bootstrap-datetimepicker-widget.dropdown-black table td span:hover,
.bootstrap-datetimepicker-widget.dropdown-black table td.minute:hover,
.bootstrap-datetimepicker-widget.dropdown-black table td.hour:hover {
  background: transparent;
  color: rgba(255, 255, 255, 0.4);
}

.bootstrap-datetimepicker-widget.dropdown-black table td span:hover div,
.bootstrap-datetimepicker-widget.dropdown-black table td.minute:hover div,
.bootstrap-datetimepicker-widget.dropdown-black table td.hour:hover div {
  background: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-black table td .btn[data-action] {
  color: #fff;
}

.bootstrap-datetimepicker-widget.dropdown-black table td .btn[data-action="togglePeriod"] {
  background: transparent;
}

.dropzone .dz-button {
  padding: 0;
  border: none;
  text-align: center;
  color: #8898aa;
  transition: all 0.15s ease;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
}

.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
  float: right;
}

.fc-dayGrid-view .fc-body .fc-row {
  min-height: 4em;
}

.fc.fc-theme-standard td,
.fc.fc-theme-standard th,
.fc.fc-theme-standard .fc-scrollgrid {
  border-color: #eff1f3 !important;
}

.fc .fc-h-event {
  border: none;
}

.fc .fc-col-header-cell.fc-day {
  text-align: left;
  padding: 0.75rem 1rem;
}

.fc .fc-col-header-cell.fc-day .fc-col-header-cell-cushion {
  padding: 0;
  color: #8898aa;
}

.fc .fc-day .fc-daygrid-day-top {
  flex-direction: row;
}

.fc .fc-day .fc-daygrid-day-top .fc-daygrid-day-number {
  font-size: 0.875rem;
  font-weight: 600;
  color: #67779d;
  padding: 0.5rem 1rem;
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: inherit !important;
}

.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number {
  color: #fb6340;
}

.fc .fc-event {
  margin: 2px 9px 1px !important;
}

.fc .fc-event-main {
  padding: 0;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  border: 0;
}

.fc .fc-event-main .fc-event-title {
  padding: 0.4rem 0.5rem;
  display: block;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.fc .fc-event-main .fc-time {
  float: left;
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 6px;
  margin: 0 0 0 -1px;
}

.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

.noUi-horizontal {
  height: 5px;
}

.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  left: -17px;
  top: -6px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
  right: -17px;
  left: auto;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #5e72e4;
}

.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
  outline: none;
}

.noUi-active {
  outline: none;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #ccc;
}

.noUi-marker-sub {
  background: #aaa;
}

.noUi-marker-large {
  background: #aaa;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%, 0);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-target {
  background: #eceeef;
  border-radius: 5px;
  border: 0;
  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);
  margin: 15px 0;
  cursor: pointer;
}

.noUi-horizontal {
  height: 5px;
}

html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
  right: -10px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-connect {
  background: #5e72e4;
  box-shadow: none;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  top: -5px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  box-shadow: none;
  cursor: pointer;
  background-color: #5e72e4;
  border: 0;
  transition: box-shadow 0.15s, transform 0.15s;
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
  transform: scale(1.2);
}

.input-slider--cyan .noUi-connect {
  background: #2bffc6;
}

.input-slider--cyan.noUi-horizontal .noUi-handle,
.input-slider--cyan.noUi-vertical .noUi-handle {
  background-color: #2bffc6;
}

.input-slider--red .noUi-connect {
  background: #f5365c;
}

.input-slider--red.noUi-horizontal .noUi-handle,
.input-slider--red.noUi-vertical .noUi-handle {
  background-color: #f5365c;
}

.input-slider--green .noUi-connect {
  background: #2dce89;
}

.input-slider--green.noUi-horizontal .noUi-handle,
.input-slider--green.noUi-vertical .noUi-handle {
  background-color: #2dce89;
}

.input-slider--yellow .noUi-connect {
  background: #ffd600;
}

.input-slider--yellow.noUi-horizontal .noUi-handle,
.input-slider--yellow.noUi-vertical .noUi-handle {
  background-color: #ffd600;
}

.input-slider--pink .noUi-connect {
  background: #f3a4b5;
}

.input-slider--pink.noUi-horizontal .noUi-handle,
.input-slider--pink.noUi-vertical .noUi-handle {
  background-color: #f3a4b5;
}

/* Disabled state */
[disabled] .noUi-connect,
[disabled].noUi-connect {
  background: #b2b2b2;
}

[disabled] .noUi-handle,
[disabled].noUi-origin {
  cursor: not-allowed;
}

/* Range slider value labels */
.range-slider-value {
  font-size: 0.75rem;
  font-weight: 500;
  background-color: rgba(33, 37, 41, 0.7);
  color: #fff;
  border-radius: 10px;
  padding: 0.4em 0.8em 0.3em 0.85em;
}

.range-slider-wrapper .upper-info {
  font-weight: 400;
  margin-bottom: 5px;
}

.input-slider-value-output {
  background: #333;
  color: #fff;
  padding: 4px 8px;
  position: relative;
  top: 12px;
  font-size: 11px;
  border-radius: 2px;
}

.input-slider-value-output:after {
  bottom: 100%;
  left: 10px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #333;
  border-width: 4px;
  margin-left: -4px;
}

.input-slider-value-output.left:after {
  left: 10px;
  right: auto;
}

.input-slider-value-output.right:after {
  right: 10px;
  left: auto;
}

@media (min-width: 576px) {
  .sweet-alert {
    margin-top: 100px !important;
  }
}

@media (max-width: 767.98px) {
  .sweet-alert {
    margin-top: 50px !important;
  }
}

.react-bootstrap-table .table {
  margin-bottom: 1.25rem;
  border-bottom: 1px solid #e9ecef;
}

.react-bootstrap-table th {
  color: #000000;
  background-color: #f6f9fc;
}

.react-bootstrap-table th.sortable {
  position: relative;
}

.react-bootstrap-table .order-4:after,
.react-bootstrap-table .caret-4-asc:after,
.react-bootstrap-table .caret-4-desc:after {
  right: 0.5em;
  content: "\\2193";
}

.react-bootstrap-table .order-4:before,
.react-bootstrap-table .caret-4-asc:before,
.react-bootstrap-table .caret-4-desc:before {
  right: 1em;
  content: "\\2191";
}

.react-bootstrap-table .order-4:after,
.react-bootstrap-table .order-4:before,
.react-bootstrap-table .caret-4-asc:after,
.react-bootstrap-table .caret-4-asc:before,
.react-bootstrap-table .caret-4-desc:after,
.react-bootstrap-table .caret-4-desc:before {
  position: absolute;
  bottom: 1.1em;
  display: block;
  opacity: 0.3;
}

.react-bootstrap-table .caret-4-asc:before {
  opacity: 1;
}

.react-bootstrap-table .caret-4-desc:after {
  opacity: 1;
}

.react-bootstrap-table-pagination .dataTables_length {
  display: inline-block;
}

.react-bootstrap-table-pagination .dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  display: inline-block;
  margin-bottom: 0.5rem;
}

.react-bootstrap-table-pagination .dataTables_length select {
  width: auto;
  display: inline-block;
}

.react-bootstrap-table-pagination .dataTables_length select.form-control-sm {
  height: calc(1.8125rem + 6px);
}

.react-bootstrap-table-pagination .dataTables_length,
.react-bootstrap-table-pagination .react-bootstrap-table-pagination-total {
  font-size: 0.875rem;
}

.react-bootstrap-table-pagination .react-bootstrap-table-pagination-list .pagination {
  justify-content: flex-end;
  padding-right: 1.5rem;
}

.dataTables_filter {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
  float: left;
}

.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}

.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}

.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  padding: 20px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.375rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 292px;
}

@media (max-width: 575.98px) {
  .rdtPicker {
    padding: 5px;
    min-width: 262px;
  }
}

.rdtPicker {
  display: block;
  top: 50px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  visibility: hidden;
  position: relative;
}

.rdtPicker .rdtTimeToggle:before {
  visibility: visible;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal normal 1em/1 "Nucleo";
  font-size: 18px;
  content: "\\EA5E";
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #fff !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 50%;
}

.rdtDay.rdtToday.rdtActive,
.rdtDay.rdtActive,
.rdtDay.rdtActive:hover,
.rdtDay.start-date,
.rdtDay.end-date,
.rdtDay.middle-date,
.rdtDay.start-date:hover,
.rdtDay.end-date:hover,
.rdtDay.middle-date:hover {
  background-color: #11cdef !important;
  color: #fff !important;
}

.rdtDay.start-date {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rdtDay.middle-date {
  border-radius: 0;
}

.rdtDay.end-date {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rdtDays tr .dow {
  text-align: center;
  font-size: 12px;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
  font-weight: 300;
  font-size: 0.875rem;
  width: 20px;
  height: 20px;
}

.rdtDays tr .rdtDay {
  color: #525f7f;
  font-size: 0.875rem;
}

.rdtDays tr .rdtDay.rdtOld,
.rdtDays tr .rdtDay.rdtNew {
  color: #adb5bd;
  font-weight: 300;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover,
.rdtPicker .rdtTimeToggle:hover:before {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker tr .dow {
  width: 14.2857%;
  border-bottom: none;
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  font-weight: 500;
  border-radius: 0.375rem;
}

.rdtPicker th.rdtSwitch {
  font-weight: 500;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  width: 145px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #525f7f;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  /* Konqueror */
  /* Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters>div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}

.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}

.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #11cdef;
  border-radius: 50%;
  border: 1px solid #11cdef;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #adb5bd;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  /* Konqueror */
  /* Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}

.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtMonth.start-date,
.rdtMonths .rdtMonth.end-date,
.rdtMonths .rdtMonth.middle-date,
.rdtMonths .rdtYear.rdtActive,
.rdtMonths .rdtYear.start-date,
.rdtMonths .rdtYear.end-date,
.rdtMonths .rdtYear.middle-date,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtMonth.start-date,
.rdtYears .rdtMonth.end-date,
.rdtYears .rdtMonth.middle-date,
.rdtYears .rdtYear.rdtActive,
.rdtYears .rdtYear.start-date,
.rdtYears .rdtYear.end-date,
.rdtYears .rdtYear.middle-date {
  background-color: #11cdef !important;
  color: #fff;
}

.input-group .input-group-prepend+.rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .input-group-prepend+.rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group>.rdt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.form-group .rdt {
  margin-bottom: 0;
  flex: 1 1 auto;
}

.vector-map .jvectormap-zoomin,
.vector-map .jvectormap-zoomout {
  cursor: pointer;
  margin-right: 0.5rem;
  font-size: 0.75rem;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  text-transform: none;
  will-change: transform;
  line-height: 1.5;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  color: #fff;
  border-color: #5e72e4;
  background-color: #5e72e4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  font-weight: 600;
  display: inline-block;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  border: 1px solid transparent;
}

.rna-wrapper .alert {
  display: flex !important;
  max-width: 600px;
  width: calc(100% - 30px);
  padding-right: 80px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.85);
}

.rna-wrapper .alert:hover {
  z-index: 1081 !important;
}

.rna-wrapper .alert:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) {
  background-color: rgba(0, 0, 0, 0.95);
}

.rna-wrapper .alert:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close {
  color: #ffd600;
}

.rna-wrapper .alert:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close:hover {
  opacity: 0.8;
}

.rna-wrapper .alert .ni[data-notify="icon"] {
  position: relative;
  top: 4px;
}

.rna-wrapper .alert .alert-title {
  display: block;
  font-size: 1rem;
  font-weight: 600;
}

.rna-wrapper .alert .close {
  top: 1rem !important;
  right: 1.5rem !important;
  transform: translateY(0);
}

.rna-wrapper .alert [data-notify="icon"] {
  font-size: 1.25rem;
  margin-right: 1.25rem;
  display: inline-block;
  vertical-align: middle;
}

.ql-container {
  position: relative;
}

.ql-tooltip {
  z-index: 1050;
}

.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.ReactTable * {
  box-sizing: border-box;
}

.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
}

.ReactTable .rt-thead.-filters .rt-th {
  border-right: 1px solid rgba(0, 0, 0, 0.02);
}

.ReactTable .rt-thead.-header {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-thead .rt-tr {
  text-align: center;
}

.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
}

.ReactTable .rt-thead .rt-th.-sort-asc,
.ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6);
}

.ReactTable .rt-thead .rt-th.-sort-desc,
.ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6);
}

.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}

.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-thead .rt-th:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}

.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.02);
}

.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
  text-overflow: clip;
}

.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 7px 5px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
}

.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}

.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}

.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}

.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.ReactTable .-pagination input,
.ReactTable .-pagination select {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
}

.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.1);
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: default;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}

.ReactTable .-pagination .-center {
  flex: 1.5 1;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;
}

.ReactTable .-pagination .-pageJump {
  display: inline-block;
}

.ReactTable .-pagination .-pageJump input {
  width: 70px;
  text-align: center;
}

.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}

.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

.ReactTable .-loading>div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}

.ReactTable .-loading.-active>div {
  transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}

.bootstrap-tagsinput .tag a {
  position: absolute;
  top: 50%;
  margin-left: 10px;
  cursor: pointer;
  transform: translate(0, -50%);
  color: #fff;
}

.bootstrap-tagsinput .tag a::after {
  font-size: 16px;
  content: "×";
}

.avatar-group .avatar {
  margin-right: 0.2rem;
}

.badge+.badge {
  margin-left: 4px;
}

.badge.badge-dot i {
  margin-right: 0.6rem;
}

.btn+.btn {
  margin-left: 4px;
}

.btn-group+.btn-group {
  margin-left: 4px;
}

.btn.btn-sm.btn-.btn-icon-only.text-light,
.btn-group-sm>.btn.btn-.btn-icon-only.text-light {
  background-color: transparent;
}

.input-group .btn+.btn {
  margin-left: -1px;
}

.custom-checkbox-primary .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-secondary .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-success .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-info .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-warning .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-danger .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-light .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-dark .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-default .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-white .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-neutral .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox-darker .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.icon-actions a i+span {
  margin-left: 7px;
}

.icon-actions a+a {
  margin-left: 4px;
}

.input-group.is-invalid~.invalid-feedback {
  display: block;
}

button:focus,
:focus {
  outline: none;
}

@keyframes show-navbar-dropdown {
  0% {
    opacity: 0;
    transition: visibility 0.25s, opacity 0.25s;
  }

  100% {
    opacity: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/argon-dashboard-pro-react.css","webpack://./src/assets/scss/bootstrap-rtl/bootstrap-rtl.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/custom/_variables.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./src/assets/scss/core/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./src/assets/scss/core/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./src/assets/scss/core/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./src/assets/scss/core/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./src/assets/scss/core/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./src/assets/scss/core/avatars/_avatar.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/core/alerts/_alert.scss","webpack://./src/assets/scss/core/alerts/_alert-dismissible.scss","webpack://./src/assets/scss/core/alerts/_alert-notify.scss","webpack://./src/assets/scss/core/avatars/_avatar-group.scss","webpack://./src/assets/scss/core/badges/_badge.scss","webpack://./src/assets/scss/core/badges/_badge-circle.scss","webpack://./src/assets/scss/core/badges/_badge-dot.scss","webpack://./src/assets/scss/core/badges/_badge-floating.scss","webpack://./src/assets/scss/core/breadcrumbs/_breadcrumb.scss","webpack://./src/assets/scss/core/buttons/_button.scss","webpack://./src/assets/scss/core/buttons/_button-group.scss","webpack://./src/assets/scss/core/buttons/_button-icon.scss","webpack://./src/assets/scss/core/cards/_card.scss","webpack://./src/assets/scss/core/cards/_card-animations.scss","webpack://./src/assets/scss/core/cards/_card-blockquote.scss","webpack://./src/assets/scss/core/cards/_card-money.scss","webpack://./src/assets/scss/core/cards/_card-pricing.scss","webpack://./src/assets/scss/core/cards/_card-profile.scss","webpack://./src/assets/scss/core/cards/_card-stats.scss","webpack://./src/assets/scss/core/charts/_chart.scss","webpack://./src/assets/scss/core/close/_close.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./src/assets/scss/core/collapse/_accordion.scss","webpack://./src/assets/scss/core/content/_main-content.scss","webpack://./src/assets/scss/core/custom-forms/_custom-form.scss","webpack://./src/assets/scss/core/custom-forms/_custom-control.scss","webpack://./src/assets/scss/core/custom-forms/_custom-checkbox.scss","webpack://./src/assets/scss/core/mixins/_custom-forms.scss","webpack://./src/assets/scss/core/custom-forms/_custom-radio.scss","webpack://./src/assets/scss/core/custom-forms/_custom-toggle.scss","webpack://./src/assets/scss/core/dropdowns/_dropdown.scss","webpack://./src/assets/scss/core/footers/_footer.scss","webpack://./src/assets/scss/core/forms/_form.scss","webpack://./src/assets/scss/core/forms/_input-group.scss","webpack://./src/assets/scss/core/forms/_form-extend.scss","webpack://./src/assets/scss/core/forms/_form-validation.scss","webpack://./src/assets/scss/core/grid/_grid.scss","webpack://./src/assets/scss/core/headers/_header.scss","webpack://./src/assets/scss/core/icons/_icon.scss","webpack://./src/assets/scss/core/icons/_icon-actions.scss","webpack://./src/assets/scss/core/icons/_icon-shape.scss","webpack://./src/assets/scss/core/mixins/_icon.scss","webpack://./src/assets/scss/core/list-groups/_list-group.scss","webpack://./src/assets/scss/core/list-groups/_list-check.scss","webpack://./src/assets/scss/core/maps/_map.scss","webpack://./src/assets/scss/core/masks/_mask.scss","webpack://./src/assets/scss/core/medias/_media-comment.scss","webpack://./src/assets/scss/core/modals/_modal.scss","webpack://./src/assets/scss/core/mixins/_modals.scss","webpack://./src/assets/scss/core/navbars/_navbar.scss","webpack://./src/assets/scss/core/navbars/_navbar-floating.scss","webpack://./src/assets/scss/core/navbars/_navbar-vertical.scss","webpack://./src/assets/scss/core/navbars/_navbar-search.scss","webpack://./src/assets/scss/core/navbars/_navbar-dropdown.scss","webpack://./src/assets/scss/core/navbars/_navbar-collapse.scss","webpack://./src/assets/scss/core/navbars/_navbar-top.scss","webpack://./src/assets/scss/core/navs/_nav.scss","webpack://./src/assets/scss/core/navs/_nav-pills.scss","webpack://./src/assets/scss/core/paginations/_pagination.scss","webpack://./src/assets/scss/core/popovers/_popover.scss","webpack://./src/assets/scss/core/mixins/_popover.scss","webpack://./src/assets/scss/core/progresses/_progress.scss","webpack://./src/assets/scss/core/rtl/_rtl.scss","webpack://./src/assets/scss/core/separators/_separator.scss","webpack://./src/assets/scss/core/sections/_nucleo-icons.scss","webpack://./src/assets/scss/core/shortcuts/_shortcut.scss","webpack://./src/assets/scss/core/tables/_table.scss","webpack://./src/assets/scss/core/tables/_table-actions.scss","webpack://./src/assets/scss/core/tables/_table-sortable.scss","webpack://./src/assets/scss/core/timeline/_timeline.scss","webpack://./src/assets/scss/core/type/_type.scss","webpack://./src/assets/scss/core/type/_article.scss","webpack://./src/assets/scss/core/type/_display.scss","webpack://./src/assets/scss/core/type/_heading.scss","webpack://./src/assets/scss/core/utilities/_backgrounds.scss","webpack://./src/assets/scss/core/utilities/_blurable.scss","webpack://./src/assets/scss/core/utilities/_floating.scss","webpack://./src/assets/scss/core/utilities/_helper.scss","webpack://./src/assets/scss/core/utilities/_image.scss","webpack://./src/assets/scss/core/utilities/_opacity.scss","webpack://./src/assets/scss/core/utilities/_overflow.scss","webpack://./src/assets/scss/core/utilities/_position.scss","webpack://./src/assets/scss/core/utilities/_shadows.scss","webpack://./src/assets/scss/core/utilities/_sizing.scss","webpack://./src/assets/scss/core/utilities/_spacing.scss","webpack://./src/assets/scss/core/utilities/_text.scss","webpack://./src/assets/scss/core/utilities/_transform.scss","webpack://./src/assets/scss/core/vendors/_bootstrap-datepicker.scss","webpack://./src/assets/scss/core/vendors/_bootstrap-tagsinput.scss","webpack://./src/assets/scss/core/vendors/_chartjs.scss","webpack://./src/assets/scss/core/vendors/_datatables.scss","webpack://./src/assets/scss/core/vendors/_dropzone.scss","webpack://./src/assets/scss/core/vendors/_fullcalendar.scss","webpack://./src/assets/scss/core/vendors/_jvectormap.scss","webpack://./src/assets/scss/core/vendors/_lavalamp.scss","webpack://./src/assets/scss/core/vendors/_nouislider.scss","webpack://./src/assets/scss/core/vendors/_quill.scss","webpack://./src/assets/scss/core/vendors/_scrollbar.scss","webpack://./src/assets/scss/core/vendors/_select2.scss","webpack://./src/assets/scss/core/vendors/_sweet-alert-2.scss","webpack://./src/assets/scss/core/vendors/_plugin-datetimepicker.scss","webpack://./src/assets/scss/react/plugins/_plugin-dropzone.scss","webpack://./src/assets/scss/react/plugins/_plugin-fullcalendar.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./src/assets/scss/react/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-bootstrap-table2.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-jvectormap.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-notification-alert.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-quill.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-table.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-tagsinput.scss","webpack://./src/assets/scss/react/_badge.scss","webpack://./src/assets/scss/react/_buttons.scss","webpack://./src/assets/scss/react/_forms.scss","webpack://./src/assets/scss/react/_icon-actions.scss","webpack://./src/assets/scss/react/_mixins.scss","webpack://./src/assets/scss/react/_navbar-dropdown.scss"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;;;;;;;;;;;;;;CCFA;ADkBA;;;;;;gFCVS;ADiBT;EACE,cAAc;ACfhB;;ADkBA;EACE,4CChBC;ADiBH;;AAEA;EACE,cCfc;ADgBhB;;AAEA;EC1BA,iBAcc;ADcd;;AAEA;EACE,gBCbgB;ADclB;;AAEA;ECVE,gBAAQ;EDYR,eCXgB;EDWhB,qBCXgB;ADYlB;;AAEA;EACE,gBCVE;EDWF,eCVkB;EDUlB,qBCVkB;EDWlB,kBCVkB;EAhCpB,cAmCE;ADSF;;AAEA;EC9CA,eAwCY;EDQV,cCPoB;EDOpB,oBCPoB;ADQtB;;AAEA;EACE;ICpDF,YA+CW;IACP,YAAU;IACV,gBAAe;EDOjB;;ECxDF;IAsDI,mBACD;IAvDH,cAwDa;EDKX;AACF;;AAEA;EACE,+BCDC;EAhEH,cAiEW;ADEX;;AAEA;;EAEE,kBCCS;EAxEX,gBA0EY;EDDV,8BCGC;EA5EH,eA6EY;EDFV,gBCGS;ADFX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EC9EA,kBAoJE;EDrBA,eCsBS;EDrBT,kBCuBC;EAvJH,mBAwJE;ADtBF;;AAEA;;;;;;;;;;;;ECpIA,YA4KE;AD3BF;;AAEA;EACE,WC6BS;AD5BX;;AAEA;EACE,mBC+BC;AD9BH;;AAEA;EC3JA,mBA4LgB;AD/BhB;;AAEA;EACE,UCiCS;ADhCX;;AAEA;EACE,mBCmCC;ADlCH;;AAEA;ECvKA,mBA4ME;ADnCF;;AAEA;EACE,UCqCE;ADpCJ;;AAEA;EACE,mBCuCC;ADtCH;;AAEA;ECnLA,mBA4NE;ADvCF;;AAEA;EACE,UCyCE;ADxCJ;;AAEA;EACE,mBC2CC;AD1CH;;AAEA;EC/LA,kBA4OE;AD3CF;;AAEA;EACE,UC6CE;ED5CF,WC6CE;AD5CJ;;AAEA;ECgDE,kBAAiB;ED9CjB,WC+CE;AD9CJ;;AAEA;EACE,kBCiDa;EDhDb,WCiDW;ADhDb;;AAEA;EACE,SCmDS;EDlDT,WCoDE;ADnDJ;;AAEA;EACE,kBCsDY;EDrDZ,WCsDW;ADrDb;;AAEA;EACE,kBCwDW;EDvDX,WCyDE;ADxDJ;;AAEA;EACE,SC2DE;ED1DF,WC2DW;AD1Db;;AAEA;EACE,kBC6DE;ED5DF,WC6DU;AD5DZ;;AAEA;EACE,kBC+DG;ED9DH,WC+DE;AD9DJ;;AAEA;EACE,SCgEQ;ED/DR,WCgEW;AD/Db;;AAEA;EACE,kBCkEE;EDjEF,WCkEU;ADjEZ;;AAEA;EACE,iBCmEe;EDlEf,WCoEE;ADnEJ;;AAEA;EACE,UCqEU;EDpEV,WCqEW;ADpEb;;AAEA;EACE,WCuEE;EDtEF,OCuEI;ADtEN;;AAEA;EACE,mBCyEG;EDxEH,OCyEE;ADxEJ;;AAEA;EACE,mBC0EW;EDzEX,OC0EI;ADzEN;;AAEA;EACE,UC4EE;ED3EF,OC4EI;AD3EN;;AAEA;EACE,mBC8EG;ED7EH,OC8EE;AD7EJ;;AAEA;EACE,mBC+Ec;ED9Ed,OC+EI;AD9EN;;AAEA;EACE,UCiFE;EDhFF,OCiFI;ADhFN;;AAEA;EACE,mBCmFG;EDlFH,OCmFE;ADlFJ;;AAEA;EACE,mBCoFW;EDnFX,OCoFI;ADnFN;;AAEA;EACE,UCsFE;EDrFF,OCsFI;ADrFN;;AAEA;EACE,mBCuFkB;EDtFlB,OCwFE;ADvFJ;;AAEA;EACE,kBCyFkB;EDxFlB,OCyFI;ADxFN;;AAEA;EACE,WC2FE;ED1FF,OC2FI;AD1FN;;AAEA;EACE,kBC4FkB;ED3FlB,cC6FE;AD5FJ;;AAEA;EACE,0BC8FkB;ED7FlB,cC8FI;AD7FN;;AAEA;EACE,0BCgGmB;ED/FnB,cCgGI;AD/FN;;AAEA;EACE,iBCiGiB;EDhGjB,cCkGE;ADjGJ;;AAEA;EACE,0BCoGa;EDnGb,cCoGW;ADnGb;;AAEA;EACE,0BCuGG;EDtGH,cCuGE;ADtGJ;;AAEA;EACE,iBCyGY;EDxGZ,cCyGW;ADxGb;;AAEA;EACE,0BC4GG;ED3GH,cC4GE;AD3GJ;;AAEA;EACE,0BC8GY;ED7GZ,cC8Gc;AD7GhB;;AAEA;EACE,iBCgHW;ED/GX,cCiHE;ADhHJ;;AAEA;EACE,0BCkHsB;EDjHtB,cCkHW;ADjHb;;AAEA;EACE,yBCoHiB;EDnHjB,cCoHa;ADnHf;;AAEA;EACE,gBCqHe;EDpHf,cCsHE;ADrHJ;;AAEA;;EAEE;;;;;;;;;;;;IAYE,YC2HS;ED1HX;;EAEA;ICvZF,WAqhBI;ED5HF;;EAEA;IACE,mBC8Ha;ED7Hf;;EAEA;IACE,mBCgIC;ED/HH;;EAEA;ICnaF,UAqiBI;EDhIF;;EAEA;IACE,mBCkIS;EDjIX;;EAEA;IACE,mBCoIC;EDnIH;;EAEA;IC/aF,UAqjBI;EDpIF;;EAEA;IACE,mBCsIS;EDrIX;;EAEA;IACE,mBCwIC;EDvIH;;EAEA;IC3bF,UAqkBI;EDxIF;;EAEA;IACE,mBC0Ia;EDzIf;;EAEA;IACE,kBC2IgB;ED1IlB;;EAEA;ICvcF,UAqlBI;ID5IA,WC6IE;ED5IJ;;EAEA;IACE,kBC8IgB;IA3lBpB,WA6lBI;ED9IF;;EAEA;IACE,kBCgJgB;ID/IhB,WCgJE;ED/IJ;;EAEA;ICtdF,SAymBI;IDjJA,WCkJE;EDjJJ;;EAEA;IACE,kBCmJgB;IA/mBpB,WAinBI;EDnJF;;EAEA;IACE,kBCqJgB;IDpJhB,WCqJE;EDpJJ;;EAEA;ICreF,SA6nBI;IDtJA,WCuJE;EDtJJ;;EAEA;IACE,kBC0JC;IAroBL,WAsoBI;EDzJF;;EAEA;IC/eF,kBA4oBe;ID3JX,WC4JS;ED3JX;;EAEA;IACE,SC8JS;IAnpBb,WAqpBI;ED9JF;;EAEA;ICzfF,kBA2pBc;IDhKV,WCiKS;EDhKX;;EAEA;IACE,iBCoKC;IAnqBL,WAoqBI;EDnKF;;EAEA;ICngBF,UA0qBI;IDrKA,WCsKQ;EDrKV;;EAEA;IACE,WCuKS;IAhrBb,OAkrBI;EDvKF;;EAEA;IACE,mBCyKW;IDxKX,OCyKO;EDxKT;;EAEA;IClhBF,mBA8rBkB;ID1Kd,OC2KM;ED1KR;;EAEA;IACE,UC4KS;IApsBb,OAssBI;ED5KF;;EAEA;IACE,mBC8KQ;ID7KR,OC8KO;ED7KT;;EAEA;ICjiBF,mBAktBkB;ID/Kd,OCgLM;ED/KR;;EAEA;IACE,UCiLS;IAxtBb,OA0tBI;EDjLF;;EAEA;IACE,mBCmLa;IDlLb,OCmLM;EDlLR;;EAEA;IChjBF,mBAsuBI;IDpLA,OCqLO;EDpLT;;EAEA;IACE,UCsLS;IA5uBb,OA8uBI;EDtLF;;EAEA;IACE,mBCwLS;IDvLT,OCwLM;EDvLR;;EAEA;IC/jBF,kBA0vBI;IDzLA,OC0LO;EDzLT;;EAEA;IACE,WC2LS;IAhwBb,OAkwBI;ED3LF;;EAEA;IACE,kBC6LS;ID5LT,cC8LC;ED7LH;;EAEA;IC9kBF,0BA8wBmB;ID9Lf,cC+La;ED9Lf;;EAEA;IACE,0BCiMC;IArxBL,cAsxBI;EDhMF;;EAEA;IACE,iBCkMgB;IDjMhB,cCkMa;EDjMf;;EAEA;IC7lBF,0BAkyBqB;IDnMjB,cCoMc;EDnMhB;;EAEA;IACE,0BCsMC;IAzyBL,cA0yBI;EDrMF;;EAEA;IACE,iBCuMgB;IDtMhB,cCuMa;EDtMf;;EAEA;IC5mBF,0BAszBqB;IDxMjB,cCyMc;EDxMhB;;EAEA;IACE,0BC2MC;IA7zBL,cA8zBI;ED1MF;;EAEA;IACE,iBC4MgB;ID3MhB,cC4Ma;EAp0BjB;;EAAA;IA20BI,0BACD;IACD,cAAa;ED/Mb;;EAEA;IChoBF,yBAk1BwB;IAl1BxB,cAm1BI;EDhNF;;EAEA;IACE,gBCiNgB;IDhNhB,cCiNa;EDhNf;AACF;;AAEA;;EAEE;;;;;;;;;;;;ICiOE,YAAW;EA92Bf;;ED4pBE;ICuNE,WAAA;EAn3BJ;;EDgqBE;ICwNE,mBACD;EAz3BH;;EDoqBE;ICpqBF,mBA83BE;EDxNA;;EC4NA;IAl4BF,UAm4BI;EDzNF;;EAEA;IC5qBF,mBAw4BiB;ED1Nf;;EC+NA;IA74BF,mBA84BI;ED5NF;;EAEA;ICgOE,UAAO;EAp5BX;;EDwrBE;ICxrBF,mBA05BiB;EDhOf;;EAEA;ICkOE,mBAAiB;EA95BrB;;EDgsBE;ICmOE,UAAO;EAn6BX;;EDosBE;ICpsBF,mBAy6BE;EDnOA;;ECuOA;IA76BF,kBA86BiB;EDpOf;;EAEA;IACE,UCsOS;IDrOT,WCsOS;EAp7Bb;;EDitBE;ICjtBF,kBA27BiB;IA37BjB,WA47BE;EA57BF;;EDstBE;IC0OE,kBAAgB;IAh8BpB,WAk8BE;EDzOA;;ECztBF;IAAA,SAu8BE;IACE,WAAO;EAx8BX;;EAAA;IA68BI,kBAAiB;IACjB,WAAW;EA98Bf;;EAAA;IAo9BI,kBAAA;IACA,WAAA;ED7OF;;ECxuBF;IAAA,SA09BE;IACE,WAAA;ED9OF;;EAEA;IC/uBF,kBAg+Be;IACX,WAAO;EAj+BX;;EDovBE;ICpvBF,kBAu+Be;IACX,WAAA;EAx+BJ;;EDyvBE;ICoPE,SAAA;IACA,WAAA;EDlPF;;EAEA;ICqPE,kBAAA;IACA,WAAA;EDnPF;;EAEA;ICnwBF,iBA0/BE;IA1/BF,WA2/BE;EA3/BF;;EDwwBE;ICuPE,UAAA;IA//BJ,WAigCE;EDtPA;;EC3wBF;IAAA,WAsgCE;IAtgCF,OAugCE;EAvgCF;;EAAA;IA2gCI,mBAAA;IACA,OAAA;EDvPF;;ECrxBF;IAihCI,mBAAgB;IAChB,OAAA;EAlhCJ;;EAAA;IAAA,UAuhCE;IAvhCF,OAwhCE;EAxhCF;;EDiyBE;IC2PE,mBAAA;IACA,OAAA;EDzPF;;EAEA;IC4PE,mBAAmB;IACnB,OAAA;EAniCJ;;ED2yBE;IC3yBF,UAyiCE;IAziCF,OA0iCE;ED5PA;;EC9yBF;IAAA,mBA+iCkB;IACd,OAAA;ED7PF;;EAEA;ICgQE,mBAAc;IArjClB,OAujCE;ED/PA;;EAEA;ICkQE,UAAA;IACA,OAAA;EA7jCJ;;EAAA;IAmkCI,mBAAkB;IAnkCtB,OAqkCE;EDnQA;;ECl0BF;IA0kCI,kBACD;IA3kCH,OA4kCE;EDrQA;;ECv0BF;IAilCI,WAAW;IAjlCf,OAmlCE;EDvQA;;EC2QA;IAvlCF,kBAmlCE;IDnQE,cCyQE;EAGJ;;EDzQA;ICn1BF,0BAimCmB;IACf,cAAa;ED5Qf;;EAEA;ICgRA,0BAAwB;IAxmC1B,cAymCW;ED9QT;;EAEA;IC71BF,iBCGI;IDHJ,cA0mCW;ED1QT;;ECh2BF;IAgnCI,0BAAW;IACX,cAAa;ED5Qf;;EAEA;ICv2BF,0BAsnCsB;ID7QlB,cC8QW;EAGb;;ED9QA;IC52BF,iBA8nCI;IDhRA,cCiRS;EDhRX;;EAEA;IACE,0BCmRyB;IAG3B,cAAQ;EDpRR;;EAEA;IACE,0BCsRoB;IDrRpB,cCsRc;EDrRhB;;EAEA;IACE,iBCuRgB;IAnpCpB,cA86BI;EDhDF;;EC4RA;IA1pCF,0BA2pCiB;IDzRb,cC0Rc;EDzRhB;;EAEA;ICr4BF,yBAmqCc;IACV,cAAa;EApqCjB;;ED04BE;IC+RE,gBAAc;IACd,cAAa;EA1qCjB;AD84BA;;AAEA;;EAEE;;;;;;;;;;;;ICl5BF,YAgsCS;EAhsCT;;EAAA;IAAA,WAqsCS;EDlSP;;EAEA;ICqSE,mBAAiB;EA1sCrB;;EAAA;IAgtCI,mBAAgB;EDrSlB;;EC36BF;IAqtCI,UAAA;EDtSF;;EC/6BF;IA0tCI,mBAAW;EDvSb;;EAEA;ICr7BF,mBAguCW;EDzST;;EAEA;IC4SE,UAAA;EAruCJ;;EAAA;IA2uCI,mBAAc;ED5ShB;;EC/7BF;IAgvCI,mBAAmB;ED7SrB;;ECn8BF;IAqvCI,UAAA;ED9SF;;EAEA;ICiTE,mBAAc;ED/ShB;;EAEA;ICkTE,kBAAc;EA/vClB;;EAAA;IAAA,UAowCQ;IApwCR,WAqwCQ;EArwCR;;EAAA;IAywCI,kBAAA;IACA,WAAA;EA1wCJ;;EAAA;IAAA,kBA+wCW;IA/wCX,WAgxCQ;EAhxCR;;EAAA;IAoxCI,SAAA;IACA,WAAA;EArxCJ;;EAAA;IAAA,kBA0xCW;IA1xCX,WA2xCQ;EA3xCR;;EAAA;IA+xCI,kBAAA;IACA,WAAA;EAhyCJ;;EAAA;IAAA,SAqyCQ;IAryCR,WAsyCQ;EAtyCR;;EAAA;IA0yCI,kBAAA;IACA,WAAA;EA3yCJ;;EAAA;IAAA,kBAgzCW;IAhzCX,WAizCQ;EAjzCR;;EAAA;IAAA,SAqzCQ;IArzCR,WAszCQ;EAtzCR;;EDmgCE;ICuTE,kBAAiB;IA1zCrB,WA4zCQ;EA5zCR;;EAAA;IAAA,iBAg0CW;IAh0CX,WAi0CQ;EAj0CR;;EAAA;IAAA,UAq0CQ;IAr0CR,WAs0CQ;EAt0CR;;EDkhCE;IClhCF,WA20CE;IA30CF,OA40CE;EA50CF;;EDuhCE;ICyTE,mBACD;IAj1CH,OAk1CE;EDxTA;;EAEA;IC5hCF,mBAw1Ce;IACX,OAAA;EAz1CJ;;EDiiCE;ICjiCF,UA+1CE;IACE,OAAA;ED5TF;;EAEA;IC+TE,mBAAiB;IAr2CrB,OAu2CE;ED9TA;;ECziCF;IA42CI,mBAAU;IACV,OAAM;ED/TR;;EC9iCF;IAk3CI,UAAA;IACA,OAAA;EAn3CJ;;EDqjCE;ICmUE,mBAAmB;IACnB,OAAA;EAz3CJ;;ED0jCE;IC1jCF,mBA+3CE;IACE,OAAO;EDnUT;;EAEA;ICsUE,UAAO;IACP,OAAA;EDpUF;;EAEA;ICsUE,mBAAQ;IA14CZ,OA44CE;EDrUA;;EAEA;ICuUE,kBAAkB;IAClB,OAAA;EDrUF;;EC5kCF;IAAA,WAs5CE;IACE,OAAM;EDtUR;;ECjlCF;IAAA,kBA45CE;IACE,cAAU;EDvUZ;;ECtlCF;IAk6CI,0BAAU;IACV,cAAO;EDxUT;;EAEA;IC2UA,0BAA4B;IAx6C9B,cAy6CI;EDzUF;;EAEA;IClmCF,iBA86CI;IA96CJ,cA+6CI;ED1UF;;EAEA;IACE,0BC4UW;ID3UX,cC4UY;ED3Ud;;EAEA;IC5mCF,0BA47CkB;IACd,cAAO;ED9UT;;EGvnCE;IAAA,iBAAc;IAAd,cAAa;EAAb;;EAAA;IAAA,0BAAc;IAAd,cAAc;EAAd;;EAAA;IAAA,0BAAc;IAAd,cAAa;EAAb;;EAIA;IAAA,iBAAa;IAAb,cAAa;EAAb;;EAAA;IAAA,0BAAc;IAAd,cAAc;EAAd;;EAAA;IAAA,yBAAc;IAId,cAAgC;EAAhC;;EAAA;IAAA,gBAAgC;IAKlC,cAAA;EACA;AH6oCF;;AI3oCA;EACC,iBAAQ;AJ8oCT;;AI1oCA;EACE,iBAAa;AJ6oCf;;AAEA;EACE;IIvoCF,SAAS;EACP;;EAUF;;;;;;IAME,eClBgB;IDmBhB,cAAgB;IAAhB,oBAAgB;EAChB;;EAYF;;;;;;IAaE,cAAU;IJgnCR,eAAqB;IAArB,qBAAqB;EInmCvB;AJqmCF;;AAEA;;EI7lCE,mBAAa;EACb,eEoF8B;EFpF9B,qBEoF8B;AN4gChC;;AIplCA;;;;EAIE,mBAAgB;EAChB,iBAAA;AJulCF;;AAEA;;EInlCE,mBAAa;EJslCb,eAAe;AInlCjB;;AAEA;;EAEE,kBAAe;EJqlCf,cAAc;AIllChB;;AAEA;EACE,oBAAI;EACJ,mBACD;AJmlCD;;AAEA;EACE,OAAO;EIhlCP,WAAC;AJklCH;;AAEA;EI/kCA;IACE,gBAAgB;IJilCd,eAAqB;IAArB,qBAAqB;EI9kCxB;;EAEC;;IAGF,eAAM;IGxFF,iBH0FH;EJ8kCC;AIvkCF;;AJ0kCA;EO3qCI;IHqGF,gBAAc;EACd;AJykCF;;AAEA;EACE,UAAU;EIxkCZ,WAAI;AJ0kCJ;;AInkCA;EACE,iBCxGqB;EDyGrB,cAAA;AJskCF;;AAEA;EACE,QIpkCE;EJqkCF,UAAU;EI5jCX,WAAY;EACX,iBAAc;AJ8jChB;;AAEA;EACE,OI5jCE;EJ6jCF,WAAW;EIpjCb,YAAG;AACH;;AAEA;EACE,UAAA;EGpJE,QAAA;AP2sCJ;;AAEA;EIjjCE,OAAA;EAEA,WAAU;AJkjCZ;;AIviCA;EAEE;IJyiCE,UAAU;IIjiCV,QAAA;EACF;;EJoiCA;IIhiCE,OAAA;IAGF,WAAU;EACV;AJgiCF;;AAEA;;EIthCA,YAAQ;AJyhCR;;AAEA;;;;EI/gCE,kBAAC;EAED,gBAAY;AJmhCd;;AI1gCA;EAEE,kBAAS;EACT,gBE2JsC;ANi3BxC;;AAEA;;EI9/BA,YAAY;AJigCZ;;AI7/BA;;;EAGA,iBAAQ;EACR,gBAAS;AJggCT;;AAEA;EI9/BE,eAAa;AJggCf;;AI5/BA;EACE,4BACD;EJ8/BC,+BAA+B;EI5/BjC,4BAAM;EACN,yBAAO;AJ8/BP;;AAEA;;EAEE,2BAA2B;EIp/B7B,8BAAO;EACL,6BACD;EJq/BC,0BAA0B;AI/+B5B;;AJk/BA;EI/+BA,YAAC;AJi/BD;;AI3+BE;;EAEA,WAAC;AJ8+BH;;AAEA;EIv+BA,gBAAM;AJy+BN;;AAEA;;EIt+BE,4BACD;EJw+BC,+BAA+B;EIt+BjC,4BAAM;EACN,yBAAuB;AJw+BvB;;AAEA;EIp+BA,2BAAS;EACP,8BAAc;EAEd,6BACD;EJo+BC,0BAA0B;AIl+B5B;;AJq+BA;EI59BE,eAAS;AJ89BX;;AIx9BA;;;;EAIE,gBAAU;EACV,eAAe;AJ29BjB;;AAEA;EIz9BE,YAAW;AJ29Bb;;AAEA;;;;;;;EIn9BE,+BACD;EJ09BC,4BAA4B;EIx9B9B,4BAAgB;EAKd,yBAAoB;AJs9BtB;;AAEA;EI/8BE,gBAAA;EJi9BA,uBAAuB;AIz8BzB;;AJ48BA;;;;;;;EI77BE,8BACD;EJo8BC,2BAA2B;EIl8B7B,6BAAS;EACP,0BACD;AJm8BD;;AAEA;EACE,sBAAsB;EQ75CtB,wBAAoB;EACtB,iBAAkB;AR+5ClB;;AAEA;EQ75CE,kBHsX+B;EGrX/B,iBACD;AR85CD;;AAEA;;EAEE,iBQh6CM;ERi6CN,kBOvzCgB;APwzClB;;AAEA;;EQl6CE,kBAAM;ED8GF,iBAtCW;AP81CjB;;AAEA;EACE,gBAAgB;EQv6ChB,eAAM;EAAN,qBAAM;ARy6CR;;AQx6CA;ED2GM,YAtCW;APu2CjB;;AAEA;EQ16CE,iBH2Y+B;ELiiC/B,kBAAkB;EQx6CpB,0BAAW;AR06CX;;AAEA;EOzxCQ,YAAQ;AP2xChB;;AAEA;EQ36CA,kBAAW;AR66CX;;AAEA;EOjyCQ,iBAAiB;EPmyCvB,iBQj7CS;ARk7CX;;AQ76CA;EDmHQ,WAhES;AP83CjB;;AAEA;EACE,eQp7CS;ERq7CT,iBOl2CgB;APm2ClB;;AAEA;EQj7CE,WAAW;ARm7Cb;;AAEA;EACE,cO5yCmB;EP6yCnB,kBAAkB;AIz5CpB;;AJ45CA;EQ96CE;IACA,0BHtBS;ELs8CT;AQx6CF;;AR26CA;EQx6CE;IR06CE,YAAY;EQv6ChB;AACA;;AR06CA;EACE,mBAAmB;EQj6CrB,kBAAe;ARm6Cf;;AAEA;EQh6CA,YAAa;ARk6Cb;;AAEA;;EQh6CE;;;;;;IAeA,mBAAgB;IR05Cd,iBAAiB;EQt5CrB;ARw5CA;;AAEA;EQr5CA,WAAA;EACE,iBAAc;ED7CZ,kBAAW;APq8Cf;;AAEA;;ESxgDA;;ICOE,0BDLD;ET2gDC;ASvgDF;;AT0gDA;ESvgDE;IEEE,YAAa;ECFX;;EFFJ;IV+gDE,sBAAsB;ESjgD1B;;ETogDE;IS//CF,uBAAY;EACV;;ETkgDA;IS9/CF,uBAAgB;EFkCZ;AP+9CJ;;AatiDA;ENuEI;IMrEF,uBRmDe;EQlDf;;Eb0iDA;IACE,kBAAkB;IaliDlB,kBAAA;EACF;;EAEA;IACA,sBRkBS;IMjBP,kBNqS0B;IOvSxB,kBNgUiC;EOnUvC;;Eb4iDE;IajiDE,OAAA;IDRE,WAAU;EZ4iDd;AI51CF;;AJ+1CA;Ea9hDE;IAHF,YAMO;Eb8hDL;;EAEA;IACE,cAAc;IazhDlB,kBAAgB;EACd;Ab2hDF;;AElkDE;EAEA,gBAAgB;AAMd;;AAAA;;EYTF,YAAW;EACX,kBAAe;EACf,gBAAc;Ad4kDhB;;AAEA;;EElkDM,cALF;EF0kDF,+BEnkDK;EFokDL,4BAA4B;Ee7hD1B,4BAAwB;EbzCtB,yBALW;AF8kDjB;;AehiDI;;EfoiDF,kBM34CS;EN44CT,8BAA8B;EeriD5B,2BAAyB;EbzCvB,6BALF;EFslDF,0BE/kDK;AFglDP;;AAEA;EczlDE,gBAAe;EACf,eAA0B;EAA1B,qBAA0B;Ad2lD5B;;AEpjDE;;EAEE,WAAW;AFujDf;;AAEA;;EAEE,YAAY;AgB5mDZ;;AAoBE;EAAA,gBAPI;EAOJ,iBAPI;AAOJ;;AhBgmDJ;EgBjnDI,WAAA;AhBmnDJ;;AgB5lDM;EACE,gBAAa;EACb,kBAAY;AhB+lDpB;;AgBzlDU;;EFyBN,kBACD;EdokDD,mBAAmB;AgB9lDX;;AhBimDV;;EgBjmDU,WAAW;EFwBjB,WAAU;Ad6kDd;;AgBrmDU;EFwBN,YAAU;AdilDd;;AgBzmDU;EFwBN,kBAAuB;AdqlD3B;;AgB7mDU;EFwBN,eAAU;EACV,iBAAW;AdylDf;;AAEA;Ec5mDE,iBAAW;Ad8mDb;;AgB1mDU;EFbR,cAAU;EAIV,kBAAW;AdwnDb;;AAEA;;EAEE,mBAAmB;EgBnnDX,eAAoB;EAApB,qBAAoB;AhBqnD9B;;AAEA;;EcpoDE,kBAAU;EAIV,gBAAuC;EAAvC,sBAAuC;AdooDzC;;AAEA;EctoDE,gBAAW;EdwoDX,eAAqB;EAArB,qBAAqB;EgB/nDb,gBAAoB;AhBioD9B;;AAEA;EgBnoDU,gBAAoB;EFb5B,eAAsC;EAAtC,qBAAsC;AdmpDxC;;AgBtoDU;;;;;;;;EAAA,4BAAoB;EFb5B,yBAAsC;Ad+pDxC;;AgBlpDU;;;;;;;;EAMJ,2BAAsB;EAAE,0BAAa;AhBwpD3C;;AAEA;;;;;;;;EgBrpDQ,8BAAsB;EAAE,0BAAa;AhB+pD7C;;AAEA;;;;;;;;EgBjqDQ,+BAAsB;EAAE,yBAAa;AhB2qD7C;;AAEA;;;;;;;;;;;;EgB7qDgC,eAAa;EhB0rD3C,iBAAiB;AgB1rDX;;AhB6rDR;;;;;;;;;;;;EAYE,kBAAkB;EgBlsDR,cAAuB;AhBosDnC;;AgBpsDY;;;;EFhBV,QAAA;Ed2tDA,UAAU;AgB3sDA;;AhB8sDZ;EgB9sDY,WAAuB;AhBgtDnC;;AgBhtDY;EFhBV,gBAA8B;AdouDhC;;AAEA;EACE,iBAAiB;AeluDf;;AfquDJ;EACE,iBgB/vDkB;EhBgwDlB,iBgB/vDqB;AhBgwDvB;;AAEA;EgB7vDU,kBFuBL;EdwuDH,iBcvuDyB;AdwuD3B;;AAEA;EACE,ec1uDa;EEzBL,iBFuBN;Ad8uDJ;;AAEA;EACE,UchvDU;EdivDV,iBchvD0B;AdivD5B;;AAEA;EgBtwDM,UAAA;EhBwwDJ,UcvwDM;EdwwDN,mBcvwDW;EdwwDX,iBcvwDe;AdwwDjB;;AAEA;EgBvwDU,mBAAoB;EhBywD5B,iBctxDU;AduxDZ;;AAEA;EACE,UctxDA;EESQ,UAAoB;EhB+wD5B,mBc5xDU;Ed6xDV,iBczxDW;Ad0xDb;;AAEA;EgBnxDU,mBAAoB;EhBqxD5B,iBclyDsC;AdmyDxC;;AAEA;EACE,QclyDA;EESQ,SAAS;AhB2xDnB;;AAEA;EACE,Wc3yDS;Ed4yDT,OcxyDA;EESQ;;iCAEC;EAIL,2BAAsB;EhBoyD1B,sHgBpyDyC;AhBqyD3C;;AAEA;EACE,UgBpyDkB;EACZ,QAAA;EhB2yDN;;8BgB3yD2C;EAArC,2BAAsB;EhB+yD5B,sHgB/yD2C;AhBgzD7C;;AAEA;;EgBlzDQ,SAAA;EhBqzDN,WgBtzDkB;EACZ,mBAAsB;AhBuzD9B;;AAEA;;EAEE,UgB5zDiB;EAQP,UAAA;EhBszDV,kBct0D4B;Adu0D9B;;AAEA;EACE,Uc10DA;EEgBU,OAAA;EhB4zDV,kBc50D8C;EEgBpC,cAAuB;EhB8zDjC,ec90D8B;Ad+0DhC;;AAEA;;EgBj0DY;;IAAA,cAAuB;IFhBjC,mBAA8B;EEgBpB;;EAAA;;IAAA,cAAuB;IFhBjC,mBAA8B;Ed61D9B;;EgBn3DI;IACE,SAAA;IACA,UAAS;IACT,oBACD;EAIG;AhBk3DV;;AAEA;EACE,sBc71DyB;Ad81D3B;;AAEA;EACE,uBch2D0B;Adi2D5B;;AAEA;EgB53DU,eAAc;EhB83DtB,iBct2DyB;Edu2DzB,iBct2D0B;EEzBlB,eAAc;EhBi4DtB,ccz2DY;Ed02DZ,iBcz2Da;EEnBT,iBAAmB;EhB83DvB,gBc73Dc;Ed83Dd,ec73DW;Ed83DX,ec73DW;EEGH,aAAoB;EhB43D5B,ecz4DU;Ed04DV,oBct4DW;EESH,gBAAoB;EhB+3D5B,kBc54DU;Ed64DV,kBcz4DW;EESH,oBAAoB;EhBk4D5B,kBc/4DsC;Edg5DtC,ec54DW;EESH,kBAAoB;EhBq4D5B,iBcl5DU;Edm5DV,gBc/4DW;EESH,eAAoB;EhBw4D5B,kBcr5DU;Eds5DV,acl5DW;EESH,eAAoB;EhB24D5B,ecx5DsC;Edy5DtC,kBcr5DuC;EES/B,sBAAoB;EhB84D5B,sBc35DsC;Ed45DtC,sBcx5DuC;EES/B,uBAAoB;EhBi5D5B,+Cc95DsC;Ed+5DtC;+CgBl5D4B;AhBo5D9B;;AAEA;;;EgBt5DU,sBAAoB;AhB05D9B;;AAEA;EACE,uBc16DsC;Ed26DtC,iBcv6DuC;EEenC,8BAAsB;EhB05D1B,6CgB15DyC;AhB25D3C;;AAEA;;;;;;;;;;EgBx5DQ,cAAsB;AhBm6D9B;;AAEA;EgBr6DQ,SAAA;EhBu6DN,kCgBv6D2C;EAArC,eAAsB;EhBy6D5B,gBgBz6D2C;EAArC,gBAAsB;EhB26D5B,cgB36D2C;EAArC,gBAAsB;EhB66D5B,yBgB76D2C;AhB86D7C;;AAEA;EACE,qBgBj7D2C;AhBk7D7C;;AAEA;EACE,uBc97D8C;EEgBpC,SAAA;EhBg7DV,iBch8D8B;Adi8DhC;;AAEA;;;;;;EgBn7DY,aAAuB;EhB07DjC,qBc18D8B;Ad28DhC;;AAEA;EACE,ac98DW;EEgBD,mBAAuB;AhBg8DnC;;AAEA;;Ee78DI,0BAAwB;EC3BtB,yCAAc;UAAd,iCAAc;EhB4+DlB,YgB3+DgB;EhB4+DhB,gBgB3+DkB;EhB4+DlB,sCgB1+DK;UhB0+DL,8BgB1+DK;AhB2+DP;;AAEA;EgBz+DU,mBFuBJ;Edo9DJ,kBcn9DyB;Edo9DzB,oBcl9DC;Adm9DH;;AAEA;;;EAGE,acz9Da;EEzBL,mBFuBJ;Ad69DN;;AAEA;;;;EAIE,gBcn/Dc;Ado/DhB;;AAEA;EACE,gBc//DU;AdggEZ;;AAEA;EACE,qBc//DW;EESH,cAAoB;AhBw/D9B;;AAEA;EACE,gBcxgEU;AdygEZ;;AAEA;;EgB9/DU,mBAAoB;AhBigE9B;;AAEA;EACE,ccjhEU;AdkhEZ;;AAEA;;EgBvgEU,kBAAoB;EhB0gE5B,ccvhEU;EdwhEV,ccphEW;EESH,wBAAoB;AhB6gE9B;;AAEA;EACE,ec7hEU;Ad8hEZ;;AAEA;EACE,Wc7hES;Ad8hEX;;AAEA;EACE,cgBhhEkD;EAG5C,qBAAsB;EhB+gE5B,6BgB/gE2C;AhBghE7C;;AAEA;EACE,cgBnhE2C;EAArC,qBAAsB;AhBqhE9B;;AAEA;EgBvhEQ,cAAsB;EhByhE5B,qBgBzhE2C;AhB0hE7C;;AAEA;EACE,cgB7hE2C;EAArC,qBAAsB;AhB+hE9B;;AAEA;;;;EAIE;4BgBriE4B;EhBuiE5B,cgBviE2C;AhBwiE7C;;AAEA;EACE,acpjEW;EEgBD,mBAAuB;EhBsiEjC,cctjEW;EEgBD,6BAAuB;AhBwiEnC;;AAEA;EgB1iEY,gBAAuB;AhB4iEnC;;AAEA;EgB9iEY,sBAAuB;EhBgjEjC,kBchkE8B;AdikEhC;;AAEA;EACE,gBcpkE8B;EEgBpB,sBAAuB;AhBsjEnC;;AAEA;EACE,yBAAyB;AepkEvB;;AfukEJ;EACE,iBgBjmEkB;EhBkmElB,oBgBhmEK;EAIG,cAAc;EhB8lEtB,gBctkEyB;EdukEzB,oBcrkEC;AdskEH;;AAEA;EgBlmEU,mBFuBJ;Ed6kEJ,gCc5kEyB;Ad6kE3B;;AAEA;EACE,qBc9kEC;EE1BO,qBFuBJ;AdmlEN;;AAEA;EACE,gBcrlEY;AdslEd;;AAEA;EACE,UczmEO;Ad0mET;;AAEA;;;;;EgBxmEU,SAAS;EhB8mEjB,oBc3nEsC;Ed4nEtC,kBcxnEuC;EES/B,oBAAoB;AhBinE9B;;AAEA;;EAEE,iBc9nEW;Ad+nEb;;AAEA;;EAEE,oBcvoEU;AdwoEZ;;AAEA;EACE,ecvoEW;AdwoEb;;AAEA;EgBjoEU,iBAAoB;AhBmoE9B;;AAEA;;;;EAIE,0BctpEsC;AdupExC;;AAEA;;;;EAIE,egBroE2C;AhBsoE7C;;AAEA;;;;EgBxoEQ,UAAA;EhB6oEN,kBgB7oE2C;AhB8oE7C;;AAEA;;EgBhpEQ,sBAAsB;EhBmpE5B,UgBppEkB;AhBqpEpB;;AAEA;EACE,egBvpE2C;AhBwpE7C;;AAEA;EACE,egB3pE2C;AhB4pE7C;;AAEA;EACE,ccxqEW;EEgBD,gBAAuB;AhB0pEnC;;AAEA;EgB5pEY,YAAY;EhB8pEtB,Uc9qEA;EEgBU,SAAA;EhBgqEV,SchrEA;AdirEF;;AAEA;EACE,ccprEW;EEgBD,WAAA;EhBsqEV,ectrE8B;EEgBpB,UAAA;EhBwqEV,qBcxrE8B;EEgBpB,iBAAuB;EhB0qEjC,oBc1rE8C;EEgBpC,cAAuB;EhB4qEjC,mBc5rE8B;Ad6rEhC;;AAEA;EiBlvEA;IACE,iCAAW;EACX;AjBovEF;;AAEA;EiBxvEA,wBAOK;AjBmvEL;;AAEA;;EAEE,YiBhvEE;AjBivEJ;;AAEA;EACE,oBAAoB;EiBtuEtB,wBACI;AADJ;;AjB0uEA;EiB9tEA,wBAAgB;AjBguEhB;;AAEA;EACE,aK99D+B;EYrQjC,0BASM;AjB4tEN;;AAEA;EiBvtEA,qBACI;AADJ;;AAAA;EAKI,kBACD;EjButED,eAAe;AiBhtEjB;;AjBmtEA;EkBhxEE,aDyEA;AjBysEF;;AAEA;EmB3xEE,wBAAc;AAAd;;AnB+xEF;;;;;;;;;;;;EAYE,qBmBvxEqB;EnBwxErB,oBAAoB;EmB5yEpB,gBAAgB;EAAhB,gBAAgB;EAAhB,cAAgB;AnBgzElB;;AmBhzEE;;EAAA,mBAUI;AAVJ;;AnBuzEF;;EmB/xEQ;;IALN,mCDZO;ElBqzEP;AACF;;AmB7zEE;;EAII,kBCgGI;ApB8tEV;;AmBl0EE;;EAAA,oBAWS;AnB4zEX;;AkBh0EE;;ECYA,oBAGE;AnBszEJ;;AAEA;;EmB90EE,oBAEM;AAFN;;AnBm1EF;;EmBn1EE,mBASM;AATN;;AnBw1EF;EACE,kBAAkB;EkBl1ElB,gBCeE;AnBq0EJ;;AAEA;EACE,iBmBl0EQ;EnBm0ER,gBAAgB;EmB/1EhB,gBAAc;AAAd;;AnBm2EF;EACE;ImBp2EA,kCAQM;EARN;AAAA;;AnBy2EF;EACE,kBAAkB;EkBn2ElB,gBCeE;EAEI,gBAAgB;AnBq1ExB;;AAEA;EACE;ImBh3EA,+BAAa;EAAb;AAAA;;AnBq3EF;EmBr3EE,oBAQM;EARN,gBASM;EATN,gBAUI;AAVJ;;AnB23EF;EkBp3EE;ICiBM,qCDjBgB;ECYtB;AnB42EF;;AAEA;EmBj4EE,oBAAY;EAAZ,gBAEM;EAFN,gBAGO;AnBk4ET;;AmBr4EE;EAAA;IAAA,qCAUY;EAVZ;AnB24EF;;AkBp4EE;ECiBM,gBAAgB;EALtB,mBAGE;EAHF,SAAA;EnB83EA,wCmBp3EO;AnBq3ET;;AmBl5EE;;EAII,cAAA;EnBm5EJ,gBAAgB;AmBv5EhB;;AAAA;;EAYM,cCwFE;EpByzER,yBAAyB;AkBt5EzB;;AlBy5EF;EmB74EE,eAGE;EnB44EF,gBmBt4EQ;AnBu4EV;;AmBn6EE;EAAA,eAGI;EACA,gBAAgB;AnBo6EtB;;AmBx6EE;EAAA,qBAUY;AAVZ;;AnB86EF;EkBv6EE,oBCeE;AnB05EJ;;AAEA;EACE,cmBv5EQ;EnBw5ER,yBAAyB;AmBp7EzB;;AAAA;EAII,mBCgGI;EpBq1ER,kBAAkB;AmBz7ElB;;AAAA;EAAA,cAWI;EACE,cCwFE;EpB21ER,cAAc;AkBx7Ed;;AlB27EF;EmB/6EE,qBAGE;AnB86EJ;;AmBp8EE;EAAA,eAEI;EAFJ,YAAc;AnBy8EhB;;AmBz8EE;EAAA,gBASM;EATN,yBAUY;EAVZ,yBAWY;EACN,uBACD;EnBm8EL,0CAA0C;EkBz8E1C,eCeE;EAEI,YAAA;AnB27ER;;AAEA;EACE,qBAAqB;AmBt9ErB;;AAAA;EAII,qBCgGI;EpBu3ER,cAAc;AmB39Ed;;AAAA;EAAA,cAWI;EACE,cCwFE;ApB63EV;;AAEA;EmBh9EE,gBAGE;EAHF,cAGE;EnBg9EF,qBmBl9EqB;AnBm9EvB;;AmBv+EE;EAAA,cAGI;AnBw+EN;;AkBp+EE;ECiBM,sBAJe;EADrB,gBAGE;EAHF,WAAA;EnB89EA,yBmB79EqB;EnB89ErB,sBAAsB;EiBx4ExB,iDAEO;AjBw4EP;;AAEA;EACE,UAAU;EiB74EZ,eASE;EAEI,gBZ1FY;EY2FZ,gBAAgB;AjBq4EtB;;AiB/3EA;EACE,cZsFqB;EYrFrB,gBAAgB;EAFlB,cAII;AjBi4EJ;;AAEA;EiBv4EA,kBAAW;EjBy4ET,ciB73EC;EAZH,kBAAW;AjB24EX;;AAEA;EACE,iBiBt3EM;EjBu3EN,kBAAkB;Aev8EhB;;Af08EJ;;;;;;EAME,WAAW;Eeh9ET,mBAAmB;EEiGnB,kBAAA;EjBk3EF,kBiBh3EoB;EjBi3EpB,iBiBh3EiB;AjBi3EnB;;AAEA;;EAEE;;IiBx3EE,gBAAA;EjB23EF;AACF;;AAEA;;EAEE;;;IiBh4EE,gBAAA;EjBo4EF;AACF;;AAEA;;EAEE;;;;IiBt4EM,gBAAW;EACX;AjB24ER;;AAEA;;EqBrjFA;;;;;IdyHM,iBAtCY;Ec5EhB;ArBujFF;;AAEA;EqBrjFE,aAAA;EACA,eAA4B;EVA1B,mBNqS0B;EOvSxB,kBPghBwC;AL2iE9C;;AAEA;EACE,esBzjFgB;EDflB,cAAa;ArB0kFb;;AAEA;;EAEE,gBqBjjFgB;EElChB,eAAC;AvBqlFH;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EqBr7EE,kBhBwIgC;EMzR9B,WAAA;EX8oFF,mBAAmB;EqBx/ErB,kBACG;ArBy/EH;;AqBn/EA;EACE,aAAY;ErBs/EZ,YAAY;EqB9+Ed,eAAY;ArBg/EZ;;AqB5+EA;EACE,cAAc;EACd,ef2TsC;ANorExC;;AAEA;EqBv+EE,aAAW;EACX,cAAc;ArBy+EhB;;AAEA;EACE,mBqBv+EiB;ErBw+EjB,oBqBv+E2C;ArBw+E7C;;AAEA;EqB/9EE,aAAS;EACT,cfgSsC;ANisExC;;AAEA;EqB99EE,af4RsC;Ee3RtC,cf0RsC;ANssExC;;AAEA;EACE,mBAAmB;EqB19ErB,oBAAkB;ArB49ElB;;AqBx9EA;EACE,cAAS;EACT,WAAW;EACX,eAAe;ArB29EjB;;AAEA;EACE,kBqBx9Ee;ErBy9Ef,mBMhtEsC;ANitExC;;AuBhsFE;EACE,mBAAa;EACb,oBAAW;AvBmsFf;;AAEA;EACE,aAAa;EuBhsFb,cAAmB;AvBksFrB;;AAEA;EuBhsFI,mBAAa;EACb,oBAAe;AvBksFnB;;AAEA;EuBhsFI,mBAAc;EACd,oBAAW;AvBksFf;;AAEA;EuB7rFI,aAFF;EACA,cAAc;AAAd;;AvBmsFF;EuBnsFE,mBAAc;EAAd,oBAAc;AvBssFhB;;AAEA;EuBzsFE,mBAAa;EACb,oBACwB;AvB0sF1B;;AAEA;EuB7sFE,aAAA;EvB+sFA,cuBnsFe;AvBosFjB;;AAEA;EACE,mBAAmB;EuBjsFjB,oBADF;AACE;;AvBqsFJ;EACE,mBAAmB;EuBxrFjB,oBADF;AvB2rFF;;AAEA;EACE,cuBtrFoB;EvBurFpB,eAAe;AuB9rFb;;AADF;EAcM,SAAS;AvBsrFjB;;AAEA;EuBlrFU,SAAA;AvBorFV;;AAEA;EACE,QAAQ;AuB1qFR;;AvB6qFF;EuB1qFI,QAAQ;AvB4qFZ;;AAEA;EACE,QuBzqFkB;AvB0qFpB;;AAEA;EACE,QuBxqFM;AvByqFR;;AAEA;EACE,QuBjqFI;AvBkqFN;;AAEA;EuBnxFI,QAAO;AvBqxFX;;AAEA;EACE,QAAQ;AuBlxFR;;AvBqxFF;EuBlxFI,QAAO;AvBoxFX;;AAEA;EuBlxFI,QAAA;AvBoxFJ;;AAEA;EuBlxFI,QAAA;AvBoxFJ;;AuB9wFI;EADF,SAAA;AAAA;;AvBqxFF;EuBrxFE,SAAA;AvBuxFF;;AAEA;EuBxxFI,SAAA;AvB0xFJ;;AAEA;EuB7xFE,qBAAc;AvB+xFhB;;AAEA;EACE,sBAAsB;AuBhxFpB;;AvBmxFJ;EuBnxFI,gBADF;AACE;;AvBuxFJ;EACE,sBAAsB;AuB1wFpB;;AvB6wFJ;EACE,sBuBxwF0B;AvBywF5B;;AuB/wFI;EAAA,gBADF;AAAA;;AvBsxFF;EuBrxFI,sBADF;AvBwxFF;;AAEA;EuBzxFI,sBADF;AvB4xFF;;AuB3vFE;EACE,gBAAS;AvB8vFb;;AAEA;EACE,sBKnzFQ;ALozFV;;AAEA;EuBjwFI,sBAJF;AvBuwFF;;AAEA;EACE;IuB1wFA,aAAA;IAyBI,YAAS;IvBovFX,eAAe;EqBpmFnB;;EAEE;IACA,cAAa;IAHf,eAQE;ErBkmFA;;EAEA;IACE,aqB9lFW;IrB+lFX,cqB9lFa;ErB+lFf;;EAEA;IACE,mBqB3lFe;IrB4lFf,oBqB3lFgB;ErB4lFlB;;EAEA;IqBtnFF,aA+BI;IrBylFA,cqBxlFW;ErBylFb;;EAEA;IACE,aqBrlFW;IAvCf,cA0CI;ErBolFF;;EAEA;IACE,mBqB/kFe;IrBglFf,oBqB/kFe;ErBglFjB;;EAEA;IqBroFF,cAwDI;IrB+kFA,WqB9kFU;IrB+kFV,eqB9kFe;ErB+kFjB;;EAEA;IqB3oFF,kBAgEI;IrB6kFA,mBqB5kFe;ErB6kFjB;;EAEA;IACE,mBAAmB;IwB75FnB,oBAAC;EACH;;EAGA;IACA,aAAY;IAGZ,cAAgB;EAChB;;EAEA;IC8EE,mBpB2hB0B;IoB1hB1B,oBpB+ZiC;EoB9ZjC;;EHjFE;IAIA,mBAAQ;IEdd,oBAAK;ExB86FH;;EAEA;IwB/5FE,aAAA;IAjBJ,cAAI;ExBm7FF;;EwBn7FF;IA6BI,mBlBiZ6B;IMpa3B,oBYqBH;EA/BH;;ExB07FE;IACE,mBKnzE8B;ILozE9B,oBIhlFe;EJilFjB;;EwB74FD;IACD,aAAiB;IACf,cAAgB;ExBg5FhB;;EyBv8FE;ICKA,mBrB4EY;IoB/EZ,oBpB+EmB;EOlEjB;;EZ+7FJ;I0Bz8FE,mBDN2D;IASvD,oBAT+F;EAYnG;;EAUA;IAEI,cpBEO;IoBDP,eAAA;EzB87FN;;EyBx7FE;IACI,SpBNG;ELi8FT;;EAEA;IyB97FE,SDkCF;ExB85FA;;EwB95FA;IChEE,QpBkCO;EqB7BP;;EdUE;IMJJ,QAAA;ElB29FA;;EAEA;IyB79FE,QAAA;EzB+9FF;;EAEA;IyBp9FM,QAAA;EzBs9FN;;EyBh9FE;IACI,QpBGG;ELg9FT;;EAEA;IyBt9FE,QDkCF;ExBs7FA;;EwBt7FA;IChEE,QpByBO;EqBpBP;;EdUE;IMJJ,QAAA;ElBm/FA;;EAEA;IyBr/FE,QAAA;EzBu/FF;;EAEA;IyB5+FM,QAAA;EzB8+FN;;EyBx+FE;IACI,SpBNG;ELi/FT;;EAEA;IyB9+FE,SDkCF;ExB88FA;;EwB98FA;IChEE,SpByBW;EqBpBX;;EdUE;IMJJ,cAAQ;ElB2gGR;;EAEA;IyB7gGE,qBDqDF;ExB09FA;;EAEA;IyBpgGM,sBpBkCE;ELo+FR;;EyBhgGE;IACI,gBpBNO;ELygGb;;EAEA;IyBtgGE,sBAAO;EzBwgGT;;EwBt+FA;IChEE,sBpByBW;EqBpBX;;EdUE;IMJJ,gBAAO;ElBmiGP;;EAEA;IyBriGE,sBDqDF;ExBk/FA;;EAEA;IyB5hGM,sBpB+BE;EL+/FR;;EyBxhGE;IACI,gBpBNO;ELiiGb;;EAEA;IyB9hGE,sBAAO;EzBgiGT;;EwB9/FA;IChEE,sBpByBW;EqBpBX;A1B8jGJ;;AAEA;EACE;I0BjkGE,aAAA;IDGI,YAAY;IAGhB,eAAO;EzB+jGT;;EAEA;IyBpjGM,cAAA;IACA,epB6BE;EoB1BN;;EzBqjGF;IyBjjGM,aAAA;IAIA,cArCkL;EzBqlGxL;;EAEA;IACE,mBAAmB;IwBvhGrB,oBAAe;EChEb;;EAEA;IbaE,aP0nB0B;Ia9nB9B,cAAO;ElBmlGP;;EAEA;IyBrlGE,aAAC;IAIO,cpB0nBoB;EoBpnB5B;;EzBglGF;IyB5kGM,mBpBKG;IoBFP,oBrBqVM;EqBnVN;;EzB4kGF;IyBtkGM,cArCkL;IAuClL,WAVH;IAED,eDkCF;ExB8iGA;;EwB9iGA;IChEE,kBpByBW;IqBpBX,mBrB6BO;EoBhCP;;EPSF;IOLM,mBpBmBO;IqBpBX,oBDN2D;EzBynG7D;;EAEA;IyBrmGE,aAAC;IAEG,cpBEO;ELomGb;;EyBjmGE;IAEA,mBAAO;IACH,oBpBNO;ELymGb;;EAEA;IyBtmGE,mBAAO;IzBwmGP,oByB7lGgD;EzB8lGlD;;EyBvoGE;ICKA,aAAA;IDHA,cpB8EY;EOjEV;;EZ+nGJ;I0BzoGE,mBDN2D;IASvD,oBAT+F;EAYnG;;EAUA;IAEI,mBpBEO;IoBDP,oBpBwDQ;ELskGd;;EyBxnGE;IACI,apBNO;IoBOP,cAAA;EzB2nGN;;EAEA;IACE,mBKjhF8B;ILkhF9B,oBAAoB;EwB/lGtB;;EE3DE;IDHA,mBpBuBW;IOVT,oBP0nBkC;Ea9nBtC;;ElB4pGA;IyB/pGM,cAT+F;IAYnG,eAAO;EzB+pGT;;EAEA;IyBppGM,SAAA;EzBspGN;;EyBhpGE;IACI,SpBGG;ELgpGT;;EAEA;IyBtpGE,QDkCF;ExBsnGA;;EwBtnGA;IChEE,QpBkCO;EqB7BP;;EdUE;IMJJ,QAAA;ElBmrGA;;EAEA;IyBrrGE,QAAA;EzBurGF;;EAEA;IyB5qGM,QAAA;EzB8qGN;;EyBxqGE;IACI,QpBGG;ELwqGT;;EAEA;IyB9qGE,QDkCF;ExB8oGA;;EwB9oGA;IChEE,QpByBO;EqBpBP;;EdUE;IMJJ,QAAA;ElB2sGA;;EAEA;IyB7sGE,QAAA;EzB+sGF;;EAEA;IyBpsGM,SAAA;EzBssGN;;EyBhsGE;IACI,SpBNG;ELysGT;;EAEA;IyBtsGE,SDkCF;ExBsqGA;;EwBhqGA;ICnBE,cpB8BmB;EoB7BnB;;EAEA;IAEA,qBAAC;EzBsrGH;;EAEA;IyBlrGE,sBAAC;EzBorGH;;EAEA;IyB9qGM,gBAAgB;EAGpB;;EzB+qGF;IyB3qGM,sBpBIQ;ELyqGd;;EAEA;IACE,sBK5qGY;EL6qGd;;EyB3sGE;IACA,gBAAkB;EAClB;;EAGA;IACI,sBpBvBU;ELouGhB;;EyBxsGE;IAEI,sBpBkBQ;EoBfZ;;EzBysGF;IyBnsGE,gBAAA;EAEA;;EzBqsGF;IyBlsGM,sBpBIe;ELgsGrB;;EAEA;IACE,sBAAsB;EwB/sGxB;AxBitGF;;AAEA;EyBnuGI;IAEA,aAAA;IACI,YpBhCO;IoBiCP,eAAA;EzBouGN;;EAEA;IyB7tGE,cAAA;IAEI,epBZS;EL0uGf;;EyBxtGE;IACI,apBnDO;IoBoDP,cAAA;EzB2tGN;;EAEA;IACE,mByBrtG6B;IzBstG7B,oBAAoB;EwBtuGtB;;EClBE;IACA,aAAA;IACA,cpBIM;EoBFN;;EzB4vGF;IyBzvGM,aAAY;IAGhB,cAAA;EzByvGF;;EAEA;IyBnvGM,mBAAkB;IAGtB,oBrBwSM;EqBtSN;;EzBmvGF;IyBhvGM,cpBpBE;IoBsBF,WAAA;IALJ,eDLF;ExB4vGA;;EwB5vGA;ICnBE,kBpBIa;IoBHb,mBAAkB;EAClB;;EAGA;IACI,mBpBhCO;IoBiCP,oBpBHE;ELqxGR;;EAEA;IyB3wGE,aAAA;IAEI,cpBdS;EL0xGf;;EyBtwGE;IACI,mBpBnDO;IoBoDP,oBpBtBE;EL+xGR;;EAEA;IACE,mByBnwG6B;IzBowG7B,oBAAoB;EwBpxGtB;;EClBE;IACA,aAAA;IACA,cpBAM;EoBEN;;EzB0yGF;IyBvyGM,mBpBLE;IoBQN,oBAAC;EzBuyGH;;EAEA;IyBjyGM,mBAAkB;IAGtB,oBAAC;EAED;;EzBiyGF;IyB9xGM,aAAY;IAEZ,cAAA;EzB+xGN;;EAEA;IwB3yGA,mBAAuB;ICnBrB,oBpBrBc;EoBsBd;;EAEA;IAEA,mBAAC;IACG,oBpBhCO;ELg2Gb;;EyB3zGE;IAEI,cAAc;IAGlB,eAAA;EzB2zGF;;EyBrzGE;IAEA,SDLF;ExB4zGA;;EAEA;IyBpzGM,SAAA;EzBszGN;;EAEA;IwBl0GA,QAAA;ECnBE;;EAEA;IACA,QAAA;EAEA;;EzBw1GF;IyBr1GM,QAAA;EAGJ;;EAKA;IAEI,QpBnCG;ELo3GT;;EyB30GE;IACI,QpBnDG;ELi4GT;;EAEA;IyBj1GE,QDLF;ExBw1GA;;EwBx1GA;ICnBE,QpB6BY;EoB5BZ;;EAEA;IAEA,QAAA;EzB82GF;;EAEA;IyB12GE,QAAA;EzB42GF;;EAEA;IyBt2GM,QAAA;EAGJ;;EzBu2GF;IyBn2GM,SAAA;EzBq2GN;;EAEA;IACE,SyB/1GY;EzBg2Gd;;EyBn4GE;IACA,SAAA;EACA;;EAGA;IACI,cpBvBU;EL45GhB;;EyBh4GE;IAEI,qBpBvCG;EoB0CP;;EzBi4GF;IyB33GE,sBrBwSM;EqBtSN;;EzB63GF;IyB13GM,gBpBrDG;ELi7GT;;EAEA;IACE,sBAAsB;EwBv4GxB;;EClBE;IACA,sBAAsB;EACtB;;EzB85GF;IyB15GM,gBAAgB;EzB45GtB;;EAEA;IyBr5GE,sBAAC;EzBu5GH;;EyBj5GE;IAEA,sBDLF;ExBw5GA;;EAEA;IyBh5GM,gBAAA;EzBk5GN;;EAEA;IwB95GA,sBAAuB;ECnBrB;;EAEA;IACA,sBDkBD;EChBC;AzBm7GJ;;AAEA;EyB/6GI;IAEI,aAAa;IAGjB,YAAA;IAEI,epBoB8B;ELy5GpC;;EyBv6GE;IACI,cpBnDO;IoBoDP,eAAA;EzB06GN;;EAEA;IACE,ayBp6GsB;IzBq6GtB,cAAc;EwB16GlB;;EAEE;IACA,mBnBqJ8B;Ia9N9B,oBAAQ;ElBs/GR;;EwBh7GF;IAYI,aAAA;IAZJ,cAAS;ExBq7GP;;EAEA;IwB15GF,aGlDA;IFkCI,cpByZ0B;EoBxZ1B;;EAGI;IzB46GJ,mBAAmB;IwB55GvB,oBGvDa;EFmCT;;EAEA;IAEI,cpBoNsB;IL8tG1B,WAAW;IwBz5Gf,eAAW;EACT;;EADF;IAMI,kBlBuT+B;INkmG/B,mBAAmB;EwBp5GvB;;EAEA;IAEI,mBACD;IxBo5GC,oBAAoB;E4BhiHxB;;ENoBM;IMpBN,aAAM;I5BqiHF,csBhhHgB;EMrBpB;;E5BwiHE;I4BhiHF,mBACe;IACX,oBACD;E5BgiHD;;E4B5hHA;IACA,mBAAS;IACT,oBAAgB;ENDZ;;EtBkiHJ;IACE,asB9hHc;ItB+hHd,cAAc;E6BnjHlB;;EAEA;IACA,mBAAU;IACR,oBACD;E7BojHC;;E6BjjHA;ICoBE,mBAAC;IACC,oBAAS;E9BiiHb;;EAEA;I8BhkHA,azB4U4B;IyB3U5B,czB2U4B;ELuvG5B;;E8B3gHE;IACE,mBACD;I9B6gHD,oBAAoB;E6BxjHxB;;EAEE;IACA,mBAAO;IACP,oBvBwpBsC;EuBvpBtC;;EAEA;IACA,cvBguBkC;IuB/tBlC,eAAyB;EtBsGrB;;EsBnGJ;IACA,SAAU;EACV;;EAEA;IlBdE,SAAA;ECFE;;EiByBF;IACE,QAAO;EACP;;EAGF;IACE,QAAQ;EACR;;EdYF;IcnBA,QAAA;E7B8jHF;;E6BzjHE;IACE,QAAQ;E7B4jHZ;;Ee/iHE;IcnBA,QAAA;E7BskHF;;E6BjkHE;IACE,QAAQ;E7BokHZ;;EevjHE;IcnBA,QAAA;E7B8kHF;;E6BzkHE;IACE,QAAQ;E7B4kHZ;;Ee/jHE;IcnBA,QAAA;E7BslHF;;E6BjlHE;IACE,QAAQ;E7BolHZ;;E6B5kHF;IAEI,SAAS;EACT;;EAEA;I7B8kHA,SAAS;E8B7mHT;;EAEE;IACA,SAAA;EACA;;EAxBJ;IACA,czBmU4B;EyBlU5B;;EA8CE;IACE,qBACD;E9B4lHH;;E6BjlHE;IACA,sBAAW;EACX;;EAEA;I7BolHA,gBAAgB;E8BjoHhB;;EAEE;IACA,sBxB6N0C;EwB5N1C;;EAjBJ;IACA,sBAA4B;EAC5B;;EAuCE;IACE,gBACD;E9BgnHH;;E6B3lHI;I7B8lHF,sBAAsB;E6BzlH1B;;EAGI;IACA,sBAAU;EACV;;E7B2lHF;I8BxpHE,gBDiEF;EChEI;;EAEA;IACA,sBAQD;E9BkpHH;;E8B9oHM;I9BipHJ,sBAAsB;E8B9oHpB;A9BgpHN;;AAEA;E8B9oHQ,WAAW;EA9BjB,mBAAyB;EACzB,sBAA2B;EAC3B,6BAAkC;A9B+qHpC;;AAEA;;E8BzpHM,aD8CJ;EAGI,mBAAiB;E7B4mHrB,6BAA6B;A6BrmH/B;;A7BwmHA;EACE,sBAAsB;E6B9lHxB,gCAAkB;A7BgmHlB;;AAEA;E+B7sHE,6B1BoBgB;AL2rHlB;;AAEA;;E6B5lHE,exB+iBoC;ALgjGtC;;AAEA;E6B7lHE,yBAAmB;A7B+lHrB;;AAEA;;EAEE,yBK9jGoD;AL+jGtD;;AAEA;;EAEE,wB6B7kHuB;A7B8kHzB;;AAEA;;;;E6BhkHA,SAAA;A7BqkHA;;A6BhkHA;EACE,0CAAc;A7BmkHhB;;AAEA;E6BjkHE,cxBtJgB;EwBuJhB,yBACD;A7BkkHD;;AAEA;;;EAGE,yBAAyB;A2B5vH3B;;A3B+vHA;;;;E2B9vHA,qBAAmB;A3BmwHnB;;AAEA;EACE,yB2BjwHE;A3BkwHJ;;AAEA;;EAEE,yB2BtwHE;A3BuwHJ;;A2BrvHA;;;EAGE,yBAAiB;A3BwvHnB;;AAEA;;;;EAIE,qBAAqB;A2BvvHvB;;A3B0vHA;EW5vHI,yBAAA;AX8vHJ;;A2B5vHA;;EhBYI,yBAAyB;AXqvH7B;;AAEA;;;E2B/tHE,yBALF;A3BwuHA;;AAEA;;;;E2B1tHE,qBAAe;A3B+tHjB;;A2B3tHA;EACE,yBAAsC;A3B8tHxC;;A2BvtHA;;EAAA,yBAAgB;A3B4tHhB;;A2B9sHA;;;EAGE,yBAAuB;A3BitHzB;;AAEA;;;;E2BttHA,qBAAmB;A3B2tHnB;;AAEA;E2B7tHA,yBAqBI;A3B0sHJ;;AAEA;;E2BzrHA,yBACQ;AADR;;A3B8rHA;;;E2B9rHA,yBAEI;A3BgsHJ;;AAEA;;;;EgCl1HE,qBAAa;AhCu1Hf;;AAEA;EgC31HA,yBAOI;AhCs1HJ;;AAEA;;EAEE,yBgCr1HgB;AhCs1HlB;;AAEA;;;EAGE,yBgCh2HE;AhCi2HJ;;AAEA;;;;EAIE,qBgCp2HE;AhCq2HJ;;AAEA;EgCj3HA,yBAyBI;AhC01HJ;;AAEA;;EAEE,yBgCr1HC;AhCs1HH;;AAEA;;;EAGE,yBgCj1He;AhCk1HjB;;AAEA;;;;EgCh4HA,qBAmDQ;AhCk1HR;;AAEA;EgCv4HA,yBAAY;AhCy4HZ;;AAEA;;EAEE,yBAAyB;AgCl0H3B;;AhCq0HA;;;EAGE,yBgCh0HoB;AhCi0HtB;;AAEA;;;;EgC30HA,qBAkBE;AhC8zHF;;AAEA,0BgCj0HM;AhCk0HN;EgCl1HA,oCAkBE;AhCk0HF;;AgC7zHA,yBAAqB;AhCg0HrB;EACE,oCAAoC;EgCh0HtC,cAAA;AhCk0HA;;AgC1zHA,kDAAkB;AhC6zHlB;EgC3zHE,oCAAmB;AhC6zHrB;;AAEA,qBO11HkB;AP21HlB;EgC3zHE,oC3B4P+B;ALikHjC;;AAEA;EgC3zHE,yB3BnGa;ALg6Hf;;AAEA;;EAEE,yBgCzzHC;AhC0zHH;;AgChzHA;;;EAIA,yBAAkB;AAClB;;AAEA;;;;EzBvBM,qBAtCY;APm3HlB;;AAEA;EgC/yHA,yBAAkB;AAClB;;AhCkzHA;;EgC7yHA,yBAAkB;AAClB;;AAEA;;;EzBzCM,uBAtCY;APk4HlB;;AAEA;;;;EAIE,mBAAmB;AgCpyHrB;;AAEA;EACA,yBAvIQ;AAwIR;;AAEA;;ErBjKI,yBqBmK2B;AhCsyH/B;;AgCnyHA;;;EAGA,uBAAe;AACf;;AhCuyHA;;;;EiCz+HE,mBAAkB;AjC8+HpB;;AAEA;EiC5+HE,yBAAqE;AjC8+HvE;;AiC1+HA;;EAEE,yBACD;AjC4+HD;;AAEA;;;EiCx+HE,yB5BqjBkD;ALu7GpD;;AAEA;;;;EAIE,qBK7+G4C;AL8+G9C;;AAEA;EACE,yBK/7HqB;ALg8HvB;;AAEA;;EAEE,yBK1/HS;AL2/HX;;AAEA;;;EiC98HA,yBAAsB;AjCk9HtB;;AAEA;EiCp9HA,yBAAqB;AjCs9HrB;;AAEA;;EAEE,yBKr9GkD;ALs9GpD;;AAEA;EACE,ciC78HE;EjC88HF,yBKv9G8C;ELw9G9C,qBK3gH4C;AL4gH9C;;AAEA;EACE,ciC18HU;EjC28HV,yBiC18HgB;EjC28HhB,qBKj+GkD;ALk+GpD;;AAEA;EACE,cAAc;EiCl8HhB,yBACE;AjCm8HF;;AiCp8HA;;;EAAA,qBAWE;AjC+7HF;;AAEA;EACE,SAAS;AiC78HX;;AjCg9HA;EiCh9HA,2CAsBuB;AjC47HvB;;AiCl9HA;EP7GI,cAAA;E1BmkIF,4CAA4C;AiCl7H9C;;AjCq7HA;EiCr7HA;IAQM,cAAgB;IjCg7HlB,WAAW;IiCx7Hf,gBAYE;IP7JE,iCrB4EY;ELggId;;EiCl6HA;IADF,SAAA;EjCu6HE;AACF;;AAEA;EiC16HA;IAaM,cblE6B;IamE7B,WbnE6B;IaoE7B,gBbhD6B;IaiD7B,iCbjD0D;EpBi9H9D;;EAEA;IsB7kII,SAAQ;EtB+kIZ;AACF;;AAEA;EACE;IiCx7HF,cA+BE;IPxME,WAAA;I1BomIA,gBAAgB;IiC94HpB,iCAAe;EACb;;EAEA;IACA,S5B4Q4B;EE7WxB;APk/HN;;AAEA;EiC74HE;IACA,c5B7Ma;I4B8Mb,WAAoC;ItBtNlC,gBNkS0B;IOpSxB,iCPoBK;E4BuMT;;EjCg5HA;IiC54HE,SAAS;EjC84HX;AACF;;AAEA;EiCp6HA,cAAc;EjCs6HZ,WiC93HU;EjC+3HV,gBiC93He;EjC+3Hf,iCiC73HC;AjC83HH;;AAEA;EiC36HA,SAAA;AjC66HA;;AAEA;EACE,ciCt3Ha;EjCu3Hb,WAAW;EiCn3Hb,mCAAkB;EAChB,yBbjKiC;EakKjC,mB5BwN4B;E4BvN5B,gB5BuN4B;E4BtN5B,gB5BuN4B;EEtXxB,cAtCW;EP2jIf,sBAAsB;EiCl3HxB,4BAAkB;EAChB,yBbzKiC;Ea0KjC,sB5BoNmC;E4BnNnC,+C5BmNmC;E4BlNnC,4D5BmNgC;ALiqHlC;;AiC32HA;EACE;IACA,gBAAS;EACT;AjC82HF;;AAEA;EuBzjIE,6BU8MiB;EACjB,SAAQ;AjC62HV;;AAEA;EiC32HE,kBAAS;EACT,0BAAgB;AjC62HlB;;AAEA;EACE,cKvoHsC;E4B/OxC,sBAeG;EAfH,qBAAkB;EjCy3HhB,UiCx2HE;EAjBJ,6EAqBiD;AjCs2HjD;;AAEA;EACE,cAAc;EiC/1HhB,UAAA;AjCi2HA;;AAEA;;EiC91HE,yBAAU;EACV,UblOiC;ApBmkInC;;AAEA;;;;EiC31HE,wBAAkC;UAAlC,gBAAkC;AjCg2HpC;;AAEA;EACE,ciC91HY;EjC+1HZ,sBiC91HQ;AjC+1HV;;AAEA;;EAEE,coBnlIiC;EpBolIjC,WKluH4B;ALmuH9B;;AAEA;EACE,iCKxrIa;ELyrIb,oCiC91HsB;EjC+1HtB,gBWlsIe;EXmsIf,kBAAkB;EiCr1HpB,gBAAc;AjCu1Hd;;AAEA;EiCr1HE,iCAA6B;EAC7B,oCAkID;EAvID,mBAOS;EjCs1HP,gBiC90HC;AjC+0HH;;AAEA;EACE,gCKzgIc;EL0gId,mCiCp1H0B;EjCq1H1B,kBMpnH6C;E2B/O/C,gBAAa;AjCq2Hb;;AAEA;EACE,cM/nH+C;ENgoH/C,WiCj1HE;EjCk1HF,mB0BpuIkB;E1BquIlB,gBM/nH4C;ENgoH5C,mBM/nH2C;ENgoH3C,gBM/nH6C;ENgoH7C,cMruHsC;ENsuHtC,6BiC50HC;EjC60HD,yBsB5tIY;EtB6tIZ,mBiCj3HW;AjCk3Hb;;AAEA;;EAEE,gBMppHsC;ENqpHtC,eMppHkC;ANqpHpC;;AAEA;EACE,kCiCh1H2B;EjCi1H3B,uBMtpHsC;ENupHtC,kBMtpHkC;E2BvOpC,gBAAa;EjC+3HX,sBMtpH+C;ANupHjD;;AAEA;EACE,mCMtpH+C;ENupH/C,sBMtpHkD;ENupHlD,mBM5vHsC;EN6vHtC,gBiC90Hc;EjC+0Hd,wBsBnvIY;AtBovId;;AAEA;;EiC14HA,YAAA;AjC64HA;;AAEA;EACE,YM5qHkC;AN6qHpC;;AAEA;EACE,qBM7qHyC;AN8qH3C;;AAEA;EACE,ciC30Hc;EjC40Hd,mBKpvHuC;ALqvHzC;;AAEA;EACE,aW3wIE;EX4wIF,eMhrH4C;ENirH5C,kBMtxHsC;ENuxHtC,iBiC30Hc;AjC40HhB;;AAEA;;EAEE,kB0B/xIE;EO0XJ,iBAAa;AjCu6Hb;;AAEA;EACE,kBMtsHyC;ENusHzC,ciC10HE;EjC20HF,qBiC10HgB;AjC20HlB;;AAEA;EACE,kBiCx0HkB;EjCy0HlB,kBM3sHkC;E2BtOpC,qBAAa;AjCm7Hb;;AAEA;;EAEE,ciCn0HI;AjCo0HN;;AAEA;EACE,gBiC/zHI;AjCg0HN;;AAEA;EACE,oBKhyIS;ELiyIT,mBAAmB;EiCvzHrB,eAAA;EACA,qBAAkB;AAClB;;AjC0zHA;EACE,gBiC7zHF;EjC8zHE,aiC7zHF;EjC8zHE,uBiC7zHa;EjC8zHb,csBpzIgB;AtBqzIlB;;AAEA;EkCr0IE,aAAW;EACX,WAAA;EACA,mBAAgB;EAChB,cAAY;ElCu0IZ,cAAc;AkCp0IhB;;AlCu0IA;EkBp0IE,kBgBHF;ElCy0IE,SkCn0IE;EANJ,UAAS;ElC20IP,aKxzIS;ELyzIT,ekCh0IE;ElCi0IF,ekCh0IU;ElCi0IV,kBAAkB;EkCzzIpB,mBAAU;EACR,cAAa;EADf,WAGE;ElC0zIA,yCK9iI+B;EL+iI/B,qBkCzzIuC;AlC0zIzC;;AAEA;;;;EAIE,qBkCvzIoB;AlCwzItB;;AAEA;;;;EkCx0IA,qBA0BE;AlCmzIF;;AAEA;;;;;;;;EkChyII,cAAA;AlCyyIJ;;AkChyIA;;EAII,cAAY;AlCiyIhB;;AkC7xIA;;;;ElCmyIE,cAAc;AkCrxIhB;;AlCwxIA;;EkCnxII,cAAc;AlCsxIlB;;AAEA;;EmCz3IE,yBAAe;EACf,qBAAmB;AnC43IrB;;AAEA;;;;EAIE,cmCz3Ia;AnC03If;;AmCr2IA;;EAEE,yB7BiqB+E;E6BhqB/E,qB7BgqBkC;ANwsHpC;;AAEA;;EkBh5IE,+DACQ;AlBk5IV;;AmC71IA;EACE,qBAAa;EACb,qBAAgB;EAChB,sBAAe;AnCg2IjB;;AAEA;;EAEE,qBmC71IC;AnC81IH;;AAEA;;EmCn1IA,qBAAa;AnCs1Ib;;AAEA;;;;EmCv0IE,cAAY;AnC40Id;;AmCr0IA;;E5BUM,4CAtCY;APs2IlB;;AAEA;EW/6II,aAAa;AXi7IjB;;AAEA;EmCj0IA,aAAA;EACE,WAAS;EACT,mBAAY;EACZ,cAAa;EACb,cAAc;AnCm0IhB;;AAEA;EmCh0IA,kBAAmB;EACjB,SAAA;EACA,UAAU;EnCk0IV,aAAa;Eex4IX,eAAiB;EoBgFhB,eAAA;EAAA,kBAAG;EnC4zIN,mBmCzzIwB;EnC0zIxB,cmCzzIoB;EnC0zIpB,WAAW;Ee35IT,wCAAwB;EoB6FxB,qBAAW;AnCi0If;;AAEA;;;;EAIE,qBmCv0IM;AnCw0IR;;AAEA;;;;EAIE,qBmCzxIyB;AnC0xI3B;;AAEA;;;;;;;;EAQE,cmCr1IoB;AnCs1ItB;;AAEA;;EAEE,cmCz0IM;AnC00IR;;AAEA;;;;EAIE,cmCr0IU;AnCs0IZ;;AAEA;;EAEE,cmCrzIkB;AnCszIpB;;AAEA;;EAEE,yBmC9yIO;EnC+yIP,qBAAqB;Aeh8InB;;Afm8IJ;;;;Eeh9II,cAAQ;Afq9IZ;;AAEA;;EAEE,yBmCp2I2B;EnCq2I3B,qBmC73IM;AnC83IR;;AAEA;;EAEE,8DmC33IkB;AnC43IpB;;AAEA;EACE,qBmCj1IyB;EnCk1IzB,qBmC/0IM;EnCg1IN,sBmC/0IiB;AnCg1InB;;AAEA;;Ee39II,qBAAmB;Af89IvB;;AAEA;;EAEE,qBAAqB;Ae/+InB;;Afk/IJ;;;;EAIE,cmCz5IG;AnC05IL;;AAEA;;EAEE,2CmCv5IkB;AnCw5IpB;;AAEA;EACE,amC72IgB;AnC82IlB;;AAEA;EACE,amCt6IG;EnCu6IH,mBmCv2IqB;EnCw2IrB,mBAAmB;AmC76IrB;;AnCg7IA;EmCh7IA,WAAA;AnCk7IA;;AAEA;EmCp7IA;IA6BU,aAAA;IA7BV,mBA4BQ;InC45IJ,uBmCv5IO;IAjCX,gBA4BQ;EnC85IN;;EmC17IF;IAAA,aAAc;IA2CJ,cAAW;IA3CrB,mBAyDQ;IACE,mBAAiB;IA1D3B,gBA6DQ;EnCq4IN;;EmCl8IF;IAqEU,qBACD;InCg4IL,WAAW;ImCp3If,sBACE;EACE;;EnCs3IF;IACE,qBAAqB;EmCz3IzB;;EjBtNE;;IiBsNF,WAAa;EnC+3IX;;EmC/3IF;IAAA,aASE;IATF,mBASE;IATF,uBAyBI;IACE,W9B5NK;ILwkJP,eAAe;EmCt4InB;;EAgCI;InC02IA,kBAAkB;ImC14ItB,cAmCE;IACE,aAAA;InCy2IA,qBAAqB;ImC74IzB,cAuCE;EACE;;EnCy2IF;IkBvmJA,mBiB6PA;InC42IE,uBKrlJO;ELslJT;;EmC91IE;IjB5QF,gBiB2QA;EnCm2IA;AACF;;AAEA;EkBjnJE,qBiBmRA;EnCg2IA,gBKzmJS;E8BgQX,cASE;EnCk2IA,kBK3mJS;EL4mJT,sBAAsB;EmC52IxB,yBASE;UATF,iBASE;EATF,6BAuBI;EAvBJ,6BAwBI;EAxBJ,yBAyBI;EACE,mB9B1RK;ELknJT,gBAAgB;EmCl3IlB,sBA8BE;EACE;gEAED;AnCq1IH;;AAEA;EACE;ImCz3IF,gBAuCE;EACE;AnCo1IJ;;AAEA;EACE,cK/nJS;ELgoJT,qBAAqB;AoCtpJvB;;ApCypJA;;EoCrpJE,UAAS;EAET,2EAAqB;ApCupJvB;;AAEA;;EoC/pJA,aAYO;EpCspJL,gBoCrpJgB;ApCspJlB;;AAEA;EACE,eoCnpJe;ApCopJjB;;AAEA;;EAEE,gBoC1pJE;ApC2pJJ;;AAEA;;EoC9qJA,2EAmC+B;ApC8oJ/B;;AoCzoJA;;EAME,oBAAe;ApCwoJjB;;AoCnoJA;EACE,WAAA;EpCsoJA,yBAAyB;EoCnoJ3B,qBAAe;EACb,2EAA+B;ApCqoJjC;;AoCjoJA;EACE,WAAA;EpCooJA,yBAAyB;EkBzrJzB,qBAAQ;AlB2rJV;;AoCnoJA;;EpCuoJE;mCoCznJW;ApC2nJb;;AAEA;;EoC7nJA,WAAA;EpCgoJE,yBKhzHkC;ELizHlC,qBAAqB;AoCrnJvB;;ApCwnJA;;;EAGE,WWvsJE;EXwsJF,yBAAyB;EoC5mJ3B,qBAAkB;ApC8mJlB;;AAEA;;;EoCzmJA,iDAAmB;ApC6mJnB;;AAEA;EoCzmJA,cAAA;EACE,yBAAkB;EAClB,qBAAM;EACN,2EAAQ;ApC2mJV;;AAEA;EWztJI,cAAa;EX2tJf,yBAAyB;EoCxmJ3B,qBAAS;AACT;;ApC2mJA;;EAEE;oCoCvmJO;AACT;;ApC0mJA;;EoCtmJA,cAAS;EACT,yBAAiB;EzBzGb,qBAAA;AXmtJJ;;AoCnmJA;;;ErB7FI,cAAQ;EqB6FZ,yBAAW;EpC0mJT,qBoCpmJe;ApCqmJjB;;AAEA;;;EAGE,kDM37HwD;AN47H1D;;AAEA;EoCzlJA,WAAW;EAIP,yBACD;EpCulJD,qBAAqB;EentJnB,2EAAwB;AfqtJ5B;;AAEA;EACE,WoCjmJF;EpCkmJE,yBoCplJgB;EpCqlJhB,qBoCplJoB;ApCqlJtB;;AAEA;;EAEE;mCWxvJ4B;AX0vJ9B;;AAEA;;EAEE,WoC9mJF;EpC+mJE,yBoC5kJU;EpC6kJV,qBoCpmJI;ApCqmJN;;AAEA;;;EAGE,WoCtnJF;EpCunJE,yBoC3mJS;EpC4mJT,qBoCtkJU;ApCukJZ;;AAEA;;;EoC5jJA,iDAAc;ApCgkJd;;AAEA;EACE,WoC1jJW;EpC2jJX,yBoCzjJQ;EpC0jJR,qBoCzjJa;EpC0jJb,2EoCxjJG;ApCyjJL;;AAEA;EoCljJA,WAAU;EpCojJR,yBoCjiJC;EpCkiJD,qBoCljJO;ApCmjJT;;AAEA;;EAEE;mCoC7iJG;ApC+iJL;;AAEA;;EqCv0JA,WAAY;EACV,yBAAa;EACb,qBAAe;ArC00JjB;;AAEA;;;EAGE,WAAW;EqCt0Jb,yBAEI;EACA,qBhCwhCqC;AL8yHzC;;AAEA;;;EAGE,iDAAiD;AqC90JnD;;ArCi1JA;EqCj1JA,WAAA;EAwBI,yBACD;ErC2zJD,qBAAqB;EqCp1JvB,2EA2BW;ArC2zJX;;AsCj2JA;EACE,WAAS;ECGT,yBAAe;EACf,qBAAgB;AvCk2JlB;;AsCj2JA;;EAEE;kChCixBwC;ANolI1C;;AAEA;;EsCh2JE,WjCkS+B;EiC3SjC,yBAWU;EtCk2JR,qBsCj2JY;AtCk2Jd;;AAEA;;;EAGE,WsC/1JW;EtCg2JX,yBMplImC;ENqlInC,qBsC91JC;AtC+1JH;;AAEA;;;EAGE,gDAAgD;AsCj2JlD;;AtCo2JA;EACE,WAAW;EsCr2Jb,yBAaW;EACP,qBAAU;EACV,2EjCrBW;AL+2Jf;;AAEA;EsC32JA,WAAU;EAqBN,yBjCrBc;EiCsBd,qBAAoB;AtCy1JxB;;AAEA;;EwC94JE;kClC0xBwC;ANwnI1C;;AAEA;;EWv2JI,WAAA;EACA,yBAAyB;EX02J3B,qBAAqB;AwC34JjB;;AxC84JN;;;EwC15JI,WlCsxBgC;EC3pB9B,yBAtCY;EiCnFd,qBACD;AxC65JH;;AAEA;;;EwCt5JM,gDAAW;AxC05JjB;;AAEA;EyCv6JA,WAAO;EACL,yBAAqB;EACrB,qBpCm3BkC;EElzBhC,2EAAW;APy2Jf;;AAEA;EyCv6JE,WAAW;EACX,yBAAwB;E9BKtB,qBNkS0B;ALmoJ9B;;AAEA;;EkBz6JE;oCAGC;AlB06JH;;AAEA;;EyCh6JE,WAAU;EACV,yBACD;EzCk6JC,qBAAqB;AyC55JvB;;AzC+5JA;;;EyCp5JE,WAAA;ECjDD,yBAAqC;EAClC,qBAAkB;A1C08JtB;;AAEA;;;EyC55JE,kDAAiB;AzCg6JnB;;AAEA;EACE,WKl7JS;ELm7JT,yB0C/8J4B;E1Cg9J5B,qB0C/8JyB;E1Cg9JzB,2EAA2E;AyCt6J3E;;AzCy6JF;EkB38JE,WAAA;ElB68JA,yBKn8Ja;ELo8Jb,qB0Cv9JwB;A1Cw9J1B;;AyC76JE;;EChDE;iCDgDF;AzCm7JF;;AAEA;;EyCr7JE,WAAA;ECjDD,yBAAqC;EAClC,qBAAkB;A1C0+JtB;;AAEA;;;EyC57JE,WAAa;ECjDd,yBAAqC;EAClC,qBAAkB;A1Ck/JtB;;AAEA;;;EyCp8JE,+CAAiB;AzCw8JnB;;AAEA;EACE,WKn+JS;ELo+JT,yB0Cv/J4B;E1Cw/J5B,qB0Cv/JyB;E1Cw/JzB,2EAA2E;AyC98J3E;;AzCi9JF;EkBn/JE,WuBkCW;EzCm9JX,yBK3+Ja;EL4+Jb,qB0C//JwB;A1CggK1B;;AyCr9JE;;EChDE;iCDgDF;AzC29JF;;AAEA;;EyC79JE,WAAiB;ECjDlB,yBAAqC;EAClC,qBAAkB;A1CkhKtB;;AAEA;;;EyCp+JE,WAAA;ECjDD,yBAAqC;EAClC,qBAAkB;A1C0hKtB;;AAEA;;;EyC5+JE,+CAAiB;AzCg/JnB;;AAEA;EACE,cK3gKa;EL4gKb,sB0C/hKwB;E1CgiKxB,kB0C/hKuB;E1CgiKvB,2EAA2E;A2CxiK7E;;A3C2iKA;E2CviKE,cAAA;EhCcE,uBNoS0B;EU1P1B,mBAAmB;Afm/JvB;;AAEA;;E2CpiKE;oCACe;A3CuiKjB;;A4CjjKA;;EAEE,cvCqyBgB;EuCpyBhB,sBtCu9BsC;EsCt9BtC,kBAAkC;A5CojKpC;;A4C/iKA;;;EAMA,cAAY;EACV,yBACD;E5C8iKC,mBAAmB;A4CviKrB;;A5C0iKA;;;EAGE,kD4CtiKU;A5CuiKZ;;AAEA;EACE,yBAAyB;E4C7hKzB,gBAAiB;EC/Cf,iCxCyBW;EwCxBX,6BzBuG8D;EMnG9D,6BkB4CD;EC7CC,yBAAE;E7C8kKJ,sF6C7kKqC;A7C8kKvC;;AAEA;;;;EAIE,yB6CtkKG;E7CukKH,4CAA4C;E4C3iK5C,iCAAiB;EC/Cf,6BxCkCc;EwCjCd,sFzBuG8D;ApBs/JlE;;AAEA;;EAEE,yB6C9lKG;E7C+lKH,kC6CzlKO;EAGL,iCAAG;E7CwlKL,6B6CvlK2C;A7CwlK7C;;AAEA;E4CzjKE,cAAiB;EC/Cf,sBxCyBW;EwCxBX,kBzBuGM;EMnGN,2EkB4CD;A5C4jKH;;AAEA;EACE,c6CxmKM;E7CymKN,uB6CvmKO;EAGL,mBAAG;A7CsmKP;;AAEA;;E4CtkKE;oCvCtBa;ALgmKf;;AAEA;;EAEE,c6CvnKiB;E7CwnKjB,sB6CtnKc;E7CunKd,kB6CrnKO;A7CsnKT;;AAEA;;;E4CnlKE,cAAiB;EC/Cf,yBxCyBW;EwCxBX,mBzBuGM;ApBgiKV;;AAEA;;;EAGE,kD6CnoKO;A7CooKT;;AAEA;EACE,W6C/nKa;E7CgoKb,uBAAuB;E4CnmKvB,mBAAiB;EC/Cf,2ExCyBW;AL4nKf;;AAEA;EACE,W6CnpKa;E7CopKb,uB6C9oKG;E7C+oKH,mB6CtpKG;A7CupKL;;AAEA;;EAEE;8BAC4B;A4CjnK5B;;A5ConKF;;E6C/pKI,WAAA;E7CkqKF,uB6CjqKqC;E7CkqKrC,mB6CjqKsB;A7CkqKxB;;AAEA;;;EAGE,W6C3pKa;E7C4pKb,uBAAuB;E4C/nKvB,mBAAiB;A5CioKnB;;AAEA;;;EAGE,4C6C1qKG;A7C2qKL;;AAEA;EACE,c6C3qKM;EAGJ,6BAAY;E7C0qKd,sB6CxqKG;E7CyqKH,qBAAqB;A4C7oKrB;;A5CgpKF;E0B1rKI,WAAA;EmBDA,yBAAE;E7C8rKJ,qB6C7rKqC;A7C8rKvC;;AAEA;;EAEE,2C6CxrKG;A7CyrKL;;AAEA;;E6C1sKI,cxCkCc;EwCjCd,6BzBuG8D;ApBsmKlE;;AAEA;;;EAGE,WKjrKS;EwCrBP,yBAAG;E7CwsKL,qB6CvsKwB;A7CwsK1B;;AAEA;;;E6CvtKI,2CzBuG8D;ApBonKlE;;AAEA;EACE,c6CztKiB;E7C0tKjB,6B6CxtKc;E7CytKd,sB6CvtKO;EAGL,qBAAG;A7CstKP;;AAEA;EACE,cAAc;E4CvrKd,yBAAiB;EC/Cf,qBxCyBW;ALgtKf;;AAEA;;EAEE,4C6CluKG;A7CmuKL;;AAEA;;E6C/tKI,cAAA;E7CkuKF,6B6ChuKG;A7CiuKL;;AAEA;;;EAGE,c8CtvKO;E9CuvKP,yBAAyB;E8CnvK3B,qBAAU;A9CqvKV;;AAEA;;;E8CjvKE,4CzCcgB;ALuuKlB;;AAEA;E8ClvKA,cAAc;EACZ,6BAAa;EACb,sBAAsB;EACtB,qBAAiB;A9CovKnB;;AAEA;E8ClvKE,WAAW;EACX,yBzCuDqB;EiBlEjB,qBhBk+BoC;AN8xI1C;;AAEA;;E8CnvKA,2CAAsB;A9CsvKtB;;AAEA;;E8CjvKI,cxC28BmC;EwCx8BjC,6BAAQ;A9CkvKd;;AAEA;;;E+C3xKE,WAAW;E/C+xKX,yBAAyB;E+C5xK3B,qBAAY;A/C8xKZ;;AgD/xKA;;;EAKE,2CAAe;AhDgyKjB;;AAEA;EgDvxKA,cAAA;EACE,6BAAW;EACX,sB3CWgB;E2CVhB,qBAAmB;AhDyxKrB;;AAEA;EACE,WgDtxKE;EhDuxKF,yBKzxKS;E2CPX,qBAAA;AhDkyKA;;AAEA;;EgD3wKE,2CAAkB;AhD8wKpB;;AAEA;;EgDjxKA,cAAA;EhDoxKE,6BgD1wK6B;AhD2wK/B;;AAEA;;;EAGE,WKtyKS;ELuyKT,yBgDvwKsB;EhDwwKtB,qBK9yKS;AL+yKX;;AAEA;;;EgD/xKA,2CAgCQ;AhDmwKR;;AAEA;EACE,cgDjwKI;EhDkwKJ,6BAA6B;EgDpvK3B,sBAAgC;EAC9B,qBAAmB;AhDsvKzB;;AAEA;EgDzvKI,WAAA;EhD2vKF,yBW7xKyB;EX8xKzB,qBWlxKE;AXmxKJ;;AAEA;;EAEE,0CgDvuKO;AhDwuKT;;AAEA;;EevyKI,cAAQ;EiCmCR,6BAAgC;AhDwwKpC;;AAEA;;;EAGE,WW/yKE;EXgzKF,yBWpyKE;EXqyKF,qBgD/wKE;AhDgxKJ;;AAEA;;;EAGE,0CKnkK+B;ALokKjC;;AezzKI;EiCmCA,cAAA;EhD0xKF,6BgD9vKG;EhD+vKH,sBgD3xKE;EhD4xKF,qBWlzKE;AXmzKJ;;AAEA;EACE,WWtzKE;EXuzKF,yBgDjyKE;EhDkyKF,qBgDlxKO;AhDmxKT;;AAEA;;EAEE,0CKrlK+B;ALslKjC;;Ae30KI;;Ef+0KF,cgD3yKI;EhD4yKJ,6BgD7yK2B;AhD8yK7B;;AAEA;;;EAGE,WgDnzKE;EhDozKF,yBgDpyKO;EhDqyKP,qBgDrzKE;AhDszKJ;;AAEA;;;EAGE,0CAA0C;Ae91KxC;;Afi2KJ;EACE,cgD/zKE;EhDg0KF,6BWt1K2B;EXu1K3B,sBWn2KE;EXo2KF,qBgDl0KE;AhDm0KJ;;AAEA;EACE,WgDvzKQ;EhDwzKR,yBgDv0KE;EhDw0KF,qBgDrzKwB;AhDszK1B;;AAEA;;EAEE,4CAA4C;AgDvyK9C;;AhD0yKA;;EAEE,cgD5yKF;EhD6yKE,6BgDryKG;AhDsyKL;;AAEA;;;EAGE,WoB/0KQ;EpBg1KR,yBiD/6KwB;EAPxB,qBAAA;AjDw7KF;;AAEA;;;EiDz7KI,4C7BqG8D;ApBw1KlE;;AAEA;EACE,ciD17KM;EAPN,6BAA0B;EjDm8K1B,sBK56Ka;EL66Kb,qBoB91KQ;ApB+1KV;;AiDr8KE;EACE,W7BqGM;E6BpGN,yB7BoG8D;EFzFhE,qBAAA;AlB87KF;;AAEA;;EAEE,yCoBz2KgE;ApB02KlE;;AiDh9KE;;EAEE,cAAA;E/BWF,6B+BbqB;AjDs9KvB;;AAEA;;;EAGE,WiD98KM;EjD+8KN,yBAAyB;EiD59KzB,qBAAA;AjD89KF;;AAEA;;;EiDh+KE,yCAAwB;AjDo+K1B;;AAEA;EACE,cAAc;EiDv+Kd,6BAA2B;EACzB,sB7BqG8D;E6BpG9D,qB7BoGM;ApBq4KV;;AAEA;EiD7+KE,WAAA;EjD++KA,yBKx9Ka;ELy9Kb,qBoB14KQ;ApB24KV;;AiDj/KE;;EAEE,yCAcD;AjDs+KH;;AAEA;;EAEE,cKn+Ka;ELo+Kb,6BoBr5KgE;ApBs5KlE;;AiD5/KE;;;E/BaA,WAAA;ElBq/KA,yBoB55KgE;EpB65KhE,qBiD5/KwB;AjD6/K1B;;AAEA;;;EiDtgLE,yCAA2B;AjD0gL7B;;AAEA;EACE,WoBv6KQ;EpBw6KR,6BiDvgL+C;EAP/C,sBAAA;EjDghLA,kBKz/Ka;AL0/Kf;;AAEA;EiDnhLE,cAAA;EACE,sB7BqG8D;E6BpG9D,kB7BoGM;ApBi7KV;;AAEA;;EAEE,4CKpgLa;ALqgLf;;AAEA;;EiD7hLI,W7BqGM;E6BpGN,6BAcD;AjDkhLH;;AAEA;;;EAGE,ciD3hLM;EjD4hLN,sBoBl8KQ;EpBm8KR,kBAAkB;AiDziLlB;;AjD4iLF;;;EAGE,4CkB/hLC;AlBgiLH;;AAEA;EACE,WiDtiLM;EjDuiLN,6BAA6B;EkDvjL/B,sBAAO;EACL,kBAAY;AlDyjLd;;AAEA;EkDvjLE,c7C+0BkC;E6C90BlC,sB7Cg1BsC;E6C/0BtC,kBAaD;AlD4iLD;;AAEA;;EAEE,4CKhvJmD;ALivJrD;;AAEA;;EkD3iLA,WAAa;EACX,6BAAU;AlD8iLZ;;AAEA;;;EAGE,cAAc;EmD1kLhB,sBAAY;EAEV,kBAAgB;AnD2kLlB;;AAEA;;;EmDnkLE,4CAAe;AnDukLjB;;AAEA;EmDrkLE,YAAS;EACT,6BAAW;EACX,sBAAY;EACZ,mBAAgB;AnDukLlB;;AmD7jLA;EACE,WAAU;EACV,uBAAW;EACX,mB7C+4BuC;ANirJzC;;AAEA;;EAEE,sCsBtlLoC;AtBulLtC;;AAEA;;EmDzjLE,YAAM;EnD4jLN,6BmD1jLC;AnD2jLH;;AAEA;;;EAGE,WmDxjLE;EnDyjLF,uBmDvjLC;EAPH,mBAAA;AnDgkLA;;AAEA;;;EmD/iLA,sCAAuB;AnDmjLvB;;AAEA;EmDrjLA,gBAAA;EnDujLE,cmDhjLW;EnDijLX,qBoBt/KiC;ApBu/KnC;;AAEA;EACE,cmD7iLE;EnD8iLF,qBmD7iLmB;AnD8iLrB;;AAEA;;EAEE,qBmDziLG;AnD0iLL;;AAEA;;EmDpiLE,cAAc;EACd,oBAAW;AnDuiLb;;AAEA;;EWroLI,sBNoS0B;EOtSxB,mBPo7BqC;E8C50BzC,gBACD;EnDmiLC,wBAAwB;AmDhiL1B;;AnDmiLA;;EmD/hLE,uB7C+iBsC;E6C9iBtC,kBAAY;EACZ,gBAAa;EACb,sB9C/Fa;ALioLf;;AAEA;EACE,cKhuJkC;ELiuJlC,WAAW;AmD7hLb;;AnDgiLA;EmD7hLE,kBAAiB;AnD+hLnB;;AAEA;;;EAGE,WKtuJkC;ALuuJpC;;AmDxhLA;EACE,gCAAgB;AnD2hLlB;;AmDrhLA;EACE;IAGA,gBAAc;EACd;AnDshLF;;AAEA;EmDlhLE,UAAS;AnDohLX;;AAEA;EmDlhLE,a9CgxBmC;ALowJrC;;AAEA;EACE,kBmDhhL0C;EnDihL1C,SAAS;EmD5gLX,gBAAA;EACE,4BAAkB;AnD8gLpB;;AAEA;EmD5gLE;InD8gLE,gBAAgB;EerpLhB;AfupLJ;;AAEA;;;;EAIE,kBoB3kLiC;ApB4kLnC;;AAEA;EACE,mBoB/kLiC;ApBglLnC;;AAEA;EmD7/KE,qBAAU;EnD+/KV,oBKvyJuC;ELwyJvC,uBAAuB;EevqLrB,WAAQ;EoC2KV,uBAAS;EACT,qCAAU;EnD+/KV,gBK9yJkC;EL+yJlC,oCAAoC;Ae5qLlC;;Af+qLJ;EACE,cAAc;AoD3uLhB;;ApD8uLA;EoD3uLE,kBAAc;EACd,S9C21BmC;E+C/1BnC,OAAA;EAEA,aAAY;EACZ,ahD2W4B;EgD1W5B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAiB;EACjB,eAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAY;EACZ,sBAAoB;EACpB,4BAAmB;EACnB,mCAAgB;E9CgHZ,wBAtCY;E6C9EhB;qEAkBD;ApDsuLD;;AAEA;EACE,WoDrvLU;EpDsvLV,OoDrvLE;ApDsvLJ;;AAEA;EACE,QoDpvLI;EpDqvLJ,UoDpvLI;ApDqvLN;;AAEA;EoDhvLA;IACE,W9Cm0BkC;I8Cp0BpC,OAAA;EpDovLE;;EAEA;IACE,QoD/uLE;IpDgvLF,UoD/uLE;EpDgvLJ;AoD3uLF;;ApD8uLA;EACE;IoD1uLE,W9CizBgC;I8ChzBhC,OAAM;EpD4uLR;;EAEA;IACE,QoD1uLE;IpD2uLF,UAAU;EoDtuLd;ApDwuLA;;AAEA;EACE;IACE,WoDruLW;IpDsuLX,OoDruLE;EpDsuLJ;;EoDhuLF;IACE,QAAU;IADZ,UAAA;EpDquLE;AACF;;AAEA;EACE;IACE,WoDhuLE;IpDiuLF,OoDhuLE;EpDiuLJ;;EoD3sLA;IACA,Q9CivBkC;I8ChvBlC,U/CpFa;E+CqFb;ApD8sLF;;AAEA;EsD/zLA,SAAS;EACP,YAAU;EACV,aAAM;EACN,uBAAO;AtDi0LT;;AAEA;EqDr0LE,qBhDoW4B;EgDlW5B,oBAAkB;EAClB,uBhD2W+B;EgD1W/B,WAAW;EACX,aAAY;EACZ,qCAAiB;EACjB,0BAAqB;EACrB,oCAAiB;ArDs0LnB;;AAEA;EqDp0LE,cAAc;ArDs0LhB;;AAEA;EsDz0LE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAA8B;E3CG5B,qBNoS0B;ALqiL9B;;AAEA;EACE,qBsDz0LgB;EtD00LhB,oBKl/JsC;ELm/JtC,uBKl/JuC;ELm/JvC,WsDz0LW;EtD00LX,mCsDl2LM;EtDm2LN,esDv0Lc;EtDw0Ld,sCsDv0LkB;EtDw0LlB,wBsDv0Le;AtDw0LjB;;AAEA;EsDn0LA,cAAe;AtDq0Lf;;AAEA;EACE,iBsDx0La;AtDy0Lf;;AAEA;EACE,MsD50LF;EtD60LE,WsDh0LU;EtDi0LV,UsDh0LI;EtDi0LJ,asDh0LI;EtDi0LJ,sBAAsB;AsD5zLxB;;AtD+zLA;EACE,qBoB3uLiC;EpB4uLjC,oBK5gKuC;EL6gKvC,uBK9gKsC;EL+gKtC,WKtkL4B;ALukL9B;;AAEA;EACE,asD3zLI;AtD4zLN;;AAEA;EACE,qBsDzzLI;EtD0zLJ,qBAAqB;EsDrzLvB,uBAuDA;EAtDE,WAAU;EADZ,mCAuDA;EtDkwLE,yBoB3vLiC;EpB4vLjC,sCsDpzLW;AtDqzLb;;AAEA;EACE,csD9zLF;AtD+zLA;;AAEA;EsDj0LA,iBAAA;AtDm0LA;;AAEA;;;;EAIE,WsD9yLW;EtD+yLX,YsD9yLE;AtD+yLJ;;AAEA;EsD7yLA,SAAA;EtD+yLE,gBoBjxLiC;EpBkxLjC,gBKljKuC;ELmjKvC,6BKpjKsC;ALqjKxC;;AAEA;EACE,csD1yLI;EtD2yLJ,WsD1yLI;EtD2yLJ,oBsDvzLc;EtDwzLd,WKzkKkC;EL0kKlC,gBsDxyLgB;EtDyyLhB,csDxyLI;EtDyyLJ,mBAAmB;EsDnxLrB,mBAAgB;EACd,6BjD8sBwC;EiD7sBxC,SAAA;AtDqxLF;;AAEA;;EWt5LI,cAAA;EACA,qBAAA;E2C4HJ,yBASU;AtDqxLV;;AsDhxLA;;EAEE,cjDvIgB;EL05LhB,qBAAqB;EuD96LvB,6BAAU;AvDg7LV;;AuD56LA;;EvDg7LE,cAAc;EuD56LhB,oBAAgB;EACd,6BAAkB;AvD86LpB;;AAEA;EACE,cwDr8LW;AxDs8Lb;;AAEA;EuD96LA,cAAe;EACb,oBAAkB;EAClB,gBAAa;EACb,mBAAW;EACX,cAAW;EACX,mBAAmB;AvDg7LrB;;AAEA;EACE,cuDx7LF;EvDy7LE,oBsBh8LsB;EtBi8LtB,cAAc;AuDh7LhB;;AAEA;;EvDm7LE,kBAAkB;EuD/6LpB,oBAAmB;EACnB,sBAAO;AvDi7LP;;AuD76LA;;EAEE,kBAAW;EvDg7LX,cAAc;AuDx6LhB;;AvD26LA;;EAEE,UAAU;AuD76LZ;;AAAA;;;;;;EAgBI,UAAU;AvDu6Ld;;AAEA;EACE,auD17LF;EvD27LE,euD37LF;EvD47LE,2BuDz6LC;AvD06LH;;AuDj6LA;EACE,WAAU;AvDo6LZ;;AAEA;;EuDh6LE,iBAAa;AvDm6Lf;;AAEA;;EuDh6LE,0BjDk9BqC;EgBriCjC,6BhBuiC4C;ANg9JlD;;AAEA;;EkBz/LE,yBAAC;EqCuEH,4BrCvES;AlB6/LT;;AAEA;EACE,wBuDt6LY;EvDu6LZ,uBkB9/LC;AlB+/LH;;AAEA;;;EuD/5LE,cAID;AvD+5LD;;AuD35LA;EACE,eAAS;AvD85LX;;AAEA;;EuD35LA,uBAAA;EACE,sBnCvEe;ApBq+LjB;;AAEA;;EuDp5LA,sBAAqB;EACnB,qBAAkB;AvDu5LpB;;AAEA;EuDr5LE,gBAAW;AvDu5Lb;;AAEA;EuDp5LE,gBjD05BmC;AN4/JrC;;AAEA;EACE,sBuDp5Lc;EvDq5Ld,uBuDp5LgB;EvDq5LhB,uBM5/JuC;AN6/JzC;;AAEA;;EAEE,WuDp5LU;AvDq5LZ;;AAEA;;EAEE,gBuDn5La;AvDo5Lf;;AAEA;;EuDl7LA,6BAgCU;EvDq5LR,4BuDn5LC;AvDo5LH;;AAEA;;EuD34LE,yBAAY;EACZ,0BAA0C;AvD84L5C;;AAEA;;EuD34LE,gBAAY;AvD84Ld;;AAEA;;;;EAIE,kBAAkB;EyDnlMpB,sBAAmB;EAAE,oBAAgB;AzDslMrC;;AAEA;EACE,kBAAkB;EyDvlMpB,aAAA;EAAqB,eAAc;EzD0lMjC,oBAAoB;EyDzlMtB,WAAA;AzD2lMA;;A0DhmMI;;;;EAIA,kBxCUD;EwCVC,cAAM;EAEE,SAAA;E1DmmMV,YAAY;E0DzmMV,gBAAW;A1D2mMf;;AkB7lME;;;;;;;;;;;;ElB2mMA,iBAAiB;A0DznMf;;A1D4nMJ;;;E0DxnMI,UAAM;A1D4nMV;;A0DhoMI;EACI,UAAA;A1DmoMR;;A0DhoMI;;EAEQ,yBAAqC;E1DmoM/C,4BAA4B;A0DzoM1B;;A1D4oMJ;E0DzoMK,axCWF;EwCVC,mBxCUD;AwCVC;;A1D6oMJ;;E0DhpMQ,yBrD4BU;ELunMhB,4BAA4B;AkBtoM5B;;AwCVE;;;EAJA,0BAAW;EACP,6BAAyB;A1D2pMjC;;A0DxpMI;;;E1D6pMF,0BAA0B;E0DjqMxB,6BAAW;A1DmqMf;;AkBrpME;;EwCVE,aAAM;A1DoqMV;;A0DxqMI;;E1D4qMF,kBAAkB;E0DzqMf,UxCWF;AwCVC;;A1D4qMJ;;E0DhrMI,UAAW;A1DmrMf;;AkBrqME;;;;;;;;EwCXG,iBAAD;AACA;;A1D4rMJ;EACE,kBAAkB;A0DjsMhB;;A1DosMJ;E2DtrMA,iBAAgB;A3DwrMhB;;A4DlsMA;EAAkB,aAAsB;E5DssMtC,mBAAmB;E4DrsMrB,yBAAgB;EAAE,gBAA0B;E5DwsM1C,mBAAmB;E4DvsMrB,gBAAgB;EAAE,gBvDySY;ELi6L5B,cAAc;E4DzsMhB,kBAAgB;EAAE,mBAA6B;E5D4sM7C,sBAAsB;E4D3sMxB,yBAAgB;EAAE,sBAAgC;A5D8sMlD;;AAEA;;E4D7sMA,aAAiB;A5DgtMjB;;A4D/sMA;;E5DmtME,mCAAmC;A4DltMrC;;A5DqtMA;;;;;;EAME,sBAAsB;E4DvtMtB,mBAAkB;EAChB,gBvD+DY;EL0pMd,wBAAwB;A4D1tMxB;;A5D6tMF;;E4D5tMI,kCAA+B;A5D+tMnC;;AAEA;;;;;;E4DjuMI,uBAAqB;E5DwuMvB,kBAAkB;E4DzuMlB,gBAAkB;EAChB,sBAAqB;A5D2uMzB;;AAEA;;E4D9uME,sBAAkB;A5DivMpB;;A4DjvME;;;;;;;;E5D2vMA,0BAA0B;E4D9uM5B,6BAAY;A5DgvMZ;;A4D5uMA;;;;;;E5DovME,yBAAyB;E4D3uM3B,4BAAe;A5D6uMf;;AAEA;E4D1uMA,aAAe;EACb,cAAA;EACA,mBAAA;A5D4uMF;;AAEA;E4DzuME,kBAAA;E5D2uMA,UAAU;E4DxuMZ,cAAY;EACV,kBvDyP4B;ELi/L5B,qBAAqB;E4DvuMvB,iCC1DA;UD0DA,mBC1DA;A7DmyMA;;A4DruMA;EACE,oBtD8KiC;EN0jMjC,kBAAkB;A4DruMpB;;A5DwuMA;EwD/yME,kBAAS;EACP,OAAO;EACP,WAAW;EACX,WAAW;ExDizMb,eAAe;E8D1yMX,UAAsB;A9D4yM5B;;A8D5yMM;EAAwB,WxDqmCb;EN2sKf,qBAAqB;E8DhzMjB,yBAAsB;EAAE,+CAA8B;A9DmzM5D;;AAEA;EACE;uC8DtzM0B;A9DwzM5B;;A8DxzMM;EAAwB,qBAAgB;A9D4zM9C;;AAEA;EACE,WAAW;E8D/zMP,yBAAsB;EAAE,qBAAgB;E9Dk0M5C,+CAA+C;A8Dl0M3C;;A9Dq0MN;;E8Dr0MM,cAAsB;A9Dw0M5B;;AAEA;;EAEE,yB8D50M4C;A9D60M9C;;AAEA;EACE,kB8Dh1M4C;EAAxC,gBAAsB;E9Dk1M1B,mBM7uKmD;AN8uKrD;;AAEA;EACE,kB8Dt1M4C;EAAxC,YAAA;E9Dw1MJ,cMnvKgF;ENovKhF,cAAc;EexyMZ,WAAQ;E+CjDN,YAAsB;E9D41M1B,oB8D51M4C;EAAxC,WAAA;E9D81MJ,sB8D91M4C;EAAxC,yBAAsB;E9Dg2M1B,+C8Dh2M0D;A9Di2M5D;;AAEA;EACE,kB8Dp2M4C;EAAxC,YAAA;E9Ds2MJ,cMjwKmD;EwDrmC/C,cAAA;E9Dw2MJ,WMnwK8D;EwDrmC1D,YAAsB;E9D02M1B,WMrwK0E;EwDrmCtE,mCAAsB;A9D42M5B;;Ae3zMI;E+CjDE,sBAAsB;A9Dg3M5B;;AAEA;E8Dl3MM,yDAAsB;A9Do3M5B;;AAEA;E8Dt3MM,qBAAsB;E9Dw3M1B,yB8Dx3M4C;EAAxC,YAAA;A9D03MN;;AAEA;E8D53MM,yDAAsB;A9D83M5B;;AAEA;EACE,yCAAyC;Aeh1MvC;;Afm1MJ;E8Dp4MM,yCAAsB;A9Ds4M5B;;AAEA;E8Dx4MM,kBAAsB;A9D04M5B;;AAEA;E8D54MM,yDAAsB;A9D84M5B;;AAEA;E8Dh5MM,yCAAsB;A9Dk5M5B;;AAEA;EACE,oBAAoB;A8D34MtB;;A9D84MA;E8D54MI,aAAA;E9D84MF,cMrzKe;EwDzlCb,mBAAA;E9Dg5MF,qBMvzKuB;ANwzKzB;;AAEA;EACE,wB8Dp5MuC;EAArC,yBAAmB;E9Ds5MrB,uB8Dt5MuC;EAArC,wBAAmB;E9Dw5MrB,yB8Dx5MuC;EAArC,qBAAmB;E9D05MrB;gE8D15MqB;A9D45MvB;;A+Dj7MA;EACE;IACA,gBAAc;EACd;A/Do7MF;;AAEA;EACE,sB+Dl7MgB;E/Dm7MhB,8B+Dj7MC;A/Dk7MH;;AAEA;E+D97MA,yCAeQ;A/Di7MR;;AAEA;EACE,qB+Dh7MW;E/Di7MX,W+Dh7MS;E/Di7MT,mC+Dh7Ma;E/Di7Mb,0C+Dh7Mc;E/Di7Md,mB+D/6MC;E/Dg7MD,gBAAgB;E+Dz6MhB,gBAAA;EAEI,cAAa;E/D06MjB,sBAAsB;E+D56MtB,gGACY;EACR,yBACD;E/D46MH,uBAAuB;E+D/6MvB,gDACY;EACR,wBAA4F;UAA5F,gBAA4F;A/Dg7MlG;;AAEA;EACE,qBAAqB;E+Dr7MrB,UAAA;EAEI,iEACD;A/Dq7ML;;AAEA;EACE,cAAc;E+D37Md,sBAAsB;A/D67MxB;;A+D77ME;;E/Di8MA,YAAY;EgEx9MV,sBAA8B;EAAE,sBAAgB;AhE29MpD;;AAEA;EACE,cAAc;EgE59MZ,yBAA8B;AhE89MlC;;AgE79MI;EAAgC,aAAA;AhEi+MpC;;AAEA;EACE,kBAAkB;EgEj+MhB,0BAA4B;AhEm+MhC;;AgEl+MI;EAA8B,kCAAkC;EhEs+MlE,oBAAoB;EgEr+MlB,uBAA4B;EAAE,oBAAM;EhEw+MtC,kBAAkB;AgEv+MhB;;AhE0+MJ;EgEz+MI,mCAA4B;EAAE,qBAAW;EhE4+M3C,wBAAwB;EgE3+MtB,kBAA4B;EAAE,mBAAa;AhE8+M/C;;AAEA;EACE,kBAAkB;EgE9+MhB,qBAAkC;EAAE,WAAA;EhEi/MtC,mCAAmC;EgEh/MjC,gBAAA;AhEk/MJ;;AgEj/MI;EAAoC,kBAAiB;EhEq/MvD,UAAU;EgEp/MR,WAAA;EAAoC,mCAAiB;EhEu/MvD,SAAS;EgEt/MP,gBAAA;EAAoC,UAAA;AhEy/MxC;;AAEA;EACE,qBAAqB;EgEz/MnB,6EAA+B;AhE2/MnC;;AgE1/MI;;EhE8/MF,yBAAyB;AgE7/MvB;;AhEggNJ;EgE//MI,iBAAA;AhEigNJ;;AgE//MI;EAAkC,0BAAe;AhEmgNrD;;AAEA;EACE,kBAAkB;EgEpgNhB,MAAA;EAAkC,QAAA;EhEugNpC,OAAO;EgEtgNL,UAAA;EAAkC,mCAAe;EhEygNnD,yBAAyB;EgExgNvB,gBAAA;EAAkC,gBAAe;EhE2gNnD,gBAAgB;EgE1gNd,cAAA;EAAkC,sBAAe;EhE6gNnD,yBAAyB;EgE3gNvB,sBAA8B;EAAE,+CAA+B;AhE8gNnE;;AAEA;EACE,kBAAkB;EgE/gNhB,MAAA;EAAgC,QAAA;EhEkhNlC,SAAS;EgEjhNP,UAAA;EAAgC,cAAY;EhEohN9C,6BAA6B;EgEnhN3B,yBAA8B;EAAE,gBAAY;EhEshN9C,cAAc;EgErhNZ,iBAAmB;EAAa,sBAAY;EhEwhN9C,oBAAoB;Ee5gNlB,kCAAwB;Af8gN5B;;AAEA;EACE,WgElkNkC;EAChC,YAAA;EhEmkNF,UgEnkNkC;EAChC,6BAA8B;EhEokNhC,wBgEpkNgD;UhEokNhD,gBgEpkNgD;AhEqkNlD;;AAEA;EACE,UgErkNgC;AhEskNlC;;AAEA;EACE;uCgEtkN8B;AhEwkNhC;;AAEA;EgExkNI;uCAA2D;AhE2kN/D;;AAEA;EACE;uCgE1kNoC;AhE4kNtC;;AAEA;EgE5kNI,SAAA;AhE8kNJ;;AAEA;EgE7kNI,WAAA;EhE+kNF,YgE/kNmC;EACjC,oBAA+B;EhEglNjC,yBgEhlNgD;EAC9C,SAAA;EhEilNF,mBgEjlNgD;EAC9C,+CAA+B;EhEklNjC;gCgEjlNiC;EhEilNjC;gCgEjlNiC;EhEmlNjC,wBgEnlNgD;UhEmlNhD,gBgEnlNgD;AhEolNlD;;AAEA;EACE;IgEnlNE,wBAAA;IAAA,gBAAA;EhEqlNF;AACF;;AAEA;EACE,yBgEvlNmD;AhEwlNrD;;AAEA;EACE,WgExlNkC;EAChC,cAAA;EhEylNF,kBgEzlN8C;EAC5C,eAAA;EhE0lNF,yBgE1lN8C;EAC5C,yBAA8B;EhE2lNhC,mBgE3lN8C;EAC5C,sDAA8B;AhE4lNlC;;AAEA;EACE,WAAW;EellNT,YAAQ;EiDlDR,yBAA8B;EhEuoNhC,SgEvoNkC;EAChC,mBAA8B;EhEwoNhC,+CgExoNuE;EACrE;gCAAgD;EAAhD;gCAAgD;EAChD,gBAAA;AhE0oNJ;;AAEA;EgEzoNI;IAA8B,qBAAW;IAAX,gBAAW;EACzC;AhE4oNJ;;AAEA;EgE5oNI,yBAA4B;AhE8oNhC;;AAEA;EgE9oNI,WAAA;EhEgpNF,cgEhpN2C;EACzC,kBAA4B;EhEipN9B,egEjpN6C;EAE3C,yBAAyB;EhEipN3B,yBgEjpNuD;EACrD,mBAAA;EhEkpNF,sDgElpN8E;AhEmpNhF;;AAEA;EACE,WgEppNsC;EACpC,YAAA;EhEqpNF,agErpNsC;EAEpC,eAAA;EhEqpNF,cgErpN8C;EAC5C,yBAA+B;EhEspNjC,SgEtpNmC;EACjC,mBAAA;EhEupNF,+CgEvpNqE;EACnE;gCAA8C;EAA9C;gCAA8C;EAC9C,gBAAA;AhEypNJ;;AAEA;EgExpNI;IAAkC,oBAAe;IAAf,gBAAe;EACjD;AhE2pNJ;;AAEA;EgE3pNI,yBAAgC;AhE6pNpC;;AAEA;EgE5pNI,WAAA;EhE8pNF,cgE9pN8C;EAC5C,kBAAA;EhE+pNF,egE/pN8C;EAC5C,6BAA8B;EhEgqNhC,yBgEhqN8C;EAC5C,oBAAA;EhEiqNF,sDgEjqNmE;AhEkqNrE;;AAEA;EACE,yBgEnqN8C;EhEoqN9C,mBAAmB;AexpNjB;;Af2pNJ;EgE5sNI,kBAA8B;EhE8sNhC,yBgE9sNkD;EAChD,mBAAA;AhE+sNJ;;AAEA;EgE9sNI,yBAA4B;AhEgtNhC;;AAEA;EgEhtNI,eAAA;AhEktNJ;;AAEA;EgEltNI,yBAA4B;AhEotNhC;;AAEA;EgEptNI,eAAA;AhEstNJ;;AAEA;EgErtNI,yBAAyB;AhEutN7B;;AAEA;;;EgEttNI;gCAAqD;AhE2tNzD;;AAEA;;EgEztNI;;;IACiC,gBAAa;EAC9C;AhE8tNJ;;AAEA;EgE7tNI,aAAA;EhE+tNF,egE/tNiD;EAC/C,eAAA;EhEguNF,gBgEhuNiD;EAC/C,gBAAA;AhEiuNJ;;AAEA;EgEjuNI,cAAA;EhEmuNF,wBgEnuNmD;AhEouNrD;;AAEA;;EgEluNI,qBAA8B;AhEquNlC;;AAEA;EgEruNI,cAAA;EhEuuNF,oBgEvuN8C;EAC5C,eAAA;AhEwuNJ;;AAEA;EACE,gCAAgC;Ae9tN9B;;AfiuNJ;EgElxNI,mBAA8B;EhEoxNhC,6BgEpxNkD;EAChD,gCAA8B;EhEqxNhC,iCgErxNkD;AhEsxNpD;;AAEA;;EgEpxNI,qCAA4B;AhEuxNhC;;AAEA;EgEvxNI,cAA4B;EhEyxN9B,6BgEzxNyD;EACvD,yBAA4B;AhE0xNhC;;AAEA;;EAEE,cgE5xN2C;EACzC,yBAA4B;EhE6xN9B,qCgE7xN6D;AhE8xN/D;;AAEA;EACE,gBgE9xNsC;EACpC,yBAAA;EhE+xNF,0BgE/xNuD;AhEgyNzD;;AAEA;EACE,uBgEjyNuD;AhEkyNzD;;AAEA;;EgEhyNI,WAAA;EhEmyNF,yBgEnyNgD;AhEoyNlD;;AAEA;;EgElyNI,cAAA;EhEqyNF,kBgEryNmD;AhEsyNrD;;AAEA;;EgEryNI,aAAA;EhEwyNF,YgExyNoC;EAClC,kBAAA;AhEyyNJ;;AAEA;EgExyNI,aAAA;AhE0yNJ;;AAEA;EgE1yNI,cAAA;AhE4yNJ;;AAEA;EgE5yNI,kBAAA;EhE8yNF,agE9yN4C;EAC1C,eAAA;EhE+yNF,mBgE/yN8C;EhEgzN9C,8BAA8B;EiE11N5B,kBAAsB;AjE41N1B;;AiE31NI;;;;;;ElDqDA,aAAQ;EkDtDR,eAAsB;EjEs2NxB,mBiEt2NiC;EAC/B,8BAAsB;AjEu2N1B;;AAEA;EACE,qBAAqB;EerzNnB,sBAAwB;EkDtDxB,yBAAsB;EjE82NxB,kBiE92NiC;EAC/B,kBAAsB;EjE+2NxB,oBiE/2NiC;EAC/B,mBAAsB;AjEg3N1B;;Ae5zNI;;Efg0NF,qBiEt3NiC;AjEu3NnC;;AAEA;EACE,aiEx3NiC;EjEy3NjC,sBAAsB;Eer0NpB,eAAiB;EkDtDjB,gBAAsB;EjE83NxB,gBiE93NiC;AjE+3NnC;;AAEA;EACE,gBiEh4NiC;EjEi4NjC,eAAe;AkEt4Nf;;AlEy4NF;EkEz4NE,gBAAuB;EAAE,WAAW;AlE44NtC;;AAEA;EACE,qBAAqB;EmE/4NrB,oBAAoB;EAAE,uBAAiB;AnEk5NzC;;AAEA;EACE,gBAAgB;EoEp5NhB,YAAA;EAAyB,mBAAoB;ApEu5N/C;;AAEA;EACE,wBAAwB;EoE15NxB,kBAAuB;EAAE,c9D8mCG;EN+yL5B,6BAA6B;EoE75N7B,6BAAuB;EAAE,sBAAoB;ApEg6N/C;;AAEA;;EoE75NA,qBAAW;ApEg6NX;;AAEA;EoE95NE,qBAAO;EACP,Y9DgqBkC;ENgwMlC,aAAa;EoE75Nf,sBAAc;EACZ,WAAU;EACV,qCAAQ;ApE+5NV;;AAEA;EACE,gBAAgB;EoE35NY,gBAAjB;ApE65Nb;;AAEA;;EAEE;;;;;;IqEj7NA,gBAAY;IACZ,eAAgB;EAChB;ArEw7NF;;AAEA;EqE96NE;IAEE,qBAAgB;IAChB,2BAAW;EACX;;EAEA;IACA,mBAAmB;ErE+6NrB;;EsE58NW;ItE+8NT,kBAAkB;EsE98NtB;;EtEi9NE;IsEh9NF,mBAAW;IAAE,kBjEuTyB;EL4pNpC;;EsEl9Na;;;;;;ICCY,iBAAkB;EvE09N3C;;EuE19NyB;IvE69NvB,iBAAiB;EuE79NjB;;EvEg+NF;IuEh+NE,wBAAqB;IAAE,gBAAkB;EvEm+N3C;;EuEn+NyB;IvEs+NvB,aAAa;EuEt+Nb;AvEw+NJ;;AuEx+NI;;EvE4+NF;;;;;;IAME,gBAAgB;IuE9+NpB,eAAQ;EAAE;AvEi/NV;;AAEA;EACE;IuE/+NF,qBAAY;IAAE,2BAA2B;EvEk/NvC;;EuEj/NY;IvEo/NV,mBAAmB;EuEl/NvB;;EvEq/NE;IuEp/NF,kBAAQ;EAAE;;ECTF;IAAgC,mBAA4B;IxEmgOhE,kBAAkB;EwElgOd;;EAEE;;;;;;IAMF,iBAAK;EACL;;ExEqgON;IwElgOM,iBAAK;EACL;;ExEqgON;IwEnhOU,wBAA0B;IAAE,gBAAkB;ExEshOxD;;EwEphOM;IACE,anEiQL;ELsxNH;AwErhOM;;AxEwhOR;;EwEphOQ;;;;;;IAME,gBnEqPL;ILkyND,eAAe;EwEtiOX;AxEwiOR;;AwEviOQ;EACA;IACE,qBAA0B;IxE0iOhC,2BAA2B;EwExiOvB;;EAEE;IxE0iON,mBAAmB;EwExiOf;;EAEE;IxE0iON,kBAAkB;EwExiOd;;EAEE;IxE0iON,mBAAmB;IwEzjOX,kBAA0B;EAAE;;EAChC;;;;;;IAME,iBAA8B;ExE6jOtC;;EwE1jOM;IACE,iBnE4OG;ELi1NX;;EwE1jOM;IACE,wBAA4B;IxE6jOlC,gBAAgB;EwE5kOZ;;ExE+kON;IwE9kOM,aAAK;EACL;AxEglOR;;AwE7kOQ;;EAEE;;;;;;IAMF,gBAAK;IACL,eAA+B;EAC7B;AxEglOV;;AAEA;EACE;IwEjmOM,qBAAK;IACL,2BAA+B;EAC7B;;EAEF;IACA,mBAA+B;EAC7B;;EAEF;IACA,kBAA+B;EAC7B;;EAEF;IACA,mBAA+B;IAC7B,kBAA4B;ExEmmOpC;;EwElnOsC;;;;;;IAKhC,iBAAM;EACN;;ExEunON;IwEpnOM,iBAAM;EACN;;ExEunON;IwEpnOM,wBAAM;IACN,gBAA+B;EAC7B;;EAfF;IAAgC,aAAkB;ExEwoOxD;AwEvoOM;;AxE0oOR;EACE,qBAAqB;EwEvoOf,2BAAM;AACN;;AxE0oOR;;;;;;EwEloOQ,gBAA+B;EAC7B,enE4OF;AL65NR;;AAEA;EACE,mBAAmB;AwE1pOb;;AxE6pOR;EACE,kBAAkB;AwE1pOZ;;AxE6pOR;EACE,mBAAmB;EwE1pOb,kBAAM;AACN;;AxE6pOR;;;;;;EwEvqOwC,iBAAkB;AxE8qO1D;;AwE5qOQ;EACE,iBnE0PF;ALq7NR;;AwE5qOQ;EACE,wBAA8B;ExE+qOtC,gBAAgB;AwE7qOV;;AxEgrOR;EACE,aAAa;AwE7qOP;;AxEgrOR;EACE,yBAAyB;AwE9rOnB;;AxEisOR;;EwE/rOQ,yBAA+B;AxEksOvC;;AwE/rOQ;EACA,yBAA+B;AxEksOvC;;AwE/rOQ;;EAEE,yBAAgC;AxEksO1C;;AwE/rOQ;EACE,yBAA4B;AxEksOtC;;AAEA;;;;EwEhtOU,yBAA0B;AxEqtOpC;;AwEltOQ;EACE,yBAA8B;ExEqtOtC,yBAAyB;AwEntOnB;;AxEstOR;EACE,yDAAmR;AwEntO7Q;;AxEstOR;EACE,yBAAyB;AwEpuOnB;;AxEuuOR;EwEtuOQ,yBAAM;AACN;;AxEyuOR;;EwEruOQ,yBAA+B;AxEwuOvC;;AwEruOQ;EACA,gCAA+B;AxEwuOvC;;AwEruOQ;;EAEE,gCACD;AxEuuOT;;AAEA;EACE,gCAAgC;AwEzvO1B;;AxE4vOR;;EwExvOQ,gCAAM;AACN;;AxE4vOR;EwEzvOQ,gCAAM;AACN;;AxE4vOR;;;;EAIE,gCAAgC;AwE1wO1B;;AxE6wOR;EwE5wOQ,gCAAM;EACN,yBAA+B;AxE8wOvC;;AwE3wOQ;EACA,yDAA+B;AxE8wOvC;;AwE3wOQ;EACA,gCAA+B;AxE8wOvC;;AwE3wOQ;EACA,gCAA+B;AxE8wOvC;;AwE5xOQ;;ExEgyON,gCAAgC;AwE/xO1B;;AxEkyOR;EACE,kBAAkB;EwE/xOZ,aAAK;EACL,sBAA+B;EAC7B,YAAc;ExEiyOtB,qBAAqB;EwE/xOf,sBAAK;EACL,2BAA+B;EAC7B,qCACD;ExEgyOP,uBAAuB;AwE/xOjB;;AxEkyOR;EACE,eAAe;EwEhzOT,cAA8B;AxEkzOtC;;AwEjzOQ;EACA,mBAA+B;EAC7B,sBAA0B;AxEozOpC;;AwEjzOQ;EACE,mBAA8B;ExEozOtC,4CAA4C;EwElzOtC,6CAAK;AACL;;AxEqzOR;EwElzOQ,sBAAK;EACL,gDAA+B;EAC7B,+CACD;AxEmzOT;;AAEA;;EwEp0OQ,aAAK;AACL;;AxEw0OR;EwEr0OQ,cAAK;EACL,eAA+B;EAC7B,enEoQL;ALmkOL;;AwEp0OQ;EACE,sBAAgC;AxEu0O1C;;AwEp0OQ;EACE,qBAA4B;ExEu0OpC,gBAAgB;AwEt1OV;;AxEy1OR;EwEx1OQ,gBAAK;AACL;;AxE21OR;EwEx1OQ,qBAAK;AACL;;AxE21OR;EwEx1OQ,mBAAK;AACL;;AxE21OR;EwEx1OQ,uBAAK;EACL,gBAA+B;EAC7B,sBAA4B;ExE01OpC,4CAA4C;AwEz2OtC;;AxE42OR;EwE32OQ,4DAAK;AACL;;AxE82OR;EwE32OQ,uBAAK;EACL,sBAA+B;EAC7B,yCACD;AxE42OT;;AwE12OQ;EACE,4DACD;AxE42OT;;AwE12OQ;EACE,sBAA4B;ExE62OpC,uBAAuB;EwE53OjB,qBAA8B;EAAE,gBnEoQpB;AL2nOpB;;AwE73OQ;EACE,sBAA0B;ExEg4OlC,qBAAqB;AwE93Of;;AxEi4OR;EACE,kBAAkB;EwE93OZ,MAAK;EACL,QAA+B;EAC7B,SAAA;ExEg4OR,OAAO;EwE93OD,gBAAK;EACL,mCAA+B;AxEg4OvC;;AwE94OQ;;;EACA,cAAK;EACL,WAA+B;AxEm5OvC;;AwEh5OQ;;EAEE,4CACD;ExEk5OP,6CAA6C;AwEj5OvC;;AxEo5OR;;EwEh5OQ,gDAAK;EACL,+CAA+B;AxEm5OvC;;AwEj6OQ;EAAgC,mBAAkB;AxEq6O1D;;AwEn6OQ;EACE;IxEs6ON,aAAa;IwEp6OT,mBAAK;IACL,mBAA+B;IAC7B,kBAA8B;ExEs6OtC;;EwEn6OM;IACE,SAAe;IxEs6OrB,kBAAkB;IwEp6Od,gBAAK;IACL,iBAA+B;EAC7B;AxEs6OV;;AAEA;EACE,mBAAmB;AwEv7Ob;;AxE07OR;EACE;IwEv7OM,aAAK;IACL,mBAA+B;EAC7B;;EAEF;IACA,SAA+B;IAC7B,gBnE4PL;EL6rOH;;EwEt7OM;IACE,cnEwPL;ILisOD,cAAc;EwEx8OV;;ExE28ON;IwE18OM,0BAAK;IACL,6BAA+B;EAC7B;;EAEF;;IAEE,0BAA8B;ExE48OtC;;EwEz8OM;;IxE68OJ,6BAA6B;EwE18OzB;;EAEE;IxE48ON,yBAAyB;IwE39OrB,4BAA8B;EAAE;;EAChC;;IAEE,yBAA0B;ExE+9OlC;;EwE59OM;;IxEg+OJ,4BAA4B;EwE79OxB;AACA;;AxEg+OR;EwE79OQ,sBAAM;AACN;;AxEg+OR;EwE9+OQ;IAAgC,eAAkB;IxEi/OtD,mBAAmB;IwEh/Of,UAAM;IACN,SAA+B;EAC7B;;EAEF;IACA,qBAA+B;IAC7B,WAAc;ExEk/OtB;AwEh/OM;;AxEm/OR;EACE,qBAAqB;AwEh/Of;;AxEm/OR;EACE,gBAAgB;AwEjgPV;;AxEogPR;EwEngPQ,gBAAM;EACN,6BAA+B;EAC7B,4BAA0B;AxEqgPpC;;AwElgPQ;EACE,yBAA8B;ExEqgPtC,0BAA0B;AwEngPpB;;AxEsgPR;EACE,gBAAgB;EwEngPV,mBAAM;AACN;;AxEsgPR;EwEphPQ,aAA8B;EAAE,enE6PhC;EL0xON,oBAAoB;EwEthPd,mBAAM;EACN,gBAA+B;EAC7B,yBAA0B;ExEwhPlC,uBAAuB;AwEthPjB;;AxEyhPR;EACE,oBAAoB;AwEthPd;;AxEyhPR;EACE,WAAW;EwEthPL,qBAAM;EACN,cAA+B;EAC7B,YAAa;AxEwhPvB;;AAEA;EACE,0BAA0B;AwEziPpB;;AxE4iPR;EACE,qBAAqB;AwEziPf;;AxE4iPR;EACE,cAAc;AwEziPR;;AxE4iPR;EACE,aAAa;EwEziPP,eAAM;EACN,gBAA+B;EAC7B,uBAA4B;AxE2iPtC;;AAEA;EACE,kBAAkB;EwE5jPZ,cAAM;EACN,uBAA+B;EAC7B,iBnE4PF;ELk0ON,iBAAiB;EwE5jPX,cAAM;EACN,sBAA+B;EAC7B,yBAA8B;AxE8jPxC;;AwE3jPQ;EACE,UAAA;ExE8jPR,cAAc;EwE5jPR,qBAAM;EACN,yBAA+B;EAC7B,qBnEgPW;AL80OrB;;AAEA;EACE,UAAU;EwE/kPJ,UAAM;EACN,gBAA+B;AxEilPvC;;AwE9kPQ;EACA,cAA+B;EAC7B,gCAAwC;ExEilPhD,mCAAmC;AwE/kP7B;;AxEklPR;EACE,iCAAiC;EwE/kP3B,oCAAM;AACN;;AxEklPR;EwEhmPQ,UAA8B;EAAE,WnEiQhC;ELk2ON,yBAAyB;EwElmPnB,qBAAM;AACN;;AxEqmPR;EwElmPQ,cAAM;EACN,oBAA+B;EAC7B,YAAA;ExEomPR,sBAAsB;EwElmPhB,qBAAM;AACN;;AxEqmPR;EwElmPQ,uBAAM;EACN,kBAA+B;EAC7B,gBnEkPF;ALk3OR;;AAEA;EACE,iCAAiC;EwErnP3B,oCAAM;AACN;;AxEwnPR;EwErnPQ,kCAAM;EACN,qCAA+B;AxEunPvC;;AwEpnPQ;EACA,uBAA+B;EAC7B,mBnEuPF;ELg4ON,gBAAgB;AwErnPV;;AxEwnPR;EACE,+BAA+B;EwEtoPzB,kCAA8B;AxEwoPtC;;AwEvoPQ;EACA,gCAA+B;EAC7B,mCACD;AxEyoPT;;AwEvoPQ;;oCxE2oP4B;;AwEvoP5B;EACE,cAAe;ExE0oPvB,yBAAyB;EwExoPnB,qBAAK;AACL;;AxE2oPR;EwEzpPQ,cAA8B;EAAE,yBAA4B;ExE4pPlE,qBAAqB;AwE3pPf;;AxE8pPR;EACE,cAAc;EwE3pPR,yBAAK;EACL,qBAA+B;AxE6pPvC;;AwE1pPQ;EACA,cAA+B;EAC7B,yBAAgC;ExE6pPxC,qBAAqB;AwE3pPf;;AxE8pPR;EACE,qBAAqB;EwE5qPf,yBAA8B;EAAE,cAAkB;ExE+qPxD,gBAAgB;EwE9qPV,cAAK;EACL,kBAA+B;EAC7B,mBAA0B;ExEgrPlC,wBAAwB;EwE9qPlB,uBAAK;EACL;gEAEC;AxE+qPT;;AwE7qPQ;EACE;IxEgrPN,gBAAgB;EwE9qPZ;AACA;;AxEirPR;;EwE/rPwC,qBAAkB;AxEksP1D;;AwEhsPQ;EACE,anEyQL;AL07OL;;AwEhsPQ;EACE,kBnEqQL;EL87OH,SAAS;AwEjsPH;;AxEosPR;EACE,sBAAsB;EwEjsPhB,qBAAK;EACL,oBAA+B;AxEmsPvC;;AwE1rPQ;EAAwB,cnE6O3B;ELi9OH,yBAAyB;AwE7rPnB;;AxEgsPR;;EwE5rPQ,WAAM;EACN,qBAAuB;EACrB,yBAAuB;AxE+rPjC;;AwE5rPQ;EACE,cAAa;ExE+rPrB,uBAAuB;AwE7rPjB;;AxEgsPR;;EwE7sPQ,cAAsB;EAAE,qBAAiB;ExEitP/C,yBAAyB;AwEhtPnB;;AxEmtPR;EACE,cAAc;EwEhtPR,yBAAM;AACN;;AxEmtPR;;EwE/sPQ,WAAuB;EACrB,qBnEmOL;EL++OH,yBAAyB;AwEhtPnB;;AxEmtPR;EACE,cAAc;EwEjuPR,yBAAsB;AxEmuP9B;;AwEluPQ;;EAEE,WAAU;ExEquPlB,qBAAqB;EwEnuPf,yBAAM;AACN;;AxEsuPR;EwEnuPQ,cAAM;EACN,yBAAuB;AxEquP/B;;AwEluPQ;;EAEE,WAAW;ExEquPnB,qBAAqB;EwEpvPf,yBAAsB;AxEsvP9B;;AwErvPQ;EACA,cAAuB;EACrB,yBAAqB;AxEwvP/B;;AwErvPQ;;ExEyvPN,WAAW;EwEtvPL,qBAAM;EACN,yBAAuB;AxEwvP/B;;AwErvPQ;EACA,cAAuB;EACrB,uBAAsB;AxEwvPhC;;AAEA;;EwExwPQ,WAAM;EACN,qBAAuB;EACrB,yBAAqB;AxE2wP/B;;AwExwPQ;EACE,cnE0OL;ELiiPH,yBAAyB;AwEzwPnB;;AxE4wPR;;EwExwPQ,WAAM;EACN,qBAAuB;EACrB,yBAAsB;AxE2wPhC;;AAEA;EACE,cAAc;EwE5xPR,yBAAO;AACP;;AxE+xPR;;EwE3xPQ,WAAuB;EACrB,qBAAuB;ExE8xP/B,yBAAyB;AwE5xPnB;;AxE+xPR;EACE,cAAc;EwE5xPR,uBAAO;AACP;;AxE+xPR;;EwE7yPgC,cAAiB;ExEgzP/C,qBAAqB;EwE/yPf,yBAAO;AACP;;AxEkzPR;EwE/yPQ,cAAO;EACP,uBAAuB;AxEizP/B;;AwE9yPQ;;EAEE,cAAa;ExEizPrB,qBAAqB;EwE/yPf,yBAAO;AACP;;AxEkzPR;EwEh0PQ,YAAsB;EAAE,yBAA2B;AxEm0P3D;;AwEj0PQ;;ExEq0PN,WAAW;EwEl0PL,qBAAO;EACP,uBAAuB;AxEo0P/B;;AwEj0PQ;EACA,kBAAuB;EACrB,mBnE0NS;EL0mPjB,yBAAyB;EwEl0PnB,wBAAO;AACP;;AxEq0PR;EwEn1PQ;IAAwB,kBAAiB;ExEs1P/C;AwEr1PM;;AxEw1PR;EACE,gBAAgB;EwEr1PV,eAAO;EACP,gBAAuB;AxEu1P/B;;AwEp1PQ;EACA,kBAAuB;EACrB,oBnE2NF;EL4nPN,mBAAmB;EwEr1Pb,6BAAO;EACP,uBAAuB;AxEu1P/B;;AwEr2PQ;EAAwB,cAAiB;AxEy2PjD;;AwEv2PQ;EACE,gBnEoOS;ALsoPnB;;AwEv2PQ;EACE,qBAAuB;AxE02PjC;;AwEv2PQ;EACE,kBnE4NF;EL8oPN,MAAM;EwEx2PA,QAAO;EACP,UAAuB;EACrB,oBAAsB;ExE02P9B,cAAc;AwEz3PR;;AxE43PR;EwE33PQ,WAAO;EACP,qBAAuB;EACrB,yBAAqB;AxE63P/B;;AwE13PQ;EACE,cnEiOF;EL4pPN,gBAAgB;AwE33PV;;AxE83PR;EACE,WAAW;AwE33PL;;AxE83PR;EACE,yBAAyB;AwE54PnB;;AxE+4PR;EwE94PQ,cAAO;AACP;;AxEi5PR;EwE94PQ,cAAO;EACP,qBAAuB;EACrB,yBAAuB;AxEg5PjC;;AwE74PQ;EACE,cAAa;ExEg5PrB,gBAAgB;AwE94PV;;AxEi5PR;EACE,cAAc;AwE/5PR;;AxEk6PR;EwEj6PQ,yBAAO;AACP;;AxEo6PR;EwEj6PQ,cAAO;AACP;;AxEo6PR;EwEj6PQ,WAAO;EACP,qBAAuB;EACrB,yBAAwB;AxEm6PlC;;AwEh6PQ;EACE,cnE2NF;ELwsPN,gBAAgB;AwEl7PV;;AxEq7PR;EwEp7PQ,WAAO;AACP;;AxEu7PR;EwEp7PQ,yBAAO;AACP;;AxEu7PR;EwEp7PQ,cAAO;AACP;;AxEu7PR;EwEp7PQ,WAAO;EACP,qBAAuB;EACrB,yBAAsB;AxEs7PhC;;AAEA;EACE,cAAc;EwEv8PR,gBAAM;AACN;;AxE08PR;EwEv8PQ,WAAM;AACN;;AxE08PR;EwEv8PQ,yBAAM;AACN;;AxE08PR;EwEv8PQ,cAAM;AACN;;AxE08PR;EwEx9PQ,WAAsB;EAAE,qBAAiB;ExE29P/C,yBAAyB;AwE19PnB;;AxE69PR;EACE,cAAc;EwE19PR,gBAAM;AACN;;AxE69PR;EwE19PQ,WAAM;AACN;;AxE69PR;EwE19PQ,yBAAM;AACN;;AxE69PR;EwE3+PQ,cAAsB;AxE6+P9B;;AwE5+PQ;EACA,WAAuB;EACrB,qBAAqB;ExE++P7B,yBAAyB;AwE7+PnB;;AxEg/PR;EACE,cAAc;EwE7+PR,gBAAM;AACN;;AxEg/PR;EwE7+PQ,WAAM;AACN;;AxEg/PR;EwE9/PQ,yBAAsB;AxEggQ9B;;AwE//PQ;EACA,cAAuB;AxEkgQ/B;;AwE//PQ;EACA,WAAuB;EACrB,qBAAuB;ExEkgQ/B,yBAAyB;AwEhgQnB;;AxEmgQR;EACE,cAAc;EwEhgQR,gBAAM;AACN;;AxEmgQR;EwE5/PI,WAAiB;AxE8/PrB;;AwE7/PI;EACA,yBAAkB;AxEggQtB;;AwE7/PI;EACA,cAAkB;AxEggQtB;;AwE7/PI;EACA,WAAkB;EAChB,qBAAe;ExEggQnB,yBAAyB;AwE9/PvB;;AxEigQJ;EACE,YAAY;EezgQV,gBAAiB;Af2gQrB;;AAEA;EwE7jQQ,WAA+B;AxE+jQvC;;AAEA;EACE,yBwE7jQsC;AxE8jQxC;;AAEA;EwE1jQQ,cAAQ;AxE4jQhB;;AAEA;EACE,WKx0PG;EmEnQG,qBAAQ;EACR,yBAA+B;AxE6kQvC;;AAEA;EACE,cwE3kQsB;EAEhB,gBAAQ;AxE2kQhB;;AAEA;EwExkQQ,WAA+B;AxE0kQvC;;AAEA;EwEzlQQ,yBAAQ;AxE2lQhB;;AAEA;EwExlQQ,cAA+B;AxE0lQvC;;AAEA;EACE,cwExlQQ;EAEF,mBAAQ;EACR,uBAA+B;AxEwlQvC;;AAEA;EwEvmQQ,cAAQ;EACR,gBAA+B;AxEymQvC;;AAEA;EACE,cwEvmQsB;AxEwmQxB;;AAEA;EwEpmQQ,yBAAQ;AxEsmQhB;;AAEA;EACE,cK/2PG;ALg3PL;;AAEA;EwEpnQQ,cAAQ;EACR,mBAA+B;ExEsnQrC,uBwErnQsC;AxEsnQxC;;AAEA;EwElnQQ,cAAQ;EACR,gBAA+B;AxEonQvC;;AAEA;EwEnoQQ,cAAQ;AxEqoQhB;;AAEA;EwEloQQ,yBAA+B;AxEooQvC;;AAEA;EACE,cwEloQQ;AxEmoQV;;AAEA;EwEhpQQ,WAA8B;ExEkpQpC,qBwElpQwD;EAClD,yBAAS;AxEmpQjB;;AAEA;EwEhpQQ,YAA+B;ExEkpQrC,gBK95PM;AL+5PR;;AAEA;EwE9oQQ,WAAS;AxEgpQjB;;AAEA;EACE,yBwEhqQwD;AxEiqQ1D;;AAEA;EwE9pQQ,YAAS;AxEgqQjB;;AAEA;EwE7pQQ;IACE,2BAAgC;EAElC;;ExE+pQN;IwE5qQM,wBAA8B;ExE8qQpC;AACF;;AAEA;EwE5qQQ,aAAS;EACT,YAA+B;ExE8qQrC,gBKx7PM;EmEnPA,cAAS;EACT,kBAA+B;ExE6qQrC,yBwE5qQwC;EAElC,uBAAS;EACT,oDAA+B;AxE4qQvC;;AAEA;EwE3rQQ,aAAS;EACT,sBAA+B;ExE6rQrC,uBwE5rQkC;EAE5B,gBAAS;EACT,WAA+B;ExE4rQrC,kBKr8PM;EmEpPA,mBAAS;EACT,yBAA+B;ExE2rQrC,2BwE1rQwC;AxE2rQ1C;;AAEA;EwExsQQ;IAAgC,gBAAkB;EAClD;AxE2sQR;;AAEA;EwExsQQ;;;;;;;kBnEwPA;EmE9PA,0BAA8B;AxEwtQtC;;AAEA;EACE,kDwEvtQO;AxEwtQT;;AAEA;EwErtQQ;IACA,eAA+B;ExEutQrC;AACF;;AAEA;EwEpuQQ,aAA8B;ExEsuQpC,uBwEtuQwD;AxEuuQ1D;;AAEA;EwEpuQQ,SAAA;AxEsuQR;;AAEA;EwEnuQQ,aAA+B;ExEquQrC,sBKx/PW;EmE1OL,eAAS;EACT,gBAA+B;ExEouQrC,uBwEnuQoC;AxEouQtC;;AAEA;EwEnvQQ,WAA+B;ExEqvQrC,cKt/PM;EmE5PA,mBAAS;AxEovQjB;;AAEA;;EAEE,UwElvQQ;EAEF,cAAS;EACT,qBAA+B;ExEkvQrC,yBwEjvQoC;AxEkvQtC;;AAEA;EwEjwQQ,cAA+B;ExEmwQrC,yBwElwQkC;AxEmwQpC;;AAEA;EwE/vQQ,kBAAS;EACT,cAA+B;ExEiwQrC,kBKzgQM;EmErPA,sBAAS;EACT,yBAA+B;AxEgwQvC;;AAEA;EwE/wQQ,+BAAQ;EACR,gCAA+B;AxEixQvC;;AAEA;EACE,mCwE/wQgD;EAE1C,kCAAQ;AxE+wQhB;;AAEA;;EAEE,cwE7wQqB;EAff,oBAA8B;ExE8xQpC,sBwE9xQwD;AxE+xQ1D;;AAEA;EwE5xQQ,UAAQ;EACR,WAA+B;ExE8xQrC,yBwE7xQsC;EAEhC,qBAAQ;AxE6xQhB;;AAEA;EwE1xQQ,mBAA+B;AxE4xQvC;;AAEA;EwE3yQQ,gBAAQ;EACR,qBAA+B;AxE6yQvC;;AAEA;EACE,mBKviQG;ALwiQL;;AAEA;EwExyQQ,mCAAQ;EACR,0BAA+B;AxE0yQvC;;AAEA;EwEzzQQ,iCAAQ;EACR,4BAA+B;AxE2zQvC;;AAEA;EACE,awEzzQQ;AxE0zQV;;AAEA;EwEtzQQ,qBAAQ;EACR,oBAA+B;AxEwzQvC;;AAEA;EwEv0QQ,iBAAQ;EACR,sBAA+B;AxEy0QvC;;AAEA;EACE;IwEr0QM,mBAAQ;EACR;;EAGA;IACA,mCAA+B;IAC7B,0BAAsC;EAfxC;;EACA;IACA,iCAA+B;IAC7B,4BAA0B;EAE5B;;ExEu1QN;IwEn1QM,aAAQ;EACR;;EAGA;IACA,qBAA+B;IAC7B,oBnEqPL;EmEpQG;;EACA;IACA,iBAA+B;IAC7B,sBAA0B;EAE5B;AxEo2QR;;AAEA;EwEj2QQ;IACE,mBnE0PL;EmExPG;;ExEm2QN;IwEh3QM,mCAA8B;IAAE,0BAA4B;EAC5D;;ExEo3QN;IwEh3QM,iCAAQ;IACR,4BAA+B;ExEk3QrC;;EwE92QM;IACE,aAAA;EAEF;;ExEi3QN;IwE93QM,qBAA8B;IAAE,oBAAkB;EAClD;;ExEk4QN;IwE93QM,iBAAQ;IACR,sBAA+B;ExEg4QrC;AACF;;AAEA;EwE53QQ;IACA,mBAA+B;ExE83QrC;;EAEA;IwE74QM,mCAAQ;IACR,0BAA+B;ExE+4QrC;;EwE34QM;IACE,iCACD;IACD,4BAAQ;EACR;;EAGA;IACA,aAA+B;ExE44QrC;;EAEA;IwE35QM,qBAAS;IACT,oBAA+B;ExE65QrC;;EwEz5QM;IACE,iBnEmPF;ImEjPA,sBAAS;EACT;AxE25QR;;AAEA;EACE;IwEx6QM,mBAA8B;ExE06QpC;;EwEx6QM;IACE,mCACD;IACD,0BAAS;EACT;;EAGA;IACA,iCAA+B;IAC7B,4BAAgC;EAElC;;ExEy6QN;IwEt7QM,aAA8B;ExEw7QpC;;EwEt7QM;IACE,qBAA0B;IAE5B,oBAAS;EACT;;EAGA;IACA,iBAA+B;IAC7B,sBAAgC;EAElC;AxEs7QR;;AAEA;EACE,gBKzsQM;AL0sQR;;AAEA;EwEp8QQ,qBAAS;AxEs8QjB;;AAEA;EwEn8QQ,sBAA+B;AxEq8QvC;;AAEA;EACE,cwEn8QqB;EAff,yBAA8B;AxEo9QtC;;AAEA;;EwEj9QQ,cAAS;EACT,yBAA+B;AxEo9QvC;;AAEA;EACE,WwEl9QQ;EAEF,yBAAS;EACT,qBAA+B;AxEk9QvC;;AAEA;EwEj+QQ,cAAS;EACT,yBAA+B;AxEm+QvC;;AAEA;;EwE99QQ,cAAS;EACT,yBAA+B;AxEi+QvC;;AAEA;EACE,WwE/9QQ;EAfF,yBAA8B;ExEg/QpC,qBwEh/QwD;AxEi/Q1D;;AAEA;EwE9+QQ,cAAS;EACT,yBAA+B;AxEg/QvC;;AAEA;;EwE3+QQ,cAAS;EACT,yBAA+B;AxE8+QvC;;AAEA;EwE7/QQ,WAAS;EACT,yBAA+B;ExE+/QrC,qBKhwQM;ALiwQR;;AAEA;EwE3/QQ,cAAS;EACT,yBAA+B;AxE6/QvC;;AAEA;;EwEzgRQ,cAA8B;ExE4gRpC,yBwE5gRwD;AxE6gR1D;;AAEA;EwE1gRQ,WAAS;EACT,yBAA+B;ExE4gRrC,qBKhxQM;ALixQR;;AAEA;EwExgRQ,cAAS;EACT,yBAA+B;AxE0gRvC;;AAEA;;EwExhRQ,cAA+B;ExE2hRrC,yBwE1hRkC;AxE2hRpC;;AAEA;EwEvhRQ,WAAQ;EACR,yBAA+B;ExEyhRrC,qBK1xQG;AL2xQL;;AAEA;EwEtiRQ,cAA8B;ExEwiRpC,yBwExiRwD;AxEyiR1D;;AAEA;;EwEriRQ,cAA+B;ExEwiRrC,yBwEviRsC;AxEwiRxC;;AAEA;EwEpiRQ,WAAQ;EACR,yBAA+B;ExEsiRrC,qBwEriRoC;AxEsiRtC;;AAEA;EwErjRQ,cAA+B;ExEujRrC,yBwEtjRkC;AxEujRpC;;AAEA;;EwEljRQ,cAA+B;ExEqjRrC,yBwEpjRwC;AxEqjR1C;;AAEA;EwElkRQ,WAA8B;ExEokRpC,yBwEpkRwD;EAClD,qBAAQ;AxEqkRhB;;AAEA;EwElkRQ,cAA+B;ExEokRrC,yBwEnkRsC;AxEokRxC;;AAEA;;EwE/jRQ,cAA+B;ExEkkRrC,yBwEjkRoC;AxEkkRtC;;AAEA;EwE1jRQ,WAAuB;ExE4jR7B,yBwE3jR6B;EAEvB,qBAAS;AxE2jRjB;;AAEA;EwExjRQ,cAAuB;ExE0jR7B,yBKv1QkB;ALw1QpB;;AAEA;;EAEE,cK31QG;EmE7OG,yBAAS;AxE0kRjB;;AAEA;EwEvkRQ,WAAuB;ExEykR7B,yBwExkR+B;EAEzB,qBAAS;AxEwkRjB;;AAEA;EwErkRQ,cAAuB;ExEukR7B,uBwEtkR8B;AxEukRhC;;AAEA;;EAEE,cK13QO;EmE3ND,yBAAS;AxEulRjB;;AAEA;EwEplRQ,WAAuB;ExEslR7B,yBwErlRgC;EAE1B,qBAAS;AxEqlRjB;;AAEA;EACE,cKr3QG;EmE/OG,uBAAS;AxEsmRjB;;AAEA;;EAEE,cwEpmRoB;EAEd,yBAAS;AxEomRjB;;AAEA;EwEjmRQ,WAAuB;ExEmmR7B,yBwElmR8B;EAfxB,qBAAsB;AxEmnR9B;;AAEA;EACE,YwEnnRkB;EAEZ,yBAAS;AxEmnRjB;;AAEA;;EAEE,YwEjnRQ;EAEF,yBAAS;AxEinRjB;;AAEA;EACE,WK95QM;EmElOA,uBAAU;EACV,mBAAuB;AxEkoR/B;;AAEA;EACE,YwEhoRQ;EAEF,iBAAU;EACV,gBAAuB;ExEgoR7B,cwE/nRQ;EAEF,yBAAU;EACV,iBAAuB;ExE+nR7B,YwE9nRQ;AxE+nRV;;AAEA;EwE9oRQ;IACE,iCACD;EACD;AxE+oRR;;AAEA;EwE5oRQ,yBAAuB;ExE8oR7B,qBKp7QiB;ALq7QnB;;AAEA;;EAEE,aKx7QM;ALy7QR;;AAEA;EwE3pRQ,UAAU;EACV,6BAAuB;ExE6pR7B,SwE5pRQ;AxE6pRV;;AAEA;EwEzpRQ,oBAAU;AxE2pRlB;;AAEA;EACE,gBKr8QmB;ALs8QrB;;AAEA;EwEzqRQ,kBAAU;EACV,gBAAuB;AxE2qR/B;;AAEA;EACE,ewEzqRqB;EAEf,MAAA;EACA,OAAA;ExEyqRN,awExqRmB;EAfb,aAAsB;ExEyrR5B,WKl9QM;EmEtOA,YAAU;EACV,gBAAuB;ExE0rR7B,UwEzrRQ;AxE0rRV;;AAEA;EwEtrRQ,kBAAU;EACV,WAAuB;ExEwrR7B,cwEvrRQ;EAEF,oBAAU;AxEurRlB;;AAEA;EACE,mCwEvsR6D;EACvD,8BAAU;AxEwsRlB;;AAEA;EwErsRQ;IACE,gBnEiOF;EmE/NA;AxEssRR;;AAEA;EwEnsRQ,eAAuB;AxEqsR/B;;AAEA;EwEptRQ,sBAAU;AxEstRlB;;AAEA;EwEntRQ,aAAuB;ExEqtR7B,6BwEptR+B;AxEqtRjC;;AAEA;EwEjtRQ,8BAAU;EACV,gBAAuB;AxEmtR/B;;AAEA;;EwEjuRQ,cAAuB;AxEouR/B;;AAEA;EACE,gBK//QM;ALggRR;;AAEA;EwE/tRQ,aAAU;EACV,mBAAuB;ExEiuR7B,6BwEhuR8B;AxEiuRhC;;AAEA;EwEhvRQ,cAAuB;ExEkvR7B,0BwEjvR6B;EAEvB,2BAAU;EAAV,mBAAU;EACV,WAAuB;AxEivR/B;;AAEA;EACE,sBK/gRM;EmE9NA,uBAAU;EACV,YAAuB;AxE+uR/B;;AAEA;EwE9vRQ,gBAAS;AxEgwRjB;;AAEA;EwE7vRQ,aAAuB;AxE+vR/B;;AAEA;EACE,kBKthRG;EmErOG,aAAS;EACT,sBAAuB;ExE6vR7B,WwE5vRQ;EAfF,oBAAsB;ExE6wR5B,sBwE7wR+C;EACzC,4BAAS;EACT,kCAAuB;ExE8wR7B,wBwE7wR6B;EAEvB,6EAAS;EACT,UAAuB;AxE6wR/B;;AAEA;EACE,ewE3wRqB;EAEf,MAAA;EACA,OAAA;ExE2wRN,awE1wRmB;EAfb,YAAsB;ExE2xR5B,aKviRG;EmEnPG,sBAAS;AxE4xRjB;;AAEA;EwEzxRQ,UAAuB;AxE2xR/B;;AAEA;EACE,awEzxRQ;AxE0xRV;;AAEA;EwEvyRQ,aAAsB;ExEyyR5B,uBwEzyR+C;EACzC,8BAAS;EACT,gBAAuB;ExE0yR7B,8BwEzyR6B;EAEvB,iCAAS;EACT,kCAAuB;AxEyyR/B;;AAEA;EACE,gBwEvyRqB;EAEf,8BAAS;AxEuyRjB;;AAEA;EACE,gBwElyR6B;EAC3B,gBAAW;AxEmyRf;;AAEA;EwEhyRI,kBAAkB;ExEkyRpB,cwEjyRgB;EAEd,eAAW;AxEiyRf;;AAEA;EwE9xRI,aAAkB;ExEgyRpB,ewE/xRiB;ExEgyRjB,mBAAmB;EezyRjB,yBAAwB;EyDlDpB,gBAA8B;ExE81RpC,2BwE91RsE;EAChE,qCAAQ;EACR,oCAA+B;AxE+1RvC;;AAEA;EACE,ewE71RsB;AxE81RxB;;AAEA;EwE11RQ,kBAAQ;EACR,YAA+B;ExE41RrC,WwE31RQ;EAfF,YAA8B;ExE42RpC,gBKxmRG;ALymRL;;AAEA;EwE12RQ;IACA,gBAA+B;IAC7B,oBnE6PL;EmE3PG;;ExE42RN;IwEx2RM,+BAAQ;EACR;;EAdA;IAAgC,gCAAgC;EAChE;;ExE43RN;IwEx3RM,+BAAQ;EACR;;EAGA;IACA,4BAA+B;IAC7B,2BnE0PL;ImE1PK,mBnE0PL;EmExPG;;ExEy3RN;IwEt4RM;oCAAgE;EAChE;;ExE04RN;IwEt4RM,gBAAQ;EACR;AxEw4RR;;AAEA;;EwEn4RQ;;IAEE,gBnEwOD;EmEvPD;AxEs5RR;;AAEA;EACE;IwEp5RM,iBAAQ;EACR;AxEs5RR;;AAEA;EACE,kBKxpRG;EmE1PG,aAAQ;EACR,cAA+B;ExEo5RrC,SwEn5RQ;EAfF,kCAA8B;ExEo6RpC,kBwEp6RwD;EAClD,gBAAQ;EACR,gBAA+B;ExEq6RrC,gBK/pRG;EmEnQG,iBAAQ;EACR,qBAA+B;ExEo6RrC,iBKlqRG;EmE/PG,oBAAQ;EACR,sBAA+B;ExEm6RrC,kBKrqRG;EmE3PG,oBAAQ;EACR,mBAA+B;ExEk6RrC,gBKxqRG;EmExQG,mBAA8B;ExEk7RpC,qBwEl7RwD;EAClD,UAAS;AxEm7RjB;;AAEA;EwEh7RQ,YAA+B;AxEk7RvC;;AAEA;EACE,kBKjsRM;EmE7OA,cAAS;EACT,aAA+B;ExEg7RrC,cwE/6RqB;AxEg7RvB;;AAEA;EwE/7RQ,kBAA+B;ExEi8RrC,WwEh8RQ;EAEF,yBAAS;EACT,mBAA+B;AxEg8RvC;;AAEA;;EwE37RQ,iBAAS;AxE87RjB;;AAEA;;EwE58RQ,SAAS;AxE+8RjB;;AAEA;;EAEE,MwE78RQ;EAEF,6BAAS;EACT,sBAA+B;AxE68RvC;;AAEA;;EwEz9RQ,iBAA8B;AxE49RtC;;AAEA;;EwEz9RQ,OAAA;EACA,aAA+B;ExE49RrC,cwE39RsB;AxE49RxB;;AAEA;;EwEv9RQ,QAAA;ExE09RN,oCwEx9RO;EAhBD,wBAA8B;AxE0+RtC;;AAEA;;EwEv+RQ,iBAAS;AxE0+RjB;;AAEA;;EAEE,MwEx+RQ;AxEy+RV;;AAEA;;EAEE,SwEx/R8C;EACxC,6BAAS;EACT,yBAA+B;AxEy/RvC;;AAEA;;EwEp/RQ,iBAAS;AxEu/RjB;;AAEA;;EAEE,QwEr/RQ;EAfF,aAA8B;ExEsgSpC,cK/wRO;ALgxRT;;AAEA;;EwEngSQ,OAAA;ExEsgSN,oCwEpgSO;EACD,uBAAS;AxEqgSjB;;AAEA;EwElgSQ,gBAA+B;ExEogSrC,uBwEngSoC;EAf9B,WAA8B;ExEohSpC,kBwEphSwD;EAClD,sBAAS;EACT,uBAA+B;AxEqhSvC;;AAEA;EACE,kBKzxRM;EmExPA,MAAA;EACA,OAAA;ExEmhSN,awElhSQ;EAEF,cAAS;EACT,gBAA+B;ExEkhSrC,kCwEjhS8C;EAfxC,kBAA8B;ExEkiSpC,gBKhyRM;EmEjQA,gBAAS;EACT,gBAA+B;ExEmiSrC,iBKnyRM;EmE7PA,qBAAS;EACT,iBAA+B;ExEkiSrC,oBKtyRM;EmEzPA,sBAAS;EACT,kBAA+B;ExEiiSrC,oBKzyRM;EmErPA,mBAAS;EACT,gBAA+B;ExEgiSrC,mBK5yRM;EmElQA,qBAA8B;ExEgjSpC,sBwEhjSwD;EAClD,4BAAQ;EACR,qCAA+B;ExEijSrC,wBwEhjSkC;EAE5B,kDAAQ;AxEgjShB;;AAEA;EwE7iSQ,kBAA+B;ExE+iSrC,cwE9iSQ;EAEF,WAAQ;EACR,cAA+B;ExE8iSrC,mBKnzRG;ALozRL;;AAEA;;EAEE,kBKvzRgB;EmErQV,cAAQ;EACR,WAA+B;ExE8jSrC,yBwE7jSsC;EAEhC,mBAAQ;AxE6jShB;;AAEA;;EAEE,qBwE3jSoC;AxE4jStC;;AAEA;;EAEE,2BwE5kSkC;AxE6kSpC;;AAEA;;EwExkSQ,SAA+B;ExE2kSrC,6BwE1kSwC;EAElC,6BAAQ;AxE0kShB;;AAEA;;EwExlSQ,WAAQ;EACR,6BAA+B;ExE2lSrC,sBwE1lSkC;AxE2lSpC;;AAEA;;EwEtlSQ,mBAA+B;AxEylSvC;;AAEA;;EwErmSQ,yBAA8B;ExEwmSpC,awExmSwD;EAClD,YAAQ;EACR,mBAA+B;AxEymSvC;;AAEA;;EwEpmSQ,OAAA;EACA,oCAA+B;ExEumSrC,+BwEtmSkD;AxEumSpD;;AAEA;;EAEE,SwEtnS8C;EACxC,oCAAQ;EACR,wBAA+B;AxEunSvC;;AAEA;;EwElnSQ,kBAAQ;AxEqnShB;;AAEA;;EAEE,wBwEnnSoC;AxEonStC;;AAEA;;EAEE,MwEpoSQ;EAEF,oCAAQ;EACR,gCAA+B;AxEooSvC;;AAEA;;EwE/nSQ,QAAQ;EACR,oCAA+B;ExEkoSrC,yBwEjoSoC;AxEkoStC;;AAEA;;EAEE,kBK95RO;EmElPD,MAAA;EACA,SAA+B;ExEkpSrC,cwEjpSQ;EAEF,WAAQ;EACR,oBAA+B;ExEipSrC,WwEhpSQ;EAEF,6BAAQ;AxEgpShB;;AAEA;;EwE9pSQ,oBAAQ;AxEiqShB;;AAEA;;EAEE,0BwE/pSsC;EAEhC,aAAQ;EACR,YAA+B;ExE+pSrC,mBKl6RG;ALm6RL;;AAEA;;EAEE,QwE9qSsC;EAChC,oCAAQ;EACR,8BAA+B;AxE+qSvC;;AAEA;;EwE1qSQ,UAAQ;EACR,oCAA+B;ExE6qSrC,uBwE5qSwC;AxE6qS1C;;AAEA;EwE1rSQ,uBAA8B;ExE4rSpC,gBKl8RM;EmEzPA,eAAS;EACT,cAA+B;ExE6rSrC,sBwE5rSkC;EAE5B,gCAAS;EACT,6CAA+B;ExE4rSrC,8CwE1rSO;AxE2rST;;AAEA;EwExrSQ,aAAS;AxE0rSjB;;AAEA;EACE,uBwE1sSwD;EAClD,cAAS;AxE2sSjB;;AAEA;EwExsSQ,kBAA+B;AxE0sSvC;;AAEA;EACE,mBKx9RM;ALy9RR;;AAEA;EwEttSQ,kBAA8B;ExEwtSpC,WK59RM;EmE3PA,gBAAS;AxEytSjB;;AAEA;EwEttSQ,cAA+B;ExEwtSrC,WwEvtSQ;EAEF,WAAS;AxEutSjB;;AAEA;EwEptSQ,kBAA+B;ExEstSrC,awErtSQ;EAfF,WAA8B;ExEsuSpC,WKz+RM;EmE5PA,mBAAS;EACT,mCAA+B;UAA/B,2BAA+B;ExEuuSrC,sCwEruSO;AxEsuST;;AAEA;EwEnuSQ;IACA,gBAA+B;ExEquSrC;AACF;;AAEA;;;EwEjvSQ,cAAS;AxEqvSjB;;AAEA;;EAEE,2BwEnvSsC;AxEovSxC;;AAEA;;EwE/uSQ,4BAA+B;AxEkvSvC;;AAEA;EwEjwSQ,UAAS;EACT,4BAA+B;ExEmwSrC,eKtgSM;ALugSR;;AAEA;;;EAGE,UwEhwSQ;EAEF,UAAS;AxEgwSjB;;AAEA;;EwE9wSQ,UAAS;EACT,UAA+B;ExEixSrC,2BwEhxSkC;AxEixSpC;;AAEA;;EwE5wSQ;;IAGA,gBAAS;EACT;AxE8wSR;;AAEA;;EwE5xSQ,kBAA+B;ExE+xSrC,MwE9xSQ;EAEF,SAAS;EACT,UAA+B;ExE8xSrC,awE7xSQ;EAEF,mBAAS;EACT,uBAA+B;ExE6xSrC,UwE5xSQ;EAEF,WAAS;EACT,kBAA+B;ExE4xSrC,YwE3xSQ;EAfF,8BAA8B;AxE4yStC;;AAEA;;EwEzySQ;;IAEE,gBnE2PF;EmEzPA;AxE2ySR;;AAEA;;;;EAIE,WKjjSG;EmExQG,qBAAQ;EACR,UAA+B;ExE2zSrC,YwE1zSQ;AxE2zSV;;AAEA;EwEvzSQ,OAAA;AxEyzSR;;AAEA;EwEtzSQ,QAAQ;AxEwzShB;;AAEA;;EwEt0SQ,qBAA+B;ExEy0SrC,WwEx0SQ;EAEF,YAAQ;EACR,qCAA+B;AxEw0SvC;;AAEA;EACE,yDwEr0SO;AxEs0ST;;AAEA;EwEp1SQ,yDAA8B;AxEs1StC;;AAEA;EACE,kBK9kSG;EmEtQG,QAAQ;EACR,SAA+B;ExEs1SrC,OwEr1SQ;EAEF,WAAQ;EACR,aAA+B;ExEq1SrC,uBwEp1SwC;EAElC,eAAQ;EACR,iBAA+B;ExEo1SrC,gBKvlSG;EmE3QG,gBAA8B;AxEo2StC;;AAEA;EACE,uBwEp2SkC;EAE5B,cAAQ;EACR,WAA+B;ExEo2SrC,WwEn2SQ;EAEF,iBAAQ;EACR,gBAA+B;ExEm2SrC,mBKjmSG;EmE/PG,eAAQ;EACR,sBAA+B;ExEk2SrC,4BwEj2SoC;EAQ9B,kCAAsB;ExE21S5B,qCwE31S6D;EACvD,YAAS;EACT,6BAAuB;AxE41S/B;;AAEA;EACE;IwEx1SM,gBAAS;EACT;AxE01SR;;AAEA;EACE,UwEx1SQ;AxEy1SV;;AAEA;EwEx2SQ,kBAAuB;ExE02S7B,UwEz2SQ;EAEF,YAAS;EACT,SAAS;ExEy2Sf,WwEx2SQ;EAEF,iBAAS;EACT,oBAAuB;ExEw2S7B,WwEv2SQ;EAEF,kBAAS;AxEu2SjB;;AAEA;EACE,mCwEv3S6D;AxEw3S/D;;AAEA;EwEr3SQ,8BAAS;AxEu3SjB;;AAEA;EwEp3SQ,iCAAuB;AxEs3S/B;;AAEA;EACE,iCwEp3SwC;AxEq3S1C;;AAEA;EwEp4SQ,sCAAuB;AxEs4S/B;;AAEA;EACE,mCwEp4SyC;AxEq4S3C;;AAEA;EwEj4SQ,oCAAS;AxEm4SjB;;AAEA;;;;EAIE,oCwEl5SO;AxEm5ST;;AAEA;EwEh5SQ,oCAAS;AxEk5SjB;;AAEA;;;;EAIE,oCwEj6S6D;AxEk6S/D;;AAEA;EwE/5SQ,oCAAU;AxEi6SlB;;AAEA;;;;EwE15SQ,oCAAuB;AxE+5S/B;;AAEA;EwE96SQ,oCAAU;AxEg7SlB;;AAEA;;;;EwEz6SQ,oCAAuB;AxE86S/B;;AAEA;EACE,oCwE36SO;AxE46ST;;AAEA;;;;EwEx7SQ,oCAAuB;AxE67S/B;;AAEA;EACE,oCwE17SO;AxE27ST;;AAEA;;;;EwEv8SQ,oCAAuB;AxE48S/B;;AAEA;EACE,oCwEz8SO;AxE08ST;;AAEA;;;;EwEp9SQ,oCAAsB;AxEy9S9B;;AAEA;EACE,oCwEx9SO;AxEy9ST;;AAEA;;;;EwEl9SQ,oCAAU;AxEu9SlB;;AAEA;EACE,oCwEv+S6D;AxEw+S/D;;AAEA;;;;EwEj+SQ,oCAAU;AxEs+SlB;;AAEA;EwEn+SQ,iCAAuB;AxEq+S/B;;AAEA;;;;EwEh/SQ,oCAAU;AxEq/SlB;;AAEA;EwEl/SQ,iCAAuB;AxEo/S/B;;AAEA;;;;EwE//SQ,oCAAU;AxEogTlB;;AAEA;EwEjgTQ,kCAAuB;AxEmgT/B;;AAEA;;;;EAIE,kCwEhgTwC;AxEigT1C;;AAEA;EwEhhTQ,iCAAuB;AxEkhT/B;;AAEA;EACE,wCwE/gTO;AxEghTT;;AAEA;EwE7gTQ,oCAAU;AxE+gTlB;;AAEA;EACE,wCwE/hT6D;AxEgiT/D;;AAEA;EwE7hTQ,0CAAS;AxE+hTjB;;AAEA;EwE5hTQ,2CAAuB;AxE8hT/B;;AAEA;EACE,yCwE3hTO;AxE4hTT;;AAEA;EwE5iTQ,oBAAuB;AxE8iT/B;;AAEA;EACE,wBwE5iT+B;AxE6iTjC;;AAEA;EwEziTQ,0BAAS;AxE2iTjB;;AAEA;EACE,2BwE3jTyD;AxE4jT3D;;AAEA;EwEzjTQ,yBAAS;AxE2jTjB;;AAEA;EwExjTQ,gCAAuB;AxE0jT/B;;AAEA;EACE,gCwExjTwC;AxEyjT1C;;AAEA;EwExkTQ,gCAAuB;AxE0kT/B;;AAEA;EACE,gCwExkT+B;AxEykTjC;;AAEA;EwErkTQ,gCAAS;AxEukTjB;;AAEA;EACE,gCwElkTgD;AxEmkTlD;;AAEA;EwEhkTI,gCAAW;AxEkkTf;;AAEA;EwE/jTI,gCAAkB;AxEikTtB;;AAEA;EACE,gCwE/jTgC;AxEgkTlC;;AAEA;EACE,6BwE9nTsE;AxE+nTxE;;AAEA;EwE5nTQ,6BAAQ;AxE8nThB;;AAEA;EwE3nTQ,8BAA+B;AxE6nTvC;;AAEA;EACE,6BwE3nT8C;AxE4nThD;;AAEA;EwE3oTQ,iCAA+B;AxE6oTvC;;AAEA;EACE,kCwE3oTgD;AxE4oTlD;;AAEA;EwExoTQ,2CAAQ;EACR,4CAA+B;AxE0oTvC;;AAEA;EwEzpTQ,4CAAQ;EACR,+CAA+B;AxE2pTvC;;AAEA;EACE,+CwExpTO;EACD,8CAAQ;AxEypThB;;AAEA;EwEtpTQ,2CAA+B;ExEwpTrC,8CwEtpTO;AxEupTT;;AAEA;EwEvqTQ,mCAA+B;AxEyqTvC;;AAEA;;EwEpqTQ,6BAAQ;AxEuqThB;;AAEA;EwEpqTQ,+BAA+B;AxEsqTvC;;AAEA;EwErrTQ,2BAAQ;AxEurThB;;AAEA;EwEprTQ,cAA+B;ExEsrTrC,WwErrTQ;EAEF,WAAQ;AxEqrThB;;AAEA;EwElrTQ,wBAA+B;AxEorTvC;;AAEA;EwEnsTQ,0BAAQ;AxEqsThB;;AAEA;EwElsTQ,gCAA+B;AxEosTvC;;AAEA;EACE,yBwElsTwC;AxEmsT1C;;AAEA;EwEhtTQ,yBAA8B;AxEktTtC;;AAEA;EACE,6BwEltTkC;AxEmtTpC;;AAEA;EwE/sTQ,8BAAS;AxEitTjB;;AAEA;EwE9sTQ,wBAA+B;AxEgtTvC;;AAEA;EwE/tTQ,+BAAS;AxEiuTjB;;AAEA;EwE9tTQ;IACE,wBAA8B;EAEhC;;ExEguTN;IwE5tTM,0BAAS;EACT;;EAdA;IAAgC,gCAAgC;EAChE;;ExEgvTN;IwE5uTM,yBAAS;EACT;;EAGA;IACA,yBAA+B;ExE6uTrC;;EwEzuTM;IACE,6BAAsC;EAfxC;;EACA;IACA,8BAA+B;ExE6vTrC;;EwEzvTM;IACE,wBAA8B;EAEhC;;ExE4vTN;IwExvTM,+BAAS;EACT;AxE0vTR;;AAEA;EwEzwTQ;IACA,wBAA+B;ExE2wTrC;;EwEvwTM;IACE,0BAA8B;EAEhC;;ExE0wTN;IwEtwTM,gCAAS;EACT;;EAdA;IAAgC,yBAAkB;EAClD;;ExE0xTN;IwEtxTM,yBAAS;EACT;;EAGA;IACA,6BAA+B;ExEuxTrC;;EwEnxTM;IACE,8BAA4B;EAf9B;;EACA;IACA,wBAA+B;ExEuyTrC;;EwEnyTM;IACE,+BAAwC;EAE1C;AxEqyTR;;AAEA;EwElyTQ;IACE,wBAA4B;EAf9B;;EACA;IACA,0BAA+B;ExEqzTrC;;EwEjzTM;IACE,gCAAwC;EAE1C;;ExEozTN;IwEhzTM,yBAAS;EACT;;EAdA;IAAgC,yBAAkB;EAClD;;ExEo0TN;IwEh0TM,6BAAS;EACT;;EAGA;IACA,8BAA+B;ExEi0TrC;;EwE7zTM;IACE,wBAA4B;EAf9B;;EACA;IACA,+BAA+B;ExEi1TrC;AACF;;AAEA;EwE70TQ;IACA,wBAA+B;ExE+0TrC;;EwE30TM;IACE,0BAA4B;EAf9B;;EACA;IACA,gCAA+B;ExE+1TrC;;EwE31TM;IACE,yBAA8B;EAEhC;;ExE81TN;IwE11TM,yBAAQ;EACR;;EAdA;IAAgC,6BAAgC;EAChE;;ExE82TN;IwE12TM,8BAAQ;EACR;;EAGA;IACA,wBAA+B;ExE22TrC;;EwEv2TM;IACE,+BACD;EAhBD;AxE03TR;;AAEA;EACE;IwEx3TM,wBAAQ;EACR;;EAGA;IACA,0BAA+B;ExEy3TrC;;EwEr3TM;IACE,gCACD;EAhBD;;EACA;IACA,yBAA+B;ExEy4TrC;;EwEr4TM;IACE,yBAA8B;EAEhC;;ExEw4TN;IwEp4TM,6BAAQ;EACR;;EAdA;IAAgC,8BAAgC;EAChE;;ExEw5TN;IwEp5TM,wBAAQ;EACR;;EAGA;IACA,+BAA+B;ExEq5TrC;AACF;;AAEA;EwEl6TQ,kBAA8B;ExEo6TpC,cK/pTG;EmEpQG,WAAQ;EACR,UAA+B;ExEq6TrC,gBKlqTG;ALmqTL;;AAEA;EwEj6TQ,cAAQ;EACR,WAA+B;AxEm6TvC;;AAEA;;;;;EwE76TQ,kBAA+B;ExEm7TrC,MwEl7TQ;EAEF,SAAQ;EACR,OAAA;ExEk7TN,WwEj7TQ;EAEF,YAAQ;EACR,SAA+B;AxEi7TvC;;AAEA;EACE,sBwE/6ToC;AxEg7TtC;;AAEA;EwE/7TQ,mBAA+B;AxEi8TvC;;AAEA;EACE,gBwE/7TsB;AxEg8TxB;;AAEA;EwE57TQ,iBAAQ;AxE87ThB;;AAEA;EACE,sBwE98TwD;AxE+8T1D;;AAEA;EwE58TQ,mBAAQ;AxE88ThB;;AAEA;EwE38TQ,gBAA+B;AxE68TvC;;AAEA;EACE,iBKltTG;ALmtTL;;AAEA;EwE39TQ,8BAA+B;AxE69TvC;;AAEA;EACE,iCwE39TsC;AxE49TxC;;AAEA;EwEx9TQ,sCAAS;AxE09TjB;;AAEA;EACE,yCwE1+TsE;AxE2+TxE;;AAEA;EwEx+TQ,0BAAS;AxE0+TjB;;AAEA;EwEv+TQ,4BAA+B;AxEy+TvC;;AAEA;EACE,kCwEv+T8C;AxEw+ThD;;AAEA;EwEv/TQ,yBAA+B;AxEy/TvC;;AAEA;EACE,uBwEv/TsC;AxEw/TxC;;AAEA;EwEp/TQ,uBAAS;AxEs/TjB;;AAEA;EACE,yBwEtgUwD;AxEugU1D;;AAEA;EwEpgUQ,yBAAS;AxEsgUjB;;AAEA;EwEngUQ,sCAA+B;AxEqgUvC;;AAEA;EACE,oCwEngU8C;AxEogUhD;;AAEA;EwEnhUQ,kCAA+B;AxEqhUvC;;AAEA;EACE,yCwElhUO;AxEmhUT;;AAEA;EwEhhUQ,wCAAS;AxEkhUjB;;AAEA;EACE,kCwEliUsE;AxEmiUxE;;AAEA;EwEhiUQ,gCAAS;AxEkiUjB;;AAEA;EwE/hUQ,8BAA+B;AxEiiUvC;;AAEA;EACE,gCwE/hUoC;AxEgiUtC;;AAEA;EwE/iUQ,+BAA+B;AxEijUvC;;AAEA;EACE,oCwE9iUO;AxE+iUT;;AAEA;EwE5iUQ,kCAAS;AxE8iUjB;;AAEA;EACE,gCwE9jUsE;AxE+jUxE;;AAEA;EwE5jUQ,uCAAS;AxE8jUjB;;AAEA;EwE3jUQ,sCAA+B;AxE6jUvC;;AAEA;EACE,iCwE3jUoC;AxE4jUtC;;AAEA;EwE3kUQ,2BAA+B;AxE6kUvC;;AAEA;EACE,iCwE3kUsC;AxE4kUxC;;AAEA;EwExkUQ,+BAAS;AxE0kUjB;;AAEA;EACE,6BwE1lUkE;AxE2lUpE;;AAEA;EwExlUQ,+BAAQ;AxE0lUhB;;AAEA;EwEvlUQ,8BAA+B;AxEylUvC;;AAEA;EACE;IwEtmUM,8BAA8B;ExEwmUpC;;EwEtmUM;IACE,iCACD;EACD;;ExEymUN;IwErmUM,sCAAQ;EACR;;EAGA;IACA,yCAA+B;ExEsmUrC;;EAEA;IwErnUM,0BAAQ;EACR;;EAGA;IACA,4BAA+B;ExEsnUrC;;EwElnUM;IACE,kCACD;EACD;;ExEqnUN;IwEloUM,yBAA8B;ExEooUpC;;EwEloUM;IACE,uBAA0B;EAE5B;;ExEqoUN;IwEjoUM,uBAAQ;EACR;;EAGA;IACA,yBAA+B;ExEkoUrC;;EAEA;IwE1nUM,yBAAS;EACT;;EAGA;IACA,sCAAuB;ExE2nU7B;;EwEvnUM;IACE,oCAAkC;EAEpC;;ExE0nUN;IwEvoUM,kCAAsB;ExEyoU5B;;EwEvoUM;IACE,yCACD;EACD;;ExE0oUN;IwEtoUM,wCAAS;EACT;;EAGA;IACA,kCAAuB;ExEuoU7B;;EAEA;IwEtpUM,gCAAS;EACT;;EAGA;IACA,8BAAuB;ExEupU7B;;EwEnpUM;IACE,gCAAkC;EAEpC;;ExEspUN;IwEnqUM,+BAAsB;ExEqqU5B;;EwEnqUM;IACE,oCACD;EACD;;ExEsqUN;IwElqUM,kCAAS;EACT;;EAGA;IACA,gCAAuB;ExEmqU7B;;EAEA;IwElrUM,uCAAS;EACT;;EAGA;IACA,sCAAuB;ExEmrU7B;;EwE/qUM;IACE,iCAAkC;EAEpC;;ExEkrUN;IwE/rUM,2BAAsB;ExEisU5B;;EwE/rUM;IACE,iCACD;EACD;;ExEksUN;IwE9rUM,+BAAU;EACV;;EAGA;IACA,6BAAuB;ExE+rU7B;;EAEA;IwE9sUM,+BAAU;EACV;;EAGA;IACA,8BAAuB;ExE+sU7B;AACF;;AAEA;EwE3sUQ;IACA,8BAAuB;ExE6sU7B;;EAEA;IwE5tUM,iCAAU;EACV;;EAGA;IACA,sCAAuB;ExE6tU7B;;EwEztUM;IACE,yCACD;EACD;;ExE4tUN;IwEzuUM,0BAAsB;ExE2uU5B;;EwEzuUM;IACE,4BAAqB;EAEvB;;ExE4uUN;IwExuUM,kCAAU;EACV;;EAGA;IACA,yBAAuB;ExEyuU7B;;EAEA;IwExvUM,uBAAU;EACV;;EAGA;IACA,uBAAuB;ExEyvU7B;;EwErvUM;IACE,yBAAwB;EAE1B;;ExEwvUN;IwErwUM,yBAAsB;ExEuwU5B;;EwErwUM;IACE,sCACD;EACD;;ExEwwUN;IwEpwUM,oCAAU;EACV;;EAGA;IACA,kCAAuB;ExEqwU7B;;EAEA;IwEpxUM,yCAAU;EACV;;EAGA;IACA,wCAAuB;ExEqxU7B;;EwEjxUM;IACE,kCACD;EACD;;ExEoxUN;IwEjyUM,gCAAsB;ExEmyU5B;;EwEjyUM;IACE,8BAA+B;EAEjC;;ExEoyUN;IwEhyUM,gCAAU;EACV;;EAGA;IACA,+BAAuB;ExEiyU7B;;EAEA;IwEhzUM,oCAAU;EACV;;EAGA;IACA,kCAAuB;ExEizU7B;;EwE7yUM;IACE,gCAAwB;EAE1B;;ExEgzUN;IwE7zUM,uCAAsB;ExE+zU5B;;EwE7zUM;IACE,sCACD;EACD;;ExEg0UN;IwE5zUM,iCAAS;EACT;;EAGA;IACA,2BAAuB;ExE6zU7B;;EAEA;IwE50UM,iCAAS;EACT;;EAGA;IACA,+BAAuB;ExE60U7B;;EwEz0UM;IACE,6BAAwB;EAE1B;;ExE40UN;IwEz1UM,+BAAsB;ExE21U5B;;EwEz1UM;IACE,8BAA+B;EAEjC;AxE21UR;;AAEA;EwEx1UQ;IACE,8BAAwB;EAE1B;;ExE01UN;IwEv2UM,iCAAsB;ExEy2U5B;;EwEv2UM;IACE,sCACD;EACD;;ExE02UN;IwEt2UM,yCAAS;EACT;;EAGA;IACA,0BAAuB;ExEu2U7B;;EAEA;IwEj2UE,4BAAW;EACX;;EAGA;IACA,kCAAkB;ExEk2UpB;;EwE91UE;IACE,yBAAe;EAEjB;;ExEi2UF;IACE,uBAAuB;Eez2UvB;;Ef42UF;IwE75UM,uBAAQ;EACR;;EAGA;IACA,yBAA+B;ExE85UrC;;EwE15UM;IACE,yBAAgC;EAElC;;ExE65UN;IwE16UM,sCAA8B;ExE46UpC;;EwE16UM;IACE,oCACD;EACD;;ExE66UN;IwEz6UM,kCAAQ;EACR;;EAGA;IACA,yCAA+B;ExE06UrC;;EAEA;IwEz7UM,wCAAQ;EACR;;EAGA;IACA,kCAA+B;ExE07UrC;;EwEt7UM;IACE,gCAA0C;EAE5C;;ExEy7UN;IwEt8UM,8BAA8B;ExEw8UpC;;EwEt8UM;IACE,gCACD;EACD;;ExEy8UN;IwEr8UM,+BAAQ;EACR;;EAGA;IACA,oCAA+B;ExEs8UrC;;EAEA;IwEr9UM,kCAAQ;EACR;;EAGA;IACA,gCAA+B;ExEs9UrC;;EwEl9UM;IACE,uCACD;EACD;;ExEq9UN;IwEl+UM,sCAA8B;ExEo+UpC;;EwEl+UM;IACE,iCACD;EACD;;ExEq+UN;IwEj+UM,2BAAQ;EACR;;EAGA;IACA,iCAA+B;ExEk+UrC;;EAEA;IwEj/UM,+BAAS;EACT;;EAGA;IACA,6BAA+B;ExEk/UrC;;EwE9+UM;IACE,+BAAgC;EAElC;;ExEi/UN;IwE9/UM,8BAA8B;ExEggVpC;AACF;;AAEA;EwE9/UQ;IACA,8BAA+B;ExEggVrC;;EwE5/UM;IACE,iCAA0C;EAE5C;;ExE+/UN;IwE5gVM,sCAA8B;ExE8gVpC;;EwE5gVM;IACE,yCACD;EACD;;ExE+gVN;IwE3gVM,0BAAS;EACT;;EAGA;IACA,4BAA+B;ExE4gVrC;;EAEA;IwE3hVM,kCAAS;EACT;;EAGA;IACA,yBAA+B;ExE4hVrC;;EwExhVM;IACE,uBAAgC;EAElC;;ExE2hVN;IwExiVM,uBAA8B;ExE0iVpC;;EwExiVM;IACE,yBAA0B;EAE5B;;ExE2iVN;IwEviVM,yBAAS;EACT;;EAGA;IACA,sCAA+B;ExEwiVrC;;EAEA;IwEvjVM,oCAAS;EACT;;EAGA;IACA,kCAA+B;ExEwjVrC;;EwEpjVM;IACE,yCACD;EACD;;ExEujVN;IwEpkVM,wCAA8B;ExEskVpC;;EwEpkVM;IACE,kCACD;EACD;;ExEukVN;IwEnkVM,gCAAS;EACT;;EAGA;IACA,8BAA+B;ExEokVrC;;EAEA;IwEnlVM,gCAAS;EACT;;EAGA;IACA,+BAA+B;ExEolVrC;;EwEhlVM;IACE,oCACD;EACD;;ExEmlVN;IwEhmVM,kCAA8B;ExEkmVpC;;EwEhmVM;IACE,gCAAoC;EAEtC;;ExEmmVN;IwE/lVM,uCAAS;EACT;;EAGA;IACA,sCAA+B;ExEgmVrC;;EAEA;IwE/mVM,iCAAQ;EACR;;EAGA;IACA,2BAA+B;ExEgnVrC;;EwE5mVM;IACE,iCAA0C;EAE5C;;ExE+mVN;IwE5nVM,+BAA8B;ExE8nVpC;;EwE5nVM;IACE,6BAAoC;EAEtC;;ExE+nVN;IwE3nVM,+BAAQ;EACR;;EAGA;IACA,8BAA+B;ExE4nVrC;AACF;;AAEA;EwE3oVQ,sBAA+B;AxE6oVvC;;AAEA;EACE,uBwE3oVsC;AxE4oVxC;;AAEA;EwExoVQ,sBAAQ;AxE0oVhB;;AAEA;EACE;IwEzpVM,sBAAQ;EACR;;EAGA;IACA,uBAA+B;ExE0pVrC;;EwEtpVM;IACE,sBAAgC;EAElC;AxEwpVR;;AAEA;EACE;IwEvqVM,sBAAQ;EACR;;EAGA;IACA,uBAA+B;ExEwqVrC;;EwEpqVM;IACE,sBAAgC;EAElC;AxEsqVR;;AAEA;EACE;IwErrVM,sBAAQ;EACR;;EAGA;IACA,uBAA+B;ExEsrVrC;;EwElrVM;IACE,sBnEyPL;EmEvPG;AxEorVR;;AAEA;EACE;IwEnsVM,sBAAQ;EACR;;EAGA;IACA,uBAA+B;ExEosVrC;;EwEhsVM;IACE,sBnE0PS;EmExPX;AxEksVR;;AAEA;EACE,mCwEltVkE;UxEktVlE,2BwEltVkE;AxEmtVpE;;AAEA;EwEhtVQ,oCAAQ;UAAR,4BAAQ;AxEktVhB;;AAEA;EwE/sVQ,oCAA+B;UAA/B,4BAA+B;AxEitVvC;;AAEA;EACE,yBwE/sVoC;AxEgtVtC;;AAEA;EwE/tVQ,2BAA+B;AxEiuVvC;;AAEA;EACE,2BwE/tVsC;AxEguVxC;;AAEA;EwE5tVQ,6BAAQ;AxE8tVhB;;AAEA;EACE,6BwE9uVsE;AxE+uVxE;;AAEA;EwE5uVQ,0BAAQ;AxE8uVhB;;AAEA;EwE3uVQ,mCAA+B;EAA/B,2BAA+B;AxE6uVvC;;AAEA;EACE,ewE3uVqB;EAff,MAAA;ExE4vVN,QwE5vVsC;EAChC,OAAA;EACA,aAA+B;AxE6vVvC;;AAEA;EACE,ewE3vVsB;EAEhB,QAAA;EACA,SAAS;ExE2vVf,OwE1vVQ;EAEF,aAAS;AxE0vVjB;;AAEA;EACE;IwEzwVM,wBAAS;IAAT,gBAAS;IACT,MAAA;IACE,anEwPF;EmEtPA;AxE0wVR;;AAEA;EwEvwVQ,kBAA+B;ExEywVrC,UwExwVQ;EAEF,WAAS;EACT,UAA+B;ExEwwVrC,YwEvwVQ;EAfF,gBAA8B;ExEwxVpC,sBwExxVwD;EAClD,mBAAS;EACT,SAAS;AxEyxVjB;;AAEA;;EwEpxVQ,gBAAS;EACT,WAA+B;ExEuxVrC,YwEtxVQ;EAEF,iBAAS;EACT,UAA+B;ExEsxVrC,mBKxiVM;ALyiVR;;AAEA;EwEryVQ,4DAA+B;AxEuyVvC;;AAEA;EACE,2DwEpyVO;AxEqyVT;;AAEA;EwElyVQ,0DAAS;AxEoyVjB;;AAEA;EACE,2BwEpzVkE;AxEqzVpE;;AAEA;EwElzVQ,qBAAS;AxEozVjB;;AAEA;EwEjzVQ,qBAA+B;AxEmzVvC;;AAEA;EACE,qBKlkViB;ALmkVnB;;AAEA;EwEj0VQ,sBAA+B;AxEm0VvC;;AAEA;EACE,sBKzkVM;AL0kVR;;AAEA;EwE9zVQ,sBAAS;AxEg0VjB;;AAEA;EACE,sBwEh1VwD;AxEi1V1D;;AAEA;EwE90VQ,sBAAS;AxEg1VjB;;AAEA;EwE70VQ,uBAA+B;AxE+0VvC;;AAEA;EACE,uBwE70VoC;AxE80VtC;;AAEA;EwE71VQ,0BAA+B;AxE+1VvC;;AAEA;EACE,2BwE71VsC;AxE81VxC;;AAEA;EwE11VQ,2BAAS;AxE41VjB;;AAEA;EACE,4BwE52VwD;AxE62V1D;;AAEA;EwE12VQ,uBAAS;AxE42VjB;;AAEA;EwEz2VQ,wBAA+B;AxE22VvC;;AAEA;EACE,oBKtnVM;ALunVR;;AAEA;;EAEE,wBwE13VkC;AxE23VpC;;AAEA;;EwEt3VQ,0BAA+B;AxEy3VvC;;AAEA;;EwEr4VQ,2BAA8B;AxEw4VtC;;AAEA;;EwEr4VQ,yBAAQ;AxEw4VhB;;AAEA;EwEr4VQ,0BAA+B;AxEu4VvC;;AAEA;;EwEn5VQ,8BAA8B;AxEs5VtC;;AAEA;;EwEn5VQ,gCAAQ;AxEs5VhB;;AAEA;;EAEE,iCwEp5VkD;AxEq5VpD;;AAEA;;EAEE,+BwEp6VsE;AxEq6VxE;;AAEA;EwEl6VQ,yBAAQ;AxEo6VhB;;AAEA;;EAEE,6BwEl6VwC;AxEm6V1C;;AAEA;;EAEE,+BwE35VyD;AxE45V3D;;AAEA;;EwEx5VQ,gCAAuB;AxE25V/B;;AAEA;;EwEt5VQ,8BAAS;AxEy5VjB;;AAEA;EACE,uBwEz6V+C;AxE06VjD;;AAEA;;EwEt6VQ,2BAAuB;AxEy6V/B;;AAEA;;EwEp6VQ,6BAAS;AxEu6VjB;;AAEA;;EwEr7VQ,8BAAS;AxEw7VjB;;AAEA;;EAEE,4BwEt7V+B;AxEu7VjC;;AAEA;EwEn7VQ,yBAAS;AxEq7VjB;;AAEA;;EwEn8VQ,6BAAS;AxEs8VjB;;AAEA;;EAEE,+BwEp8V+B;AxEq8VjC;;AAEA;;EwEh8VQ,gCAAuB;AxEm8V/B;;AAEA;;EwEj9VQ,8BAAuB;AxEo9V/B;;AAEA;EACE,uBwEl9V+B;AxEm9VjC;;AAEA;;EwE98VQ,2BAAuB;AxEi9V/B;;AAEA;;EwE/9VQ,6BAAuB;AxEk+V/B;;AAEA;;EwE79VQ,8BAAU;AxEg+VlB;;AAEA;;EAEE,4BwE99V8B;AxE+9VhC;;AAEA;EwE9+VQ,yBAAuB;AxEg/V/B;;AAEA;;EwE3+VQ,6BAAU;AxE8+VlB;;AAEA;;EAEE,+BwE5+VwC;AxE6+V1C;;AAEA;;EAEE,gCwE5/VO;AxE6/VT;;AAEA;;EwEz/VQ,8BAAuB;AxE4/V/B;;AAEA;EACE,wBwE1/V8B;AxE2/VhC;;AAEA;;EAEE,4BwE3gW6B;AxE4gW/B;;AAEA;;EwEvgWQ,8BAAuB;AxE0gW/B;;AAEA;;EwEthWQ,+BAAsB;AxEyhW9B;;AAEA;;EwEthWQ,6BAAU;AxEyhWlB;;AAEA;EwEthWQ,wBAAuB;AxEwhW/B;;AAEA;;EwEpiWQ,4BAAsB;AxEuiW9B;;AAEA;;EwEpiWQ,8BAAU;AxEuiWlB;;AAEA;;EAEE,+BwEriWgC;AxEsiWlC;;AAEA;;EAEE,6BwErjW6D;AxEsjW/D;;AAEA;EwEnjWQ,0BAAU;AxEqjWlB;;AAEA;;EAEE,8BwEnjWgC;AxEojWlC;;AAEA;;EAEE,gCwEnkW6D;AxEokW/D;;AAEA;;EwEhkWQ,iCAAuB;AxEmkW/B;;AAEA;;EwE9jWQ,+BAAU;AxEikWlB;;AAEA;EACE,wBwEjlW+C;AxEklWjD;;AAEA;;EwE9kWQ,4BAAuB;AxEilW/B;;AAEA;;EwE5kWQ,8BAAU;AxE+kWlB;;AAEA;;EwE7lWQ,+BAAS;AxEgmWjB;;AAEA;;EAEE,6BwE9lW+B;AxE+lWjC;;AAEA;EwE3lWQ,0BAAS;AxE6lWjB;;AAEA;;EwE3mWQ,8BAAS;AxE8mWjB;;AAEA;;EAEE,gCwE5mWyC;AxE6mW3C;;AAEA;;EwExmWQ,iCAAuB;AxE2mW/B;;AAEA;;EwEznWQ,+BAAuB;AxE4nW/B;;AAEA;EACE,wBwE1nW+B;AxE2nWjC;;AAEA;;EwEtnWQ,4BAAuB;AxEynW/B;;AAEA;;EwEvoWQ,8BAAuB;AxE0oW/B;;AAEA;;EwEroWQ,+BAAS;AxEwoWjB;;AAEA;;EAEE,6BwEtoW8B;AxEuoWhC;;AAEA;EwEjoWI,0BAAkB;AxEmoWtB;;AAEA;;EwE9nWI,8BAAW;AxEioWf;;AAEA;;EAEE,gCwE/nWgC;AxEgoWlC;;AAEA;;EyE/rWI,iCAAQ;AzEksWZ;;AAEA;;EyE9rWI,+BAAW;AzEisWf;;A0EzsWA;EAAkB,2BpE+Q0B;AN87V5C;;AAEA;;E0E1sWA,+BAAe;A1E6sWf;;A0E5sWA;;E1EgtWE,iCAAiC;A0E/sWnC;;A1EktWA;;EAEE,kCAAkC;A0E5sWhC;;A1E+sWJ;;E0E9sW4B,gCAAgC;A1EitW5D;;AAEA;EACE,yBAAyB;Ae9qWvB;;AfirWJ;;EAEE,6B0EztWsC;A1E0tWxC;;AAEA;;E0E7tWI,+BAAsB;A1EguW1B;;AAEA;;EAEE,gC0EluWuD;A1EmuWzD;;AAEA;;E0EtuWI,8BAAsB;A1EyuW1B;;AAEA;EACE,uBAAuB;AetsWrB;;AfysWJ;;EAEE,2B0EjvWsC;A1EkvWxC;;AAEA;;E0E7uWmB,6BAAgB;A1EgvWnC;;AAEA;;E0EhvWA,8BAAiB;A1EmvWjB;;A0E/uWA;;E1EmvWE,4BAA4B;A0ElvW9B;;A1EqvWA;E0EpvWA,uBAAqB;A1EsvWrB;;A0ErvWA;;E1EyvWE,2BAA2B;A0ExvW7B;;A1E2vWA;;E0E1vWuB,6BAA6B;A1E6vWpD;;AAEA;;E2ElyWE,8BAAW;A3EqyWb;;AkB1xWE;;ElB8xWA,4BAA4B;A2EzyW5B;;A3E4yWF;E2ExyWK,wBAAA;A3E0yWL;;A2E9yWE;;E3EkzWA,4BAA4B;AkBvyW5B;;AlB0yWF;;E2EpzWI,8BACD;A3EszWH;;AAEA;;E2E1zWE,+BAAW;A3E6zWb;;AkBlzWE;;ElBszWA,6BAA6B;A2Ej0W7B;;A3Eo0WF;E2Eh0WK,qBAAA;A3Ek0WL;;A2Et0WE;;E3E00WA,yBAAyB;AkB/zWzB;;AlBk0WF;;E2E50WI,2BAAwB;A3E+0W5B;;AAEA;;E2El1WE,4BAAW;A3Eq1Wb;;AkB10WE;;ElB80WA,0BAA0B;A0ElzW5B;;A1EqzWA;E2Ex1WK,2BAAA;A3E01WL;;A2E91WE;;E3Ek2WA,+BAA+B;AkBv1W/B;;AlB01WF;;E2Ep2WI,iCACD;A3Es2WH;;AAEA;;E0E7zWA,kCAAW;A1Eg0WX;;A0E/zWA;;E1Em0WE,gCAAgC;A0Ej0WlC;;A1Eo0WA;E0En0WA,0BAAe;A1Eq0Wf;;A0Ej0WA;;EEtDE,8BAAkB;A5E43WpB;;AAEA;;E0Ep0WA,gCAAsB;A1Eu0WtB;;A0Er0WA;;EAEE,iCAAgC;A1Ew0WlC;;AAEA;;E6Et4WA,+BAAS;A7Ey4WT;;A6Er4WA;EACE,wBAAY;A7Ew4Wd;;AAEA;;EAEE,4BAA4B;A8E/4W9B;;A9Ek5WA;;E8E94WE,8BAA2B;A9Ei5W7B;;AAEA;;EAEE,+BAA+B;A8E74WjC;;A9Eg5WA;;EAEE,6BAA6B;A8Ex4W/B;;A9E24WA;E8Ev4WE,0BAAG;A9Ey4WL;;AAEA;;E8Ep4WE,8BAAqB;A9Eu4WvB;;AAEA;;E8En4WE,gCAAkB;A9Es4WpB;;AAEA;;E8El4WE,iCxE6hC4B;ANw2U9B;;A8Eh4WE;;EAEE,+BAAc;A9Em4WlB;;A+Ep7WE;E3EOF,wBAAC;AJi7WD;;AAEA;;E+E/6WI,4BACc;A/Ei7WlB;;AAEA;;EAEE,8B+E35WiB;A/E45WnB;;AAEA;;E+Ej5WI,+BAAM;A/Eo5WV;;AAEA;;E+E74WI,6BAAC;A/Eg5WL;;AAEA;EACE,0B+E94WG;A/E+4WL;;AAEA;;EAEE,8BMv2UoC;ANw2UtC;;AAEA;;EmCj9WA,gC4CkFY;A/Ek4WZ;;AAEA;;EAEE,iC+E93WqB;A/E+3WvB;;AAEA;;EiBh8WA,+B8DyES;A/E03WT;;AAEA;EACE,yBmBr+WM;AnBs+WR;;AAEA;;EiBt4WA,6B8DsB0B;A/Em3W1B;;AAEA;;EgFp/WI,+BACH;AhFs/WD;;AAEA;;EgFj/WI,gCACH;AhFm/WD;;AAEA;;EgF7+WI,8BAAqB;AhFg/WzB;;AAEA;EACE,yBgF7+WG;AhF8+WL;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;E4Ct/WA,+BqCvBW;AjFghXX;;AAEA;;EiF7gXQ,gCAoBH;AjF4/WL;;AAEA;;EiFxhXA,8BAaU;AjF8gXV;;AAEA;EiF7hXA,2BACU;AjF8hXV;;AAEA;;EiFjgXY,+BACH;AjFmgXT;;AAEA;;EkFpiXA,iCAAc;AlFuiXd;;AAEA;;EkFpiXI,kC7EyBO;AL8gXX;;AAEA;;EAEE,gCKlhXS;ALmhXX;;AAEA;EACE,yBkFhiXW;AlFiiXb;;AAEA;;EAEE,6BkF3hXoB;AlF4hXtB;;AAEA;;EAEE,+BkFzhXwC;AlF0hX1C;;A6D/jXA;;EAEC,gCxDuBiB;AL2iXlB;;AAEA;;E6D/jXC,8BxDuSoC;AL2xWrC;;AAEA;EACE,2B6DhkXc;A7DikXhB;;AAEA;;EAEE,+BAA+B;A6DljXjC;;A7DqjXA;;E6DhjXA,iCAAW;A7DmjXX;;AAEA;;E6D/iXA,kCAAW;A7DkjXX;;AAEA;;E6D9iXA,gCAAW;A7DijXX;;AAEA;EACE,yBAAyB;AmFpmX3B;;AnFumXA;;EmFvmXA,6BAMU;AnFomXV;;AmF1mXA;;EnF8mXE,+BAA+B;AyC/mXjC;;AzCknXA;;EAEE,gCAAgC;AoFvmXlC;;ApF0mXA;;EoFrmXI,8BACH;ApFumXD;;AAEA;EoFpmXA,2BAGW;ApFmmXX;;AAEA;;EAEE,+BAA+B;AyCrlX/B;;AzCwlXF;;EoFxlXI,iC/EiCmB;AL0jXvB;;AoFplXA;;EpFwlXE,kCAAkC;AoFxlXpC;;ApF2lXA;;EqF5oXI,gCAAkB;ArF+oXtB;;AAEA;EqF7oXI,4BAAkB;ArF+oXtB;;AAEA;;EqF5oXI,gCAWH;ArFooXD;;AAEA;;EAEE,kCqF3oXiB;ArF4oXnB;;AsF9pXA;;EAEI,mCAAgB;AtFiqXpB;;AAEA;;EsFrqXA,iCAQW;AtFgqXX;;AAEA;EACE,0BsF7pX4B;AtF8pX9B;;AAEA;;EsF9qXA,8BAsBU;AtF2pXV;;AAEA;;EAEE,gCsFrpXO;AtFspXT;;AAEA;;EuFtrXQ,iCAA0B;AvFyrXlC;;AAEA;;EwFhsXA,+BAAiB;AxFmsXjB;;AwF/rXA;EACI,wBnFwEY;AL0nXhB;;AAEA;;EAEE,4BwFpsXE;AxFqsXJ;;AAEA;;EAEE,8BwFtrXO;AxFurXT;;AAEA;;EwF/qXI,+BACH;AxFirXD;;AAEA;;EyFntXI,6BpF2U0D;AL24W9D;;AAEA;EkBrtXE,wBuEEU;AzFqtXZ;;AAEA;;EyF/tXA,4BxF89B+C;ADowV/C;;AAEA;;EAEE,8ByF3sXG;AzF4sXL;;AyFrsXA;;EAGQ,+BACH;AzFssXL;;AAEA;;EwBroXA,6BiEzDQ;AzFisXR;;AAEA;EyF1rXI,yBACH;AzF2rXD;;AAEA;;EyFvrXA,6BACe;AzFyrXf;;AAEA;;EyFprXI,+BpFyjB6B;AL8nWjC;;AAEA;;EAEE,gCAAgC;AwBxsXhC;;AxB2sXF;;EyB3wXI,8BpByBW;ALqvXf;;AAEA;EkBrwXE,2BAAQ;AlBuwXV;;AAEA;;EAEE,+BK7oWsC;AL8oWxC;;AAEA;;EyB7vXI,iCDUmB;AxBsvXvB;;AAEA;;EAEE,kCyBpwXuB;AzBqwXzB;;AAEA;;EyBnyXI,gCpByBW;AL6wXf;;AAEA;EkB7xXE,0BAAQ;AlB+xXV;;AAEA;;EAEE,8BKrqWsC;ALsqWxC;;AAEA;;EyBrxXI,gCDUmB;AxB8wXvB;;AAEA;;EAEE,iCyB5xXuB;AzB6xXzB;;AAEA;;EyB3zXI,+BpByBW;ALqyXf;;AAEA;EkBrzXE,wBAAQ;AlBuzXV;;AAEA;;EAEE,4BK7rWsC;AL8rWxC;;AAEA;;EyB7yXI,8BrBqVe;AJ29WnB;;AAEA;;EAEE,+BI/9WQ;AJg+WV;;AAEA;;EyBn1XI,6BpByBW;AL6zXf;;AAEA;EkB70XE,0BAAQ;AlB+0XV;;AAEA;;EAEE,8BKrtWsC;ALstWxC;;AAEA;;EyBr0XI,gCAAgB;AzBw0XpB;;AAEA;;EAEE,iCyB50XkB;AzB60XpB;;AAEA;;EyB32XI,+BpByBW;ALq1Xf;;AAEA;EkBr2XE,wBAAQ;AlBu2XV;;AAEA;;EAEE,4BK7uWsC;AL8uWxC;;AAEA;;EyB71XI,8BAAgB;AzBg2XpB;;AAEA;;EAEE,+ByBp2XkB;AzBq2XpB;;AAEA;;EyBn4XI,6BpByBW;AL62Xf;;AAEA;EkB73XE,wBAAQ;AlB+3XV;;AAEA;;EAEE,4BKrwWsC;ALswWxC;;AAEA;;EyBr3XI,8BAAgB;AzBw3XpB;;AAEA;;EAEE,+ByB53XkB;AzB63XpB;;AAEA;;EyB35XI,6BpByBW;ALq4Xf;;AAEA;EkBr5XE,uBAAQ;AlBu5XV;;AAEA;;EAEE,2BK7xWsC;AL8xWxC;;AAEA;;EyB74XI,6BAAqB;AzBg5XzB;;AAEA;;EAEE,8ByBp5XkB;AzBq5XpB;;AAEA;;EyBn7XI,4BpByBW;AL65Xf;;AAEA;EkB76XE,uBAAQ;AlB+6XV;;AAEA;;EAEE,2BKrzWsC;ALszWxC;;AAEA;;EyBr6XI,6BAAgB;AzBw6XpB;;AAEA;;EAEE,8ByB56XkB;AzB66XpB;;AAEA;;EyB38XI,4BpByBW;ALq7Xf;;AAEA;EkBr8XE,yBAAQ;AlBu8XV;;AAEA;;EAEE,6BK70WsC;AL80WxC;;AAEA;;EyB77XI,+BDUmB;AxBs7XvB;;AAEA;;EAEE,gCyBp8XuB;AzBq8XzB;;AAEA;;EyBn+XI,8BpByBW;AL68Xf;;AAEA;EkB79XE,uBAAQ;AlB+9XV;;AAEA;;EAEE,2BKr2WsC;ALs2WxC;;AAEA;;EyBr9XI,6BAAqB;AzBw9XzB;;AAEA;;EAEE,8ByB59XkB;AzB69XpB;;AAEA;;E0Fp/XQ,4BACH;A1Fs/XL;;AAEA;E0F/+XQ,yBAAe;A1Fi/XvB;;AAEA;;EAEE,6B0F9+XO;A1F++XT;;AAEA;;E0Fx+XA,+BACa;A1F0+Xb;;AAEA;;E0Fv+XQ,gCAAU;A1F0+XlB;;AAEA;;EAEE,8B0Fx+XkC;A1Fy+XpC;;AAEA;EACE,uB0Ft+XgB;A1Fu+XlB;;AAEA;;EAEE,2B0Ft+X6B;A1Fu+X/B;;AAEA;;EAEE,6B0Fx+X6C;A1Fy+X/C;;AAEA;;EAEE,8B0Fp+XO;A1Fq+XT;;AAEA;;EAEE,4B0Fn+XW;A1Fo+Xb;;AAEA;EACE,yBAAyB;A2F9iY3B;;A3FijYA;;E2FriYO,6BACH;A3FuiYJ;;AAEA;;E2FhiYI,+BACH;A3FkiYD;;AAEA;;E2F9hYA,gChE2BA;A3BsgYA;;AAEA;;E2FvhYI,8BAAS;A3F0hYb;;AAEA;E2FxhYI,0BAAiB;A3F0hYrB;;AAEA;;E2FvhYI,8BAAgB;A3F0hYpB;;AAEA;;E2FvhYI,gCAAqB;A3F0hYzB;;AAEA;;EAEE,iCK/jYa;ALgkYf;;AAEA;;E2FhjYA,+BA8BM;A3FqhYN;;AAEA;EACE,0B2FnhYG;A3FohYL;;AAEA;;EAEE,8B2FlhYuB;A3FmhYzB;;AAEA;;EAEE,gCAAgC;AoCxmYlC;;ApC2mYA;;EAEE,iCAAiC;A4FpmYnC;;A5FumYA;;E4F/kYQ,+BACH;A5FilYL;;AAEA;EACE,wBAAwB;Ae9jYtB;;AfikYJ;;EejkYI,4BAAwB;AfokY5B;;AAEA;;EoCh5XA,8BwD3Lc;A5F8kYd;;AAEA;;E6FjoYQ,+BAA4B;A7FooYpC;;AAEA;;EAEE,6BAA6B;A8F1oY/B;;A9F6oYA;E8F7oYA,wBAIW;A9F2oYX;;AAEA;;EAEE,4B8F1oYgB;A9F2oYlB;;A+FnpYA;;EAEI,8BAA8B;A/FspYlC;;AAEA;;EAEE,+B+FvpYY;A/FwpYd;;AAEA;;EAEE,6B+FlpYO;A/FmpYT;;AAEA;EACE,yBAAyB;AgGtqY3B;;AhGyqYA;;EgGzqYA,6BAKqB;AhGuqYrB;;AAEA;;EgGlqYI,+BAAU;AhGqqYd;;AeznYI;;Ef6nYF,gCgGnqYgB;AhGoqYlB;;AiGtrYA;;EAAA,8BAGQ;AjGwrYR;;AAEA;EACE,uBiGvrYiB;AjGwrYnB;;AAEA;;EAEE,2BiGtrYqB;AjGurYvB;;AAEA;;EAEE,6BiGlrYwB;AjGmrY1B;;AAEA;;EAEE,8BiG/qYM;AjGgrYR;;AAEA;;EAEE,4BiG9qY4B;AjG+qY9B;;AiGzqYA;EACI;IjG4qYA,oBAAoB;EkGvtYxB;;ElG0tYE;;IkGptYM,wBAAkB;EAClB;;EAEA;;ICTR,0BAAO;EACH;;EnGmuYF;;ImG3tYE,2BACH;EnG6tYC;;EmGvtYE;;IAEA,yB9FkjC4B;E8FjjC5B;;EAEA;InG0tYA,0BAA0B;EmGvtY9B;;EAEI;;IAGI,8BACH;EnGutYH;;EmGntYE;;IAEA,gCAAc;EACd;;EnGutYF;;ImG/sYE,iCAOH;EARD;;EnGqtYE;;IAEE,+BAA+B;EmG1sYnC;;EAEE;IACA,yBAAQ;EACR;;EAEA;;IjDnEF,6BkDIO;EAEC;;EpG6wYN;;IoGvwYM,+BAAiB;EpG0wYvB;;EAEA;;IoGvwYM,gCAAc;EpG0wYpB;;EAEA;;IoGlwYM,8BAKH;EpGgwYH;;EAEA;IoG/vYF,uBC/BA;EDiCQ;;EAFR;;IpGqwYI,2BAA2B;EsGnyY/B;;EAGE;;IAGC,6BAAgB;EtGmyYjB;;EAEA;;IsGhyYC,8BAAM;EtGmyYP;;EAEA;;IAEE,4BsGpyYD;EtGqyYD;;EsGhyYC;ItGmyYC,yBAAyB;EsGtzY7B;;EtGyzYE;;IsG5xYC,6BACA;EtG8xYD;;EuGh0YE;;IAII,+BAA0B;EvGi0YhC;;EAEA;;IAEE,gCuG7zYoF;EvG8zYtF;;EwGr0YM;;IxGy0YJ,8BAA8B;EwG30YlC;;ExG80YE;IiC/tYF,uBAKE;EuEvGkB;;EAbpB;;IxGo1YI,2BAA2B;EwGp1Y/B;;ExGu1YE;;IyGn1YM,6BpGqBU;EiBbZ;;EmFLE;;IxEgER,8BwEpEc;EzG41YZ;;EiCxxYF;;IwE1DM,4BAED;EzGq1YH;;EyGl1YM;IACA,yBACH;EzGo1YH;;EyGh1YE;;IAMJ,6BACI;EAGQ;;EzG60YV;;IyGp0YkB,+BpGigB8B;ELs0XhD;;EyGp1YF;;IzGw1YI,gCAAgC;EwGt3YpC;;EEGQ;;I1Gw3YJ,8BAA8B;EwG33YlC;;ExG83YE;IiC/wYF,wBAKE;EyEtGkB;;EFdpB;;IxGo4YI,4BAA4B;EwGp4YhC;;ExGu4YE;;I2Gt4YkB,8BtG6EG;EqB5EnB;;EiFEY;;I3G04YZ,+BAA+B;E2G94YnB;;EjFEZ;;IiFEY,6BAPZ;EAQgB;;EALJ;IACI,wBtGqDH;EqBpDb;;EiFEY;;I3Gw5YZ,4BAA4B;E2G55YhB;;EjFEZ;;IiFEY,8BAPZ;EAQgB;;EALJ;;IjFEZ,+BiFCa;E3Go6Yf;;E2Gl6YkB;;IALJ,6BAHZ;EAIgB;;E3G66YlB;I2G16Yc,0BAPZ;EAQgB;;EALJ;;IjFEZ,8BiFCa;E3Gk7Yf;;E2Gh7YkB;;IALJ,gCAHZ;EAIgB;;E3G27YlB;;I2Gv7YkB,iCACH;E3Gy7Yf;;E2G97YkB;;I3Gk8YhB,+BAA+B;E2G/7YnB;;E3Gk8Yd;I2Gt8Yc,wBAHZ;EAIgB;;E3Gy8YlB;;I2Gr8YkB,4BACH;E3Gu8Yf;;E2G58YkB;;I3Gg9YhB,8BAA8B;E2G78YlB;;E3Gg9Yd;;I2Gn9YkB,+BtGqFkB;EqBpFlC;;EiFEY;;I3Gu9YZ,6BAA6B;E4G39YjC;;EAGQ;IACA,0BACH;E5G29YH;;E4Gr9YkB;;I3EwIpB,8BAME;E2E3IkB;;EAdpB;;I5Gy+YI,gCAAgC;E4Gz+YpC;;E5G4+YE;;I6G3+YE,iCAAkB;EAClB;;EAEA;;IAEA,+BAgCH;EAtCD;;E7Gs/YE;IACE,wBKz6YY;EL06Yd;;EAEA;;IAEE,4BKp+Yc;ELq+YhB;;EAEA;;IAEE,8BAA8B;E6Gz9YlC;;EAEI;;IAEA,+BAAO;EACP;;EAEA;;IAEA,6BAA6B;EATjC;;E7Gs+YE;I6Gv9YM,0BAAY;E7Gy9YlB;;EAEA;;I6Gt9YM,8BxGpCU;EL6/YhB;;E6Gp9YF;;I7Gw9YI,gCAAgC;E6G/8YpC;;EAOoB;;IAEA,iCACH;E7G28Yf;;E6Gn8YM;;IAEA,+BAAc;EACd;;EAEA;IACA,2BAAiB;EACjB;;EAEA;;IAEA,+BAAkB;EAClB;;EvF5FF;;IuF8EN,iCACY;E7Gu9YV;;E2GliZW;;IAGG,kCAJC;E3GwiZf;;EAEA;;I2GzhZc,gCAlBP;EAmBW;;E3G6hZlB;IACE,yBAAyB;E2G/iZhB;;EAGG;;IAKZ,6BAVK;E3GujZP;;E2GriZc;;IAGI,+BArBX;E3G4jZP;;E2G1jZW;;IAGG,gCALP;E3GikZP;;EAEA;;I2GjjZc,8BAlBP;EAmBW;;E3GqjZlB;IACE,uBAAuB;E2GvkZd;;EAGG;;IAKZ,2BAVK;E3G+kZP;;E2G7jZc;;IAGI,6BArBX;E3GolZP;;E2GllZW;;IAGG,8BALP;E3GylZP;;EAEA;;I2GzkZc,4BAlBP;EAmBW;;E3G6kZlB;IACE,uBAAuB;E2G/lZd;;EAGG;;IAKZ,2BAVK;E3GumZP;;E2GrlZc;;IAGI,6BArBX;E3G4mZP;;E2G1mZW;;IAGG,8BALP;E3GinZP;;EAEA;;I2GjmZc,4BAlBP;EAmBW;;E3GqmZlB;IACE,wBAAwB;E2GvnZf;;EAGG;;IAKZ,4BAVK;E3G+nZP;;E2G7mZc;;IAGI,8BArBX;E3GooZP;;E2GloZW;;IAGG,+BALP;E3GyoZP;;EAEA;;I2GznZc,6BAlBP;EAmBW;;E3G6nZlB;IACE,qBAAqB;E2G/oZZ;;EAGG;;IAKZ,yBAVK;E3GupZP;;E2GroZc;;IAGI,2BArBX;E3G4pZP;;E2G1pZW;;IAGG,4BALP;E3GiqZP;;EAEA;;I2GjpZc,0BAlBP;EAmBW;;E3GqpZlB;IACE,2BAA2B;E2GvqZlB;;EAGG;;IAKZ,+BAVK;E3G+qZP;;E2G7pZc;;IAGI,iCArBX;E3GorZP;;E8GhsZF;;IAEA,kCAAU;EACV;;E9GosZE;;I8G/rZE,gCAiBH;EAlBD;;E9GqsZE;I8GrsZF,0BAGI;E9GosZF;;EAEA;;I8GzsZF,8BAcQ;E9G8rZN;;E6BxiZF;;IiF9II,gCAAmB;EAEnB;;EAEA;;IAMJ,iCAGa;EAEG;;EALhB;;I9G0rZI,+BAA+B;E8G1rZnC;;EAgBgB;I9G8qZZ,wBAAwB;E8GxqZ5B;;E9G2qZE;;I8GlqZE,4BAAgB;EAChB;;EAGJ;;IAEI,8BACH;E9GmqZC;;E8GhqZE;;I9GoqZA,+BAA+B;E+GnvZnC;;EAEI;;IAIQ,6B1GmBM;ELguZhB;;EAEA;I+GjvZU,0B1G+VqB;ELo5Y/B;;E+G7vZF;;IAAA,8BAemB;E/GmvZjB;;E+GlwZF;;IA0BQ,gCAAkB;E/G6uZxB;;EAEA;;I+GzwZF,iCAmCe;E/GyuZb;;E+GjuZF;;I/GquZI,+BAA+B;E+G5tZnC;;E/G+tZE;I+G/tZF,wBAKa;EAED;;EAQZ;;IAEI,4BAAkB;EAClB;;EAEA;;IALJ,8BAQa;E/GotZX;;EAEA;;I+GjtZM,+BAAU;E/GotZhB;;EAEA;;I+G/sZM,6BAAoB;E/GktZ1B;;E+G1sZF;IACI,0BAAkB;EAClB;;E/G8sZF;;IgH9yZE,8B3GyBc;E2GxBd;;EhHkzZF;;IgH1yZE,gC3G8eiC;EiB/e/B;;EAIA;;ItB8yZF,iCgHtyZH;EAZD;;EhHqzZE;;IgHtyZA,+BAAS;EhHyyZT;;EgHpyZA;IhHuyZE,yBAAyB;EgHhyZ7B;;EAEI;;IAEA,6BAOH;EAXD;;EhHwyZE;;IAEE,+BAA+B;EgH3xZnC;;EhH8xZE;;IgHzxZE,gCACH;EhH2xZC;;EgHxxZE;;IAGJ,8BAA8B;EAC1B;;EAQJ;IACI,yB3G0c2C;E2Gzc3C;;EAFJ;;IhHyxZI,6BAA6B;EgH5wZjC;;EAEI;;IAFJ,+BAKY;EhH6wZV;;EgHtwZF;;IAEA,gCAAkB;EACd;;E/ElGJ;;IjC82ZI,8BAA8B;EgCj3ZlC;;EiFKC;I3FKK,2BjByUoD;EiBrUpD;;EtB02ZJ;;IiH/2ZA,+BAKA;EjH62ZA;;EAEA;;IsBn3ZI,iCjBuUoD;EiBnUpD;;EtBo3ZJ;;IiH72ZA,kCACA;EALF;;EjHs3ZE;;IiHr2ZA,gCACA;EjHu2ZA;;EiHh2ZA;IjHm2ZE,yBAAyB;EiH51Z7B;;EAIM;;IAJN,6BACc;EAOX;;EjH41ZD;;IiHn1ZE,+B5Gue8C;E4Gte9C;;EAFJ;;IAOQ,gCAAS;EjHq1Zf;;EiHh1ZF;;IjHo1ZI,8BAA8B;EiH30ZlC;;EAAA;IAIE,2BAAU;EjH40ZV;;EiHh1ZF;;IAcG,+BAAU;EjHu0ZX;;EAEA;;IiH9zZF,iCACc;EACZ;;EAFF;;IAOK,kC5GlGU;E4GmGV;;EARL;;IjH00ZI,gCAAgC;EiH10ZpC;;EjH60ZE;IkH37ZF,yBACkB;EACV;;EAEA;;IAGI,6BAAkB;ElH27Z5B;;EAEA;;IkHp8ZF,+BAiBsB;EACd;;EAEA;;IApBR,gCAwBQ;EACI;;EAEA;;IC5BZ,8BAAY;EACZ;;EADA;IACA,2BAGa;EnHk9ZX;;EAEA;;ImH98ZM,+BAAkB;EnHi9ZxB;;EAEA;;ImH98ZM,iCAA2B;EnHi9ZjC;;EAEA;;ImHj+ZF,kCAqBM;EnH+8ZJ;;EmHz8ZF;;IAGQ,gCAA8C;EAC9C;;EAJR;IAQQ,4BAYH;EApBL;;EnHo9ZE;;ImH37ZM,gCAAgB;EAChB;;EnH+7ZN;;ImH17ZM,kCAWH;EAnBL;;EnHu8ZE;;IoHz/ZF,mCAGa;EACD;;EAEA;;IAEA,iCAAmC;EACnC;;EAEA;IpHy/ZR,0BAA0B;EoHp/Z9B;;EAIY;;ICvBZ,8BAAQ;EACJ;;ECDJ;;IAEC,gCAUA;EAZD;;EAAA;;IAUK,iCACA;EtH4gaH;;EsHrgaD;;IADD,+BAIQ;EtHugaN;;EAEA;IACE,wBAAwB;EsH9/Z5B;;EAEC;;IAGC,4BACA;EANF;;EtHsgaE;;IsHr/ZD,8BjH0YkB;EiHzYlB;;EtHy/ZC;;IsHl/ZG,+BACA;EtHo/ZH;;EsH9+ZD;;IADD,6BAIQ;EtHg/ZN;;EAEA;IACE,wBAAwB;EuHtja5B;;EAGQ;;IAEA,4BAiBH;EAtBL;;EAAA;;IAaY,8BlH8VqB;ELstZ/B;;EAEA;;IuHnkaF,+BAwBO;EAxBP;;EA2BQ;;IA3BR,6BA8BqB;EA9BrB;;EvH6kaE;IuH7kaF,yBAmCiB;EAnCjB;;EvHilaE;;IuHjlaF,6BAyCmB;EACX;;EAIR;;IAGQ,+BACH;EvHuiaH;;EwHxlaD;;IAEA,gCAAoB;EACpB;;EAEA;;IAIC,8BACA;EAXF;;EAAA;IAqBG,2BACA;EAtBH;;EAAA;;IAiCE,+BACA;ExH0kaA;;EyHhnaE;;IzHonaA,iCAAiC;EwHzkapC;;EC1CG;;ID0CH,kCAAsB;EC3CnB;;EzH4naF;;IyH5naE,gCAAwC;EACxC;;ED0CH;IC3CG,0BAAwC;EACxC;;ED0CH;;IC1CG,8BAAkB;EzHuoapB;;EyHxoaE;;IzH4oaA,gCAAgC;EwHjmanC;;EC1CG;;ID0CH,iCAAsB;EC3CnB;;EzHopaF;;IyHppaE,+BAAwC;EACxC;;ED0CH;IC3CG,wBAAwC;EACxC;;ED0CH;;IC1CG,4BAAkB;EzH+papB;;E0HxpaM;;I1H4paJ,8BAA8B;E0HppalC;;EAEI;;IAEA,+BAAmB;EACnB;;EAGJ;;IAEI,6BAOH;EATD;;E1HypaE;I0HlpaK,0BACH;E1HmpaF;;E0H/oaE;;IADJ,8BAIY;E1HipaV;;EAEA;;I2H1qaF,gCAAgB;EACZ;;EAEA;;IAEA,iCAYH;EAjBD;;E3HoraE;;I2HzqaM,+BAAY;E3H4qalB;;EAEA;I2H1qaM,wBACH;E3H2qaH;;E2HtqaM;;IAQJ,4BACa;EACL;;EAFR;;I3HuqaA,8BAA8B;E2Hvqa9B;;E3H0qaF;;I2HxqaU,+BACH;E3H0qaP;;E2H3qaU;;IAFR,6BACa;EACL;;EAFR;IAEQ,wBtHjBM;ELqsahB;;E2HpraU;;IAFR,4BACa;EACL;;EAFR;;I3H+raA,8BAA8B;E2H/ra9B;;E3HksaF;;I2HhsaU,+BACH;E3HksaP;;E4H9uaE;;IAEA,6BvH4qBc;EuH3qBd;;ECJJ;IACI,uBAAkB;EAClB;;EAEA;;IvGQE,2BuGLL;EvGSK;;EtB+uaJ;;I6HnvaF,6BAAU;EACN;;EAEA;;IAEA,8BAAY;EACZ;;E7HuvaF;;I6HlvaE,4BxHSW;EL4uab;;E6HjvaE;I7HovaA,uBAAuB;E8H9wa3B;;E9HixaE;;I8H5waE,2BAAiB;EACjB;;EAEA;;IxGGE,6BwGAL;ExGIK;;EtB4waJ;;I8H9waF,8BAAoB;EACnB;;EAEA;;IAEA,4BAAS;E9HixaR;;E8H3waC;I9H8waC,yBAAyB;EmD/oa7B;;EnDkpaE;;I+HhyaM,6BAAa;EACb;;EAHR;;I/HyyaI,+BAA+B;EgIpzalC;;EhIuzaC;;I+H7xaE,gCCrBW;EACb;;EAGD;;IAEC,8BAKA;EAHA;;EhIozaA;IgI9yaG,uBAAI;EACH;;EApBL;;IhIu0aG,2BAA2B;EgIn0a9B;;EAEC;;IAGD,6BAAe;EACd;;EAGA;;IhIo0aE,8BAA8B;EgI9za7B;;EhIi0aH;;IgIn1aA,4BACA;EhIq1aA;;E+H7zaE;ICpBF,yB3HmBS;ELk0aT;;EgIj1aA;;IAGA,6BAAA;EhIm1aA;;EgI70aG;;IhIi1aD,+BAA+B;EgIp2alC;;EhIu2aC;;I+H70aE,gCCrBW;EACb;;EAGD;;IAEC,8BAKA;EAHA;;EhIo2aA;IgI91aG,uBAAQ;EACP;;EApBL;;IhIu3aG,2BAA2B;EgIn3a9B;;EAEC;;IAGD,6BAAe;EACd;;EAGA;;IhIo3aE,8BAA8B;EgI92a7B;;EhIi3aH;;IgIn4aA,4BACA;EhIq4aA;;E+H72aE;ICpBF,yB3HmBS;ELk3aT;;EgIj4aA;;IAGA,6BAAA;EhIm4aA;;EgI73aG;;IhIi4aD,+BAA+B;EgIp5alC;;EhIu5aC;;I+H73aE,gCCrBW;EACb;;EAGD;;IAEC,8BAKA;EAHA;;EhIo5aA;IgI94aG,0BAAa;EACZ;;EApBL;;IhIu6aG,8BAA8B;EgIn6ajC;;EAEC;;IAGD,gCAAe;EACd;;EAGA;;IhIo6aE,iCAAiC;EgI95ahC;;EhIi6aH;;IgIn7aA,+BACA;EhIq7aA;;E+H75aE;ICpBF,0B3HmBS;ELk6aT;;EgIj7aA;;IAGA,8BAAA;EhIm7aA;;EgI76aG;;IhIi7aD,gCAAgC;EgIp8anC;;EhIu8aC;;I+H76aE,iCCrBW;EACb;;EAGD;;IAEC,+BAKA;EAHA;;EhIo8aA;IgI97aG,wBAAQ;EACP;;EApBL;;IhIu9aG,4BAA4B;EgIn9a/B;;EAEC;;IAGD,8BAAe;EACd;;EAGA;;IhIo9aE,+BAA+B;EgI98a9B;;EhIi9aH;;IgIn+aA,6BACA;EhIq+aA;;E+H78aE;ICpBF,wB3HmBS;ELk9aT;;EgIj+aA;;IAGA,4BAAA;EhIm+aA;;EgI79aG;;IhIi+aD,8BAA8B;EiI9+alC;;EAIY;;IAEA,+BAMH;EAZT;;EjIs/aE;;IiIt+aM,6B5HoV8C;E4HnV9C;;EAEA;IACA,yBAKH;EAzBL;;EjI+/aE;;IiIl+aU,6BACH;EjIo+aP;;EiI/9aU;;IAnCZ,+BAwCM;EAEI;;ElHWN;;IkHCY,gCAWH;EjI28aX;;EAEA;;IiI9gbF,8BAEQ;EjI+gbN;;EAEA;IiInhbF,uBAoDQ;EjIi+aN;;EAEA;;IiIx8ac,2BAAe;EjI28a7B;;EAEA;;IiIn8ac,6BAAU;EjIs8axB;;EAEA;;IAEE,8BiIp8agC;EjIq8alC;;EAEA;;IAEE,4BiIp8a0B;EjIq8a5B;AACF;;AAEA;EACE;IiI7ibF,oBAoDQ;EjI2/aN;;EiI/ibF;;IAwHwB,wBAAoB;EjI47a1C;;EAEA;;IiItjbF,0BAoDQ;EjIqgbN;;EAEA;;IiIl7akB,2BAAY;EAzIhC;;EjIgkbE;;IiIh7akB,yBAAmB;EjIm7arC;;EiInkbF;IAuJgB,0BAAkB;EjIg7ahC;;EiIvkbF;;IAgKQ,8BAAM;EACN;;EAEA;;IAEA,gCAaH;EAlLL;;EAAA;;IAAA,iCAAkB;EjIslbhB;;EejibE;;IkHmIgB,+B5HrKT;ELwkbT;;EAEA;IACE,yBK3kbO;E4HnBX;;EAAA;;IAuMoB,6B5HpLT;E4HnBX;;EjIsmbE;;IAEE,+BAA+B;EiIxmbnC;;EjI2mbE;;IiI3mbF,gCAEQ;EjI4mbN;;EiI9mbF;;IAoOgB,8BAOH;EjIw4aX;;EiInnbF;IA+OY,uBAAO;EjIw4ajB;;EAEA;;IiIr4aU,2BAAa;EjIw4avB;;EAEA;;IiI9nbF,6BA8OQ;EjIm5aN;;EAEA;;IAEE,8BiIt4aiC;EjIu4anC;;EAEA;;IAEE,4BiIr4a2B;EjIs4a7B;;EAEA;IACE,yBiIr4amC;EjIs4arC;;EAEA;;IiIjpbF,6BA8OQ;EjIs6aN;;EAEA;;IiItpbF,+BA8OQ;EjI26aN;;EAEA;;IiI3pbF,gCAwSQ;EjIs3aN;;EAEA;;IiIn3aU,8BAAW;EA7SvB;;EjIqqbE;IiI92aE,uBAAA;EACI;;EjIi3aN;;IiI32aM,2BAAI;EjI82aV;;EAEA;;IiIz2aM,6BAAI;EjI42aV;;EAEA;;IiIv2aU,8BAAU;EjI02apB;;EiIr2aE;;IAEQ,4BAAU;EjIw2apB;;EiIn2aM;IACI,yBAAW;EjIs2arB;;EiIj2aE;;IAEQ,6BAAU;EAGd;;EjIm2aN;;IkIzsbF,+BAAyB;EACrB;;EAEA;;IAEA,gCAAM;EACN;;EANJ;;IlIqtbI,8BAA8B;EmIptblC;;EAEI;IACA,wBAAmB;EAEf;;EnIstbN;;ImI3tbF,4BAkBkB;EnI4sbhB;;EmI9tbF;;IAAA,8BA8BI;EA9BJ;;EnIqubE;;ImIrubF,+BAwCQ;EnIgsbN;;EAEA;;IAEE,6BmI9rb0B;EnI+rb5B;;EAEA;ImItrbM,wBA0CH;EnI8obH;;EAEA;;IAEE,4BmIzpbK;EnI0pbP;;EAEA;;IAEE,8BmI5qb+B;EnI6qbjC;;EAEA;;IAEE,+BmIrqba;EnIsqbf;;EmIhwbF;;IA0GQ,6BAAmB;EnI2pbzB;;EAEA;ImItpbU,0BAAkB;EnIwpb5B;;EAEA;;ImIrpbU,8BAAgB;EnIwpb1B;;EAEA;;IsBjwbI,gCAAgC;EtBowbpC;;EmInxbF;;IAiIgB,iCACH;EAlIb;;EAAA;;IAAA,+BAkJoB;EnI2oblB;;EAEA;ImIzobM,wBAAgB;EnI2obtB;;EAEA;;ImIhobkB,4BAAM;EnImobxB;;EAEA;;ImIhobkB,8BAAe;EnImobjC;;EAEA;;ImI7ybF,+BAAgB;EnIgzbd;;EAEA;;IAEE,6BmIznbiB;EnI0nbnB;;EAEA;IACE,0BmI7nbiB;EnI8nbnB;;EAEA;;IAEE,8BmItnb4B;EnIunb9B;;EAEA;;IAEE,gCmIlnb0C;EnImnb5C;;EAEA;;IAEE,iCmI7mbiB;EnI8mbnB;;EAEA;;IAEE,+BKvla8C;ELwlahD;;EAEA;ImI/0bF,wBAAgB;EnIi1bd;;EAEA;;IAEE,4BmIrmb8C;EnIsmbhD;;EAEA;;IAEE,8BmIjmb6C;EnIkmb/C;;EAEA;;IAEE,+BmIjmbsC;EnIkmbxC;;EAEA;;IAEE,6BmI9lb6E;EnI+lb/E;;EAEA;IACE,0BmI9lbkC;EnI+lbpC;;EAEA;;ImI32bF,8BAAgB;EnI82bd;;EAEA;;IAEE,gCmIhtb+B;EnIitbjC;;EAEA;;IAEE,iCmIhtbgC;EnIitblC;;EAEA;;IAEE,+BmI9sbiB;EnI+sbnB;;EAEA;IACE,2BmI5sboC;EnI6sbtC;;EAEA;;IAEE,+BmI7sbwC;EnI8sb1C;;EAEA;;IAEE,iCmIxsbiB;EnIysbnB;;EAEA;;IAEE,kCmIjsb2B;EnIksb7B;;EAEA;;IAEE,gCK/pa8C;ELgqahD;;EAEA;IACE,yBmI/rbqB;EnIgsbvB;;EAEA;;IAEE,6BmI75bY;EnI85bd;;EAEA;;IAEE,+BK54bc;EL64bhB;;EAEA;;IAEE,gCmInrbyB;EnIorb3B;;EAEA;;IAEE,8BmIhrbuC;EnIirbzC;;EAEA;IACE,uBKjob0B;ELkob5B;;EAEA;;IAEE,2BmIr7bY;EnIs7bd;;EAEA;;IAEE,6BmI3qbwC;EnI4qb1C;;EAEA;;ImI77bF,8BAAgB;EnIg8bd;;EAEA;;IAEE,4BmI/xb2B;EnIgyb7B;;EAEA;IACE,uBmI7qbS;EnI8qbX;;EAEA;;IAEE,2BmI3xb0C;EnI4xb5C;;EAEA;;ImIzxbsB,6BpHhID;Ef45brB;;EAEA;;IAEE,8BmIv9bY;EnIw9bd;;EAEA;;IAEE,4BmIpxb2C;EnIqxb7C;;EAEA;IACE,wBmIhxboC;EnIixbtC;;EAEA;;IAEE,4BmI3wbiB;EnI4wbnB;;EAEA;;IAEE,8BKrva8C;ELsvahD;;EAEA;;IAEE,+BmIzvbiB;EnI0vbnB;;EAEA;;IAEE,6BmInwb8C;EnIowbhD;;EAEA;IACE,qBmI/vb2B;EnIgwb7B;;EAEA;;IAEE,yBmI/vbsC;EnIgwbxC;;EAEA;;IAEE,2BmI5vb6E;EnI6vb/E;;EAEA;;IAEE,4BmIvgcY;EnIwgcd;;EAEA;;IAEE,0BmIrvb2F;EpHhO3F;;Efw9bF;IACE,2BmI92b+B;EnI+2bjC;;EAEA;;IAEE,+BmI92bgC;EnI+2blC;;EAEA;;IAEE,iCmI52biB;EnI62bnB;;EAEA;;IAEE,kCmI12bmC;EnI22brC;;EAEA;;IAEE,gCmIz2biB;EpHpIjB;;Efg/bF;IACE,0BmIv2bkC;EnIw2bpC;;EAEA;;IAEE,8BmI/1b2B;EnIg2b7B;;EAEA;;IAEE,gCK7za8C;EL8zahD;;EAEA;;IAEE,iCmIvjcY;EnIwjcd;;EAEA;;IAEE,+BmIr1biB;EnIs1bnB;;EAEA;IACE,wBK1icO;EL2icT;;EAEA;;IAEE,4BKtxb0B;ELuxb5B;;EAEA;;IAEE,8BmI90buC;EnI+0bzC;;EAEA;;IAEE,+BmI/kcY;EnIglcd;;EAEA;;IAEE,6BmI30buC;EnI40bzC;;EAEA;IACE,0BmIz0bwC;EnI00b1C;;EAEA;;ImI3lcF,8BAAgB;EnI8lcd;;EAEA;;IAEE,gCmI77b2B;EnI87b7B;;EAEA;;IAEE,iCmIvmcY;EnIwmcd;;EAEA;;IAEE,+BmIz7bwC;EnI07b1C;;EAEA;ImIx7bsB,wBpHhIZ;Ef0jcV;;EAEA;;IAEE,4BmIrncY;EnIsncd;;EAEA;;IAEE,8BmIj7biB;EnIk7bnB;;EAEA;;IAEE,+BmI96bwC;EnI+6b1C;;EAEA;;IAEE,6BmIpocY;EnIqocd;;EAEA;IACE,0BKn5a8C;ELo5ahD;;EAEA;;IAEE,8BmIv5biB;EnIw5bnB;;EAEA;;IAEE,gCmIj6b8C;EnIk6bhD;;EAEA;;IAEE,iCK1kcmB;EL2kcrB;;EAEA;;IAEE,+BmI75buC;EnI85bzC;;EAEA;IACE,yBmI15boC;EnI25btC;;EAEA;;IAEE,6BmIrqcY;EnIsqcd;;EAEA;;IAEE,+BmIj5biB;EnIk5bnB;;EmIj4bkB;;IALpB,gCAEY;EAMQ;;EpHtPhB;;IoHmPgB,8BACH;EANjB;;EnIk5bE;IehocE,yBAAwB;EoH8O5B;;EAAA;;InIw5bI,6BAA6B;Eetoc7B;;EfyocF;;ImIn5bkB,+BACH;EnIq5bf;;EmI95bF;;IAAA,gCAEY;EnIi6bV;;EmIp5bF;;I7GzSM,8B6G6SD;E7GzSC;;EtBgscJ;IACE,2BAA2B;EmI55b/B;;E7GzSM;;I6GySN,+BAKoB;EnI65blB;;Ee/pcE;;IoH4QY,iCACH;EALb;;EnI85bE;;ImI34bE,kCAAa;EACb;;EnI+4bF;;ImIj5bF,gCASyB;EnI24bvB;;EmIp5bF;IAgBM,yBACD;EAjBL;;EAAA;;IAAA,6BA2BiB;EnIk4bf;;EmI73bF;;InIi4bI,+BAA+B;EmI13bnC;;EAIY;;IAJZ,gCAMQ;EACE;;EAPV;;I7G7WM,8B6G2XG;E7GvXH;;EtBgvcJ;IACE,2BAA2B;EmIx4b/B;;EAkBU;;IAlBV,+BAqBkB;EACR;;EAKV;;IAAA,iCAIQ;EAJR;;EnI03bE;;ImI12bkB,kCACH;EnI42bf;;EmIv2bU;;IAXZ,gCAAsB;EAeV;;EAKZ;IAKoB,yBACH;EnIi2bf;;EmI51bU;;IAXZ,6BAcQ;EACI;;EpH7XR;;IoHuYI,+BAKH;EnIm1bH;;EmIh5bF;;InIo5bI,gCAAgC;EmI50bpC;;EAEI;;I7G9cE,8BAAgC;EtB8xcpC;;EAEA;IACE,2BAA2B;EmI/0b/B;;EAAA;;IAKQ,+BAAkB;EnIg1bxB;;EAEA;;ImI50bM,iCAAkB;EnI+0bxB;;EAEA;;IAEE,kCmIh1bC;EnIi1bH;;EmI70bE;;IAEA,gCAAc;EACd;;EnIi1bF;IACE,4BAA4B;EmI30bhC;;EnI80bE;;ImIv0bE,gCAuBH;EAxBD;;EAAA;;IAegB,kCACH;EAhBb;;EnIk1bE;;IoIt1cF,mCACiB;EACT;;E9GUF;;IAIA,iCAAgC;EtB80cpC;;EoI91cF;IAQY,0BAAkB;EpI01c5B;;EAEA;;IoIr1cM,8B/HsvByC;E+HrvBzC;;E9GJF;;I8GZN,gCAckB;EpI81chB;;EoI52cF;;IpIg3cI,iCAAiC;EoIh3crC;;EpIm3cE;;IoI50cM,+B/HsCQ;E+HrCR;;EAHR;IAOQ,wB/HouBoC;EL0mb1C;;EoI10cM;;IAGI,4B/H6tBgC;EL+mb1C;;EoIt0cU;;IpI00cR,8BAA8B;EoIp0clC;;EAGQ;;IAHR,+BAMI;EACI;;EAPR;;IAAA,6BAUI;EpIq0cF;;EoI/0cF;IAoBY,wB/HksBsD;E+HjsBtD;;ErHfR;;IqHuBI,4BAAa;EpI2zcnB;;EAEA;;IoI9zcE,8BAAe;EpIi0cjB;;Eev1cE;;If21cA,+BoI7zcK;EpI8zcP;;EAEA;;IoIn6cF,6BAiHe;EpIqzcb;;EAEA;IACE,yBoInzcuB;EpIozczB;;EAEA;;IoIhzcE,6BACgB;EpIkzclB;;Ee12cE;;IqHgEY,+BACH;EAJT;;EpIozcF;;IoIpycE,gCAEI;EpIqycN;;EAEA;;IAEE,8BoIjycwB;EpIkyc1B;;EAEA;IACE,2BoIjycuB;EpIkyczB;;EAEA;;IoIlzcE,+BAuBe;EpI8xcjB;;EAEA;;IoIlxcU,iCAMH;EpI+wcP;;EAEA;;IoI1wcc,kCAAa;EpI6wc3B;;EoItwcE;;IAIY,gCACH;EpIswcX;;EqIn9cM;IACA,0BAAoB;EACpB;;EAJR;;IAUY,8BAAgB;EAChB;;EAEA;;IAEA,gCAAU;EACV;;EAEA;;IAEA,iCACH;ErIm9cP;;EqI98cU;;IrIk9cR,+BAA+B;EqI5+cnC;;EAmCgB;IACA,wBAAW;ErI68czB;;EqIz8cc;;IrI68cZ,4BAA4B;EqIr/chC;;EAiDY;;IAEA,8BAA8B;EAC9B;;EApDZ;;IAyDY,+BAAU;EACV;;EAEA;;IrIw8cR,6BAA6B;EqIpgdjC;;EAmEQ;IrIq8cJ,0BAA0B;EqI/7c1B;;ErIk8cF;;IqI77cU,8BAAY;EAGhB;;ErI+7cN;;IqIz7cE,gCAAU;EACN;;EAIA;;IAEI,iCAA6B;ErI07cvC;;EsIthdE;;IAKJ,+BAAU;EACN;;EtIuhdF;IsIphdM,wBAAwB;EAG5B;;EtIqhdF;;IsI/gdF,4BAAU;EACN;;EtImhdF;;IsI7gdI,8BAAA;EtIghdJ;;EAEA;;IuI5idE,+BAAS;EACT;;EAFJ;;IAAA,6BrISiB;EqITjB;;EAAA;IAOQ,wBAAkB;EvIkjdxB;;EAEA;;Iev/cE,4BAA2B;Ef0/c7B;;EAEA;;IAEE,8BuIzidQ;EvI0idV;;EAEA;;IAEE,+BuIxidS;EA/Bb;;EAAA;;IvI4kdI,6BAA6B;EuI9hdjC;;EvIiidE;IwI5kdF,uBAAa;EACT;;E7HmBA;;IADA,2B6HdgC;ExI8kdlC;;EAEA;;IkChldF,6BsGQU;EACN;;ExI4kdF;;IwIrkdM,8BAAkB;ExIwkdxB;;EyI9ldF;;IzIkmdI,4BAA4B;EkChidhC;;EuG3DQ;IACA,uBAAgB;EAChB;;EAEA;;IAXR,2BAcgB;EzI8ldd;;EkC1idF;;IuG7CQ,6BpIFO;EoIGP;;E1H4CJ;;I0HvCQ,8BACH;EzI0ldP;;EyIrldE;;IzIyldA,4BAA4B;EyI/kdhC;;EAGQ;IACA,yBAAW;EACX;;EAEA;;IAPR,6BAWQ;EACI;;EnG9BZ;;ItC+mdI,+BAA+B;E0I1odnC;;EAOQ;;IAEA,gCAAuB;EACvB;;EAEA;;IAEN,8BAAY;EACZ;;EAOF;IAAA,uBAGQ;EACI;;EAEA;;IAKZ,2BAEQ;EAFR;;EAKY;;I1I4ndR,6BAA6B;EsDvqdjC;;EtD0qdE;;I2IhqdD,8BACA;E3IkqdC;;E4I3qdD;;IAGC,4BvI6EqB;ELgmdrB;;EAEA;I4IhrdD,yBAAA;E5IkrdC;;EAEA;;I4IlqdC,6BvI4DoB;EuIxDrB;;EAKA;;I5IgqdE,+BAA+B;E2I9qd/B;;ECbH;;IAEC,gCACA;EAED;;EALA;;IAYC,8BADA;E5I2rdA;;EAEA;I4IlrdA,uBADA;E5IqrdA;;EAEA;;I2I/rdE,2BAAmB;ECftB;;E5ImtdC;;I4I5sdD,6BAAc;E5I+sdb;;EAEA;;I4IzsdC,8BACA;EAGD;;EAKA;;IAKA,4BADA;E5IosdA;;E2IjtdE;ICfH,yBvIyDgB;EuIvDhB;;E5IoudC;;I4I9tdA,6BACA;EAPD;;EAYC;;IAKA,+BAAA;E5I2tdA;;EAEA;;I4IltdC,gCACA;E5IotdD;;E4InvdD;;IAGC,8BvImDe;ELksdf;;EAEA;I4IxvdD,0BAAA;E5I0vdC;;EAEA;;I4I1udC,8BACA;EAGD;;EAKA;;I5IwudE,gCAAgC;E2ItvdhC;;ECbH;;IAEC,iCACA;EAED;;EALA;;IAYC,+BAAA;E5IkwdA;;EAEA;I4I1vdA,0BADA;E5I6vdA;;EAEA;;I2IvwdE,8BAAmB;ECftB;;E5I2xdC;;I4IpxdD,gCAAc;E5Iuxdb;;EAEA;;I4IjxdC,iCACA;EAGD;;EAKA;;IAKA,+BAAA;E5I2wdA;;E2IzxdE;ICfH,wBvIiCiB;EuI/BjB;;E5I4ydC;;I4ItydA,4BACA;EAPD;;EAYC;;IAKA,8BAAA;E5ImydA;;EAEA;;I4I1xdC,+BACA;E5I4xdD;;E4I3zdD;;IAGC,6BvI4EqB;ELivdrB;;EAEA;I4Ih0dD,wBAAA;E5Ik0dC;;EAEA;;I4IlzdC,4BvI2DoB;EuIvDrB;;EAKA;;I5IgzdE,8BAA8B;E2I9zd9B;;ECbH;;IAEC,+BACA;EAED;;EALA;;IAYC,6BAAA;E5I00dA;;EAEA;I4Il0dA,yBADA;E5Iq0dA;;EAEA;;I2I/0dE,6BAAmB;ECftB;;E5Im2dC;;I4I51dD,+BAAc;E5I+1db;;EAEA;;I4Iz1dC,gCACA;EAGD;;EAKA;;IAKA,8BADgB;E5Io1dhB;;E2Ij2dE;ICfH,uBvIwFqC;EuItFrC;;E5Io3dC;;I4I92dA,2BACA;EAPD;;EAYC;;IAKA,6BADA;E5I42dA;;EAEA;;I4Il2dC,8BACA;E5Io2dD;;E6I73dE;;I7Ii4dA,4BAA4B;E8Cj4dhC;A9Cm4dA;;AAEA;E6I13dI;IACA,oBxIQO;EwIPP;;E7I63dF;;I6Ix3dM,wBAAkB;E7I23dxB;;EAEA;;IAEE,0BAA0B;E6Ip3d9B;;E7Iu3dE;;I6Il3dE,2BACH;E7Io3dC;;E6I/2dE;;IAEA,yBAAe;EACf;;E/FhCJ;I+FoCI,0BAAgB;EAChB;;E7Ik3dF;;I6I72dE,8BAAoB;EACpB;;EAEA;;IAGJ,gCACS;EACD;;EAEA;;IAEA,iCAAyB;EACzB;;EAEA;;IAIR,+BAAqB;EACjB;;E7I62dF;I6I12dM,yBxIpDU;ELg6dhB;;EAEA;;I8Ih8dE,6BACD;E9Ik8dD;;E8I/7dE;;IANA,+BAWW;EACT;;EAZN;;IAgBM,gCACD;E9I87dH;;E8I37dI;;IAEA,8BACD;E9I67dH;;E8I17dI;I9I67dF,uBAAuB;E8Iv9d3B;;E9I09dE;;I8Iz7dI,2BACD;E9I27dH;;E8Iz7dI;;IApCF,6BAsCe;EACb;;EAvCN;;IAAA,8BA2CM;E9I47dJ;;E8Iv+dF;;IAoDI,4BACD;E9Iu7dD;;E8Ip7dE;I9Iu7dA,yBAAyB;ECp+d7B;;EDu+dE;;I8Il7dE,6BACD;E9Io7dD;;E8Ir/dF;;IAAA,+BAsEuB;E9Io7drB;;EAEA;;I8I56dI,gCACD;EAjFL;;E9IigeE;;I8IjgeF,8BAyF+B;E9I26d7B;;EAEA;I8Ix6dI,uBACD;EA/FL;;EAAA;;I9I4geI,2BAA2B;E+Itge/B;;EAEI;;IAEA,6BAAQ;EACR;;EAEA;;IAEA,8BAMH;EAfD;;E/ImheE;;I+IlgeF,4BAAe;EACX;;EADJ;IAKQ,yBACH;E/ImgeH;;E+I//dE;;IADJ,6BAIQ;E/IigeN;;E+I5/dF;;I/IggeI,+BAA+B;E+I1/dnC;;EhIaI;;Ifk/dA,gC+Iz/dH;E/I0/dC;;EgJ7ieE;;IAEA,8BAgHH;EApHD;;EhJsjeE;IgJ7ieM,wBAAa;EhJ+ienB;;EAEA;;IAEE,4BgJ7ie4B;EhJ8ie9B;;EAEA;;IAEE,8BgJ7iekB;EhJ8iepB;;EAEA;;IAEE,+BgJ5iemC;EhJ6ierC;;EAEA;;IAEE,6BgJ1ieoB;EhJ2ietB;;EAEA;IACE,wBKvhea;ELwhef;;EAEA;;IAEE,4BgJpieqB;EhJqievB;;EAEA;;IAEE,8BgJliekB;EhJmiepB;;EAEA;;IAEE,+BgJxleA;EhJyleF;;EAEA;;IAEE,6BgJ3heS;EhJ4heX;;EAEA;IACE,0BgJjmeA;EhJkmeF;;EAEA;;IAEE,8BgJrheS;EhJsheX;;EAEA;;IAEE,gCgJlhekB;EhJmhepB;;EAEA;;IAEE,iCgJhneA;EhJineF;;EAEA;;IAEE,+BgJ5geiB;EhJ6genB;;EsB5meI;IAIA,wBAAQ;EtB4meZ;;EAEA;;IiJrneE,4BAAiB;EACjB;;EAFJ;;IAOQ,8BAAkB;EjJunexB;;EiJ9neF;;IjJkoeI,+BAA+B;EiB1oenC;;EiIMQ;;IAEA,6B7I0c+B;E6Izc/B;;ElJyoeN;IkJ/oeF,0BAUO;EACC;;EAXR;;IAiBY,8BAAY;EACZ;;EnEiFR;;ImE3EI,gC7I6b8B;E6I5b9B;;EAzBR;;IAkCY,iCACH;ElJ6neP;;EkJrneU;;IA3CZ,+BA8Cc;ElJuneZ;;EiB7jeF;IiI/CY,wB7IrCM;E6IsCN;;ElJineV;;IkJrmeF,4BACO;E5H9DD;;EtBuqeJ;;IAEE,8BAA8B;EkJnmelC;;EAGQ;;IlJqmeJ,+BAA+B;EkJxmenC;;EAYoB;;IAZpB,6BAiBgB;EAjBhB;;ElJgneE;IkJnleF,0BACW;EACH;;EAFR;;IAOY,8BACH;ElJkleP;;EkJzkeM;;IChIR,gCAAc;EACV;;EAEA;;IAGI,iCACH;EnJ4seH;;EmJvseM;;IAIR,+BACkB;EACV;;EClBR;IAEQ,2BACH;EpJyteH;;EoJptec;;IpJwteZ,+BAA+B;EoJhuenC;;EAkBgB;;ICjBhB,iCAAU;EACN;;ErJsueF;;IqJ/teM,kCAAM;ErJkueZ;;EAEA;;IqJ3teF,gCACK;EACG;;EAIR;IAEQ,yBAAoB;ErJ0te1B;;EqJnteE;;IADJ,6BAIY;ErJqteV;;EAEA;;IqJhteM,+BACH;EAZL;;ErJgueE;;IqJ1seE,gCAAkB;EAClB;;EAEA;;IAEA,8BAAW;EACX;;EAIA;IACA,uBAAW;EACX;;EAEA;;IAGI,2BACH;ErJyseH;;EqJrseE;;IrJyseA,6BAA6B;EqJrsejC;;EAEI;;IrJwseA,8BAA8B;EqJpselC;;EAEI;;IrJuseA,4BAA4B;EqJnsehC;;EAEI;IACA,uBACH;ErJoseC;;EqJhseE;;IAEA,2BAAkB;EAClB;;EAJJ;;IASQ,6BAAc;ErJksepB;;EqJ7reF;;IrJiseI,8BAA8B;Ee1ve9B;;Ef6veF;;IqJhweF,4BAwEmB;ErJ2rejB;;EAEA;IqJzseF,wBAqBmB;ErJsrejB;;EAEA;;IqJ3qec,4BACH;ErJ6qeX;;EAEA;;IqJlreM,8BAAC;ErJqreP;;EAEA;;IqJrrec,+BACH;ErJureX;;EAEA;;IqJ5reM,6BAA0B;ErJ+rehC;;EAEA;IqJjseM,qBAAA;ErJmseN;;EAEA;;IqJ3reF,yBACa;EACL;;EAFR;;IrJkseI,2BAA2B;EqJlse/B;;ErJqseE;;IqJrseF,4BASI;ErJ+reF;;EqJpreF;;IrJwreI,0BAA0B;EsJp2e5B;;EAED;IACA,2BACA;EtJq2eC;;EsJl2eD;;IAEA,+BjJgZgC;EiJ/YhC;;EtJs2eC;;IsJ/1eF,iCAAa;EACZ;;ECrBD;;IAGE,kCACA;EvJu3eA;;EuJp3eA;;IAPF,gCAUQ;EACN;;EAXF;IAeE,0BACA;EvJo3eA;;EwJl4eF;;IAEA,8BACM;EACJ;;ExJq4eA;;IyJv4eD,gCACA;EzJy4eC;;EyJt4eD;;IAEA,iCpJwXsC;EoJvXtC;;EAMD;;IAEC,+BAAsB;EACtB;;EAEA;IzJq4eG,wBAAwB;EyJl4e5B;;EAEC;;IAEA,4BACA;EzJm4eC;;EyJh4eD;;IAEA,8BpJyUgC;EoJxUhC;;EzJo4eC;;IyJ/3eA,+BAAY;EzJk4eZ;;EAEA;;IAEE,6BAA6B;EyJx3ejC;;EAEC;IACA,0BAAmB;EACnB;;E/F7DG;;I1D07eA,8BAA8B;E0Dv7e7B;;EACD;;I1D27eA,gCAAgC;E0D/7ehC;;E1Dk8eF;;I0D97eE,iCxCUK;EwCVL;;E1Dm8eF;;I0Dt8eM,+BAAyB;E1Dy8e/B;;E0Dt8eE;IAAA,wBxCWM;EwCTE;;EANR;;I1Dk9eA,4BAA4B;E0D/8e3B;;EACD;;I1Dm9eA,8BAA8B;E0Dv9e9B;;E1D09eF;;I0Dt9eE,+BxCUK;EwCVL;;E1D29eF;;I0D99eM,6BAAyB;E1Di+e/B;;E0D99eE;IAAA,0BxCWM;EwCTE;;EANR;;I1D0+eA,8BAA8B;E0Dv+e7B;;EACD;;I1D2+eA,gCAAgC;E0D/+ehC;;E1Dk/eF;;I0D9+eE,iCxCUK;EwCVL;;E1Dm/eF;;I0Dt/eM,+BAAyB;E1Dy/e/B;;E0Dt/eE;IAAA,yBxCWM;EwCTE;;EANR;;I1DkgfA,6BAA6B;E0D//e5B;;EACD;;I1DmgfA,+BAA+B;E0Dvgf/B;;E1D0gfF;;I0DtgfE,gCxCUK;EwCVL;;E1D2gfF;;I0D9gfM,8BAAyB;E1Dihf/B;;E0D9gfE;IAAA,yBxCWM;EwCTE;;EANR;;I1D0hfA,6BAA6B;E0Dvhf5B;;EACD;;I1D2hfA,+BAA+B;E0D/hf/B;;E1DkifF;;I0D9hfE,gCxCUK;EwCVL;;E1DmifF;;I0DtifM,8BAAyB;E1Dyif/B;;E0DtifE;IAAA,2BxCWM;EwCTE;;EAMR;;I1DsifA,+BAA+B;E0Dtif/B;;E1DyifF;;I0DxifM,iCAAY;E1D2iflB;;E0D3ifM;;IADJ,kCAAW;EACP;;EADJ;;I1DqjfA,gCAAgC;E0DrjfhC;;E1DwjfF;I0DxjfE,yBAAW;EACP;;EADJ;;I1D8jfA,6BAA6B;E0D9jf7B;;E1DikfF;;I0DhkfM,+BAAY;E1DmkflB;;E0DnkfM;;IADJ,gCAAW;EACP;;EADJ;;I1D6kfA,8BAA8B;E0D7kf9B;;E1DglfF;I0DhlfE,2BAAW;EACP;;EADJ;;I1DslfA,+BAA+B;E0Dtlf/B;;E1DylfF;;I0DxlfM,iCAAY;E1D2lflB;;E0D3lfM;;IADJ,kCAAW;EACP;;EADJ;;I1DqmfA,gCAAgC;E0DrmfhC;;E1DwmfF;I0DxmfE,yBAAW;EACP;;EADJ;;I1D8mfA,6BAA6B;E0D9mf7B;;E1DinfF;;I0DhnfM,+BAAY;E1DmnflB;;E0D7mfM;;IAEH,gCAAA;EACD;;EAEQ;;IANR,8BAAW;EACP;;EAEH;IACD,2BxCRD;EwCQC;;E1D0nfF;;I0D7nfM,+BAAkB;E1DgofxB;;E0D7nfE;;IAEQ,iCAAkB;E1Dgof5B;;E0DrofM;;IAEH,kCAAA;EACD;;EAEQ;;IANR,gCAAW;EACP;;EAEH;IACD,4BxCRD;EwCQC;;E1DkpfF;;I0DrpfM,gCAAkB;E1DwpfxB;;E0DrpfE;;IAEQ,kCAAkB;E1Dwpf5B;;E0D7pfM;;IAEH,mCAAA;EACD;;EAEQ;;IANR,iCAAW;EACP;;EAEH;IACD,0BxCRD;EwCQC;;E1D0qfF;;I0D7qfM,8BAAkB;E1DgrfxB;;E0D7qfE;;IAEQ,gCAAkB;E1Dgrf5B;;E0DrrfM;;IAEH,iCAAA;EACD;;EAEQ;;IANR,+BAAW;EACP;;EAEH;IACD,wBAAM;EAAN;;E1DksfF;;I0DrsfM,4BAAkB;E1DwsfxB;;E0DrsfE;;IAEQ,8BAAkB;E1Dwsf5B;;E0D/tfM;;IAEH,+BAAA;EACD;;EAEQ;;IANR,6BAAW;EACP;;EAEH;IACD,wBxCUD;EwCVC;;E1D4ufF;;I0D/ufM,4BAAyB;E1Dkvf/B;;E0D/ufE;;IAEQ,8BAAsC;E1DkvfhD;;E0DvvfM;;IAEH,+BAAA;EACD;;EAEQ;;IANR,6BAAW;EACP;;EAEH;IACD,yBxCUK;EwCVL;;E1DowfF;;I0D3vfM,6BAAY;E1D8vflB;;E0D9vfM;;IADJ,+BAAW;EACP;;EADJ;;I1DwwfA,gCAAgC;E0DxwfhC;;E1D2wfF;;I0D1wfM,8BAAY;E1D6wflB;;E0D7wfM;I1DgxfJ,2BAA2B;E0Djxf3B;;E1DoxfF;;I0DnxfM,+BAAY;E1DsxflB;;E0DtxfM;;IADJ,iCAAW;EACP;;EADJ;;I1DgyfA,kCAAkC;E0JvwflC;;E1J0wfF;;I0JrwfM,gCACH;E1JuwfH;;E0J5wfM;I1J+wfJ,0BAA0B;E0J5wf1B;;E1J+wfF;;I0JlxfM,8BACH;E1JoxfH;;E0JjxfM;;IALJ,gCAAiB;EACb;;EAGJ;;I1J2xfA,iCAAiC;E0J/xfjC;;E1JkyfF;;I0J7xfM,+BACH;E1J+xfH;;E0JpyfM;I1JuyfJ,wBAAwB;E0JpyfxB;;E1JuyfF;;I0J1yfM,4BACH;E1J4yfH;;E0JzyfM;;IALJ,8BAAiB;EACb;;EAGJ;;I1JmzfA,+BAA+B;E0Jvzf/B;;E1J0zfF;;I0JrzfM,6BACH;E1JuzfH;;E0J5zfM;I1J+zfJ,0BAA0B;E0J5zf1B;;E1J+zfF;;I0Jl0fM,8BACH;E1Jo0fH;;E0Jj0fM;;IALJ,gCAAiB;EACb;;EAGJ;;I1J20fA,iCAAiC;E0Jt0frC;;E1Jy0fE;;I2Jn3fE,+BA8BH;EA/BD;;E3Jy3fE;I2Jn3fM,wBAAe;E3Jq3frB;;EAEA;;I2Jh3fM,4BAAS;E3Jm3ff;;EAEA;;I2Jl4fF,8BAoBmB;E3Ji3fjB;;EAEA;;I2Jv4fF,+BA0BqB;E3Jg3fnB;;EAEA;;I4J14fD,6BAAW;EACX;;E5J84fC;IACE,wBAAwB;E4Jr4f5B;;E5Jw4fE;;I4Jn4fD,4BAAW;E5Js4fV;;E4J/3fE;;IAGA,8BAAG;E5Ji4fL;;EAEA;;I4J33fF,+BAAU;EACN;;EAGA;;IAGA,6BAAI;E5J43fN;;E4Jv3fF;IACM,uBAAA;E5J03fJ;;EAEA;;I4Jr3fM,2BAA0B;E5Jw3fhC;;E6J16fM;;I7J86fJ,6BAA6B;E6Jj7fjC;;E7Jo7fE;;I8Jv7fE,8BAAc;EACd;;E9J27fF;;I+J37fE,4BACH;E/J67fC;;E+J37fE;I/J87fA,uBAAuB;E+J57f3B;;E/J+7fE;;I+J37fE,2BACH;E/J67fC;;E+J37fE;;IAEJ,6BAAW;EACP;;EAEJ;;I/J+7fI,8BAA8B;E+J57flC;;E/J+7fE;;I+J37fE,4BACH;E/J67fC;;E+J37fE;I/J87fA,yBAAyB;EgK39f7B;;EhK89fE;;IgKz9fE,6BACH;EhK29fC;;EiK79fA;;IAED,+BAAgB;EACf;;EAED;;IjKi+fG,gCAAgC;EiK99fnC;;EjKi+fC;;IiKz+fA,8BACA;EjK2+fA;;EiKz+fA;IjK4+fE,uBAAuB;EiK1+f1B;;EjK6+fC;;IiKz+fA,2BACA;EjK2+fA;;EiKr/fA;;IAED,6BAAgB;EACf;;EAED;;IjKy/fG,8BAA8B;EiKt/fjC;;EjKy/fC;;IiKjggBA,4BACA;EjKmggBA;;EiKjggBA;IjKoggBE,yBAAyB;EiKlggB5B;;EjKqggBC;;IiKjggBA,6BACA;EjKmggBA;;EiK7ggBA;;IAED,+BAAgB;EACf;;EAED;;IjKihgBG,gCAAgC;EiK9ggBnC;;EjKihgBC;;IiKzhgBA,8BACA;EjK2hgBA;;EiKzhgBA;IjK4hgBE,uBAAuB;EiK1hgB1B;;EjK6hgBC;;IiKzhgBA,2BACA;EjK2hgBA;;EiKrigBA;;IAED,6BAAgB;EACf;;EAED;;IjKyigBG,8BAA8B;EiKtigBjC;;EjKyigBC;;IiKjjgBA,4BACA;EjKmjgBA;;EiKjjgBA;IjKojgBE,yBAAyB;EiKljgB5B;;EjKqjgBC;;IiKjjgBA,6BACA;EjKmjgBA;;EiK7jgBA;;IAED,+BAAgB;EACf;;EAED;;IjKikgBG,gCAAgC;EiK9jgBnC;;EjKikgBC;;IiKzkgBA,8BACA;EjK2kgBA;;EiKzkgBA;IjK4kgBE,0BAA0B;EiK1kgB7B;;EjK6kgBC;;IiKzkgBA,8BACA;EjK2kgBA;;EiKrlgBA;;IAED,gCAAgB;EACf;;EAED;;IjKylgBG,iCAAiC;EiKtlgBpC;;EjKylgBC;;IiKjmgBA,+BACA;EjKmmgBA;;EiKjmgBA;IjKomgBE,0BAA0B;EiKlmgB7B;;EjKqmgBC;;IiKjmgBA,8BACA;EjKmmgBA;;EiK7mgBA;;IAED,gCAAgB;EACf;;EAED;;IjKingBG,iCAAiC;EiK9mgBpC;;EjKingBC;;IiKzngBA,+BACA;EjK2ngBA;;EiKzngBA;IjK4ngBE,wBAAwB;EiK1ngB3B;;EjK6ngBC;;IiKzngBA,4BACA;EjK2ngBA;;EiKrogBA;;IAED,8BAAgB;EACf;;EAED;;IjKyogBG,+BAA+B;EiKtogBlC;;EjKyogBC;;IiKjpgBA,6BACA;EjKmpgBA;;EiKjpgBA;IjKopgBE,wBAAwB;EiKlpgB3B;;EjKqpgBC;;IiKjpgBA,4BACA;EjKmpgBA;;EiK7pgBA;;IAED,8BAAgB;EACf;;EAED;;IjKiqgBG,+BAA+B;EiK9pgBlC;;EjKiqgBC;;IiKzqgBA,6BACA;EjK2qgBA;;EiKzqgBA;IjK4qgBE,yBAAyB;EiK1qgB5B;;EjK6qgBC;;IiKzqgBA,6BACA;EjK2qgBA;;EiKrrgBA;;IAED,+BAAgB;EACf;;EAED;;IjKyrgBG,gCAAgC;EiKtrgBnC;;EjKyrgBC;;IiKnrgBD,8BAAS;EACT;;EClBD;IAEQ,uB7J6UkD;EL43fxD;;EkKlsgBD;;IAGD,2BAAqB;EACpB;;EAGD;;IlKosgBI,6BAA6B;EkKhsgBjC;;ElKmsgBE;;ImKvtgBD,8BACA;EnKytgBC;;EoK1tgBE;;IrJuDA,4BAAwB;EqJnDxB;ApK4tgBJ;;AezqgBI;EqJ9CA;IACI,oBACH;EpK0tgBH;;EoKvtgBE;;IpK2tgBA,wBAAwB;EoKttgB5B;;EpKytgBE;;IoKvsgBE,0BAAS;EpK0sgBX;;EAEA;;IoKrsgBM,2BAAe;EAEnB;;EAGA;;IAGA,yBAAS;EpKqsgBX;;EAEA;IoKjsgBE,0BAAS;EpKmsgBX;;EAEA;;IoK9rgBM,8BAAe;EAMnB;;EAGA;;IAGA,gCAAQ;EpK0rgBV;;EAEA;;IoKrrgBM,iCACH;EACD;;EAGA;;IAGA,+BAAQ;EpKqrgBV;;EAEA;IoKjrgBE,yBAAQ;EpKmrgBV;;EqKxxgBF;;IrK4xgBI,6BAA6B;EqK3xgBjC;;ErK8xgBE;;IqK7xgBiB,+BAA+B;ErKgygBhD;;EqK/xgBiB;;IACnB,gCAAiB;EAAE;;EACnB;;IrKsygBI,8BAA8B;EqKrygBlC;;ErKwygBE;IqKnygBF,uBAAgB;EAAE;;EAClB;;IrKwygBI,2BAA2B;EqKnygB/B;;ErKsygBE;;IqKrygBS,6BAAmC;ErKwygB5C;;EqKvygBS;;IACX,8BAAS;EAAE;;EAKX;;IrK0ygBI,4BAA4B;EqKzygBhC;;ErK4ygBE;IqK3ygBF,yBAAQ;EAAE;;EACV;;IrKgzgBI,6BAA6B;EqK/ygBjC;;ErKkzgBE;;IqKjzgBQ,+BAAoB;ErKozgB5B;;EqKnzgBQ;;IACV,gCAAQ;EAAE;;EACV;;IrK0zgBI,8BAA8B;EqKrzgBlC;;ErKwzgBE;IqKvzgBF,uBAAO;EAAE;;EACT;;IrK4zgBI,2BAA2B;E2Ej2gB7B;;E3Eo2gBA;;I2E91gBM,6BzDQL;ElBy1gBD;;E2Et2gBE;;IAGC,8BzDQF;EyDNK;;EANN;;I3Eg3gBE,4BAA4B;E2E52gB3B;;E3E+2gBH;I2En3gBA,yBAAW;EACT;;EAGC;;I3Eq3gBD,6BAA6B;E2Ez3gB/B;;E3E43gBA;;I2Et3gBM,+BzDQL;ElBi3gBD;;E2E93gBE;;IAGC,gCzDQF;EyDNK;;EANN;;I3Ew4gBE,8BAA8B;E2Ep4gB7B;;E3Eu4gBH;I2E34gBA,wBAAW;EACT;;EAGC;;I3E64gBD,4BAA4B;E2Ej5gB9B;;E3Eo5gBA;;I2E94gBM,8BzDQL;ElBy4gBD;;E2Et5gBE;;IAGC,+BzDQF;EyDNK;;EDiCR;;I1Ey3gBI,6BAA6B;E2E55gB5B;;E3E+5gBH;I2En6gBA,wBAAW;EACT;;EAGC;;I3Eq6gBD,4BAA4B;E2Ez6gB9B;;E3E46gBA;;I2Et6gBM,8BzDQL;ElBi6gBD;;E2E96gBE;;IAGC,+BzDQF;EyDNK;;EANN;;I3Ew7gBE,6BAA6B;E2Ep7gB5B;;E3Eu7gBH;Iep4gBE,0BAAwB;EuJtD3B;;EAGA;;ItK67gBG,8BAA8B;EuKj8gBlC;;EAOI;;IAHI,gCACH;EAID;;EvKg8gBF;;IuKh8gBG,iCAKoB;EvK87gBvB;;EAEA;;IuKx7gBM,+BlK68B+B;EL8+erC;;EAEA;IuKh8gBG,wBAAS;EvKk8gBZ;;EAEA;;IAEE,4BuKr7gBK;EvKs7gBP;;EAEA;;IuKz8gBG,8BAAS;EvK48gBZ;;EAEA;;IAEE,+BuKh7gBoB;EvKi7gBtB;;EuKp+gBF;;IA2DQ,6BAA2B;EvK86gBjC;;EAEA;IuK3+gBF,0BAmEe;EvK06gBb;;EAEA;;IAEE,8BKlqgB0D;ELmqgB5D;;EAEA;;IAEE,gCuKt6gBS;EAMT;;EvKm6gBF;;IuKz5gBU,iCACH;EAjGT;;EvK8/gBE;;IuKn5gBU,+BAAgB;EvKs5gB1B;;EuKjghBF;IAiHY,wBAWH;EvKy4gBP;;EAEA;;IAEE,4BuK94gBS;EA3Hb;;EvK4ghBE;;IuK5ghBF,8BA8He;EvKi5gBb;;EuK/ghBF;;IA8IY,+BlKzHG;EL+/gBb;;EAEA;;IAEE,6BuKh4gBkE;EvKi4gBpE;;EAEA;IuK3hhBF,0BA6Fe;EvKg8gBb;;EuK7hhBF;;IA6KgB,8BACH;EA9Kb;;EvKoihBE;;IuK72gBU,gCAAyB;EvKg3gBnC;;EAEA;;IuKr2gBU,iClKvHW;EL+9gBrB;;EAEA;;IuKh2gBU,+BACH;EA/MT;;EvKmjhBE;IuK/1gBU,2BAAY;EvKi2gBtB;;EAEA;;IuK91gBU,+BAyBH;EvKw0gBP;;EAEA;;IAEE,iCKtihBc;ELuihBhB;;EAEA;;IAEE,kCuKl1gBS;EAjPb;;EAAA;;IAAA,gCA2PS;EA3PT;;EvK2khBE;IuK3khBF,yBA8Pe;EvK+0gBb;;EAEA;;IuK/khBF,6BAqQmB;EvK60gBjB;;EAEA;;IuKt0gBM,+BAAoB;EvKy0gB1B;;EwKvlhBF;;IAEI,gCnKolC2C;EmKnlC3C;;EAEA;;IAEA,8BnK2SgC;EmK1ShC;;EARJ;IAYQ,uBAAY;ExKylhBlB;;EAEA;;IwKtlhBM,2BAAS;ExKylhBf;;EAEA;;IAEE,6BwKtlhBK;ExKulhBP;;EAEA;;IwKhlhBM,8BAAkB;ExKmlhBxB;;EAEA;;IwKhlhBM,4BnKjBO;ELomhBb;;EAEA;IsB5mhBI,uBAAQ;EtB8mhBZ;;EAEA;;IwK/nhBF,2BAgDI;ExKklhBF;;EAEA;;IwK/khBM,6BAAQ;ExKklhBd;;EAEA;;IAEE,8BAA8B;EyK3ohBlC;;EAEC;;IAEA,4BAAY;EACZ;;EAEA;IACA,wBAAW;EzK6ohBV;;EyKzohBD;;IAEA,4BAAY;EACZ;;EChBD;;I1K+phBI,8BAA8B;E0K3phBlC;;EAEI;;IAIQ,+BACH;E1K0phBP;;E0KrphBF;;IAEI,6BACH;E1KuphBC;;E0KnphBM;I1KsphBJ,qBAAqB;E0KlphBzB;;EAEI;;I1KqphBA,yBAAyB;E0KjphB7B;;E1KophBE;;I2KprhBE,2BAAkB;EAClB;;E3KwrhBF;;I2KnrhBE,4BAAkB;EAClB;;EAEA;;IAEA,0BtKgBc;EsKfd;;EAEA;IACA,2BAMH;EAhBD;;E3KkshBE;;I2KhrhBF,+BAA2B;EACvB;;E3KorhBF;;I2K/qhBE,iCAAiB;EACjB;;EAGJ;;IAEI,kCAAY;EACZ;;E3KkrhBF;;I2K3qhBF,gCAAmB;EACf;;EACQ;IAAU,0BAAS;EAAE;;E3KkrhB/B;;I2K7qhBE,8BAAkB;EAClB;;EAAkB;;IAClB,gCACH;E3KkrhBC;;E2K/qhBE;;IACa,iCAAY;EACzB;;EAGJ;;IAEI,+BACH;E3KirhBC;;E2K9qhBE;I3KirhBA,wBAAwB;E4KpvhB5B;;E5KuvhBE;;I4KlvhBE,4BACH;E5KovhBC;;E4KhvhBM;;IAEA,8BvK+VyB;EuK9VzB;;E5KovhBN;;I4K7uhBM,+BAAe;EACf;;EAbR;;I5KgwhBI,6BAA6B;E4KzuhBjC;;EAAA;IAKY,0BACH;E5KwuhBP;;E4KnuhBE;;IAEA,8BvKsQgC;EuKrQhC;;E5KuuhBF;;I4KluhBM,gCvK7BO;ELkwhBb;;EAEA;;I4KhvhBF,iCAca;E5KquhBX;;EAEA;;IAEE,+BAA+B;E4KjuhBnC;;EAGQ;I5KkuhBJ,wBAAwB;E4KruhB5B;;E5KwuhBE;;I4KvthBE,4BACH;E5KythBC;;E4KtthBE;;IAEA,8BAAW;EACX;;EAEA;;IAGI,+BACH;E5KuthBH;;E4KnthBE;;IAEA,6BAMH;EATD;;E5K2thBE;I4K7shBF,0BAAU;EACN;;E5KgthBF;;I4K1shBM,8BAAa;E5K6shBnB;;EAEA;;I4K1shBM,gCAIH;E5KyshBH;;EAEA;;I4KxshBM,iCAAmB;E5K2shBzB;;EAEA;;IAEE,+BK1+gBkD;EL2+gBpD;;E4KnuhBF;IA6BQ,yBACH;EA9BL;;E5KyuhBE;;I4KjshBE,6BAAwB;EtJ3ItB;;EtBi1hBJ;;IAEE,+BAA+B;E4K5phBnC;;E5K+phBE;;I4KzphBM,gCAWH;EAjBL;;EAAA;;I5KsqhBI,8BAA8B;E4KhphBlC;;EAEI;IAFJ,yBAAA;E5KqphBE;;E4KrphBF;;IAAA,6BAYQ;E5K8ohBN;;EAEA;;I4KxohBM,+BACH;EArBL;;EAAA;;IA6BY,gCACH;E5KsohBP;;E6K33hBE;;I7K+3hBA,8BAA8B;E6Kx3hBlC;;E7K23hBE;I6Kp3hBF,2BAAsB;EAClB;;E7Ku3hBF;;I6Kl3hBF,+BAAoB;EAChB;;EAEA;;IAGJ,iCAAmB;EACf;;EAGJ;;I7Ko3hBI,kCAAkC;E8Kn5hBtC;;E9Ks5hBE;;I8Kj5hBF,gCAAU;EACT;;EAED;IACC,yBAAU;EACV;;EAED;;IAEC,6BAAM;EACN;;EAGD;;IAGC,+BAAoB;E9Kk5hBnB;;E8K/4hBD;;IAED,gCAAmC;EAClC;;EAED;;I9Km5hBI,8BAA8B;E8Kh5hBlC;;E9Km5hBE;I8Kh5hBF,2BAA0B;EACzB;;EAED;;I9Km5hBI,+BAA+B;E8Kh5hBnC;;E9Km5hBE;;I8K/4hBD,iCAA4B;E9Kk5hB3B;;E8K/4hBD;;IAED,kCAAsC;EACrC;;EAED;;I9Km5hBI,gCAAgC;E8Kh5hBpC;;E9Km5hBE;I8Kh5hBF,yBAA0B;EACzB;;EAED;;I9Km5hBI,6BAA6B;E8Kh5hBjC;;E9Km5hBE;;I8K/4hBD,+BAAA;EACA;;EAEA;;IAED,gCAA0B;EACzB;;EAEA;;I9Km5hBG,8BAA8B;E8Kh5hBlC;;EAEC;IACA,2BAA6B;EAC7B;;EAED;;IAEC,+BAAiC;EACjC;;E9Km5hBC;;I8K/4hBD,iCAAkC;EAClC;;EAEA;;IAED,kCAAsC;EACrC;;EAEA;;I9Km5hBG,gCAAgC;E8Kh5hBpC;;EAEC;IACA,4BAA6B;EAC7B;;EAED;;IAEC,gCAAiC;EACjC;;E9Km5hBC;;I8K/4hBD,kCAAoC;EACpC;;EAEA;;IAED,mCAA0B;EACzB;;EAEA;;I9Km5hBG,iCAAiC;E8Kh5hBrC;;EAEC;IACA,0BAAA;EACA;;EAED;;IAEC,8BAA+B;EAC/B;;E9Km5hBC;;I8K/4hBD,gCAAkC;EAClC;;EAEA;;IAED,iCAA0B;EACzB;;EAEA;;I9Km5hBG,+BAA+B;E+KtiiBnC;;EAEI;IACA,wBAAA;EACA;;EAEA;;I/KyiiBA,4BAA4B;E+KriiBhC;;EAEI;;IAGJ,8BAAU;EACV;;EAEI;;IAEA,+BACH;E/KqiiBC;;E+K/hiBE;;I/KmiiBA,6BAA6B;E+K/hiBjC;;EAEI;IACA,wBAAkB;EAClB;;EAEA;;IAEA,4BAAW;EACX;;EAIJ;;IAEI,8BACH;E/K8hiBC;;E+K3hiBE;;IAGJ,+BAA8B;EAC1B;;EAGJ;;I/K6hiBI,6BAA6B;E+KzhiBjC;;EAEI;I/K2hiBA,yBAAyB;E+KxhiB7B;;E/K2hiBE;;I+KthiBE,6BACH;E/KwhiBC;;E+KrhiBE;;IAEA,+BAAW;EACX;;EAGJ;;I/KwhiBI,gCAAgC;E+KphiBpC;;EAEI;;IAEA,8BACH;E/KqhiBC;;E+KlhiBE;IACA,2BACH;E/KohiBC;;E+KjhiBE;;IAGJ,+BAAc;EACV;;EAGJ;;I/KmhiBI,iCAAiC;E+K/giBrC;;E/KkhiBE;;I+K7giBE,kCAAyB;EACzB;;EAEA;;IAEA,gCACH;E/K+giBC;;E+K5giBE;I/K+giBA,0BAA0B;E+K3giB9B;;EAGA;;I/K6giBI,8BAA8B;E+KzgiBlC;;EAEA;;I/K4giBI,gCAAgC;E+KvgiBpC;;E/K0giBE;;I+KrgiBF,iCAAa;EACT;;E/KygiBF;;I+KpgiBE,+BAAkB;EAClB;;EAIJ;I/KqgiBI,wBAAwB;EAC1B;;E+KjgiBE;;IAEA,4BACH;E/KmgiBC;;E+KhgiBE;;I/KogiBA,8BAA8B;E+K//hBlC;;E/KkgiBE;;I+K7/hBE,+BAAkB;EAClB;;EAGJ;;I/KggiBI,6BAA6B;E+K5/hBjC;;E/K+/hBE;I+K1/hBF,0BAAA;E/K4/hBE;;E+Kx/hBF;;IAEI,8BAAY;EACZ;;EAEA;;IAGJ,gCAAuB;EACnB;;EAGJ;;I/K0/hBI,iCAAiC;E+Kt/hBrC;;EAEI;;I/Ky/hBA,+BAA+B;E+Kr/hBnC;;E/Kw/hBE;I+Kp/hBF,wBAAuB;EACnB;;EAIJ;;IAEG,4BAAA;EAEH;;EAEI;;IAEA,8BACH;E/Kk/hBC;;E+K/+hBE;;IAEA,+BACH;E/Ki/hBC;;E+K9+hBE;;I/Kk/hBA,6BAA6B;E+K9+hBjC;;EAEI;IACA,wBACH;E/K++hBC;;E+K5+hBE;;IAGJ,4BAAqB;EACjB;;EAGJ;;IAEI,8BAAkB;EAClB;;EAEA;;IAEA,+BAAY;EACZ;;E/K8+hBF;;I+Kz+hBE,6BAAmB;EACnB;;EAEA;I/K4+hBA,uBAAuB;E+Kz+hB3B;;EAEI;;IAEA,2BACH;E/K0+hBC;;E+Kp+hBE;;IAEA,6BAAS;EACT;;EAEA;;IAnOJ,8BAsOiB;EACb;;EAjNJ;;I/K0riBI,4BAA4B;E+KrsiBhC;;E/KwsiBE;I+KpriBF,uBAmNc;EACV;;E/Ko+hBF;;I+K39hBF,2BAA4B;EACxB;;EAEA;;IAEA,6BAAgB;EAChB;;EAEA;;I/K+9hBA,8BAA8B;E+K39hBlC;;EAEI;;IAGJ,4BAAoB;EAChB;;EAIJ;IAEA,yBAAwB;EACxB;;E/K09hBE;;I+Kr9hBF,6BAAuB;EACnB;;EAGJ;;IAGI,+B1KFiD;E0KGjD;;EAEA;;IAEA,gCACH;E/Kq9hBC;;E+Kl9hBE;;I/Ks9hBA,8BAA8B;E+Kl9hBlC;;EAEI;IACA,uBAAgB;EAChB;;EAEA;;I/Kq9hBA,2BAA2B;E+Kj9hB/B;;EAEI;;IAEA,6BAAY;EACZ;;EAEA;;IAEA,8BAAc;EACd;;EAEA;;IAGJ,4BAA+B;EAC3B;;E/Km9hBF;I+K/8hBF,yBAA0B;EACtB;;E/Kk9hBF;;IgLv2iBE,6B3KgWgC;EL0giBlC;;EgLt2iBE;;IAEA,+B3KeW;E2KdX;;EAEA;;IAGJ,gCAA4B;EACxB;;EAGJ;;IAEI,8BACH;EhLs2iBC;;EgLn2iBE;IACA,uBAAc;EACd;;EAEA;;IAEA,2B3KDc;E2KEd;;EAEA;;IpKpBE,6BPYK;EiBZL;;EtB83iBJ;;IgLp3iBF,8BAyBkB;EhL81iBhB;;EuBh5iBA;;IAEE,4BlBuBW;EL43iBb;;EAEA;IuBv5iBA,yByJ0DU;EhL+1iBV;;EgL11iBF;;IAEI,6BACH;EhL41iBC;;EgLt1iBE;;IACA,+BAAkB;EAClB;;EAGJ;;IhL01iBI,gCAAgC;EgLn1iBpC;;EAEI;;IAGI,8BACH;EANL;;EhL21iBE;IgL90iBF,0BAAmB;EACf;;EACkB;;IAElB,8BAAe;EACf;;EhLk1iBF;;IgL30iBM,gCACH;EhL60iBH;;EgLz0iBF;;IAGA,iCAAuB;EACnB;;EhL40iBF;;IgLx0iBE,+BAAoB;EACpB;;EAEA;IACA,0BACH;EhL00iBC;;EgLv0iBE;;IAGJ,8BAAqB;EACjB;;EAGJ;;IAEI,gCACH;EhLu0iBC;;EgLj0iBE;;IAEA,iCAAiB;EACjB;;EAEA;;IAEA,+B3KmVgC;E2KlVhC;;EATJ;IAeQ,wBAAW;EhLi0iBjB;;EAEA;;IgLl1iBF,4BAqBa;EhLg0iBX;;EAEA;;IgL3ziBM,8B3KpJG;ELk9iBT;;EAEA;;IgLzziBE,+BACH;EhL2ziBC;;EgLxziBE;;IvJzFA,6BpB2QkD;EoB1QlD;;EHjFE;IAIA,wBAAQ;EtBs+iBZ;;EAEA;;IgL7ziBE,4BACH;EhL+ziBC;;EgL5ziBE;;IAEA,8BAAkE;EAClE;;EAEA;;IAEA,+BAAY;EACZ;;EhLg0iBF;;IgLzziBF,6BAA6B;EACzB;;EAIJ;IACA,yBAAuB;EACnB;;EAGJ;;IAEI,6BAAqB;EACrB;;EAEA;;IAEA,+BAAiB;EACjB;;EvJrIA;;IAEA,gCpB2M8B;EoBzM1B;;EH/EF;;I0JyMN,8BAA8B;EhLy0iB5B;;EgLz0iBF;IAAA,uBAAsB;EhL60iBpB;;EgL70iBF;;IAmBQ,2BAAU;EhL+ziBhB;;EgL1ziBF;;IvJpPI,6BpByBW;EqBpBX;;EdUE;;IoKsON,8BAAuB;EhLm0iBrB;;EAEA;;IgLr0iBF,4BAAuB;EAAvB;AhLy0iBA;;AAEA;EgL30iBA,kBAAW;EhL60iBT,MyB3ijBM;EzB4ijBN,QyB3ijBM;EzB4ijBN,SyB3ijBM;EAGJ,OAAA;EAEA,UuJsNJ;EACA,oBAAW;EAAX,WAAW;EvJvNP,kCAAK;AzB4ijBT;;AAEA;EACE;uCI5tiBQ;AJ8tiBV;;AAEA;EACE,8ByBpjjBO;AzBqjjBT;;AAEA;EgL51iBA,8BAA+B;AhL81iB/B;;AgL11iBA;EACI,8BACH;AhL41iBD;;AAEA;E0BxljBI,gBAAgB;EDHhB,uBpBuBW;EOVT,mBP0nB8B;ALw9hBpC;;AAEA;EACE,2BKlkjBgB;ALmkjBlB;;AAEA;EACE,4BK/9hBsC;ALg+hBxC;;AAEA;EACE,6ByBlljBG;AzBmljBL;;AAEA;EACE;IyB5kjBM,2BAWH;EzBmkjBH;;EAEA;IACE,4BAA4B;EgL92iBhC;;EhLi3iBE;IgL12iBF,6BAAsB;EAClB;AhL42iBJ;;AgLx2iBA;EACI;IACA,2BACH;EhL02iBC;;EiL3njBA;IACA,4BAAqB;EACrB;;EAEF;IACE,6BAAuB;EACvB;AjL8njBF;;AAEA;EiL5njBE;IACA,2BAA0B;EAC1B;;EAEA;IACA,4BAAM;EACN;;EAEF;IACE,6BAAS;EACT;AjL8njBF;;AAEA;EACE;IiL3njBF,2BAAgB;EACd;;EjL8njBA;IiL3njBF,4BAAoB;EAClB;;EAEF;IACA,6BAA8B;EAC5B;AjL6njBF;;AAEA;EACE,oCAAoC;AiL1njBtC;;AjL6njBA;EACE,oCAAoC;AiL1njBtC;;AjL6njBA;EiL1njBA,qCAAqC;AjL4njBrC;;AAEA;EiL1njBE,2BAAS;AjL4njBX;;AAEA;EiL1njBE,+BAAa;AjL4njBf;;AAEA;EiL1njBE,2BACD;AjL2njBD;;AAEA;EiL1njBE,2BACD;AjL2njBD;;AiLxnjBA;EACA,8BAAmB;AjL2njBnB;;AAEA;EiLznjBE,6BAAkB;AjL2njBpB;;AiLvnjBA;EACE,sBAAc;AjL0njBhB;;AAEA;EiLxnjBE,yBACD;AjLynjBD;;AAEA;;EiLtnjBE,yBAAO;AjLynjBT;;AiLrnjBA;EACE,yBAAY;AjLwnjBd;;AAEA;;EiLpnjBA,yBAAmB;AjLunjBnB;;AiLnnjBA;EACA,yBAAmB;AACnB;;AjLunjBA;;EAEE,yBAAyB;AiLnnjB3B;;AjLsnjBA;EiLnnjBE,yBAAyB;AjLqnjB3B;;AiLjnjBA;;EjLqnjBE,yBAAyB;AiLjnjB3B;;AjLonjBA;EiLhnjBA,yBAAmB;AjLknjBnB;;AiL9mjBA;;EjLknjBE,yBAAyB;AiL9mjB3B;;AjLinjBA;EACE,yBAAyB;AiL7mjB3B;;AjLgnjBA;;EiL3mjBE,yBACD;AjL6mjBD;;AAEA;EACE,yBAAyB;AiL1mjB3B;;AAEA;;EAEE,yBAAS;AjL4mjBX;;AAEA;EACE,yBAAyB;AiLzmjB3B;;AjL4mjBA;;EiLvmjBE,uBAAc;AjL0mjBhB;;AAEA;EiLxmjBE,yBACD;AjLymjBD;;AAEA;;EiLtmjBE,yBAAO;AjLymjBT;;AiLrmjBA;EACE,sBAAY;AjLwmjBd;;AAEA;;EiLpmjBA,yBAAmB;AjLumjBnB;;AAEA;EiLpmjBA,sBAAmB;AjLsmjBnB;;AAEA;;EiLlmjBE,yBACD;AjLomjBD;;AAEA;EACE,uBAAuB;AiLjmjBzB;;AAEA;;EAEE,uBAAuB;AjLmmjBzB;;AiL/ljBA;EACE,yBAAyB;AjLkmjB3B;;AAEA;EACE,yBAAyB;AiL9ljB3B;;AjLimjBA;EiL7ljBA,oCAAA;AACA;;AjLgmjBA;EACE,0CAA0C;AiL5ljB5C;;AjL+ljBA;EACE,WAAW;EiL3ljBb,kBAAmB;EACjB,iBAAe;EjL6ljBf,6BAA6B;EiL1ljB/B,SAAA;AjL4ljBA;;AiLxljBA;EACA,gCAAkC;AjL2ljBlC;;AiLvljBA;EACE,iCACD;EjLyljBC,gCAAgC;AiLvljBlC;;AjL0ljBA;EiLtljBA,yBAAmB;AjLwljBnB;;AiLpljBA;EACA,8BAAoB;AACpB;;AjLwljBA;EiLrljBE,6BAAS;AjLuljBX;;AAEA;EACE;IiLpljBF,yBAAoB;EAClB;AjLsljBF;;AAEA;EiLpljBE,qBACD;EjLqljBC,WAAW;EiLnljBb,YAAA;EACE,2BACD;EjLoljBC,iCAAiC;EiLlljBnC,+BAAoB;EAClB,kBAAkB;EAClB,+CAAc;AjLoljBhB;;AAEA;EiLlljBE,WAAA;EACA,YAAA;EACA,mBAAkB;AjLoljBpB;;AAEA;EiLlljBE;IACA,mBAAY;EjLoljBZ;;EiLhljBF;IACE,UAAY;IACZ,eAAQ;EACR;AjLmljBF;;AAEA;EiLhljBE,qBAAW;EACX,WAAO;EACP,YAAW;EACX,2BAAiB;EACjB,8BACD;EjLiljBC,kBAAkB;EiL/kjBpB,UAAA;EACE,6CAAY;AjLiljBd;;AAEA;EiL/kjBE,WAAU;EjLiljBV,YAAY;AiL9kjBd;;AjLiljBA;;EiL7kjBE;;IAGF,wBAAoB;EAClB;AjL+kjBF;;AAEA;;EiL3kjBE;;;IAIA,4BACD;IjL4kjBG,2BAA2B;EiL1kjB/B;;EjL6kjBE;IiLzkjBF,0BAAoB;EAClB;;EAGF;IACA,6BAAoB;EAClB;;EAGF;IACE,gCACD;EjLwkjBC;;EiLrkjBF;;IAEE,yBAAY;IACZ,wBAAS;EACT;;EAEA;IACA,2BACD;EjLukjBC;;EiLpkjBA;;IAGF,wBAAmB;EACjB;;EAEA;;;IjLwkjBE,UAAU;IiLnkjBd,SAAA;EACE;;EAEA;;IAGF,uBAAmB;EACjB;;EAEA;IACA,QAAU;EACV;;EAEA;IACA,2BAAY;EACZ;;EAEA;IjLokjBE,2BAA2B;EiLjkjB/B;;EAEE;IACA,aAAO;EACP;;EjLokjBA;IiLhkjBF,sBAAmB;EACjB;;EAEA;IACA,oCAAM;EACN;;EAGF;;IAEE,iCAAY;EACZ;;EAEA;;IAEA,oCAAY;EACZ;;EAEA;IACA,cAAA;EACA;;EAGF;;;;IjLmkjBI,qBAAqB;EiL7jjBzB;;EAEE;IjL+jjBE,cAAc;IiL5jjBlB,qBAAmB;EACjB;AjL8jjBF;;AAEA;EiL3jjBA,mBAAmB;AjL6jjBnB;;AAEA;EACE,gBAAgB;EiL1jjBlB,oBAAmB;EACjB,mBAAY;AjL4jjBd;;AAEA;EiLzjjBA,kBAAmB;EACjB,qBACD;EjL0jjBC,qBAAqB;EiLxjjBvB,sBAAmB;AjL0jjBnB;;AAEA;EACE,kBAAkB;EiLvjjBpB,QAAA;AjLyjjBA;;AiLrjjBA;EACA,qBAAmB;EACjB,sBACD;AjLujjBD;;AAEA;EACE,WAAW;EiLpjjBb,kDAA2C;AjLsjjB3C;;AiLljjBA;EACE,QAAK;EjLqjjBL,aAAa;EiLljjBf,2BAAA;EACA,UAAA;EACA,UAAA;AjLojjBA;;AAEA;EiLljjBE;IACA,SAAU;IACV,aACD;EjLmjjBC;AiLjjjBF;;AjLojjBA;EiLhjjBA,iBAAkB;EAChB,6BAAc;EACd,+BAAY;AjLkjjBd;;AAEA;;EiL9ijBA,6BAAkB;EAChB,YAAA;AjLijjBF;;AiL7ijBA;EACE,4BAAsB;AjLgjjBxB;;AiL5ijBA;;EAEE,cAAY;AjL+ijBd;;AAEA;EiL7ijBE,wBACD;EjL8ijBC,gBAAgB;EiL5ijBlB,wBAAkB;EAChB,mBAAY;EACZ,0CAAgB;EAChB,gCAAoB;AjL8ijBtB;;AAEA;EACE,wBAAwB;AiL3ijB1B;;AjL8ijBA;EiL3ijBE,qCAAuB;AjL6ijBzB;;AAEA;EiL1ijBA,cAAe;AjL4ijBf;;AiLxijBA;EACA,YAAA;AjL2ijBA;;AAEA;EiLxijBA,kBAAkB;EAChB,QAAA;AjL0ijBF;;AiLtijBA;EACE,cAAY;EACZ,eAAe;EACf,gBACD;AjLwijBD;;AAEA;EiLtijBE,oBAAgB;EAChB,wBACD;EjLuijBC,wBAAwB;AiLrijB1B;;AjLwijBA;EACE,WAAW;EiLpijBb,yBAAkB;EAChB,oBAAW;EACX,mBAAW;EACX,uBACD;EjLqijBC,eAAe;EiLnijBjB,uBAAkB;EAChB,YAAQ;EACR,WAAW;AjLqijBb;;AAEA;EiLlijBE,WAAU;EACV,uBACD;AjLmijBD;;AiLhijBA;EACE,qBACD;EjLkijBC,oBAAoB;AiLhijBtB;;AjLmijBA;EiL/hjBA,WAAA;EACE,YAAW;AjLiijBb;;AAEA;EACE,WAAW;EiL7hjBb,YAAA;EACA,mBAAqB;AACrB;;AjLgijBA;EiL7hjBE,WAAS;EACT,YAAU;EACV,mBAAkB;AjL+hjBpB;;AiL3hjBA;EACE,WAAS;EACT,YAAY;EACZ,kBAAO;AjL8hjBT;;AAEA;EiL3hjBA,kBAAkB;EAChB,UAAQ;EACR,sBAAW;AjL6hjBb;;AAEA;EACE,UAAU;AiL1hjBZ;;AjL6hjBA;EiL1hjBE,kBAAU;AjL4hjBZ;;AAEA;EiLzhjBA,yBAAqB;AjL2hjBrB;;AAEA;EiLzhjBE,WAAA;AjL2hjBF;;AAEA;EiLxhjBE,mBAAU;AjL0hjBZ;;AAEA;EiLxhjBE,uBAAoB;AjL0hjBtB;;AAEA;EiLxhjBE,sBAAY;AjL0hjBd;;AAEA;EiLvhjBE,QAAA;EACA,kBAAkB;AjLyhjBpB;;AiLrhjBA;EACA,0BAAqB;AjLwhjBrB;;AAEA;EiLthjBE,WAAS;AjLwhjBX;;AAEA;EiLrhjBE,yBAAgB;EAChB,cAAQ;AjLuhjBV;;AiLnhjBA;EACE,mBAAS;AjLshjBX;;AAEA;EiLphjBE,oBAAiB;AjLshjBnB;;AAEA;EACE,kBAAkB;EiLnhjBpB,oBAAqB;EACnB,mBAAU;EACV,uBAAQ;EACR,kBAAQ;EACR,qBAAoB;EACpB,cAAA;EACA,eAAe;EACf,kBAAgB;EAChB,gBAAY;AjLqhjBd;;AAEA;EACE,aAAa;EiLjhjBf,cAAA;AjLmhjBA;;AiL/gjBA;EACA,WAAA;EACE,YAAW;AjLkhjBb;;AAEA;EACE,eAAe;EiL9gjBjB,gBAAkB;EAClB,uBAAqB;EACrB,gBAAkB;EAChB,mBAAgB;EAChB,oBAAY;AjLghjBd;;AAEA;EiL7gjBA,cAAA;AACA;;AjLghjBA;EiL5gjBA,qBAAqB;EACrB,sBAAqB;EACnB,eAAY;EACZ,gBAAW;EACX,kBAAA;EACA,sBAAoB;AjL8gjBtB;;AiL1gjBA;EACA,aAAA;EACE,cAAY;AjL6gjBd;;AiLzgjBA;EACA,eAAA;EACE,gBAAc;AjL4gjBhB;;AiLxgjBA;EACA,kBAAoB;EACpB,SAAA;EACE,0BAAY;EACZ,iBAAS;AjL2gjBX;;AAEA;EiLzgjBE,+BACD;AjL0gjBD;;AAEA;EACE,mBAAmB;AiLvgjBrB;;AjL0gjBA;EiLvgjBE,yBAAO;AjLygjBT;;AAEA;EiLtgjBA,gBAAiB;AjLwgjBjB;;AAEA;EiLrgjBA,cAAA;AjLugjBA;;AAEA;EiLrgjBE,WAAW;AjLugjBb;;AiLngjBA;EACE,cAAY;AjLsgjBd;;AAEA;EiLpgjBE,cACD;AjLqgjBD;;AAEA;EiLngjBE,UAAQ;EACR,SAAQ;EACR,uBAAuB;AjLqgjBzB;;AAEA;EiLlgjBA,kBAAoB;EAClB,oBAAkB;EAClB,0BACD;EjLmgjBC,uBAAuB;EiLjgjBzB,mBAAoB;EAClB,sBAAkB;AjLmgjBpB;;AiL//iBA;EACA,2EAA2D;EACzD,2BAAW;AjLkgjBb;;AiL9/iBA;EACE,oBAAU;AjLigjBZ;;AiL7/iBA;;EAEE,mBAAe;AjLggjBjB;;AiL5/iBA;;EAEE,oBAAgB;AjL+/iBlB;;AiL3/iBA;;EjL+/iBE,eAAe;EiL3/iBjB,wBAAoB;AjL6/iBpB;;AAEA;;EiLz/iBE,kBAAY;AjL4/iBd;;AiLx/iBA;;EjL4/iBE,mBAAmB;AiLx/iBrB;;AjL2/iBA;EACE,iBAAiB;AiLv/iBnB;;AjL0/iBA;EACE,cAAc;AiLt/iBhB;;AjLy/iBA;EACE,kBAAkB;EiLr/iBpB,QAAA;AjLu/iBA;;AiLn/iBA;EACE,gBACD;EjLq/iBC,gBAAgB;AiLn/iBlB;;AjLs/iBA;EiL7+iBA,gBAAiB;EACb,eAiCH;AjL88iBD;;AAEA;EACE,ciL3+iBkB;AjL4+iBpB;;AAEA;EACE,WiL1+iBU;EjL2+iBV,yBiLj/iBE;EjLk/iBF,qBiLx+iB0B;EjLy+iB1B,2EiLt+iBc;AjLu+iBhB;;AAEA;EACE,WiLn+iBc;EA3BhB,yBA8BI;EjLk+iBF,qBiLj+iBiB;AjLk+iBnB;;AkL94kBA;;ElLk5kBE;kCkL94kByB;AlLg5kB3B;;AkL54kBA;;EAEA,WAAA;EACA,yBAA2B;EACzB,qBAAc;AlL+4kBhB;;AAEA;;;EkL34kBE,W7KSS;E6KRT,yB7KEa;E6KDb,qBAAiB;AlL+4kBnB;;AAEA;;;EAGE,gDkLh6kB2C;AlLi6kB7C;;AAEA;EACE,WsB55kBM;E4JRR,yBAAmB;EACnB,qBAAA;EACA,2EA0Be;AlL44kBf;;AAEA;EuBt7kBE,WAAA;E2JaF,yBAAA;EACA,qBAAA;AlL46kBA;;AAEA;;EAEE;mCKz5jBgD;AL25jBlD;;AAEA;;EAEE,WKt6kBS;ELu6kBT,yBkLh5kBC;EAzCH,qBAAmB;AlL27kBnB;;AAEA;;;EkL17kBA,WAAA;ElL87kBE,yBKl7kBS;ELm7kBT,qBkL74kBC;AlL84kBH;;AAEA;;;EkLz4kBE,iDACD;AlL44kBD;;AAEA;EkL14kBE,WAAW;ElL44kBX,yBAAyB;EkLz4kB3B,qBAAkB;EAChB,2EAA8B;AlL24kBhC;;AAEA;EACE,WAAW;EkLx4kBb,yBAAyB;EACvB,qB7KoZ4B;ALs/jB9B;;AAEA;;EAEE;kCkLv4kBuB;AlLy4kBzB;;AkLp4kBA;;EAEE,WAAA;EACA,yBACD;ElLs4kBC,qBAAqB;AkLp4kBvB;;AlLu4kBA;;;EkLj4kBE,WAAQ;EACR,yB9JQiC;EpB63kBjC,qBAAqB;AkLl4kBvB;;AlLq4kBA;;;EkL/3kBA,gDAA4B;AlLm4kB5B;;AAEA;EkLj4kBE,WAAA;EACA,yBAAY;EACZ,qB7KsL4B;E6KrL5B,2EAAmD;AlLm4kBrD;;AAEA;EkLh4kBA,WAAA;EACE,yBAAQ;EACR,qBAAkB;AlLk4kBpB;;AAEA;;EkL53kBA;kCAEC;AlL83kBD;;AAEA;;EAEE,WAAW;EkLz3kBb,yBAA0B;EACxB,qB7KgV4B;AL2ikB9B;;AAEA;;;EWxglBI,WAAA;EX4glBF,yBAAyB;EkLj3kB3B,qBAAmB;AACnB;;AlLo3kBA;;;EkL/2kBE,gD7KyHgC;AL0vkBlC;;AkL/2kBA;EACA,WAAA;EACE,yB9J/DiC;EpBi7kBjC,qBAAqB;EkL/2kBvB,2EAA4E;AlLi3kB5E;;AkL72kBA;EACA,WAAA;EACA,yBAAmB;EACjB,qB9JzEiC;ApBy7kBnC;;AAEA;;EAEE;iCkL72kBiB;AACnB;;AlLg3kBA;;EkL32kBE,WAAW;ElL82kBX,yBAAyB;EmLxjlB3B,qBAAa;AnL0jlBb;;AAEA;;;EmL5jlBA,WAAA;EnLgklBE,yBmLljlBG;EnLmjlBH,qBAAqB;AoLvklBvB;;AAEA;;;EAGA,+CAAsC;AACtC;;AAEA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,2EAAsD;ApLyklBtD;;AAEA;EoLvklBE,WAAQ;EACR,yBAAU;EACV,qBAAgB;ApLyklBlB;;AAEA;;EoLrklBE;kCpLwklBgC;AoLtklBlC;;ApLyklBA;;EoLrklBE,WAAS;EACT,yBAAY;EACZ,qBAoCD;ApLoilBD;;AAEA;;;EoL7klBA,WAAA;EpLillBE,yBoL9jlBoB;EpL+jlBpB,qBoL9jlBsB;ApL+jlBxB;;AAEA;;;EoLrllBA,gDA4BE;ApL6jlBF;;AAEA;EACE,WoL5llBF;EpL6llBE,yBoLzjlBK;EpL0jlBL,qBAAqB;Ee/jlBnB,2EAAwB;AfiklB5B;;AAEA;EenklBI,WAAQ;EqKUV,yBAAA;EpL4jlBA,qBoLrjlBC;ApLsjlBH;;AAEA;;EAEE;mCoLnjlB8B;ApLqjlBhC;;AAEA;;EoLljlBI,WAAA;EACA,yBAAW;EACX,qBAAW;ApLqjlBf;;AAEA;;;EoL9ilBI,WAAS;EpLkjlBX,yBAAyB;EoL/ilB3B,qBAAA;ApLijlBA;;AAEA;;;EoL7ilBI,iDAAW;ApLijlBf;;AAEA;EoL/ilBI,WAAU;EACV,yB/KxFW;E+KyFX,qBAAY;EACZ,2EAAoC;ApLijlBxC;;AoL9ilBA;EACE,WAAU;EpLijlBV,yBAAyB;EoL/ilB3B,qBAAA;ApLijlBA;;AoL9ilBA;;EAEE;mCpLijlBiC;AoL/ilBnC;;ApLkjlBA;;EoL9ilBA,WAAA;EACE,yBACD;EpLgjlBC,qBAAqB;AoL/ilBvB;;ApLkjlBA;;;EoL7ilBA,WAAA;EACA,yBAAA;EACI,qBACH;ApLgjlBD;;AAEA;;;EoL7ilBA,iDAAmD;AACnD;;ApLkjlBA;EoL/ilBE,WAAW;EACX,yBAAgB;EAChB,qBAAgB;EAChB,2EAAW;ApLijlBb;;AAEA;EoL/ilBA,WAAA;EACE,yBAAW;EACX,qBAAY;ApLijlBd;;AAEA;;EoL7ilBI;iCpLgjlB6B;AoL9ilBjC;;ApLijlBA;;EoL7ilBE,WAAS;EpLgjlBT,yBAAyB;EoL9ilB3B,qBAAA;ApLgjlBA;;AoL7ilBA;;;EAGA,WAAA;EACE,yBACD;EpL+ilBC,qBAAqB;AoL9ilBvB;;ApLijlBA;;;EAGE,+CAA+C;AoL9ilBjD;;ApLijlBA;EoL9ilBA,WAAA;EACE,yBAAS;EpLgjlBT,qBAAqB;EoL9ilBvB,2EAAgD;ApLgjlBhD;;AAEA;EACE,WAAW;EoL9ilBb,yBAAA;EACE,qBAAS;ApLgjlBX;;AAEA;;EoL7ilBE;kCACW;ApLgjlBb;;AoL7ilBA;;EAEE,WAAQ;EACR,yBAAW;EACX,qBAAkB;ApLgjlBpB;;AoL7ilBA;;;EAGE,WAAU;EpLgjlBV,yBAAyB;EoL9ilB3B,qBAAA;ApLgjlBA;;AoL7ilBA;;;EAGE,gDAAW;ApLgjlBb;;AoL7ilBA;EACE,gBACD;ApL+ilBD;;AAEA;EoL9ilBE,yBAAc;EACd,eAAQ;EpLgjlBR,gBAAgB;EoL9ilBlB,SAAA;EACE,SAAA;ApLgjlBF;;AAEA;EoL9ilBE,cAAW;ApLgjlBb;;AAEA;EACE,yBAAyB;EoL9ilB3B,WAAA;ApLgjlBA;;AoL7ilBA;EACE,gBAAS;EpLgjlBT,6BAA6B;EoL9ilB/B,WAAA;EACE,YAAY;EACZ,U/KjLc;E+KkLd,oBAAmB;EACnB,sBACD;EpL+ilBC,kBAAkB;AoL9ilBpB;;ApLijlBA;EoL9ilBA,gCAAiC;ApLgjlBjC;;AoL5ilBA;EACE,kBAAe;EACf,OAAM;EACN,MAAA;EACA,WAAO;EpL+ilBP,YAAY;EoL7ilBd,iBAAA;EACA,WAAA;EACA,mBAAA;EACE,UAAQ;EACR,YAAW;EACX,oCAAW;EACX,eAAY;EACZ,0CAAY;ApL+ilBd;;AAEA;EoL7ilBE;IACA,gBAAkB;EAClB;ApL+ilBF;;AAEA;EoL7ilBE,yBAAoB;ApL+ilBtB;;AAEA;EoL7ilBE,cAAY;ApL+ilBd;;AAEA;EoL7ilBE,mBACD;EpL8ilBC,UAAU;AoL7ilBZ;;ApLgjlBA;EoL7ilBA,WAAA;ApL+ilBA;;AoL1ilBA;EACE,mBAAW;ApL6ilBb;;AAEA;EoL3ilBE,oBAAkB;ApL6ilBpB;;AAEA;EACE,eAAe;EoL3ilBjB,gBAAA;EACE,UAAA;ApL6ilBF;;AAEA;EoL3ilBA,gBAAA;ApL6ilBA;;AoL1ilBA;;EAEE,WAAO;EACP,YAAQ;ApL6ilBV;;AAEA;EoL3ilBE,SAAO;EACP,eAAY;EACZ,eAAa;EACb,gBAAa;EACb,iBAAe;EACf,cAAa;EACb,yBACD;EpL4ilBC,uBAAuB;EoL1ilBzB,SAAA;EACE,gBAAgB;EAChB,oBACD;EpL2ilBC,qBAAqB;EoL1ilBvB,sBAAA;EACE,qBACD;EpL2ilBC,qBAAqB;EoL1ilBvB,eAAA;EACE,WAAU;EACV,gBAAc;ApL4ilBhB;;AoLzilBA;EACA,sBAAA;EACA,uEAA0D;ApL4ilB1D;;AoLzilBA;EACE,mBAAY;EACZ,aAAa;ApL4ilBf;;AAEA;EACE,uBAAuB;EoLxilBzB,cAAgB;EAChB,sBAAwB;EACxB,iBAAmB;AACnB;;AAEA;EACE,qBAAY;EACZ,mBAAkB;EAClB,gBAAU;EACV,iBAAe;EpL0ilBf,gBAAgB;EoLvilBlB,mBAAA;EACI,uBAAkB;EAClB,sBAAU;ApLyilBd;;AAEA;EoLrilBA,mBAAoB;EAApB,gDAAmC;EAAnC,SAAK;AAAL;;AAAA;EAAA,yCAAmC;AAAnC;;AAAA;EAAA,mBAAoB;AAApB;;ApLmjlBA;EoLnjlBA,oBAAoB;ApLqjlBpB;;AoLrjlBA;EAAA;IAwBQ,eAAO;EpLkilBb;AoL1jlBF;;ApL6jlBA;EoL7jlBA;IAAA,eAAK;EAiCG;ApLgilBR;;AoLjklBA;EAAA;IAAA,eAAK;IAAL,mBAAoB;EAyCX;ApL+hlBT;;AoLxklBA;EA8CS,4BAAkB;EpL8hlBzB,0BAA0B;AoLzhlB5B;;ApL4hlBA;EoL5hlBA;IAAA,gBAAK;EpL+hlBH;AACF;;AAEA;EoLthlBA,aAAK;EAAL,kBAAK;ApLyhlBL;;AAEA;EoL/glBA,cAAK;EACD,WAAA;EADJ,YAAK;EAAL,kBAAK;EAAL,UAAK;EpLqhlBH,OoL7glBW;ApL8glBb;;AAEA;EoL5glBA,aAAK;EAAL,8BAAoB;EAApB,mBAAK;ApLghlBL;;AoLpglBA;EACI,aAAA;EADJ,cAAK;ApLyglBL;;AAEA;EACE,YAAY;EoL//kBd,cAAA;EAIQ,kBAAO;EAJf,kBAAA;EpLmglBE,UoL5/kBe;ApL6/kBjB;;AAEA;EACE;IoLvglBF,oBAAA;EAgBM;ApL0/kBN;;AAEA;EACE,oBAAoB;EoL7glBtB,uBAAA;ApL+glBA;;AoL/glBA;EA8BM,iBAAY;EpLq/kBhB,cAAc;AqL1gmBhB;;ArL6gmBA;EqLzgmBI,UAAU;EACV,oChL2Bc;ALg/lBlB;;AAEA;EqLzgmBI;IACA,UAAW;IACX,qBACD;ErL0gmBD;AsLthmBF;;AtLyhmBA;EsLthmBA,kBAAiB;AtLwhmBjB;;AsLrhmBA;EAEI,gBAAc;EtLuhmBhB,uBAAuB;EsLzhmBzB,sBAIc;EACV,yCACD;EtLshmBD,kBAAkB;EsL5hmBpB,SAOE;EACE,0BAAgB;AtLuhmBpB;;AAEA;EACE,4CsLrhmBG;AtLshmBL;;AAEA;EsLrimBA,eAeU;AtLwhmBV;;AAEA;EACE,kBsLrhmBa;EtLshmBb,kBAAkB;EsL3imBpB,iBAwBiB;AtLqhmBjB;;AAEA;EACE,eAAe;AsLhjmBjB;;AtLmjmBA;EsLnjmBA,iBAmCiB;EACX,iBAAU;EACV,cjLiUwB;ALitlB9B;;AAEA;EACE,mBsLhhmBiB;EtLihmBjB,csLhhmBiB;AtLihmBnB;;AAEA;EACE,iBuL/jmBa;AvLgkmBf;;AAEA;EACE,oBKrimBS;ALsimBX;;AAEA;E+KrkmBA,kBAAY;EACZ,MAAA;ESLI,QAAA;EACA,+BAA6B;AxL6kmBjC;;AAEA;EwL3kmBI,kBAAY;ExL6kmBd,aAAa;A+KpkmBf;;A/KukmBA;EACE,aAAa;A+KnkmBf;;A/KskmBA;EwLzkmBI,aAAY;EACZ,uBAAkB;EAClB,kBACH;ExL0kmBC,mBAAmB;EwLxkmBrB,kBAAA;ExL0kmBE,cwLzkmBC;ATQH;;A/KokmBA;EACE,oBAAoB;E+KhkmBtB,mBAAa;AACb;;A/KmkmBA;EwLtkmBE,iBAAU;AxLwkmBZ;;AAEA;EwLtkmBE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAqB;ExLwkmBrB,kBAAkB;A+KvgmBpB;;A/K0gmBA;EACE,UAAU;AwLrkmBZ;;AxLwkmBA;EACE,SAAS;E+KxkmBX,SAAS;ESKL,+CAAU;AxLskmBd;;A+KtkmBA;ESKI,kBACH;ExLokmBC,MAAM;E+KtkmBR,QAAA;ESKI,gBACH;ExLmkmBC,aAAa;E+KrkmBf,UAAY;A/KukmBZ;;AAEA;EACE,0BAA0B;AwLhkmB5B;;AxLmkmBA;EACE,6BAA6B;E+K1kmB/B,yBAAgB;EAChB,iBAAgB;ESYd,eAAA;EACC,cAAY;ExLikmBb,kBAAkB;E+K1kmBpB,kBSYmB;EACf,cAAQ;ExLgkmBV,0BAA0B;A+KzkmB5B;;A/K4kmBA;;EwL3jmBI,6BAAW;EACX,yBAAY;EACZ,aAAW;AxL8jmBf;;A+KtkmBA;;E/K0kmBE,6BAA6B;A+KtkmB/B;;A/KykmBA;EwL1jmBI,+BAAU;AxL4jmBd;;A+KpkmBA;;EScI,YAAU;AxL2jmBd;;AAEA;EACE,kBAAkB;E+KnkmBpB,eSYc;AxLyjmBd;;A+KjkmBA;ESaI,gBAAQ;ExLwjmBV,kBAAkB;E+KjkmBpB,aAAe;ESaX,QAAQ;ExLujmBV,2BAA2B;E+KxnmB7B,6CSoEa;EACT,cAAQ;EACR,4DAAkB;AxLsjmBtB;;AAEA;EwLpjmBI;IxLsjmBA,gBAAgB;E+K/jmBpB;A/KikmBA;;AwL/imBA;ExLkjmBE,gBwLjjmBC;AxLkjmBH;;AAEA;E+K3jmBA,yBAAsB;A/K6jmBtB;;AAEA;EACE,cAAc;AwL5imBhB;;AxL+imBA;E+KxjmBA,kBAAU;AACV;;A/K2jmBA;EACE,0BAA0B;E+KvjmB5B,2BSaW;AxL4imBX;;AAEA;;EAEE;;;;;IwLnimBE,6BACH;IxLwimBG,8BAA8B;E+KnjmBlC;A/KqjmBA;;AAEA;EwLpimBA,eAAA;ExLsimBE,mBAAmB;AACrB;;AAEA;EwLnimBI,qBACH;AxLoimBD;;AAEA;EACE,yDAAoN;A+K9imBtN;;A/KijmBA;EwL/hmBA,qBAAA;AxLiimBA;;A+K1imBA;EScI,qCAAe;AxLgimBnB;;AAEA;EwL9hmBI,yBACH;ExL+hmBC,4DAA4D;E+K1imB9D,YAAA;EScE,cAAA;AxL+hmBF;;A+KzimBA;ESeE;IACA,gBAAW;ExL8hmBX;A+K1imBF;;A/K6imBA;EwL3hmBI,YAAW;ExL6hmBb,cAAc;A+KzimBhB;;A/K4imBA;E+KximBA,kBAAA;ESgBI,QAAQ;AxL2hmBZ;;AAEA;EACE,gBwLxhmBC;ATbH;;A/KwimBA;EwLthmBI,SAAM;EACN,yEACH;AxLuhmBD;;AAEA;EwLrhmBI,2EAAgC;AxLuhmBpC;;A+KlimBA;;ESiBI,yEACH;AxLqhmBD;;AAEA;EwLnhmBI,eAAW;EACX,mBACH;ExLohmBC,YAAY;A+KjimBd;;A/KoimBA;E+KhimBA,qBAAqB;A/KkimBrB;;A+K9hmBA;ESgBI,yDAAc;AxLkhmBlB;;AAEA;EwLhhmBI,qBAAgB;AxLkhmBpB;;AAEA;EwLhhmBI,qCACH;AxLihmBD;;AAEA;EwL/gmBI,qBAAW;EACX,yBAAS;AxLihmBb;;A+K5hmBA;ESgBI,yBAAmB;AxLghmBvB;;AAEA;EACE,qBAAqB;E+KlzmBvB,yBSwSa;AxL4gmBb;;AAEA;EwL1gmBI,yBnL6sB0C;AL+zkB9C;;AAEA;E+K9vmBA,qBSqPiB;EACb,yBACH;AxL0gmBD;;AAEA;EACE,yBAAyB;A+KzvmB3B;;A/K4vmBA;E+KxumBA,qBSkOc;EACV,yBnL7PmB;ALqwmBvB;;A+K/gmBA;EACA,yBAA2B;A/KkhmB3B;;AAEA;EwLjgmBI,qBAAmB;EACnB,yBAAgB;AxLmgmBpB;;AAEA;EwLjgmBI,yBAAY;AxLmgmBhB;;A+K9gmBA;ESiBI,qBAAqB;ExLigmBvB,yBAAyB;A+K9gmB3B;;A/KihmBA;EwLx/lBA,yBAAmB;AACnB;;AxL2/lBA;EwLv/lBA,qBAAmB;EACf,yBACH;AxLw/lBD;;AwLr/lBA;EACI,yBnLvUa;AL+zmBjB;;AAEA;EACE,qBAAqB;EwLp/lBvB,yBAAoB;AACpB;;AxLu/lBA;EwLn/lBA,yBAAsB;AxLq/lBtB;;AwLj/lBA;EACA,qBAAqB;EACjB,yBnLvVa;AL20mBjB;;AAEA;EACE,yBAAyB;AwLh/lB3B;;AxLm/lBA;EACE,kBAAkB;EwLh/lBpB,sBAAoB;AxLk/lBpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EwL9+lBpB,sBAAA;ATzDA;;A/K2imBA;EwL9+lBI,sBnLvYO;ALu3mBX;;AAEA;EACE,mBAAmB;E+KvimBrB,uBAAsB;A/KyimBtB;;AAEA;E+KtimBA,uBAAA;A/KwimBA;;AAEA;EwL5+lBI,eAAU;EACV,mBAAS;EACT,YAAW;AxL8+lBf;;A+KpimBA;ES2DI,qBAAY;AxL6+lBhB;;AAEA;EwL3+lBI,yDAAS;AxL6+lBb;;AAEA;EwL3+lBI,qBAAc;AxL6+lBlB;;AAEA;EACE,qCAAqC;A+KpimBvC;;A/KuimBA;EACE,kBAAkB;E+KnimBpB,gBAAA;ES2DI,WAAW;EACX,cACH;ExL0+lBC,SAAS;Eep4mBP,qBAAmB;Afs4mBvB;;AAEA;Ee33mBI,aAAQ;Af63mBZ;;AAEA;EyLx8mBA,yBACE;AzLy8mBF;;AAEA;EyL58mBA,mBAAA;EAMI,2BpL0Bc;AL+6mBlB;;AAEA;EACE,yBAAyB;AyLl9mB3B;;AzLq9mBA;EACE,yBAAyB;AyLt9mB3B;;AzLy9mBA;EACE,yBAAyB;AyL19mB3B;;AzL69mBA;EyLr8mBM,kBAAc;EACd,eACD;EzLs8mBH,MAAM;EyLh+mBR,OAAA;EA6BI,QAAO;EzLs8mBT,SAAS;EyLn+mBX,yBA+BE;EACE,8BACD;EzLq8mBD,6BAA6B;AyLn8mB/B;;AzLs8mBA;EACE,kByLn8mBiB;EzLo8mBjB,WyLn8mBI;EzLo8mBJ,YyLn8mBI;EzLo8mBJ,WyLn8mBa;EzLo8mBb,SyLn8mBI;EARN,WAAA;EzL68mBE,6ByLl8mBe;EzLm8mBf,yByLl8mByB;EzLm8mBzB,4DyLr8mBE;AzLs8mBJ;;AyLh9mBA;EAmBI,4BACD;AzLg8mBH;;AAEA;EyL97mBM,4BACD;EzL+7mBH,cAAc;E0K59mBhB,WAAA;EeiCE,OAAA;AzL87mBF;;AAEA;EyLj8mBA,cAAA;EzLm8mBE,6ByL77mBoB;EzL87mBpB,cyL77mBW;EzL87mBX,oByL57mBC;EzL67mBD,gBAAgB;E0LrgnBlB,kBAAA;E1LugnBE,iBAAiB;E0LrgnBjB,kBAAA;EACF,QAAK;EACH,oBAAkB;EADpB,MAGE;E1LsgnBA,kB0LrgnBE;E1LsgnBF,qB0LrgnBmB;E1LsgnBnB,gB0LrgnBe;E1LsgnBf,0B0LrgnBkB;A1LsgnBpB;;AAEA;EACE;I0LpgnBE,gBACD;EAbH;A1LmhnBA;;AAEA,uC0LlgnBK;A1LmgnBL;;E0L//mBE,sBAAa;EACb,0BAAkB;EAClB,0BAAa;;EAEb,gCAAyB;EACzB,iCAAgB;;EAEhB,kBAAgB;EAChB,mBAAA;;EAEA,yBAKD;E3KgCG,+BAA2B;Af89mB/B;;AAEA,8B0LhgnBC;A1LignBD;;E0L9/mBE,eAAc;EACd,qBACD;E1LggnBC,qBAAqB;E0L//mBvB,oBAAsB;A1LignBtB;;AAEA,2BAA2B;A0L9/mB3B;EACE,eAAY;A1LggnBd;;AAEA,+B0L//mBoB;A1LggnBpB;E0LpgnBA,0BAAyB;A1LsgnBzB;;AAEA,qC0L//mBgB;A1LggnBhB;;EAEE,0B0L//mBQ;A1LggnBV;;AAEA;EACE,qB0L//mBqB;A1LggnBvB;;AAEA;EACE,mBAAmB;A0L5/mBrB;;A1L+/mBA;E0L5/mBE,crLpDS;ALkjnBX;;A0L3/mBA;EACE,qBAAkB;A1L8/mBpB;;A0L3/mBA;EACE,yBACD;A1L6/mBD;;AAEA;E0L5/mBE,qBAAW;A1L8/mBb;;AAEA;E0L5/mBE,mBAAY;A1L8/mBd;;AAEA;EACE,c0Lr/mBgB;A1Ls/mBlB;;AAEA;E0L1gnBA,qBAwBe;A1Lo/mBf;;AAEA;EACE,uB0Ll/mBE;A1Lm/mBJ;;AAEA;E0L9+mBM,qBAAe;A1Lg/mBrB;;AAEA;E0L9+mBM,mBAAgB;A1Lg/mBtB;;AAEA;EACE,cAAc;A0L3/mBhB;;A1L8/mBA;E0L9/mBA,qBAaW;A1Lm/mBX;;AAEA;E0Lz+mBA,yBAA0B;AAC1B;;AAEA;EACA,qBAAW;AACX;;A1L4+mBA;EACE,mBAAmB;A0Lz+mBrB;;A1L4+mBA;E0Lz+mBA,cAAa;A1L2+mBb;;A0Lx+mBA;EACA,qBAAa;A1L2+mBb;;AAEA;EACE,yBAAyB;A0Lx+mB3B;;A1L2+mBA;E0Lx+mBA,qBAAkB;AAClB;;A1L2+mBA;E0Lx+mBE,mBAAmB;A1L0+mBrB;;AAEA;E0Lx+mBE,cAAa;A1L0+mBf;;AAEA;E0Lx+mBE,qBAAY;A1L0+mBd;;AAEA;E0Lz+mBE,yBACD;A1L0+mBD;;AAEA;E0Lz+mBE,qBAAe;A1L2+mBjB;;AAEA;E0Lz+mBE,mBAAY;A1L2+mBd;;AAEA;E0Lz+mBA,cAAa;AACb;;A1L4+mBA;E0Lz+mBE,qBAAY;A1L2+mBd;;AAEA;E0Lz+mBE,yBAAsB;A1L2+mBxB;;A0Lv+mBA;EAAA,qBAEc;AAFd;;AAAA;EAMI,mBACD;A1Lw+mBH;;A0Lp+mBA;EACE,cAAc;A1Lu+mBhB;;AAEA;E0Lv+mB6B,qBAAA;A1Ly+mB7B;;AAEA;E0Lz+mB0B,yBAAa;A1L2+mBvC;;AAEA;EACE,qBAAqB;A0Lz+mBvB;;A1L4+mBA;E0Lz+mBE,mBAAc;A1L2+mBhB;;A0Lx+mBA;EACE,cAAQ;A1L2+mBV;;AAEA;EACE,qBAAqB;A0Lx+mBvB;;A1L2+mBA;E0Lx+mBE,yBACD;A1Ly+mBD;;AAEA;EACE,qBAAqB;A0Lv+mBvB;;A1L0+mBA;EACE,mBAAmB;A0Lt+mBrB;;A1Ly+mBA;E0Lt+mBE,cAAU;A1Lw+mBZ;;A0Lr+mBA;EACE,qBAAe;A1Lw+mBjB;;A0Lp+mBA;EACE,yBACD;A1Ls+mBD;;AAEA;E0Ln+mBI,kBAAW;A1Lq+mBf;;AAEA;EACE,gBAAgB;A0L3+mBlB;;A1L8+mBA;EACE,WAAW;A0Lj+mBb;;A1Lo+mBA;E0Lp+mBA,kBAIY;A1Lk+mBZ;;AAEA;EACE,uB0Lj+mBc;A1Lk+mBhB;;A0L99mBA;EAGM,kBrLlPW;ALitnBjB;;AAEA;E0L19mBA,gBAAA;A1L49mBA;;AAEA;E0L19mBA,WAAY;A1L49mBZ;;AAEA;E0L19mBE,kBAAkB;A1L49mBpB;;AAEA;E0L19mBE,uBAAe;A1L49mBjB;;AAEA;E0L19mB+B,mBAAgB;A1L49mB/C;;AAEA;E0L59mB4B,iBAAe;A1L89mB3C;;AAEA;E0L99mByB,YAAA;A1Lg+mBzB;;A0L79mBA;EACE,mBAAgB;A1Lg+mBlB;;A0L1gnBA;EA8CE,yBAAkB;A1Lg+mBpB;;A0L59mBA;;;;E1Lk+mBE,qBAAqB;A0L59mBvB;;A1L+9mBA;E0L59mBE,gBAAgB;A1L89mBlB;;A0L39mBA;EACE,oBAAoB;EAFtB,mBAGE;A1L89mBF;;AAEA;;EAEE,kB0L/9mBa;E1Lg+mBb,e0L/9mBc;E1Lg+mBd,oB0L/9mBmB;A1Lg+mBrB;;AAEA;EACE,oB0L/9mBoB;A1Lg+mBtB;;AAEA;EACE,kB0L3+mBA;E1L4+mBA,mB0L5+mBA;E1L6+mBA,mB0L9+mBA;E1L++mBA,yB0L/+mBS;E1Lg/mBT,gB0Lh/mBA;A1Li/mBF;;AAEA;EACE,c0Ln/mBA;A1Lo/mBF;;AAEA;EACE,cAAc;A0Lp+mBhB;;A1Lu+mBA;;E0Lv+mBA,yBAAa;A1L0+mBb;;AAEA;;;;;;;E0L79mBE,YAAM;A1Lq+mBR;;A2L12nBA;EAGI,gBAAe;EACf,iBAAc;A3L22nBlB;;AAEA;E2Lz2nBI,gBAAgB;EAChB,wBAAsB;A3L22nB1B;;AAEA;E2Lz2nBI,gBAAW;EACX,wBAAqB;A3L22nBzB;;AAEA;E2Lz2nBI,mBAAS;EACT,eAAa;A3L22nBjB;;AAEA;E2Lz2nBI,cAAQ;E3L22nBV,iBAAiB;E4Ll4nBnB,mBACS;EACL,yBAAwB;EACxB,gBAAgB;EAChB,mBAAO;A5Lm4nBX;;AAEA;;EAEE,yB4Lj4nBa;A5Lk4nBf;;AAEA;;EAEE,yB4L/4nBM;A5Lg5nBR;;AAEA;EACE,qB4Lx3nBG;EA5BL,mBACQ;E5Lq5nBN,c4Lv3nBa;E5Lw3nBb,kBK/inBgC;ALgjnBlC;;AAEA;EACE,cKhnmBgB;ALinmBlB;;AAEA;EACE,mB4Lp3nBkB;A5Lq3nBpB;;AAEA;EgL95nBA,WAAa;AhLg6nBb;;AgLlxnBA;Ea9IE,mBACD;A7Lm6nBD;;AAEA;E8Lx6nBI,gBAAS;A9L06nBb;;AAEA;E8Lx6nBI,gBAAA;EACA,kBAAkB;EAClB,kBAAgB;EAChB,kBAAkB;E9L06nBpB,uBAAuB;E8Lv6nBzB,oBAAc;A9Ly6nBd;;A8Lr6nBA;EACI,WAAA;EACA,kBAAgB;EAChB,OAAM;EACN,QAAO;EACP,UAAS;EACT,cAAa;EACb,mBAAkB;EAClB,yBAAuB;A9Lw6nB3B;;AAEA;E8Lt6nBI,oBAAgB;EAChB,kBAAa;A9Lw6nBjB;;AAEA;EACE,kBAAkB;E8Lr6nBpB,SAAW;EACP,WAAA;A9Lu6nBJ;;AAEA;E8Lr6nBI,cAAS;EACT,mBAAa;EACb,gBAAA;A9Lu6nBJ;;AAEA;E8Lr6nBI,mBAAmB;EACnB,iCAAsB;EACtB,mCAAqB;A9Lu6nBzB;;A8Ln6nBA;EACI;IACA,gBAAkB;E9Ls6nBpB;A8Ln6nBF;;A9Ls6nBA;E8Ll6nBA,cAAY;AACZ;;A9Lq6nBA;E8Ll6nBI,oCAAgB;A9Lo6nBpB;;AAEA;E8Ll6nBI,oCACH;A9Lm6nBD;;AAEA;EACE,UAAU;E8Lh6nBZ,eAAY;EACR,6BAAyB;E9Lk6nB3B,gBAAgB;A8L/5nBlB;;A9Lk6nBA;E8L95nBA,6BAA4B;EAC5B,gBAAY;EACR,eAAS;A9Lg6nBb;;AAEA;E8L95nBI,uBAAuB;A9Lg6nB3B;;A8L55nBA;EACA,uBAAsB;A9L+5nBtB;;A8L35nBA;EACA,2BAA4B;A9L85nB5B;;A8L15nBA;EACA,6BAA4B;A9L65nB5B;;A8Lz5nBA;EACA,yBAAsB;EAClB,qBACH;E9L25nBC,gBAAgB;A8Lz5nBlB;;A9L45nBA;E8Lx5nBA,yBAAsB;A9L05nBtB;;A8Lt5nBA;EACI,yEACH;E9Lw5nBC,SAAS;E8Lt5nBX,iCAAsB;A9Lw5nBtB;;AAEA;E8Lr5nBA,2EAAuC;A9Lu5nBvC;;A8Ln5nBA;;;EAGI,0BAAQ;A9Ls5nBZ;;AAEA;E8Lp5nBI,qBAAQ;A9Ls5nBZ;;AAEA;E8Ln5nBA,+CAA6C;EACzC,sBAAc;EACd,iCAAuB;A9Lq5nB3B;;AAEA;E8Ll5nBA;IACI,gBAAc;EACd;A9Lo5nBJ;;AAEA;E8Lj5nBA,gBAAY;A9Lm5nBZ;;AAEA;E8Lj5nBI,gBAAS;A9Lm5nBb;;AAEA;E8Lj5nBI,4DAA6B;A9Lm5nBjC;;AAEA;EACE;I8Lh5nBF,gBAAY;EACR;A9Lk5nBJ;;AAEA;EACE,mBAAmB;A8L94nBrB;;A9Li5nBA;E8L74nBA,cAAY;A9L+4nBZ;;A8L34nBA;EACI,eAAe;A9L84nBnB;;A8L14nBA;EACI,cAAA;A9L64nBJ;;AAEA;E8L34nBI,cAAS;EACT,eAAa;A9L64nBjB;;AAEA;E8L34nBI,eAAc;EACd,gBAAA;A9L64nBJ;;AAEA;E8L14nBA,yEAAmB;EACf,SAAA;EACA,iCAAkB;A9L44nBtB;;AAEA;;EAEE,SAAS;E8Lz4nBX,gBAAkB;AAClB;;A9L44nBA;E8Lz4nBI,sFAAW;A9L24nBf;;AAEA;E8Lz4nBI,gBAAgB;A9L24nBpB;;AAEA;E8Lx4nBA,UAAY;EACZ,eAAY;EACR,6BAAmB;A9L04nBvB;;AAEA;;EAEE,UAAU;E8Lv4nBZ,mBAAY;EACR,eAAS;EACT,6BAAkB;A9Ly4nBtB;;AAEA;EACE,6EAA6E;A8Lt4nB/E;;A9Ly4nBA;E8Lt4nBI,cAAQ;EACR,sBAAS;EACT,qBAAQ;A9Lw4nBZ;;AAEA;E8Lt4nBI,qBAAa;A9Lw4nBjB;;AAEA;E8Lt4nBI,gBACJ;A9Lu4nBA;;AAEA;E8Lr4nBI,WAAW;E9Lu4nBb,wCAAwC;E8Lp4nB1C,qBAAuB;A9Ls4nBvB;;AAEA;E8Lp4nBI,wCAAM;EACN,yBAAS;A9Ls4nBb;;AAEA;EACE,+BAA+B;A8Ln4nBjC;;A9Ls4nBA;E8Ln4nBI,WAAM;EACN,wCAAoB;EACpB,qBAAoB;A9Lq4nBxB;;AAEA;E8Ln4nBI,WAAA;EACA,wCAAsB;EACtB,qBAAqB;A9Lq4nBzB;;AAEA;;E8Lh4nBA,kBAAY;A9Lm4nBZ;;A8L/3nBA;;E9Lm4nBE,aAAa;E8L/3nBf,WAAW;EACP,YAAY;E9Li4nBd,iBAAiB;E8L93nBnB,kBAAY;EACR,0BAAU;EACV,kBAAS;EACT,WAAS;EACT,QAAO;EACP,2BAAyB;EACzB,kBAAe;EACf,cAAA;EACA,UAAA;A9Lg4nBJ;;AAEA;;E8L73nBI,iBAAY;A9Lg4nBhB;;AAEA;E8L73nBA,gBAAY;EACZ,cAAY;EACR,yBAAkB;A9L+3nBtB;;AAEA;E8L73nBI,sBAAkB;A9L+3nBtB;;AAEA;E8L53nBA,cAAY;A9L83nBZ;;AAEA;E8L53nBI,gBAAc;EACd,cAAW;EACX,yBAAY;A9L83nBhB;;AAEA;E8L53nBI,sBAAc;A9L83nBlB;;AAEA;E8L53nBI,cAAQ;A9L83nBZ;;A8L13nBA;;EAEI,cAAQ;E9L63nBV,gBAAgB;E8L13nBlB,cAAY;EACR,uBAAY;EACZ;mC9L43nB+B;E8Lz3nBnC,mBAAY;EACZ,sBAAwB;EACpB,cAAA;A9L23nBJ;;AAEA;;E8Lv3nBA,gBAAY;A9L03nBZ;;AAEA;E8Lx3nBI,kBAAkB;A9L03nBtB;;AAEA;E8Lx3nBI,WAAS;EACT,YAAA;A9L03nBJ;;AAEA;;E8Lv3nBI,kBAAe;A9L03nBnB;;AAEA;E8Lx3nBI,kBAAe;EACf,4BAAiB;A9L03nBrB;;AAEA;E8Lv3nBI,WAAQ;EACR,YAAW;A9Ly3nBf;;AAEA;;E8Lp3nBA,kBAAY;A9Lu3nBZ;;AAEA;E8Lp3nBA,4BAAyB;A9Ls3nBzB;;A8Ll3nBA;EACI,WAAS;EACT,YAAU;A9Lq3nBd;;AAEA;;E8Ll3nBI,kBAAY;A9Lq3nBhB;;AAEA;E8Ln3nBI,4BAAa;A9Lq3nBjB;;A8Lj3nBA;EACI,WAAS;EACT,YAAU;A9Lo3nBd;;AAEA;;E8Lj3nBI,kBAAY;A9Lo3nBhB;;AAEA;E8Ll3nBI,4BACH;A9Lm3nBD;;AAEA;E8Lj3nBI,cAAc;EACd,eAAY;A9Lm3nBhB;;AAEA;;E8Lh3nBI,iBAAO;A9Lm3nBX;;AAEA;EACE,+BAA+B;A8Lh3nBjC;;A9Lm3nBA;E8Lh3nBI,qBAAmB;E9Lk3nBrB,qBAAqB;E8L/2nBvB,cAAY;EACR,mBAAmB;A9Li3nBvB;;A8L72nBA;EACA,eAAY;A9Lg3nBZ;;AAEA;E8L92nBI,sBAAsB;EACtB,gBAAe;EACf,cAAa;A9Lg3nBjB;;AAEA;E+Lh1oBE,cAAQ;A/Lk1oBV;;AAEA;;;EAGE,c+Lh1oBa;A/Li1oBf;;AmFp1oBA;;EnFw1oBE,cAAc;AgM91oBhB;;AhMi2oBA;;EgM71oBE,cAAc;AhMg2oBhB;;AAEA;;EiMn2oBA,cAAa;AjMs2oBb;;AiMn2oBA;EACE,kBAAkB;EjMs2oBlB,sBAAsB;AiMp2oBxB;;AjMu2oBA;E2Gx2oBgB,aAAA;EuFNR,kBAAkB;ElMi3oBxB,oBAAoB;E2G32oBN,mBAAA;EuFNR,uBAAkB;ElMo3oBxB,kBAAkB;A2G92oBJ;;A3Gi3oBhB;;EkMv3oBQ,kBAAkB;AlM03oB1B;;AAEA;;E2Gt3oBgB,mBAAA;A3Gy3oBhB;;A2Gz3oBgB;;E3G63oBd,mBAAmB;A2G73oBL;;A3Gg4oBhB;;EkMt4oBQ,iBAAgB;AlMy4oBxB;;AAEA;EACE,WAAW;E2Gt4oBG,YAAA;A3Gw4oBhB;;A2Gx4oBgB;EuFNR,cAAA;ElMk5oBN,0CAA0C;AmMp5oB5C;;AnMu5oBA;EmMv5oBA,cAIG;EACC,0CACD;AnMo5oBH;;AAEA;EACE,cAAc;EoM75oBhB,yCAAqB;ApM+5oBrB;;AqM/5oBA;EACE,cAAE;ErMk6oBF,yCqMj6oBY;ArMk6oBd;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,mDAAmD;EACrD;;EAEA;IACE,cAAc;IACd,oDAAoD;EACtD;;EAEA;IACE,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,+DAA+D;IAC/D,4DAA4D;EAC9D;;EAEA;IACE,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0DAA0Q;AAC5Q;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;;;IAIE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB;uEACmE;IACnE,kDAAkD;EACpD;;EAEA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,+DAA+D;IAC/D,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,6BAAoB;EAApB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,MAAM;EACN,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;EAOE;;AAEF;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;;IAOE;;EAEF;IACE,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,+DAA+D;EAC/D,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,gDAAgD;IAChD,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;EAME,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2EAA2E;EAC3E,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAoB;EAApB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gCAAgC;EAChC,gDAAgD;EAChD,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iDAAgP;EAChP,oBAAoB;AACtB;;AAEA;EACE,iDAAgP;EAChP,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;;EAIE,mDAAmD;AACrD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;;EAIE,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;;EAIE,mDAAmD;AACrD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;;;EAIE,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE;IACE,kFAAkF;EACpF;;EAEA;IACE,kFAAkF;EACpF;AACF;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB;qEACmE;AACrE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE;AACF;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EAIE,8DAA8D;AAChE;;AAEA;EAIE,0DAA0D;AAC5D;;AAEA;EAIE,+DAA+D;AACjE;;AAEA;EAIE,0DAA0D;AAC5D;;AAEA;EAIE,+DAA+D;AACjE;;AAEA;EAIE,mEAAmE;AACrE;;AAEA;EAIE,mEAAmE;AACrE;;AAEA;EAIE,gEAAgE;AAClE;;AAEA;EAIE,gEAAgE;AAClE;;AAEA;EAIE,0DAA0D;AAC5D;;AAEA;EAIE,iEAAiE;AACnE;;AAEA;EAIE,oDAAoD;AACtD;;AAEA;EAIE,kEAAkE;AACpE;;AAEA;EAIE,kEAAkE;AACpE;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;EAC5E,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE;AACF;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,UAAU;AACZ;;AAEA;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAEE,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EAEE,6BAA6B;EAC7B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kDAAkD;EAClD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,4DAA4D;AAC9D;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,6EAA6E;AAC/E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,qCAAqC;EACrC,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB;gEAC8D;AAChE;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,mCAAmC;EACnC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB;gEAC8D;AAChE;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,UAAU;EACV,2EAA2E;AAC7E;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,2EAA2E;AAC7E;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE;mCACiC;AACnC;;AAEA;;;;EAIE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;EAME,iDAAiD;AACnD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,2EAA2E;EAC3E,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE;oCACkC;AACpC;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;EACZ,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA,uDAAuD;AACvD;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,OAAO;EACP,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAKE,kBAAkB;AACpB;;AAEA;;EAEE,iEAAiE;EACjE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,uDAAuD;AACvD;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;;EAEE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gEAAgE;EAChE,wBAAwB;EACxB,UAAU;EAGV,kBAAkB;EAKlB,+BAA+B;AACjC;;AAEA;;EAEE,iEAAiE;EACjE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;;EAEE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oDAAqqB;EAUrqB,+DAA+D;EAG/D,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oDAAqqB;EAUrqB,+DAA+D;EAC/D,yBAAyB;EAGzB,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;;EAEE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,yBAAyB;EAGzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,kDAAkD;AAClD;;EAEE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,OAAO;EACP,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;EAGZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EAGV,mBAAmB;EAKnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EAGzB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,SAAS;EACT,SAAS;EAKT,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,QAAQ;EAKR,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;;EAEE,gBAAgB;EAChB,iEAAiE;EACjE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,WAAW;EAGX,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA,wDAAwD;AACxD;;EAEE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EAGf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,4DAA4D;AAC9D;;AAEA;;EAEE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;;;EAIE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,6EAA6E;AAC/E;;AAEA;;;;EAIE,cAAc;EACd,UAAU;AACZ;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;EAaE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EAKf,6BAA6B;AAC/B;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;EAGE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;EAEd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;AACF;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;EAC5E,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE;AACF;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,UAAU;AACZ;;AAEA;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAEE,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EAEE,6BAA6B;EAC7B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kDAAkD;EAClD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;EAKE,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,gDAAgD;EAChD,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EAExB,cAAc;EAEd,YAAY;EAEZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EAKd,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EAExB,cAAc;EAEd,YAAY;EAEZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;EAgBE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,2EAA2E;EAC3E,gBAAgB;EAChB,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAGE,YAAY;EAGZ,aAAa;EAIb,sBAAsB;EAGtB,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EAGE,cAAc;EAGd,aAAa;EAIb,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,mEAAmE;EACnE,qCAAqC;AACvC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EAGE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EAGd,aAAa;EAIb,sBAAsB;EAGtB,oBAAoB;AACtB;;AAEA;EAGE,cAAc;EAGd,oBAAoB;AACtB;;AAEA;;EAIE,SAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EAET,+CAA+C;EAC/C,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;EACxC,4DAA4D;EAC5D,eAAe;AACjB;;AAEA;EAEE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EAGE,cAAc;EAGd,aAAa;EAIb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EAGV,aAAa;EAGb,8BAA8B;EAG9B,oBAAoB;EAEpB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EAExB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAIE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EAGE,WAAS;EACT,kBAAkB;EAClB,gBAAgB;EAGhB,aAAa;EAIb,mBAAmB;EAEnB,eAAe;EAGf,mBAAmB;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EAER,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,eAAe;EACf,yBAAyB;EAEzB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/*!\r\n\r\n=========================================================\r\n* Argon Dashboard PRO React - v1.2.5\r\n=========================================================\r\n\r\n* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react\r\n* Copyright 2024 Creative Tim (https://www.creative-tim.com)\r\n\r\n* Coded by www.creative-tim.com\r\n\r\n=========================================================\r\n\r\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\n*/\r\n/*******************************************************************************\r\n *              bootstrap-rtl (version 3.3.4)\r\n *      Author: Morteza Ansarinia (http://github.com/morteza)\r\n *  Created on: August 13,2015\r\n *     Project: bootstrap-rtl\r\n *   Copyright: Unlicensed Public Domain\r\n *******************************************************************************/\r\nhtml.rtl {\r\n  direction: rtl;\r\n}\r\n\r\n.rtl {\r\n  /*# sourceMappingURL=bootstrap-rtl.css.map */\r\n}\r\n\r\n.rtl body {\r\n  direction: rtl;\r\n}\r\n\r\n.rtl .flip.text-left {\r\n  text-align: right;\r\n}\r\n\r\n.rtl .flip.text-right {\r\n  text-align: left;\r\n}\r\n\r\n.rtl .list-unstyled {\r\n  padding-right: 0;\r\n  padding-left: initial;\r\n}\r\n\r\n.rtl .list-inline {\r\n  padding-right: 0;\r\n  padding-left: initial;\r\n  margin-right: -5px;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl dd {\r\n  margin-right: 0;\r\n  margin-left: initial;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .dl-horizontal dt {\r\n    float: right;\r\n    clear: right;\r\n    text-align: left;\r\n  }\r\n\r\n  .rtl .dl-horizontal dd {\r\n    margin-right: 180px;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.rtl blockquote {\r\n  border-right: 5px solid #eeeeee;\r\n  border-left: 0;\r\n}\r\n\r\n.rtl .blockquote-reverse,\r\n.rtl blockquote.pull-left {\r\n  padding-left: 15px;\r\n  padding-right: 0;\r\n  border-left: 5px solid #eeeeee;\r\n  border-right: 0;\r\n  text-align: left;\r\n}\r\n\r\n.rtl .col-xs-1,\r\n.rtl .col-sm-1,\r\n.rtl .col-md-1,\r\n.rtl .col-lg-1,\r\n.rtl .col-xs-2,\r\n.rtl .col-sm-2,\r\n.rtl .col-md-2,\r\n.rtl .col-lg-2,\r\n.rtl .col-xs-3,\r\n.rtl .col-sm-3,\r\n.rtl .col-md-3,\r\n.rtl .col-lg-3,\r\n.rtl .col-xs-4,\r\n.rtl .col-sm-4,\r\n.rtl .col-md-4,\r\n.rtl .col-lg-4,\r\n.rtl .col-xs-5,\r\n.rtl .col-sm-5,\r\n.rtl .col-md-5,\r\n.rtl .col-lg-5,\r\n.rtl .col-xs-6,\r\n.rtl .col-sm-6,\r\n.rtl .col-md-6,\r\n.rtl .col-lg-6,\r\n.rtl .col-xs-7,\r\n.rtl .col-sm-7,\r\n.rtl .col-md-7,\r\n.rtl .col-lg-7,\r\n.rtl .col-xs-8,\r\n.rtl .col-sm-8,\r\n.rtl .col-md-8,\r\n.rtl .col-lg-8,\r\n.rtl .col-xs-9,\r\n.rtl .col-sm-9,\r\n.rtl .col-md-9,\r\n.rtl .col-lg-9,\r\n.rtl .col-xs-10,\r\n.rtl .col-sm-10,\r\n.rtl .col-md-10,\r\n.rtl .col-lg-10,\r\n.rtl .col-xs-11,\r\n.rtl .col-sm-11,\r\n.rtl .col-md-11,\r\n.rtl .col-lg-11,\r\n.rtl .col-xs-12,\r\n.rtl .col-sm-12,\r\n.rtl .col-md-12,\r\n.rtl .col-lg-12 {\r\n  position: relative;\r\n  min-height: 1px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.rtl .col-xs-1,\r\n.rtl .col-xs-2,\r\n.rtl .col-xs-3,\r\n.rtl .col-xs-4,\r\n.rtl .col-xs-5,\r\n.rtl .col-xs-6,\r\n.rtl .col-xs-7,\r\n.rtl .col-xs-8,\r\n.rtl .col-xs-9,\r\n.rtl .col-xs-10,\r\n.rtl .col-xs-11,\r\n.rtl .col-xs-12 {\r\n  float: right;\r\n}\r\n\r\n.rtl .col-xs-12 {\r\n  width: 100%;\r\n}\r\n\r\n.rtl .col-xs-11 {\r\n  width: 91.66666667%;\r\n}\r\n\r\n.rtl .col-xs-10 {\r\n  width: 83.33333333%;\r\n}\r\n\r\n.rtl .col-xs-9 {\r\n  width: 75%;\r\n}\r\n\r\n.rtl .col-xs-8 {\r\n  width: 66.66666667%;\r\n}\r\n\r\n.rtl .col-xs-7 {\r\n  width: 58.33333333%;\r\n}\r\n\r\n.rtl .col-xs-6 {\r\n  width: 50%;\r\n}\r\n\r\n.rtl .col-xs-5 {\r\n  width: 41.66666667%;\r\n}\r\n\r\n.rtl .col-xs-4 {\r\n  width: 33.33333333%;\r\n}\r\n\r\n.rtl .col-xs-3 {\r\n  width: 25%;\r\n}\r\n\r\n.rtl .col-xs-2 {\r\n  width: 16.66666667%;\r\n}\r\n\r\n.rtl .col-xs-1 {\r\n  width: 8.33333333%;\r\n}\r\n\r\n.rtl .col-xs-pull-12 {\r\n  left: 100%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-11 {\r\n  left: 91.66666667%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-10 {\r\n  left: 83.33333333%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-9 {\r\n  left: 75%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-8 {\r\n  left: 66.66666667%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-7 {\r\n  left: 58.33333333%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-6 {\r\n  left: 50%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-5 {\r\n  left: 41.66666667%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-4 {\r\n  left: 33.33333333%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-3 {\r\n  left: 25%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-2 {\r\n  left: 16.66666667%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-1 {\r\n  left: 8.33333333%;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-pull-0 {\r\n  left: auto;\r\n  right: auto;\r\n}\r\n\r\n.rtl .col-xs-push-12 {\r\n  right: 100%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-11 {\r\n  right: 91.66666667%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-10 {\r\n  right: 83.33333333%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-9 {\r\n  right: 75%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-8 {\r\n  right: 66.66666667%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-7 {\r\n  right: 58.33333333%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-6 {\r\n  right: 50%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-5 {\r\n  right: 41.66666667%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-4 {\r\n  right: 33.33333333%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-3 {\r\n  right: 25%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-2 {\r\n  right: 16.66666667%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-1 {\r\n  right: 8.33333333%;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-push-0 {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-12 {\r\n  margin-right: 100%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-11 {\r\n  margin-right: 91.66666667%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-10 {\r\n  margin-right: 83.33333333%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-9 {\r\n  margin-right: 75%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-8 {\r\n  margin-right: 66.66666667%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-7 {\r\n  margin-right: 58.33333333%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-6 {\r\n  margin-right: 50%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-5 {\r\n  margin-right: 41.66666667%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-4 {\r\n  margin-right: 33.33333333%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-3 {\r\n  margin-right: 25%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-2 {\r\n  margin-right: 16.66666667%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-1 {\r\n  margin-right: 8.33333333%;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .col-xs-offset-0 {\r\n  margin-right: 0%;\r\n  margin-left: 0;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\r\n  .rtl .col-sm-1,\r\n  .rtl .col-sm-2,\r\n  .rtl .col-sm-3,\r\n  .rtl .col-sm-4,\r\n  .rtl .col-sm-5,\r\n  .rtl .col-sm-6,\r\n  .rtl .col-sm-7,\r\n  .rtl .col-sm-8,\r\n  .rtl .col-sm-9,\r\n  .rtl .col-sm-10,\r\n  .rtl .col-sm-11,\r\n  .rtl .col-sm-12 {\r\n    float: right;\r\n  }\r\n\r\n  .rtl .col-sm-12 {\r\n    width: 100%;\r\n  }\r\n\r\n  .rtl .col-sm-11 {\r\n    width: 91.66666667%;\r\n  }\r\n\r\n  .rtl .col-sm-10 {\r\n    width: 83.33333333%;\r\n  }\r\n\r\n  .rtl .col-sm-9 {\r\n    width: 75%;\r\n  }\r\n\r\n  .rtl .col-sm-8 {\r\n    width: 66.66666667%;\r\n  }\r\n\r\n  .rtl .col-sm-7 {\r\n    width: 58.33333333%;\r\n  }\r\n\r\n  .rtl .col-sm-6 {\r\n    width: 50%;\r\n  }\r\n\r\n  .rtl .col-sm-5 {\r\n    width: 41.66666667%;\r\n  }\r\n\r\n  .rtl .col-sm-4 {\r\n    width: 33.33333333%;\r\n  }\r\n\r\n  .rtl .col-sm-3 {\r\n    width: 25%;\r\n  }\r\n\r\n  .rtl .col-sm-2 {\r\n    width: 16.66666667%;\r\n  }\r\n\r\n  .rtl .col-sm-1 {\r\n    width: 8.33333333%;\r\n  }\r\n\r\n  .rtl .col-sm-pull-12 {\r\n    left: 100%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-11 {\r\n    left: 91.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-10 {\r\n    left: 83.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-9 {\r\n    left: 75%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-8 {\r\n    left: 66.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-7 {\r\n    left: 58.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-6 {\r\n    left: 50%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-5 {\r\n    left: 41.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-4 {\r\n    left: 33.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-3 {\r\n    left: 25%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-2 {\r\n    left: 16.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-1 {\r\n    left: 8.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-pull-0 {\r\n    left: auto;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-sm-push-12 {\r\n    right: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-11 {\r\n    right: 91.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-10 {\r\n    right: 83.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-9 {\r\n    right: 75%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-8 {\r\n    right: 66.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-7 {\r\n    right: 58.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-6 {\r\n    right: 50%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-5 {\r\n    right: 41.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-4 {\r\n    right: 33.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-3 {\r\n    right: 25%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-2 {\r\n    right: 16.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-1 {\r\n    right: 8.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-push-0 {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-12 {\r\n    margin-right: 100%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-11 {\r\n    margin-right: 91.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-10 {\r\n    margin-right: 83.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-9 {\r\n    margin-right: 75%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-8 {\r\n    margin-right: 66.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-7 {\r\n    margin-right: 58.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-6 {\r\n    margin-right: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-5 {\r\n    margin-right: 41.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-4 {\r\n    margin-right: 33.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-3 {\r\n    margin-right: 25%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-2 {\r\n    margin-right: 16.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-1 {\r\n    margin-right: 8.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-sm-offset-0 {\r\n    margin-right: 0%;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\r\n  .rtl .col-md-1,\r\n  .rtl .col-md-2,\r\n  .rtl .col-md-3,\r\n  .rtl .col-md-4,\r\n  .rtl .col-md-5,\r\n  .rtl .col-md-6,\r\n  .rtl .col-md-7,\r\n  .rtl .col-md-8,\r\n  .rtl .col-md-9,\r\n  .rtl .col-md-10,\r\n  .rtl .col-md-11,\r\n  .rtl .col-md-12 {\r\n    float: right;\r\n  }\r\n\r\n  .rtl .col-md-12 {\r\n    width: 100%;\r\n  }\r\n\r\n  .rtl .col-md-11 {\r\n    width: 91.66666667%;\r\n  }\r\n\r\n  .rtl .col-md-10 {\r\n    width: 83.33333333%;\r\n  }\r\n\r\n  .rtl .col-md-9 {\r\n    width: 75%;\r\n  }\r\n\r\n  .rtl .col-md-8 {\r\n    width: 66.66666667%;\r\n  }\r\n\r\n  .rtl .col-md-7 {\r\n    width: 58.33333333%;\r\n  }\r\n\r\n  .rtl .col-md-6 {\r\n    width: 50%;\r\n  }\r\n\r\n  .rtl .col-md-5 {\r\n    width: 41.66666667%;\r\n  }\r\n\r\n  .rtl .col-md-4 {\r\n    width: 33.33333333%;\r\n  }\r\n\r\n  .rtl .col-md-3 {\r\n    width: 25%;\r\n  }\r\n\r\n  .rtl .col-md-2 {\r\n    width: 16.66666667%;\r\n  }\r\n\r\n  .rtl .col-md-1 {\r\n    width: 8.33333333%;\r\n  }\r\n\r\n  .rtl .col-md-pull-12 {\r\n    left: 100%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-11 {\r\n    left: 91.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-10 {\r\n    left: 83.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-9 {\r\n    left: 75%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-8 {\r\n    left: 66.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-7 {\r\n    left: 58.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-6 {\r\n    left: 50%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-5 {\r\n    left: 41.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-4 {\r\n    left: 33.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-3 {\r\n    left: 25%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-2 {\r\n    left: 16.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-1 {\r\n    left: 8.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-pull-0 {\r\n    left: auto;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-md-push-12 {\r\n    right: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-11 {\r\n    right: 91.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-10 {\r\n    right: 83.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-9 {\r\n    right: 75%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-8 {\r\n    right: 66.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-7 {\r\n    right: 58.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-6 {\r\n    right: 50%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-5 {\r\n    right: 41.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-4 {\r\n    right: 33.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-3 {\r\n    right: 25%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-2 {\r\n    right: 16.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-1 {\r\n    right: 8.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-push-0 {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-12 {\r\n    margin-right: 100%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-11 {\r\n    margin-right: 91.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-10 {\r\n    margin-right: 83.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-9 {\r\n    margin-right: 75%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-8 {\r\n    margin-right: 66.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-7 {\r\n    margin-right: 58.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-6 {\r\n    margin-right: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-5 {\r\n    margin-right: 41.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-4 {\r\n    margin-right: 33.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-3 {\r\n    margin-right: 25%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-2 {\r\n    margin-right: 16.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-1 {\r\n    margin-right: 8.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-md-offset-0 {\r\n    margin-right: 0%;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n\r\n  .rtl .col-lg-1,\r\n  .rtl .col-lg-2,\r\n  .rtl .col-lg-3,\r\n  .rtl .col-lg-4,\r\n  .rtl .col-lg-5,\r\n  .rtl .col-lg-6,\r\n  .rtl .col-lg-7,\r\n  .rtl .col-lg-8,\r\n  .rtl .col-lg-9,\r\n  .rtl .col-lg-10,\r\n  .rtl .col-lg-11,\r\n  .rtl .col-lg-12 {\r\n    float: right;\r\n  }\r\n\r\n  .rtl .col-lg-12 {\r\n    width: 100%;\r\n  }\r\n\r\n  .rtl .col-lg-11 {\r\n    width: 91.66666667%;\r\n  }\r\n\r\n  .rtl .col-lg-10 {\r\n    width: 83.33333333%;\r\n  }\r\n\r\n  .rtl .col-lg-9 {\r\n    width: 75%;\r\n  }\r\n\r\n  .rtl .col-lg-8 {\r\n    width: 66.66666667%;\r\n  }\r\n\r\n  .rtl .col-lg-7 {\r\n    width: 58.33333333%;\r\n  }\r\n\r\n  .rtl .col-lg-6 {\r\n    width: 50%;\r\n  }\r\n\r\n  .rtl .col-lg-5 {\r\n    width: 41.66666667%;\r\n  }\r\n\r\n  .rtl .col-lg-4 {\r\n    width: 33.33333333%;\r\n  }\r\n\r\n  .rtl .col-lg-3 {\r\n    width: 25%;\r\n  }\r\n\r\n  .rtl .col-lg-2 {\r\n    width: 16.66666667%;\r\n  }\r\n\r\n  .rtl .col-lg-1 {\r\n    width: 8.33333333%;\r\n  }\r\n\r\n  .rtl .col-lg-pull-12 {\r\n    left: 100%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-11 {\r\n    left: 91.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-10 {\r\n    left: 83.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-9 {\r\n    left: 75%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-8 {\r\n    left: 66.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-7 {\r\n    left: 58.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-6 {\r\n    left: 50%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-5 {\r\n    left: 41.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-4 {\r\n    left: 33.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-3 {\r\n    left: 25%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-2 {\r\n    left: 16.66666667%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-1 {\r\n    left: 8.33333333%;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-pull-0 {\r\n    left: auto;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .col-lg-push-12 {\r\n    right: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-11 {\r\n    right: 91.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-10 {\r\n    right: 83.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-9 {\r\n    right: 75%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-8 {\r\n    right: 66.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-7 {\r\n    right: 58.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-6 {\r\n    right: 50%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-5 {\r\n    right: 41.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-4 {\r\n    right: 33.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-3 {\r\n    right: 25%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-2 {\r\n    right: 16.66666667%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-1 {\r\n    right: 8.33333333%;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-push-0 {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-12 {\r\n    margin-right: 100%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-11 {\r\n    margin-right: 91.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-10 {\r\n    margin-right: 83.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-9 {\r\n    margin-right: 75%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-8 {\r\n    margin-right: 66.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-7 {\r\n    margin-right: 58.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-6 {\r\n    margin-right: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-5 {\r\n    margin-right: 41.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-4 {\r\n    margin-right: 33.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-3 {\r\n    margin-right: 25%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-2 {\r\n    margin-right: 16.66666667%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-1 {\r\n    margin-right: 8.33333333%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .rtl .col-lg-offset-0 {\r\n    margin-right: 0%;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.rtl caption {\r\n  text-align: right;\r\n}\r\n\r\n.rtl th {\r\n  text-align: right;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .rtl .table-responsive>.table-bordered {\r\n    border: 0;\r\n  }\r\n\r\n  .rtl .table-responsive>.table-bordered>thead>tr>th:first-child,\r\n  .rtl .table-responsive>.table-bordered>tbody>tr>th:first-child,\r\n  .rtl .table-responsive>.table-bordered>tfoot>tr>th:first-child,\r\n  .rtl .table-responsive>.table-bordered>thead>tr>td:first-child,\r\n  .rtl .table-responsive>.table-bordered>tbody>tr>td:first-child,\r\n  .rtl .table-responsive>.table-bordered>tfoot>tr>td:first-child {\r\n    border-right: 0;\r\n    border-left: initial;\r\n  }\r\n\r\n  .rtl .table-responsive>.table-bordered>thead>tr>th:last-child,\r\n  .rtl .table-responsive>.table-bordered>tbody>tr>th:last-child,\r\n  .rtl .table-responsive>.table-bordered>tfoot>tr>th:last-child,\r\n  .rtl .table-responsive>.table-bordered>thead>tr>td:last-child,\r\n  .rtl .table-responsive>.table-bordered>tbody>tr>td:last-child,\r\n  .rtl .table-responsive>.table-bordered>tfoot>tr>td:last-child {\r\n    border-left: 0;\r\n    border-right: initial;\r\n  }\r\n}\r\n\r\n.rtl .radio label,\r\n.rtl .checkbox label {\r\n  padding-right: 20px;\r\n  padding-left: initial;\r\n}\r\n\r\n.rtl .radio input[type=\"radio\"],\r\n.rtl .radio-inline input[type=\"radio\"],\r\n.rtl .checkbox input[type=\"checkbox\"],\r\n.rtl .checkbox-inline input[type=\"checkbox\"] {\r\n  margin-right: -20px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .radio-inline,\r\n.rtl .checkbox-inline {\r\n  padding-right: 20px;\r\n  padding-left: 0;\r\n}\r\n\r\n.rtl .radio-inline+.radio-inline,\r\n.rtl .checkbox-inline+.checkbox-inline {\r\n  margin-right: 10px;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .has-feedback .form-control {\r\n  padding-left: 42.5px;\r\n  padding-right: 12px;\r\n}\r\n\r\n.rtl .form-control-feedback {\r\n  left: 0;\r\n  right: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .form-inline label {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n  }\r\n\r\n  .rtl .form-inline .radio input[type=\"radio\"],\r\n  .rtl .form-inline .checkbox input[type=\"checkbox\"] {\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .form-horizontal .control-label {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.rtl .form-horizontal .has-feedback .form-control-feedback {\r\n  left: 15px;\r\n  right: auto;\r\n}\r\n\r\n.rtl .caret {\r\n  margin-right: 2px;\r\n  margin-left: 0;\r\n}\r\n\r\n.rtl .dropdown-menu {\r\n  right: 0;\r\n  left: auto;\r\n  float: left;\r\n  text-align: right;\r\n}\r\n\r\n.rtl .dropdown-menu.pull-right {\r\n  left: 0;\r\n  right: auto;\r\n  float: right;\r\n}\r\n\r\n.rtl .dropdown-menu-right {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.rtl .dropdown-menu-left {\r\n  left: 0;\r\n  right: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .navbar-right .dropdown-menu {\r\n    left: auto;\r\n    right: 0;\r\n  }\r\n\r\n  .rtl .navbar-right .dropdown-menu-left {\r\n    left: 0;\r\n    right: auto;\r\n  }\r\n}\r\n\r\n.rtl .btn-group>.btn,\r\n.rtl .btn-group-vertical>.btn {\r\n  float: right;\r\n}\r\n\r\n.rtl .btn-group .btn+.btn,\r\n.rtl .btn-group .btn+.btn-group,\r\n.rtl .btn-group .btn-group+.btn,\r\n.rtl .btn-group .btn-group+.btn-group {\r\n  margin-right: -1px;\r\n  margin-left: 0px;\r\n}\r\n\r\n.rtl .btn-toolbar {\r\n  margin-right: -5px;\r\n  margin-left: 0px;\r\n}\r\n\r\n.rtl .btn-toolbar .btn-group,\r\n.rtl .btn-toolbar .input-group {\r\n  float: right;\r\n}\r\n\r\n.rtl .btn-toolbar>.btn,\r\n.rtl .btn-toolbar>.btn-group,\r\n.rtl .btn-toolbar>.input-group {\r\n  margin-right: 5px;\r\n  margin-left: 0px;\r\n}\r\n\r\n.rtl .btn-group>.btn:first-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.rtl .btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  border-bottom-left-radius: 0;\r\n  border-top-left-radius: 0;\r\n}\r\n\r\n.rtl .btn-group>.btn:last-child:not(:first-child),\r\n.rtl .btn-group>.dropdown-toggle:not(:first-child) {\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n  border-bottom-right-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.rtl .btn-group>.btn-group {\r\n  float: right;\r\n}\r\n\r\n.rtl .btn-group.btn-group-justified>.btn,\r\n.rtl .btn-group.btn-group-justified>.btn-group {\r\n  float: none;\r\n}\r\n\r\n.rtl .btn-group>.btn-group:not(:first-child):not(:last-child)>.btn {\r\n  border-radius: 0;\r\n}\r\n\r\n.rtl .btn-group>.btn-group:first-child>.btn:last-child,\r\n.rtl .btn-group>.btn-group:first-child>.dropdown-toggle {\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  border-bottom-left-radius: 0;\r\n  border-top-left-radius: 0;\r\n}\r\n\r\n.rtl .btn-group>.btn-group:last-child>.btn:first-child {\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n  border-bottom-right-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.rtl .btn .caret {\r\n  margin-right: 0;\r\n}\r\n\r\n.rtl .btn-group-vertical>.btn+.btn,\r\n.rtl .btn-group-vertical>.btn+.btn-group,\r\n.rtl .btn-group-vertical>.btn-group+.btn,\r\n.rtl .btn-group-vertical>.btn-group+.btn-group {\r\n  margin-top: -1px;\r\n  margin-right: 0;\r\n}\r\n\r\n.rtl .input-group .form-control {\r\n  float: right;\r\n}\r\n\r\n.rtl .input-group .form-control:first-child,\r\n.rtl .input-group-addon:first-child,\r\n.rtl .input-group-btn:first-child>.btn,\r\n.rtl .input-group-btn:first-child>.btn-group>.btn,\r\n.rtl .input-group-btn:first-child>.dropdown-toggle,\r\n.rtl .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),\r\n.rtl .input-group-btn:last-child>.btn-group:not(:last-child)>.btn {\r\n  border-bottom-right-radius: 4px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-left-radius: 0;\r\n  border-top-left-radius: 0;\r\n}\r\n\r\n.rtl .input-group-addon:first-child {\r\n  border-left: 0px;\r\n  border-right: 1px solid;\r\n}\r\n\r\n.rtl .input-group .form-control:last-child,\r\n.rtl .input-group-addon:last-child,\r\n.rtl .input-group-btn:last-child>.btn,\r\n.rtl .input-group-btn:last-child>.btn-group>.btn,\r\n.rtl .input-group-btn:last-child>.dropdown-toggle,\r\n.rtl .input-group-btn:first-child>.btn:not(:first-child),\r\n.rtl .input-group-btn:first-child>.btn-group:not(:first-child)>.btn {\r\n  border-bottom-left-radius: 4px;\r\n  border-top-left-radius: 4px;\r\n  border-bottom-right-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.rtl .input-group-addon:last-child {\r\n  border-left-width: 1px;\r\n  border-left-style: solid;\r\n  border-right: 0px;\r\n}\r\n\r\n.rtl .input-group-btn>.btn+.btn {\r\n  margin-right: -1px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .input-group-btn:first-child>.btn,\r\n.rtl .input-group-btn:first-child>.btn-group {\r\n  margin-left: -1px;\r\n  margin-right: auto;\r\n}\r\n\r\n.rtl .input-group-btn:last-child>.btn,\r\n.rtl .input-group-btn:last-child>.btn-group {\r\n  margin-right: -1px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .nav {\r\n  padding-right: 0;\r\n  padding-left: initial;\r\n}\r\n\r\n.rtl .nav-tabs>li {\r\n  float: right;\r\n}\r\n\r\n.rtl .nav-tabs>li>a {\r\n  margin-left: auto;\r\n  margin-right: -2px;\r\n  border-radius: 4px 4px 0 0;\r\n}\r\n\r\n.rtl .nav-pills>li {\r\n  float: right;\r\n}\r\n\r\n.rtl .nav-pills>li>a {\r\n  border-radius: 4px;\r\n}\r\n\r\n.rtl .nav-pills>li+li {\r\n  margin-right: 2px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .nav-stacked>li {\r\n  float: none;\r\n}\r\n\r\n.rtl .nav-stacked>li+li {\r\n  margin-right: 0;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .nav-justified>.dropdown .dropdown-menu {\r\n  right: auto;\r\n}\r\n\r\n.rtl .nav-tabs-justified>li>a {\r\n  margin-left: 0;\r\n  margin-right: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .nav-tabs-justified>li>a {\r\n    border-radius: 4px 4px 0 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .navbar-header {\r\n    float: right;\r\n  }\r\n}\r\n\r\n.rtl .navbar-collapse {\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.rtl .navbar-brand {\r\n  float: right;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\r\n  .rtl .navbar>.container .navbar-brand,\r\n  .rtl .navbar>.container-fluid .navbar-brand,\r\n  .rtl .navbar>.container-sm .navbar-brand,\r\n  .rtl .navbar>.container-md .navbar-brand,\r\n  .rtl .navbar>.container-lg .navbar-brand,\r\n  .rtl .navbar>.container-xl .navbar-brand {\r\n    margin-right: -15px;\r\n    margin-left: auto;\r\n  }\r\n}\r\n\r\n.rtl .navbar-toggle {\r\n  float: left;\r\n  margin-left: 15px;\r\n  margin-right: auto;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n  .rtl .navbar-nav .open .dropdown-menu>li>a,\r\n  .rtl .navbar-nav .open .dropdown-menu .dropdown-header {\r\n    padding: 5px 25px 5px 15px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .navbar-nav {\r\n    float: right;\r\n  }\r\n\r\n  .rtl .navbar-right {\r\n    float: left !important;\r\n  }\r\n\r\n  .rtl .navbar-left {\r\n    float: right !important;\r\n  }\r\n\r\n  .rtl .navbar-nav>li {\r\n    float: right !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .navbar-left.flip {\r\n    float: right !important;\r\n  }\r\n\r\n  .rtl .navbar-right:last-child {\r\n    margin-left: -15px;\r\n    margin-right: auto;\r\n  }\r\n\r\n  .rtl .navbar-right.flip {\r\n    float: left !important;\r\n    margin-left: -15px;\r\n    margin-right: auto;\r\n  }\r\n\r\n  .rtl .navbar-right .dropdown-menu {\r\n    left: 0;\r\n    right: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .rtl .navbar-text {\r\n    float: right;\r\n  }\r\n\r\n  .rtl .navbar-text.navbar-right:last-child {\r\n    margin-left: 0;\r\n    margin-right: auto;\r\n  }\r\n}\r\n\r\n.rtl .pagination {\r\n  padding-right: 0;\r\n}\r\n\r\n.rtl .pagination>li>a,\r\n.rtl .pagination>li>span {\r\n  float: right;\r\n  margin-right: -1px;\r\n  margin-left: 0px;\r\n}\r\n\r\n.rtl .pagination>li:first-child>a,\r\n.rtl .pagination>li:first-child>span {\r\n  margin-left: 0;\r\n  border-bottom-right-radius: 4px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-left-radius: 0;\r\n  border-top-left-radius: 0;\r\n}\r\n\r\n.rtl .pagination>li:last-child>a,\r\n.rtl .pagination>li:last-child>span {\r\n  margin-right: -1px;\r\n  border-bottom-left-radius: 4px;\r\n  border-top-left-radius: 4px;\r\n  border-bottom-right-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.rtl .pager {\r\n  padding-right: 0;\r\n  padding-left: initial;\r\n}\r\n\r\n.rtl .pager .next>a,\r\n.rtl .pager .next>span {\r\n  float: left;\r\n}\r\n\r\n.rtl .pager .previous>a,\r\n.rtl .pager .previous>span {\r\n  float: right;\r\n}\r\n\r\n.rtl .nav-pills>li>a>.badge {\r\n  margin-left: 0px;\r\n  margin-right: 3px;\r\n}\r\n\r\n.rtl .list-group-item>.badge {\r\n  float: left;\r\n}\r\n\r\n.rtl .list-group-item>.badge+.badge {\r\n  margin-left: 5px;\r\n  margin-right: auto;\r\n}\r\n\r\n.rtl .alert-dismissable,\r\n.rtl .alert-dismissible {\r\n  padding-left: 35px;\r\n  padding-right: 15px;\r\n}\r\n\r\n.rtl .alert-dismissable .close,\r\n.rtl .alert-dismissible .close {\r\n  right: auto;\r\n  left: -21px;\r\n}\r\n\r\n.rtl .progress-bar {\r\n  float: right;\r\n}\r\n\r\n.rtl .media>.pull-left {\r\n  margin-right: 10px;\r\n}\r\n\r\n.rtl .media>.pull-left.flip {\r\n  margin-right: 0;\r\n  margin-left: 10px;\r\n}\r\n\r\n.rtl .media>.pull-right {\r\n  margin-left: 10px;\r\n}\r\n\r\n.rtl .media>.pull-right.flip {\r\n  margin-left: 0;\r\n  margin-right: 10px;\r\n}\r\n\r\n.rtl .media-right,\r\n.rtl .media>.pull-right {\r\n  padding-right: 10px;\r\n  padding-left: initial;\r\n}\r\n\r\n.rtl .media-left,\r\n.rtl .media>.pull-left {\r\n  padding-left: 10px;\r\n  padding-right: initial;\r\n}\r\n\r\n.rtl .media-list {\r\n  padding-right: 0;\r\n  padding-left: initial;\r\n  list-style: none;\r\n}\r\n\r\n.rtl .list-group {\r\n  padding-right: 0;\r\n  padding-left: initial;\r\n}\r\n\r\n.rtl .panel>.table:first-child>thead:first-child>tr:first-child td:first-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,\r\n.rtl .panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,\r\n.rtl .panel>.table:first-child>thead:first-child>tr:first-child th:first-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,\r\n.rtl .panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child {\r\n  border-top-right-radius: 3px;\r\n  border-top-left-radius: 0;\r\n}\r\n\r\n.rtl .panel>.table:first-child>thead:first-child>tr:first-child td:last-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,\r\n.rtl .panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,\r\n.rtl .panel>.table:first-child>thead:first-child>tr:first-child th:last-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,\r\n.rtl .panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,\r\n.rtl .panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child {\r\n  border-top-left-radius: 3px;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.rtl .panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,\r\n.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,\r\n.rtl .panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,\r\n.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child {\r\n  border-bottom-left-radius: 3px;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.rtl .panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,\r\n.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,\r\n.rtl .panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,\r\n.rtl .panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child,\r\n.rtl .panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child {\r\n  border-bottom-right-radius: 3px;\r\n  border-top-left-radius: 0;\r\n}\r\n\r\n.rtl .panel>.table-bordered>thead>tr>th:first-child,\r\n.rtl .panel>.table-responsive>.table-bordered>thead>tr>th:first-child,\r\n.rtl .panel>.table-bordered>tbody>tr>th:first-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,\r\n.rtl .panel>.table-bordered>tfoot>tr>th:first-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,\r\n.rtl .panel>.table-bordered>thead>tr>td:first-child,\r\n.rtl .panel>.table-responsive>.table-bordered>thead>tr>td:first-child,\r\n.rtl .panel>.table-bordered>tbody>tr>td:first-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,\r\n.rtl .panel>.table-bordered>tfoot>tr>td:first-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child {\r\n  border-right: 0;\r\n  border-left: none;\r\n}\r\n\r\n.rtl .panel>.table-bordered>thead>tr>th:last-child,\r\n.rtl .panel>.table-responsive>.table-bordered>thead>tr>th:last-child,\r\n.rtl .panel>.table-bordered>tbody>tr>th:last-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,\r\n.rtl .panel>.table-bordered>tfoot>tr>th:last-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,\r\n.rtl .panel>.table-bordered>thead>tr>td:last-child,\r\n.rtl .panel>.table-responsive>.table-bordered>thead>tr>td:last-child,\r\n.rtl .panel>.table-bordered>tbody>tr>td:last-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,\r\n.rtl .panel>.table-bordered>tfoot>tr>td:last-child,\r\n.rtl .panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child {\r\n  border-right: none;\r\n  border-left: 0;\r\n}\r\n\r\n.rtl .embed-responsive .embed-responsive-item,\r\n.rtl .embed-responsive iframe,\r\n.rtl .embed-responsive embed,\r\n.rtl .embed-responsive object {\r\n  right: 0;\r\n  left: auto;\r\n}\r\n\r\n.rtl .close {\r\n  float: left;\r\n}\r\n\r\n.rtl .modal-footer {\r\n  text-align: left;\r\n}\r\n\r\n.rtl .modal-footer.flip {\r\n  text-align: right;\r\n}\r\n\r\n.rtl .modal-footer .btn+.btn {\r\n  margin-left: auto;\r\n  margin-right: 5px;\r\n}\r\n\r\n.rtl .modal-footer .btn-group .btn+.btn {\r\n  margin-right: -1px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .modal-footer .btn-block+.btn-block {\r\n  margin-right: 0;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .popover {\r\n  left: auto;\r\n  text-align: right;\r\n}\r\n\r\n.rtl .popover.top>.arrow {\r\n  right: 50%;\r\n  left: auto;\r\n  margin-right: -11px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .popover.top>.arrow:after {\r\n  margin-right: -10px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .popover.bottom>.arrow {\r\n  right: 50%;\r\n  left: auto;\r\n  margin-right: -11px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .popover.bottom>.arrow:after {\r\n  margin-right: -10px;\r\n  margin-left: auto;\r\n}\r\n\r\n.rtl .carousel-control {\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.rtl .carousel-control.left {\r\n  right: auto;\r\n  left: 0;\r\n  background-image: -webkit-linear-gradient(left,\r\n      color-stop(rgba(0, 0, 0, 0.5) 0%),\r\n      color-stop(rgba(0, 0, 0, 0.0001) 100%));\r\n  background-image: -o-linear-gradient(left,\r\n      rgba(0, 0, 0, 0.5) 0%,\r\n      rgba(0, 0, 0, 0.0001) 100%);\r\n  background-image: linear-gradient(to right,\r\n      rgba(0, 0, 0, 0.5) 0%,\r\n      rgba(0, 0, 0, 0.0001) 100%);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\r\n}\r\n\r\n.rtl .carousel-control.right {\r\n  left: auto;\r\n  right: 0;\r\n  background-image: -webkit-linear-gradient(left,\r\n      color-stop(rgba(0, 0, 0, 0.0001) 0%),\r\n      color-stop(rgba(0, 0, 0, 0.5) 100%));\r\n  background-image: -o-linear-gradient(left,\r\n      rgba(0, 0, 0, 0.0001) 0%,\r\n      rgba(0, 0, 0, 0.5) 100%);\r\n  background-image: linear-gradient(to right,\r\n      rgba(0, 0, 0, 0.0001) 0%,\r\n      rgba(0, 0, 0, 0.5) 100%);\r\n  background-repeat: repeat-x;\r\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\r\n}\r\n\r\n.rtl .carousel-control .icon-prev,\r\n.rtl .carousel-control .glyphicon-chevron-left {\r\n  left: 50%;\r\n  right: auto;\r\n  margin-right: -10px;\r\n}\r\n\r\n.rtl .carousel-control .icon-next,\r\n.rtl .carousel-control .glyphicon-chevron-right {\r\n  right: 50%;\r\n  left: auto;\r\n  margin-left: -10px;\r\n}\r\n\r\n.rtl .carousel-indicators {\r\n  right: 50%;\r\n  left: 0;\r\n  margin-right: -30%;\r\n  margin-left: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n\r\n  .rtl .carousel-control .glyphicon-chevron-left,\r\n  .rtl .carousel-control .icon-prev {\r\n    margin-left: 0;\r\n    margin-right: -15px;\r\n  }\r\n\r\n  .rtl .carousel-control .glyphicon-chevron-right,\r\n  .rtl .carousel-control .icon-next {\r\n    margin-left: 0;\r\n    margin-right: -15px;\r\n  }\r\n\r\n  .rtl .carousel-caption {\r\n    left: 20%;\r\n    right: 20%;\r\n    padding-bottom: 30px;\r\n  }\r\n}\r\n\r\n.rtl .pull-right.flip {\r\n  float: left !important;\r\n}\r\n\r\n.rtl .pull-left.flip {\r\n  float: right !important;\r\n}\r\n\r\n:root {\r\n  --blue: #5e72e4;\r\n  --indigo: #5603ad;\r\n  --purple: #8965e0;\r\n  --pink: #f3a4b5;\r\n  --red: #f5365c;\r\n  --orange: #fb6340;\r\n  --yellow: #ffd600;\r\n  --green: #2dce89;\r\n  --teal: #11cdef;\r\n  --cyan: #2bffc6;\r\n  --white: #fff;\r\n  --gray: #8898aa;\r\n  --gray-dark: #32325d;\r\n  --light: #ced4da;\r\n  --lighter: #e9ecef;\r\n  --primary: #5e72e4;\r\n  --secondary: #f7fafc;\r\n  --success: #2dce89;\r\n  --info: #11cdef;\r\n  --warning: #fb6340;\r\n  --danger: #f5365c;\r\n  --light: #adb5bd;\r\n  --dark: #212529;\r\n  --default: #172b4d;\r\n  --white: #fff;\r\n  --neutral: #fff;\r\n  --darker: black;\r\n  --breakpoint-xs: 0;\r\n  --breakpoint-sm: 576px;\r\n  --breakpoint-md: 768px;\r\n  --breakpoint-lg: 992px;\r\n  --breakpoint-xl: 1200px;\r\n  --font-family-sans-serif: Open Sans, sans-serif;\r\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,\r\n    \"Liberation Mono\", \"Courier New\", monospace;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  font-family: sans-serif;\r\n  line-height: 1.15;\r\n  -webkit-text-size-adjust: 100%;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\narticle,\r\naside,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmain,\r\nnav,\r\nsection {\r\n  display: block;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: Open Sans, sans-serif;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #000000;\r\n  text-align: left;\r\n  background-color: #f8f9fe;\r\n}\r\n\r\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\r\n  outline: 0 !important;\r\n}\r\n\r\nhr {\r\n  box-sizing: content-box;\r\n  height: 0;\r\n  overflow: visible;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  margin-top: 0;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nabbr[title],\r\nabbr[data-original-title] {\r\n  text-decoration: underline;\r\n  text-decoration: underline dotted;\r\n  cursor: help;\r\n  border-bottom: 0;\r\n  text-decoration-skip-ink: none;\r\n}\r\n\r\naddress {\r\n  margin-bottom: 1rem;\r\n  font-style: normal;\r\n  line-height: inherit;\r\n}\r\n\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nol ol,\r\nul ul,\r\nol ul,\r\nul ol {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndt {\r\n  font-weight: 600;\r\n}\r\n\r\ndd {\r\n  margin-bottom: 0.5rem;\r\n  margin-left: 0;\r\n}\r\n\r\nblockquote {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\nb,\r\nstrong {\r\n  font-weight: bolder;\r\n}\r\n\r\nsmall {\r\n  font-size: 80%;\r\n}\r\n\r\nsub,\r\nsup {\r\n  position: relative;\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -0.25em;\r\n}\r\n\r\nsup {\r\n  top: -0.5em;\r\n}\r\n\r\na {\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  background-color: transparent;\r\n}\r\n\r\na:hover {\r\n  color: #233dd2;\r\n  text-decoration: none;\r\n}\r\n\r\na:not([href]):not([class]) {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\na:not([href]):not([class]):hover {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\npre,\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\r\n    \"Courier New\", monospace;\r\n  font-size: 1em;\r\n}\r\n\r\npre {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n  overflow: auto;\r\n  -ms-overflow-style: scrollbar;\r\n}\r\n\r\nfigure {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\nimg {\r\n  vertical-align: middle;\r\n  border-style: none;\r\n}\r\n\r\nsvg {\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n}\r\n\r\ncaption {\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n  color: #8898aa;\r\n  text-align: left;\r\n  caption-side: bottom;\r\n}\r\n\r\nth {\r\n  text-align: inherit;\r\n  text-align: -webkit-match-parent;\r\n}\r\n\r\nlabel {\r\n  display: inline-block;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\nbutton {\r\n  border-radius: 0;\r\n}\r\n\r\nbutton:focus:not(:focus-visible) {\r\n  outline: 0;\r\n}\r\n\r\ninput,\r\nbutton,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0;\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\nbutton,\r\ninput {\r\n  overflow: visible;\r\n}\r\n\r\nbutton,\r\nselect {\r\n  text-transform: none;\r\n}\r\n\r\n[role=\"button\"] {\r\n  cursor: pointer;\r\n}\r\n\r\nselect {\r\n  word-wrap: normal;\r\n}\r\n\r\nbutton,\r\n[type=\"button\"],\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  -webkit-appearance: button;\r\n}\r\n\r\nbutton:not(:disabled),\r\n[type=\"button\"]:not(:disabled),\r\n[type=\"reset\"]:not(:disabled),\r\n[type=\"submit\"]:not(:disabled) {\r\n  cursor: pointer;\r\n}\r\n\r\nbutton::-moz-focus-inner,\r\n[type=\"button\"]::-moz-focus-inner,\r\n[type=\"reset\"]::-moz-focus-inner,\r\n[type=\"submit\"]::-moz-focus-inner {\r\n  padding: 0;\r\n  border-style: none;\r\n}\r\n\r\ninput[type=\"radio\"],\r\ninput[type=\"checkbox\"] {\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n}\r\n\r\ninput[type=\"file\"]::-webkit-file-upload-button {\r\n  cursor: pointer;\r\n}\r\n\r\ninput[type=\"file\"]::file-selector-button {\r\n  cursor: pointer;\r\n}\r\n\r\ntextarea {\r\n  overflow: auto;\r\n  resize: vertical;\r\n}\r\n\r\nfieldset {\r\n  min-width: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n}\r\n\r\nlegend {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  padding: 0;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1.5rem;\r\n  line-height: inherit;\r\n  color: inherit;\r\n  white-space: normal;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  legend {\r\n    font-size: calc(1.275rem + 0.3vw);\r\n  }\r\n}\r\n\r\nprogress {\r\n  vertical-align: baseline;\r\n}\r\n\r\n[type=\"number\"]::-webkit-inner-spin-button,\r\n[type=\"number\"]::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n[type=\"search\"] {\r\n  outline-offset: -2px;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n[type=\"search\"]::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n::-webkit-file-upload-button {\r\n  font: inherit;\r\n  -webkit-appearance: button;\r\n}\r\n\r\noutput {\r\n  display: inline-block;\r\n}\r\n\r\nsummary {\r\n  display: list-item;\r\n  cursor: pointer;\r\n}\r\n\r\ntemplate {\r\n  display: none;\r\n}\r\n\r\n[hidden] {\r\n  display: none !important;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n  margin-bottom: 0.5rem;\r\n  font-family: inherit;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n  color: #32325d;\r\n}\r\n\r\nh1,\r\n.h1 {\r\n  font-size: 1.625rem;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\r\n  h1,\r\n  .h1 {\r\n    font-size: calc(1.2875rem + 0.45vw);\r\n  }\r\n}\r\n\r\nh2,\r\n.h2 {\r\n  font-size: 1.25rem;\r\n}\r\n\r\nh3,\r\n.h3 {\r\n  font-size: 1.0625rem;\r\n}\r\n\r\nh4,\r\n.h4 {\r\n  font-size: 0.9375rem;\r\n}\r\n\r\nh5,\r\n.h5 {\r\n  font-size: 0.8125rem;\r\n}\r\n\r\nh6,\r\n.h6 {\r\n  font-size: 0.625rem;\r\n}\r\n\r\n.lead {\r\n  font-size: 1.25rem;\r\n  font-weight: 300;\r\n}\r\n\r\n.display-1 {\r\n  font-size: 3.3rem;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .display-1 {\r\n    font-size: calc(1.455rem + 2.46vw);\r\n  }\r\n}\r\n\r\n.display-2 {\r\n  font-size: 2.75rem;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .display-2 {\r\n    font-size: calc(1.4rem + 1.8vw);\r\n  }\r\n}\r\n\r\n.display-3 {\r\n  font-size: 2.1875rem;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .display-3 {\r\n    font-size: calc(1.34375rem + 1.125vw);\r\n  }\r\n}\r\n\r\n.display-4 {\r\n  font-size: 1.6275rem;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .display-4 {\r\n    font-size: calc(1.28775rem + 0.453vw);\r\n  }\r\n}\r\n\r\nhr {\r\n  margin-top: 2rem;\r\n  margin-bottom: 2rem;\r\n  border: 0;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nsmall,\r\n.small {\r\n  font-size: 80%;\r\n  font-weight: 400;\r\n}\r\n\r\nmark,\r\n.mark {\r\n  padding: 0.2em;\r\n  background-color: #fcf8e3;\r\n}\r\n\r\n.list-unstyled {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n\r\n.list-inline {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n\r\n.list-inline-item {\r\n  display: inline-block;\r\n}\r\n\r\n.list-inline-item:not(:last-child) {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.initialism {\r\n  font-size: 90%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.blockquote {\r\n  margin-bottom: 1rem;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.blockquote-footer {\r\n  display: block;\r\n  font-size: 80%;\r\n  color: #8898aa;\r\n}\r\n\r\n.blockquote-footer::before {\r\n  content: \"\\2014\\00A0\";\r\n}\r\n\r\n.img-fluid {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.img-thumbnail {\r\n  padding: 0.25rem;\r\n  background-color: #f8f9fe;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.375rem;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.figure {\r\n  display: inline-block;\r\n}\r\n\r\n.figure-img {\r\n  margin-bottom: 0.5rem;\r\n  line-height: 1;\r\n}\r\n\r\n.figure-caption {\r\n  font-size: 90%;\r\n  color: #8898aa;\r\n}\r\n\r\ncode {\r\n  font-size: 87.5%;\r\n  color: #f3a4b5;\r\n  word-wrap: break-word;\r\n}\r\n\r\na>code {\r\n  color: inherit;\r\n}\r\n\r\nkbd {\r\n  padding: 0.2rem 0.4rem;\r\n  font-size: 87.5%;\r\n  color: #fff;\r\n  background-color: #212529;\r\n  border-radius: 0.25rem;\r\n  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);\r\n}\r\n\r\nkbd kbd {\r\n  padding: 0;\r\n  font-size: 100%;\r\n  font-weight: 600;\r\n  box-shadow: none;\r\n}\r\n\r\npre {\r\n  display: block;\r\n  font-size: 87.5%;\r\n  color: #212529;\r\n}\r\n\r\npre code {\r\n  font-size: inherit;\r\n  color: inherit;\r\n  word-break: normal;\r\n}\r\n\r\n.pre-scrollable {\r\n  max-height: 340px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.container,\r\n.container-fluid,\r\n.container-sm,\r\n.container-md,\r\n.container-lg,\r\n.container-xl {\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n\r\n  .container,\r\n  .container-sm {\r\n    max-width: 540px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\r\n  .container,\r\n  .container-sm,\r\n  .container-md {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\r\n  .container,\r\n  .container-sm,\r\n  .container-md,\r\n  .container-lg {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n\r\n  .container,\r\n  .container-sm,\r\n  .container-md,\r\n  .container-lg,\r\n  .container-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n}\r\n\r\n.no-gutters {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.no-gutters>.col,\r\n.no-gutters>[class*=\"col-\"] {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.col-1,\r\n.col-2,\r\n.col-3,\r\n.col-4,\r\n.col-5,\r\n.col-6,\r\n.col-7,\r\n.col-8,\r\n.col-9,\r\n.col-10,\r\n.col-11,\r\n.col-12,\r\n.col,\r\n.col-auto,\r\n.col-sm-1,\r\n.col-sm-2,\r\n.col-sm-3,\r\n.col-sm-4,\r\n.col-sm-5,\r\n.col-sm-6,\r\n.col-sm-7,\r\n.col-sm-8,\r\n.col-sm-9,\r\n.col-sm-10,\r\n.col-sm-11,\r\n.col-sm-12,\r\n.col-sm,\r\n.col-sm-auto,\r\n.col-md-1,\r\n.col-md-2,\r\n.col-md-3,\r\n.col-md-4,\r\n.col-md-5,\r\n.col-md-6,\r\n.col-md-7,\r\n.col-md-8,\r\n.col-md-9,\r\n.col-md-10,\r\n.col-md-11,\r\n.col-md-12,\r\n.col-md,\r\n.col-md-auto,\r\n.col-lg-1,\r\n.col-lg-2,\r\n.col-lg-3,\r\n.col-lg-4,\r\n.col-lg-5,\r\n.col-lg-6,\r\n.col-lg-7,\r\n.col-lg-8,\r\n.col-lg-9,\r\n.col-lg-10,\r\n.col-lg-11,\r\n.col-lg-12,\r\n.col-lg,\r\n.col-lg-auto,\r\n.col-xl-1,\r\n.col-xl-2,\r\n.col-xl-3,\r\n.col-xl-4,\r\n.col-xl-5,\r\n.col-xl-6,\r\n.col-xl-7,\r\n.col-xl-8,\r\n.col-xl-9,\r\n.col-xl-10,\r\n.col-xl-11,\r\n.col-xl-12,\r\n.col-xl,\r\n.col-xl-auto {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.col {\r\n  flex-basis: 0;\r\n  flex-grow: 1;\r\n  max-width: 100%;\r\n}\r\n\r\n.row-cols-1>* {\r\n  flex: 0 0 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.row-cols-2>* {\r\n  flex: 0 0 50%;\r\n  max-width: 50%;\r\n}\r\n\r\n.row-cols-3>* {\r\n  flex: 0 0 33.33333%;\r\n  max-width: 33.33333%;\r\n}\r\n\r\n.row-cols-4>* {\r\n  flex: 0 0 25%;\r\n  max-width: 25%;\r\n}\r\n\r\n.row-cols-5>* {\r\n  flex: 0 0 20%;\r\n  max-width: 20%;\r\n}\r\n\r\n.row-cols-6>* {\r\n  flex: 0 0 16.66667%;\r\n  max-width: 16.66667%;\r\n}\r\n\r\n.col-auto {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  max-width: 100%;\r\n}\r\n\r\n.col-1 {\r\n  flex: 0 0 8.33333%;\r\n  max-width: 8.33333%;\r\n}\r\n\r\n.col-2 {\r\n  flex: 0 0 16.66667%;\r\n  max-width: 16.66667%;\r\n}\r\n\r\n.col-3 {\r\n  flex: 0 0 25%;\r\n  max-width: 25%;\r\n}\r\n\r\n.col-4 {\r\n  flex: 0 0 33.33333%;\r\n  max-width: 33.33333%;\r\n}\r\n\r\n.col-5 {\r\n  flex: 0 0 41.66667%;\r\n  max-width: 41.66667%;\r\n}\r\n\r\n.col-6 {\r\n  flex: 0 0 50%;\r\n  max-width: 50%;\r\n}\r\n\r\n.col-7 {\r\n  flex: 0 0 58.33333%;\r\n  max-width: 58.33333%;\r\n}\r\n\r\n.col-8 {\r\n  flex: 0 0 66.66667%;\r\n  max-width: 66.66667%;\r\n}\r\n\r\n.col-9 {\r\n  flex: 0 0 75%;\r\n  max-width: 75%;\r\n}\r\n\r\n.col-10 {\r\n  flex: 0 0 83.33333%;\r\n  max-width: 83.33333%;\r\n}\r\n\r\n.col-11 {\r\n  flex: 0 0 91.66667%;\r\n  max-width: 91.66667%;\r\n}\r\n\r\n.col-12 {\r\n  flex: 0 0 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.order-first {\r\n  order: -1;\r\n}\r\n\r\n.order-last {\r\n  order: 13;\r\n}\r\n\r\n.order-0 {\r\n  order: 0;\r\n}\r\n\r\n.order-1 {\r\n  order: 1;\r\n}\r\n\r\n.order-2 {\r\n  order: 2;\r\n}\r\n\r\n.order-3 {\r\n  order: 3;\r\n}\r\n\r\n.order-4 {\r\n  order: 4;\r\n}\r\n\r\n.order-5 {\r\n  order: 5;\r\n}\r\n\r\n.order-6 {\r\n  order: 6;\r\n}\r\n\r\n.order-7 {\r\n  order: 7;\r\n}\r\n\r\n.order-8 {\r\n  order: 8;\r\n}\r\n\r\n.order-9 {\r\n  order: 9;\r\n}\r\n\r\n.order-10 {\r\n  order: 10;\r\n}\r\n\r\n.order-11 {\r\n  order: 11;\r\n}\r\n\r\n.order-12 {\r\n  order: 12;\r\n}\r\n\r\n.offset-1 {\r\n  margin-left: 8.33333%;\r\n}\r\n\r\n.offset-2 {\r\n  margin-left: 16.66667%;\r\n}\r\n\r\n.offset-3 {\r\n  margin-left: 25%;\r\n}\r\n\r\n.offset-4 {\r\n  margin-left: 33.33333%;\r\n}\r\n\r\n.offset-5 {\r\n  margin-left: 41.66667%;\r\n}\r\n\r\n.offset-6 {\r\n  margin-left: 50%;\r\n}\r\n\r\n.offset-7 {\r\n  margin-left: 58.33333%;\r\n}\r\n\r\n.offset-8 {\r\n  margin-left: 66.66667%;\r\n}\r\n\r\n.offset-9 {\r\n  margin-left: 75%;\r\n}\r\n\r\n.offset-10 {\r\n  margin-left: 83.33333%;\r\n}\r\n\r\n.offset-11 {\r\n  margin-left: 91.66667%;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .col-sm {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-sm-1>* {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-sm-2>* {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .row-cols-sm-3>* {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .row-cols-sm-4>* {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .row-cols-sm-5>* {\r\n    flex: 0 0 20%;\r\n    max-width: 20%;\r\n  }\r\n\r\n  .row-cols-sm-6>* {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-sm-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-sm-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-sm-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-sm-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-sm-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-sm-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-sm-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-sm-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-sm-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-sm-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-sm-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-sm-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-sm-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-sm-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-sm-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-sm-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-sm-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-sm-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-sm-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-sm-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-sm-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-sm-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-sm-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-sm-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-sm-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-sm-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-sm-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-sm-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-sm-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-sm-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-sm-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-sm-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-sm-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-sm-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-sm-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-sm-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-sm-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-sm-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-sm-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-sm-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .col-md {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-md-1>* {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-md-2>* {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .row-cols-md-3>* {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .row-cols-md-4>* {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .row-cols-md-5>* {\r\n    flex: 0 0 20%;\r\n    max-width: 20%;\r\n  }\r\n\r\n  .row-cols-md-6>* {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-md-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-md-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-md-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-md-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-md-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-md-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-md-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-md-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-md-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-md-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-md-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-md-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-md-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-md-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-md-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-md-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-md-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-md-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-md-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-md-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-md-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-md-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-md-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-md-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-md-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-md-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-md-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-md-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-md-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-md-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-md-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-md-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-md-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-md-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-md-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-md-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-md-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-md-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-md-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-md-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .col-lg {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-lg-1>* {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-lg-2>* {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .row-cols-lg-3>* {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .row-cols-lg-4>* {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .row-cols-lg-5>* {\r\n    flex: 0 0 20%;\r\n    max-width: 20%;\r\n  }\r\n\r\n  .row-cols-lg-6>* {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-lg-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-lg-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-lg-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-lg-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-lg-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-lg-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-lg-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-lg-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-lg-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-lg-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-lg-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-lg-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-lg-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-lg-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-lg-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-lg-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-lg-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-lg-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-lg-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-lg-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-lg-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-lg-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-lg-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-lg-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-lg-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-lg-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-lg-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-lg-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-lg-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-lg-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-lg-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-lg-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-lg-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-lg-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-lg-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-lg-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-lg-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-lg-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-lg-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-lg-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .col-xl {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-xl-1>* {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .row-cols-xl-2>* {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .row-cols-xl-3>* {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .row-cols-xl-4>* {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .row-cols-xl-5>* {\r\n    flex: 0 0 20%;\r\n    max-width: 20%;\r\n  }\r\n\r\n  .row-cols-xl-6>* {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-xl-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-xl-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-xl-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-xl-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-xl-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-xl-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-xl-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-xl-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-xl-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-xl-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-xl-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-xl-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-xl-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-xl-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-xl-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-xl-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-xl-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-xl-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-xl-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-xl-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-xl-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-xl-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-xl-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-xl-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-xl-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-xl-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-xl-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-xl-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-xl-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-xl-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-xl-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-xl-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-xl-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-xl-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-xl-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-xl-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-xl-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-xl-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-xl-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-xl-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  margin-bottom: 1rem;\r\n  color: rgb(33, 37, 41);\r\n  background-color: transparent;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  padding: 1rem;\r\n  vertical-align: top;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.table thead th {\r\n  vertical-align: bottom;\r\n  border-bottom: 2px solid #e9ecef;\r\n}\r\n\r\n.table tbody+tbody {\r\n  border-top: 2px solid #e9ecef;\r\n}\r\n\r\n.table-sm th,\r\n.table-sm td {\r\n  padding: 0.5rem;\r\n}\r\n\r\n.table-bordered {\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.table-bordered th,\r\n.table-bordered td {\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.table-bordered thead th,\r\n.table-bordered thead td {\r\n  border-bottom-width: 2px;\r\n}\r\n\r\n.table-borderless th,\r\n.table-borderless td,\r\n.table-borderless thead th,\r\n.table-borderless tbody+tbody {\r\n  border: 0;\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n  background-color: rgba(246, 249, 252, 0.3);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  color: #525f7f;\r\n  background-color: #f6f9fc;\r\n}\r\n\r\n.table-primary,\r\n.table-primary>th,\r\n.table-primary>td {\r\n  background-color: #d2d8f7;\r\n}\r\n\r\n.table-primary th,\r\n.table-primary td,\r\n.table-primary thead th,\r\n.table-primary tbody+tbody {\r\n  border-color: #abb6f1;\r\n}\r\n\r\n.table-hover .table-primary:hover {\r\n  background-color: #bcc5f3;\r\n}\r\n\r\n.table-hover .table-primary:hover>td,\r\n.table-hover .table-primary:hover>th {\r\n  background-color: #bcc5f3;\r\n}\r\n\r\n.table-secondary,\r\n.table-secondary>th,\r\n.table-secondary>td {\r\n  background-color: #fdfefe;\r\n}\r\n\r\n.table-secondary th,\r\n.table-secondary td,\r\n.table-secondary thead th,\r\n.table-secondary tbody+tbody {\r\n  border-color: #fbfcfd;\r\n}\r\n\r\n.table-hover .table-secondary:hover {\r\n  background-color: #ecf6f6;\r\n}\r\n\r\n.table-hover .table-secondary:hover>td,\r\n.table-hover .table-secondary:hover>th {\r\n  background-color: #ecf6f6;\r\n}\r\n\r\n.table-success,\r\n.table-success>th,\r\n.table-success>td {\r\n  background-color: #c4f1de;\r\n}\r\n\r\n.table-success th,\r\n.table-success td,\r\n.table-success thead th,\r\n.table-success tbody+tbody {\r\n  border-color: #92e6c2;\r\n}\r\n\r\n.table-hover .table-success:hover {\r\n  background-color: #afecd2;\r\n}\r\n\r\n.table-hover .table-success:hover>td,\r\n.table-hover .table-success:hover>th {\r\n  background-color: #afecd2;\r\n}\r\n\r\n.table-info,\r\n.table-info>th,\r\n.table-info>td {\r\n  background-color: #bcf1fb;\r\n}\r\n\r\n.table-info th,\r\n.table-info td,\r\n.table-info thead th,\r\n.table-info tbody+tbody {\r\n  border-color: #83e5f7;\r\n}\r\n\r\n.table-hover .table-info:hover {\r\n  background-color: #a4ecfa;\r\n}\r\n\r\n.table-hover .table-info:hover>td,\r\n.table-hover .table-info:hover>th {\r\n  background-color: #a4ecfa;\r\n}\r\n\r\n.table-warning,\r\n.table-warning>th,\r\n.table-warning>td {\r\n  background-color: #fed3ca;\r\n}\r\n\r\n.table-warning th,\r\n.table-warning td,\r\n.table-warning thead th,\r\n.table-warning tbody+tbody {\r\n  border-color: #fdae9c;\r\n}\r\n\r\n.table-hover .table-warning:hover {\r\n  background-color: #febeb1;\r\n}\r\n\r\n.table-hover .table-warning:hover>td,\r\n.table-hover .table-warning:hover>th {\r\n  background-color: #febeb1;\r\n}\r\n\r\n.table-danger,\r\n.table-danger>th,\r\n.table-danger>td {\r\n  background-color: #fcc7d1;\r\n}\r\n\r\n.table-danger th,\r\n.table-danger td,\r\n.table-danger thead th,\r\n.table-danger tbody+tbody {\r\n  border-color: #fa96aa;\r\n}\r\n\r\n.table-hover .table-danger:hover {\r\n  background-color: #fbafbd;\r\n}\r\n\r\n.table-hover .table-danger:hover>td,\r\n.table-hover .table-danger:hover>th {\r\n  background-color: #fbafbd;\r\n}\r\n\r\n.table-light,\r\n.table-light>th,\r\n.table-light>td {\r\n  background-color: #e8eaed;\r\n}\r\n\r\n.table-light th,\r\n.table-light td,\r\n.table-light thead th,\r\n.table-light tbody+tbody {\r\n  border-color: #d4d9dd;\r\n}\r\n\r\n.table-hover .table-light:hover {\r\n  background-color: #dadde2;\r\n}\r\n\r\n.table-hover .table-light:hover>td,\r\n.table-hover .table-light:hover>th {\r\n  background-color: #dadde2;\r\n}\r\n\r\n.table-dark,\r\n.table-dark>th,\r\n.table-dark>td {\r\n  background-color: #c1c2c3;\r\n}\r\n\r\n.table-dark th,\r\n.table-dark td,\r\n.table-dark thead th,\r\n.table-dark tbody+tbody {\r\n  border-color: #8c8e90;\r\n}\r\n\r\n/* Light mode Salto rows */\r\ntr.salto-synced-row > td {\r\n  background-color: #f7f7f8 !important;\r\n}\r\n\r\n/* Dark mode Salto rows */\r\nbody[data-theme=\"dark\"] tr.salto-synced-row > td {\r\n  background-color: #252932 !important;\r\n  color: #f8f9fa;\r\n}\r\n\r\n/* Keep the Salto row visibly different on hover */\r\nbody[data-theme=\"dark\"] tr.salto-synced-row:hover > td {\r\n  background-color: #323946 !important;\r\n}\r\n\r\n/* Light mode hover */\r\ntr.salto-synced-row:hover > td {\r\n  background-color: #eeeeef !important;\r\n}\r\n\r\n.table-hover .table-dark:hover {\r\n  background-color: #b4b5b6;\r\n}\r\n\r\n.table-hover .table-dark:hover>td,\r\n.table-hover .table-dark:hover>th {\r\n  background-color: #b4b5b6;\r\n}\r\n\r\n.table-default,\r\n.table-default>th,\r\n.table-default>td {\r\n  background-color: #bec4cd;\r\n}\r\n\r\n.table-default th,\r\n.table-default td,\r\n.table-default thead th,\r\n.table-default tbody+tbody {\r\n  border-color: #8691a2;\r\n}\r\n\r\n.table-hover .table-default:hover {\r\n  background-color: #b0b7c2;\r\n}\r\n\r\n.table-hover .table-default:hover>td,\r\n.table-hover .table-default:hover>th {\r\n  background-color: #b0b7c2;\r\n}\r\n\r\n.table-white,\r\n.table-white>th,\r\n.table-white>td {\r\n  background-color: white;\r\n}\r\n\r\n.table-white th,\r\n.table-white td,\r\n.table-white thead th,\r\n.table-white tbody+tbody {\r\n  border-color: white;\r\n}\r\n\r\n.table-hover .table-white:hover {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.table-hover .table-white:hover>td,\r\n.table-hover .table-white:hover>th {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.table-neutral,\r\n.table-neutral>th,\r\n.table-neutral>td {\r\n  background-color: white;\r\n}\r\n\r\n.table-neutral th,\r\n.table-neutral td,\r\n.table-neutral thead th,\r\n.table-neutral tbody+tbody {\r\n  border-color: white;\r\n}\r\n\r\n.table-hover .table-neutral:hover {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.table-hover .table-neutral:hover>td,\r\n.table-hover .table-neutral:hover>th {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.table-darker,\r\n.table-darker>th,\r\n.table-darker>td {\r\n  background-color: #b8b8b8;\r\n}\r\n\r\n.table-darker th,\r\n.table-darker td,\r\n.table-darker thead th,\r\n.table-darker tbody+tbody {\r\n  border-color: #7a7a7a;\r\n}\r\n\r\n.table-hover .table-darker:hover {\r\n  background-color: #ababab;\r\n}\r\n\r\n.table-hover .table-darker:hover>td,\r\n.table-hover .table-darker:hover>th {\r\n  background-color: #ababab;\r\n}\r\n\r\n.table-active,\r\n.table-active>th,\r\n.table-active>td {\r\n  background-color: #f6f9fc;\r\n}\r\n\r\n.table-hover .table-active:hover {\r\n  background-color: #e3ecf6;\r\n}\r\n\r\n.table-hover .table-active:hover>td,\r\n.table-hover .table-active:hover>th {\r\n  background-color: #e3ecf6;\r\n}\r\n\r\n.table .thead-dark th {\r\n  color: #f8f9fe;\r\n  background-color: #172b4d;\r\n  border-color: #1f3a68;\r\n}\r\n\r\n.table .thead-light th {\r\n  color: #8898aa;\r\n  background-color: #f6f9fc;\r\n  border-color: #e9ecef;\r\n}\r\n\r\n.table-dark {\r\n  color: #f8f9fe;\r\n  background-color: #172b4d;\r\n}\r\n\r\n.table-dark th,\r\n.table-dark td,\r\n.table-dark thead th {\r\n  border-color: #1f3a68;\r\n}\r\n\r\n.table-dark.table-bordered {\r\n  border: 0;\r\n}\r\n\r\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\r\n  background-color: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.table-dark.table-hover tbody tr:hover {\r\n  color: #f8f9fe;\r\n  background-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .table-responsive-sm {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-sm>.table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .table-responsive-md {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-md>.table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .table-responsive-lg {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-lg>.table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n  .table-responsive-xl {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-xl>.table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.table-responsive {\r\n  display: block;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.table-responsive>.table-bordered {\r\n  border: 0;\r\n}\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  padding: 0.625rem 0.75rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #000000;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.25rem;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .form-control {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.form-control::-ms-expand {\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.form-control:-moz-focusring {\r\n  color: transparent;\r\n  text-shadow: 0 0 0 #8898aa;\r\n}\r\n\r\n.form-control:focus {\r\n  color: #000000;\r\n  background-color: #fff;\r\n  border-color: #5e72e4;\r\n  outline: 0;\r\n  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: #adb5bd;\r\n  opacity: 1;\r\n}\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n  background-color: #e9ecef;\r\n  opacity: 1;\r\n}\r\n\r\ninput[type=\"date\"].form-control,\r\ninput[type=\"time\"].form-control,\r\ninput[type=\"datetime-local\"].form-control,\r\ninput[type=\"month\"].form-control {\r\n  appearance: none;\r\n}\r\n\r\nselect.form-control:focus::-ms-value {\r\n  color: #000000;\r\n  background-color: #fff;\r\n}\r\n\r\n.form-control-file,\r\n.form-control-range {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.col-form-label {\r\n  padding-top: calc(0.625rem + 1px);\r\n  padding-bottom: calc(0.625rem + 1px);\r\n  margin-bottom: 0;\r\n  font-size: inherit;\r\n  line-height: 1.5;\r\n}\r\n\r\n.col-form-label-lg {\r\n  padding-top: calc(0.875rem + 1px);\r\n  padding-bottom: calc(0.875rem + 1px);\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.col-form-label-sm {\r\n  padding-top: calc(0.25rem + 1px);\r\n  padding-bottom: calc(0.25rem + 1px);\r\n  font-size: 0.75rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.form-control-plaintext {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.625rem 0;\r\n  margin-bottom: 0;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  color: #525f7f;\r\n  background-color: transparent;\r\n  border: solid transparent;\r\n  border-width: 1px 0;\r\n}\r\n\r\n.form-control-plaintext.form-control-sm,\r\n.form-control-plaintext.form-control-lg {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.form-control-sm {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.form-control-lg {\r\n  height: calc(1.5em + 1.75rem + 2px);\r\n  padding: 0.875rem 1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\nselect.form-control[size],\r\nselect.form-control[multiple] {\r\n  height: auto;\r\n}\r\n\r\ntextarea.form-control {\r\n  height: auto;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form-text {\r\n  display: block;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n}\r\n\r\n.form-row>.col,\r\n.form-row>[class*=\"col-\"] {\r\n  padding-right: 5px;\r\n  padding-left: 5px;\r\n}\r\n\r\n.form-check {\r\n  position: relative;\r\n  display: block;\r\n  padding-left: 1.25rem;\r\n}\r\n\r\n.form-check-input {\r\n  position: absolute;\r\n  margin-top: 0.3rem;\r\n  margin-left: -1.25rem;\r\n}\r\n\r\n.form-check-input[disabled]~.form-check-label,\r\n.form-check-input:disabled~.form-check-label {\r\n  color: #8898aa;\r\n}\r\n\r\n.form-check-label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-check-inline {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-left: 0;\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.form-check-inline .form-check-input {\r\n  position: static;\r\n  margin-top: 0;\r\n  margin-right: 0.3125rem;\r\n  margin-left: 0;\r\n}\r\n\r\n.valid-feedback {\r\n  display: none;\r\n  width: 100%;\r\n  margin-top: 0.25rem;\r\n  font-size: 80%;\r\n  color: #2dce89;\r\n}\r\n\r\n.valid-tooltip {\r\n  position: absolute;\r\n  top: 100%;\r\n  z-index: 5;\r\n  display: none;\r\n  max-width: 100%;\r\n  padding: 0.5rem;\r\n  margin-top: 0.1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1;\r\n  color: #fff;\r\n  background-color: rgba(45, 206, 137, 0.8);\r\n  border-radius: 0.2rem;\r\n}\r\n\r\n.was-validated .form-control:valid,\r\n.form-control.is-valid,\r\n.was-validated .custom-select:valid,\r\n.custom-select.is-valid {\r\n  border-color: #2dce89;\r\n}\r\n\r\n.was-validated .form-control:valid:focus,\r\n.form-control.is-valid:focus,\r\n.was-validated .custom-select:valid:focus,\r\n.custom-select.is-valid:focus {\r\n  border-color: #2dce89;\r\n}\r\n\r\n.was-validated .form-control:valid~.valid-feedback,\r\n.was-validated .form-control:valid~.valid-tooltip,\r\n.form-control.is-valid~.valid-feedback,\r\n.form-control.is-valid~.valid-tooltip,\r\n.was-validated .custom-select:valid~.valid-feedback,\r\n.was-validated .custom-select:valid~.valid-tooltip,\r\n.custom-select.is-valid~.valid-feedback,\r\n.custom-select.is-valid~.valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .form-check-input:valid~.form-check-label,\r\n.form-check-input.is-valid~.form-check-label {\r\n  color: #2dce89;\r\n}\r\n\r\n.was-validated .form-check-input:valid~.valid-feedback,\r\n.was-validated .form-check-input:valid~.valid-tooltip,\r\n.form-check-input.is-valid~.valid-feedback,\r\n.form-check-input.is-valid~.valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:valid~.custom-control-label,\r\n.custom-control-input.is-valid~.custom-control-label {\r\n  color: #2dce89;\r\n}\r\n\r\n.was-validated .custom-control-input:valid~.custom-control-label::before,\r\n.custom-control-input.is-valid~.custom-control-label::before {\r\n  background-color: #93e7c3;\r\n  border-color: #93e7c3;\r\n}\r\n\r\n.was-validated .custom-control-input:valid~.valid-feedback,\r\n.was-validated .custom-control-input:valid~.valid-tooltip,\r\n.custom-control-input.is-valid~.valid-feedback,\r\n.custom-control-input.is-valid~.valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:valid:checked~.custom-control-label::before,\r\n.custom-control-input.is-valid:checked~.custom-control-label::before {\r\n  background-color: #54daa1;\r\n  border-color: #93e7c3;\r\n}\r\n\r\n.was-validated .custom-control-input:valid:focus~.custom-control-label::before,\r\n.custom-control-input.is-valid:focus~.custom-control-label::before {\r\n  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(45, 206, 137, 0.25);\r\n}\r\n\r\n.custom-file-input {\r\n  opacity: 1 !important;\r\n  width: 60% !important;\r\n  margin: 8px !important;\r\n}\r\n\r\n.was-validated .custom-file-input:valid~.custom-file-label,\r\n.custom-file-input.is-valid~.custom-file-label {\r\n  border-color: #2dce89;\r\n}\r\n\r\n.was-validated .custom-file-input:valid~.custom-file-label::before,\r\n.custom-file-input.is-valid~.custom-file-label::before {\r\n  border-color: inherit;\r\n}\r\n\r\n.was-validated .custom-file-input:valid~.valid-feedback,\r\n.was-validated .custom-file-input:valid~.valid-tooltip,\r\n.custom-file-input.is-valid~.valid-feedback,\r\n.custom-file-input.is-valid~.valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-file-input:valid:focus~.custom-file-label,\r\n.custom-file-input.is-valid:focus~.custom-file-label {\r\n  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.25);\r\n}\r\n\r\n.custom-file-input:focus {\r\n  outline: none;\r\n}\r\n\r\n.invalid-feedback {\r\n  display: none;\r\n  width: 100%;\r\n  margin-top: 0.25rem;\r\n  font-size: 80%;\r\n  color: #fb6340;\r\n}\r\n\r\n.invalid-tooltip {\r\n  position: absolute;\r\n  top: 100%;\r\n  z-index: 5;\r\n  display: none;\r\n  max-width: 100%;\r\n  padding: 0.5rem;\r\n  margin-top: 0.1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1;\r\n  color: #fff;\r\n  background-color: rgba(251, 99, 64, 0.8);\r\n  border-radius: 0.2rem;\r\n}\r\n\r\n.was-validated .form-control:invalid,\r\n.form-control.is-invalid,\r\n.was-validated .custom-select:invalid,\r\n.custom-select.is-invalid {\r\n  border-color: #fb6340;\r\n}\r\n\r\n.was-validated .form-control:invalid:focus,\r\n.form-control.is-invalid:focus,\r\n.was-validated .custom-select:invalid:focus,\r\n.custom-select.is-invalid:focus {\r\n  border-color: #fb6340;\r\n}\r\n\r\n.was-validated .form-control:invalid~.invalid-feedback,\r\n.was-validated .form-control:invalid~.invalid-tooltip,\r\n.form-control.is-invalid~.invalid-feedback,\r\n.form-control.is-invalid~.invalid-tooltip,\r\n.was-validated .custom-select:invalid~.invalid-feedback,\r\n.was-validated .custom-select:invalid~.invalid-tooltip,\r\n.custom-select.is-invalid~.invalid-feedback,\r\n.custom-select.is-invalid~.invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .form-check-input:invalid~.form-check-label,\r\n.form-check-input.is-invalid~.form-check-label {\r\n  color: #fb6340;\r\n}\r\n\r\n.was-validated .form-check-input:invalid~.invalid-feedback,\r\n.was-validated .form-check-input:invalid~.invalid-tooltip,\r\n.form-check-input.is-invalid~.invalid-feedback,\r\n.form-check-input.is-invalid~.invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid~.custom-control-label,\r\n.custom-control-input.is-invalid~.custom-control-label {\r\n  color: #fb6340;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid~.custom-control-label::before,\r\n.custom-control-input.is-invalid~.custom-control-label::before {\r\n  background-color: #fec9bd;\r\n  border-color: #fec9bd;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid~.invalid-feedback,\r\n.was-validated .custom-control-input:invalid~.invalid-tooltip,\r\n.custom-control-input.is-invalid~.invalid-feedback,\r\n.custom-control-input.is-invalid~.invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid:checked~.custom-control-label::before,\r\n.custom-control-input.is-invalid:checked~.custom-control-label::before {\r\n  background-color: #fc8c72;\r\n  border-color: #fec9bd;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid:focus~.custom-control-label::before,\r\n.custom-control-input.is-invalid:focus~.custom-control-label::before {\r\n  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);\r\n}\r\n\r\n.custom-file-input {\r\n  opacity: 1 !important;\r\n  width: 60% !important;\r\n  margin: 8px !important;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid~.custom-file-label,\r\n.custom-file-input.is-invalid~.custom-file-label {\r\n  border-color: #fb6340;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid~.custom-file-label::before,\r\n.custom-file-input.is-invalid~.custom-file-label::before {\r\n  border-color: inherit;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid~.invalid-feedback,\r\n.was-validated .custom-file-input:invalid~.invalid-tooltip,\r\n.custom-file-input.is-invalid~.invalid-feedback,\r\n.custom-file-input.is-invalid~.invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid:focus~.custom-file-label,\r\n.custom-file-input.is-invalid:focus~.custom-file-label {\r\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);\r\n}\r\n\r\n.custom-file-input:focus {\r\n  outline: none;\r\n}\r\n\r\n.form-inline {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center;\r\n}\r\n\r\n.form-inline .form-check {\r\n  width: 100%;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .form-inline label {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .form-inline .form-group {\r\n    display: flex;\r\n    flex: 0 0 auto;\r\n    flex-flow: row wrap;\r\n    align-items: center;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .form-inline .form-control {\r\n    display: inline-block;\r\n    width: auto;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .form-inline .form-control-plaintext {\r\n    display: inline-block;\r\n  }\r\n\r\n  .form-inline .input-group,\r\n  .form-inline .custom-select {\r\n    width: auto;\r\n  }\r\n\r\n  .form-inline .form-check {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: auto;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .form-inline .form-check-input {\r\n    position: relative;\r\n    flex-shrink: 0;\r\n    margin-top: 0;\r\n    margin-right: 0.25rem;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .form-inline .custom-control {\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .form-inline .custom-control-label {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: 600;\r\n  color: #525f7f;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  user-select: none;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  padding: 0.625rem 1.25rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\r\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .btn {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.btn:hover {\r\n  color: #525f7f;\r\n  text-decoration: none;\r\n}\r\n\r\n.btn:focus,\r\n.btn.focus {\r\n  outline: 0;\r\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn.disabled,\r\n.btn:disabled {\r\n  opacity: 0.65;\r\n  box-shadow: none;\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled) {\r\n  cursor: pointer;\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled):active,\r\n.btn:not(:disabled):not(.disabled).active {\r\n  box-shadow: none;\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled):active:focus,\r\n.btn:not(:disabled):not(.disabled).active:focus {\r\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\na.btn.disabled,\r\nfieldset:disabled a.btn {\r\n  pointer-events: none;\r\n}\r\n\r\n.btn-primary {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-primary:hover {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.btn-primary:focus,\r\n.btn-primary.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.btn-primary.disabled,\r\n.btn-primary:disabled {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled):active,\r\n.btn-primary:not(:disabled):not(.disabled).active,\r\n.show>.btn-primary.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #324cdd;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled):active:focus,\r\n.btn-primary:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-primary.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.btn-secondary {\r\n  color: #212529;\r\n  background-color: #f7fafc;\r\n  border-color: #f7fafc;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-secondary:hover {\r\n  color: #212529;\r\n  background-color: #f7fafc;\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.btn-secondary:focus,\r\n.btn-secondary.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(247, 250, 252, 0.5);\r\n}\r\n\r\n.btn-secondary.disabled,\r\n.btn-secondary:disabled {\r\n  color: #212529;\r\n  background-color: #f7fafc;\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled):active,\r\n.btn-secondary:not(:disabled):not(.disabled).active,\r\n.show>.btn-secondary.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #d2e3ee;\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\r\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-secondary.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);\r\n}\r\n\r\n.btn-success {\r\n  color: #fff;\r\n  background-color: #2dce89;\r\n  border-color: #2dce89;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-success:hover {\r\n  color: #fff;\r\n  background-color: #2dce89;\r\n  border-color: #2dce89;\r\n}\r\n\r\n.btn-success:focus,\r\n.btn-success.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(45, 206, 137, 0.5);\r\n}\r\n\r\n.btn-success.disabled,\r\n.btn-success:disabled {\r\n  color: #fff;\r\n  background-color: #2dce89;\r\n  border-color: #2dce89;\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled):active,\r\n.btn-success:not(:disabled):not(.disabled).active,\r\n.show>.btn-success.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #24a46d;\r\n  border-color: #2dce89;\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled):active:focus,\r\n.btn-success:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-success.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(45, 206, 137, 0.5);\r\n}\r\n\r\n.btn-info {\r\n  color: #fff;\r\n  background-color: #11cdef;\r\n  border-color: #11cdef;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-info:hover {\r\n  color: #fff;\r\n  background-color: #11cdef;\r\n  border-color: #11cdef;\r\n}\r\n\r\n.btn-info:focus,\r\n.btn-info.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(17, 205, 239, 0.5);\r\n}\r\n\r\n.btn-info.disabled,\r\n.btn-info:disabled {\r\n  color: #fff;\r\n  background-color: #11cdef;\r\n  border-color: #11cdef;\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled):active,\r\n.btn-info:not(:disabled):not(.disabled).active,\r\n.show>.btn-info.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #0da5c0;\r\n  border-color: #11cdef;\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled):active:focus,\r\n.btn-info:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-info.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(17, 205, 239, 0.5);\r\n}\r\n\r\n.btn-warning {\r\n  color: #fff;\r\n  background-color: #fb6340;\r\n  border-color: #fb6340;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-warning:hover {\r\n  color: #fff;\r\n  background-color: #fb6340;\r\n  border-color: #fb6340;\r\n}\r\n\r\n.btn-warning:focus,\r\n.btn-warning.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(251, 99, 64, 0.5);\r\n}\r\n\r\n.btn-warning.disabled,\r\n.btn-warning:disabled {\r\n  color: #fff;\r\n  background-color: #fb6340;\r\n  border-color: #fb6340;\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled):active,\r\n.btn-warning:not(:disabled):not(.disabled).active,\r\n.show>.btn-warning.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #fa3a0e;\r\n  border-color: #fb6340;\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled):active:focus,\r\n.btn-warning:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-warning.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);\r\n}\r\n\r\n.btn-danger {\r\n  color: #fff;\r\n  background-color: #f5365c;\r\n  border-color: #f5365c;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-danger:hover {\r\n  color: #fff;\r\n  background-color: #f5365c;\r\n  border-color: #f5365c;\r\n}\r\n\r\n.btn-danger:focus,\r\n.btn-danger.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(245, 54, 92, 0.5);\r\n}\r\n\r\n.btn-danger.disabled,\r\n.btn-danger:disabled {\r\n  color: #fff;\r\n  background-color: #f5365c;\r\n  border-color: #f5365c;\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled):active,\r\n.btn-danger:not(:disabled):not(.disabled).active,\r\n.show>.btn-danger.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #ec0c38;\r\n  border-color: #f5365c;\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled):active:focus,\r\n.btn-danger:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-danger.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);\r\n}\r\n\r\n.btn-light {\r\n  color: #fff;\r\n  background-color: #adb5bd;\r\n  border-color: #adb5bd;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-light:hover {\r\n  color: #fff;\r\n  background-color: #adb5bd;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.btn-light:focus,\r\n.btn-light.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(173, 181, 189, 0.5);\r\n}\r\n\r\n.btn-light.disabled,\r\n.btn-light:disabled {\r\n  color: #fff;\r\n  background-color: #adb5bd;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.btn-light:not(:disabled):not(.disabled):active,\r\n.btn-light:not(:disabled):not(.disabled).active,\r\n.show>.btn-light.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #919ca6;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.btn-light:not(:disabled):not(.disabled):active:focus,\r\n.btn-light:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-light.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);\r\n}\r\n\r\n.btn-dark {\r\n  color: #fff;\r\n  background-color: #212529;\r\n  border-color: #212529;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-dark:hover {\r\n  color: #fff;\r\n  background-color: #212529;\r\n  border-color: #212529;\r\n}\r\n\r\n.btn-dark:focus,\r\n.btn-dark.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(33, 37, 41, 0.5);\r\n}\r\n\r\n.btn-dark.disabled,\r\n.btn-dark:disabled {\r\n  color: #fff;\r\n  background-color: #212529;\r\n  border-color: #212529;\r\n}\r\n\r\n.btn-dark:not(:disabled):not(.disabled):active,\r\n.btn-dark:not(:disabled):not(.disabled).active,\r\n.show>.btn-dark.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #0a0c0d;\r\n  border-color: #212529;\r\n}\r\n\r\n.btn-dark:not(:disabled):not(.disabled):active:focus,\r\n.btn-dark:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-dark.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);\r\n}\r\n\r\n.btn-default {\r\n  color: #fff;\r\n  background-color: #172b4d;\r\n  border-color: #172b4d;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-default:hover {\r\n  color: #fff;\r\n  background-color: #172b4d;\r\n  border-color: #172b4d;\r\n}\r\n\r\n.btn-default:focus,\r\n.btn-default.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(23, 43, 77, 0.5);\r\n}\r\n\r\n.btn-default.disabled,\r\n.btn-default:disabled {\r\n  color: #fff;\r\n  background-color: #172b4d;\r\n  border-color: #172b4d;\r\n}\r\n\r\n.btn-default:not(:disabled):not(.disabled):active,\r\n.btn-default:not(:disabled):not(.disabled).active,\r\n.show>.btn-default.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #0b1526;\r\n  border-color: #172b4d;\r\n}\r\n\r\n.btn-default:not(:disabled):not(.disabled):active:focus,\r\n.btn-default:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-default.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(23, 43, 77, 0.5);\r\n}\r\n\r\n.btn-white {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-white:hover {\r\n  color: #212529;\r\n  background-color: white;\r\n  border-color: white;\r\n}\r\n\r\n.btn-white:focus,\r\n.btn-white.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-white.disabled,\r\n.btn-white:disabled {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-white:not(:disabled):not(.disabled):active,\r\n.btn-white:not(:disabled):not(.disabled).active,\r\n.show>.btn-white.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #e6e6e6;\r\n  border-color: white;\r\n}\r\n\r\n.btn-white:not(:disabled):not(.disabled):active:focus,\r\n.btn-white:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-white.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.static-text-btn {\r\n  color: #007bff !important;\r\n  /* normal text */\r\n  background-color: #fff !important;\r\n  /* keep original background */\r\n  border-color: #fff !important;\r\n  /* keep original border */\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\r\n}\r\n\r\n.static-text-btn:hover,\r\n.static-text-btn:focus,\r\n.static-text-btn:active,\r\n.static-text-btn.active {\r\n  color: #007bff !important;\r\n  /* prevent hover/focus/active color change */\r\n  background-color: #fff !important;\r\n  border-color: #fff !important;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\r\n}\r\n\r\n.static-text-btn:disabled,\r\n.static-text-btn.disabled {\r\n  color: #007bff !important;\r\n  /* prevent disabled color change */\r\n  background-color: #fff !important;\r\n  border-color: #fff !important;\r\n}\r\n\r\n.btn-neutral {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-neutral:hover {\r\n  color: #212529;\r\n  background-color: white;\r\n  border-color: white;\r\n}\r\n\r\n.btn-neutral:focus,\r\n.btn-neutral.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-neutral.disabled,\r\n.btn-neutral:disabled {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-neutral:not(:disabled):not(.disabled):active,\r\n.btn-neutral:not(:disabled):not(.disabled).active,\r\n.show>.btn-neutral.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #e6e6e6;\r\n  border-color: white;\r\n}\r\n\r\n.btn-neutral:not(:disabled):not(.disabled):active:focus,\r\n.btn-neutral:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-neutral.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-darker {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-darker:hover {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n}\r\n\r\n.btn-darker:focus,\r\n.btn-darker.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.btn-darker.disabled,\r\n.btn-darker:disabled {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n}\r\n\r\n.btn-darker:not(:disabled):not(.disabled):active,\r\n.btn-darker:not(:disabled):not(.disabled).active,\r\n.show>.btn-darker.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n}\r\n\r\n.btn-darker:not(:disabled):not(.disabled):active:focus,\r\n.btn-darker:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-darker.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.btn-outline-primary {\r\n  color: #5e72e4;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary.focus {\r\n  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.btn-outline-primary.disabled,\r\n.btn-outline-primary:disabled {\r\n  color: #5e72e4;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled):active,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-primary.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-primary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.btn-outline-secondary {\r\n  color: #f7fafc;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.btn-outline-secondary:hover {\r\n  color: #212529;\r\n  background-color: #f7fafc;\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.btn-outline-secondary:focus,\r\n.btn-outline-secondary.focus {\r\n  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);\r\n}\r\n\r\n.btn-outline-secondary.disabled,\r\n.btn-outline-secondary:disabled {\r\n  color: #f7fafc;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-secondary.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #f7fafc;\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-secondary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);\r\n}\r\n\r\n.btn-outline-success {\r\n  color: #2dce89;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #2dce89;\r\n}\r\n\r\n.btn-outline-success:hover {\r\n  color: #fff;\r\n  background-color: #2dce89;\r\n  border-color: #2dce89;\r\n}\r\n\r\n.btn-outline-success:focus,\r\n.btn-outline-success.focus {\r\n  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);\r\n}\r\n\r\n.btn-outline-success.disabled,\r\n.btn-outline-success:disabled {\r\n  color: #2dce89;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled):active,\r\n.btn-outline-success:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-success.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #2dce89;\r\n  border-color: #2dce89;\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-success.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);\r\n}\r\n\r\n.btn-outline-info {\r\n  color: #11cdef;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #11cdef;\r\n}\r\n\r\n.btn-outline-info:hover {\r\n  color: #fff;\r\n  background-color: #11cdef;\r\n  border-color: #11cdef;\r\n}\r\n\r\n.btn-outline-info:focus,\r\n.btn-outline-info.focus {\r\n  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);\r\n}\r\n\r\n.btn-outline-info.disabled,\r\n.btn-outline-info:disabled {\r\n  color: #11cdef;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled):active,\r\n.btn-outline-info:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-info.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #11cdef;\r\n  border-color: #11cdef;\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-info.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);\r\n}\r\n\r\n.btn-outline-warning {\r\n  color: #fb6340;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #fb6340;\r\n}\r\n\r\n.btn-outline-warning:hover {\r\n  color: #fff;\r\n  background-color: #fb6340;\r\n  border-color: #fb6340;\r\n}\r\n\r\n.btn-outline-warning:focus,\r\n.btn-outline-warning.focus {\r\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);\r\n}\r\n\r\n.btn-outline-warning.disabled,\r\n.btn-outline-warning:disabled {\r\n  color: #fb6340;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled):active,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-warning.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #fb6340;\r\n  border-color: #fb6340;\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-warning.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);\r\n}\r\n\r\n.btn-outline-danger {\r\n  color: #f5365c;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #f5365c;\r\n}\r\n\r\n.btn-outline-danger:hover {\r\n  color: #fff;\r\n  background-color: #f5365c;\r\n  border-color: #f5365c;\r\n}\r\n\r\n.btn-outline-danger:focus,\r\n.btn-outline-danger.focus {\r\n  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);\r\n}\r\n\r\n.btn-outline-danger.disabled,\r\n.btn-outline-danger:disabled {\r\n  color: #f5365c;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled):active,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-danger.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #f5365c;\r\n  border-color: #f5365c;\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-danger.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);\r\n}\r\n\r\n.btn-outline-light {\r\n  color: #adb5bd;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.btn-outline-light:hover {\r\n  color: #fff;\r\n  background-color: #adb5bd;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.btn-outline-light:focus,\r\n.btn-outline-light.focus {\r\n  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);\r\n}\r\n\r\n.btn-outline-light.disabled,\r\n.btn-outline-light:disabled {\r\n  color: #adb5bd;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-light:not(:disabled):not(.disabled):active,\r\n.btn-outline-light:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-light.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #adb5bd;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-light.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);\r\n}\r\n\r\n.btn-outline-dark {\r\n  color: #212529;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #212529;\r\n}\r\n\r\n.btn-outline-dark:hover {\r\n  color: #fff;\r\n  background-color: #212529;\r\n  border-color: #212529;\r\n}\r\n\r\n.btn-outline-dark:focus,\r\n.btn-outline-dark.focus {\r\n  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);\r\n}\r\n\r\n.btn-outline-dark.disabled,\r\n.btn-outline-dark:disabled {\r\n  color: #212529;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-dark:not(:disabled):not(.disabled):active,\r\n.btn-outline-dark:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-dark.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #212529;\r\n  border-color: #212529;\r\n}\r\n\r\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-dark.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);\r\n}\r\n\r\n.btn-outline-default {\r\n  color: #172b4d;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #172b4d;\r\n}\r\n\r\n.btn-outline-default:hover {\r\n  color: #fff;\r\n  background-color: #172b4d;\r\n  border-color: #172b4d;\r\n}\r\n\r\n.btn-outline-default:focus,\r\n.btn-outline-default.focus {\r\n  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);\r\n}\r\n\r\n.btn-outline-default.disabled,\r\n.btn-outline-default:disabled {\r\n  color: #172b4d;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-default:not(:disabled):not(.disabled):active,\r\n.btn-outline-default:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-default.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #172b4d;\r\n  border-color: #172b4d;\r\n}\r\n\r\n.btn-outline-default:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-default:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-default.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);\r\n}\r\n\r\n.btn-outline-white {\r\n  color: #fff;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-outline-white:hover {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-outline-white:focus,\r\n.btn-outline-white.focus {\r\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-outline-white.disabled,\r\n.btn-outline-white:disabled {\r\n  color: #fff;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-white:not(:disabled):not(.disabled):active,\r\n.btn-outline-white:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-white.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-outline-white:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-white:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-white.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-outline-neutral {\r\n  color: #fff;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-outline-neutral:hover {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-outline-neutral:focus,\r\n.btn-outline-neutral.focus {\r\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-outline-neutral.disabled,\r\n.btn-outline-neutral:disabled {\r\n  color: #fff;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-neutral:not(:disabled):not(.disabled):active,\r\n.btn-outline-neutral:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-neutral.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.btn-outline-neutral:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-neutral:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-neutral.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.btn-outline-darker {\r\n  color: black;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: black;\r\n}\r\n\r\n.btn-outline-darker:hover {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n}\r\n\r\n.btn-outline-darker:focus,\r\n.btn-outline-darker.focus {\r\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.btn-outline-darker.disabled,\r\n.btn-outline-darker:disabled {\r\n  color: black;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-darker:not(:disabled):not(.disabled):active,\r\n.btn-outline-darker:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-darker.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n}\r\n\r\n.btn-outline-darker:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-darker:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-outline-darker.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.btn-link {\r\n  font-weight: 400;\r\n  color: #5e72e4;\r\n  text-decoration: none;\r\n}\r\n\r\n.btn-link:hover {\r\n  color: #233dd2;\r\n  text-decoration: none;\r\n}\r\n\r\n.btn-link:focus,\r\n.btn-link.focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.btn-link:disabled,\r\n.btn-link.disabled {\r\n  color: #8898aa;\r\n  pointer-events: none;\r\n}\r\n\r\n.btn-lg,\r\n.btn-group-lg>.btn {\r\n  padding: 0.875rem 1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n.btn-sm,\r\n.btn-group-sm>.btn {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.btn-block {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.btn-block+.btn-block {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\ninput[type=\"submit\"].btn-block,\r\ninput[type=\"reset\"].btn-block,\r\ninput[type=\"button\"].btn-block {\r\n  width: 100%;\r\n}\r\n\r\n.fade {\r\n  transition: opacity 0.15s linear;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .fade {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.fade:not(.show) {\r\n  opacity: 0;\r\n}\r\n\r\n.collapse:not(.show) {\r\n  display: none;\r\n}\r\n\r\n.collapsing {\r\n  position: relative;\r\n  height: 0;\r\n  overflow: hidden;\r\n  transition: height 0.3s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .collapsing {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.dropup,\r\n.dropright,\r\n.dropdown,\r\n.dropleft {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  white-space: nowrap;\r\n}\r\n\r\n.dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.3em solid transparent;\r\n}\r\n\r\n.dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: 1000;\r\n  display: none;\r\n  float: left;\r\n  min-width: 10rem;\r\n  padding: 0.5rem 0;\r\n  margin: 0.125rem 0 0;\r\n  font-size: 1rem;\r\n  color: #525f7f;\r\n  text-align: left;\r\n  list-style: none;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 0 solid rgba(0, 0, 0, 0.15);\r\n  border-radius: 0.4375rem;\r\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),\r\n    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.dropdown-menu-left {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.dropdown-menu-right {\r\n  right: 0;\r\n  left: auto;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .dropdown-menu-sm-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-sm-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .dropdown-menu-md-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-md-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .dropdown-menu-lg-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-lg-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .dropdown-menu-xl-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-xl-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n.dropup .dropdown-menu {\r\n  top: auto;\r\n  bottom: 100%;\r\n  margin-top: 0;\r\n  margin-bottom: 0.125rem;\r\n}\r\n\r\n.dropup .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0.3em solid;\r\n  border-left: 0.3em solid transparent;\r\n}\r\n\r\n.dropup .dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropright .dropdown-menu {\r\n  top: 0;\r\n  right: auto;\r\n  left: 100%;\r\n  margin-top: 0;\r\n  margin-left: 0.125rem;\r\n}\r\n\r\n.dropright .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid transparent;\r\n  border-right: 0;\r\n  border-bottom: 0.3em solid transparent;\r\n  border-left: 0.3em solid;\r\n}\r\n\r\n.dropright .dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropright .dropdown-toggle::after {\r\n  vertical-align: 0;\r\n}\r\n\r\n.dropleft .dropdown-menu {\r\n  top: 0;\r\n  right: 100%;\r\n  left: auto;\r\n  margin-top: 0;\r\n  margin-right: 0.125rem;\r\n}\r\n\r\n.dropleft .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n}\r\n\r\n.dropleft .dropdown-toggle::after {\r\n  display: none;\r\n}\r\n\r\n.dropleft .dropdown-toggle::before {\r\n  display: inline-block;\r\n  margin-right: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid transparent;\r\n  border-right: 0.3em solid;\r\n  border-bottom: 0.3em solid transparent;\r\n}\r\n\r\n.dropleft .dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropleft .dropdown-toggle::before {\r\n  vertical-align: 0;\r\n}\r\n\r\n.dropdown-menu[x-placement^=\"top\"],\r\n.dropdown-menu[x-placement^=\"right\"],\r\n.dropdown-menu[x-placement^=\"bottom\"],\r\n.dropdown-menu[x-placement^=\"left\"] {\r\n  right: auto;\r\n  bottom: auto;\r\n}\r\n\r\n.dropdown-divider {\r\n  height: 0;\r\n  margin: 0.5rem 0;\r\n  overflow: hidden;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.5rem 1rem;\r\n  clear: both;\r\n  font-weight: 400;\r\n  color: #212529;\r\n  text-align: inherit;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.dropdown-item:hover,\r\n.dropdown-item:focus {\r\n  color: #16181b;\r\n  text-decoration: none;\r\n  background-color: #f6f9fc;\r\n}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n  color: #16181b;\r\n  text-decoration: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.dropdown-item.disabled,\r\n.dropdown-item:disabled {\r\n  color: #adb5bd;\r\n  pointer-events: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.dropdown-menu.show {\r\n  display: block;\r\n}\r\n\r\n.dropdown-header {\r\n  display: block;\r\n  padding: 0.5rem 1rem;\r\n  margin-bottom: 0;\r\n  font-size: 0.875rem;\r\n  color: #8898aa;\r\n  white-space: nowrap;\r\n}\r\n\r\n.dropdown-item-text {\r\n  display: block;\r\n  padding: 0.5rem 1rem;\r\n  color: #212529;\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle;\r\n}\r\n\r\n.btn-group>.btn,\r\n.btn-group-vertical>.btn {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.btn-group>.btn:hover,\r\n.btn-group-vertical>.btn:hover {\r\n  z-index: 1;\r\n}\r\n\r\n.btn-group>.btn:focus,\r\n.btn-group>.btn:active,\r\n.btn-group>.btn.active,\r\n.btn-group-vertical>.btn:focus,\r\n.btn-group-vertical>.btn:active,\r\n.btn-group-vertical>.btn.active {\r\n  z-index: 1;\r\n}\r\n\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.btn-toolbar .input-group {\r\n  width: auto;\r\n}\r\n\r\n.btn-group>.btn:not(:first-child),\r\n.btn-group>.btn-group:not(:first-child) {\r\n  margin-left: -1px;\r\n}\r\n\r\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\r\n.btn-group>.btn-group:not(:last-child)>.btn {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.btn-group>.btn:not(:first-child),\r\n.btn-group>.btn-group:not(:first-child)>.btn {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: 0.9375rem;\r\n  padding-left: 0.9375rem;\r\n}\r\n\r\n.dropdown-toggle-split::after,\r\n.dropup .dropdown-toggle-split::after,\r\n.dropright .dropdown-toggle-split::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropleft .dropdown-toggle-split::before {\r\n  margin-right: 0;\r\n}\r\n\r\n.btn-sm+.dropdown-toggle-split,\r\n.btn-group-sm>.btn+.dropdown-toggle-split {\r\n  padding-right: 0.375rem;\r\n  padding-left: 0.375rem;\r\n}\r\n\r\n.btn-lg+.dropdown-toggle-split,\r\n.btn-group-lg>.btn+.dropdown-toggle-split {\r\n  padding-right: 0.75rem;\r\n  padding-left: 0.75rem;\r\n}\r\n\r\n.btn-group.show .dropdown-toggle {\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-group.show .dropdown-toggle.btn-link {\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-group-vertical>.btn,\r\n.btn-group-vertical>.btn-group {\r\n  width: 100%;\r\n}\r\n\r\n.btn-group-vertical>.btn:not(:first-child),\r\n.btn-group-vertical>.btn-group:not(:first-child) {\r\n  margin-top: -1px;\r\n}\r\n\r\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),\r\n.btn-group-vertical>.btn-group:not(:last-child)>.btn {\r\n  border-bottom-right-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.btn-group-vertical>.btn:not(:first-child),\r\n.btn-group-vertical>.btn-group:not(:first-child)>.btn {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.btn-group-toggle>.btn,\r\n.btn-group-toggle>.btn-group>.btn {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.btn-group-toggle>.btn input[type=\"radio\"],\r\n.btn-group-toggle>.btn input[type=\"checkbox\"],\r\n.btn-group-toggle>.btn-group>.btn input[type=\"radio\"],\r\n.btn-group-toggle>.btn-group>.btn input[type=\"checkbox\"] {\r\n  position: absolute;\r\n  clip: rect(0, 0, 0, 0);\r\n  pointer-events: none;\r\n}\r\n\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: stretch;\r\n  width: 100%;\r\n}\r\n\r\n.input-group>.form-control,\r\n.input-group>.form-control-plaintext,\r\n.input-group>.custom-select,\r\n.input-group>.custom-file {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  width: 1%;\r\n  min-width: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.input-group>.form-control+.form-control,\r\n.input-group>.form-control+.custom-select,\r\n.input-group>.form-control+.custom-file,\r\n.input-group>.form-control-plaintext+.form-control,\r\n.input-group>.form-control-plaintext+.custom-select,\r\n.input-group>.form-control-plaintext+.custom-file,\r\n.input-group>.custom-select+.form-control,\r\n.input-group>.custom-select+.custom-select,\r\n.input-group>.custom-select+.custom-file,\r\n.input-group>.custom-file+.form-control,\r\n.input-group>.custom-file+.custom-select,\r\n.input-group>.custom-file+.custom-file {\r\n  margin-left: -1px;\r\n}\r\n\r\n.input-group>.form-control:focus,\r\n.input-group>.custom-select:focus,\r\n.input-group>.custom-file .custom-file-input:focus~.custom-file-label {\r\n  z-index: 3;\r\n}\r\n\r\n.input-group>.custom-file .custom-file-input:focus {\r\n  z-index: 4;\r\n}\r\n\r\n.input-group>.form-control:not(:first-child),\r\n.input-group>.custom-select:not(:first-child) {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.input-group>.custom-file {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.input-group>.custom-file:not(:last-child) .custom-file-label,\r\n.input-group>.custom-file:not(:first-child) .custom-file-label {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.input-group:not(.has-validation)>.form-control:not(:last-child),\r\n.input-group:not(.has-validation)>.custom-select:not(:last-child),\r\n.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.input-group.has-validation>.form-control:nth-last-child(n + 3),\r\n.input-group.has-validation>.custom-select:nth-last-child(n + 3),\r\n.input-group.has-validation>.custom-file:nth-last-child(n + 3) .custom-file-label::after {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.input-group-prepend,\r\n.input-group-append {\r\n  display: flex;\r\n}\r\n\r\n.input-group-prepend .btn,\r\n.input-group-append .btn {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.input-group-prepend .btn:focus,\r\n.input-group-append .btn:focus {\r\n  z-index: 3;\r\n}\r\n\r\n.input-group-prepend .btn+.btn,\r\n.input-group-prepend .btn+.input-group-text,\r\n.input-group-prepend .input-group-text+.input-group-text,\r\n.input-group-prepend .input-group-text+.btn,\r\n.input-group-append .btn+.btn,\r\n.input-group-append .btn+.input-group-text,\r\n.input-group-append .input-group-text+.input-group-text,\r\n.input-group-append .input-group-text+.btn {\r\n  margin-left: -1px;\r\n}\r\n\r\n.input-group-prepend {\r\n  margin-right: -1px;\r\n}\r\n\r\n.input-group-append {\r\n  margin-left: -1px;\r\n}\r\n\r\n.input-group-text {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.625rem 0.75rem;\r\n  margin-bottom: 0;\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #adb5bd;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.input-group-text input[type=\"radio\"],\r\n.input-group-text input[type=\"checkbox\"] {\r\n  margin-top: 0;\r\n}\r\n\r\n.input-group-lg>.form-control:not(textarea),\r\n.input-group-lg>.custom-select {\r\n  height: calc(1.5em + 1.75rem + 2px);\r\n}\r\n\r\n.input-group-lg>.form-control,\r\n.input-group-lg>.custom-select,\r\n.input-group-lg>.input-group-prepend>.input-group-text,\r\n.input-group-lg>.input-group-append>.input-group-text,\r\n.input-group-lg>.input-group-prepend>.btn,\r\n.input-group-lg>.input-group-append>.btn {\r\n  padding: 0.875rem 1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n.input-group-sm>.form-control:not(textarea),\r\n.input-group-sm>.custom-select {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n}\r\n\r\n.input-group-sm>.form-control,\r\n.input-group-sm>.custom-select,\r\n.input-group-sm>.input-group-prepend>.input-group-text,\r\n.input-group-sm>.input-group-append>.input-group-text,\r\n.input-group-sm>.input-group-prepend>.btn,\r\n.input-group-sm>.input-group-append>.btn {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.input-group-lg>.custom-select,\r\n.input-group-sm>.custom-select {\r\n  padding-right: 1.75rem;\r\n}\r\n\r\n.input-group>.input-group-prepend>.btn,\r\n.input-group>.input-group-prepend>.input-group-text,\r\n.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,\r\n.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,\r\n.input-group.has-validation>.input-group-append:nth-last-child(n + 3)>.btn,\r\n.input-group.has-validation>.input-group-append:nth-last-child(n + 3)>.input-group-text,\r\n.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),\r\n.input-group>.input-group-append:last-child>.input-group-text:not(:last-child) {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.input-group>.input-group-append>.btn,\r\n.input-group>.input-group-append>.input-group-text,\r\n.input-group>.input-group-prepend:not(:first-child)>.btn,\r\n.input-group>.input-group-prepend:not(:first-child)>.input-group-text,\r\n.input-group>.input-group-prepend:first-child>.btn:not(:first-child),\r\n.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child) {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.cards-header-icon-img {\r\n  width: 3.0rem;\r\n  height: 3.0rem;\r\n  object-fit: contain;\r\n}\r\n\r\n.custom-control {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: block;\r\n  min-height: 1.5rem;\r\n  padding-left: 2.75rem;\r\n  color-adjust: exact;\r\n}\r\n\r\n.custom-control-inline {\r\n  display: inline-flex;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.custom-control-input {\r\n  position: absolute;\r\n  left: 0;\r\n  z-index: -1;\r\n  width: 1rem;\r\n  height: 1.25rem;\r\n  opacity: 0;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n  color: #fff;\r\n  border-color: #5e72e4;\r\n  background-color: #5e72e4;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n}\r\n\r\n.custom-control-input:focus~.custom-control-label::before {\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05),\r\n    0 3px 2px rgba(233, 236, 239, 0.05);\r\n}\r\n\r\n.custom-control-input:focus:not(:checked)~.custom-control-label::before {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.custom-control-input:not(:disabled):active~.custom-control-label::before {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n}\r\n\r\n.custom-control-input[disabled]~.custom-control-label,\r\n.custom-control-input:disabled~.custom-control-label {\r\n  color: #8898aa;\r\n}\r\n\r\n.custom-control-input[disabled]~.custom-control-label::before,\r\n.custom-control-input:disabled~.custom-control-label::before {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.custom-control-label {\r\n  position: relative;\r\n  margin-bottom: 0;\r\n  vertical-align: top;\r\n}\r\n\r\n.custom-control-label::before {\r\n  position: absolute;\r\n  top: 0.25rem;\r\n  left: -2.75rem;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  pointer-events: none;\r\n  content: \"\";\r\n  background-color: #fff;\r\n  border: #dee2e6 solid 1px;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n}\r\n\r\n.custom-control-label::after {\r\n  position: absolute;\r\n  top: 0.25rem;\r\n  left: -2.75rem;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  content: \"\";\r\n  background: 50% / 50% 50% no-repeat;\r\n}\r\n\r\n.custom-checkbox .custom-control-label::before {\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {\r\n  border-color: #5e72e4;\r\n  background-color: #5e72e4;\r\n  box-shadow: ;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {\r\n  background-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before {\r\n  background-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-radio .custom-control-label::before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before {\r\n  background-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-switch {\r\n  padding-left: 3.5rem;\r\n}\r\n\r\n.custom-switch .custom-control-label::before {\r\n  left: -3.5rem;\r\n  width: 1.75rem;\r\n  pointer-events: all;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.custom-switch .custom-control-label::after {\r\n  top: calc(0.25rem + 2px);\r\n  left: calc(-3.5rem + 2px);\r\n  width: calc(1rem - 4px);\r\n  height: calc(1rem - 4px);\r\n  background-color: #dee2e6;\r\n  border-radius: 0.5rem;\r\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out,\r\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-switch .custom-control-label::after {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-switch .custom-control-input:checked~.custom-control-label::after {\r\n  background-color: #fff;\r\n  transform: translateX(0.75rem);\r\n}\r\n\r\n.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before {\r\n  background-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-select {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  padding: 0.625rem 1.75rem 0.625rem 0.75rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #8898aa;\r\n  vertical-align: middle;\r\n  background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%2332325d' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.375rem;\r\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\r\n  appearance: none;\r\n}\r\n\r\n.custom-select:focus {\r\n  border-color: #5e72e4;\r\n  outline: 0;\r\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #5e72e4;\r\n}\r\n\r\n.custom-select:focus::-ms-value {\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n}\r\n\r\n.custom-select[multiple],\r\n.custom-select[size]:not([size=\"1\"]) {\r\n  height: auto;\r\n  padding-right: 0.75rem;\r\n  background-image: none;\r\n}\r\n\r\n.custom-select:disabled {\r\n  color: #8898aa;\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.custom-select::-ms-expand {\r\n  display: none;\r\n}\r\n\r\n.custom-select:-moz-focusring {\r\n  color: transparent;\r\n  text-shadow: 0 0 0 #8898aa;\r\n}\r\n\r\n.custom-select-sm {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n  padding-left: 0.5rem;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.custom-select-lg {\r\n  height: calc(1.5em + 1.75rem + 2px);\r\n  padding-top: 0.875rem;\r\n  padding-bottom: 0.875rem;\r\n  padding-left: 1rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  margin: 0;\r\n  overflow: hidden;\r\n  opacity: 0;\r\n}\r\n\r\n.custom-file-input:focus~.custom-file-label {\r\n  border-color: #5e72e4;\r\n  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.custom-file-input[disabled]~.custom-file-label,\r\n.custom-file-input:disabled~.custom-file-label {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.custom-file-input:lang(en)~.custom-file-label::after {\r\n  content: \"Browse\";\r\n}\r\n\r\n.custom-file-input~.custom-file-label[data-browse]::after {\r\n  content: attr(data-browse);\r\n}\r\n\r\n.custom-file-label {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  padding: 0.625rem 0.75rem;\r\n  overflow: hidden;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.25rem;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n}\r\n\r\n.custom-file-label::after {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 3;\r\n  display: block;\r\n  height: calc(1.5em + 1.25rem);\r\n  padding: 0.625rem 0.75rem;\r\n  line-height: 1.5;\r\n  color: #8898aa;\r\n  content: \"Browse\";\r\n  background-color: #fff;\r\n  border-left: inherit;\r\n  border-radius: 0 0.25rem 0.25rem 0;\r\n}\r\n\r\n.custom-range {\r\n  width: 100%;\r\n  height: 1rem;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  appearance: none;\r\n}\r\n\r\n.custom-range:focus {\r\n  outline: 0;\r\n}\r\n\r\n.custom-range:focus::-webkit-slider-thumb {\r\n  box-shadow: 0 0 0 1px #f8f9fe, 0 3px 9px rgba(50, 50, 9, 0),\r\n    3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.custom-range:focus::-moz-range-thumb {\r\n  box-shadow: 0 0 0 1px #f8f9fe, 0 3px 9px rgba(50, 50, 9, 0),\r\n    3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.custom-range:focus::-ms-thumb {\r\n  box-shadow: 0 0 0 1px #f8f9fe, 0 3px 9px rgba(50, 50, 9, 0),\r\n    3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.custom-range::-moz-focus-outer {\r\n  border: 0;\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  margin-top: -0.25rem;\r\n  background-color: #5e72e4;\r\n  border: 0;\r\n  border-radius: 1rem;\r\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n  appearance: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-range::-webkit-slider-thumb {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb:active {\r\n  background-color: #f7f8fe;\r\n}\r\n\r\n.custom-range::-webkit-slider-runnable-track {\r\n  width: 100%;\r\n  height: 0.5rem;\r\n  color: transparent;\r\n  cursor: pointer;\r\n  background-color: #dee2e6;\r\n  border-color: transparent;\r\n  border-radius: 1rem;\r\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.custom-range::-moz-range-thumb {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  background-color: #5e72e4;\r\n  border: 0;\r\n  border-radius: 1rem;\r\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n  appearance: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-range::-moz-range-thumb {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-range::-moz-range-thumb:active {\r\n  background-color: #f7f8fe;\r\n}\r\n\r\n.custom-range::-moz-range-track {\r\n  width: 100%;\r\n  height: 0.5rem;\r\n  color: transparent;\r\n  cursor: pointer;\r\n  background-color: #dee2e6;\r\n  border-color: transparent;\r\n  border-radius: 1rem;\r\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.custom-range::-ms-thumb {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  margin-top: 0;\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n  background-color: #5e72e4;\r\n  border: 0;\r\n  border-radius: 1rem;\r\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n  appearance: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-range::-ms-thumb {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-range::-ms-thumb:active {\r\n  background-color: #f7f8fe;\r\n}\r\n\r\n.custom-range::-ms-track {\r\n  width: 100%;\r\n  height: 0.5rem;\r\n  color: transparent;\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  border-width: 0.5rem;\r\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.custom-range::-ms-fill-lower {\r\n  background-color: #dee2e6;\r\n  border-radius: 1rem;\r\n}\r\n\r\n.custom-range::-ms-fill-upper {\r\n  margin-right: 15px;\r\n  background-color: #dee2e6;\r\n  border-radius: 1rem;\r\n}\r\n\r\n.custom-range:disabled::-webkit-slider-thumb {\r\n  background-color: #adb5bd;\r\n}\r\n\r\n.custom-range:disabled::-webkit-slider-runnable-track {\r\n  cursor: default;\r\n}\r\n\r\n.custom-range:disabled::-moz-range-thumb {\r\n  background-color: #adb5bd;\r\n}\r\n\r\n.custom-range:disabled::-moz-range-track {\r\n  cursor: default;\r\n}\r\n\r\n.custom-range:disabled::-ms-thumb {\r\n  background-color: #adb5bd;\r\n}\r\n\r\n.custom-control-label::before,\r\n.custom-file-label,\r\n.custom-select {\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .custom-control-label::before,\r\n  .custom-file-label,\r\n  .custom-select {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: 0.25rem 0.75rem;\r\n}\r\n\r\n.nav-link:hover,\r\n.nav-link:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.nav-link.disabled {\r\n  color: #8898aa;\r\n  pointer-events: none;\r\n  cursor: default;\r\n}\r\n\r\n.nav-tabs {\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n  margin-bottom: -1px;\r\n  border: 1px solid transparent;\r\n  border-top-left-radius: 0.375rem;\r\n  border-top-right-radius: 0.375rem;\r\n}\r\n\r\n.nav-tabs .nav-link:hover,\r\n.nav-tabs .nav-link:focus {\r\n  border-color: #e9ecef #e9ecef #dee2e6;\r\n}\r\n\r\n.nav-tabs .nav-link.disabled {\r\n  color: #8898aa;\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n}\r\n\r\n.nav-tabs .nav-link.active,\r\n.nav-tabs .nav-item.show .nav-link {\r\n  color: #525f7f;\r\n  background-color: #f8f9fe;\r\n  border-color: #dee2e6 #dee2e6 #f8f9fe;\r\n}\r\n\r\n.nav-tabs .dropdown-menu {\r\n  margin-top: -1px;\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.nav-pills .nav-link {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show>.nav-link {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n}\r\n\r\n.nav-fill>.nav-link,\r\n.nav-fill .nav-item {\r\n  flex: 1 1 auto;\r\n  text-align: center;\r\n}\r\n\r\n.nav-justified>.nav-link,\r\n.nav-justified .nav-item {\r\n  flex-basis: 0;\r\n  flex-grow: 1;\r\n  text-align: center;\r\n}\r\n\r\n.tab-content>.tab-pane {\r\n  display: none;\r\n}\r\n\r\n.tab-content>.active {\r\n  display: block;\r\n}\r\n\r\n.navbar {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1rem 1rem;\r\n}\r\n\r\n.navbar .container,\r\n.navbar .container-fluid,\r\n.navbar .container-sm,\r\n.navbar .container-md,\r\n.navbar .container-lg,\r\n.navbar .container-xl {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.navbar-brand {\r\n  display: inline-block;\r\n  padding-top: 0.0625rem;\r\n  padding-bottom: 0.0625rem;\r\n  margin-right: 1rem;\r\n  font-size: 1.25rem;\r\n  line-height: inherit;\r\n  white-space: nowrap;\r\n}\r\n\r\n.navbar-brand:hover,\r\n.navbar-brand:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.navbar-nav .nav-link {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.navbar-nav .dropdown-menu {\r\n  position: static;\r\n  float: none;\r\n}\r\n\r\n.navbar-text {\r\n  display: inline-block;\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n}\r\n\r\n.navbar-collapse {\r\n  flex-basis: 100%;\r\n  flex-grow: 1;\r\n  align-items: center;\r\n}\r\n\r\n.navbar-toggler {\r\n  padding: 0.25rem 0.75rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.navbar-toggler:hover,\r\n.navbar-toggler:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  background: 50% / 100% 100% no-repeat;\r\n}\r\n\r\n.navbar-nav-scroll {\r\n  max-height: 75vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n\r\n  .navbar-expand-sm>.container,\r\n  .navbar-expand-sm>.container-fluid,\r\n  .navbar-expand-sm>.container-sm,\r\n  .navbar-expand-sm>.container-md,\r\n  .navbar-expand-sm>.container-lg,\r\n  .navbar-expand-sm>.container-xl {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .navbar-expand-sm {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav .nav-link {\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n  }\r\n\r\n  .navbar-expand-sm>.container,\r\n  .navbar-expand-sm>.container-fluid,\r\n  .navbar-expand-sm>.container-sm,\r\n  .navbar-expand-sm>.container-md,\r\n  .navbar-expand-sm>.container-lg,\r\n  .navbar-expand-sm>.container-xl {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav-scroll {\r\n    overflow: visible;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n\r\n  .navbar-expand-md>.container,\r\n  .navbar-expand-md>.container-fluid,\r\n  .navbar-expand-md>.container-sm,\r\n  .navbar-expand-md>.container-md,\r\n  .navbar-expand-md>.container-lg,\r\n  .navbar-expand-md>.container-xl {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-expand-md {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav .nav-link {\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n  }\r\n\r\n  .navbar-expand-md>.container,\r\n  .navbar-expand-md>.container-fluid,\r\n  .navbar-expand-md>.container-sm,\r\n  .navbar-expand-md>.container-md,\r\n  .navbar-expand-md>.container-lg,\r\n  .navbar-expand-md>.container-xl {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav-scroll {\r\n    overflow: visible;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n\r\n  .navbar-expand-lg>.container,\r\n  .navbar-expand-lg>.container-fluid,\r\n  .navbar-expand-lg>.container-sm,\r\n  .navbar-expand-lg>.container-md,\r\n  .navbar-expand-lg>.container-lg,\r\n  .navbar-expand-lg>.container-xl {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .navbar-expand-lg {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav .nav-link {\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n  }\r\n\r\n  .navbar-expand-lg>.container,\r\n  .navbar-expand-lg>.container-fluid,\r\n  .navbar-expand-lg>.container-sm,\r\n  .navbar-expand-lg>.container-md,\r\n  .navbar-expand-lg>.container-lg,\r\n  .navbar-expand-lg>.container-xl {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav-scroll {\r\n    overflow: visible;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n\r\n  .navbar-expand-xl>.container,\r\n  .navbar-expand-xl>.container-fluid,\r\n  .navbar-expand-xl>.container-sm,\r\n  .navbar-expand-xl>.container-md,\r\n  .navbar-expand-xl>.container-lg,\r\n  .navbar-expand-xl>.container-xl {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .navbar-expand-xl {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav .nav-link {\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n  }\r\n\r\n  .navbar-expand-xl>.container,\r\n  .navbar-expand-xl>.container-fluid,\r\n  .navbar-expand-xl>.container-sm,\r\n  .navbar-expand-xl>.container-md,\r\n  .navbar-expand-xl>.container-lg,\r\n  .navbar-expand-xl>.container-xl {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav-scroll {\r\n    overflow: visible;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.navbar-expand {\r\n  flex-flow: row nowrap;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.navbar-expand>.container,\r\n.navbar-expand>.container-fluid,\r\n.navbar-expand>.container-sm,\r\n.navbar-expand>.container-md,\r\n.navbar-expand>.container-lg,\r\n.navbar-expand>.container-xl {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.navbar-expand .navbar-nav {\r\n  flex-direction: row;\r\n}\r\n\r\n.navbar-expand .navbar-nav .dropdown-menu {\r\n  position: absolute;\r\n}\r\n\r\n.navbar-expand .navbar-nav .nav-link {\r\n  padding-right: 1rem;\r\n  padding-left: 1rem;\r\n}\r\n\r\n.navbar-expand>.container,\r\n.navbar-expand>.container-fluid,\r\n.navbar-expand>.container-sm,\r\n.navbar-expand>.container-md,\r\n.navbar-expand>.container-lg,\r\n.navbar-expand>.container-xl {\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.navbar-expand .navbar-nav-scroll {\r\n  overflow: visible;\r\n}\r\n\r\n.navbar-expand .navbar-collapse {\r\n  display: flex !important;\r\n  flex-basis: auto;\r\n}\r\n\r\n.navbar-expand .navbar-toggler {\r\n  display: none;\r\n}\r\n\r\n.navbar-light .navbar-brand {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-brand:hover,\r\n.navbar-light .navbar-brand:focus {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link {\r\n  color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link:hover,\r\n.navbar-light .navbar-nav .nav-link:focus {\r\n  color: rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link.disabled {\r\n  color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.navbar-light .navbar-nav .show>.nav-link,\r\n.navbar-light .navbar-nav .active>.nav-link,\r\n.navbar-light .navbar-nav .nav-link.show,\r\n.navbar-light .navbar-nav .nav-link.active {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-toggler {\r\n  color: rgba(0, 0, 0, 0.6);\r\n  border-color: transparent;\r\n}\r\n\r\n.navbar-light .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.6%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.navbar-light .navbar-text {\r\n  color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.navbar-light .navbar-text a {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-text a:hover,\r\n.navbar-light .navbar-text a:focus {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-dark .navbar-brand {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.navbar-dark .navbar-brand:hover,\r\n.navbar-dark .navbar-brand:focus {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link {\r\n  color: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link:hover,\r\n.navbar-dark .navbar-nav .nav-link:focus {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link.disabled {\r\n  color: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.navbar-dark .navbar-nav .show>.nav-link,\r\n.navbar-dark .navbar-nav .active>.nav-link,\r\n.navbar-dark .navbar-nav .nav-link.show,\r\n.navbar-dark .navbar-nav .nav-link.active {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.navbar-dark .navbar-toggler {\r\n  color: rgba(255, 255, 255, 0.95);\r\n  border-color: transparent;\r\n}\r\n\r\n.navbar-dark .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.95%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.navbar-dark .navbar-text {\r\n  color: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n.navbar-dark .navbar-text a {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.navbar-dark .navbar-text a:hover,\r\n.navbar-dark .navbar-text a:focus {\r\n  color: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.card>hr {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.card>.list-group {\r\n  border-top: inherit;\r\n  border-bottom: inherit;\r\n}\r\n\r\n.card>.list-group:first-child {\r\n  border-top-width: 0;\r\n  border-top-left-radius: calc(0.375rem - 1px);\r\n  border-top-right-radius: calc(0.375rem - 1px);\r\n}\r\n\r\n.card>.list-group:last-child {\r\n  border-bottom-width: 0;\r\n  border-bottom-right-radius: calc(0.375rem - 1px);\r\n  border-bottom-left-radius: calc(0.375rem - 1px);\r\n}\r\n\r\n.card>.card-header+.list-group,\r\n.card>.list-group+.card-footer {\r\n  border-top: 0;\r\n}\r\n\r\n.card-body {\r\n  flex: 1 1 auto;\r\n  min-height: 1px;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.card-title {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.card-subtitle {\r\n  margin-top: -0.625rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-text:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-link:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.card-link+.card-link {\r\n  margin-left: 1.5rem;\r\n}\r\n\r\n.card-header {\r\n  padding: 1.25rem 1.5rem;\r\n  margin-bottom: 0;\r\n  background-color: #fff;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.card-header:first-child {\r\n  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;\r\n}\r\n\r\n.card-footer {\r\n  padding: 1.25rem 1.5rem;\r\n  background-color: #fff;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.card-footer:last-child {\r\n  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);\r\n}\r\n\r\n.card-header-tabs {\r\n  margin-right: -0.75rem;\r\n  margin-bottom: -1.25rem;\r\n  margin-left: -0.75rem;\r\n  border-bottom: 0;\r\n}\r\n\r\n.card-header-pills {\r\n  margin-right: -0.75rem;\r\n  margin-left: -0.75rem;\r\n}\r\n\r\n.card-img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 1.25rem;\r\n  border-radius: calc(0.375rem - 1px);\r\n}\r\n\r\n.card-img,\r\n.card-img-top,\r\n.card-img-bottom {\r\n  flex-shrink: 0;\r\n  width: 100%;\r\n}\r\n\r\n.card-img,\r\n.card-img-top {\r\n  border-top-left-radius: calc(0.375rem - 1px);\r\n  border-top-right-radius: calc(0.375rem - 1px);\r\n}\r\n\r\n.card-img,\r\n.card-img-bottom {\r\n  border-bottom-right-radius: calc(0.375rem - 1px);\r\n  border-bottom-left-radius: calc(0.375rem - 1px);\r\n}\r\n\r\n.card-deck .card {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-deck {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n  }\r\n\r\n  .card-deck .card {\r\n    flex: 1 0 0%;\r\n    margin-right: 15px;\r\n    margin-bottom: 0;\r\n    margin-left: 15px;\r\n  }\r\n}\r\n\r\n.card-group>.card {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-group {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n  }\r\n\r\n  .card-group>.card {\r\n    flex: 1 0 0%;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .card-group>.card+.card {\r\n    margin-left: 0;\r\n    border-left: 0;\r\n  }\r\n\r\n  .card-group>.card:not(:last-child) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  .card-group>.card:not(:last-child) .card-img-top,\r\n  .card-group>.card:not(:last-child) .card-header {\r\n    border-top-right-radius: 0;\r\n  }\r\n\r\n  .card-group>.card:not(:last-child) .card-img-bottom,\r\n  .card-group>.card:not(:last-child) .card-footer {\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  .card-group>.card:not(:first-child) {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .card-group>.card:not(:first-child) .card-img-top,\r\n  .card-group>.card:not(:first-child) .card-header {\r\n    border-top-left-radius: 0;\r\n  }\r\n\r\n  .card-group>.card:not(:first-child) .card-img-bottom,\r\n  .card-group>.card:not(:first-child) .card-footer {\r\n    border-bottom-left-radius: 0;\r\n  }\r\n}\r\n\r\n.card-columns .card {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-columns {\r\n    column-count: 3;\r\n    column-gap: 1.25rem;\r\n    orphans: 1;\r\n    widows: 1;\r\n  }\r\n\r\n  .card-columns .card {\r\n    display: inline-block;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.accordion {\r\n  overflow-anchor: none;\r\n}\r\n\r\n.accordion>.card {\r\n  overflow: hidden;\r\n}\r\n\r\n.accordion>.card:not(:last-of-type) {\r\n  border-bottom: 0;\r\n  border-bottom-right-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.accordion>.card:not(:first-of-type) {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.accordion>.card>.card-header {\r\n  border-radius: 0;\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.breadcrumb {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: 0.5rem 1rem;\r\n  margin-bottom: 1rem;\r\n  list-style: none;\r\n  background-color: #f6f9fc;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item {\r\n  padding-left: 0.5rem;\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n  float: left;\r\n  padding-right: 0.5rem;\r\n  color: #8898aa;\r\n  content: \"-\";\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item:hover::before {\r\n  text-decoration: underline;\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item:hover::before {\r\n  text-decoration: none;\r\n}\r\n\r\n.breadcrumb-item.active {\r\n  color: #ffffff;\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  padding-left: 0;\r\n  list-style: none;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: 0.5rem 0.75rem;\r\n  margin-left: -1px;\r\n  line-height: 1.25;\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.page-link:hover {\r\n  z-index: 2;\r\n  color: #8898aa;\r\n  text-decoration: none;\r\n  background-color: #dee2e6;\r\n  border-color: #dee2e6;\r\n}\r\n\r\n.page-link:focus {\r\n  z-index: 3;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.page-item:first-child .page-link {\r\n  margin-left: 0;\r\n  border-top-left-radius: 0.375rem;\r\n  border-bottom-left-radius: 0.375rem;\r\n}\r\n\r\n.page-item:last-child .page-link {\r\n  border-top-right-radius: 0.375rem;\r\n  border-bottom-right-radius: 0.375rem;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  z-index: 3;\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.page-item.disabled .page-link {\r\n  color: #8898aa;\r\n  pointer-events: none;\r\n  cursor: auto;\r\n  background-color: #fff;\r\n  border-color: #dee2e6;\r\n}\r\n\r\n.pagination-lg .page-link {\r\n  padding: 0.75rem 1.5rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.pagination-lg .page-item:first-child .page-link {\r\n  border-top-left-radius: 0.4375rem;\r\n  border-bottom-left-radius: 0.4375rem;\r\n}\r\n\r\n.pagination-lg .page-item:last-child .page-link {\r\n  border-top-right-radius: 0.4375rem;\r\n  border-bottom-right-radius: 0.4375rem;\r\n}\r\n\r\n.pagination-sm .page-link {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.pagination-sm .page-item:first-child .page-link {\r\n  border-top-left-radius: 0.25rem;\r\n  border-bottom-left-radius: 0.25rem;\r\n}\r\n\r\n.pagination-sm .page-item:last-child .page-link {\r\n  border-top-right-radius: 0.25rem;\r\n  border-bottom-right-radius: 0.25rem;\r\n}\r\n\r\n/* ===============================\r\n   Pagination – Dark Mode Fix\r\n   =============================== */\r\n\r\n.table-dark-mode .page-link {\r\n  color: #8898aa;\r\n  background-color: #ffffff;\r\n  border-color: #374151;\r\n}\r\n\r\n.table-dark-mode .page-link:hover {\r\n  color: #ffffff;\r\n  background-color: #374151;\r\n  border-color: #4b5563;\r\n}\r\n\r\n.table-dark-mode .page-item.disabled .page-link {\r\n  color: #6b7280;\r\n  background-color: #1f2937;\r\n  border-color: #374151;\r\n}\r\n\r\n.table-dark-mode .page-item.active .page-link {\r\n  color: #ffffff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: 0.35rem 0.375rem;\r\n  font-size: 66%;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  border-radius: 0.375rem;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\r\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .badge {\r\n    transition: none;\r\n  }\r\n}\r\n\r\na.badge:hover,\r\na.badge:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.badge:empty {\r\n  display: none;\r\n}\r\n\r\n.btn .badge {\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n.badge-pill {\r\n  padding-right: 0.875em;\r\n  padding-left: 0.875em;\r\n  border-radius: 10rem;\r\n}\r\n\r\n.badge-primary {\r\n  color: #2643e9;\r\n  background-color: #eaecfb;\r\n}\r\n\r\n.badge-primary[href]:hover,\r\n.badge-primary[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #2a44db;\r\n}\r\n\r\n.badge-secondary {\r\n  color: #cfe3f1;\r\n  background-color: white;\r\n}\r\n\r\n.badge-secondary[href]:hover,\r\n.badge-secondary[href]:focus {\r\n  color: #212529;\r\n  text-decoration: none;\r\n  background-color: #cadeeb;\r\n}\r\n\r\n.badge-success {\r\n  color: #1aae6f;\r\n  background-color: #b0eed3;\r\n}\r\n\r\n.badge-success[href]:hover,\r\n.badge-success[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #229c68;\r\n}\r\n\r\n.badge-info {\r\n  color: #03acca;\r\n  background-color: #aaedf9;\r\n}\r\n\r\n.badge-info[href]:hover,\r\n.badge-info[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #0c9cb7;\r\n}\r\n\r\n.badge-warning {\r\n  color: #ff3709;\r\n  background-color: #fee6e0;\r\n}\r\n\r\n.badge-warning[href]:hover,\r\n.badge-warning[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #f93305;\r\n}\r\n\r\n.badge-danger {\r\n  color: #f80031;\r\n  background-color: #fdd1da;\r\n}\r\n\r\n.badge-danger[href]:hover,\r\n.badge-danger[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #e30b36;\r\n}\r\n\r\n.badge-light {\r\n  color: #879cb0;\r\n  background-color: white;\r\n}\r\n\r\n.badge-light[href]:hover,\r\n.badge-light[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #8b96a2;\r\n}\r\n\r\n.badge-dark {\r\n  color: #090c0e;\r\n  background-color: #6a7783;\r\n}\r\n\r\n.badge-dark[href]:hover,\r\n.badge-dark[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #060607;\r\n}\r\n\r\n.badge-default {\r\n  color: #091428;\r\n  background-color: #4172c6;\r\n}\r\n\r\n.badge-default[href]:hover,\r\n.badge-default[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: #09111e;\r\n}\r\n\r\n.badge-white {\r\n  color: #e8e3e3;\r\n  background-color: white;\r\n}\r\n\r\n.badge-white[href]:hover,\r\n.badge-white[href]:focus {\r\n  color: #212529;\r\n  text-decoration: none;\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.badge-neutral {\r\n  color: #e8e3e3;\r\n  background-color: white;\r\n}\r\n\r\n.badge-neutral[href]:hover,\r\n.badge-neutral[href]:focus {\r\n  color: #212529;\r\n  text-decoration: none;\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.badge-darker {\r\n  color: black;\r\n  background-color: #525252;\r\n}\r\n\r\n.badge-darker[href]:hover,\r\n.badge-darker[href]:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: black;\r\n}\r\n\r\n.jumbotron {\r\n  padding: 2rem 1rem;\r\n  margin-bottom: 2rem;\r\n  background-color: #e9ecef;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .jumbotron {\r\n    padding: 4rem 2rem;\r\n  }\r\n}\r\n\r\n.jumbotron-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n  border-radius: 0;\r\n}\r\n\r\n.alert {\r\n  position: relative;\r\n  padding: 1rem 1.5rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid transparent;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.alert-heading {\r\n  color: inherit;\r\n}\r\n\r\n.alert-link {\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-dismissible {\r\n  padding-right: 4.5rem;\r\n}\r\n\r\n.alert-dismissible .close {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 2;\r\n  padding: 1rem 1.5rem;\r\n  color: inherit;\r\n}\r\n\r\n.alert-primary {\r\n  color: #fff;\r\n  border-color: #7889e8;\r\n  background-color: #7889e8;\r\n}\r\n\r\n.alert-primary a {\r\n  color: #1d32aa;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-primary a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-primary hr {\r\n  border-top-color: #6276e4;\r\n}\r\n\r\n.alert-primary .alert-link {\r\n  color: #324cdd;\r\n}\r\n\r\n.alert-secondary {\r\n  color: #212529;\r\n  border-color: #f8fbfc;\r\n  background-color: #f8fbfc;\r\n}\r\n\r\n.alert-secondary a {\r\n  color: #8dbece;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-secondary a:hover {\r\n  color: #212529;\r\n}\r\n\r\n.alert-secondary hr {\r\n  border-top-color: #e6f1f4;\r\n}\r\n\r\n.alert-secondary .alert-link {\r\n  color: #d2e3ee;\r\n}\r\n\r\n.alert-success {\r\n  color: #fff;\r\n  border-color: #4fd69c;\r\n  background-color: #4fd69c;\r\n}\r\n\r\n.alert-success a {\r\n  color: #1a724c;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-success a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-success hr {\r\n  border-top-color: #3ad190;\r\n}\r\n\r\n.alert-success .alert-link {\r\n  color: #24a46d;\r\n}\r\n\r\n.alert-info {\r\n  color: #fff;\r\n  border-color: #37d5f2;\r\n  background-color: #37d5f2;\r\n}\r\n\r\n.alert-info a {\r\n  color: #097487;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-info a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-info hr {\r\n  border-top-color: #1fd0f0;\r\n}\r\n\r\n.alert-info .alert-link {\r\n  color: #0da5c0;\r\n}\r\n\r\n.alert-warning {\r\n  color: #fff;\r\n  border-color: #fc7c5f;\r\n  background-color: #fc7c5f;\r\n}\r\n\r\n.alert-warning a {\r\n  color: #be2604;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-warning a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-warning hr {\r\n  border-top-color: #fc6846;\r\n}\r\n\r\n.alert-warning .alert-link {\r\n  color: #fa3a0e;\r\n}\r\n\r\n.alert-danger {\r\n  color: #fff;\r\n  border-color: #f75676;\r\n  background-color: #f75676;\r\n}\r\n\r\n.alert-danger a {\r\n  color: #ac0829;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-danger a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-danger hr {\r\n  border-top-color: #f63e62;\r\n}\r\n\r\n.alert-danger .alert-link {\r\n  color: #ec0c38;\r\n}\r\n\r\n.alert-light {\r\n  color: #fff;\r\n  border-color: #bac1c8;\r\n  background-color: #bac1c8;\r\n}\r\n\r\n.alert-light a {\r\n  color: #677582;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-light a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-light hr {\r\n  border-top-color: #acb4bd;\r\n}\r\n\r\n.alert-light .alert-link {\r\n  color: #919ca6;\r\n}\r\n\r\n.alert-dark {\r\n  color: #fff;\r\n  border-color: #45484b;\r\n  background-color: #45484b;\r\n}\r\n\r\n.alert-dark a {\r\n  color: black;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-dark a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-dark hr {\r\n  border-top-color: #393b3e;\r\n}\r\n\r\n.alert-dark .alert-link {\r\n  color: #0a0c0d;\r\n}\r\n\r\n.alert-default {\r\n  color: #fff;\r\n  border-color: #3c4d69;\r\n  background-color: #3c4d69;\r\n}\r\n\r\n.alert-default a {\r\n  color: #040608;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-default a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-default hr {\r\n  border-top-color: #334159;\r\n}\r\n\r\n.alert-default .alert-link {\r\n  color: #0b1526;\r\n}\r\n\r\n.alert-white {\r\n  color: #212529;\r\n  border-color: white;\r\n  background-color: white;\r\n}\r\n\r\n.alert-white a {\r\n  color: #b3b3b3;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-white a:hover {\r\n  color: #212529;\r\n}\r\n\r\n.alert-white hr {\r\n  border-top-color: #f2f2f2;\r\n}\r\n\r\n.alert-white .alert-link {\r\n  color: #e6e6e6;\r\n}\r\n\r\n.alert-neutral {\r\n  color: #212529;\r\n  border-color: white;\r\n  background-color: white;\r\n}\r\n\r\n.alert-neutral a {\r\n  color: #b3b3b3;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-neutral a:hover {\r\n  color: #212529;\r\n}\r\n\r\n.alert-neutral hr {\r\n  border-top-color: #f2f2f2;\r\n}\r\n\r\n.alert-neutral .alert-link {\r\n  color: #e6e6e6;\r\n}\r\n\r\n.alert-darker {\r\n  color: #fff;\r\n  border-color: #292929;\r\n  background-color: #292929;\r\n}\r\n\r\n.alert-darker a {\r\n  color: black;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-darker a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.alert-darker hr {\r\n  border-top-color: #1c1c1c;\r\n}\r\n\r\n.alert-darker .alert-link {\r\n  color: black;\r\n}\r\n\r\n@keyframes progress-bar-stripes {\r\n  from {\r\n    background-position: 1rem 0;\r\n  }\r\n\r\n  to {\r\n    background-position: 0 0;\r\n  }\r\n}\r\n\r\n.progress {\r\n  display: flex;\r\n  height: 1rem;\r\n  overflow: hidden;\r\n  line-height: 0;\r\n  font-size: 0.75rem;\r\n  background-color: #e9ecef;\r\n  border-radius: 0.375rem;\r\n  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  color: #fff;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: #5e72e4;\r\n  transition: width 0.6s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .progress-bar {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.progress-bar-striped {\r\n  background-image: linear-gradient(45deg,\r\n      rgba(255, 255, 255, 0.15) 25%,\r\n      transparent 25%,\r\n      transparent 50%,\r\n      rgba(255, 255, 255, 0.15) 50%,\r\n      rgba(255, 255, 255, 0.15) 75%,\r\n      transparent 75%,\r\n      transparent);\r\n  background-size: 1rem 1rem;\r\n}\r\n\r\n.progress-bar-animated {\r\n  animation: 1s linear infinite progress-bar-stripes;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .progress-bar-animated {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n.media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.media-body {\r\n  flex: 1;\r\n}\r\n\r\n.list-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.list-group-item-action {\r\n  width: 100%;\r\n  color: #525f7f;\r\n  text-align: inherit;\r\n}\r\n\r\n.list-group-item-action:hover,\r\n.list-group-item-action:focus {\r\n  z-index: 1;\r\n  color: #525f7f;\r\n  text-decoration: none;\r\n  background-color: #f6f9fc;\r\n}\r\n\r\n.list-group-item-action:active {\r\n  color: #525f7f;\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: 1rem 1rem;\r\n  background-color: #fff;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.list-group-item:first-child {\r\n  border-top-left-radius: inherit;\r\n  border-top-right-radius: inherit;\r\n}\r\n\r\n.list-group-item:last-child {\r\n  border-bottom-right-radius: inherit;\r\n  border-bottom-left-radius: inherit;\r\n}\r\n\r\n.list-group-item.disabled,\r\n.list-group-item:disabled {\r\n  color: #8898aa;\r\n  pointer-events: none;\r\n  background-color: #fff;\r\n}\r\n\r\n.list-group-item.active {\r\n  z-index: 2;\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.list-group-item+.list-group-item {\r\n  border-top-width: 0;\r\n}\r\n\r\n.list-group-item+.list-group-item.active {\r\n  margin-top: -1px;\r\n  border-top-width: 1px;\r\n}\r\n\r\n.list-group-horizontal {\r\n  flex-direction: row;\r\n}\r\n\r\n.list-group-horizontal>.list-group-item:first-child {\r\n  border-bottom-left-radius: 0.375rem;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.list-group-horizontal>.list-group-item:last-child {\r\n  border-top-right-radius: 0.375rem;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.list-group-horizontal>.list-group-item.active {\r\n  margin-top: 0;\r\n}\r\n\r\n.list-group-horizontal>.list-group-item+.list-group-item {\r\n  border-top-width: 1px;\r\n  border-left-width: 0;\r\n}\r\n\r\n.list-group-horizontal>.list-group-item+.list-group-item.active {\r\n  margin-left: -1px;\r\n  border-left-width: 1px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .list-group-horizontal-sm {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-sm>.list-group-item:first-child {\r\n    border-bottom-left-radius: 0.375rem;\r\n    border-top-right-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-sm>.list-group-item:last-child {\r\n    border-top-right-radius: 0.375rem;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-sm>.list-group-item.active {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .list-group-horizontal-sm>.list-group-item+.list-group-item {\r\n    border-top-width: 1px;\r\n    border-left-width: 0;\r\n  }\r\n\r\n  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\r\n    margin-left: -1px;\r\n    border-left-width: 1px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .list-group-horizontal-md {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-md>.list-group-item:first-child {\r\n    border-bottom-left-radius: 0.375rem;\r\n    border-top-right-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-md>.list-group-item:last-child {\r\n    border-top-right-radius: 0.375rem;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-md>.list-group-item.active {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .list-group-horizontal-md>.list-group-item+.list-group-item {\r\n    border-top-width: 1px;\r\n    border-left-width: 0;\r\n  }\r\n\r\n  .list-group-horizontal-md>.list-group-item+.list-group-item.active {\r\n    margin-left: -1px;\r\n    border-left-width: 1px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .list-group-horizontal-lg {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-lg>.list-group-item:first-child {\r\n    border-bottom-left-radius: 0.375rem;\r\n    border-top-right-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-lg>.list-group-item:last-child {\r\n    border-top-right-radius: 0.375rem;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-lg>.list-group-item.active {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .list-group-horizontal-lg>.list-group-item+.list-group-item {\r\n    border-top-width: 1px;\r\n    border-left-width: 0;\r\n  }\r\n\r\n  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\r\n    margin-left: -1px;\r\n    border-left-width: 1px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .list-group-horizontal-xl {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-xl>.list-group-item:first-child {\r\n    border-bottom-left-radius: 0.375rem;\r\n    border-top-right-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-xl>.list-group-item:last-child {\r\n    border-top-right-radius: 0.375rem;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .list-group-horizontal-xl>.list-group-item.active {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .list-group-horizontal-xl>.list-group-item+.list-group-item {\r\n    border-top-width: 1px;\r\n    border-left-width: 0;\r\n  }\r\n\r\n  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\r\n    margin-left: -1px;\r\n    border-left-width: 1px;\r\n  }\r\n}\r\n\r\n.list-group-flush {\r\n  border-radius: 0;\r\n}\r\n\r\n.list-group-flush>.list-group-item {\r\n  border-width: 0 0 1px;\r\n}\r\n\r\n.list-group-flush>.list-group-item:last-child {\r\n  border-bottom-width: 0;\r\n}\r\n\r\n.list-group-item-primary {\r\n  color: #313b77;\r\n  background-color: #d2d8f7;\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action:hover,\r\n.list-group-item-primary.list-group-item-action:focus {\r\n  color: #313b77;\r\n  background-color: #bcc5f3;\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #313b77;\r\n  border-color: #313b77;\r\n}\r\n\r\n.list-group-item-secondary {\r\n  color: #808283;\r\n  background-color: #fdfefe;\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action:hover,\r\n.list-group-item-secondary.list-group-item-action:focus {\r\n  color: #808283;\r\n  background-color: #ecf6f6;\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #808283;\r\n  border-color: #808283;\r\n}\r\n\r\n.list-group-item-success {\r\n  color: #176b47;\r\n  background-color: #c4f1de;\r\n}\r\n\r\n.list-group-item-success.list-group-item-action:hover,\r\n.list-group-item-success.list-group-item-action:focus {\r\n  color: #176b47;\r\n  background-color: #afecd2;\r\n}\r\n\r\n.list-group-item-success.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #176b47;\r\n  border-color: #176b47;\r\n}\r\n\r\n.list-group-item-info {\r\n  color: #096b7c;\r\n  background-color: #bcf1fb;\r\n}\r\n\r\n.list-group-item-info.list-group-item-action:hover,\r\n.list-group-item-info.list-group-item-action:focus {\r\n  color: #096b7c;\r\n  background-color: #a4ecfa;\r\n}\r\n\r\n.list-group-item-info.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #096b7c;\r\n  border-color: #096b7c;\r\n}\r\n\r\n.list-group-item-warning {\r\n  color: #833321;\r\n  background-color: #fed3ca;\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action:hover,\r\n.list-group-item-warning.list-group-item-action:focus {\r\n  color: #833321;\r\n  background-color: #febeb1;\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #833321;\r\n  border-color: #833321;\r\n}\r\n\r\n.list-group-item-danger {\r\n  color: #7f1c30;\r\n  background-color: #fcc7d1;\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action:hover,\r\n.list-group-item-danger.list-group-item-action:focus {\r\n  color: #7f1c30;\r\n  background-color: #fbafbd;\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #7f1c30;\r\n  border-color: #7f1c30;\r\n}\r\n\r\n.list-group-item-light {\r\n  color: #5a5e62;\r\n  background-color: #e8eaed;\r\n}\r\n\r\n.list-group-item-light.list-group-item-action:hover,\r\n.list-group-item-light.list-group-item-action:focus {\r\n  color: #5a5e62;\r\n  background-color: #dadde2;\r\n}\r\n\r\n.list-group-item-light.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #5a5e62;\r\n  border-color: #5a5e62;\r\n}\r\n\r\n.list-group-item-dark {\r\n  color: #111315;\r\n  background-color: #c1c2c3;\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action:hover,\r\n.list-group-item-dark.list-group-item-action:focus {\r\n  color: #111315;\r\n  background-color: #b4b5b6;\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #111315;\r\n  border-color: #111315;\r\n}\r\n\r\n.list-group-item-default {\r\n  color: #0c1628;\r\n  background-color: #bec4cd;\r\n}\r\n\r\n.list-group-item-default.list-group-item-action:hover,\r\n.list-group-item-default.list-group-item-action:focus {\r\n  color: #0c1628;\r\n  background-color: #b0b7c2;\r\n}\r\n\r\n.list-group-item-default.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #0c1628;\r\n  border-color: #0c1628;\r\n}\r\n\r\n.list-group-item-white {\r\n  color: #858585;\r\n  background-color: white;\r\n}\r\n\r\n.list-group-item-white.list-group-item-action:hover,\r\n.list-group-item-white.list-group-item-action:focus {\r\n  color: #858585;\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.list-group-item-white.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #858585;\r\n  border-color: #858585;\r\n}\r\n\r\n.list-group-item-neutral {\r\n  color: #858585;\r\n  background-color: white;\r\n}\r\n\r\n.list-group-item-neutral.list-group-item-action:hover,\r\n.list-group-item-neutral.list-group-item-action:focus {\r\n  color: #858585;\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.list-group-item-neutral.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #858585;\r\n  border-color: #858585;\r\n}\r\n\r\n.list-group-item-darker {\r\n  color: black;\r\n  background-color: #b8b8b8;\r\n}\r\n\r\n.list-group-item-darker.list-group-item-action:hover,\r\n.list-group-item-darker.list-group-item-action:focus {\r\n  color: black;\r\n  background-color: #ababab;\r\n}\r\n\r\n.list-group-item-darker.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: black;\r\n  border-color: black;\r\n}\r\n\r\n.close {\r\n  float: right;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  text-shadow: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .close {\r\n    font-size: calc(1.275rem + 0.3vw);\r\n  }\r\n}\r\n\r\n.close:hover {\r\n  color: rgba(0, 0, 0, 0.6);\r\n  text-decoration: none;\r\n}\r\n\r\n.close:not(:disabled):not(.disabled):hover,\r\n.close:not(:disabled):not(.disabled):focus {\r\n  opacity: 0.75;\r\n}\r\n\r\nbutton.close {\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\na.close.disabled {\r\n  pointer-events: none;\r\n}\r\n\r\n.modal-open {\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-open .modal {\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1050;\r\n  display: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  outline: 0;\r\n}\r\n\r\n.modal-dialog {\r\n  position: relative;\r\n  width: auto;\r\n  margin: 0.5rem;\r\n  pointer-events: none;\r\n}\r\n\r\n.modal.fade .modal-dialog {\r\n  transition: transform 0.3s ease-out;\r\n  transform: translate(0, -50px);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .modal.fade .modal-dialog {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.modal.show .modal-dialog {\r\n  transform: none;\r\n}\r\n\r\n.modal.modal-static .modal-dialog {\r\n  transform: scale(1.02);\r\n}\r\n\r\n.modal-dialog-scrollable {\r\n  display: flex;\r\n  max-height: calc(100% - 1rem);\r\n}\r\n\r\n.modal-dialog-scrollable .modal-content {\r\n  max-height: calc(100vh - 1rem);\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-dialog-scrollable .modal-header,\r\n.modal-dialog-scrollable .modal-footer {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.modal-dialog-scrollable .modal-body {\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: calc(100% - 1rem);\r\n}\r\n\r\n.modal-dialog-centered::before {\r\n  display: block;\r\n  height: calc(100vh - 1rem);\r\n  height: min-content;\r\n  content: \"\";\r\n}\r\n\r\n.modal-dialog-centered.modal-dialog-scrollable {\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\r\n  max-height: none;\r\n}\r\n\r\n.modal-dialog-centered.modal-dialog-scrollable::before {\r\n  content: none;\r\n}\r\n\r\n.modal-content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  pointer-events: auto;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 0 solid rgba(0, 0, 0, 0.2);\r\n  border-radius: 0.4375rem;\r\n  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);\r\n  outline: 0;\r\n}\r\n\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1040;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: #000;\r\n}\r\n\r\n.modal-backdrop.fade {\r\n  opacity: 0;\r\n}\r\n\r\n.modal-backdrop.show {\r\n  opacity: 0.16;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  padding: 1.25rem;\r\n  border-bottom: 0 solid #e9ecef;\r\n  border-top-left-radius: 0.4375rem;\r\n  border-top-right-radius: 0.4375rem;\r\n}\r\n\r\n.modal-header .close {\r\n  padding: 1.25rem;\r\n  margin: -1rem -1rem -1rem auto;\r\n}\r\n\r\n.modal-title {\r\n  margin-bottom: 0;\r\n  line-height: 1.1;\r\n}\r\n\r\n.modal-body {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding: 1.25rem;\r\n  border-top: 0 solid #e9ecef;\r\n  border-bottom-right-radius: 0.4375rem;\r\n  border-bottom-left-radius: 0.4375rem;\r\n}\r\n\r\n.modal-footer>* {\r\n  margin: 0.25rem;\r\n}\r\n\r\n.modal-scrollbar-measure {\r\n  position: absolute;\r\n  top: -9999px;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: scroll;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .modal-dialog {\r\n    max-width: 500px;\r\n    margin: 1.75rem auto;\r\n  }\r\n\r\n  .modal-dialog-scrollable {\r\n    max-height: calc(100% - 3.5rem);\r\n  }\r\n\r\n  .modal-dialog-scrollable .modal-content {\r\n    max-height: calc(100vh - 3.5rem);\r\n  }\r\n\r\n  .modal-dialog-centered {\r\n    min-height: calc(100% - 3.5rem);\r\n  }\r\n\r\n  .modal-dialog-centered::before {\r\n    height: calc(100vh - 3.5rem);\r\n    height: min-content;\r\n  }\r\n\r\n  .modal-content {\r\n    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2),\r\n      0 5px 15px rgba(0, 0, 0, 0.17);\r\n  }\r\n\r\n  .modal-sm {\r\n    max-width: 380px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\r\n  .modal-lg,\r\n  .modal-xl {\r\n    max-width: 800px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .modal-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n.tooltip {\r\n  position: absolute;\r\n  z-index: 1070;\r\n  display: block;\r\n  margin: 0;\r\n  font-family: Open Sans, sans-serif;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n  text-align: start;\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n  font-size: 0.875rem;\r\n  word-wrap: break-word;\r\n  opacity: 0;\r\n}\r\n\r\n.tooltip.show {\r\n  opacity: 0.9;\r\n}\r\n\r\n.tooltip .arrow {\r\n  position: absolute;\r\n  display: block;\r\n  width: 0.8rem;\r\n  height: 0.4rem;\r\n}\r\n\r\n.tooltip .arrow::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.bs-tooltip-top,\r\n.bs-tooltip-auto[x-placement^=\"top\"] {\r\n  padding: 0.4rem 0;\r\n}\r\n\r\n.bs-tooltip-top .arrow,\r\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow {\r\n  bottom: 0;\r\n}\r\n\r\n.bs-tooltip-top .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\r\n  top: 0;\r\n  border-width: 0.4rem 0.4rem 0;\r\n  border-top-color: #000;\r\n}\r\n\r\n.bs-tooltip-right,\r\n.bs-tooltip-auto[x-placement^=\"right\"] {\r\n  padding: 0 0.4rem;\r\n}\r\n\r\n.bs-tooltip-right .arrow,\r\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow {\r\n  left: 0;\r\n  width: 0.4rem;\r\n  height: 0.8rem;\r\n}\r\n\r\n.bs-tooltip-right .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\r\n  right: 0;\r\n  border-width: 0.4rem 0.4rem 0.4rem 0;\r\n  border-right-color: #000;\r\n}\r\n\r\n.bs-tooltip-bottom,\r\n.bs-tooltip-auto[x-placement^=\"bottom\"] {\r\n  padding: 0.4rem 0;\r\n}\r\n\r\n.bs-tooltip-bottom .arrow,\r\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\r\n  top: 0;\r\n}\r\n\r\n.bs-tooltip-bottom .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\r\n  bottom: 0;\r\n  border-width: 0 0.4rem 0.4rem;\r\n  border-bottom-color: #000;\r\n}\r\n\r\n.bs-tooltip-left,\r\n.bs-tooltip-auto[x-placement^=\"left\"] {\r\n  padding: 0 0.4rem;\r\n}\r\n\r\n.bs-tooltip-left .arrow,\r\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow {\r\n  right: 0;\r\n  width: 0.4rem;\r\n  height: 0.8rem;\r\n}\r\n\r\n.bs-tooltip-left .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\r\n  left: 0;\r\n  border-width: 0.4rem 0 0.4rem 0.4rem;\r\n  border-left-color: #000;\r\n}\r\n\r\n.tooltip-inner {\r\n  max-width: 200px;\r\n  padding: 0.25rem 0.5rem;\r\n  color: #fff;\r\n  text-align: center;\r\n  background-color: #000;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.popover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1060;\r\n  display: block;\r\n  max-width: 276px;\r\n  font-family: Open Sans, sans-serif;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n  text-align: start;\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n  font-size: 0.875rem;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 0.4375rem;\r\n  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.popover .arrow {\r\n  position: absolute;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 0.5rem;\r\n  margin: 0 0.4375rem;\r\n}\r\n\r\n.popover .arrow::before,\r\n.popover .arrow::after {\r\n  position: absolute;\r\n  display: block;\r\n  content: \"\";\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.bs-popover-top,\r\n.bs-popover-auto[x-placement^=\"top\"] {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.bs-popover-top>.arrow,\r\n.bs-popover-auto[x-placement^=\"top\"]>.arrow {\r\n  bottom: calc(-0.5rem - 1px);\r\n}\r\n\r\n.bs-popover-top>.arrow::before,\r\n.bs-popover-auto[x-placement^=\"top\"]>.arrow::before {\r\n  bottom: 0;\r\n  border-width: 0.5rem 0.5rem 0;\r\n  border-top-color: transparent;\r\n}\r\n\r\n.bs-popover-top>.arrow::after,\r\n.bs-popover-auto[x-placement^=\"top\"]>.arrow::after {\r\n  bottom: 1px;\r\n  border-width: 0.5rem 0.5rem 0;\r\n  border-top-color: #fff;\r\n}\r\n\r\n.bs-popover-right,\r\n.bs-popover-auto[x-placement^=\"right\"] {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.bs-popover-right>.arrow,\r\n.bs-popover-auto[x-placement^=\"right\"]>.arrow {\r\n  left: calc(-0.5rem - 1px);\r\n  width: 0.5rem;\r\n  height: 1rem;\r\n  margin: 0.4375rem 0;\r\n}\r\n\r\n.bs-popover-right>.arrow::before,\r\n.bs-popover-auto[x-placement^=\"right\"]>.arrow::before {\r\n  left: 0;\r\n  border-width: 0.5rem 0.5rem 0.5rem 0;\r\n  border-right-color: transparent;\r\n}\r\n\r\n.bs-popover-right>.arrow::after,\r\n.bs-popover-auto[x-placement^=\"right\"]>.arrow::after {\r\n  left: 1px;\r\n  border-width: 0.5rem 0.5rem 0.5rem 0;\r\n  border-right-color: #fff;\r\n}\r\n\r\n.bs-popover-bottom,\r\n.bs-popover-auto[x-placement^=\"bottom\"] {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.bs-popover-bottom>.arrow,\r\n.bs-popover-auto[x-placement^=\"bottom\"]>.arrow {\r\n  top: calc(-0.5rem - 1px);\r\n}\r\n\r\n.bs-popover-bottom>.arrow::before,\r\n.bs-popover-auto[x-placement^=\"bottom\"]>.arrow::before {\r\n  top: 0;\r\n  border-width: 0 0.5rem 0.5rem 0.5rem;\r\n  border-bottom-color: transparent;\r\n}\r\n\r\n.bs-popover-bottom>.arrow::after,\r\n.bs-popover-auto[x-placement^=\"bottom\"]>.arrow::after {\r\n  top: 1px;\r\n  border-width: 0 0.5rem 0.5rem 0.5rem;\r\n  border-bottom-color: #fff;\r\n}\r\n\r\n.bs-popover-bottom .popover-header::before,\r\n.bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  display: block;\r\n  width: 1rem;\r\n  margin-left: -0.5rem;\r\n  content: \"\";\r\n  border-bottom: 1px solid #fff;\r\n}\r\n\r\n.bs-popover-left,\r\n.bs-popover-auto[x-placement^=\"left\"] {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.bs-popover-left>.arrow,\r\n.bs-popover-auto[x-placement^=\"left\"]>.arrow {\r\n  right: calc(-0.5rem - 1px);\r\n  width: 0.5rem;\r\n  height: 1rem;\r\n  margin: 0.4375rem 0;\r\n}\r\n\r\n.bs-popover-left>.arrow::before,\r\n.bs-popover-auto[x-placement^=\"left\"]>.arrow::before {\r\n  right: 0;\r\n  border-width: 0.5rem 0 0.5rem 0.5rem;\r\n  border-left-color: transparent;\r\n}\r\n\r\n.bs-popover-left>.arrow::after,\r\n.bs-popover-auto[x-placement^=\"left\"]>.arrow::after {\r\n  right: 1px;\r\n  border-width: 0.5rem 0 0.5rem 0.5rem;\r\n  border-left-color: #fff;\r\n}\r\n\r\n.popover-header {\r\n  padding: 0.5rem 0.95rem;\r\n  margin-bottom: 0;\r\n  font-size: 1rem;\r\n  color: #32325d;\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #f2f2f2;\r\n  border-top-left-radius: calc(0.4375rem - 1px);\r\n  border-top-right-radius: calc(0.4375rem - 1px);\r\n}\r\n\r\n.popover-header:empty {\r\n  display: none;\r\n}\r\n\r\n.popover-body {\r\n  padding: 0.5rem 0.95rem;\r\n  color: #525f7f;\r\n}\r\n\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel.pointer-event {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-inner::after {\r\n  display: block;\r\n  clear: both;\r\n  content: \"\";\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  float: left;\r\n  width: 100%;\r\n  margin-right: -100%;\r\n  backface-visibility: hidden;\r\n  transition: transform 0.6s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-item {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-item.active,\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  display: block;\r\n}\r\n\r\n.carousel-item-next:not(.carousel-item-left),\r\n.active.carousel-item-right {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.carousel-item-prev:not(.carousel-item-right),\r\n.active.carousel-item-left {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.carousel-fade .carousel-item {\r\n  opacity: 0;\r\n  transition-property: opacity;\r\n  transform: none;\r\n}\r\n\r\n.carousel-fade .carousel-item.active,\r\n.carousel-fade .carousel-item-next.carousel-item-left,\r\n.carousel-fade .carousel-item-prev.carousel-item-right {\r\n  z-index: 1;\r\n  opacity: 1;\r\n}\r\n\r\n.carousel-fade .active.carousel-item-left,\r\n.carousel-fade .active.carousel-item-right {\r\n  z-index: 0;\r\n  opacity: 0;\r\n  transition: opacity 0s 0.6s;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .carousel-fade .active.carousel-item-left,\r\n  .carousel-fade .active.carousel-item-right {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 15%;\r\n  color: #fff;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .carousel-control-prev,\r\n  .carousel-control-next {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-control-prev:hover,\r\n.carousel-control-prev:focus,\r\n.carousel-control-next:hover,\r\n.carousel-control-next:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  outline: 0;\r\n  opacity: 0.9;\r\n}\r\n\r\n.carousel-control-prev {\r\n  left: 0;\r\n}\r\n\r\n.carousel-control-next {\r\n  right: 0;\r\n}\r\n\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: 50% / 100% 100% no-repeat;\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.carousel-control-next-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-left: 0;\r\n  margin-right: 15%;\r\n  margin-left: 15%;\r\n  list-style: none;\r\n}\r\n\r\n.carousel-indicators li {\r\n  box-sizing: content-box;\r\n  flex: 0 1 auto;\r\n  width: 30px;\r\n  height: 3px;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border-top: 10px solid transparent;\r\n  border-bottom: 10px solid transparent;\r\n  opacity: 0.5;\r\n  transition: opacity 0.6s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-indicators li {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-indicators .active {\r\n  opacity: 1;\r\n}\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: 15%;\r\n  bottom: 20px;\r\n  left: 15%;\r\n  z-index: 10;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n\r\n.align-baseline {\r\n  vertical-align: baseline !important;\r\n}\r\n\r\n.align-top {\r\n  vertical-align: top !important;\r\n}\r\n\r\n.align-middle {\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.align-bottom {\r\n  vertical-align: bottom !important;\r\n}\r\n\r\n.align-text-bottom {\r\n  vertical-align: text-bottom !important;\r\n}\r\n\r\n.align-text-top {\r\n  vertical-align: text-top !important;\r\n}\r\n\r\n.bg-primary {\r\n  background-color: #5e72e4 !important;\r\n}\r\n\r\na.bg-primary:hover,\r\na.bg-primary:focus,\r\nbutton.bg-primary:hover,\r\nbutton.bg-primary:focus {\r\n  background-color: #324cdd !important;\r\n}\r\n\r\n.bg-secondary {\r\n  background-color: #f7fafc !important;\r\n}\r\n\r\na.bg-secondary:hover,\r\na.bg-secondary:focus,\r\nbutton.bg-secondary:hover,\r\nbutton.bg-secondary:focus {\r\n  background-color: #d2e3ee !important;\r\n}\r\n\r\n.bg-success {\r\n  background-color: #2dce89 !important;\r\n}\r\n\r\na.bg-success:hover,\r\na.bg-success:focus,\r\nbutton.bg-success:hover,\r\nbutton.bg-success:focus {\r\n  background-color: #24a46d !important;\r\n}\r\n\r\n.bg-info {\r\n  background-color: #11cdef !important;\r\n}\r\n\r\na.bg-info:hover,\r\na.bg-info:focus,\r\nbutton.bg-info:hover,\r\nbutton.bg-info:focus {\r\n  background-color: #0da5c0 !important;\r\n}\r\n\r\n.bg-warning {\r\n  background-color: #fb6340 !important;\r\n}\r\n\r\na.bg-warning:hover,\r\na.bg-warning:focus,\r\nbutton.bg-warning:hover,\r\nbutton.bg-warning:focus {\r\n  background-color: #fa3a0e !important;\r\n}\r\n\r\n.bg-danger {\r\n  background-color: #f5365c !important;\r\n}\r\n\r\na.bg-danger:hover,\r\na.bg-danger:focus,\r\nbutton.bg-danger:hover,\r\nbutton.bg-danger:focus {\r\n  background-color: #ec0c38 !important;\r\n}\r\n\r\n.bg-light {\r\n  background-color: #adb5bd !important;\r\n}\r\n\r\na.bg-light:hover,\r\na.bg-light:focus,\r\nbutton.bg-light:hover,\r\nbutton.bg-light:focus {\r\n  background-color: #919ca6 !important;\r\n}\r\n\r\n.bg-dark {\r\n  background-color: #212529 !important;\r\n}\r\n\r\na.bg-dark:hover,\r\na.bg-dark:focus,\r\nbutton.bg-dark:hover,\r\nbutton.bg-dark:focus {\r\n  background-color: #0a0c0d !important;\r\n}\r\n\r\n.bg-default {\r\n  background-color: #172b4d !important;\r\n}\r\n\r\na.bg-default:hover,\r\na.bg-default:focus,\r\nbutton.bg-default:hover,\r\nbutton.bg-default:focus {\r\n  background-color: #0b1526 !important;\r\n}\r\n\r\n.bg-white {\r\n  background-color: #fff !important;\r\n}\r\n\r\na.bg-white:hover,\r\na.bg-white:focus,\r\nbutton.bg-white:hover,\r\nbutton.bg-white:focus {\r\n  background-color: #e6e6e6 !important;\r\n}\r\n\r\n.bg-neutral {\r\n  background-color: #fff !important;\r\n}\r\n\r\na.bg-neutral:hover,\r\na.bg-neutral:focus,\r\nbutton.bg-neutral:hover,\r\nbutton.bg-neutral:focus {\r\n  background-color: #e6e6e6 !important;\r\n}\r\n\r\n.bg-darker {\r\n  background-color: black !important;\r\n}\r\n\r\na.bg-darker:hover,\r\na.bg-darker:focus,\r\nbutton.bg-darker:hover,\r\nbutton.bg-darker:focus {\r\n  background-color: black !important;\r\n}\r\n\r\n.bg-white {\r\n  background-color: #fff !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.border {\r\n  border: 1px solid #e9ecef !important;\r\n}\r\n\r\n.border-top {\r\n  border-top: 1px solid #e9ecef !important;\r\n}\r\n\r\n.border-right {\r\n  border-right: 1px solid #e9ecef !important;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: 1px solid #e9ecef !important;\r\n}\r\n\r\n.border-left {\r\n  border-left: 1px solid #e9ecef !important;\r\n}\r\n\r\n.border-0 {\r\n  border: 0 !important;\r\n}\r\n\r\n.border-top-0 {\r\n  border-top: 0 !important;\r\n}\r\n\r\n.border-right-0 {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.border-bottom-0 {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.border-left-0 {\r\n  border-left: 0 !important;\r\n}\r\n\r\n.border-primary {\r\n  border-color: #5e72e4 !important;\r\n}\r\n\r\n.border-secondary {\r\n  border-color: #f7fafc !important;\r\n}\r\n\r\n.border-success {\r\n  border-color: #2dce89 !important;\r\n}\r\n\r\n.border-info {\r\n  border-color: #11cdef !important;\r\n}\r\n\r\n.border-warning {\r\n  border-color: #fb6340 !important;\r\n}\r\n\r\n.border-danger {\r\n  border-color: #f5365c !important;\r\n}\r\n\r\n.border-light {\r\n  border-color: #adb5bd !important;\r\n}\r\n\r\n.border-dark {\r\n  border-color: #212529 !important;\r\n}\r\n\r\n.border-default {\r\n  border-color: #172b4d !important;\r\n}\r\n\r\n.border-white {\r\n  border-color: #fff !important;\r\n}\r\n\r\n.border-neutral {\r\n  border-color: #fff !important;\r\n}\r\n\r\n.border-darker {\r\n  border-color: black !important;\r\n}\r\n\r\n.border-white {\r\n  border-color: #fff !important;\r\n}\r\n\r\n.rounded-sm {\r\n  border-radius: 0.25rem !important;\r\n}\r\n\r\n.rounded {\r\n  border-radius: 0.375rem !important;\r\n}\r\n\r\n.rounded-top {\r\n  border-top-left-radius: 0.375rem !important;\r\n  border-top-right-radius: 0.375rem !important;\r\n}\r\n\r\n.rounded-right {\r\n  border-top-right-radius: 0.375rem !important;\r\n  border-bottom-right-radius: 0.375rem !important;\r\n}\r\n\r\n.rounded-bottom {\r\n  border-bottom-right-radius: 0.375rem !important;\r\n  border-bottom-left-radius: 0.375rem !important;\r\n}\r\n\r\n.rounded-left {\r\n  border-top-left-radius: 0.375rem !important;\r\n  border-bottom-left-radius: 0.375rem !important;\r\n}\r\n\r\n.rounded-lg {\r\n  border-radius: 0.4375rem !important;\r\n}\r\n\r\n.rounded-circle,\r\n.avatar.rounded-circle img {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.rounded-pill {\r\n  border-radius: 50rem !important;\r\n}\r\n\r\n.rounded-0 {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.clearfix::after {\r\n  display: block;\r\n  clear: both;\r\n  content: \"\";\r\n}\r\n\r\n.d-none {\r\n  display: none !important;\r\n}\r\n\r\n.d-inline {\r\n  display: inline !important;\r\n}\r\n\r\n.d-inline-block {\r\n  display: inline-block !important;\r\n}\r\n\r\n.d-block {\r\n  display: block !important;\r\n}\r\n\r\n.d-table {\r\n  display: table !important;\r\n}\r\n\r\n.d-table-row {\r\n  display: table-row !important;\r\n}\r\n\r\n.d-table-cell {\r\n  display: table-cell !important;\r\n}\r\n\r\n.d-flex {\r\n  display: flex !important;\r\n}\r\n\r\n.d-inline-flex {\r\n  display: inline-flex !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .d-sm-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-sm-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-sm-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-sm-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-sm-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-sm-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-sm-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-sm-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-sm-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .d-md-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-md-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-md-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-md-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-md-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-md-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-md-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-md-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-md-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .d-lg-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-lg-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-lg-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-lg-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-lg-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-lg-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-lg-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-lg-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-lg-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .d-xl-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-xl-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-xl-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-xl-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-xl-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-xl-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-xl-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-xl-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-xl-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media print {\r\n  .d-print-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-print-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-print-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-print-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-print-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-print-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-print-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-print-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-print-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n.embed-responsive {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.embed-responsive::before {\r\n  display: block;\r\n  content: \"\";\r\n}\r\n\r\n.embed-responsive .embed-responsive-item,\r\n.embed-responsive iframe,\r\n.embed-responsive embed,\r\n.embed-responsive object,\r\n.embed-responsive video {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n}\r\n\r\n.embed-responsive-21by9::before {\r\n  padding-top: 42.85714%;\r\n}\r\n\r\n.embed-responsive-16by9::before {\r\n  padding-top: 56.25%;\r\n}\r\n\r\n.embed-responsive-4by3::before {\r\n  padding-top: 75%;\r\n}\r\n\r\n.embed-responsive-1by1::before {\r\n  padding-top: 100%;\r\n}\r\n\r\n.embed-responsive-21by9::before {\r\n  padding-top: 42.85714%;\r\n}\r\n\r\n.embed-responsive-16by9::before {\r\n  padding-top: 56.25%;\r\n}\r\n\r\n.embed-responsive-4by3::before {\r\n  padding-top: 75%;\r\n}\r\n\r\n.embed-responsive-1by1::before {\r\n  padding-top: 100%;\r\n}\r\n\r\n.flex-row {\r\n  flex-direction: row !important;\r\n}\r\n\r\n.flex-column {\r\n  flex-direction: column !important;\r\n}\r\n\r\n.flex-row-reverse {\r\n  flex-direction: row-reverse !important;\r\n}\r\n\r\n.flex-column-reverse {\r\n  flex-direction: column-reverse !important;\r\n}\r\n\r\n.flex-wrap {\r\n  flex-wrap: wrap !important;\r\n}\r\n\r\n.flex-nowrap {\r\n  flex-wrap: nowrap !important;\r\n}\r\n\r\n.flex-wrap-reverse {\r\n  flex-wrap: wrap-reverse !important;\r\n}\r\n\r\n.flex-fill {\r\n  flex: 1 1 auto !important;\r\n}\r\n\r\n.flex-grow-0 {\r\n  flex-grow: 0 !important;\r\n}\r\n\r\n.flex-grow-1 {\r\n  flex-grow: 1 !important;\r\n}\r\n\r\n.flex-shrink-0 {\r\n  flex-shrink: 0 !important;\r\n}\r\n\r\n.flex-shrink-1 {\r\n  flex-shrink: 1 !important;\r\n}\r\n\r\n.justify-content-start {\r\n  justify-content: flex-start !important;\r\n}\r\n\r\n.justify-content-end {\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.justify-content-center {\r\n  justify-content: center !important;\r\n}\r\n\r\n.justify-content-between {\r\n  justify-content: space-between !important;\r\n}\r\n\r\n.justify-content-around {\r\n  justify-content: space-around !important;\r\n}\r\n\r\n.align-items-start {\r\n  align-items: flex-start !important;\r\n}\r\n\r\n.align-items-end {\r\n  align-items: flex-end !important;\r\n}\r\n\r\n.align-items-center {\r\n  align-items: center !important;\r\n}\r\n\r\n.align-items-baseline {\r\n  align-items: baseline !important;\r\n}\r\n\r\n.align-items-stretch {\r\n  align-items: stretch !important;\r\n}\r\n\r\n.align-content-start {\r\n  align-content: flex-start !important;\r\n}\r\n\r\n.align-content-end {\r\n  align-content: flex-end !important;\r\n}\r\n\r\n.align-content-center {\r\n  align-content: center !important;\r\n}\r\n\r\n.align-content-between {\r\n  align-content: space-between !important;\r\n}\r\n\r\n.align-content-around {\r\n  align-content: space-around !important;\r\n}\r\n\r\n.align-content-stretch {\r\n  align-content: stretch !important;\r\n}\r\n\r\n.align-self-auto {\r\n  align-self: auto !important;\r\n}\r\n\r\n.align-self-start {\r\n  align-self: flex-start !important;\r\n}\r\n\r\n.align-self-end {\r\n  align-self: flex-end !important;\r\n}\r\n\r\n.align-self-center {\r\n  align-self: center !important;\r\n}\r\n\r\n.align-self-baseline {\r\n  align-self: baseline !important;\r\n}\r\n\r\n.align-self-stretch {\r\n  align-self: stretch !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .flex-sm-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-sm-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-sm-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-sm-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-sm-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-sm-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-sm-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-sm-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-sm-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-sm-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-sm-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-sm-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-sm-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-sm-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-sm-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-sm-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-sm-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-sm-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-sm-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-sm-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-sm-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-sm-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-sm-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-sm-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-sm-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-sm-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-sm-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-sm-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-sm-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-sm-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-sm-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-sm-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-sm-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-sm-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .flex-md-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-md-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-md-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-md-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-md-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-md-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-md-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-md-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-md-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-md-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-md-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-md-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-md-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-md-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-md-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-md-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-md-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-md-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-md-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-md-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-md-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-md-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-md-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-md-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-md-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-md-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-md-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-md-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-md-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-md-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-md-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-md-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-md-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-md-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .flex-lg-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-lg-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-lg-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-lg-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-lg-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-lg-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-lg-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-lg-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-lg-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-lg-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-lg-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-lg-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-lg-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-lg-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-lg-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-lg-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-lg-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-lg-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-lg-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-lg-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-lg-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-lg-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-lg-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-lg-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-lg-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-lg-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-lg-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-lg-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-lg-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-lg-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-lg-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-lg-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-lg-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-lg-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .flex-xl-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-xl-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-xl-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-xl-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-xl-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-xl-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-xl-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-xl-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-xl-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-xl-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-xl-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-xl-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-xl-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-xl-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-xl-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-xl-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-xl-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-xl-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-xl-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-xl-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-xl-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-xl-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-xl-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-xl-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-xl-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-xl-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-xl-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-xl-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-xl-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-xl-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-xl-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-xl-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-xl-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-xl-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n.float-left {\r\n  float: left !important;\r\n}\r\n\r\n.float-right {\r\n  float: right !important;\r\n}\r\n\r\n.float-none {\r\n  float: none !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .float-sm-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-sm-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-sm-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .float-md-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-md-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-md-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .float-lg-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-lg-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-lg-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .float-xl-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-xl-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-xl-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n.user-select-all {\r\n  user-select: all !important;\r\n}\r\n\r\n.user-select-auto {\r\n  user-select: auto !important;\r\n}\r\n\r\n.user-select-none {\r\n  user-select: none !important;\r\n}\r\n\r\n.overflow-auto {\r\n  overflow: auto !important;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.position-static {\r\n  position: static !important;\r\n}\r\n\r\n.position-relative {\r\n  position: relative !important;\r\n}\r\n\r\n.position-absolute {\r\n  position: absolute !important;\r\n}\r\n\r\n.position-fixed {\r\n  position: fixed !important;\r\n}\r\n\r\n.position-sticky {\r\n  position: sticky !important;\r\n}\r\n\r\n.fixed-top {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1030;\r\n}\r\n\r\n.fixed-bottom {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 1030;\r\n}\r\n\r\n@supports (position: sticky) {\r\n  .sticky-top {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1020;\r\n  }\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.sr-only-focusable:active,\r\n.sr-only-focusable:focus {\r\n  position: static;\r\n  width: auto;\r\n  height: auto;\r\n  overflow: visible;\r\n  clip: auto;\r\n  white-space: normal;\r\n}\r\n\r\n.shadow-sm {\r\n  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;\r\n}\r\n\r\n.shadow {\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\r\n}\r\n\r\n.shadow-lg {\r\n  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;\r\n}\r\n\r\n.shadow-none {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.w-25 {\r\n  width: 25% !important;\r\n}\r\n\r\n.w-50 {\r\n  width: 50% !important;\r\n}\r\n\r\n.w-75 {\r\n  width: 75% !important;\r\n}\r\n\r\n.w-100 {\r\n  width: 100% !important;\r\n}\r\n\r\n.w-auto {\r\n  width: auto !important;\r\n}\r\n\r\n.h-25 {\r\n  height: 25% !important;\r\n}\r\n\r\n.h-50 {\r\n  height: 50% !important;\r\n}\r\n\r\n.h-75 {\r\n  height: 75% !important;\r\n}\r\n\r\n.h-100 {\r\n  height: 100% !important;\r\n}\r\n\r\n.h-auto {\r\n  height: auto !important;\r\n}\r\n\r\n.mw-100 {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.mh-100 {\r\n  max-height: 100% !important;\r\n}\r\n\r\n.min-vw-100 {\r\n  min-width: 100vw !important;\r\n}\r\n\r\n.min-vh-100 {\r\n  min-height: 100vh !important;\r\n}\r\n\r\n.vw-100 {\r\n  width: 100vw !important;\r\n}\r\n\r\n.vh-100 {\r\n  height: 100vh !important;\r\n}\r\n\r\n.m-0 {\r\n  margin: 0 !important;\r\n}\r\n\r\n.mt-0,\r\n.my-0 {\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.mr-0,\r\n.mx-0 {\r\n  margin-right: 0 !important;\r\n}\r\n\r\n.mb-0,\r\n.my-0 {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.ml-0,\r\n.mx-0 {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.m-1 {\r\n  margin: 0.25rem !important;\r\n}\r\n\r\n.mt-1,\r\n.my-1 {\r\n  margin-top: 0.25rem !important;\r\n}\r\n\r\n.mr-1,\r\n.mx-1 {\r\n  margin-right: 0.25rem !important;\r\n}\r\n\r\n.mb-1,\r\n.my-1 {\r\n  margin-bottom: 0.25rem !important;\r\n}\r\n\r\n.ml-1,\r\n.mx-1 {\r\n  margin-left: 0.25rem !important;\r\n}\r\n\r\n.m-2 {\r\n  margin: 0.5rem !important;\r\n}\r\n\r\n.mt-2,\r\n.my-2 {\r\n  margin-top: 0.5rem !important;\r\n}\r\n\r\n.mr-2,\r\n.mx-2 {\r\n  margin-right: 0.5rem !important;\r\n}\r\n\r\n.mb-2,\r\n.my-2 {\r\n  margin-bottom: 0.5rem !important;\r\n}\r\n\r\n.ml-2,\r\n.mx-2 {\r\n  margin-left: 0.5rem !important;\r\n}\r\n\r\n.m-3 {\r\n  margin: 1rem !important;\r\n}\r\n\r\n.mt-3,\r\n.my-3 {\r\n  margin-top: 1rem !important;\r\n}\r\n\r\n.mr-3,\r\n.mx-3 {\r\n  margin-right: 1rem !important;\r\n}\r\n\r\n.mb-3,\r\n.my-3 {\r\n  margin-bottom: 1rem !important;\r\n}\r\n\r\n.ml-3,\r\n.mx-3 {\r\n  margin-left: 1rem !important;\r\n}\r\n\r\n.m-4 {\r\n  margin: 1.5rem !important;\r\n}\r\n\r\n.mt-4,\r\n.my-4 {\r\n  margin-top: 1.5rem !important;\r\n}\r\n\r\n.mr-4,\r\n.mx-4 {\r\n  margin-right: 1.5rem !important;\r\n}\r\n\r\n.mb-4,\r\n.my-4 {\r\n  margin-bottom: 1.5rem !important;\r\n}\r\n\r\n.ml-4,\r\n.mx-4 {\r\n  margin-left: 1.5rem !important;\r\n}\r\n\r\n.m-5 {\r\n  margin: 3rem !important;\r\n}\r\n\r\n.mt-5,\r\n.my-5 {\r\n  margin-top: 3rem !important;\r\n}\r\n\r\n.mr-5,\r\n.mx-5 {\r\n  margin-right: 3rem !important;\r\n}\r\n\r\n.mb-5,\r\n.my-5 {\r\n  margin-bottom: 3rem !important;\r\n}\r\n\r\n.ml-5,\r\n.mx-5 {\r\n  margin-left: 3rem !important;\r\n}\r\n\r\n.m--9 {\r\n  margin: -10rem !important;\r\n}\r\n\r\n.mt--9,\r\n.my--9 {\r\n  margin-top: -10rem !important;\r\n}\r\n\r\n.mr--9,\r\n.mx--9 {\r\n  margin-right: -10rem !important;\r\n}\r\n\r\n.mb--9,\r\n.my--9 {\r\n  margin-bottom: -10rem !important;\r\n}\r\n\r\n.ml--9,\r\n.mx--9 {\r\n  margin-left: -10rem !important;\r\n}\r\n\r\n.m--8 {\r\n  margin: -8rem !important;\r\n}\r\n\r\n.mt--8,\r\n.my--8 {\r\n  margin-top: -8rem !important;\r\n}\r\n\r\n.mr--8,\r\n.mx--8 {\r\n  margin-right: -8rem !important;\r\n}\r\n\r\n.mb--8,\r\n.my--8 {\r\n  margin-bottom: -8rem !important;\r\n}\r\n\r\n.ml--8,\r\n.mx--8 {\r\n  margin-left: -8rem !important;\r\n}\r\n\r\n.m--7 {\r\n  margin: -6rem !important;\r\n}\r\n\r\n.mt--7,\r\n.my--7 {\r\n  margin-top: -6rem !important;\r\n}\r\n\r\n.mr--7,\r\n.mx--7 {\r\n  margin-right: -6rem !important;\r\n}\r\n\r\n.mb--7,\r\n.my--7 {\r\n  margin-bottom: -6rem !important;\r\n}\r\n\r\n.ml--7,\r\n.mx--7 {\r\n  margin-left: -6rem !important;\r\n}\r\n\r\n.m--6 {\r\n  margin: -4.5rem !important;\r\n}\r\n\r\n.mt--6,\r\n.my--6 {\r\n  margin-top: -4.5rem !important;\r\n}\r\n\r\n.mr--6,\r\n.mx--6 {\r\n  margin-right: -4.5rem !important;\r\n}\r\n\r\n.mb--6,\r\n.my--6 {\r\n  margin-bottom: -4.5rem !important;\r\n}\r\n\r\n.ml--6,\r\n.mx--6 {\r\n  margin-left: -4.5rem !important;\r\n}\r\n\r\n.m--5 {\r\n  margin: -3rem !important;\r\n}\r\n\r\n.mt--5,\r\n.my--5 {\r\n  margin-top: -3rem !important;\r\n}\r\n\r\n.mr--5,\r\n.mx--5 {\r\n  margin-right: -3rem !important;\r\n}\r\n\r\n.mb--5,\r\n.my--5 {\r\n  margin-bottom: -3rem !important;\r\n}\r\n\r\n.ml--5,\r\n.mx--5 {\r\n  margin-left: -3rem !important;\r\n}\r\n\r\n.m--4 {\r\n  margin: -1.5rem !important;\r\n}\r\n\r\n.mt--4,\r\n.my--4 {\r\n  margin-top: -1.5rem !important;\r\n}\r\n\r\n.mr--4,\r\n.mx--4 {\r\n  margin-right: -1.5rem !important;\r\n}\r\n\r\n.mb--4,\r\n.my--4 {\r\n  margin-bottom: -1.5rem !important;\r\n}\r\n\r\n.ml--4,\r\n.mx--4 {\r\n  margin-left: -1.5rem !important;\r\n}\r\n\r\n.m--3 {\r\n  margin: -1rem !important;\r\n}\r\n\r\n.mt--3,\r\n.my--3 {\r\n  margin-top: -1rem !important;\r\n}\r\n\r\n.mr--3,\r\n.mx--3 {\r\n  margin-right: -1rem !important;\r\n}\r\n\r\n.mb--3,\r\n.my--3 {\r\n  margin-bottom: -1rem !important;\r\n}\r\n\r\n.ml--3,\r\n.mx--3 {\r\n  margin-left: -1rem !important;\r\n}\r\n\r\n.m--2 {\r\n  margin: -0.5rem !important;\r\n}\r\n\r\n.mt--2,\r\n.my--2 {\r\n  margin-top: -0.5rem !important;\r\n}\r\n\r\n.mr--2,\r\n.mx--2 {\r\n  margin-right: -0.5rem !important;\r\n}\r\n\r\n.mb--2,\r\n.my--2 {\r\n  margin-bottom: -0.5rem !important;\r\n}\r\n\r\n.ml--2,\r\n.mx--2 {\r\n  margin-left: -0.5rem !important;\r\n}\r\n\r\n.m--1 {\r\n  margin: -0.25rem !important;\r\n}\r\n\r\n.mt--1,\r\n.my--1 {\r\n  margin-top: -0.25rem !important;\r\n}\r\n\r\n.mr--1,\r\n.mx--1 {\r\n  margin-right: -0.25rem !important;\r\n}\r\n\r\n.mb--1,\r\n.my--1 {\r\n  margin-bottom: -0.25rem !important;\r\n}\r\n\r\n.ml--1,\r\n.mx--1 {\r\n  margin-left: -0.25rem !important;\r\n}\r\n\r\n.m-6 {\r\n  margin: 4.5rem !important;\r\n}\r\n\r\n.mt-6,\r\n.my-6 {\r\n  margin-top: 4.5rem !important;\r\n}\r\n\r\n.mr-6,\r\n.mx-6 {\r\n  margin-right: 4.5rem !important;\r\n}\r\n\r\n.mb-6,\r\n.my-6 {\r\n  margin-bottom: 4.5rem !important;\r\n}\r\n\r\n.ml-6,\r\n.mx-6 {\r\n  margin-left: 4.5rem !important;\r\n}\r\n\r\n.m-7 {\r\n  margin: 6rem !important;\r\n}\r\n\r\n.mt-7,\r\n.my-7 {\r\n  margin-top: 6rem !important;\r\n}\r\n\r\n.mr-7,\r\n.mx-7 {\r\n  margin-right: 6rem !important;\r\n}\r\n\r\n.mb-7,\r\n.my-7 {\r\n  margin-bottom: 6rem !important;\r\n}\r\n\r\n.ml-7,\r\n.mx-7 {\r\n  margin-left: 6rem !important;\r\n}\r\n\r\n.m-8 {\r\n  margin: 8rem !important;\r\n}\r\n\r\n.mt-8,\r\n.my-8 {\r\n  margin-top: 8rem !important;\r\n}\r\n\r\n.mr-8,\r\n.mx-8 {\r\n  margin-right: 8rem !important;\r\n}\r\n\r\n.mb-8,\r\n.my-8 {\r\n  margin-bottom: 8rem !important;\r\n}\r\n\r\n.ml-8,\r\n.mx-8 {\r\n  margin-left: 8rem !important;\r\n}\r\n\r\n.m-9 {\r\n  margin: 10rem !important;\r\n}\r\n\r\n.mt-9,\r\n.my-9 {\r\n  margin-top: 10rem !important;\r\n}\r\n\r\n.mr-9,\r\n.mx-9 {\r\n  margin-right: 10rem !important;\r\n}\r\n\r\n.mb-9,\r\n.my-9 {\r\n  margin-bottom: 10rem !important;\r\n}\r\n\r\n.ml-9,\r\n.mx-9 {\r\n  margin-left: 10rem !important;\r\n}\r\n\r\n.p-0 {\r\n  padding: 0 !important;\r\n}\r\n\r\n.pt-0,\r\n.py-0 {\r\n  padding-top: 0 !important;\r\n}\r\n\r\n.pr-0,\r\n.px-0 {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.pb-0,\r\n.py-0 {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.pl-0,\r\n.px-0 {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.p-1 {\r\n  padding: 0.25rem !important;\r\n}\r\n\r\n.pt-1,\r\n.py-1 {\r\n  padding-top: 0.25rem !important;\r\n}\r\n\r\n.pr-1,\r\n.px-1 {\r\n  padding-right: 0.25rem !important;\r\n}\r\n\r\n.pb-1,\r\n.py-1 {\r\n  padding-bottom: 0.25rem !important;\r\n}\r\n\r\n.pl-1,\r\n.px-1 {\r\n  padding-left: 0.25rem !important;\r\n}\r\n\r\n.p-2 {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n.pt-2,\r\n.py-2 {\r\n  padding-top: 0.5rem !important;\r\n}\r\n\r\n.pr-2,\r\n.px-2 {\r\n  padding-right: 0.5rem !important;\r\n}\r\n\r\n.pb-2,\r\n.py-2 {\r\n  padding-bottom: 0.5rem !important;\r\n}\r\n\r\n.pl-2,\r\n.px-2 {\r\n  padding-left: 0.5rem !important;\r\n}\r\n\r\n.p-3 {\r\n  padding: 1rem !important;\r\n}\r\n\r\n.pt-3,\r\n.py-3 {\r\n  padding-top: 1rem !important;\r\n}\r\n\r\n.pr-3,\r\n.px-3 {\r\n  padding-right: 1rem !important;\r\n}\r\n\r\n.pb-3,\r\n.py-3 {\r\n  padding-bottom: 1rem !important;\r\n}\r\n\r\n.pl-3,\r\n.px-3 {\r\n  padding-left: 1rem !important;\r\n}\r\n\r\n.p-4 {\r\n  padding: 1.5rem !important;\r\n}\r\n\r\n.pt-4,\r\n.py-4 {\r\n  padding-top: 1.5rem !important;\r\n}\r\n\r\n.pr-4,\r\n.px-4 {\r\n  padding-right: 1.5rem !important;\r\n}\r\n\r\n.pb-4,\r\n.py-4 {\r\n  padding-bottom: 1.5rem !important;\r\n}\r\n\r\n.pl-4,\r\n.px-4 {\r\n  padding-left: 1.5rem !important;\r\n}\r\n\r\n.p-5 {\r\n  padding: 3rem !important;\r\n}\r\n\r\n.pt-5,\r\n.py-5 {\r\n  padding-top: 3rem !important;\r\n}\r\n\r\n.pr-5,\r\n.px-5 {\r\n  padding-right: 3rem !important;\r\n}\r\n\r\n.pb-5,\r\n.py-5 {\r\n  padding-bottom: 3rem !important;\r\n}\r\n\r\n.pl-5,\r\n.px-5 {\r\n  padding-left: 3rem !important;\r\n}\r\n\r\n.p--9 {\r\n  padding: -10rem !important;\r\n}\r\n\r\n.pt--9,\r\n.py--9 {\r\n  padding-top: -10rem !important;\r\n}\r\n\r\n.pr--9,\r\n.px--9 {\r\n  padding-right: -10rem !important;\r\n}\r\n\r\n.pb--9,\r\n.py--9 {\r\n  padding-bottom: -10rem !important;\r\n}\r\n\r\n.pl--9,\r\n.px--9 {\r\n  padding-left: -10rem !important;\r\n}\r\n\r\n.p--8 {\r\n  padding: -8rem !important;\r\n}\r\n\r\n.pt--8,\r\n.py--8 {\r\n  padding-top: -8rem !important;\r\n}\r\n\r\n.pr--8,\r\n.px--8 {\r\n  padding-right: -8rem !important;\r\n}\r\n\r\n.pb--8,\r\n.py--8 {\r\n  padding-bottom: -8rem !important;\r\n}\r\n\r\n.pl--8,\r\n.px--8 {\r\n  padding-left: -8rem !important;\r\n}\r\n\r\n.p--7 {\r\n  padding: -6rem !important;\r\n}\r\n\r\n.pt--7,\r\n.py--7 {\r\n  padding-top: -6rem !important;\r\n}\r\n\r\n.pr--7,\r\n.px--7 {\r\n  padding-right: -6rem !important;\r\n}\r\n\r\n.pb--7,\r\n.py--7 {\r\n  padding-bottom: -6rem !important;\r\n}\r\n\r\n.pl--7,\r\n.px--7 {\r\n  padding-left: -6rem !important;\r\n}\r\n\r\n.p--6 {\r\n  padding: -4.5rem !important;\r\n}\r\n\r\n.pt--6,\r\n.py--6 {\r\n  padding-top: -4.5rem !important;\r\n}\r\n\r\n.pr--6,\r\n.px--6 {\r\n  padding-right: -4.5rem !important;\r\n}\r\n\r\n.pb--6,\r\n.py--6 {\r\n  padding-bottom: -4.5rem !important;\r\n}\r\n\r\n.pl--6,\r\n.px--6 {\r\n  padding-left: -4.5rem !important;\r\n}\r\n\r\n.p--5 {\r\n  padding: -3rem !important;\r\n}\r\n\r\n.pt--5,\r\n.py--5 {\r\n  padding-top: -3rem !important;\r\n}\r\n\r\n.pr--5,\r\n.px--5 {\r\n  padding-right: -3rem !important;\r\n}\r\n\r\n.pb--5,\r\n.py--5 {\r\n  padding-bottom: -3rem !important;\r\n}\r\n\r\n.pl--5,\r\n.px--5 {\r\n  padding-left: -3rem !important;\r\n}\r\n\r\n.p--4 {\r\n  padding: -1.5rem !important;\r\n}\r\n\r\n.pt--4,\r\n.py--4 {\r\n  padding-top: -1.5rem !important;\r\n}\r\n\r\n.pr--4,\r\n.px--4 {\r\n  padding-right: -1.5rem !important;\r\n}\r\n\r\n.pb--4,\r\n.py--4 {\r\n  padding-bottom: -1.5rem !important;\r\n}\r\n\r\n.pl--4,\r\n.px--4 {\r\n  padding-left: -1.5rem !important;\r\n}\r\n\r\n.p--3 {\r\n  padding: -1rem !important;\r\n}\r\n\r\n.pt--3,\r\n.py--3 {\r\n  padding-top: -1rem !important;\r\n}\r\n\r\n.pr--3,\r\n.px--3 {\r\n  padding-right: -1rem !important;\r\n}\r\n\r\n.pb--3,\r\n.py--3 {\r\n  padding-bottom: -1rem !important;\r\n}\r\n\r\n.pl--3,\r\n.px--3 {\r\n  padding-left: -1rem !important;\r\n}\r\n\r\n.p--2 {\r\n  padding: -0.5rem !important;\r\n}\r\n\r\n.pt--2,\r\n.py--2 {\r\n  padding-top: -0.5rem !important;\r\n}\r\n\r\n.pr--2,\r\n.px--2 {\r\n  padding-right: -0.5rem !important;\r\n}\r\n\r\n.pb--2,\r\n.py--2 {\r\n  padding-bottom: -0.5rem !important;\r\n}\r\n\r\n.pl--2,\r\n.px--2 {\r\n  padding-left: -0.5rem !important;\r\n}\r\n\r\n.p--1 {\r\n  padding: -0.25rem !important;\r\n}\r\n\r\n.pt--1,\r\n.py--1 {\r\n  padding-top: -0.25rem !important;\r\n}\r\n\r\n.pr--1,\r\n.px--1 {\r\n  padding-right: -0.25rem !important;\r\n}\r\n\r\n.pb--1,\r\n.py--1 {\r\n  padding-bottom: -0.25rem !important;\r\n}\r\n\r\n.pl--1,\r\n.px--1 {\r\n  padding-left: -0.25rem !important;\r\n}\r\n\r\n.p-6 {\r\n  padding: 4.5rem !important;\r\n}\r\n\r\n.pt-6,\r\n.py-6 {\r\n  padding-top: 4.5rem !important;\r\n}\r\n\r\n.pr-6,\r\n.px-6 {\r\n  padding-right: 4.5rem !important;\r\n}\r\n\r\n.pb-6,\r\n.py-6 {\r\n  padding-bottom: 4.5rem !important;\r\n}\r\n\r\n.pl-6,\r\n.px-6 {\r\n  padding-left: 4.5rem !important;\r\n}\r\n\r\n.p-7 {\r\n  padding: 6rem !important;\r\n}\r\n\r\n.pt-7,\r\n.py-7 {\r\n  padding-top: 6rem !important;\r\n}\r\n\r\n.pr-7,\r\n.px-7 {\r\n  padding-right: 6rem !important;\r\n}\r\n\r\n.pb-7,\r\n.py-7 {\r\n  padding-bottom: 6rem !important;\r\n}\r\n\r\n.pl-7,\r\n.px-7 {\r\n  padding-left: 6rem !important;\r\n}\r\n\r\n.p-8 {\r\n  padding: 8rem !important;\r\n}\r\n\r\n.pt-8,\r\n.py-8 {\r\n  padding-top: 8rem !important;\r\n}\r\n\r\n.pr-8,\r\n.px-8 {\r\n  padding-right: 8rem !important;\r\n}\r\n\r\n.pb-8,\r\n.py-8 {\r\n  padding-bottom: 8rem !important;\r\n}\r\n\r\n.pl-8,\r\n.px-8 {\r\n  padding-left: 8rem !important;\r\n}\r\n\r\n.p-9 {\r\n  padding: 10rem !important;\r\n}\r\n\r\n.pt-9,\r\n.py-9 {\r\n  padding-top: 10rem !important;\r\n}\r\n\r\n.pr-9,\r\n.px-9 {\r\n  padding-right: 10rem !important;\r\n}\r\n\r\n.pb-9,\r\n.py-9 {\r\n  padding-bottom: 10rem !important;\r\n}\r\n\r\n.pl-9,\r\n.px-9 {\r\n  padding-left: 10rem !important;\r\n}\r\n\r\n.m-n1 {\r\n  margin: -0.25rem !important;\r\n}\r\n\r\n.mt-n1,\r\n.my-n1 {\r\n  margin-top: -0.25rem !important;\r\n}\r\n\r\n.mr-n1,\r\n.mx-n1 {\r\n  margin-right: -0.25rem !important;\r\n}\r\n\r\n.mb-n1,\r\n.my-n1 {\r\n  margin-bottom: -0.25rem !important;\r\n}\r\n\r\n.ml-n1,\r\n.mx-n1 {\r\n  margin-left: -0.25rem !important;\r\n}\r\n\r\n.m-n2 {\r\n  margin: -0.5rem !important;\r\n}\r\n\r\n.mt-n2,\r\n.my-n2 {\r\n  margin-top: -0.5rem !important;\r\n}\r\n\r\n.mr-n2,\r\n.mx-n2 {\r\n  margin-right: -0.5rem !important;\r\n}\r\n\r\n.mb-n2,\r\n.my-n2 {\r\n  margin-bottom: -0.5rem !important;\r\n}\r\n\r\n.ml-n2,\r\n.mx-n2 {\r\n  margin-left: -0.5rem !important;\r\n}\r\n\r\n.m-n3 {\r\n  margin: -1rem !important;\r\n}\r\n\r\n.mt-n3,\r\n.my-n3 {\r\n  margin-top: -1rem !important;\r\n}\r\n\r\n.mr-n3,\r\n.mx-n3 {\r\n  margin-right: -1rem !important;\r\n}\r\n\r\n.mb-n3,\r\n.my-n3 {\r\n  margin-bottom: -1rem !important;\r\n}\r\n\r\n.ml-n3,\r\n.mx-n3 {\r\n  margin-left: -1rem !important;\r\n}\r\n\r\n.m-n4 {\r\n  margin: -1.5rem !important;\r\n}\r\n\r\n.mt-n4,\r\n.my-n4 {\r\n  margin-top: -1.5rem !important;\r\n}\r\n\r\n.mr-n4,\r\n.mx-n4 {\r\n  margin-right: -1.5rem !important;\r\n}\r\n\r\n.mb-n4,\r\n.my-n4 {\r\n  margin-bottom: -1.5rem !important;\r\n}\r\n\r\n.ml-n4,\r\n.mx-n4 {\r\n  margin-left: -1.5rem !important;\r\n}\r\n\r\n.m-n5 {\r\n  margin: -3rem !important;\r\n}\r\n\r\n.mt-n5,\r\n.my-n5 {\r\n  margin-top: -3rem !important;\r\n}\r\n\r\n.mr-n5,\r\n.mx-n5 {\r\n  margin-right: -3rem !important;\r\n}\r\n\r\n.mb-n5,\r\n.my-n5 {\r\n  margin-bottom: -3rem !important;\r\n}\r\n\r\n.ml-n5,\r\n.mx-n5 {\r\n  margin-left: -3rem !important;\r\n}\r\n\r\n.m-n-9 {\r\n  margin: 10rem !important;\r\n}\r\n\r\n.mt-n-9,\r\n.my-n-9 {\r\n  margin-top: 10rem !important;\r\n}\r\n\r\n.mr-n-9,\r\n.mx-n-9 {\r\n  margin-right: 10rem !important;\r\n}\r\n\r\n.mb-n-9,\r\n.my-n-9 {\r\n  margin-bottom: 10rem !important;\r\n}\r\n\r\n.ml-n-9,\r\n.mx-n-9 {\r\n  margin-left: 10rem !important;\r\n}\r\n\r\n.m-n-8 {\r\n  margin: 8rem !important;\r\n}\r\n\r\n.mt-n-8,\r\n.my-n-8 {\r\n  margin-top: 8rem !important;\r\n}\r\n\r\n.mr-n-8,\r\n.mx-n-8 {\r\n  margin-right: 8rem !important;\r\n}\r\n\r\n.mb-n-8,\r\n.my-n-8 {\r\n  margin-bottom: 8rem !important;\r\n}\r\n\r\n.ml-n-8,\r\n.mx-n-8 {\r\n  margin-left: 8rem !important;\r\n}\r\n\r\n.m-n-7 {\r\n  margin: 6rem !important;\r\n}\r\n\r\n.mt-n-7,\r\n.my-n-7 {\r\n  margin-top: 6rem !important;\r\n}\r\n\r\n.mr-n-7,\r\n.mx-n-7 {\r\n  margin-right: 6rem !important;\r\n}\r\n\r\n.mb-n-7,\r\n.my-n-7 {\r\n  margin-bottom: 6rem !important;\r\n}\r\n\r\n.ml-n-7,\r\n.mx-n-7 {\r\n  margin-left: 6rem !important;\r\n}\r\n\r\n.m-n-6 {\r\n  margin: 4.5rem !important;\r\n}\r\n\r\n.mt-n-6,\r\n.my-n-6 {\r\n  margin-top: 4.5rem !important;\r\n}\r\n\r\n.mr-n-6,\r\n.mx-n-6 {\r\n  margin-right: 4.5rem !important;\r\n}\r\n\r\n.mb-n-6,\r\n.my-n-6 {\r\n  margin-bottom: 4.5rem !important;\r\n}\r\n\r\n.ml-n-6,\r\n.mx-n-6 {\r\n  margin-left: 4.5rem !important;\r\n}\r\n\r\n.m-n-5 {\r\n  margin: 3rem !important;\r\n}\r\n\r\n.mt-n-5,\r\n.my-n-5 {\r\n  margin-top: 3rem !important;\r\n}\r\n\r\n.mr-n-5,\r\n.mx-n-5 {\r\n  margin-right: 3rem !important;\r\n}\r\n\r\n.mb-n-5,\r\n.my-n-5 {\r\n  margin-bottom: 3rem !important;\r\n}\r\n\r\n.ml-n-5,\r\n.mx-n-5 {\r\n  margin-left: 3rem !important;\r\n}\r\n\r\n.m-n-4 {\r\n  margin: 1.5rem !important;\r\n}\r\n\r\n.mt-n-4,\r\n.my-n-4 {\r\n  margin-top: 1.5rem !important;\r\n}\r\n\r\n.mr-n-4,\r\n.mx-n-4 {\r\n  margin-right: 1.5rem !important;\r\n}\r\n\r\n.mb-n-4,\r\n.my-n-4 {\r\n  margin-bottom: 1.5rem !important;\r\n}\r\n\r\n.ml-n-4,\r\n.mx-n-4 {\r\n  margin-left: 1.5rem !important;\r\n}\r\n\r\n.m-n-3 {\r\n  margin: 1rem !important;\r\n}\r\n\r\n.mt-n-3,\r\n.my-n-3 {\r\n  margin-top: 1rem !important;\r\n}\r\n\r\n.mr-n-3,\r\n.mx-n-3 {\r\n  margin-right: 1rem !important;\r\n}\r\n\r\n.mb-n-3,\r\n.my-n-3 {\r\n  margin-bottom: 1rem !important;\r\n}\r\n\r\n.ml-n-3,\r\n.mx-n-3 {\r\n  margin-left: 1rem !important;\r\n}\r\n\r\n.m-n-2 {\r\n  margin: 0.5rem !important;\r\n}\r\n\r\n.mt-n-2,\r\n.my-n-2 {\r\n  margin-top: 0.5rem !important;\r\n}\r\n\r\n.mr-n-2,\r\n.mx-n-2 {\r\n  margin-right: 0.5rem !important;\r\n}\r\n\r\n.mb-n-2,\r\n.my-n-2 {\r\n  margin-bottom: 0.5rem !important;\r\n}\r\n\r\n.ml-n-2,\r\n.mx-n-2 {\r\n  margin-left: 0.5rem !important;\r\n}\r\n\r\n.m-n-1 {\r\n  margin: 0.25rem !important;\r\n}\r\n\r\n.mt-n-1,\r\n.my-n-1 {\r\n  margin-top: 0.25rem !important;\r\n}\r\n\r\n.mr-n-1,\r\n.mx-n-1 {\r\n  margin-right: 0.25rem !important;\r\n}\r\n\r\n.mb-n-1,\r\n.my-n-1 {\r\n  margin-bottom: 0.25rem !important;\r\n}\r\n\r\n.ml-n-1,\r\n.mx-n-1 {\r\n  margin-left: 0.25rem !important;\r\n}\r\n\r\n.m-n6 {\r\n  margin: -4.5rem !important;\r\n}\r\n\r\n.mt-n6,\r\n.my-n6 {\r\n  margin-top: -4.5rem !important;\r\n}\r\n\r\n.mr-n6,\r\n.mx-n6 {\r\n  margin-right: -4.5rem !important;\r\n}\r\n\r\n.mb-n6,\r\n.my-n6 {\r\n  margin-bottom: -4.5rem !important;\r\n}\r\n\r\n.ml-n6,\r\n.mx-n6 {\r\n  margin-left: -4.5rem !important;\r\n}\r\n\r\n.m-n7 {\r\n  margin: -6rem !important;\r\n}\r\n\r\n.mt-n7,\r\n.my-n7 {\r\n  margin-top: -6rem !important;\r\n}\r\n\r\n.mr-n7,\r\n.mx-n7 {\r\n  margin-right: -6rem !important;\r\n}\r\n\r\n.mb-n7,\r\n.my-n7 {\r\n  margin-bottom: -6rem !important;\r\n}\r\n\r\n.ml-n7,\r\n.mx-n7 {\r\n  margin-left: -6rem !important;\r\n}\r\n\r\n.m-n8 {\r\n  margin: -8rem !important;\r\n}\r\n\r\n.mt-n8,\r\n.my-n8 {\r\n  margin-top: -8rem !important;\r\n}\r\n\r\n.mr-n8,\r\n.mx-n8 {\r\n  margin-right: -8rem !important;\r\n}\r\n\r\n.mb-n8,\r\n.my-n8 {\r\n  margin-bottom: -8rem !important;\r\n}\r\n\r\n.ml-n8,\r\n.mx-n8 {\r\n  margin-left: -8rem !important;\r\n}\r\n\r\n.m-n9 {\r\n  margin: -10rem !important;\r\n}\r\n\r\n.mt-n9,\r\n.my-n9 {\r\n  margin-top: -10rem !important;\r\n}\r\n\r\n.mr-n9,\r\n.mx-n9 {\r\n  margin-right: -10rem !important;\r\n}\r\n\r\n.mb-n9,\r\n.my-n9 {\r\n  margin-bottom: -10rem !important;\r\n}\r\n\r\n.ml-n9,\r\n.mx-n9 {\r\n  margin-left: -10rem !important;\r\n}\r\n\r\n.m-auto {\r\n  margin: auto !important;\r\n}\r\n\r\n.mt-auto,\r\n.my-auto {\r\n  margin-top: auto !important;\r\n}\r\n\r\n.mr-auto,\r\n.mx-auto {\r\n  margin-right: auto !important;\r\n}\r\n\r\n.mb-auto,\r\n.my-auto {\r\n  margin-bottom: auto !important;\r\n}\r\n\r\n.ml-auto,\r\n.mx-auto {\r\n  margin-left: auto !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .m-sm-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-sm-0,\r\n  .my-sm-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-sm-0,\r\n  .mx-sm-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-sm-0,\r\n  .my-sm-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-sm-0,\r\n  .mx-sm-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-sm-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-sm-1,\r\n  .my-sm-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-sm-1,\r\n  .mx-sm-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-sm-1,\r\n  .my-sm-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-sm-1,\r\n  .mx-sm-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-sm-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-sm-2,\r\n  .my-sm-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-sm-2,\r\n  .mx-sm-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-sm-2,\r\n  .my-sm-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-sm-2,\r\n  .mx-sm-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-sm-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-sm-3,\r\n  .my-sm-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-sm-3,\r\n  .mx-sm-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-sm-3,\r\n  .my-sm-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-sm-3,\r\n  .mx-sm-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-sm-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-sm-4,\r\n  .my-sm-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-sm-4,\r\n  .mx-sm-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-sm-4,\r\n  .my-sm-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-sm-4,\r\n  .mx-sm-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-sm-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-sm-5,\r\n  .my-sm-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-sm-5,\r\n  .mx-sm-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-sm-5,\r\n  .my-sm-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-sm-5,\r\n  .mx-sm-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-sm--9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-sm--9,\r\n  .my-sm--9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-sm--9,\r\n  .mx-sm--9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-sm--9,\r\n  .my-sm--9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-sm--9,\r\n  .mx-sm--9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-sm--8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-sm--8,\r\n  .my-sm--8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-sm--8,\r\n  .mx-sm--8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-sm--8,\r\n  .my-sm--8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-sm--8,\r\n  .mx-sm--8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-sm--7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-sm--7,\r\n  .my-sm--7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-sm--7,\r\n  .mx-sm--7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-sm--7,\r\n  .my-sm--7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-sm--7,\r\n  .mx-sm--7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-sm--6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-sm--6,\r\n  .my-sm--6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-sm--6,\r\n  .mx-sm--6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-sm--6,\r\n  .my-sm--6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-sm--6,\r\n  .mx-sm--6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-sm--5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-sm--5,\r\n  .my-sm--5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-sm--5,\r\n  .mx-sm--5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-sm--5,\r\n  .my-sm--5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-sm--5,\r\n  .mx-sm--5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-sm--4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-sm--4,\r\n  .my-sm--4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-sm--4,\r\n  .mx-sm--4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-sm--4,\r\n  .my-sm--4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-sm--4,\r\n  .mx-sm--4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-sm--3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-sm--3,\r\n  .my-sm--3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-sm--3,\r\n  .mx-sm--3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-sm--3,\r\n  .my-sm--3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-sm--3,\r\n  .mx-sm--3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-sm--2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-sm--2,\r\n  .my-sm--2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-sm--2,\r\n  .mx-sm--2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-sm--2,\r\n  .my-sm--2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-sm--2,\r\n  .mx-sm--2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-sm--1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-sm--1,\r\n  .my-sm--1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-sm--1,\r\n  .mx-sm--1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-sm--1,\r\n  .my-sm--1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-sm--1,\r\n  .mx-sm--1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-sm-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-sm-6,\r\n  .my-sm-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-sm-6,\r\n  .mx-sm-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-sm-6,\r\n  .my-sm-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-sm-6,\r\n  .mx-sm-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-sm-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-sm-7,\r\n  .my-sm-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-sm-7,\r\n  .mx-sm-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-sm-7,\r\n  .my-sm-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-sm-7,\r\n  .mx-sm-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-sm-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-sm-8,\r\n  .my-sm-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-sm-8,\r\n  .mx-sm-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-sm-8,\r\n  .my-sm-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-sm-8,\r\n  .mx-sm-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-sm-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-sm-9,\r\n  .my-sm-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-sm-9,\r\n  .mx-sm-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-sm-9,\r\n  .my-sm-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-sm-9,\r\n  .mx-sm-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .p-sm-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-sm-0,\r\n  .py-sm-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-sm-0,\r\n  .px-sm-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-sm-0,\r\n  .py-sm-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-sm-0,\r\n  .px-sm-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-sm-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-sm-1,\r\n  .py-sm-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-sm-1,\r\n  .px-sm-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-sm-1,\r\n  .py-sm-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-sm-1,\r\n  .px-sm-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-sm-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-sm-2,\r\n  .py-sm-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-sm-2,\r\n  .px-sm-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-sm-2,\r\n  .py-sm-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-sm-2,\r\n  .px-sm-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-sm-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-sm-3,\r\n  .py-sm-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-sm-3,\r\n  .px-sm-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-sm-3,\r\n  .py-sm-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-sm-3,\r\n  .px-sm-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-sm-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-sm-4,\r\n  .py-sm-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-sm-4,\r\n  .px-sm-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-sm-4,\r\n  .py-sm-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-sm-4,\r\n  .px-sm-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-sm-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-sm-5,\r\n  .py-sm-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-sm-5,\r\n  .px-sm-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-sm-5,\r\n  .py-sm-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-sm-5,\r\n  .px-sm-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .p-sm--9 {\r\n    padding: -10rem !important;\r\n  }\r\n\r\n  .pt-sm--9,\r\n  .py-sm--9 {\r\n    padding-top: -10rem !important;\r\n  }\r\n\r\n  .pr-sm--9,\r\n  .px-sm--9 {\r\n    padding-right: -10rem !important;\r\n  }\r\n\r\n  .pb-sm--9,\r\n  .py-sm--9 {\r\n    padding-bottom: -10rem !important;\r\n  }\r\n\r\n  .pl-sm--9,\r\n  .px-sm--9 {\r\n    padding-left: -10rem !important;\r\n  }\r\n\r\n  .p-sm--8 {\r\n    padding: -8rem !important;\r\n  }\r\n\r\n  .pt-sm--8,\r\n  .py-sm--8 {\r\n    padding-top: -8rem !important;\r\n  }\r\n\r\n  .pr-sm--8,\r\n  .px-sm--8 {\r\n    padding-right: -8rem !important;\r\n  }\r\n\r\n  .pb-sm--8,\r\n  .py-sm--8 {\r\n    padding-bottom: -8rem !important;\r\n  }\r\n\r\n  .pl-sm--8,\r\n  .px-sm--8 {\r\n    padding-left: -8rem !important;\r\n  }\r\n\r\n  .p-sm--7 {\r\n    padding: -6rem !important;\r\n  }\r\n\r\n  .pt-sm--7,\r\n  .py-sm--7 {\r\n    padding-top: -6rem !important;\r\n  }\r\n\r\n  .pr-sm--7,\r\n  .px-sm--7 {\r\n    padding-right: -6rem !important;\r\n  }\r\n\r\n  .pb-sm--7,\r\n  .py-sm--7 {\r\n    padding-bottom: -6rem !important;\r\n  }\r\n\r\n  .pl-sm--7,\r\n  .px-sm--7 {\r\n    padding-left: -6rem !important;\r\n  }\r\n\r\n  .p-sm--6 {\r\n    padding: -4.5rem !important;\r\n  }\r\n\r\n  .pt-sm--6,\r\n  .py-sm--6 {\r\n    padding-top: -4.5rem !important;\r\n  }\r\n\r\n  .pr-sm--6,\r\n  .px-sm--6 {\r\n    padding-right: -4.5rem !important;\r\n  }\r\n\r\n  .pb-sm--6,\r\n  .py-sm--6 {\r\n    padding-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .pl-sm--6,\r\n  .px-sm--6 {\r\n    padding-left: -4.5rem !important;\r\n  }\r\n\r\n  .p-sm--5 {\r\n    padding: -3rem !important;\r\n  }\r\n\r\n  .pt-sm--5,\r\n  .py-sm--5 {\r\n    padding-top: -3rem !important;\r\n  }\r\n\r\n  .pr-sm--5,\r\n  .px-sm--5 {\r\n    padding-right: -3rem !important;\r\n  }\r\n\r\n  .pb-sm--5,\r\n  .py-sm--5 {\r\n    padding-bottom: -3rem !important;\r\n  }\r\n\r\n  .pl-sm--5,\r\n  .px-sm--5 {\r\n    padding-left: -3rem !important;\r\n  }\r\n\r\n  .p-sm--4 {\r\n    padding: -1.5rem !important;\r\n  }\r\n\r\n  .pt-sm--4,\r\n  .py-sm--4 {\r\n    padding-top: -1.5rem !important;\r\n  }\r\n\r\n  .pr-sm--4,\r\n  .px-sm--4 {\r\n    padding-right: -1.5rem !important;\r\n  }\r\n\r\n  .pb-sm--4,\r\n  .py-sm--4 {\r\n    padding-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .pl-sm--4,\r\n  .px-sm--4 {\r\n    padding-left: -1.5rem !important;\r\n  }\r\n\r\n  .p-sm--3 {\r\n    padding: -1rem !important;\r\n  }\r\n\r\n  .pt-sm--3,\r\n  .py-sm--3 {\r\n    padding-top: -1rem !important;\r\n  }\r\n\r\n  .pr-sm--3,\r\n  .px-sm--3 {\r\n    padding-right: -1rem !important;\r\n  }\r\n\r\n  .pb-sm--3,\r\n  .py-sm--3 {\r\n    padding-bottom: -1rem !important;\r\n  }\r\n\r\n  .pl-sm--3,\r\n  .px-sm--3 {\r\n    padding-left: -1rem !important;\r\n  }\r\n\r\n  .p-sm--2 {\r\n    padding: -0.5rem !important;\r\n  }\r\n\r\n  .pt-sm--2,\r\n  .py-sm--2 {\r\n    padding-top: -0.5rem !important;\r\n  }\r\n\r\n  .pr-sm--2,\r\n  .px-sm--2 {\r\n    padding-right: -0.5rem !important;\r\n  }\r\n\r\n  .pb-sm--2,\r\n  .py-sm--2 {\r\n    padding-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .pl-sm--2,\r\n  .px-sm--2 {\r\n    padding-left: -0.5rem !important;\r\n  }\r\n\r\n  .p-sm--1 {\r\n    padding: -0.25rem !important;\r\n  }\r\n\r\n  .pt-sm--1,\r\n  .py-sm--1 {\r\n    padding-top: -0.25rem !important;\r\n  }\r\n\r\n  .pr-sm--1,\r\n  .px-sm--1 {\r\n    padding-right: -0.25rem !important;\r\n  }\r\n\r\n  .pb-sm--1,\r\n  .py-sm--1 {\r\n    padding-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .pl-sm--1,\r\n  .px-sm--1 {\r\n    padding-left: -0.25rem !important;\r\n  }\r\n\r\n  .p-sm-6 {\r\n    padding: 4.5rem !important;\r\n  }\r\n\r\n  .pt-sm-6,\r\n  .py-sm-6 {\r\n    padding-top: 4.5rem !important;\r\n  }\r\n\r\n  .pr-sm-6,\r\n  .px-sm-6 {\r\n    padding-right: 4.5rem !important;\r\n  }\r\n\r\n  .pb-sm-6,\r\n  .py-sm-6 {\r\n    padding-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .pl-sm-6,\r\n  .px-sm-6 {\r\n    padding-left: 4.5rem !important;\r\n  }\r\n\r\n  .p-sm-7 {\r\n    padding: 6rem !important;\r\n  }\r\n\r\n  .pt-sm-7,\r\n  .py-sm-7 {\r\n    padding-top: 6rem !important;\r\n  }\r\n\r\n  .pr-sm-7,\r\n  .px-sm-7 {\r\n    padding-right: 6rem !important;\r\n  }\r\n\r\n  .pb-sm-7,\r\n  .py-sm-7 {\r\n    padding-bottom: 6rem !important;\r\n  }\r\n\r\n  .pl-sm-7,\r\n  .px-sm-7 {\r\n    padding-left: 6rem !important;\r\n  }\r\n\r\n  .p-sm-8 {\r\n    padding: 8rem !important;\r\n  }\r\n\r\n  .pt-sm-8,\r\n  .py-sm-8 {\r\n    padding-top: 8rem !important;\r\n  }\r\n\r\n  .pr-sm-8,\r\n  .px-sm-8 {\r\n    padding-right: 8rem !important;\r\n  }\r\n\r\n  .pb-sm-8,\r\n  .py-sm-8 {\r\n    padding-bottom: 8rem !important;\r\n  }\r\n\r\n  .pl-sm-8,\r\n  .px-sm-8 {\r\n    padding-left: 8rem !important;\r\n  }\r\n\r\n  .p-sm-9 {\r\n    padding: 10rem !important;\r\n  }\r\n\r\n  .pt-sm-9,\r\n  .py-sm-9 {\r\n    padding-top: 10rem !important;\r\n  }\r\n\r\n  .pr-sm-9,\r\n  .px-sm-9 {\r\n    padding-right: 10rem !important;\r\n  }\r\n\r\n  .pb-sm-9,\r\n  .py-sm-9 {\r\n    padding-bottom: 10rem !important;\r\n  }\r\n\r\n  .pl-sm-9,\r\n  .px-sm-9 {\r\n    padding-left: 10rem !important;\r\n  }\r\n\r\n  .m-sm-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-sm-n1,\r\n  .my-sm-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-sm-n1,\r\n  .mx-sm-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-sm-n1,\r\n  .my-sm-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-sm-n1,\r\n  .mx-sm-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-sm-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n2,\r\n  .my-sm-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n2,\r\n  .mx-sm-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n2,\r\n  .my-sm-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n2,\r\n  .mx-sm-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-sm-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-sm-n3,\r\n  .my-sm-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-sm-n3,\r\n  .mx-sm-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-sm-n3,\r\n  .my-sm-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-sm-n3,\r\n  .mx-sm-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-sm-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n4,\r\n  .my-sm-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n4,\r\n  .mx-sm-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n4,\r\n  .my-sm-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n4,\r\n  .mx-sm-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-sm-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-sm-n5,\r\n  .my-sm-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-sm-n5,\r\n  .mx-sm-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-sm-n5,\r\n  .my-sm-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-sm-n5,\r\n  .mx-sm-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-sm-n-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-sm-n-9,\r\n  .my-sm-n-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-sm-n-9,\r\n  .mx-sm-n-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-sm-n-9,\r\n  .my-sm-n-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-sm-n-9,\r\n  .mx-sm-n-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .m-sm-n-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-sm-n-8,\r\n  .my-sm-n-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-sm-n-8,\r\n  .mx-sm-n-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-sm-n-8,\r\n  .my-sm-n-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-sm-n-8,\r\n  .mx-sm-n-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-sm-n-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-sm-n-7,\r\n  .my-sm-n-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-sm-n-7,\r\n  .mx-sm-n-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-sm-n-7,\r\n  .my-sm-n-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-sm-n-7,\r\n  .mx-sm-n-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-sm-n-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n-6,\r\n  .my-sm-n-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n-6,\r\n  .mx-sm-n-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n-6,\r\n  .my-sm-n-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n-6,\r\n  .mx-sm-n-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-sm-n-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-sm-n-5,\r\n  .my-sm-n-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-sm-n-5,\r\n  .mx-sm-n-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-sm-n-5,\r\n  .my-sm-n-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-sm-n-5,\r\n  .mx-sm-n-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-sm-n-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n-4,\r\n  .my-sm-n-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n-4,\r\n  .mx-sm-n-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n-4,\r\n  .my-sm-n-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n-4,\r\n  .mx-sm-n-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-sm-n-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-sm-n-3,\r\n  .my-sm-n-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-sm-n-3,\r\n  .mx-sm-n-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-sm-n-3,\r\n  .my-sm-n-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-sm-n-3,\r\n  .mx-sm-n-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-sm-n-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n-2,\r\n  .my-sm-n-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n-2,\r\n  .mx-sm-n-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n-2,\r\n  .my-sm-n-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n-2,\r\n  .mx-sm-n-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-sm-n-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-sm-n-1,\r\n  .my-sm-n-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-sm-n-1,\r\n  .mx-sm-n-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-sm-n-1,\r\n  .my-sm-n-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-sm-n-1,\r\n  .mx-sm-n-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-sm-n6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n6,\r\n  .my-sm-n6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n6,\r\n  .mx-sm-n6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n6,\r\n  .my-sm-n6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n6,\r\n  .mx-sm-n6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-sm-n7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-sm-n7,\r\n  .my-sm-n7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-sm-n7,\r\n  .mx-sm-n7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-sm-n7,\r\n  .my-sm-n7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-sm-n7,\r\n  .mx-sm-n7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-sm-n8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-sm-n8,\r\n  .my-sm-n8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-sm-n8,\r\n  .mx-sm-n8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-sm-n8,\r\n  .my-sm-n8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-sm-n8,\r\n  .mx-sm-n8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-sm-n9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-sm-n9,\r\n  .my-sm-n9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-sm-n9,\r\n  .mx-sm-n9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-sm-n9,\r\n  .my-sm-n9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-sm-n9,\r\n  .mx-sm-n9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-sm-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-sm-auto,\r\n  .my-sm-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-sm-auto,\r\n  .mx-sm-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-sm-auto,\r\n  .my-sm-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-sm-auto,\r\n  .mx-sm-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .m-md-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-md-0,\r\n  .my-md-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-md-0,\r\n  .mx-md-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-md-0,\r\n  .my-md-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-md-0,\r\n  .mx-md-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-md-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-md-1,\r\n  .my-md-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-md-1,\r\n  .mx-md-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-md-1,\r\n  .my-md-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-md-1,\r\n  .mx-md-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-md-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-md-2,\r\n  .my-md-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-md-2,\r\n  .mx-md-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-md-2,\r\n  .my-md-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-md-2,\r\n  .mx-md-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-md-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-md-3,\r\n  .my-md-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-md-3,\r\n  .mx-md-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-md-3,\r\n  .my-md-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-md-3,\r\n  .mx-md-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-md-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-md-4,\r\n  .my-md-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-md-4,\r\n  .mx-md-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-md-4,\r\n  .my-md-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-md-4,\r\n  .mx-md-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-md-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-md-5,\r\n  .my-md-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-md-5,\r\n  .mx-md-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-md-5,\r\n  .my-md-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-md-5,\r\n  .mx-md-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-md--9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-md--9,\r\n  .my-md--9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-md--9,\r\n  .mx-md--9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-md--9,\r\n  .my-md--9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-md--9,\r\n  .mx-md--9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-md--8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-md--8,\r\n  .my-md--8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-md--8,\r\n  .mx-md--8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-md--8,\r\n  .my-md--8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-md--8,\r\n  .mx-md--8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-md--7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-md--7,\r\n  .my-md--7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-md--7,\r\n  .mx-md--7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-md--7,\r\n  .my-md--7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-md--7,\r\n  .mx-md--7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-md--6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-md--6,\r\n  .my-md--6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-md--6,\r\n  .mx-md--6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-md--6,\r\n  .my-md--6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-md--6,\r\n  .mx-md--6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-md--5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-md--5,\r\n  .my-md--5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-md--5,\r\n  .mx-md--5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-md--5,\r\n  .my-md--5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-md--5,\r\n  .mx-md--5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-md--4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-md--4,\r\n  .my-md--4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-md--4,\r\n  .mx-md--4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-md--4,\r\n  .my-md--4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-md--4,\r\n  .mx-md--4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-md--3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-md--3,\r\n  .my-md--3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-md--3,\r\n  .mx-md--3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-md--3,\r\n  .my-md--3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-md--3,\r\n  .mx-md--3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-md--2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-md--2,\r\n  .my-md--2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-md--2,\r\n  .mx-md--2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-md--2,\r\n  .my-md--2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-md--2,\r\n  .mx-md--2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-md--1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-md--1,\r\n  .my-md--1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-md--1,\r\n  .mx-md--1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-md--1,\r\n  .my-md--1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-md--1,\r\n  .mx-md--1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-md-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-md-6,\r\n  .my-md-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-md-6,\r\n  .mx-md-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-md-6,\r\n  .my-md-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-md-6,\r\n  .mx-md-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-md-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-md-7,\r\n  .my-md-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-md-7,\r\n  .mx-md-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-md-7,\r\n  .my-md-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-md-7,\r\n  .mx-md-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-md-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-md-8,\r\n  .my-md-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-md-8,\r\n  .mx-md-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-md-8,\r\n  .my-md-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-md-8,\r\n  .mx-md-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-md-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-md-9,\r\n  .my-md-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-md-9,\r\n  .mx-md-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-md-9,\r\n  .my-md-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-md-9,\r\n  .mx-md-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .p-md-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-md-0,\r\n  .py-md-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-md-0,\r\n  .px-md-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-md-0,\r\n  .py-md-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-md-0,\r\n  .px-md-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-md-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-md-1,\r\n  .py-md-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-md-1,\r\n  .px-md-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-md-1,\r\n  .py-md-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-md-1,\r\n  .px-md-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-md-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-md-2,\r\n  .py-md-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-md-2,\r\n  .px-md-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-md-2,\r\n  .py-md-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-md-2,\r\n  .px-md-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-md-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-md-3,\r\n  .py-md-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-md-3,\r\n  .px-md-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-md-3,\r\n  .py-md-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-md-3,\r\n  .px-md-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-md-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-md-4,\r\n  .py-md-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-md-4,\r\n  .px-md-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-md-4,\r\n  .py-md-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-md-4,\r\n  .px-md-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-md-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-md-5,\r\n  .py-md-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-md-5,\r\n  .px-md-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-md-5,\r\n  .py-md-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-md-5,\r\n  .px-md-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .p-md--9 {\r\n    padding: -10rem !important;\r\n  }\r\n\r\n  .pt-md--9,\r\n  .py-md--9 {\r\n    padding-top: -10rem !important;\r\n  }\r\n\r\n  .pr-md--9,\r\n  .px-md--9 {\r\n    padding-right: -10rem !important;\r\n  }\r\n\r\n  .pb-md--9,\r\n  .py-md--9 {\r\n    padding-bottom: -10rem !important;\r\n  }\r\n\r\n  .pl-md--9,\r\n  .px-md--9 {\r\n    padding-left: -10rem !important;\r\n  }\r\n\r\n  .p-md--8 {\r\n    padding: -8rem !important;\r\n  }\r\n\r\n  .pt-md--8,\r\n  .py-md--8 {\r\n    padding-top: -8rem !important;\r\n  }\r\n\r\n  .pr-md--8,\r\n  .px-md--8 {\r\n    padding-right: -8rem !important;\r\n  }\r\n\r\n  .pb-md--8,\r\n  .py-md--8 {\r\n    padding-bottom: -8rem !important;\r\n  }\r\n\r\n  .pl-md--8,\r\n  .px-md--8 {\r\n    padding-left: -8rem !important;\r\n  }\r\n\r\n  .p-md--7 {\r\n    padding: -6rem !important;\r\n  }\r\n\r\n  .pt-md--7,\r\n  .py-md--7 {\r\n    padding-top: -6rem !important;\r\n  }\r\n\r\n  .pr-md--7,\r\n  .px-md--7 {\r\n    padding-right: -6rem !important;\r\n  }\r\n\r\n  .pb-md--7,\r\n  .py-md--7 {\r\n    padding-bottom: -6rem !important;\r\n  }\r\n\r\n  .pl-md--7,\r\n  .px-md--7 {\r\n    padding-left: -6rem !important;\r\n  }\r\n\r\n  .p-md--6 {\r\n    padding: -4.5rem !important;\r\n  }\r\n\r\n  .pt-md--6,\r\n  .py-md--6 {\r\n    padding-top: -4.5rem !important;\r\n  }\r\n\r\n  .pr-md--6,\r\n  .px-md--6 {\r\n    padding-right: -4.5rem !important;\r\n  }\r\n\r\n  .pb-md--6,\r\n  .py-md--6 {\r\n    padding-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .pl-md--6,\r\n  .px-md--6 {\r\n    padding-left: -4.5rem !important;\r\n  }\r\n\r\n  .p-md--5 {\r\n    padding: -3rem !important;\r\n  }\r\n\r\n  .pt-md--5,\r\n  .py-md--5 {\r\n    padding-top: -3rem !important;\r\n  }\r\n\r\n  .pr-md--5,\r\n  .px-md--5 {\r\n    padding-right: -3rem !important;\r\n  }\r\n\r\n  .pb-md--5,\r\n  .py-md--5 {\r\n    padding-bottom: -3rem !important;\r\n  }\r\n\r\n  .pl-md--5,\r\n  .px-md--5 {\r\n    padding-left: -3rem !important;\r\n  }\r\n\r\n  .p-md--4 {\r\n    padding: -1.5rem !important;\r\n  }\r\n\r\n  .pt-md--4,\r\n  .py-md--4 {\r\n    padding-top: -1.5rem !important;\r\n  }\r\n\r\n  .pr-md--4,\r\n  .px-md--4 {\r\n    padding-right: -1.5rem !important;\r\n  }\r\n\r\n  .pb-md--4,\r\n  .py-md--4 {\r\n    padding-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .pl-md--4,\r\n  .px-md--4 {\r\n    padding-left: -1.5rem !important;\r\n  }\r\n\r\n  .p-md--3 {\r\n    padding: -1rem !important;\r\n  }\r\n\r\n  .pt-md--3,\r\n  .py-md--3 {\r\n    padding-top: -1rem !important;\r\n  }\r\n\r\n  .pr-md--3,\r\n  .px-md--3 {\r\n    padding-right: -1rem !important;\r\n  }\r\n\r\n  .pb-md--3,\r\n  .py-md--3 {\r\n    padding-bottom: -1rem !important;\r\n  }\r\n\r\n  .pl-md--3,\r\n  .px-md--3 {\r\n    padding-left: -1rem !important;\r\n  }\r\n\r\n  .p-md--2 {\r\n    padding: -0.5rem !important;\r\n  }\r\n\r\n  .pt-md--2,\r\n  .py-md--2 {\r\n    padding-top: -0.5rem !important;\r\n  }\r\n\r\n  .pr-md--2,\r\n  .px-md--2 {\r\n    padding-right: -0.5rem !important;\r\n  }\r\n\r\n  .pb-md--2,\r\n  .py-md--2 {\r\n    padding-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .pl-md--2,\r\n  .px-md--2 {\r\n    padding-left: -0.5rem !important;\r\n  }\r\n\r\n  .p-md--1 {\r\n    padding: -0.25rem !important;\r\n  }\r\n\r\n  .pt-md--1,\r\n  .py-md--1 {\r\n    padding-top: -0.25rem !important;\r\n  }\r\n\r\n  .pr-md--1,\r\n  .px-md--1 {\r\n    padding-right: -0.25rem !important;\r\n  }\r\n\r\n  .pb-md--1,\r\n  .py-md--1 {\r\n    padding-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .pl-md--1,\r\n  .px-md--1 {\r\n    padding-left: -0.25rem !important;\r\n  }\r\n\r\n  .p-md-6 {\r\n    padding: 4.5rem !important;\r\n  }\r\n\r\n  .pt-md-6,\r\n  .py-md-6 {\r\n    padding-top: 4.5rem !important;\r\n  }\r\n\r\n  .pr-md-6,\r\n  .px-md-6 {\r\n    padding-right: 4.5rem !important;\r\n  }\r\n\r\n  .pb-md-6,\r\n  .py-md-6 {\r\n    padding-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .pl-md-6,\r\n  .px-md-6 {\r\n    padding-left: 4.5rem !important;\r\n  }\r\n\r\n  .p-md-7 {\r\n    padding: 6rem !important;\r\n  }\r\n\r\n  .pt-md-7,\r\n  .py-md-7 {\r\n    padding-top: 6rem !important;\r\n  }\r\n\r\n  .pr-md-7,\r\n  .px-md-7 {\r\n    padding-right: 6rem !important;\r\n  }\r\n\r\n  .pb-md-7,\r\n  .py-md-7 {\r\n    padding-bottom: 6rem !important;\r\n  }\r\n\r\n  .pl-md-7,\r\n  .px-md-7 {\r\n    padding-left: 6rem !important;\r\n  }\r\n\r\n  .p-md-8 {\r\n    padding: 8rem !important;\r\n  }\r\n\r\n  .pt-md-8,\r\n  .py-md-8 {\r\n    padding-top: 8rem !important;\r\n  }\r\n\r\n  .pr-md-8,\r\n  .px-md-8 {\r\n    padding-right: 8rem !important;\r\n  }\r\n\r\n  .pb-md-8,\r\n  .py-md-8 {\r\n    padding-bottom: 8rem !important;\r\n  }\r\n\r\n  .pl-md-8,\r\n  .px-md-8 {\r\n    padding-left: 8rem !important;\r\n  }\r\n\r\n  .p-md-9 {\r\n    padding: 10rem !important;\r\n  }\r\n\r\n  .pt-md-9,\r\n  .py-md-9 {\r\n    padding-top: 10rem !important;\r\n  }\r\n\r\n  .pr-md-9,\r\n  .px-md-9 {\r\n    padding-right: 10rem !important;\r\n  }\r\n\r\n  .pb-md-9,\r\n  .py-md-9 {\r\n    padding-bottom: 10rem !important;\r\n  }\r\n\r\n  .pl-md-9,\r\n  .px-md-9 {\r\n    padding-left: 10rem !important;\r\n  }\r\n\r\n  .m-md-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-md-n1,\r\n  .my-md-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-md-n1,\r\n  .mx-md-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-md-n1,\r\n  .my-md-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-md-n1,\r\n  .mx-md-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-md-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-md-n2,\r\n  .my-md-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-md-n2,\r\n  .mx-md-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-md-n2,\r\n  .my-md-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-md-n2,\r\n  .mx-md-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-md-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-md-n3,\r\n  .my-md-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-md-n3,\r\n  .mx-md-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-md-n3,\r\n  .my-md-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-md-n3,\r\n  .mx-md-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-md-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-md-n4,\r\n  .my-md-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-md-n4,\r\n  .mx-md-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-md-n4,\r\n  .my-md-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-md-n4,\r\n  .mx-md-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-md-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-md-n5,\r\n  .my-md-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-md-n5,\r\n  .mx-md-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-md-n5,\r\n  .my-md-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-md-n5,\r\n  .mx-md-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-md-n-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-md-n-9,\r\n  .my-md-n-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-md-n-9,\r\n  .mx-md-n-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-md-n-9,\r\n  .my-md-n-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-md-n-9,\r\n  .mx-md-n-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .m-md-n-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-md-n-8,\r\n  .my-md-n-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-md-n-8,\r\n  .mx-md-n-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-md-n-8,\r\n  .my-md-n-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-md-n-8,\r\n  .mx-md-n-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-md-n-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-md-n-7,\r\n  .my-md-n-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-md-n-7,\r\n  .mx-md-n-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-md-n-7,\r\n  .my-md-n-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-md-n-7,\r\n  .mx-md-n-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-md-n-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-md-n-6,\r\n  .my-md-n-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-md-n-6,\r\n  .mx-md-n-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-md-n-6,\r\n  .my-md-n-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-md-n-6,\r\n  .mx-md-n-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-md-n-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-md-n-5,\r\n  .my-md-n-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-md-n-5,\r\n  .mx-md-n-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-md-n-5,\r\n  .my-md-n-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-md-n-5,\r\n  .mx-md-n-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-md-n-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-md-n-4,\r\n  .my-md-n-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-md-n-4,\r\n  .mx-md-n-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-md-n-4,\r\n  .my-md-n-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-md-n-4,\r\n  .mx-md-n-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-md-n-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-md-n-3,\r\n  .my-md-n-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-md-n-3,\r\n  .mx-md-n-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-md-n-3,\r\n  .my-md-n-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-md-n-3,\r\n  .mx-md-n-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-md-n-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-md-n-2,\r\n  .my-md-n-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-md-n-2,\r\n  .mx-md-n-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-md-n-2,\r\n  .my-md-n-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-md-n-2,\r\n  .mx-md-n-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-md-n-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-md-n-1,\r\n  .my-md-n-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-md-n-1,\r\n  .mx-md-n-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-md-n-1,\r\n  .my-md-n-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-md-n-1,\r\n  .mx-md-n-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-md-n6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-md-n6,\r\n  .my-md-n6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-md-n6,\r\n  .mx-md-n6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-md-n6,\r\n  .my-md-n6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-md-n6,\r\n  .mx-md-n6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-md-n7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-md-n7,\r\n  .my-md-n7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-md-n7,\r\n  .mx-md-n7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-md-n7,\r\n  .my-md-n7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-md-n7,\r\n  .mx-md-n7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-md-n8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-md-n8,\r\n  .my-md-n8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-md-n8,\r\n  .mx-md-n8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-md-n8,\r\n  .my-md-n8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-md-n8,\r\n  .mx-md-n8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-md-n9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-md-n9,\r\n  .my-md-n9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-md-n9,\r\n  .mx-md-n9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-md-n9,\r\n  .my-md-n9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-md-n9,\r\n  .mx-md-n9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-md-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-md-auto,\r\n  .my-md-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-md-auto,\r\n  .mx-md-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-md-auto,\r\n  .my-md-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-md-auto,\r\n  .mx-md-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .m-lg-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-lg-0,\r\n  .my-lg-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-lg-0,\r\n  .mx-lg-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-lg-0,\r\n  .my-lg-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-lg-0,\r\n  .mx-lg-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-lg-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-lg-1,\r\n  .my-lg-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-lg-1,\r\n  .mx-lg-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-lg-1,\r\n  .my-lg-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-lg-1,\r\n  .mx-lg-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-lg-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-lg-2,\r\n  .my-lg-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-lg-2,\r\n  .mx-lg-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-lg-2,\r\n  .my-lg-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-lg-2,\r\n  .mx-lg-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-lg-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-lg-3,\r\n  .my-lg-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-lg-3,\r\n  .mx-lg-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-lg-3,\r\n  .my-lg-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-lg-3,\r\n  .mx-lg-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-lg-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-lg-4,\r\n  .my-lg-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-lg-4,\r\n  .mx-lg-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-lg-4,\r\n  .my-lg-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-lg-4,\r\n  .mx-lg-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-lg-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-lg-5,\r\n  .my-lg-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-lg-5,\r\n  .mx-lg-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-lg-5,\r\n  .my-lg-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-lg-5,\r\n  .mx-lg-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-lg--9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-lg--9,\r\n  .my-lg--9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-lg--9,\r\n  .mx-lg--9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-lg--9,\r\n  .my-lg--9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-lg--9,\r\n  .mx-lg--9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-lg--8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-lg--8,\r\n  .my-lg--8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-lg--8,\r\n  .mx-lg--8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-lg--8,\r\n  .my-lg--8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-lg--8,\r\n  .mx-lg--8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-lg--7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-lg--7,\r\n  .my-lg--7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-lg--7,\r\n  .mx-lg--7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-lg--7,\r\n  .my-lg--7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-lg--7,\r\n  .mx-lg--7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-lg--6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-lg--6,\r\n  .my-lg--6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-lg--6,\r\n  .mx-lg--6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-lg--6,\r\n  .my-lg--6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-lg--6,\r\n  .mx-lg--6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-lg--5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-lg--5,\r\n  .my-lg--5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-lg--5,\r\n  .mx-lg--5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-lg--5,\r\n  .my-lg--5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-lg--5,\r\n  .mx-lg--5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-lg--4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-lg--4,\r\n  .my-lg--4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-lg--4,\r\n  .mx-lg--4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-lg--4,\r\n  .my-lg--4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-lg--4,\r\n  .mx-lg--4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-lg--3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-lg--3,\r\n  .my-lg--3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-lg--3,\r\n  .mx-lg--3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-lg--3,\r\n  .my-lg--3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-lg--3,\r\n  .mx-lg--3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-lg--2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-lg--2,\r\n  .my-lg--2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-lg--2,\r\n  .mx-lg--2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-lg--2,\r\n  .my-lg--2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-lg--2,\r\n  .mx-lg--2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-lg--1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-lg--1,\r\n  .my-lg--1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-lg--1,\r\n  .mx-lg--1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-lg--1,\r\n  .my-lg--1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-lg--1,\r\n  .mx-lg--1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-lg-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-lg-6,\r\n  .my-lg-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-lg-6,\r\n  .mx-lg-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-lg-6,\r\n  .my-lg-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-lg-6,\r\n  .mx-lg-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-lg-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-lg-7,\r\n  .my-lg-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-lg-7,\r\n  .mx-lg-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-lg-7,\r\n  .my-lg-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-lg-7,\r\n  .mx-lg-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-lg-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-lg-8,\r\n  .my-lg-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-lg-8,\r\n  .mx-lg-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-lg-8,\r\n  .my-lg-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-lg-8,\r\n  .mx-lg-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-lg-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-lg-9,\r\n  .my-lg-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-lg-9,\r\n  .mx-lg-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-lg-9,\r\n  .my-lg-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-lg-9,\r\n  .mx-lg-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .p-lg-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-lg-0,\r\n  .py-lg-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-lg-0,\r\n  .px-lg-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-lg-0,\r\n  .py-lg-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-lg-0,\r\n  .px-lg-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-lg-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-lg-1,\r\n  .py-lg-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-lg-1,\r\n  .px-lg-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-lg-1,\r\n  .py-lg-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-lg-1,\r\n  .px-lg-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-lg-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-lg-2,\r\n  .py-lg-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-lg-2,\r\n  .px-lg-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-lg-2,\r\n  .py-lg-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-lg-2,\r\n  .px-lg-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-lg-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-lg-3,\r\n  .py-lg-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-lg-3,\r\n  .px-lg-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-lg-3,\r\n  .py-lg-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-lg-3,\r\n  .px-lg-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-lg-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-lg-4,\r\n  .py-lg-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-lg-4,\r\n  .px-lg-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-lg-4,\r\n  .py-lg-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-lg-4,\r\n  .px-lg-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-lg-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-lg-5,\r\n  .py-lg-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-lg-5,\r\n  .px-lg-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-lg-5,\r\n  .py-lg-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-lg-5,\r\n  .px-lg-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .p-lg--9 {\r\n    padding: -10rem !important;\r\n  }\r\n\r\n  .pt-lg--9,\r\n  .py-lg--9 {\r\n    padding-top: -10rem !important;\r\n  }\r\n\r\n  .pr-lg--9,\r\n  .px-lg--9 {\r\n    padding-right: -10rem !important;\r\n  }\r\n\r\n  .pb-lg--9,\r\n  .py-lg--9 {\r\n    padding-bottom: -10rem !important;\r\n  }\r\n\r\n  .pl-lg--9,\r\n  .px-lg--9 {\r\n    padding-left: -10rem !important;\r\n  }\r\n\r\n  .p-lg--8 {\r\n    padding: -8rem !important;\r\n  }\r\n\r\n  .pt-lg--8,\r\n  .py-lg--8 {\r\n    padding-top: -8rem !important;\r\n  }\r\n\r\n  .pr-lg--8,\r\n  .px-lg--8 {\r\n    padding-right: -8rem !important;\r\n  }\r\n\r\n  .pb-lg--8,\r\n  .py-lg--8 {\r\n    padding-bottom: -8rem !important;\r\n  }\r\n\r\n  .pl-lg--8,\r\n  .px-lg--8 {\r\n    padding-left: -8rem !important;\r\n  }\r\n\r\n  .p-lg--7 {\r\n    padding: -6rem !important;\r\n  }\r\n\r\n  .pt-lg--7,\r\n  .py-lg--7 {\r\n    padding-top: -6rem !important;\r\n  }\r\n\r\n  .pr-lg--7,\r\n  .px-lg--7 {\r\n    padding-right: -6rem !important;\r\n  }\r\n\r\n  .pb-lg--7,\r\n  .py-lg--7 {\r\n    padding-bottom: -6rem !important;\r\n  }\r\n\r\n  .pl-lg--7,\r\n  .px-lg--7 {\r\n    padding-left: -6rem !important;\r\n  }\r\n\r\n  .p-lg--6 {\r\n    padding: -4.5rem !important;\r\n  }\r\n\r\n  .pt-lg--6,\r\n  .py-lg--6 {\r\n    padding-top: -4.5rem !important;\r\n  }\r\n\r\n  .pr-lg--6,\r\n  .px-lg--6 {\r\n    padding-right: -4.5rem !important;\r\n  }\r\n\r\n  .pb-lg--6,\r\n  .py-lg--6 {\r\n    padding-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .pl-lg--6,\r\n  .px-lg--6 {\r\n    padding-left: -4.5rem !important;\r\n  }\r\n\r\n  .p-lg--5 {\r\n    padding: -3rem !important;\r\n  }\r\n\r\n  .pt-lg--5,\r\n  .py-lg--5 {\r\n    padding-top: -3rem !important;\r\n  }\r\n\r\n  .pr-lg--5,\r\n  .px-lg--5 {\r\n    padding-right: -3rem !important;\r\n  }\r\n\r\n  .pb-lg--5,\r\n  .py-lg--5 {\r\n    padding-bottom: -3rem !important;\r\n  }\r\n\r\n  .pl-lg--5,\r\n  .px-lg--5 {\r\n    padding-left: -3rem !important;\r\n  }\r\n\r\n  .p-lg--4 {\r\n    padding: -1.5rem !important;\r\n  }\r\n\r\n  .pt-lg--4,\r\n  .py-lg--4 {\r\n    padding-top: -1.5rem !important;\r\n  }\r\n\r\n  .pr-lg--4,\r\n  .px-lg--4 {\r\n    padding-right: -1.5rem !important;\r\n  }\r\n\r\n  .pb-lg--4,\r\n  .py-lg--4 {\r\n    padding-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .pl-lg--4,\r\n  .px-lg--4 {\r\n    padding-left: -1.5rem !important;\r\n  }\r\n\r\n  .p-lg--3 {\r\n    padding: -1rem !important;\r\n  }\r\n\r\n  .pt-lg--3,\r\n  .py-lg--3 {\r\n    padding-top: -1rem !important;\r\n  }\r\n\r\n  .pr-lg--3,\r\n  .px-lg--3 {\r\n    padding-right: -1rem !important;\r\n  }\r\n\r\n  .pb-lg--3,\r\n  .py-lg--3 {\r\n    padding-bottom: -1rem !important;\r\n  }\r\n\r\n  .pl-lg--3,\r\n  .px-lg--3 {\r\n    padding-left: -1rem !important;\r\n  }\r\n\r\n  .p-lg--2 {\r\n    padding: -0.5rem !important;\r\n  }\r\n\r\n  .pt-lg--2,\r\n  .py-lg--2 {\r\n    padding-top: -0.5rem !important;\r\n  }\r\n\r\n  .pr-lg--2,\r\n  .px-lg--2 {\r\n    padding-right: -0.5rem !important;\r\n  }\r\n\r\n  .pb-lg--2,\r\n  .py-lg--2 {\r\n    padding-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .pl-lg--2,\r\n  .px-lg--2 {\r\n    padding-left: -0.5rem !important;\r\n  }\r\n\r\n  .p-lg--1 {\r\n    padding: -0.25rem !important;\r\n  }\r\n\r\n  .pt-lg--1,\r\n  .py-lg--1 {\r\n    padding-top: -0.25rem !important;\r\n  }\r\n\r\n  .pr-lg--1,\r\n  .px-lg--1 {\r\n    padding-right: -0.25rem !important;\r\n  }\r\n\r\n  .pb-lg--1,\r\n  .py-lg--1 {\r\n    padding-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .pl-lg--1,\r\n  .px-lg--1 {\r\n    padding-left: -0.25rem !important;\r\n  }\r\n\r\n  .p-lg-6 {\r\n    padding: 4.5rem !important;\r\n  }\r\n\r\n  .pt-lg-6,\r\n  .py-lg-6 {\r\n    padding-top: 4.5rem !important;\r\n  }\r\n\r\n  .pr-lg-6,\r\n  .px-lg-6 {\r\n    padding-right: 4.5rem !important;\r\n  }\r\n\r\n  .pb-lg-6,\r\n  .py-lg-6 {\r\n    padding-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .pl-lg-6,\r\n  .px-lg-6 {\r\n    padding-left: 4.5rem !important;\r\n  }\r\n\r\n  .p-lg-7 {\r\n    padding: 6rem !important;\r\n  }\r\n\r\n  .pt-lg-7,\r\n  .py-lg-7 {\r\n    padding-top: 6rem !important;\r\n  }\r\n\r\n  .pr-lg-7,\r\n  .px-lg-7 {\r\n    padding-right: 6rem !important;\r\n  }\r\n\r\n  .pb-lg-7,\r\n  .py-lg-7 {\r\n    padding-bottom: 6rem !important;\r\n  }\r\n\r\n  .pl-lg-7,\r\n  .px-lg-7 {\r\n    padding-left: 6rem !important;\r\n  }\r\n\r\n  .p-lg-8 {\r\n    padding: 8rem !important;\r\n  }\r\n\r\n  .pt-lg-8,\r\n  .py-lg-8 {\r\n    padding-top: 8rem !important;\r\n  }\r\n\r\n  .pr-lg-8,\r\n  .px-lg-8 {\r\n    padding-right: 8rem !important;\r\n  }\r\n\r\n  .pb-lg-8,\r\n  .py-lg-8 {\r\n    padding-bottom: 8rem !important;\r\n  }\r\n\r\n  .pl-lg-8,\r\n  .px-lg-8 {\r\n    padding-left: 8rem !important;\r\n  }\r\n\r\n  .p-lg-9 {\r\n    padding: 10rem !important;\r\n  }\r\n\r\n  .pt-lg-9,\r\n  .py-lg-9 {\r\n    padding-top: 10rem !important;\r\n  }\r\n\r\n  .pr-lg-9,\r\n  .px-lg-9 {\r\n    padding-right: 10rem !important;\r\n  }\r\n\r\n  .pb-lg-9,\r\n  .py-lg-9 {\r\n    padding-bottom: 10rem !important;\r\n  }\r\n\r\n  .pl-lg-9,\r\n  .px-lg-9 {\r\n    padding-left: 10rem !important;\r\n  }\r\n\r\n  .m-lg-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-lg-n1,\r\n  .my-lg-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-lg-n1,\r\n  .mx-lg-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-lg-n1,\r\n  .my-lg-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-lg-n1,\r\n  .mx-lg-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-lg-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n2,\r\n  .my-lg-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n2,\r\n  .mx-lg-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n2,\r\n  .my-lg-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n2,\r\n  .mx-lg-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-lg-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-lg-n3,\r\n  .my-lg-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-lg-n3,\r\n  .mx-lg-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-lg-n3,\r\n  .my-lg-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-lg-n3,\r\n  .mx-lg-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-lg-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n4,\r\n  .my-lg-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n4,\r\n  .mx-lg-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n4,\r\n  .my-lg-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n4,\r\n  .mx-lg-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-lg-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-lg-n5,\r\n  .my-lg-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-lg-n5,\r\n  .mx-lg-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-lg-n5,\r\n  .my-lg-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-lg-n5,\r\n  .mx-lg-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-lg-n-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-lg-n-9,\r\n  .my-lg-n-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-lg-n-9,\r\n  .mx-lg-n-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-lg-n-9,\r\n  .my-lg-n-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-lg-n-9,\r\n  .mx-lg-n-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .m-lg-n-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-lg-n-8,\r\n  .my-lg-n-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-lg-n-8,\r\n  .mx-lg-n-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-lg-n-8,\r\n  .my-lg-n-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-lg-n-8,\r\n  .mx-lg-n-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-lg-n-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-lg-n-7,\r\n  .my-lg-n-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-lg-n-7,\r\n  .mx-lg-n-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-lg-n-7,\r\n  .my-lg-n-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-lg-n-7,\r\n  .mx-lg-n-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-lg-n-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n-6,\r\n  .my-lg-n-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n-6,\r\n  .mx-lg-n-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n-6,\r\n  .my-lg-n-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n-6,\r\n  .mx-lg-n-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-lg-n-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-lg-n-5,\r\n  .my-lg-n-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-lg-n-5,\r\n  .mx-lg-n-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-lg-n-5,\r\n  .my-lg-n-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-lg-n-5,\r\n  .mx-lg-n-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-lg-n-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n-4,\r\n  .my-lg-n-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n-4,\r\n  .mx-lg-n-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n-4,\r\n  .my-lg-n-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n-4,\r\n  .mx-lg-n-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-lg-n-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-lg-n-3,\r\n  .my-lg-n-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-lg-n-3,\r\n  .mx-lg-n-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-lg-n-3,\r\n  .my-lg-n-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-lg-n-3,\r\n  .mx-lg-n-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-lg-n-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n-2,\r\n  .my-lg-n-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n-2,\r\n  .mx-lg-n-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n-2,\r\n  .my-lg-n-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n-2,\r\n  .mx-lg-n-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-lg-n-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-lg-n-1,\r\n  .my-lg-n-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-lg-n-1,\r\n  .mx-lg-n-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-lg-n-1,\r\n  .my-lg-n-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-lg-n-1,\r\n  .mx-lg-n-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-lg-n6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n6,\r\n  .my-lg-n6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n6,\r\n  .mx-lg-n6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n6,\r\n  .my-lg-n6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n6,\r\n  .mx-lg-n6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-lg-n7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-lg-n7,\r\n  .my-lg-n7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-lg-n7,\r\n  .mx-lg-n7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-lg-n7,\r\n  .my-lg-n7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-lg-n7,\r\n  .mx-lg-n7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-lg-n8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-lg-n8,\r\n  .my-lg-n8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-lg-n8,\r\n  .mx-lg-n8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-lg-n8,\r\n  .my-lg-n8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-lg-n8,\r\n  .mx-lg-n8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-lg-n9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-lg-n9,\r\n  .my-lg-n9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-lg-n9,\r\n  .mx-lg-n9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-lg-n9,\r\n  .my-lg-n9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-lg-n9,\r\n  .mx-lg-n9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-lg-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-lg-auto,\r\n  .my-lg-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-lg-auto,\r\n  .mx-lg-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-lg-auto,\r\n  .my-lg-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-lg-auto,\r\n  .mx-lg-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .m-xl-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-xl-0,\r\n  .my-xl-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-xl-0,\r\n  .mx-xl-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-xl-0,\r\n  .my-xl-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-xl-0,\r\n  .mx-xl-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-xl-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-xl-1,\r\n  .my-xl-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-xl-1,\r\n  .mx-xl-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-xl-1,\r\n  .my-xl-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-xl-1,\r\n  .mx-xl-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-xl-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-xl-2,\r\n  .my-xl-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-xl-2,\r\n  .mx-xl-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-xl-2,\r\n  .my-xl-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-xl-2,\r\n  .mx-xl-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-xl-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-xl-3,\r\n  .my-xl-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-xl-3,\r\n  .mx-xl-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-xl-3,\r\n  .my-xl-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-xl-3,\r\n  .mx-xl-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-xl-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-xl-4,\r\n  .my-xl-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-xl-4,\r\n  .mx-xl-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-xl-4,\r\n  .my-xl-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-xl-4,\r\n  .mx-xl-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-xl-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-xl-5,\r\n  .my-xl-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-xl-5,\r\n  .mx-xl-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-xl-5,\r\n  .my-xl-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-xl-5,\r\n  .mx-xl-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-xl--9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-xl--9,\r\n  .my-xl--9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-xl--9,\r\n  .mx-xl--9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-xl--9,\r\n  .my-xl--9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-xl--9,\r\n  .mx-xl--9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-xl--8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-xl--8,\r\n  .my-xl--8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-xl--8,\r\n  .mx-xl--8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-xl--8,\r\n  .my-xl--8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-xl--8,\r\n  .mx-xl--8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-xl--7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-xl--7,\r\n  .my-xl--7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-xl--7,\r\n  .mx-xl--7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-xl--7,\r\n  .my-xl--7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-xl--7,\r\n  .mx-xl--7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-xl--6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-xl--6,\r\n  .my-xl--6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-xl--6,\r\n  .mx-xl--6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-xl--6,\r\n  .my-xl--6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-xl--6,\r\n  .mx-xl--6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-xl--5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-xl--5,\r\n  .my-xl--5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-xl--5,\r\n  .mx-xl--5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-xl--5,\r\n  .my-xl--5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-xl--5,\r\n  .mx-xl--5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-xl--4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-xl--4,\r\n  .my-xl--4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-xl--4,\r\n  .mx-xl--4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-xl--4,\r\n  .my-xl--4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-xl--4,\r\n  .mx-xl--4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-xl--3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-xl--3,\r\n  .my-xl--3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-xl--3,\r\n  .mx-xl--3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-xl--3,\r\n  .my-xl--3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-xl--3,\r\n  .mx-xl--3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-xl--2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-xl--2,\r\n  .my-xl--2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-xl--2,\r\n  .mx-xl--2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-xl--2,\r\n  .my-xl--2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-xl--2,\r\n  .mx-xl--2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-xl--1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-xl--1,\r\n  .my-xl--1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-xl--1,\r\n  .mx-xl--1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-xl--1,\r\n  .my-xl--1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-xl--1,\r\n  .mx-xl--1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-xl-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-xl-6,\r\n  .my-xl-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-xl-6,\r\n  .mx-xl-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-xl-6,\r\n  .my-xl-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-xl-6,\r\n  .mx-xl-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-xl-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-xl-7,\r\n  .my-xl-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-xl-7,\r\n  .mx-xl-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-xl-7,\r\n  .my-xl-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-xl-7,\r\n  .mx-xl-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-xl-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-xl-8,\r\n  .my-xl-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-xl-8,\r\n  .mx-xl-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-xl-8,\r\n  .my-xl-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-xl-8,\r\n  .mx-xl-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-xl-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-xl-9,\r\n  .my-xl-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-xl-9,\r\n  .mx-xl-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-xl-9,\r\n  .my-xl-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-xl-9,\r\n  .mx-xl-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .p-xl-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-xl-0,\r\n  .py-xl-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-xl-0,\r\n  .px-xl-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-xl-0,\r\n  .py-xl-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-xl-0,\r\n  .px-xl-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-xl-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-xl-1,\r\n  .py-xl-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-xl-1,\r\n  .px-xl-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-xl-1,\r\n  .py-xl-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-xl-1,\r\n  .px-xl-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-xl-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-xl-2,\r\n  .py-xl-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-xl-2,\r\n  .px-xl-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-xl-2,\r\n  .py-xl-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-xl-2,\r\n  .px-xl-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-xl-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-xl-3,\r\n  .py-xl-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-xl-3,\r\n  .px-xl-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-xl-3,\r\n  .py-xl-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-xl-3,\r\n  .px-xl-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-xl-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-xl-4,\r\n  .py-xl-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-xl-4,\r\n  .px-xl-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-xl-4,\r\n  .py-xl-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-xl-4,\r\n  .px-xl-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-xl-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-xl-5,\r\n  .py-xl-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-xl-5,\r\n  .px-xl-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-xl-5,\r\n  .py-xl-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-xl-5,\r\n  .px-xl-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .p-xl--9 {\r\n    padding: -10rem !important;\r\n  }\r\n\r\n  .pt-xl--9,\r\n  .py-xl--9 {\r\n    padding-top: -10rem !important;\r\n  }\r\n\r\n  .pr-xl--9,\r\n  .px-xl--9 {\r\n    padding-right: -10rem !important;\r\n  }\r\n\r\n  .pb-xl--9,\r\n  .py-xl--9 {\r\n    padding-bottom: -10rem !important;\r\n  }\r\n\r\n  .pl-xl--9,\r\n  .px-xl--9 {\r\n    padding-left: -10rem !important;\r\n  }\r\n\r\n  .p-xl--8 {\r\n    padding: -8rem !important;\r\n  }\r\n\r\n  .pt-xl--8,\r\n  .py-xl--8 {\r\n    padding-top: -8rem !important;\r\n  }\r\n\r\n  .pr-xl--8,\r\n  .px-xl--8 {\r\n    padding-right: -8rem !important;\r\n  }\r\n\r\n  .pb-xl--8,\r\n  .py-xl--8 {\r\n    padding-bottom: -8rem !important;\r\n  }\r\n\r\n  .pl-xl--8,\r\n  .px-xl--8 {\r\n    padding-left: -8rem !important;\r\n  }\r\n\r\n  .p-xl--7 {\r\n    padding: -6rem !important;\r\n  }\r\n\r\n  .pt-xl--7,\r\n  .py-xl--7 {\r\n    padding-top: -6rem !important;\r\n  }\r\n\r\n  .pr-xl--7,\r\n  .px-xl--7 {\r\n    padding-right: -6rem !important;\r\n  }\r\n\r\n  .pb-xl--7,\r\n  .py-xl--7 {\r\n    padding-bottom: -6rem !important;\r\n  }\r\n\r\n  .pl-xl--7,\r\n  .px-xl--7 {\r\n    padding-left: -6rem !important;\r\n  }\r\n\r\n  .p-xl--6 {\r\n    padding: -4.5rem !important;\r\n  }\r\n\r\n  .pt-xl--6,\r\n  .py-xl--6 {\r\n    padding-top: -4.5rem !important;\r\n  }\r\n\r\n  .pr-xl--6,\r\n  .px-xl--6 {\r\n    padding-right: -4.5rem !important;\r\n  }\r\n\r\n  .pb-xl--6,\r\n  .py-xl--6 {\r\n    padding-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .pl-xl--6,\r\n  .px-xl--6 {\r\n    padding-left: -4.5rem !important;\r\n  }\r\n\r\n  .p-xl--5 {\r\n    padding: -3rem !important;\r\n  }\r\n\r\n  .pt-xl--5,\r\n  .py-xl--5 {\r\n    padding-top: -3rem !important;\r\n  }\r\n\r\n  .pr-xl--5,\r\n  .px-xl--5 {\r\n    padding-right: -3rem !important;\r\n  }\r\n\r\n  .pb-xl--5,\r\n  .py-xl--5 {\r\n    padding-bottom: -3rem !important;\r\n  }\r\n\r\n  .pl-xl--5,\r\n  .px-xl--5 {\r\n    padding-left: -3rem !important;\r\n  }\r\n\r\n  .p-xl--4 {\r\n    padding: -1.5rem !important;\r\n  }\r\n\r\n  .pt-xl--4,\r\n  .py-xl--4 {\r\n    padding-top: -1.5rem !important;\r\n  }\r\n\r\n  .pr-xl--4,\r\n  .px-xl--4 {\r\n    padding-right: -1.5rem !important;\r\n  }\r\n\r\n  .pb-xl--4,\r\n  .py-xl--4 {\r\n    padding-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .pl-xl--4,\r\n  .px-xl--4 {\r\n    padding-left: -1.5rem !important;\r\n  }\r\n\r\n  .p-xl--3 {\r\n    padding: -1rem !important;\r\n  }\r\n\r\n  .pt-xl--3,\r\n  .py-xl--3 {\r\n    padding-top: -1rem !important;\r\n  }\r\n\r\n  .pr-xl--3,\r\n  .px-xl--3 {\r\n    padding-right: -1rem !important;\r\n  }\r\n\r\n  .pb-xl--3,\r\n  .py-xl--3 {\r\n    padding-bottom: -1rem !important;\r\n  }\r\n\r\n  .pl-xl--3,\r\n  .px-xl--3 {\r\n    padding-left: -1rem !important;\r\n  }\r\n\r\n  .p-xl--2 {\r\n    padding: -0.5rem !important;\r\n  }\r\n\r\n  .pt-xl--2,\r\n  .py-xl--2 {\r\n    padding-top: -0.5rem !important;\r\n  }\r\n\r\n  .pr-xl--2,\r\n  .px-xl--2 {\r\n    padding-right: -0.5rem !important;\r\n  }\r\n\r\n  .pb-xl--2,\r\n  .py-xl--2 {\r\n    padding-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .pl-xl--2,\r\n  .px-xl--2 {\r\n    padding-left: -0.5rem !important;\r\n  }\r\n\r\n  .p-xl--1 {\r\n    padding: -0.25rem !important;\r\n  }\r\n\r\n  .pt-xl--1,\r\n  .py-xl--1 {\r\n    padding-top: -0.25rem !important;\r\n  }\r\n\r\n  .pr-xl--1,\r\n  .px-xl--1 {\r\n    padding-right: -0.25rem !important;\r\n  }\r\n\r\n  .pb-xl--1,\r\n  .py-xl--1 {\r\n    padding-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .pl-xl--1,\r\n  .px-xl--1 {\r\n    padding-left: -0.25rem !important;\r\n  }\r\n\r\n  .p-xl-6 {\r\n    padding: 4.5rem !important;\r\n  }\r\n\r\n  .pt-xl-6,\r\n  .py-xl-6 {\r\n    padding-top: 4.5rem !important;\r\n  }\r\n\r\n  .pr-xl-6,\r\n  .px-xl-6 {\r\n    padding-right: 4.5rem !important;\r\n  }\r\n\r\n  .pb-xl-6,\r\n  .py-xl-6 {\r\n    padding-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .pl-xl-6,\r\n  .px-xl-6 {\r\n    padding-left: 4.5rem !important;\r\n  }\r\n\r\n  .p-xl-7 {\r\n    padding: 6rem !important;\r\n  }\r\n\r\n  .pt-xl-7,\r\n  .py-xl-7 {\r\n    padding-top: 6rem !important;\r\n  }\r\n\r\n  .pr-xl-7,\r\n  .px-xl-7 {\r\n    padding-right: 6rem !important;\r\n  }\r\n\r\n  .pb-xl-7,\r\n  .py-xl-7 {\r\n    padding-bottom: 6rem !important;\r\n  }\r\n\r\n  .pl-xl-7,\r\n  .px-xl-7 {\r\n    padding-left: 6rem !important;\r\n  }\r\n\r\n  .p-xl-8 {\r\n    padding: 8rem !important;\r\n  }\r\n\r\n  .pt-xl-8,\r\n  .py-xl-8 {\r\n    padding-top: 8rem !important;\r\n  }\r\n\r\n  .pr-xl-8,\r\n  .px-xl-8 {\r\n    padding-right: 8rem !important;\r\n  }\r\n\r\n  .pb-xl-8,\r\n  .py-xl-8 {\r\n    padding-bottom: 8rem !important;\r\n  }\r\n\r\n  .pl-xl-8,\r\n  .px-xl-8 {\r\n    padding-left: 8rem !important;\r\n  }\r\n\r\n  .p-xl-9 {\r\n    padding: 10rem !important;\r\n  }\r\n\r\n  .pt-xl-9,\r\n  .py-xl-9 {\r\n    padding-top: 10rem !important;\r\n  }\r\n\r\n  .pr-xl-9,\r\n  .px-xl-9 {\r\n    padding-right: 10rem !important;\r\n  }\r\n\r\n  .pb-xl-9,\r\n  .py-xl-9 {\r\n    padding-bottom: 10rem !important;\r\n  }\r\n\r\n  .pl-xl-9,\r\n  .px-xl-9 {\r\n    padding-left: 10rem !important;\r\n  }\r\n\r\n  .m-xl-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-xl-n1,\r\n  .my-xl-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-xl-n1,\r\n  .mx-xl-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-xl-n1,\r\n  .my-xl-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-xl-n1,\r\n  .mx-xl-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-xl-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n2,\r\n  .my-xl-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n2,\r\n  .mx-xl-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n2,\r\n  .my-xl-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n2,\r\n  .mx-xl-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-xl-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-xl-n3,\r\n  .my-xl-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-xl-n3,\r\n  .mx-xl-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-xl-n3,\r\n  .my-xl-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-xl-n3,\r\n  .mx-xl-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-xl-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n4,\r\n  .my-xl-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n4,\r\n  .mx-xl-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n4,\r\n  .my-xl-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n4,\r\n  .mx-xl-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-xl-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-xl-n5,\r\n  .my-xl-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-xl-n5,\r\n  .mx-xl-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-xl-n5,\r\n  .my-xl-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-xl-n5,\r\n  .mx-xl-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-xl-n-9 {\r\n    margin: 10rem !important;\r\n  }\r\n\r\n  .mt-xl-n-9,\r\n  .my-xl-n-9 {\r\n    margin-top: 10rem !important;\r\n  }\r\n\r\n  .mr-xl-n-9,\r\n  .mx-xl-n-9 {\r\n    margin-right: 10rem !important;\r\n  }\r\n\r\n  .mb-xl-n-9,\r\n  .my-xl-n-9 {\r\n    margin-bottom: 10rem !important;\r\n  }\r\n\r\n  .ml-xl-n-9,\r\n  .mx-xl-n-9 {\r\n    margin-left: 10rem !important;\r\n  }\r\n\r\n  .m-xl-n-8 {\r\n    margin: 8rem !important;\r\n  }\r\n\r\n  .mt-xl-n-8,\r\n  .my-xl-n-8 {\r\n    margin-top: 8rem !important;\r\n  }\r\n\r\n  .mr-xl-n-8,\r\n  .mx-xl-n-8 {\r\n    margin-right: 8rem !important;\r\n  }\r\n\r\n  .mb-xl-n-8,\r\n  .my-xl-n-8 {\r\n    margin-bottom: 8rem !important;\r\n  }\r\n\r\n  .ml-xl-n-8,\r\n  .mx-xl-n-8 {\r\n    margin-left: 8rem !important;\r\n  }\r\n\r\n  .m-xl-n-7 {\r\n    margin: 6rem !important;\r\n  }\r\n\r\n  .mt-xl-n-7,\r\n  .my-xl-n-7 {\r\n    margin-top: 6rem !important;\r\n  }\r\n\r\n  .mr-xl-n-7,\r\n  .mx-xl-n-7 {\r\n    margin-right: 6rem !important;\r\n  }\r\n\r\n  .mb-xl-n-7,\r\n  .my-xl-n-7 {\r\n    margin-bottom: 6rem !important;\r\n  }\r\n\r\n  .ml-xl-n-7,\r\n  .mx-xl-n-7 {\r\n    margin-left: 6rem !important;\r\n  }\r\n\r\n  .m-xl-n-6 {\r\n    margin: 4.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n-6,\r\n  .my-xl-n-6 {\r\n    margin-top: 4.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n-6,\r\n  .mx-xl-n-6 {\r\n    margin-right: 4.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n-6,\r\n  .my-xl-n-6 {\r\n    margin-bottom: 4.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n-6,\r\n  .mx-xl-n-6 {\r\n    margin-left: 4.5rem !important;\r\n  }\r\n\r\n  .m-xl-n-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-xl-n-5,\r\n  .my-xl-n-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-xl-n-5,\r\n  .mx-xl-n-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-xl-n-5,\r\n  .my-xl-n-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-xl-n-5,\r\n  .mx-xl-n-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .m-xl-n-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n-4,\r\n  .my-xl-n-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n-4,\r\n  .mx-xl-n-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n-4,\r\n  .my-xl-n-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n-4,\r\n  .mx-xl-n-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-xl-n-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-xl-n-3,\r\n  .my-xl-n-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-xl-n-3,\r\n  .mx-xl-n-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-xl-n-3,\r\n  .my-xl-n-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-xl-n-3,\r\n  .mx-xl-n-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-xl-n-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n-2,\r\n  .my-xl-n-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n-2,\r\n  .mx-xl-n-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n-2,\r\n  .my-xl-n-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n-2,\r\n  .mx-xl-n-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-xl-n-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-xl-n-1,\r\n  .my-xl-n-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-xl-n-1,\r\n  .mx-xl-n-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-xl-n-1,\r\n  .my-xl-n-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-xl-n-1,\r\n  .mx-xl-n-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-xl-n6 {\r\n    margin: -4.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n6,\r\n  .my-xl-n6 {\r\n    margin-top: -4.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n6,\r\n  .mx-xl-n6 {\r\n    margin-right: -4.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n6,\r\n  .my-xl-n6 {\r\n    margin-bottom: -4.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n6,\r\n  .mx-xl-n6 {\r\n    margin-left: -4.5rem !important;\r\n  }\r\n\r\n  .m-xl-n7 {\r\n    margin: -6rem !important;\r\n  }\r\n\r\n  .mt-xl-n7,\r\n  .my-xl-n7 {\r\n    margin-top: -6rem !important;\r\n  }\r\n\r\n  .mr-xl-n7,\r\n  .mx-xl-n7 {\r\n    margin-right: -6rem !important;\r\n  }\r\n\r\n  .mb-xl-n7,\r\n  .my-xl-n7 {\r\n    margin-bottom: -6rem !important;\r\n  }\r\n\r\n  .ml-xl-n7,\r\n  .mx-xl-n7 {\r\n    margin-left: -6rem !important;\r\n  }\r\n\r\n  .m-xl-n8 {\r\n    margin: -8rem !important;\r\n  }\r\n\r\n  .mt-xl-n8,\r\n  .my-xl-n8 {\r\n    margin-top: -8rem !important;\r\n  }\r\n\r\n  .mr-xl-n8,\r\n  .mx-xl-n8 {\r\n    margin-right: -8rem !important;\r\n  }\r\n\r\n  .mb-xl-n8,\r\n  .my-xl-n8 {\r\n    margin-bottom: -8rem !important;\r\n  }\r\n\r\n  .ml-xl-n8,\r\n  .mx-xl-n8 {\r\n    margin-left: -8rem !important;\r\n  }\r\n\r\n  .m-xl-n9 {\r\n    margin: -10rem !important;\r\n  }\r\n\r\n  .mt-xl-n9,\r\n  .my-xl-n9 {\r\n    margin-top: -10rem !important;\r\n  }\r\n\r\n  .mr-xl-n9,\r\n  .mx-xl-n9 {\r\n    margin-right: -10rem !important;\r\n  }\r\n\r\n  .mb-xl-n9,\r\n  .my-xl-n9 {\r\n    margin-bottom: -10rem !important;\r\n  }\r\n\r\n  .ml-xl-n9,\r\n  .mx-xl-n9 {\r\n    margin-left: -10rem !important;\r\n  }\r\n\r\n  .m-xl-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-xl-auto,\r\n  .my-xl-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-xl-auto,\r\n  .mx-xl-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-xl-auto,\r\n  .my-xl-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-xl-auto,\r\n  .mx-xl-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n.stretched-link::after {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  pointer-events: auto;\r\n  content: \"\";\r\n  background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.text-monospace {\r\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\r\n    \"Courier New\", monospace !important;\r\n}\r\n\r\n.text-justify {\r\n  text-align: justify !important;\r\n}\r\n\r\n.text-wrap {\r\n  white-space: normal !important;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.text-truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.text-left {\r\n  text-align: left !important;\r\n}\r\n\r\n.text-right {\r\n  text-align: right !important;\r\n}\r\n\r\n.text-center {\r\n  text-align: center !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .text-sm-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-sm-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-sm-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .text-md-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-md-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-md-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .text-lg-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-lg-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-lg-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .text-xl-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-xl-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-xl-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n.text-lowercase {\r\n  text-transform: lowercase !important;\r\n}\r\n\r\n.text-uppercase {\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.text-capitalize {\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n.font-weight-light {\r\n  font-weight: 300 !important;\r\n}\r\n\r\n.font-weight-lighter {\r\n  font-weight: lighter !important;\r\n}\r\n\r\n.font-weight-normal {\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.font-weight-bold {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.font-weight-bolder {\r\n  font-weight: bolder !important;\r\n}\r\n\r\n.font-italic {\r\n  font-style: italic !important;\r\n}\r\n\r\n.text-white {\r\n  color: #fff !important;\r\n}\r\n\r\n.text-primary {\r\n  color: #5e72e4 !important;\r\n}\r\n\r\na.text-primary:hover,\r\na.text-primary:focus {\r\n  color: #233dd2 !important;\r\n}\r\n\r\n.text-secondary {\r\n  color: #f7fafc !important;\r\n}\r\n\r\na.text-secondary:hover,\r\na.text-secondary:focus {\r\n  color: #bfd7e7 !important;\r\n}\r\n\r\n.text-success {\r\n  color: #2dce89 !important;\r\n}\r\n\r\na.text-success:hover,\r\na.text-success:focus {\r\n  color: #1f8f5f !important;\r\n}\r\n\r\n.text-info {\r\n  color: #11cdef !important;\r\n}\r\n\r\na.text-info:hover,\r\na.text-info:focus {\r\n  color: #0b90a8 !important;\r\n}\r\n\r\n.text-warning {\r\n  color: #fb6340 !important;\r\n}\r\n\r\na.text-warning:hover,\r\na.text-warning:focus {\r\n  color: #ea3005 !important;\r\n}\r\n\r\n.text-danger {\r\n  color: #f5365c !important;\r\n}\r\n\r\na.text-danger:hover,\r\na.text-danger:focus {\r\n  color: #d40b33 !important;\r\n}\r\n\r\n.text-light {\r\n  color: #adb5bd !important;\r\n}\r\n\r\na.text-light:hover,\r\na.text-light:focus {\r\n  color: #838f9b !important;\r\n}\r\n\r\n.text-dark {\r\n  color: #212529 !important;\r\n}\r\n\r\na.text-dark:hover,\r\na.text-dark:focus {\r\n  color: black !important;\r\n}\r\n\r\n.text-default {\r\n  color: #172b4d !important;\r\n}\r\n\r\na.text-default:hover,\r\na.text-default:focus {\r\n  color: #050a12 !important;\r\n}\r\n\r\n.text-white {\r\n  color: #fff !important;\r\n}\r\n\r\na.text-white:hover,\r\na.text-white:focus {\r\n  color: #d9d9d9 !important;\r\n}\r\n\r\n.text-neutral {\r\n  color: #fff !important;\r\n}\r\n\r\na.text-neutral:hover,\r\na.text-neutral:focus {\r\n  color: #d9d9d9 !important;\r\n}\r\n\r\n.text-darker {\r\n  color: black !important;\r\n}\r\n\r\na.text-darker:hover,\r\na.text-darker:focus {\r\n  color: black !important;\r\n}\r\n\r\n.text-body {\r\n  color: #525f7f !important;\r\n}\r\n\r\n.text-muted {\r\n  color: #8898aa !important;\r\n}\r\n\r\n.text-black-50 {\r\n  color: rgba(0, 0, 0, 0.5) !important;\r\n}\r\n\r\n.text-white-50 {\r\n  color: rgba(255, 255, 255, 0.5) !important;\r\n}\r\n\r\n.text-hide {\r\n  font: 0/0 a;\r\n  color: transparent;\r\n  text-shadow: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.text-decoration-none {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.text-break {\r\n  word-break: break-word !important;\r\n  word-wrap: break-word !important;\r\n}\r\n\r\n.text-reset {\r\n  color: inherit !important;\r\n}\r\n\r\n.visible {\r\n  visibility: visible !important;\r\n}\r\n\r\n.invisible {\r\n  visibility: hidden !important;\r\n}\r\n\r\n@keyframes spinner-border {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.spinner-border {\r\n  display: inline-block;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  vertical-align: text-bottom;\r\n  border: 0.25em solid currentColor;\r\n  border-right-color: transparent;\r\n  border-radius: 50%;\r\n  animation: 0.75s linear infinite spinner-border;\r\n}\r\n\r\n.spinner-border-sm {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  border-width: 0.2em;\r\n}\r\n\r\n@keyframes spinner-grow {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n\r\n  50% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.spinner-grow {\r\n  display: inline-block;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  vertical-align: text-bottom;\r\n  background-color: currentColor;\r\n  border-radius: 50%;\r\n  opacity: 0;\r\n  animation: 0.75s linear infinite spinner-grow;\r\n}\r\n\r\n.spinner-grow-sm {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .spinner-border,\r\n  .spinner-grow {\r\n    animation-duration: 1.5s;\r\n  }\r\n}\r\n\r\n@media print {\r\n\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    text-shadow: none !important;\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  a:not(.btn) {\r\n    text-decoration: underline;\r\n  }\r\n\r\n  abbr[title]::after {\r\n    content: \" (\" attr(title) \")\";\r\n  }\r\n\r\n  pre {\r\n    white-space: pre-wrap !important;\r\n  }\r\n\r\n  pre,\r\n  blockquote {\r\n    border: 1px solid #adb5bd;\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  thead {\r\n    display: table-header-group;\r\n  }\r\n\r\n  tr,\r\n  img {\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  p,\r\n  h2,\r\n  h3 {\r\n    orphans: 3;\r\n    widows: 3;\r\n  }\r\n\r\n  h2,\r\n  h3 {\r\n    page-break-after: avoid;\r\n  }\r\n\r\n  @page {\r\n    size: a3;\r\n  }\r\n\r\n  body {\r\n    min-width: 992px !important;\r\n  }\r\n\r\n  .container {\r\n    min-width: 992px !important;\r\n  }\r\n\r\n  .navbar {\r\n    display: none;\r\n  }\r\n\r\n  .badge {\r\n    border: 1px solid #000;\r\n  }\r\n\r\n  .table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  .table td,\r\n  .table th {\r\n    background-color: #fff !important;\r\n  }\r\n\r\n  .table-bordered th,\r\n  .table-bordered td {\r\n    border: 1px solid #dee2e6 !important;\r\n  }\r\n\r\n  .table-dark {\r\n    color: inherit;\r\n  }\r\n\r\n  .table-dark th,\r\n  .table-dark td,\r\n  .table-dark thead th,\r\n  .table-dark tbody+tbody {\r\n    border-color: #e9ecef;\r\n  }\r\n\r\n  .table .thead-dark th {\r\n    color: inherit;\r\n    border-color: #e9ecef;\r\n  }\r\n}\r\n\r\n.alert {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.alert-heading {\r\n  font-weight: 600;\r\n  font-size: 0.9375rem;\r\n  margin-top: 0.15rem;\r\n}\r\n\r\n.alert-icon {\r\n  font-size: 1.25rem;\r\n  margin-right: 1.25rem;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.alert-icon i.ni {\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n.alert-text {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n[class*=\"alert-\"] .alert-link {\r\n  color: #fff;\r\n  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.alert-dismissible .close {\r\n  top: 50%;\r\n  right: 1.5rem;\r\n  transform: translateY(-50%);\r\n  padding: 0;\r\n  opacity: 1;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .alert-dismissible .close {\r\n    top: 1rem;\r\n    right: 0.5rem;\r\n  }\r\n}\r\n\r\n.alert-dismissible .close>span:not(.sr-only) {\r\n  font-size: 1.5rem;\r\n  background-color: transparent;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.alert-dismissible .close:hover>span:not(.sr-only),\r\n.alert-dismissible .close:focus>span:not(.sr-only) {\r\n  background-color: transparent;\r\n  color: white;\r\n}\r\n\r\n.alert-secondary .close>span:not(.sr-only) {\r\n  color: rgba(23, 43, 77, 0.6);\r\n}\r\n\r\n.alert-secondary .close:hover>span:not(.sr-only),\r\n.alert-secondary .close:focus>span:not(.sr-only) {\r\n  color: #172b4d;\r\n}\r\n\r\n.alert-notify {\r\n  display: flex !important;\r\n  max-width: 600px;\r\n  width: calc(100% - 30px);\r\n  padding-right: 80px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);\r\n  color: rgba(255, 255, 255, 0.85);\r\n}\r\n\r\n.alert-notify:hover {\r\n  z-index: 1081 !important;\r\n}\r\n\r\n.alert-notify:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) {\r\n  background-color: rgba(0, 0, 0, 0.95);\r\n}\r\n\r\n.alert-notify:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close {\r\n  color: #ffd600;\r\n}\r\n\r\n.alert-notify:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.alert-notify .alert-icon.ni {\r\n  position: relative;\r\n  top: 4px;\r\n}\r\n\r\n.alert-notify .alert-title {\r\n  display: block;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-notify .close {\r\n  top: 1rem !important;\r\n  right: 1.5rem !important;\r\n  transform: translateY(0);\r\n}\r\n\r\n.avatar {\r\n  color: #fff;\r\n  background-color: #adb5bd;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1rem;\r\n  border-radius: 0.375rem;\r\n  height: 48px;\r\n  width: 48px;\r\n}\r\n\r\n.avatar img {\r\n  width: 100%;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.avatar+.avatar-content {\r\n  display: inline-block;\r\n  margin-left: 0.75rem;\r\n}\r\n\r\n.avatar-xl {\r\n  width: 74px;\r\n  height: 74px;\r\n}\r\n\r\n.avatar-lg {\r\n  width: 58px;\r\n  height: 58px;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.avatar-sm {\r\n  width: 36px;\r\n  height: 36px;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.avatar-xs {\r\n  width: 24px;\r\n  height: 24px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.avatar-group .avatar {\r\n  position: relative;\r\n  z-index: 2;\r\n  border: 2px solid #fff;\r\n}\r\n\r\n.avatar-group .avatar:hover {\r\n  z-index: 3;\r\n}\r\n\r\n.avatar-group .avatar+.avatar {\r\n  margin-left: -1rem;\r\n}\r\n\r\n.badge {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.badge a {\r\n  color: #fff;\r\n}\r\n\r\n.badge-md {\r\n  padding: 0.65em 1em;\r\n}\r\n\r\n.badge-lg {\r\n  padding: 0.85em 1.375em;\r\n}\r\n\r\n.badge-inline {\r\n  margin-right: 0.625rem;\r\n}\r\n\r\n.badge-inline+span {\r\n  top: 2px;\r\n  position: relative;\r\n}\r\n\r\n.badge-inline+span>a {\r\n  text-decoration: underline;\r\n}\r\n\r\n.badge-default {\r\n  color: #fff;\r\n}\r\n\r\n.badge-secondary {\r\n  background-color: #f7fafc;\r\n  color: #212529;\r\n}\r\n\r\n.btn .badge:not(:first-child) {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.btn .badge:not(:last-child) {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.badge-circle {\r\n  text-align: center;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  padding: 0 !important;\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.badge-circle.badge-md {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n}\r\n\r\n.badge-circle.badge-lg {\r\n  width: 2rem;\r\n  height: 2rem;\r\n}\r\n\r\n.badge-dot {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n  background: transparent;\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  text-transform: none;\r\n}\r\n\r\n.badge-dot strong {\r\n  color: #32325d;\r\n}\r\n\r\n.badge-dot i {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  width: 0.375rem;\r\n  height: 0.375rem;\r\n  border-radius: 50%;\r\n  margin-right: 0.375rem;\r\n}\r\n\r\n.badge-dot.badge-md i {\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n}\r\n\r\n.badge-dot.badge-lg i {\r\n  width: 0.625rem;\r\n  height: 0.625rem;\r\n}\r\n\r\n.btn .badge-floating {\r\n  position: absolute;\r\n  top: -50%;\r\n  transform: translateY(50%);\r\n  border: 3px solid;\r\n}\r\n\r\n.btn .badge-floating.badge:not(.badge-circle) {\r\n  transform: translate(147%, 50%);\r\n}\r\n\r\n.breadcrumb-item {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.breadcrumb-dark {\r\n  background-color: #172b4d;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item {\r\n  font-weight: 600;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item a {\r\n  color: #f6f9fc;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item+.breadcrumb-item::before {\r\n  color: #adb5bd;\r\n}\r\n\r\n.breadcrumb-dark .breadcrumb-item.active {\r\n  color: #f8f9fa;\r\n}\r\n\r\n.breadcrumb-links {\r\n  padding: 0;\r\n  margin: 0;\r\n  background: transparent;\r\n}\r\n\r\n.btn {\r\n  position: relative;\r\n  text-transform: none;\r\n  transition: all 0.15s ease;\r\n  letter-spacing: 0.025em;\r\n  font-size: 0.875rem;\r\n  will-change: transform;\r\n}\r\n\r\n.btn:hover {\r\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn:not(:last-child) {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.btn i:not(:first-child),\r\n.btn svg:not(:first-child) {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.btn i:not(:last-child),\r\n.btn svg:not(:last-child) {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.btn-group .btn,\r\n.input-group .btn {\r\n  margin-right: 0;\r\n  transform: translateY(0);\r\n}\r\n\r\n.btn-sm,\r\n.btn-group-sm>.btn {\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.btn-lg,\r\n.btn-group-lg>.btn {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n[class*=\"btn-outline-\"] {\r\n  border-width: 1px;\r\n}\r\n\r\n.btn-outline-secondary {\r\n  color: #4385b1;\r\n}\r\n\r\n.btn-inner--icon i:not(.fas):not(.fab) {\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n.btn-link {\r\n  font-weight: 600;\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-link:hover {\r\n  box-shadow: none;\r\n  transform: none;\r\n}\r\n\r\n.btn-neutral {\r\n  color: #5e72e4;\r\n}\r\n\r\n.btn-facebook {\r\n  color: #fff;\r\n  background-color: #3b5999;\r\n  border-color: #3b5999;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-facebook:hover {\r\n  color: #fff;\r\n  background-color: #3b5999;\r\n  border-color: #3b5999;\r\n}\r\n\r\n.btn-facebook:focus,\r\n.btn-facebook.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(59, 89, 153, 0.5);\r\n}\r\n\r\n.btn-facebook.disabled,\r\n.btn-facebook:disabled {\r\n  color: #fff;\r\n  background-color: #3b5999;\r\n  border-color: #3b5999;\r\n}\r\n\r\n.btn-facebook:not(:disabled):not(.disabled):active,\r\n.btn-facebook:not(:disabled):not(.disabled).active,\r\n.show>.btn-facebook.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #2d4474;\r\n  border-color: #3b5999;\r\n}\r\n\r\n.btn-facebook:not(:disabled):not(.disabled):active:focus,\r\n.btn-facebook:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-facebook.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);\r\n}\r\n\r\n.btn-twitter {\r\n  color: #fff;\r\n  background-color: #1da1f2;\r\n  border-color: #1da1f2;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-twitter:hover {\r\n  color: #fff;\r\n  background-color: #1da1f2;\r\n  border-color: #1da1f2;\r\n}\r\n\r\n.btn-twitter:focus,\r\n.btn-twitter.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(29, 161, 242, 0.5);\r\n}\r\n\r\n.btn-twitter.disabled,\r\n.btn-twitter:disabled {\r\n  color: #fff;\r\n  background-color: #1da1f2;\r\n  border-color: #1da1f2;\r\n}\r\n\r\n.btn-twitter:not(:disabled):not(.disabled):active,\r\n.btn-twitter:not(:disabled):not(.disabled).active,\r\n.show>.btn-twitter.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #0c85d0;\r\n  border-color: #1da1f2;\r\n}\r\n\r\n.btn-twitter:not(:disabled):not(.disabled):active:focus,\r\n.btn-twitter:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-twitter.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);\r\n}\r\n\r\n.btn-google-plus {\r\n  color: #fff;\r\n  background-color: #dd4b39;\r\n  border-color: #dd4b39;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-google-plus:hover {\r\n  color: #fff;\r\n  background-color: #dd4b39;\r\n  border-color: #dd4b39;\r\n}\r\n\r\n.btn-google-plus:focus,\r\n.btn-google-plus.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(221, 75, 57, 0.5);\r\n}\r\n\r\n.btn-google-plus.disabled,\r\n.btn-google-plus:disabled {\r\n  color: #fff;\r\n  background-color: #dd4b39;\r\n  border-color: #dd4b39;\r\n}\r\n\r\n.btn-google-plus:not(:disabled):not(.disabled):active,\r\n.btn-google-plus:not(:disabled):not(.disabled).active,\r\n.show>.btn-google-plus.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #c23321;\r\n  border-color: #dd4b39;\r\n}\r\n\r\n.btn-google-plus:not(:disabled):not(.disabled):active:focus,\r\n.btn-google-plus:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-google-plus.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);\r\n}\r\n\r\n.btn-instagram {\r\n  color: #fff;\r\n  background-color: #e4405f;\r\n  border-color: #e4405f;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-instagram:hover {\r\n  color: #fff;\r\n  background-color: #e4405f;\r\n  border-color: #e4405f;\r\n}\r\n\r\n.btn-instagram:focus,\r\n.btn-instagram.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(228, 64, 95, 0.5);\r\n}\r\n\r\n.btn-instagram.disabled,\r\n.btn-instagram:disabled {\r\n  color: #fff;\r\n  background-color: #e4405f;\r\n  border-color: #e4405f;\r\n}\r\n\r\n.btn-instagram:not(:disabled):not(.disabled):active,\r\n.btn-instagram:not(:disabled):not(.disabled).active,\r\n.show>.btn-instagram.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #d31e40;\r\n  border-color: #e4405f;\r\n}\r\n\r\n.btn-instagram:not(:disabled):not(.disabled):active:focus,\r\n.btn-instagram:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-instagram.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);\r\n}\r\n\r\n.btn-pinterest {\r\n  color: #fff;\r\n  background-color: #bd081c;\r\n  border-color: #bd081c;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-pinterest:hover {\r\n  color: #fff;\r\n  background-color: #bd081c;\r\n  border-color: #bd081c;\r\n}\r\n\r\n.btn-pinterest:focus,\r\n.btn-pinterest.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(189, 8, 28, 0.5);\r\n}\r\n\r\n.btn-pinterest.disabled,\r\n.btn-pinterest:disabled {\r\n  color: #fff;\r\n  background-color: #bd081c;\r\n  border-color: #bd081c;\r\n}\r\n\r\n.btn-pinterest:not(:disabled):not(.disabled):active,\r\n.btn-pinterest:not(:disabled):not(.disabled).active,\r\n.show>.btn-pinterest.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #8c0615;\r\n  border-color: #bd081c;\r\n}\r\n\r\n.btn-pinterest:not(:disabled):not(.disabled):active:focus,\r\n.btn-pinterest:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-pinterest.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);\r\n}\r\n\r\n.btn-youtube {\r\n  color: #fff;\r\n  background-color: #cd201f;\r\n  border-color: #cd201f;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-youtube:hover {\r\n  color: #fff;\r\n  background-color: #cd201f;\r\n  border-color: #cd201f;\r\n}\r\n\r\n.btn-youtube:focus,\r\n.btn-youtube.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(205, 32, 31, 0.5);\r\n}\r\n\r\n.btn-youtube.disabled,\r\n.btn-youtube:disabled {\r\n  color: #fff;\r\n  background-color: #cd201f;\r\n  border-color: #cd201f;\r\n}\r\n\r\n.btn-youtube:not(:disabled):not(.disabled):active,\r\n.btn-youtube:not(:disabled):not(.disabled).active,\r\n.show>.btn-youtube.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #a11918;\r\n  border-color: #cd201f;\r\n}\r\n\r\n.btn-youtube:not(:disabled):not(.disabled):active:focus,\r\n.btn-youtube:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-youtube.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);\r\n}\r\n\r\n.btn-slack {\r\n  color: #fff;\r\n  background-color: #3aaf85;\r\n  border-color: #3aaf85;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-slack:hover {\r\n  color: #fff;\r\n  background-color: #3aaf85;\r\n  border-color: #3aaf85;\r\n}\r\n\r\n.btn-slack:focus,\r\n.btn-slack.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(58, 175, 133, 0.5);\r\n}\r\n\r\n.btn-slack.disabled,\r\n.btn-slack:disabled {\r\n  color: #fff;\r\n  background-color: #3aaf85;\r\n  border-color: #3aaf85;\r\n}\r\n\r\n.btn-slack:not(:disabled):not(.disabled):active,\r\n.btn-slack:not(:disabled):not(.disabled).active,\r\n.show>.btn-slack.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #2d8968;\r\n  border-color: #3aaf85;\r\n}\r\n\r\n.btn-slack:not(:disabled):not(.disabled):active:focus,\r\n.btn-slack:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-slack.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);\r\n}\r\n\r\n.btn-dribbble {\r\n  color: #fff;\r\n  background-color: #ea4c89;\r\n  border-color: #ea4c89;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-dribbble:hover {\r\n  color: #fff;\r\n  background-color: #ea4c89;\r\n  border-color: #ea4c89;\r\n}\r\n\r\n.btn-dribbble:focus,\r\n.btn-dribbble.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(234, 76, 137, 0.5);\r\n}\r\n\r\n.btn-dribbble.disabled,\r\n.btn-dribbble:disabled {\r\n  color: #fff;\r\n  background-color: #ea4c89;\r\n  border-color: #ea4c89;\r\n}\r\n\r\n.btn-dribbble:not(:disabled):not(.disabled):active,\r\n.btn-dribbble:not(:disabled):not(.disabled).active,\r\n.show>.btn-dribbble.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #e51e6b;\r\n  border-color: #ea4c89;\r\n}\r\n\r\n.btn-dribbble:not(:disabled):not(.disabled):active:focus,\r\n.btn-dribbble:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-dribbble.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);\r\n}\r\n\r\n.btn-github {\r\n  color: #fff;\r\n  background-color: #222222;\r\n  border-color: #222222;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-github:hover {\r\n  color: #fff;\r\n  background-color: #222222;\r\n  border-color: #222222;\r\n}\r\n\r\n.btn-github:focus,\r\n.btn-github.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(34, 34, 34, 0.5);\r\n}\r\n\r\n.btn-github.disabled,\r\n.btn-github:disabled {\r\n  color: #fff;\r\n  background-color: #222222;\r\n  border-color: #222222;\r\n}\r\n\r\n.btn-github:not(:disabled):not(.disabled):active,\r\n.btn-github:not(:disabled):not(.disabled).active,\r\n.show>.btn-github.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #090909;\r\n  border-color: #222222;\r\n}\r\n\r\n.btn-github:not(:disabled):not(.disabled):active:focus,\r\n.btn-github:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-github.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);\r\n}\r\n\r\n.btn-vimeo {\r\n  color: #fff;\r\n  background-color: #04a0f0;\r\n  border-color: #04a0f0;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.btn-vimeo:hover {\r\n  color: #fff;\r\n  background-color: #04a0f0;\r\n  border-color: #04a0f0;\r\n}\r\n\r\n.btn-vimeo:focus,\r\n.btn-vimeo.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(4, 160, 240, 0.5);\r\n}\r\n\r\n.btn-vimeo.disabled,\r\n.btn-vimeo:disabled {\r\n  color: #fff;\r\n  background-color: #04a0f0;\r\n  border-color: #04a0f0;\r\n}\r\n\r\n.btn-vimeo:not(:disabled):not(.disabled):active,\r\n.btn-vimeo:not(:disabled):not(.disabled).active,\r\n.show>.btn-vimeo.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #037fbe;\r\n  border-color: #04a0f0;\r\n}\r\n\r\n.btn-vimeo:not(:disabled):not(.disabled):active:focus,\r\n.btn-vimeo:not(:disabled):not(.disabled).active:focus,\r\n.show>.btn-vimeo.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(4, 160, 240, 0.5);\r\n}\r\n\r\n.btn-group .btn {\r\n  box-shadow: none;\r\n}\r\n\r\n[data-toggle=\"buttons\"]:not(.btn-group-colors)>.btn {\r\n  background-color: #f6f9fc;\r\n  cursor: pointer;\r\n  box-shadow: none;\r\n  border: 0;\r\n  margin: 0;\r\n}\r\n\r\n[data-toggle=\"buttons\"]:not(.btn-group-colors)>.btn:not(.active) {\r\n  color: #525f7f;\r\n}\r\n\r\n[data-toggle=\"buttons\"]:not(.btn-group-colors)>.btn.active {\r\n  background-color: #5e72e4;\r\n  color: #fff;\r\n}\r\n\r\n.btn-group-colors>.btn {\r\n  box-shadow: none;\r\n  border-radius: 50% !important;\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  margin-right: 0.5rem;\r\n  margin-bottom: 0.25rem;\r\n  position: relative;\r\n}\r\n\r\n.btn-group-colors>.btn:not([class*=\"bg-\"]) {\r\n  border-color: #f6f9fc !important;\r\n}\r\n\r\n.btn-group-colors>.btn:before {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  line-height: 28px;\r\n  color: #fff;\r\n  transform: scale(0);\r\n  opacity: 0;\r\n  content: \"\";\r\n  font-family: NucleoIcons, sans-serif;\r\n  font-size: 14px;\r\n  transition: transform 200ms, opacity 200ms;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .btn-group-colors>.btn:before {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.btn-group-colors>.btn.btn:not([class*=\"bg-\"]) {\r\n  border: 1px solid #cfd5db;\r\n}\r\n\r\n.btn-group-colors>.btn.btn:not([class*=\"bg-\"]):before {\r\n  color: #525f7f;\r\n}\r\n\r\n.btn-group-colors>.btn.active:before {\r\n  transform: scale(1);\r\n  opacity: 1;\r\n}\r\n\r\n.btn-icon .btn-inner--icon img {\r\n  width: 20px;\r\n}\r\n\r\n.btn-icon .btn-inner--text:not(:first-child) {\r\n  margin-left: 0.75em;\r\n}\r\n\r\n.btn-icon .btn-inner--text:not(:last-child) {\r\n  margin-right: 0.75em;\r\n}\r\n\r\n.btn-icon-only {\r\n  width: 2.375rem;\r\n  height: 2.375rem;\r\n  padding: 0;\r\n}\r\n\r\na.btn-icon-only {\r\n  line-height: 2.5;\r\n}\r\n\r\n.btn-icon-only.btn-sm,\r\n.btn-group-sm>.btn-icon-only.btn {\r\n  width: 2rem;\r\n  height: 2rem;\r\n}\r\n\r\n.btn-icon-clipboard {\r\n  margin: 0;\r\n  padding: 1.5rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.25;\r\n  color: #32325d;\r\n  background-color: #f6f9fc;\r\n  border-radius: 0.375rem;\r\n  border: 0;\r\n  text-align: left;\r\n  font-family: inherit;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  text-decoration: none;\r\n  -moz-appearance: none;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  margin: 0.5rem 0;\r\n}\r\n\r\n.btn-icon-clipboard:hover {\r\n  background-color: #fff;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;\r\n}\r\n\r\n.btn-icon-clipboard>div {\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n\r\n.btn-icon-clipboard i {\r\n  box-sizing: content-box;\r\n  color: #5e72e4;\r\n  vertical-align: middle;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.btn-icon-clipboard span {\r\n  display: inline-block;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  margin-left: 16px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  vertical-align: middle;\r\n}\r\n\r\n.card {\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\r\n  border: 0;\r\n}\r\n\r\n.card-translucent {\r\n  background-color: rgba(18, 91, 152, 0.08);\r\n}\r\n\r\n.card-deck .card {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.card.shadow {\r\n  border: 0 !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-columns {\r\n    column-count: 1;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .card-columns {\r\n    column-count: 2;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .card-columns {\r\n    column-count: 3;\r\n    column-gap: 1.25rem;\r\n  }\r\n}\r\n\r\n.card-lift--hover:hover {\r\n  transform: translateY(-20px);\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .card-lift--hover:hover {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.card-blockquote {\r\n  padding: 2rem;\r\n  position: relative;\r\n}\r\n\r\n.card-blockquote .svg-bg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 95px;\r\n  position: absolute;\r\n  top: -94px;\r\n  left: 0;\r\n}\r\n\r\n.card-serial-number {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 1.625rem;\r\n}\r\n\r\n.card-serial-number>div:not(:last-child) {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.card-serial-number>div:not(:last-child):after {\r\n  content: \"-\";\r\n  flex: 1 1 auto;\r\n  text-align: center;\r\n  position: relative;\r\n  left: -2px;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .card-serial-number {\r\n    font-size: 1.0625rem;\r\n  }\r\n}\r\n\r\n.card-pricing .card-header {\r\n  padding-top: 1.25rem;\r\n  padding-bottom: 1.25rem;\r\n}\r\n\r\n.card-pricing .list-unstyled li {\r\n  padding: 0.5rem 0;\r\n  color: #8898aa;\r\n}\r\n\r\n.card-pricing.popular {\r\n  z-index: 1;\r\n  border: 3px solid #5e72e4 !important;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .card-pricing.zoom-in {\r\n    z-index: 1;\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n.card-profile-image {\r\n  position: relative;\r\n}\r\n\r\n.card-profile-image img {\r\n  max-width: 140px;\r\n  border-radius: 0.375rem;\r\n  border: 3px solid #fff;\r\n  transform: translate(-50%, -50%) scale(1);\r\n  position: absolute;\r\n  left: 50%;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.card-profile-image img:hover {\r\n  transform: translate(-50%, -50%) scale(1.03);\r\n}\r\n\r\n.card-profile-stats {\r\n  padding: 1rem 0;\r\n}\r\n\r\n.card-profile-stats>div {\r\n  text-align: center;\r\n  margin-right: 1rem;\r\n  padding: 0.875rem;\r\n}\r\n\r\n.card-profile-stats>div:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.card-profile-stats>div .heading {\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  display: block;\r\n}\r\n\r\n.card-profile-stats>div .description {\r\n  font-size: 0.875rem;\r\n  color: #adb5bd;\r\n}\r\n\r\n.card-profile-actions {\r\n  padding: 0.875rem;\r\n}\r\n\r\n.card-stats .card-body {\r\n  padding: 1rem 1.5rem;\r\n}\r\n\r\n.card-stats .card-status-bullet {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  transform: translate(50%, -50%);\r\n}\r\n\r\n.chart {\r\n  position: relative;\r\n  height: 350px;\r\n}\r\n\r\n.chart-sm {\r\n  height: 230px;\r\n}\r\n\r\n.chart-legend {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 2.5rem;\r\n  font-size: 0.875rem;\r\n  text-align: center;\r\n  color: #8898aa;\r\n}\r\n\r\n.chart-legend-item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.chart-legend-item+.chart-legend-item {\r\n  margin-left: 1rem;\r\n}\r\n\r\n.chart-legend-indicator {\r\n  display: inline-block;\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n  margin-right: 0.375rem;\r\n  border-radius: 50%;\r\n}\r\n\r\n#chart-tooltip {\r\n  z-index: 0;\r\n}\r\n\r\n#chart-tooltip .arrow {\r\n  top: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateX(-0.5rem);\r\n}\r\n\r\n.chart-info-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 5%;\r\n  max-width: 350px;\r\n  padding: 20px;\r\n  z-index: 1;\r\n}\r\n\r\n.close {\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.close>span:not(.sr-only) {\r\n  background-color: transparent;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  line-height: 17px;\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n  border-radius: 50%;\r\n  font-size: 1.25rem;\r\n  display: block;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.close:hover,\r\n.close:focus {\r\n  background-color: transparent;\r\n  color: rgba(0, 0, 0, 0.9);\r\n  outline: none;\r\n}\r\n\r\n.close:hover span:not(.sr-only),\r\n.close:focus span:not(.sr-only) {\r\n  background-color: transparent;\r\n}\r\n\r\n.close-dark>span:not(.sr-only) {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.close-dark:hover>span:not(.sr-only),\r\n.close-dark:focus>span:not(.sr-only) {\r\n  color: white;\r\n}\r\n\r\n.accordion .card-header {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.accordion .card-header:after {\r\n  content: \"\\ea0f\";\r\n  position: absolute;\r\n  right: 1.5rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font: normal normal normal 14px/1 NucleoIcons;\r\n  line-height: 0;\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .accordion .card-header:after {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.accordion .card-header[aria-expanded=\"false\"]:after {\r\n  content: \"\\ea0f\";\r\n}\r\n\r\n.accordion .card-header[aria-expanded=\"true\"]:after {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.accordion .card-header[aria-expanded=\"true\"] .heading {\r\n  color: #5e72e4;\r\n}\r\n\r\n.main-content {\r\n  position: relative;\r\n}\r\n\r\n.main-content .navbar-top {\r\n  padding-left: 0 !important;\r\n  padding-right: 0 !important;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n\r\n  .main-content .container-fluid,\r\n  .main-content .container-sm,\r\n  .main-content .container-md,\r\n  .main-content .container-lg,\r\n  .main-content .container-xl {\r\n    padding-left: 30px !important;\r\n    padding-right: 30px !important;\r\n  }\r\n}\r\n\r\n.custom-checkbox .custom-control-input~.custom-control-label {\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {\r\n  border-color: #e9ecef;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:checked::before {\r\n  border-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-control-label::before {\r\n  border: 1px solid #dee2e6;\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  top: 0.25rem;\r\n  left: -1.75rem;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-control-label::before {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-control-label::after {\r\n  top: 0.25rem;\r\n  left: -1.75rem;\r\n}\r\n\r\n.custom-control-label span {\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n.custom-control-label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-control-alternative .custom-control-label::before {\r\n  border: 0;\r\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.custom-control-alternative .custom-control-input:checked~.custom-control-label::before {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.custom-control-alternative .custom-control-input:active~.custom-control-label::before,\r\n.custom-control-alternative .custom-control-input:focus~.custom-control-label::before {\r\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.custom-checkbox .custom-control-input~.custom-control-label {\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  height: 1rem;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {\r\n  border-color: #e9ecef;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:checked::before {\r\n  border-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-checkbox-primary .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #5e72e4;\r\n  background-color: #5e72e4;\r\n}\r\n\r\n.custom-checkbox-primary .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #5e72e4;\r\n}\r\n\r\n.custom-checkbox-secondary .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #f7fafc;\r\n  background-color: #f7fafc;\r\n}\r\n\r\n.custom-checkbox-secondary .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #f7fafc;\r\n}\r\n\r\n.custom-checkbox-success .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #2dce89;\r\n  background-color: #2dce89;\r\n}\r\n\r\n.custom-checkbox-success .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #2dce89;\r\n}\r\n\r\n.custom-checkbox-info .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #11cdef;\r\n  background-color: #11cdef;\r\n}\r\n\r\n.custom-checkbox-info .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #11cdef;\r\n}\r\n\r\n.custom-checkbox-warning .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #fb6340;\r\n  background-color: #fb6340;\r\n}\r\n\r\n.custom-checkbox-warning .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #fb6340;\r\n}\r\n\r\n.custom-checkbox-danger .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #f5365c;\r\n  background-color: #f5365c;\r\n}\r\n\r\n.custom-checkbox-danger .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #f5365c;\r\n}\r\n\r\n.custom-checkbox-light .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #adb5bd;\r\n  background-color: #adb5bd;\r\n}\r\n\r\n.custom-checkbox-light .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #adb5bd;\r\n}\r\n\r\n.custom-checkbox-dark .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #212529;\r\n  background-color: #212529;\r\n}\r\n\r\n.custom-checkbox-dark .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #212529;\r\n}\r\n\r\n.custom-checkbox-default .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #172b4d;\r\n  background-color: #172b4d;\r\n}\r\n\r\n.custom-checkbox-default .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #172b4d;\r\n}\r\n\r\n.custom-checkbox-white .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #fff;\r\n  background-color: #fff;\r\n}\r\n\r\n.custom-checkbox-white .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #fff;\r\n}\r\n\r\n.custom-checkbox-neutral .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #fff;\r\n  background-color: #fff;\r\n}\r\n\r\n.custom-checkbox-neutral .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: #fff;\r\n}\r\n\r\n.custom-checkbox-darker .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: black;\r\n  background-color: black;\r\n}\r\n\r\n.custom-checkbox-darker .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: black;\r\n}\r\n\r\n.custom-radio .custom-control-input~.custom-control-label {\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  height: 1rem;\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::before {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#fff'/></svg>\");\r\n}\r\n\r\n.custom-radio .custom-control-input:disabled~.custom-control-label::before {\r\n  border-color: #e9ecef;\r\n}\r\n\r\n.custom-radio .custom-control-input:disabled:checked::before {\r\n  border-color: rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.custom-toggle {\r\n  position: relative;\r\n  display: inherit;\r\n  width: 52px;\r\n  height: 1.5rem;\r\n  margin: 0;\r\n  display: inline-block;\r\n}\r\n\r\n.custom-toggle input {\r\n  display: none;\r\n}\r\n\r\n.custom-toggle input:checked+.custom-toggle-slider {\r\n  border: 1px solid #5e72e4;\r\n}\r\n\r\n.custom-toggle input:checked+.custom-toggle-slider:before {\r\n  background: #5e72e4;\r\n  transform: translateX(28px);\r\n}\r\n\r\n.custom-toggle input:disabled+.custom-toggle-slider {\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.custom-toggle input:disabled:checked+.custom-toggle-slider {\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.custom-toggle input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #8a98eb;\r\n}\r\n\r\n.custom-toggle-slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 34px !important;\r\n  background-color: transparent;\r\n}\r\n\r\n.custom-toggle-slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 18px;\r\n  width: 18px;\r\n  left: 2px;\r\n  bottom: 2px;\r\n  border-radius: 50% !important;\r\n  background-color: #e9ecef;\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n.custom-toggle-wrapper .custom-toggle+.custom-toggle {\r\n  margin-left: 1rem !important;\r\n}\r\n\r\n.custom-toggle input:checked+.custom-toggle-slider:after {\r\n  content: attr(data-label-on);\r\n  color: #5e72e4;\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.custom-toggle-slider:after {\r\n  color: #ced4da;\r\n  content: attr(data-label-off);\r\n  display: block;\r\n  font-family: inherit;\r\n  font-weight: 600;\r\n  font-size: 0.75rem;\r\n  line-height: 24px;\r\n  position: absolute;\r\n  right: 0;\r\n  margin: 0 0.21667rem;\r\n  top: 0;\r\n  text-align: center;\r\n  min-width: 1.66667rem;\r\n  overflow: hidden;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-toggle-slider:after {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n/* Checkbox column cells (light mode) */\r\n.table-flush thead th.selection-cell,\r\n.table-flush tbody td.selection-cell {\r\n  width: 36px !important;\r\n  min-width: 36px !important;\r\n  max-width: 36px !important;\r\n\r\n  padding-left: 0.25rem !important;\r\n  padding-right: 0.25rem !important;\r\n\r\n  text-align: center;\r\n  white-space: nowrap;\r\n\r\n  background-color: #f5f5f5;\r\n  border-right: 1px solid #dee2e6;\r\n}\r\n\r\n/* All table checkbox inputs */\r\n.table-flush tbody td.selection-cell input[type=\"checkbox\"],\r\n.table-flush thead th.selection-cell input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n  transform: scale(0.9);\r\n  /* slightly smaller */\r\n  margin: 0 !important;\r\n}\r\n\r\n/* Select-all header cell */\r\n.table-flush thead th.selection-cell-header {\r\n  cursor: pointer;\r\n}\r\n\r\n/* Select-all checkbox itself */\r\n.table-flush thead th.selection-cell-header input[type=\"checkbox\"] {\r\n  cursor: pointer !important;\r\n}\r\n\r\n/* Optional: row checkbox cells too */\r\n.table-flush tbody td.selection-cell,\r\n.table-flush tbody td.selection-cell input[type=\"checkbox\"] {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.custom-toggle-primary input:checked+.custom-toggle-slider {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.custom-toggle-primary input:checked+.custom-toggle-slider:before {\r\n  background: #5e72e4;\r\n}\r\n\r\n.custom-toggle-primary input:checked+.custom-toggle-slider:after {\r\n  color: #5e72e4;\r\n}\r\n\r\n.custom-toggle-primary input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.custom-toggle-primary input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #8a98eb;\r\n}\r\n\r\n.custom-toggle-secondary input:checked+.custom-toggle-slider {\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.custom-toggle-secondary input:checked+.custom-toggle-slider:before {\r\n  background: #f7fafc;\r\n}\r\n\r\n.custom-toggle-secondary input:checked+.custom-toggle-slider:after {\r\n  color: #f7fafc;\r\n}\r\n\r\n.custom-toggle-secondary input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #f7fafc;\r\n}\r\n\r\n.custom-toggle-secondary input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: white;\r\n}\r\n\r\n.custom-toggle-success input:checked+.custom-toggle-slider {\r\n  border-color: #2dce89;\r\n}\r\n\r\n.custom-toggle-success input:checked+.custom-toggle-slider:before {\r\n  background: #2dce89;\r\n}\r\n\r\n.custom-toggle-success input:checked+.custom-toggle-slider:after {\r\n  color: #2dce89;\r\n}\r\n\r\n.custom-toggle-success input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #2dce89;\r\n}\r\n\r\n.custom-toggle-success input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #54daa1;\r\n}\r\n\r\n.custom-toggle-info input:checked+.custom-toggle-slider {\r\n  border-color: #11cdef;\r\n}\r\n\r\n.custom-toggle-info input:checked+.custom-toggle-slider:before {\r\n  background: #11cdef;\r\n}\r\n\r\n.custom-toggle-info input:checked+.custom-toggle-slider:after {\r\n  color: #11cdef;\r\n}\r\n\r\n.custom-toggle-info input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #11cdef;\r\n}\r\n\r\n.custom-toggle-info input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #41d7f2;\r\n}\r\n\r\n.custom-toggle-warning input:checked+.custom-toggle-slider {\r\n  border-color: #fb6340;\r\n}\r\n\r\n.custom-toggle-warning input:checked+.custom-toggle-slider:before {\r\n  background: #fb6340;\r\n}\r\n\r\n.custom-toggle-warning input:checked+.custom-toggle-slider:after {\r\n  color: #fb6340;\r\n}\r\n\r\n.custom-toggle-warning input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #fb6340;\r\n}\r\n\r\n.custom-toggle-warning input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #fc8c72;\r\n}\r\n\r\n.custom-toggle-danger input:checked+.custom-toggle-slider {\r\n  border-color: #f5365c;\r\n}\r\n\r\n.custom-toggle-danger input:checked+.custom-toggle-slider:before {\r\n  background: #f5365c;\r\n}\r\n\r\n.custom-toggle-danger input:checked+.custom-toggle-slider:after {\r\n  color: #f5365c;\r\n}\r\n\r\n.custom-toggle-danger input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #f5365c;\r\n}\r\n\r\n.custom-toggle-danger input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #f76783;\r\n}\r\n\r\n.custom-toggle-light input:checked+.custom-toggle-slider {\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.custom-toggle-light input:checked+.custom-toggle-slider:before {\r\n  background: #adb5bd;\r\n}\r\n\r\n.custom-toggle-light input:checked+.custom-toggle-slider:after {\r\n  color: #adb5bd;\r\n}\r\n\r\n.custom-toggle-light input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.custom-toggle-light input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #c9cfd4;\r\n}\r\n\r\n.custom-toggle-dark input:checked+.custom-toggle-slider {\r\n  border-color: #212529;\r\n}\r\n\r\n.custom-toggle-dark input:checked+.custom-toggle-slider:before {\r\n  background: #212529;\r\n}\r\n\r\n.custom-toggle-dark input:checked+.custom-toggle-slider:after {\r\n  color: #212529;\r\n}\r\n\r\n.custom-toggle-dark input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #212529;\r\n}\r\n\r\n.custom-toggle-dark input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #383f45;\r\n}\r\n\r\n.custom-toggle-default input:checked+.custom-toggle-slider {\r\n  border-color: #172b4d;\r\n}\r\n\r\n.custom-toggle-default input:checked+.custom-toggle-slider:before {\r\n  background: #172b4d;\r\n}\r\n\r\n.custom-toggle-default input:checked+.custom-toggle-slider:after {\r\n  color: #172b4d;\r\n}\r\n\r\n.custom-toggle-default input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #172b4d;\r\n}\r\n\r\n.custom-toggle-default input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #234174;\r\n}\r\n\r\n.custom-toggle-white input:checked+.custom-toggle-slider {\r\n  border-color: #fff;\r\n}\r\n\r\n.custom-toggle-white input:checked+.custom-toggle-slider:before {\r\n  background: #fff;\r\n}\r\n\r\n.custom-toggle-white input:checked+.custom-toggle-slider:after {\r\n  color: #fff;\r\n}\r\n\r\n.custom-toggle-white input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #fff;\r\n}\r\n\r\n.custom-toggle-white input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: white;\r\n}\r\n\r\n.custom-toggle-neutral input:checked+.custom-toggle-slider {\r\n  border-color: #fff;\r\n}\r\n\r\n.custom-toggle-neutral input:checked+.custom-toggle-slider:before {\r\n  background: #fff;\r\n}\r\n\r\n.custom-toggle-neutral input:checked+.custom-toggle-slider:after {\r\n  color: #fff;\r\n}\r\n\r\n.custom-toggle-neutral input:disabled:checked+.custom-toggle-slider {\r\n  border-color: #fff;\r\n}\r\n\r\n.custom-toggle-neutral input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: white;\r\n}\r\n\r\n.custom-toggle-darker input:checked+.custom-toggle-slider {\r\n  border-color: black;\r\n}\r\n\r\n.custom-toggle-darker input:checked+.custom-toggle-slider:before {\r\n  background: black;\r\n}\r\n\r\n.custom-toggle-darker input:checked+.custom-toggle-slider:after {\r\n  color: black;\r\n}\r\n\r\n.custom-toggle-darker input:disabled:checked+.custom-toggle-slider {\r\n  border-color: black;\r\n}\r\n\r\n.custom-toggle-darker input:disabled:checked+.custom-toggle-slider:before {\r\n  background-color: #1a1a1a;\r\n}\r\n\r\n.dropdown,\r\n.dropup,\r\n.dropright,\r\n.dropleft {\r\n  display: inline-block;\r\n}\r\n\r\n.dropdown-menu {\r\n  min-width: 12rem;\r\n}\r\n\r\n.dropdown-menu .dropdown-item {\r\n  padding: 0.5rem 1rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.dropdown-menu .dropdown-item>i,\r\n.dropdown-menu .dropdown-item>svg {\r\n  margin-right: 1rem;\r\n  font-size: 1rem;\r\n  vertical-align: -17%;\r\n}\r\n\r\n.dropdown-menu .dropdown-item img {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.dropdown-header {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  font-size: 0.625rem;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n\r\n.dropdown-menu a.media>div:first-child {\r\n  line-height: 1;\r\n}\r\n\r\n.dropdown-menu a.media p {\r\n  color: #8898aa;\r\n}\r\n\r\n.dropdown-menu a.media:hover .heading,\r\n.dropdown-menu a.media:hover p {\r\n  color: #172b4d !important;\r\n}\r\n\r\n.dropdown-menu-dark .h1,\r\n.dropdown-menu-dark .h2,\r\n.dropdown-menu-dark .h3,\r\n.dropdown-menu-dark .h4,\r\n.dropdown-menu-dark .h5,\r\n.dropdown-menu-dark .h6,\r\n.dropdown-menu-dark a {\r\n  color: white;\r\n}\r\n\r\n.dropdown-menu-sm {\r\n  min-width: 100px;\r\n  border: 0.4375rem;\r\n}\r\n\r\n.dropdown-menu-lg {\r\n  min-width: 320px;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n.dropdown-menu-xl {\r\n  min-width: 420px;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n.footer {\r\n  background: #f8f9fe;\r\n  padding: 30px 0;\r\n}\r\n\r\n.footer .col-footer .heading {\r\n  color: #8898aa;\r\n  letter-spacing: 0;\r\n  font-size: 0.875rem;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.footer .nav .nav-item .nav-link,\r\n.footer .footer-link {\r\n  color: #8898aa !important;\r\n}\r\n\r\n.footer .nav .nav-item .nav-link:hover,\r\n.footer .footer-link:hover {\r\n  color: #525f7f !important;\r\n}\r\n\r\n.footer .list-unstyled li a {\r\n  display: inline-block;\r\n  padding: 0.125rem 0;\r\n  color: #8898aa;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.footer .list-unstyled li a:hover {\r\n  color: #525f7f;\r\n}\r\n\r\n.footer .copyright {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.footer-dark .col-footer .heading {\r\n  color: #fff;\r\n}\r\n\r\n.nav-footer .nav-link {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.nav-footer .nav-item:last-child .nav-link {\r\n  padding-right: 0;\r\n}\r\n\r\n.footer.has-cards {\r\n  overflow: hidden;\r\n  padding-top: 500px;\r\n  margin-top: -420px;\r\n  position: relative;\r\n  background: transparent;\r\n  pointer-events: none;\r\n}\r\n\r\n.footer.has-cards:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 600px;\r\n  height: 2000px;\r\n  background: #f7fafc;\r\n  transform: skew(0, -8deg);\r\n}\r\n\r\n.footer.has-cards .container {\r\n  pointer-events: auto;\r\n  position: relative;\r\n}\r\n\r\n.footer-auto-bottom {\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 100%;\r\n}\r\n\r\n.form-control-label {\r\n  color: #525f7f;\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.form-control {\r\n  font-size: 0.875rem;\r\n  transition: all 0.15s ease-in-out;\r\n  height: calc(1.5em + 1.25rem + 5px);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .form-control {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.form-control:focus::placeholder {\r\n  color: #adb5bd;\r\n}\r\n\r\n.form-control-lg {\r\n  height: calc(2.25em + 1.25rem + 5px);\r\n}\r\n\r\n.form-control-sm {\r\n  height: calc(0.45em + 1.25rem + 5px);\r\n}\r\n\r\n.form-control-flush {\r\n  padding: 0;\r\n  border-width: 0;\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n}\r\n\r\n.form-control-flush:focus {\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n  border-width: 0;\r\n}\r\n\r\ntextarea[resize=\"none\"] {\r\n  resize: none !important;\r\n}\r\n\r\ntextarea[resize=\"both\"] {\r\n  resize: both !important;\r\n}\r\n\r\ntextarea[resize=\"vertical\"] {\r\n  resize: vertical !important;\r\n}\r\n\r\ntextarea[resize=\"horizontal\"] {\r\n  resize: horizontal !important;\r\n}\r\n\r\n.form-control-muted {\r\n  background-color: #f7fafe;\r\n  border-color: #f7fafe;\r\n  box-shadow: none;\r\n}\r\n\r\n.form-control-muted:focus {\r\n  background-color: #fcfdff;\r\n}\r\n\r\n.form-control-alternative {\r\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\r\n  border: 0;\r\n  transition: box-shadow 0.15s ease;\r\n}\r\n\r\n.form-control-alternative:focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.form-control-lg,\r\n.input-group-lg .form-control,\r\n.input-group-text {\r\n  font-size: 1rem !important;\r\n}\r\n\r\n.custom-control {\r\n  padding-left: 1.75rem;\r\n}\r\n\r\n.input-group {\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n  border-radius: 0.25rem;\r\n  transition: all 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .input-group {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.input-group .form-control {\r\n  box-shadow: none;\r\n}\r\n\r\n.input-group .form-control:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.input-group-text {\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .input-group-text {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.input-group-text i {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.input-group-text .custom-control {\r\n  line-height: 1;\r\n}\r\n\r\n.input-group-prepend .input-group-text {\r\n  border-right: 0;\r\n}\r\n\r\n.input-group-append .input-group-text {\r\n  border-left: 0;\r\n}\r\n\r\n.input-group-merge .form-control:not(:first-child) {\r\n  border-left: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.input-group-merge .form-control:not(:last-child) {\r\n  border-right: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.input-group-alternative {\r\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\r\n  border: 0;\r\n  transition: box-shadow 0.15s ease;\r\n}\r\n\r\n.input-group-alternative .form-control,\r\n.input-group-alternative .input-group-text {\r\n  border: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.focused .input-group-alternative {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\r\n}\r\n\r\n.input-group-flush {\r\n  box-shadow: none;\r\n}\r\n\r\n.input-group-flush>.form-control {\r\n  padding: 0;\r\n  border-width: 0;\r\n  background-color: transparent;\r\n}\r\n\r\n.input-group-flush>.input-group-prepend>.input-group-text,\r\n.input-group-flush>.input-group-append>.input-group-text {\r\n  padding: 0;\r\n  padding-right: 1rem;\r\n  border-width: 0;\r\n  background-color: transparent;\r\n}\r\n\r\n.focused .input-group {\r\n  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.focused .input-group-text {\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.focused .form-control {\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.focused .input-group-flush {\r\n  box-shadow: none;\r\n}\r\n\r\n.form-primary .form-control {\r\n  color: #fff;\r\n  background-color: rgba(50, 76, 221, 0.5);\r\n  border-color: #324cdd;\r\n}\r\n\r\n.form-primary .form-control:focus {\r\n  background-color: rgba(42, 68, 219, 0.7);\r\n  border: 1px solid #2a44db;\r\n}\r\n\r\n.form-primary .form-control::placeholder {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.form-primary .input-group-text {\r\n  color: #fff;\r\n  background-color: rgba(50, 76, 221, 0.5);\r\n  border-color: #324cdd;\r\n}\r\n\r\n.form-primary .focused .input-group-text {\r\n  color: #fff;\r\n  background-color: rgba(42, 68, 219, 0.7);\r\n  border-color: #2a44db;\r\n}\r\n\r\n.has-success,\r\n.has-danger {\r\n  position: relative;\r\n}\r\n\r\n.has-success:after,\r\n.has-danger:after {\r\n  display: none;\r\n  width: 19px;\r\n  height: 19px;\r\n  line-height: 19px;\r\n  text-align: center;\r\n  font-family: \"NucleoIcons\";\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  border-radius: 50%;\r\n  font-size: 9px;\r\n  opacity: 1;\r\n}\r\n\r\n.has-success .input-group-prepend .input-group-text,\r\n.has-danger .input-group-prepend .input-group-text {\r\n  border-color: red;\r\n}\r\n\r\n.has-success:after {\r\n  content: \"\\ea26\";\r\n  color: #1d8357;\r\n  background-color: #69deac;\r\n}\r\n\r\n.has-success .form-control {\r\n  background-color: #fff;\r\n}\r\n\r\n.has-success .form-control::placeholder {\r\n  color: #2dce89;\r\n}\r\n\r\n.has-danger:after {\r\n  content: \"\\ea53\";\r\n  color: #db2d05;\r\n  background-color: #fda08b;\r\n}\r\n\r\n.has-danger .form-control {\r\n  background-color: #fff;\r\n}\r\n\r\n.has-danger .form-control::placeholder {\r\n  color: #fb6340;\r\n}\r\n\r\n.row-example>.col span,\r\n.row-example>[class^=\"col-\"] span {\r\n  display: block;\r\n  padding: 0.75rem;\r\n  color: #393f49;\r\n  background-color: white;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,\r\n    rgba(0, 0, 0, 0.1) 0px 4px 16px;\r\n  font-size: 0.875rem;\r\n  border-radius: 0.25rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.no-gutters>.col span,\r\n.no-gutters>[class^=\"col-\"] span {\r\n  border-radius: 0;\r\n}\r\n\r\n.header {\r\n  position: relative;\r\n}\r\n\r\n.icon {\r\n  width: 3rem;\r\n  height: 3rem;\r\n}\r\n\r\n.icon i,\r\n.icon svg {\r\n  font-size: 2.25rem;\r\n}\r\n\r\n.icon+.icon-text {\r\n  padding-left: 1rem;\r\n  width: calc(100% - 3rem - 1);\r\n}\r\n\r\n.icon-xl {\r\n  width: 5rem;\r\n  height: 5rem;\r\n}\r\n\r\n.icon-xl i,\r\n.icon-xl svg {\r\n  font-size: 4.25rem;\r\n}\r\n\r\n.icon-xl+.icon-text {\r\n  width: calc(100% - 5rem - 1);\r\n}\r\n\r\n.icon-lg {\r\n  width: 4rem;\r\n  height: 4rem;\r\n}\r\n\r\n.icon-lg i,\r\n.icon-lg svg {\r\n  font-size: 3.25rem;\r\n}\r\n\r\n.icon-lg+.icon-text {\r\n  width: calc(100% - 4rem - 1);\r\n}\r\n\r\n.icon-sm {\r\n  width: 2rem;\r\n  height: 2rem;\r\n}\r\n\r\n.icon-sm i,\r\n.icon-sm svg {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.icon-sm+.icon-text {\r\n  width: calc(100% - 2rem - 1);\r\n}\r\n\r\n.icon-xs {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n}\r\n\r\n.icon-xs i,\r\n.icon-xs svg {\r\n  font-size: 0.5rem;\r\n}\r\n\r\n.icon-xs+.icon-text {\r\n  width: calc(100% - 1.25rem - 1);\r\n}\r\n\r\n.icon-actions>a {\r\n  display: inline-block;\r\n  margin-right: 0.75rem;\r\n  color: #8898aa;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.icon-actions>a:last-of-type {\r\n  margin-right: 0;\r\n}\r\n\r\n.icon-actions>a span {\r\n  margin-left: 0.1875rem;\r\n  font-weight: 600;\r\n  color: #8898aa;\r\n}\r\n\r\n.icon-actions>a:hover span {\r\n  color: #6a7e95;\r\n}\r\n\r\n.icon-actions>a,\r\n.icon-actions>a:hover,\r\n.icon-actions>a.active {\r\n  color: #32325d;\r\n}\r\n\r\n.icon-actions>.favorite:hover,\r\n.icon-actions>.favorite.active {\r\n  color: #ffd600;\r\n}\r\n\r\n.icon-actions>.love:hover,\r\n.icon-actions>.love.active {\r\n  color: #f5365c;\r\n}\r\n\r\n.icon-actions>.like:hover,\r\n.icon-actions>.like.active {\r\n  color: #5e72e4;\r\n}\r\n\r\n.icon-actions-lg a {\r\n  font-size: 1.25rem;\r\n  margin-right: 0.875rem;\r\n}\r\n\r\n.icon-shape {\r\n  padding: 12px;\r\n  text-align: center;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n}\r\n\r\n.icon-shape i,\r\n.icon-shape svg {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.icon-shape.icon-lg i,\r\n.icon-shape.icon-lg svg {\r\n  font-size: 1.625rem;\r\n}\r\n\r\n.icon-shape.icon-sm i,\r\n.icon-shape.icon-sm svg {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.icon-shape.icon-xs i,\r\n.icon-shape.icon-xs svg {\r\n  font-size: 0.6rem;\r\n}\r\n\r\n.icon-shape svg {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.icon-shape-primary {\r\n  color: #2643e9;\r\n  background-color: rgba(138, 152, 235, 0.5);\r\n}\r\n\r\n.icon-shape-secondary {\r\n  color: #cfe3f1;\r\n  background-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.icon-shape-success {\r\n  color: #1aae6f;\r\n  background-color: rgba(84, 218, 161, 0.5);\r\n}\r\n\r\n.icon-shape-info {\r\n  color: #03acca;\r\n  background-color: rgba(65, 215, 242, 0.5);\r\n}\r\n\r\n.icon-shape-warning {\r\n  color: #ff3709;\r\n  background-color: rgba(252, 140, 114, 0.5);\r\n}\r\n\r\n.icon-shape-danger {\r\n  color: #f80031;\r\n  background-color: rgba(247, 103, 131, 0.5);\r\n}\r\n\r\n.icon-shape-light {\r\n  color: #879cb0;\r\n  background-color: rgba(201, 207, 212, 0.5);\r\n}\r\n\r\n.icon-shape-dark {\r\n  color: #090c0e;\r\n  background-color: rgba(56, 63, 69, 0.5);\r\n}\r\n\r\n.icon-shape-default {\r\n  color: #091428;\r\n  background-color: rgba(35, 65, 116, 0.5);\r\n}\r\n\r\n.icon-shape-white {\r\n  color: #e8e3e3;\r\n  background-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.icon-shape-neutral {\r\n  color: #e8e3e3;\r\n  background-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.icon-shape-darker {\r\n  color: black;\r\n  background-color: rgba(26, 26, 26, 0.5);\r\n}\r\n\r\n.list-group-space .list-group-item {\r\n  margin-bottom: 1.5rem;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.list-group-img {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  border-radius: 50%;\r\n  vertical-align: top;\r\n  margin: -0.1rem 1.2rem 0 -0.2rem;\r\n}\r\n\r\n.list-group-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.list-group-content>p {\r\n  color: #adb5bd;\r\n  line-height: 1.5;\r\n  margin: 0.2rem 0 0;\r\n}\r\n\r\n.list-group-heading {\r\n  font-size: 1rem;\r\n  color: #32325d;\r\n}\r\n\r\n.list-group-heading>small {\r\n  float: right;\r\n  color: #adb5bd;\r\n  font-weight: 500;\r\n}\r\n\r\n.checklist-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n  padding-left: 0.75rem;\r\n}\r\n\r\n.checklist-item:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 3px;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #5e72e4;\r\n  border-radius: 8px;\r\n}\r\n\r\n.checklist-item-checked .checklist-info * {\r\n  text-decoration: line-through;\r\n}\r\n\r\n.checklist-item-primary:before {\r\n  background-color: #5e72e4;\r\n}\r\n\r\n.checklist-item-secondary:before {\r\n  background-color: #f7fafc;\r\n}\r\n\r\n.checklist-item-success:before {\r\n  background-color: #2dce89;\r\n}\r\n\r\n.checklist-item-info:before {\r\n  background-color: #11cdef;\r\n}\r\n\r\n.checklist-item-warning:before {\r\n  background-color: #fb6340;\r\n}\r\n\r\n.checklist-item-danger:before {\r\n  background-color: #f5365c;\r\n}\r\n\r\n.checklist-item-light:before {\r\n  background-color: #adb5bd;\r\n}\r\n\r\n.checklist-item-dark:before {\r\n  background-color: #212529;\r\n}\r\n\r\n.checklist-item-default:before {\r\n  background-color: #172b4d;\r\n}\r\n\r\n.checklist-item-white:before {\r\n  background-color: #fff;\r\n}\r\n\r\n.checklist-item-neutral:before {\r\n  background-color: #fff;\r\n}\r\n\r\n.checklist-item-darker:before {\r\n  background-color: black;\r\n}\r\n\r\n.map-canvas {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 500px;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.mask {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .mask {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n  z-index: 1040;\r\n}\r\n\r\n.backdrop-dark {\r\n  background: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.backdrop-light {\r\n  background: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.media-comment {\r\n  margin-top: 2rem;\r\n}\r\n\r\n.media-comment-avatar {\r\n  margin-top: -1rem;\r\n  margin-right: -2rem;\r\n  position: relative;\r\n  z-index: 1;\r\n  border: 4px solid #fff;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .media-comment-avatar {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.media-comment-text {\r\n  border-radius: 0.4375rem;\r\n  border-top-left-radius: 0;\r\n  position: relative;\r\n  background-color: #f6f9fc;\r\n  padding: 1rem 1.25rem 1rem 2.5rem;\r\n}\r\n\r\n.media-comment:hover .media-comment-avatar {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.metric-card-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.metric-card-icon-img {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  object-fit: contain;\r\n}\r\n\r\n.modal-title {\r\n  font-size: 1.0625rem;\r\n}\r\n\r\n.modal-fluid .modal-dialog {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.modal-fluid .modal-content {\r\n  border-radius: 0;\r\n}\r\n\r\n.modal-primary .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-primary .modal-header,\r\n.modal-primary .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-primary .modal-content {\r\n  background-color: #5e72e4;\r\n  color: #fff;\r\n}\r\n\r\n.modal-primary .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-primary .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-secondary .modal-title {\r\n  color: #212529;\r\n}\r\n\r\n.modal-secondary .modal-header,\r\n.modal-secondary .modal-footer {\r\n  border-color: rgba(33, 37, 41, 0.075);\r\n}\r\n\r\n.modal-secondary .modal-content {\r\n  background-color: #f7fafc;\r\n  color: #212529;\r\n}\r\n\r\n.modal-secondary .modal-content .heading {\r\n  color: #212529;\r\n}\r\n\r\n.modal-secondary .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-success .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-success .modal-header,\r\n.modal-success .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-success .modal-content {\r\n  background-color: #2dce89;\r\n  color: #fff;\r\n}\r\n\r\n.modal-success .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-success .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-info .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-info .modal-header,\r\n.modal-info .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-info .modal-content {\r\n  background-color: #11cdef;\r\n  color: #fff;\r\n}\r\n\r\n.modal-info .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-info .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-warning .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-warning .modal-header,\r\n.modal-warning .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-warning .modal-content {\r\n  background-color: #fb6340;\r\n  color: #fff;\r\n}\r\n\r\n.modal-warning .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-warning .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-danger .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-danger .modal-header,\r\n.modal-danger .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-danger .modal-content {\r\n  background-color: #f5365c;\r\n  color: #fff;\r\n}\r\n\r\n.modal-danger .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-danger .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-light .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-light .modal-header,\r\n.modal-light .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-light .modal-content {\r\n  background-color: #adb5bd;\r\n  color: #fff;\r\n}\r\n\r\n.modal-light .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-light .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-dark .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-dark .modal-header,\r\n.modal-dark .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-dark .modal-content {\r\n  background-color: #212529;\r\n  color: #fff;\r\n}\r\n\r\n.modal-dark .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-dark .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-default .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-default .modal-header,\r\n.modal-default .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-default .modal-content {\r\n  background-color: #172b4d;\r\n  color: #fff;\r\n}\r\n\r\n.modal-default .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-default .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-white .modal-title {\r\n  color: #212529;\r\n}\r\n\r\n.modal-white .modal-header,\r\n.modal-white .modal-footer {\r\n  border-color: rgba(33, 37, 41, 0.075);\r\n}\r\n\r\n.modal-white .modal-content {\r\n  background-color: #fff;\r\n  color: #212529;\r\n}\r\n\r\n.modal-white .modal-content .heading {\r\n  color: #212529;\r\n}\r\n\r\n.modal-white .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-neutral .modal-title {\r\n  color: #212529;\r\n}\r\n\r\n.modal-neutral .modal-header,\r\n.modal-neutral .modal-footer {\r\n  border-color: rgba(33, 37, 41, 0.075);\r\n}\r\n\r\n.modal-neutral .modal-content {\r\n  background-color: #fff;\r\n  color: #212529;\r\n}\r\n\r\n.modal-neutral .modal-content .heading {\r\n  color: #212529;\r\n}\r\n\r\n.modal-neutral .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.modal-darker .modal-title {\r\n  color: #fff;\r\n}\r\n\r\n.modal-darker .modal-header,\r\n.modal-darker .modal-footer {\r\n  border-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n.modal-darker .modal-content {\r\n  background-color: black;\r\n  color: #fff;\r\n}\r\n\r\n.modal-darker .modal-content .heading {\r\n  color: #fff;\r\n}\r\n\r\n.modal-darker .close>span:not(.sr-only) {\r\n  color: #fff;\r\n}\r\n\r\n.navbar-horizontal .navbar-nav .nav-link {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  text-transform: normal;\r\n  letter-spacing: 0;\r\n}\r\n\r\n.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.navbar-horizontal .navbar-brand {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  font-size: 0.875rem;\r\n  letter-spacing: 0.05px;\r\n}\r\n\r\n.navbar-horizontal .navbar-brand img {\r\n  height: 30px;\r\n}\r\n\r\n.navbar-horizontal .navbar-dark .navbar-brand {\r\n  color: #fff;\r\n}\r\n\r\n.navbar-horizontal .navbar-light .navbar-brand {\r\n  color: #32325d;\r\n}\r\n\r\n.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .navbar-horizontal .navbar-nav .nav-item {\r\n    margin-right: 0.5rem;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .nav-item [data-toggle=\"dropdown\"]::after {\r\n    transition: all 0.15s ease;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle=\"dropdown\"]::after {\r\n    transform: rotate(180deg);\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .nav-link {\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .nav-link i {\r\n    margin-right: 0.625rem;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .nav-link-icon {\r\n    padding-left: 0.5rem !important;\r\n    padding-right: 0.5rem !important;\r\n    font-size: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .nav-link-icon i {\r\n    margin-right: 0;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .dropdown-menu {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    margin: 0;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .dropdown-menu:before {\r\n    background: #fff;\r\n    box-shadow: none;\r\n    content: \"\";\r\n    display: block;\r\n    height: 16px;\r\n    width: 16px;\r\n    left: 20px;\r\n    position: absolute;\r\n    bottom: 100%;\r\n    transform: rotate(-45deg) translateY(1rem);\r\n    z-index: -5;\r\n    border-radius: 0.25rem;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .dropdown-menu-right:before {\r\n    right: 20px;\r\n    left: auto;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav:not(.navbar-nav-hover) .dropdown-menu.show {\r\n    opacity: 1;\r\n    pointer-events: auto;\r\n    animation: show-navbar-dropdown 0.25s ease forwards;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav:not(.navbar-nav-hover) .dropdown-menu.close {\r\n    display: block;\r\n    animation: hide-navbar-dropdown 0.15s ease backwards;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav.navbar-nav-hover .dropdown-menu {\r\n    opacity: 0;\r\n    display: block;\r\n    pointer-events: none;\r\n    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav.navbar-nav-hover .nav-item.dropdown:hover>.dropdown-menu {\r\n    display: block;\r\n    opacity: 1;\r\n    pointer-events: auto;\r\n    visibility: visible;\r\n    transform: translate(0, 0);\r\n    animation: none;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .dropdown-menu-inner {\r\n    position: relative;\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n.navbar-horizontal.navbar-transparent {\r\n  position: absolute;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 100;\r\n  background-color: transparent;\r\n  border: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.navbar-horizontal.navbar-transparent .navbar-brand {\r\n  color: white;\r\n}\r\n\r\n.navbar-horizontal.navbar-transparent .navbar-toggler {\r\n  color: white;\r\n}\r\n\r\n.navbar-horizontal.navbar-transparent .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 0.95)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link {\r\n    color: rgba(255, 255, 255, 0.95);\r\n  }\r\n\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link:hover,\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link:focus {\r\n    color: rgba(255, 255, 255, 0.65);\r\n  }\r\n\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link.disabled {\r\n    color: rgba(255, 255, 255, 0.25);\r\n  }\r\n\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .show>.nav-link,\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .active>.nav-link,\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link.show,\r\n  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link.active {\r\n    color: rgba(255, 255, 255, 0.65);\r\n  }\r\n\r\n  .navbar-horizontal.navbar-transparent .navbar-brand {\r\n    color: rgba(255, 255, 255, 0.95);\r\n  }\r\n\r\n  .navbar-horizontal.navbar-transparent .navbar-brand:hover,\r\n  .navbar-horizontal.navbar-transparent .navbar-brand:focus {\r\n    color: rgba(255, 255, 255, 0.95);\r\n  }\r\n}\r\n\r\n.navbar-horizontal .navbar-collapse-header {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .navbar-horizontal .navbar-nav .nav-link {\r\n    padding: 0.625rem 0;\r\n    color: #172b4d !important;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .dropdown-menu {\r\n    box-shadow: none;\r\n    min-width: auto;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-nav .dropdown-menu .media svg {\r\n    width: 30px;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse {\r\n    width: calc(100% - 1.4rem);\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 1050;\r\n    margin: 0.7rem;\r\n    overflow-y: auto;\r\n    height: auto !important;\r\n    opacity: 0;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .navbar-toggler {\r\n    width: 20px;\r\n    height: 20px;\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    padding: 0;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .navbar-toggler span {\r\n    display: block;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 2px;\r\n    border-radius: 2px;\r\n    opacity: 1;\r\n    background: #283448;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .navbar-toggler :nth-child(1) {\r\n    transform: rotate(135deg);\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .navbar-toggler :nth-child(2) {\r\n    transform: rotate(-135deg);\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .navbar-collapse-header {\r\n    display: block;\r\n    padding-bottom: 1rem;\r\n    margin-bottom: 1rem;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .collapse-brand img {\r\n    height: 36px;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse .collapse-close {\r\n    text-align: right;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse.collapsing,\r\n  .navbar-horizontal .navbar-collapse.show {\r\n    padding: 1.5rem;\r\n    border-radius: 0.375rem;\r\n    background: #fff;\r\n    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),\r\n      0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\r\n    animation: show-navbar-collapse 0.2s ease forwards;\r\n  }\r\n\r\n  .navbar-horizontal .navbar-collapse.collapsing-out {\r\n    animation: hide-navbar-collapse 0.2s ease forwards;\r\n  }\r\n}\r\n\r\n@keyframes show-navbar-collapse {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n    transform-origin: 100% 0;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes hide-navbar-collapse {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n    transform-origin: 100% 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n}\r\n\r\n@keyframes show-navbar-dropdown {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n  }\r\n\r\n  100% {\r\n    transform: translate(0, 0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes hide-navbar-dropdown {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    transform: translate(0, 10px);\r\n  }\r\n}\r\n\r\n.navbar-floating-wrapper {\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.navbar-floating-wrapper .navbar {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.navbar-vertical {\r\n  padding-top: 0;\r\n  border-width: 0 0 1px 0;\r\n  border-style: solid;\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\r\n}\r\n\r\n.navbar-vertical.navbar-light {\r\n  background-color: #f6f9fc;\r\n  border-color: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.navbar-vertical.navbar-dark {\r\n  background-color: transparent;\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.navbar-vertical .navbar-brand {\r\n  margin-right: 0;\r\n}\r\n\r\n.navbar-vertical .navbar-brand-img,\r\n.navbar-vertical .navbar-brand>img {\r\n  max-width: 100%;\r\n  max-height: 2rem;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-vertical .navbar-collapse {\r\n    margin-left: -1rem;\r\n    margin-right: -1rem;\r\n  }\r\n\r\n  .navbar-vertical .navbar-collapse:before {\r\n    content: \"\";\r\n    display: block;\r\n    margin: 0.5rem;\r\n  }\r\n}\r\n\r\n.navbar-vertical .navbar-nav {\r\n  margin-left: -1rem;\r\n  margin-right: -1rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .sidebar-icon.home-icon i {\r\n  font-size: 0.9375rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link.active {\r\n  position: relative;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link>i {\r\n  min-width: 2rem;\r\n  font-size: 0.9375rem;\r\n  line-height: 1.5rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link .dropdown-menu {\r\n  border: none;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link .dropdown-menu .dropdown-menu {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-sm .nav-link {\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link[data-toggle=\"collapse\"]:after {\r\n  display: inline-block;\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  text-rendering: auto;\r\n  -webkit-font-smoothing: antialiased;\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 700;\r\n  content: \"\\f105\";\r\n  margin-left: auto;\r\n  color: #ced4da;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .navbar-vertical .navbar-nav .nav-link[data-toggle=\"collapse\"]:after {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav-link[data-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\r\n  color: #5e72e4;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav .nav-link {\r\n  padding-left: 3rem;\r\n}\r\n\r\n.navbar-vertical .navbar-nav .nav .nav .nav-link {\r\n  padding-left: 3.5rem;\r\n}\r\n\r\n.navbar-vertical .navbar-heading {\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs {\r\n  display: block;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  max-width: 62px;\r\n  overflow-y: auto;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-inner {\r\n  padding-left: 1.5rem;\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs>[class*=\"container\"] {\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  min-height: 100%;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n@media all and (-ms-high-contrast: none),\r\n(-ms-high-contrast: active) {\r\n  .navbar-vertical.navbar-expand-xs>[class*=\"container\"] {\r\n    min-height: none;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs.fixed-left {\r\n  left: 0;\r\n  border-width: 0 1px 0 0;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs.fixed-right {\r\n  right: 0;\r\n  border-width: 0 0 0 1px;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-collapse {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  margin-left: -1.5rem;\r\n  margin-right: -1.5rem;\r\n  padding-left: 1.5rem;\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-collapse>* {\r\n  min-width: 100%;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav {\r\n  flex-direction: column;\r\n  margin-left: -1.5rem;\r\n  margin-right: -1.5rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {\r\n  padding: 0.675rem 1.5rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item {\r\n  margin-top: 2px;\r\n}\r\n\r\n/*.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item>.nav-link.active {\r\n  background: #f6f9fc;\r\n  margin-right: 0.5rem;\r\n  margin-left: 0.5rem;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  border-radius: 0.375rem;\r\n}*/\r\n\r\n.navbar-vertical.navbar-expand-xs .lavalamp-object {\r\n  width: calc(100% - 1rem) !important;\r\n  background: #5e72e4;\r\n  color: #fff;\r\n  margin-right: 0.5rem;\r\n  margin-left: 0.5rem;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link {\r\n  padding-top: 0.45rem;\r\n  padding-bottom: 0.45rem;\r\n  padding-left: 15px;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-normal {\r\n  padding-left: 8px;\r\n  transition: all 0.1s ease 0s;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-mini-icon {\r\n  width: 34px;\r\n  text-align: center;\r\n  transition: all 0.1s ease 0s;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav .nav-link {\r\n  padding-left: 4.25rem;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .navbar-vertical.navbar-expand-sm {\r\n    display: block;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    max-width: 62px;\r\n    overflow-y: auto;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-inner {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm>[class*=\"container\"] {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    min-height: 100%;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 576px) and (-ms-high-contrast: none),\r\n(min-width: 576px) and (-ms-high-contrast: active) {\r\n  .navbar-vertical.navbar-expand-sm>[class*=\"container\"] {\r\n    min-height: none;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .navbar-vertical.navbar-expand-sm.fixed-left {\r\n    left: 0;\r\n    border-width: 0 1px 0 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm.fixed-right {\r\n    right: 0;\r\n    border-width: 0 0 0 1px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-collapse {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-collapse>* {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav {\r\n    flex-direction: column;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link {\r\n    padding: 0.675rem 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav>.nav-item {\r\n    margin-top: 2px;\r\n  }\r\n\r\n  /*.navbar-vertical.navbar-expand-sm .navbar-nav>.nav-item>.nav-link.active {\r\n    background: #f6f9fc;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }*/\r\n\r\n  .navbar-vertical.navbar-expand-sm .lavalamp-object {\r\n    width: calc(100% - 1rem) !important;\r\n    background: #5e72e4;\r\n    color: #fff;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link {\r\n    padding-top: 0.45rem;\r\n    padding-bottom: 0.45rem;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link span.sidenav-normal {\r\n    padding-left: 8px;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link span.sidenav-mini-icon {\r\n    width: 34px;\r\n    text-align: center;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav .nav-link {\r\n    padding-left: 4.25rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-vertical.navbar-expand-md {\r\n    display: block;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    max-width: 62px;\r\n    overflow-y: auto;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-inner {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md>[class*=\"container\"] {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    min-height: 100%;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 768px) and (-ms-high-contrast: none),\r\n(min-width: 768px) and (-ms-high-contrast: active) {\r\n  .navbar-vertical.navbar-expand-md>[class*=\"container\"] {\r\n    min-height: none;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-vertical.navbar-expand-md.fixed-left {\r\n    left: 0;\r\n    border-width: 0 1px 0 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md.fixed-right {\r\n    right: 0;\r\n    border-width: 0 0 0 1px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-collapse {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-collapse>* {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav {\r\n    flex-direction: column;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link {\r\n    padding: 0.675rem 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav>.nav-item {\r\n    margin-top: 2px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav>.nav-item>.nav-link.active {\r\n    background: #f6f9fc;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .lavalamp-object {\r\n    width: calc(100% - 1rem) !important;\r\n    background: #5e72e4;\r\n    color: #fff;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link {\r\n    padding-top: 0.45rem;\r\n    padding-bottom: 0.45rem;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link span.sidenav-normal {\r\n    padding-left: 8px;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link span.sidenav-mini-icon {\r\n    width: 34px;\r\n    text-align: center;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav .nav-link {\r\n    padding-left: 4.25rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .navbar-vertical.navbar-expand-lg {\r\n    display: block;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    max-width: 62px;\r\n    overflow-y: auto;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-inner {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg>[class*=\"container\"] {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    min-height: 100%;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 992px) and (-ms-high-contrast: none),\r\n(min-width: 992px) and (-ms-high-contrast: active) {\r\n  .navbar-vertical.navbar-expand-lg>[class*=\"container\"] {\r\n    min-height: none;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .navbar-vertical.navbar-expand-lg.fixed-left {\r\n    left: 0;\r\n    border-width: 0 1px 0 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg.fixed-right {\r\n    right: 0;\r\n    border-width: 0 0 0 1px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-collapse {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-collapse>* {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav {\r\n    flex-direction: column;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link {\r\n    padding: 0.675rem 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav>.nav-item {\r\n    margin-top: 2px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav>.nav-item>.nav-link.active {\r\n    background: #f6f9fc;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .lavalamp-object {\r\n    width: calc(100% - 1rem) !important;\r\n    background: #5e72e4;\r\n    color: #fff;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link {\r\n    padding-top: 0.45rem;\r\n    padding-bottom: 0.45rem;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link span.sidenav-normal {\r\n    padding-left: 8px;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link span.sidenav-mini-icon {\r\n    width: 34px;\r\n    text-align: center;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav .nav-link {\r\n    padding-left: 4.25rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .navbar-vertical.navbar-expand-xl {\r\n    display: block;\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    max-width: 62px;\r\n    overflow-y: auto;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-inner {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl>[class*=\"container\"] {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    min-height: 100%;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1200px) and (-ms-high-contrast: none),\r\n(min-width: 1200px) and (-ms-high-contrast: active) {\r\n  .navbar-vertical.navbar-expand-xl>[class*=\"container\"] {\r\n    min-height: none;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .navbar-vertical.navbar-expand-xl.fixed-left {\r\n    left: 0;\r\n    border-width: 0 1px 0 0;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl.fixed-right {\r\n    right: 0;\r\n    border-width: 0 0 0 1px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-collapse {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-collapse>* {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav {\r\n    flex-direction: column;\r\n    margin-left: -1.5rem;\r\n    margin-right: -1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link {\r\n    padding: 0.675rem 1.5rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav>.nav-item {\r\n    margin-top: 2px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav>.nav-item>.nav-link.active {\r\n    background: #f6f9fc;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .lavalamp-object {\r\n    width: calc(100% - 1rem) !important;\r\n    background: #5e72e4;\r\n    color: #fff;\r\n    margin-right: 0.5rem;\r\n    margin-left: 0.5rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0.375rem;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link {\r\n    padding-top: 0.45rem;\r\n    padding-bottom: 0.45rem;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link span.sidenav-normal {\r\n    padding-left: 8px;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link span.sidenav-mini-icon {\r\n    width: 34px;\r\n    text-align: center;\r\n    transition: all 0.1s ease 0s;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav .nav-link {\r\n    padding-left: 4.25rem;\r\n  }\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs.fixed-left+.main-content {\r\n  margin-left: 62px;\r\n}\r\n\r\n.navbar-vertical.navbar-expand-xs.fixed-right+.main-content {\r\n  margin-right: 62px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .navbar-vertical.navbar-expand-sm.fixed-left+.main-content {\r\n    margin-left: 62px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-sm.fixed-right+.main-content {\r\n    margin-right: 62px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-vertical.navbar-expand-md.fixed-left+.main-content {\r\n    margin-left: 62px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-md.fixed-right+.main-content {\r\n    margin-right: 62px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .navbar-vertical.navbar-expand-lg.fixed-left+.main-content {\r\n    margin-left: 62px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-lg.fixed-right+.main-content {\r\n    margin-right: 62px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .navbar-vertical.navbar-expand-xl.fixed-left+.main-content {\r\n    margin-left: 62px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xl.fixed-right+.main-content {\r\n    margin-right: 62px;\r\n  }\r\n}\r\n\r\n.sidenav.fixed-left+.main-content {\r\n  margin-left: 62px;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sidenav.fixed-left+.main-content {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.sidenav.fixed-right+.main-content {\r\n  margin-right: 62px;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sidenav.fixed-right+.main-content {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .g-sidenav-pinned .sidenav.fixed-left+.main-content {\r\n    margin-left: 250px;\r\n  }\r\n\r\n  .g-sidenav-pinned .sidenav.fixed-right+.main-content {\r\n    margin-right: 250px;\r\n  }\r\n}\r\n\r\n.sidenav {\r\n  z-index: 1050;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .sidenav:hover {\r\n    max-width: 250px;\r\n  }\r\n\r\n  .sidenav .sidenav-toggler {\r\n    padding: 1.5rem;\r\n  }\r\n}\r\n\r\n.sidenav .navbar-brand,\r\n.sidenav .navbar-heading .docs-normal {\r\n  display: none;\r\n}\r\n\r\n.sidenav .navbar-heading .docs-mini {\r\n  padding-left: 3px;\r\n}\r\n\r\n.sidenav .navbar-heading {\r\n  transition: all 0.1s ease;\r\n}\r\n\r\n.sidenav .navbar-brand {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.sidenav-header {\r\n  height: 78px;\r\n}\r\n\r\n.g-sidenav-show .sidenav .navbar-brand,\r\n.g-sidenav-show .sidenav .navbar-heading .docs-normal {\r\n  display: block;\r\n}\r\n\r\n.g-sidenav-show .sidenav .navbar-heading .docs-mini {\r\n  display: none;\r\n}\r\n\r\n.g-sidenav-show .sidenav .nav-item .collapse {\r\n  height: auto;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .g-sidenav-show .sidenav .nav-item .collapse {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.g-sidenav-show .sidenav .nav-link-text {\r\n  transition: 0.3s ease;\r\n  opacity: 1;\r\n}\r\n\r\n.g-sidenav-show .sidenav .nav-item .sidenav-mini-icon {\r\n  opacity: 0;\r\n}\r\n\r\n.g-sidenav-pinned .sidenav {\r\n  max-width: 250px !important;\r\n}\r\n\r\n.g-sidenav-pinned .sidenav .navbar-brand,\r\n.g-sidenav-pinned .sidenav .navbar-heading {\r\n  display: block;\r\n}\r\n\r\n.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .navbar-nav>.nav-item>.nav-link:after {\r\n  content: \"\";\r\n}\r\n\r\n.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .nav-item .collapse .sidenav-normal {\r\n  display: none !important;\r\n}\r\n\r\n.g-sidenav-hidden:not(.g-sidenav-show) .sidenav .nav-link-text {\r\n  opacity: 0;\r\n}\r\n\r\n.g-sidenav-hide .sidenav .navbar-nav>.nav-item>.nav-link:after {\r\n  content: \"\";\r\n}\r\n\r\n.g-sidenav-hide .sidenav .nav-item .collapse .sidenav-normal {\r\n  display: none !important;\r\n}\r\n\r\n.g-sidenav-hide .sidenav .nav-link-text {\r\n  opacity: 0;\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n  .sidenav {\r\n    transform: translateX(-62px);\r\n  }\r\n\r\n  .sidenav.fixed-left+.main-content {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .g-sidenav-pinned .sidenav {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.sidenav-toggler-inner,\r\n.sidenav-toggler-line {\r\n  width: 18px;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .sidenav-toggler-inner,\r\n  .sidenav-toggler-line {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.sidenav-toggler-inner {\r\n  position: relative;\r\n}\r\n\r\n.sidenav-toggler-inner:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 40px;\r\n  height: 40px;\r\n  left: -11px;\r\n  top: -14px;\r\n  border-radius: 50%;\r\n  transform: scale(0);\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sidenav-toggler-inner:before {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.sidenav-toggler-line {\r\n  height: 2px;\r\n  background-color: #172b4d;\r\n  display: block;\r\n  position: relative;\r\n}\r\n\r\n.sidenav-toggler-line:not(:last-child) {\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.sidenav-toggler-dark .sidenav-toggler-line {\r\n  background-color: #fff;\r\n}\r\n\r\n.sidenav-toggler {\r\n  cursor: pointer;\r\n}\r\n\r\n.sidenav-toggler.active .sidenav-toggler-inner:before {\r\n  transform: scale(1);\r\n}\r\n\r\n.sidenav-toggler.active .sidenav-toggler-line:first-child {\r\n  width: 13px;\r\n  transform: translateX(5px);\r\n}\r\n\r\n.sidenav-toggler.active .sidenav-toggler-line:last-child {\r\n  width: 13px;\r\n  transform: translateX(5px);\r\n}\r\n\r\n.navbar-search .input-group {\r\n  border-radius: 2rem;\r\n  border: 0 solid;\r\n  transition: background-color 0.3s linear;\r\n  transition-delay: 0.15s;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .navbar-search .input-group {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.navbar-search .input-group .input-group-text {\r\n  background-color: transparent;\r\n  padding-left: 1rem;\r\n  border: 0;\r\n}\r\n\r\n.navbar-search .form-control {\r\n  width: 250px;\r\n  background-color: transparent;\r\n  border: 0;\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .navbar-search .form-control {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.navbar-search .focused .input-group .form-control {\r\n  width: 380px;\r\n}\r\n\r\n.navbar-search .close {\r\n  display: none;\r\n}\r\n\r\n.navbar-search-dark .input-group {\r\n  background-color: rgba(23, 43, 77, 0.8);\r\n  border-color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.navbar-search-dark .input-group-text {\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.navbar-search-dark .form-control {\r\n  color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.navbar-search-dark .form-control::placeholder {\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.navbar-search-dark .focused .input-group {\r\n  background-color: rgba(23, 43, 77, 0.9);\r\n  border-color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.navbar-search-light .input-group {\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  border-color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.navbar-search-light .input-group-text {\r\n  color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.navbar-search-light .form-control {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-search-light .form-control::placeholder {\r\n  color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.navbar-search-light .focused .input-group {\r\n  background-color: white;\r\n  border-color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .navbar-search {\r\n    display: none;\r\n    width: 100%;\r\n    transform: translateX(-150%);\r\n    transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\r\n  .navbar-search {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .navbar-search .form-group {\r\n    width: 100%;\r\n  }\r\n\r\n  .navbar-search .form-control {\r\n    width: auto;\r\n  }\r\n\r\n  .navbar-search .focused .input-group .form-control {\r\n    width: auto;\r\n  }\r\n\r\n  .navbar-search .close {\r\n    display: none;\r\n    opacity: 0;\r\n  }\r\n\r\n  .navbar-search .close span {\r\n    width: auto;\r\n    height: auto;\r\n  }\r\n\r\n  .navbar-top .navbar-nav {\r\n    transition: all 0.15s ease;\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\r\n  .navbar-top .navbar-nav {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .g-navbar-search-showing .navbar-search .close {\r\n    display: block;\r\n  }\r\n\r\n  .g-navbar-search-showing .navbar-top .navbar-nav {\r\n    display: flex;\r\n    opacity: 1;\r\n    transform: translateX(150%);\r\n  }\r\n\r\n  .g-navbar-search-show .navbar-search {\r\n    display: block;\r\n  }\r\n\r\n  .g-navbar-search-show .navbar-search .form-control {\r\n    width: auto;\r\n  }\r\n\r\n  .g-navbar-search-show .navbar-search .close {\r\n    color: white;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 46px;\r\n    height: 46px;\r\n    text-align: center;\r\n    line-height: 46px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .g-navbar-search-show .navbar-top .navbar-nav {\r\n    display: none;\r\n  }\r\n\r\n  .g-navbar-search-show .navbar-top .navbar-collapse {\r\n    width: 100%;\r\n  }\r\n\r\n  .g-navbar-search-shown .navbar-search {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .g-navbar-search-shown .navbar-search .close {\r\n    display: block;\r\n    opacity: 1;\r\n  }\r\n\r\n  .g-navbar-search-hiding .navbar-top .navbar-nav {\r\n    display: flex;\r\n    opacity: 0;\r\n    transform: translateX(150%);\r\n  }\r\n\r\n  .g-navbar-search-hidden .navbar-top .navbar-nav {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.navbar .dropdown-menu {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  margin: 0;\r\n}\r\n\r\n.navbar .dropdown-menu-arrow:before {\r\n  background: #fff;\r\n  box-shadow: none;\r\n  content: \"\";\r\n  display: block;\r\n  height: 12px;\r\n  width: 12px;\r\n  left: 20px;\r\n  position: absolute;\r\n  bottom: 100%;\r\n  transform: rotate(-45deg) translateY(12px);\r\n  z-index: -5;\r\n  border-radius: 2px;\r\n}\r\n\r\n.navbar .dropdown-menu-right:before {\r\n  right: 20px;\r\n  left: auto;\r\n}\r\n\r\n.navbar:not(.navbar-nav-hover) .dropdown-menu.show {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n  animation: show-navbar-dropdown 0.25s ease forwards;\r\n}\r\n\r\n.navbar:not(.navbar-nav-hover) .dropdown-menu.close {\r\n  display: block;\r\n  animation: hide-navbar-dropdown 0.15s ease backwards;\r\n}\r\n\r\n.navbar.navbar-nav-hover .dropdown-menu {\r\n  opacity: 0;\r\n  display: block;\r\n  pointer-events: none;\r\n  transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n  transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n}\r\n\r\n.navbar.navbar-nav-hover .nav-item.dropdown:hover>.dropdown-menu {\r\n  display: block;\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n  visibility: visible;\r\n  transform: translate(0, 0);\r\n  animation: none;\r\n}\r\n\r\n.navbar .dropdown-menu-inner {\r\n  position: relative;\r\n  padding: 1rem;\r\n}\r\n\r\n@keyframes show-navbar-dropdown {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(0, 10px) perspective(200px);\r\n    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n  }\r\n\r\n  100% {\r\n    transform: translate(0, 0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes hide-navbar-dropdown {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    transform: translate(0, 10px);\r\n  }\r\n}\r\n\r\n.navbar-collapse-header {\r\n  display: none;\r\n}\r\n\r\n@keyframes show-navbar-collapse {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n    transform-origin: 100% 0;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes hide-navbar-collapse {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n    transform-origin: 100% 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n}\r\n\r\n.navbar-top {\r\n  border: 0;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.navbar-top .container,\r\n.navbar-top .container-fluid,\r\n.navbar-top .container-sm,\r\n.navbar-top .container-md,\r\n.navbar-top .container-lg,\r\n.navbar-top .container-xl {\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .navbar-top .navbar-brand {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .navbar-top .navbar-collapse {\r\n    width: 100%;\r\n  }\r\n\r\n  .navbar-top .nav-item {\r\n    position: static;\r\n  }\r\n\r\n  .navbar-top .nav-item .dropdown-menu {\r\n    position: absolute;\r\n    width: 94%;\r\n    min-width: auto;\r\n    left: 3%;\r\n    right: auto;\r\n  }\r\n}\r\n\r\n.navbar-top.border-bottom.navbar-dark {\r\n  border-color: rgba(255, 255, 255, 0.08) !important;\r\n}\r\n\r\n.navbar-top.border-bottom.navbar-light {\r\n  border-color: rgba(0, 0, 0, 0.04) !important;\r\n}\r\n\r\n.sidenav-pinned .navbar-top .navbar-brand {\r\n  display: none;\r\n}\r\n\r\n.nav-wrapper {\r\n  padding: 1rem 0;\r\n  border-top-left-radius: 0.375rem;\r\n  border-top-right-radius: 0.375rem;\r\n}\r\n\r\n.nav-wrapper+.card {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0.375rem;\r\n  border-bottom-left-radius: 0.375rem;\r\n}\r\n\r\n.nav-link {\r\n  color: #525f7f;\r\n}\r\n\r\n.nav-link:hover {\r\n  color: #5e72e4;\r\n}\r\n\r\n.nav-link i.ni {\r\n  position: relative;\r\n  top: 2px;\r\n}\r\n\r\n.nav-pills .nav-item:not(:last-child) {\r\n  padding-right: 1rem;\r\n}\r\n\r\n.nav-pills .nav-link {\r\n  padding: 0.75rem 1rem;\r\n  color: #5e72e4;\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n  background-color: #fff;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.nav-pills .nav-link:hover {\r\n  color: #485fe0;\r\n}\r\n\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show>.nav-link {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .nav-pills .nav-item {\r\n    margin-bottom: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .nav-pills:not(.nav-pills-circle) .nav-item {\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n.nav-pills-circle .nav-link {\r\n  text-align: center;\r\n  height: 60px;\r\n  width: 60px;\r\n  padding: 0;\r\n  line-height: 60px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.nav-pills-circle .nav-link-icon i,\r\n.nav-pills-circle .nav-link-icon svg {\r\n  font-size: 1rem;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.page-item .page-link,\r\n.page-item span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0;\r\n  margin: 0 3px;\r\n  border-radius: 50% !important;\r\n  width: 36px;\r\n  height: 36px;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.pagination-lg .page-item .page-link,\r\n.pagination-lg .page-item span {\r\n  width: 46px;\r\n  height: 46px;\r\n  line-height: 46px;\r\n}\r\n\r\n.pagination-sm .page-item .page-link,\r\n.pagination-sm .page-item span {\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n}\r\n\r\n.popover {\r\n  border: 0;\r\n}\r\n\r\n.popover-header {\r\n  font-weight: 600;\r\n}\r\n\r\n.popover-primary {\r\n  background-color: #5e72e4;\r\n}\r\n\r\n.popover-primary .popover-header {\r\n  background-color: #5e72e4;\r\n  color: #fff;\r\n}\r\n\r\n.popover-primary .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-primary .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-primary.bs-popover-top .arrow::after,\r\n.popover-primary.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #5e72e4;\r\n}\r\n\r\n.popover-primary.bs-popover-right .arrow::after,\r\n.popover-primary.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #5e72e4;\r\n}\r\n\r\n.popover-primary.bs-popover-bottom .arrow::after,\r\n.popover-primary.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #5e72e4;\r\n}\r\n\r\n.popover-primary.bs-popover-left .arrow::after,\r\n.popover-primary.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #5e72e4;\r\n}\r\n\r\n.popover-secondary {\r\n  background-color: #f7fafc;\r\n}\r\n\r\n.popover-secondary .popover-header {\r\n  background-color: #f7fafc;\r\n  color: #212529;\r\n}\r\n\r\n.popover-secondary .popover-body {\r\n  color: #212529;\r\n}\r\n\r\n.popover-secondary .popover-header {\r\n  border-color: rgba(33, 37, 41, 0.2);\r\n}\r\n\r\n.popover-secondary.bs-popover-top .arrow::after,\r\n.popover-secondary.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #f7fafc;\r\n}\r\n\r\n.popover-secondary.bs-popover-right .arrow::after,\r\n.popover-secondary.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #f7fafc;\r\n}\r\n\r\n.popover-secondary.bs-popover-bottom .arrow::after,\r\n.popover-secondary.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #f7fafc;\r\n}\r\n\r\n.popover-secondary.bs-popover-left .arrow::after,\r\n.popover-secondary.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #f7fafc;\r\n}\r\n\r\n.popover-success {\r\n  background-color: #2dce89;\r\n}\r\n\r\n.popover-success .popover-header {\r\n  background-color: #2dce89;\r\n  color: #fff;\r\n}\r\n\r\n.popover-success .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-success .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-success.bs-popover-top .arrow::after,\r\n.popover-success.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #2dce89;\r\n}\r\n\r\n.popover-success.bs-popover-right .arrow::after,\r\n.popover-success.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #2dce89;\r\n}\r\n\r\n.popover-success.bs-popover-bottom .arrow::after,\r\n.popover-success.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #2dce89;\r\n}\r\n\r\n.popover-success.bs-popover-left .arrow::after,\r\n.popover-success.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #2dce89;\r\n}\r\n\r\n.popover-info {\r\n  background-color: #11cdef;\r\n}\r\n\r\n.popover-info .popover-header {\r\n  background-color: #11cdef;\r\n  color: #fff;\r\n}\r\n\r\n.popover-info .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-info .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-info.bs-popover-top .arrow::after,\r\n.popover-info.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #11cdef;\r\n}\r\n\r\n.popover-info.bs-popover-right .arrow::after,\r\n.popover-info.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #11cdef;\r\n}\r\n\r\n.popover-info.bs-popover-bottom .arrow::after,\r\n.popover-info.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #11cdef;\r\n}\r\n\r\n.popover-info.bs-popover-left .arrow::after,\r\n.popover-info.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #11cdef;\r\n}\r\n\r\n.popover-warning {\r\n  background-color: #fb6340;\r\n}\r\n\r\n.popover-warning .popover-header {\r\n  background-color: #fb6340;\r\n  color: #fff;\r\n}\r\n\r\n.popover-warning .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-warning .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-warning.bs-popover-top .arrow::after,\r\n.popover-warning.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #fb6340;\r\n}\r\n\r\n.popover-warning.bs-popover-right .arrow::after,\r\n.popover-warning.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #fb6340;\r\n}\r\n\r\n.popover-warning.bs-popover-bottom .arrow::after,\r\n.popover-warning.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #fb6340;\r\n}\r\n\r\n.popover-warning.bs-popover-left .arrow::after,\r\n.popover-warning.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #fb6340;\r\n}\r\n\r\n.popover-danger {\r\n  background-color: #f5365c;\r\n}\r\n\r\n.popover-danger .popover-header {\r\n  background-color: #f5365c;\r\n  color: #fff;\r\n}\r\n\r\n.popover-danger .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-danger .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-danger.bs-popover-top .arrow::after,\r\n.popover-danger.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #f5365c;\r\n}\r\n\r\n.popover-danger.bs-popover-right .arrow::after,\r\n.popover-danger.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #f5365c;\r\n}\r\n\r\n.popover-danger.bs-popover-bottom .arrow::after,\r\n.popover-danger.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #f5365c;\r\n}\r\n\r\n.popover-danger.bs-popover-left .arrow::after,\r\n.popover-danger.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #f5365c;\r\n}\r\n\r\n.popover-light {\r\n  background-color: #adb5bd;\r\n}\r\n\r\n.popover-light .popover-header {\r\n  background-color: #adb5bd;\r\n  color: #fff;\r\n}\r\n\r\n.popover-light .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-light .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-light.bs-popover-top .arrow::after,\r\n.popover-light.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #adb5bd;\r\n}\r\n\r\n.popover-light.bs-popover-right .arrow::after,\r\n.popover-light.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #adb5bd;\r\n}\r\n\r\n.popover-light.bs-popover-bottom .arrow::after,\r\n.popover-light.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #adb5bd;\r\n}\r\n\r\n.popover-light.bs-popover-left .arrow::after,\r\n.popover-light.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #adb5bd;\r\n}\r\n\r\n.popover-dark {\r\n  background-color: #212529;\r\n}\r\n\r\n.popover-dark .popover-header {\r\n  background-color: #212529;\r\n  color: #fff;\r\n}\r\n\r\n.popover-dark .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-dark .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-dark.bs-popover-top .arrow::after,\r\n.popover-dark.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #212529;\r\n}\r\n\r\n.popover-dark.bs-popover-right .arrow::after,\r\n.popover-dark.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #212529;\r\n}\r\n\r\n.popover-dark.bs-popover-bottom .arrow::after,\r\n.popover-dark.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #212529;\r\n}\r\n\r\n.popover-dark.bs-popover-left .arrow::after,\r\n.popover-dark.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #212529;\r\n}\r\n\r\n.popover-default {\r\n  background-color: #172b4d;\r\n}\r\n\r\n.popover-default .popover-header {\r\n  background-color: #172b4d;\r\n  color: #fff;\r\n}\r\n\r\n.popover-default .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-default .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-default.bs-popover-top .arrow::after,\r\n.popover-default.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #172b4d;\r\n}\r\n\r\n.popover-default.bs-popover-right .arrow::after,\r\n.popover-default.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #172b4d;\r\n}\r\n\r\n.popover-default.bs-popover-bottom .arrow::after,\r\n.popover-default.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #172b4d;\r\n}\r\n\r\n.popover-default.bs-popover-left .arrow::after,\r\n.popover-default.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #172b4d;\r\n}\r\n\r\n.popover-white {\r\n  background-color: #fff;\r\n}\r\n\r\n.popover-white .popover-header {\r\n  background-color: #fff;\r\n  color: #212529;\r\n}\r\n\r\n.popover-white .popover-body {\r\n  color: #212529;\r\n}\r\n\r\n.popover-white .popover-header {\r\n  border-color: rgba(33, 37, 41, 0.2);\r\n}\r\n\r\n.popover-white.bs-popover-top .arrow::after,\r\n.popover-white.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #fff;\r\n}\r\n\r\n.popover-white.bs-popover-right .arrow::after,\r\n.popover-white.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #fff;\r\n}\r\n\r\n.popover-white.bs-popover-bottom .arrow::after,\r\n.popover-white.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #fff;\r\n}\r\n\r\n.popover-white.bs-popover-left .arrow::after,\r\n.popover-white.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #fff;\r\n}\r\n\r\n.popover-neutral {\r\n  background-color: #fff;\r\n}\r\n\r\n.popover-neutral .popover-header {\r\n  background-color: #fff;\r\n  color: #212529;\r\n}\r\n\r\n.popover-neutral .popover-body {\r\n  color: #212529;\r\n}\r\n\r\n.popover-neutral .popover-header {\r\n  border-color: rgba(33, 37, 41, 0.2);\r\n}\r\n\r\n.popover-neutral.bs-popover-top .arrow::after,\r\n.popover-neutral.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: #fff;\r\n}\r\n\r\n.popover-neutral.bs-popover-right .arrow::after,\r\n.popover-neutral.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: #fff;\r\n}\r\n\r\n.popover-neutral.bs-popover-bottom .arrow::after,\r\n.popover-neutral.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: #fff;\r\n}\r\n\r\n.popover-neutral.bs-popover-left .arrow::after,\r\n.popover-neutral.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: #fff;\r\n}\r\n\r\n.popover-darker {\r\n  background-color: black;\r\n}\r\n\r\n.popover-darker .popover-header {\r\n  background-color: black;\r\n  color: #fff;\r\n}\r\n\r\n.popover-darker .popover-body {\r\n  color: #fff;\r\n}\r\n\r\n.popover-darker .popover-header {\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.popover-darker.bs-popover-top .arrow::after,\r\n.popover-darker.bs-popover-auto[x-placement^=\"top\"] .arrow::after {\r\n  border-top-color: black;\r\n}\r\n\r\n.popover-darker.bs-popover-right .arrow::after,\r\n.popover-darker.bs-popover-auto[x-placement^=\"right\"] .arrow::after {\r\n  border-right-color: black;\r\n}\r\n\r\n.popover-darker.bs-popover-bottom .arrow::after,\r\n.popover-darker.bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\r\n  border-bottom-color: black;\r\n}\r\n\r\n.popover-darker.bs-popover-left .arrow::after,\r\n.popover-darker.bs-popover-auto[x-placement^=\"left\"] .arrow::after {\r\n  border-left-color: black;\r\n}\r\n\r\n.progress-wrapper {\r\n  position: relative;\r\n  padding-top: 1.5rem;\r\n}\r\n\r\n.progress {\r\n  height: 8px;\r\n  margin-bottom: 1rem;\r\n  overflow: hidden;\r\n  border-radius: 0.25rem;\r\n  background-color: #e9ecef;\r\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.progress .sr-only {\r\n  width: auto;\r\n  height: 20px;\r\n  margin: 0 0 0 30px;\r\n  left: 0;\r\n  clip: auto;\r\n  line-height: 20px;\r\n  font-size: 13px;\r\n}\r\n\r\n.progress-sm {\r\n  height: 5px;\r\n}\r\n\r\n.progress-xs {\r\n  height: 3px;\r\n}\r\n\r\n.progress-heading {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin: 0 0 2px;\r\n  padding: 0;\r\n}\r\n\r\n.progress-bar {\r\n  box-shadow: none;\r\n  border-radius: 0;\r\n  height: auto;\r\n}\r\n\r\n.progress-info {\r\n  margin-bottom: 0.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.progress-label span {\r\n  display: inline-block;\r\n  color: #5e72e4;\r\n  font-size: 0.625rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  background: rgba(94, 114, 228, 0.1);\r\n  padding: 0.25rem 1rem;\r\n  border-radius: 30px;\r\n}\r\n\r\n.progress-percentage {\r\n  text-align: right;\r\n}\r\n\r\n.progress-percentage span {\r\n  display: inline-block;\r\n  color: #8898aa;\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.rtl.g-sidenav-pinned .sidenav+.main-content {\r\n  margin-right: 250px;\r\n}\r\n\r\n.rtl .sidenav+.main-content {\r\n  margin-right: 62px;\r\n}\r\n\r\n.rtl .sidenav .navbar-nav {\r\n  padding-right: 0;\r\n}\r\n\r\n.rtl .sidenav .navbar-nav .nav-link>i {\r\n  min-width: auto;\r\n  margin-left: 1rem;\r\n}\r\n\r\n.rtl .sidenav .navbar-nav .nav-link[data-toggle=\"collapse\"]:after {\r\n  margin-right: auto;\r\n  margin-left: initial;\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.rtl .sidenav .navbar-nav .nav-link[data-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\r\n  transform: rotate(90deg) !important;\r\n}\r\n\r\n.rtl .sidenav .navbar-nav .nav .nav-link {\r\n  padding-right: 15px;\r\n}\r\n\r\n.rtl .sidenav .sidenav-toggler.active .sidenav-toggler-line:first-child {\r\n  transform: translateX(0);\r\n}\r\n\r\n.rtl .sidenav .sidenav-toggler.active .sidenav-toggler-line:last-child {\r\n  transform: translateX(0);\r\n}\r\n\r\n.rtl .sidenav .navbar-heading {\r\n  text-align: right;\r\n}\r\n\r\n.rtl .sidenav .scrollbar-inner {\r\n  direction: initial;\r\n}\r\n\r\n.rtl .sidenav .scrollbar-inner .navbar-nav {\r\n  direction: rtl;\r\n}\r\n\r\n.rtl .sidenav .navbar-heading .docs-mini {\r\n  padding-left: 0;\r\n  padding-right: 3px;\r\n}\r\n\r\n.rtl .navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-normal {\r\n  padding-right: 8px;\r\n}\r\n\r\n.rtl .dropdown-menu-left {\r\n  text-align: right;\r\n}\r\n\r\n.rtl .card .card-body {\r\n  text-align: right;\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n  .rtl .sidenav {\r\n    transform: translateX(62px);\r\n  }\r\n\r\n  .rtl .sidenav+.main-content {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .rtl .sidenav-toggler.active .sidenav-toggler-line:first-child {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .rtl .sidenav-toggler.active .sidenav-toggler-line:last-child {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .rtl.g-sidenav-pinned .sidenav {\r\n    transform: translateX(0) !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .rtl .navbar-expand .navbar-nav .nav-link {\r\n    padding-left: 0;\r\n  }\r\n\r\n  .rtl.g-navbar-search-show .navbar-search .close {\r\n    left: 0;\r\n    right: auto;\r\n  }\r\n\r\n  .rtl .navbar-search {\r\n    transform: translateX(150%);\r\n  }\r\n\r\n  .rtl.g-navbar-search-shown .navbar-search {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.separator {\r\n  position: absolute;\r\n  top: auto;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 150px;\r\n  transform: translateZ(0);\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n}\r\n\r\n.separator svg {\r\n  position: absolute;\r\n  pointer-events: none;\r\n}\r\n\r\n.separator-top {\r\n  top: 0;\r\n  bottom: auto;\r\n}\r\n\r\n.separator-top svg {\r\n  top: 0;\r\n}\r\n\r\n.separator-bottom {\r\n  top: auto;\r\n  bottom: 0;\r\n}\r\n\r\n.separator-bottom svg {\r\n  bottom: 0;\r\n}\r\n\r\n.separator-inverse {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.separator-skew {\r\n  height: 60px;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .separator-skew {\r\n    height: 70px;\r\n  }\r\n}\r\n\r\n.section-nucleo-icons {\r\n  --icon-size: 5rem;\r\n  --icon-sm-size: 3.75rem;\r\n  --gutter: 7rem;\r\n}\r\n\r\n.section-nucleo-icons .icons-container {\r\n  position: relative;\r\n  max-width: 100%;\r\n  height: 360px;\r\n  margin: 0 auto;\r\n  z-index: 1;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i {\r\n  position: absolute;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  z-index: 1;\r\n  transform: translate(-50%, -50%);\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);\r\n  transition: all 0.2s cubic-bezier(0.25, 0.65, 0.9, 0.75);\r\n}\r\n\r\n.section-nucleo-icons .icons-container i.icon {\r\n  width: var(--icon-size);\r\n  height: var(--icon-size);\r\n  font-size: 1.7em;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i.icon-sm {\r\n  width: var(--icon-sm-size);\r\n  height: var(--icon-sm-size);\r\n  font-size: 1.5em;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(1) {\r\n  font-size: 42px;\r\n  color: #fb6340;\r\n  z-index: 2;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i {\r\n  opacity: 1;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(1) {\r\n  left: 50%;\r\n  top: 50%;\r\n  font-size: 42px;\r\n  color: #fb6340;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(2) {\r\n  left: calc(50% + (var(--gutter) * 1.7));\r\n  top: 50%;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(3) {\r\n  left: calc(50% + var(--gutter));\r\n  top: calc(50% + var(--gutter));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(4) {\r\n  left: calc(50% + var(--gutter));\r\n  top: calc(50% - var(--gutter));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(5) {\r\n  left: calc(50% + (var(--gutter) * 4));\r\n  top: 50%;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(6) {\r\n  left: calc(50% + (var(--gutter) * 2.7));\r\n  top: calc(50% + (var(--gutter) * 1.5));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(7) {\r\n  left: calc(50% + (var(--gutter) * 2.7));\r\n  top: calc(50% - (var(--gutter) * 1.5));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(8) {\r\n  left: calc(50% - (var(--gutter) * 1.7));\r\n  top: 50%;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(9) {\r\n  left: calc(50% - var(--gutter));\r\n  top: calc(50% + var(--gutter));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(10) {\r\n  left: calc(50% - var(--gutter));\r\n  top: calc(50% - var(--gutter));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(11) {\r\n  left: calc(50% - (var(--gutter) * 4));\r\n  top: 50%;\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(12) {\r\n  left: calc(50% - (var(--gutter) * 2.7));\r\n  top: calc(50% + (var(--gutter) * 1.5));\r\n}\r\n\r\n.section-nucleo-icons .icons-container i:nth-child(13) {\r\n  left: calc(50% - (var(--gutter) * 2.7));\r\n  top: calc(50% - (var(--gutter) * 1.5));\r\n}\r\n\r\n.home-child .sidebar-icon i {\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.sidebar-icon-img {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  margin-right: 0.5rem;\r\n  object-fit: contain;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.navbar-dark .sidebar-icon-img {\r\n  filter: none;\r\n  opacity: 0.85;\r\n}\r\n\r\n.sidebar-icon {\r\n  width: 1.75rem;\r\n  /* matches Argon nav icon column */\r\n  min-width: 1.75rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.sidebar-icon-img {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  object-fit: contain;\r\n}\r\n\r\n.shortcut-media {\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .shortcut-media {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.shortcut-item {\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.shortcut-item small {\r\n  display: block;\r\n  margin-top: 0.75rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.shortcut-item:hover .shortcut-media {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.table thead th {\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  font-size: 0.65rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.table th {\r\n  font-weight: 600;\r\n}\r\n\r\n.table td .progress {\r\n  height: 3px;\r\n  width: 120px;\r\n  margin: 0;\r\n}\r\n\r\n.table td,\r\n.table th {\r\n  font-size: 0.8125rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.table.align-items-center td,\r\n.table.align-items-center th {\r\n  vertical-align: middle;\r\n}\r\n\r\n.table .thead-dark th {\r\n  background-color: #1c345d;\r\n  color: #4d7bca;\r\n}\r\n\r\n.table .thead-dark th a {\r\n  color: #4d7bca;\r\n}\r\n\r\n.table .thead-light th {\r\n  background-color: #f6f9fc;\r\n  color: #000000;\r\n}\r\n\r\n.table .thead-light th a {\r\n  color: #8898aa;\r\n}\r\n\r\n.table-hover tr {\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .table-hover tr {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.table-flush td,\r\n.table-flush th {\r\n  border-left: 0;\r\n  border-right: 0;\r\n}\r\n\r\n.table-flush tbody tr:first-child td,\r\n.table-flush tbody tr:first-child th {\r\n  border-top: 0;\r\n}\r\n\r\n.table-flush tbody tr:last-child td,\r\n.table-flush tbody tr:last-child th {\r\n  border-bottom: 0;\r\n}\r\n\r\n.card .table {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card .table td,\r\n.card .table th {\r\n  padding-left: 1.5rem;\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.table .custom-toggle {\r\n  display: block;\r\n}\r\n\r\n.table-action {\r\n  font-size: 0.875rem;\r\n  color: #adb5bd;\r\n  margin: 0 0.25rem;\r\n}\r\n\r\n.table-action:hover {\r\n  color: #919ca6;\r\n}\r\n\r\n.table-action-delete:hover {\r\n  color: #f5365c;\r\n}\r\n\r\n.table-dark .table-action {\r\n  color: #4d7bca;\r\n}\r\n\r\n.table [data-sort] {\r\n  cursor: pointer;\r\n}\r\n\r\n.table .thead-dark [data-sort]::after {\r\n  content: url(\"data:image/svg+xml;utf8,<svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z' fill='%234d7bca'/></svg>\");\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.table .thead-light [data-sort]::after {\r\n  content: url(\"data:image/svg+xml;utf8,<svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z' fill='%238898aa'/></svg>\");\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.timeline {\r\n  position: relative;\r\n}\r\n\r\n.timeline:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 1rem;\r\n  height: 100%;\r\n  border-right: 2px solid #e9ecef;\r\n}\r\n\r\n[data-timeline-axis-style=\"dashed\"]:before {\r\n  border-right-style: dashed !important;\r\n}\r\n\r\n[data-timeline-axis-style=\"dotted\"]:before {\r\n  border-right-style: dotted !important;\r\n}\r\n\r\n.timeline-block {\r\n  position: relative;\r\n  margin: 2em 0;\r\n}\r\n\r\n.timeline-block:after {\r\n  content: \"\";\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.timeline-block:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.timeline-block:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.timeline-step {\r\n  position: absolute;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  left: 0;\r\n  width: 33px;\r\n  height: 33px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  transform: translateX(-50%);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  z-index: 1;\r\n}\r\n\r\n.timeline-step svg,\r\n.timeline-step i {\r\n  line-height: 1.4;\r\n}\r\n\r\n.timeline-step-icon {\r\n  background: #fff;\r\n  border: 2px solid #e9ecef;\r\n}\r\n\r\n.timeline-step-xs {\r\n  width: 17px;\r\n  height: 17px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.timeline-step-sm {\r\n  width: 23px;\r\n  height: 23px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.timeline-step-lg {\r\n  width: 47px;\r\n  height: 47px;\r\n  font-size: 1.75rem;\r\n}\r\n\r\n.timeline-content {\r\n  position: relative;\r\n  margin-left: 60px;\r\n  padding-top: 0.5rem;\r\n  position: relative;\r\n  top: -6px;\r\n}\r\n\r\n.timeline-content:after {\r\n  content: \"\";\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.timeline-body {\r\n  padding: 1.5rem;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .timeline:before {\r\n    left: 50%;\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .timeline-step {\r\n    left: 50%;\r\n  }\r\n\r\n  .timeline-content {\r\n    width: 38%;\r\n  }\r\n\r\n  .timeline-body {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .timeline-block:nth-child(even) .timeline-content {\r\n    float: right;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"primary\"]:before {\r\n    border-color: #5e72e4;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"secondary\"]:before {\r\n    border-color: #f7fafc;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"success\"]:before {\r\n    border-color: #2dce89;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"info\"]:before {\r\n    border-color: #11cdef;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"warning\"]:before {\r\n    border-color: #fb6340;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"danger\"]:before {\r\n    border-color: #f5365c;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"light\"]:before {\r\n    border-color: #adb5bd;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"dark\"]:before {\r\n    border-color: #212529;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"default\"]:before {\r\n    border-color: #172b4d;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"white\"]:before {\r\n    border-color: #fff;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"neutral\"]:before {\r\n    border-color: #fff;\r\n  }\r\n\r\n  [data-timeline-axis-color=\"darker\"]:before {\r\n    border-color: black;\r\n  }\r\n}\r\n\r\n.timeline-one-side:before {\r\n  left: 1rem;\r\n}\r\n\r\n.timeline-one-side .timeline-step {\r\n  left: 1rem;\r\n}\r\n\r\n.timeline-one-side .timeline-content {\r\n  width: auto;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .timeline-one-side .timeline-content {\r\n    max-width: 30rem;\r\n  }\r\n}\r\n\r\n.timeline-one-side .timeline-block:nth-child(even) .timeline-content {\r\n  float: none;\r\n}\r\n\r\np {\r\n  font-size: 1rem;\r\n  font-weight: 300;\r\n  line-height: 1.7;\r\n}\r\n\r\n.lead {\r\n  font-size: 1.25rem;\r\n  font-weight: 300;\r\n  line-height: 1.7;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.lead+.btn-wrapper {\r\n  margin-top: 3rem;\r\n}\r\n\r\n.description {\r\n  font-size: 0.875rem;\r\n}\r\n\r\narticle h4:not(:first-child),\r\narticle h5:not(:first-child) {\r\n  margin-top: 3rem;\r\n}\r\n\r\narticle h4,\r\narticle h5 {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\narticle figure {\r\n  margin: 3rem 0;\r\n}\r\n\r\narticle h5+figure {\r\n  margin-top: 0;\r\n}\r\n\r\n.display-1 span,\r\n.display-2 span,\r\n.display-3 span,\r\n.display-4 span {\r\n  display: block;\r\n  font-weight: 300;\r\n}\r\n\r\nh1>a,\r\nh2>a,\r\nh3>a,\r\nh4>a,\r\nh5>a,\r\nh6>a {\r\n  color: inherit;\r\n}\r\n\r\n.heading {\r\n  letter-spacing: 0.025em;\r\n  font-size: 0.95rem;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n}\r\n\r\n.heading-small {\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.heading-title {\r\n  letter-spacing: 0.025em;\r\n  font-size: 1.375rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.heading-section {\r\n  letter-spacing: 0.025em;\r\n  font-size: 1.375rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.heading-section img {\r\n  display: block;\r\n  width: 72px;\r\n  height: 72px;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.heading-section.text-center img {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.surtitle {\r\n  text-transform: uppercase;\r\n  color: #8898aa;\r\n  letter-spacing: 2px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.bg-blue {\r\n  background-color: #5e72e4 !important;\r\n}\r\n\r\na.bg-blue:hover,\r\na.bg-blue:focus,\r\nbutton.bg-blue:hover,\r\nbutton.bg-blue:focus {\r\n  background-color: #324cdd !important;\r\n}\r\n\r\n.bg-indigo {\r\n  background-color: #5603ad !important;\r\n}\r\n\r\na.bg-indigo:hover,\r\na.bg-indigo:focus,\r\nbutton.bg-indigo:hover,\r\nbutton.bg-indigo:focus {\r\n  background-color: #3d027b !important;\r\n}\r\n\r\n.bg-purple {\r\n  background-color: #8965e0 !important;\r\n}\r\n\r\na.bg-purple:hover,\r\na.bg-purple:focus,\r\nbutton.bg-purple:hover,\r\nbutton.bg-purple:focus {\r\n  background-color: #683bd7 !important;\r\n}\r\n\r\n.bg-pink {\r\n  background-color: #f3a4b5 !important;\r\n}\r\n\r\na.bg-pink:hover,\r\na.bg-pink:focus,\r\nbutton.bg-pink:hover,\r\nbutton.bg-pink:focus {\r\n  background-color: #ed7790 !important;\r\n}\r\n\r\n.bg-red {\r\n  background-color: #f5365c !important;\r\n}\r\n\r\na.bg-red:hover,\r\na.bg-red:focus,\r\nbutton.bg-red:hover,\r\nbutton.bg-red:focus {\r\n  background-color: #ec0c38 !important;\r\n}\r\n\r\n.bg-orange {\r\n  background-color: #fb6340 !important;\r\n}\r\n\r\na.bg-orange:hover,\r\na.bg-orange:focus,\r\nbutton.bg-orange:hover,\r\nbutton.bg-orange:focus {\r\n  background-color: #fa3a0e !important;\r\n}\r\n\r\n.bg-yellow {\r\n  background-color: #ffd600 !important;\r\n}\r\n\r\na.bg-yellow:hover,\r\na.bg-yellow:focus,\r\nbutton.bg-yellow:hover,\r\nbutton.bg-yellow:focus {\r\n  background-color: #ccab00 !important;\r\n}\r\n\r\n.bg-green {\r\n  background-color: #2dce89 !important;\r\n}\r\n\r\na.bg-green:hover,\r\na.bg-green:focus,\r\nbutton.bg-green:hover,\r\nbutton.bg-green:focus {\r\n  background-color: #24a46d !important;\r\n}\r\n\r\n.bg-teal {\r\n  background-color: #11cdef !important;\r\n}\r\n\r\na.bg-teal:hover,\r\na.bg-teal:focus,\r\nbutton.bg-teal:hover,\r\nbutton.bg-teal:focus {\r\n  background-color: #0da5c0 !important;\r\n}\r\n\r\n.bg-cyan {\r\n  background-color: #2bffc6 !important;\r\n}\r\n\r\na.bg-cyan:hover,\r\na.bg-cyan:focus,\r\nbutton.bg-cyan:hover,\r\nbutton.bg-cyan:focus {\r\n  background-color: #00f7b5 !important;\r\n}\r\n\r\n.bg-white {\r\n  background-color: #fff !important;\r\n}\r\n\r\na.bg-white:hover,\r\na.bg-white:focus,\r\nbutton.bg-white:hover,\r\nbutton.bg-white:focus {\r\n  background-color: #e6e6e6 !important;\r\n}\r\n\r\n.bg-gray {\r\n  background-color: #8898aa !important;\r\n}\r\n\r\na.bg-gray:hover,\r\na.bg-gray:focus,\r\nbutton.bg-gray:hover,\r\nbutton.bg-gray:focus {\r\n  background-color: #6a7e95 !important;\r\n}\r\n\r\n.bg-gray-dark {\r\n  background-color: #32325d !important;\r\n}\r\n\r\na.bg-gray-dark:hover,\r\na.bg-gray-dark:focus,\r\nbutton.bg-gray-dark:hover,\r\nbutton.bg-gray-dark:focus {\r\n  background-color: #20203c !important;\r\n}\r\n\r\n.bg-light {\r\n  background-color: #ced4da !important;\r\n}\r\n\r\na.bg-light:hover,\r\na.bg-light:focus,\r\nbutton.bg-light:hover,\r\nbutton.bg-light:focus {\r\n  background-color: #b1bbc4 !important;\r\n}\r\n\r\n.bg-lighter {\r\n  background-color: #e9ecef !important;\r\n}\r\n\r\na.bg-lighter:hover,\r\na.bg-lighter:focus,\r\nbutton.bg-lighter:hover,\r\nbutton.bg-lighter:focus {\r\n  background-color: #cbd3da !important;\r\n}\r\n\r\n.bg-gradient-primary {\r\n  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;\r\n}\r\n\r\n.bg-gradient-secondary {\r\n  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;\r\n}\r\n\r\n.bg-gradient-success {\r\n  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;\r\n}\r\n\r\n.bg-gradient-info {\r\n  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;\r\n}\r\n\r\n.bg-gradient-warning {\r\n  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;\r\n}\r\n\r\n.bg-gradient-danger {\r\n  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;\r\n}\r\n\r\n.bg-gradient-light {\r\n  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;\r\n}\r\n\r\n.bg-gradient-dark {\r\n  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;\r\n}\r\n\r\n.bg-gradient-default {\r\n  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;\r\n}\r\n\r\n.bg-gradient-white {\r\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\r\n}\r\n\r\n.bg-gradient-neutral {\r\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\r\n}\r\n\r\n.bg-gradient-darker {\r\n  background: linear-gradient(87deg, black 0, black 100%) !important;\r\n}\r\n\r\n.bg-gradient-blue {\r\n  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;\r\n}\r\n\r\n.bg-gradient-indigo {\r\n  background: linear-gradient(87deg, #5603ad 0, #9d03ad 100%) !important;\r\n}\r\n\r\n.bg-gradient-purple {\r\n  background: linear-gradient(87deg, #8965e0 0, #bc65e0 100%) !important;\r\n}\r\n\r\n.bg-gradient-pink {\r\n  background: linear-gradient(87deg, #f3a4b5 0, #f3b4a4 100%) !important;\r\n}\r\n\r\n.bg-gradient-red {\r\n  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;\r\n}\r\n\r\n.bg-gradient-orange {\r\n  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;\r\n}\r\n\r\n.bg-gradient-yellow {\r\n  background: linear-gradient(87deg, #ffd600 0, #beff00 100%) !important;\r\n}\r\n\r\n.bg-gradient-green {\r\n  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;\r\n}\r\n\r\n.bg-gradient-teal {\r\n  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;\r\n}\r\n\r\n.bg-gradient-cyan {\r\n  background: linear-gradient(87deg, #2bffc6 0, #2be0ff 100%) !important;\r\n}\r\n\r\n.bg-gradient-white {\r\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\r\n}\r\n\r\n.bg-gradient-gray {\r\n  background: linear-gradient(87deg, #8898aa 0, #888aaa 100%) !important;\r\n}\r\n\r\n.bg-gradient-gray-dark {\r\n  background: linear-gradient(87deg, #32325d 0, #44325d 100%) !important;\r\n}\r\n\r\n.bg-gradient-light {\r\n  background: linear-gradient(87deg, #ced4da 0, #cecfda 100%) !important;\r\n}\r\n\r\n.bg-gradient-lighter {\r\n  background: linear-gradient(87deg, #e9ecef 0, #e9eaef 100%) !important;\r\n}\r\n\r\n.bg-translucent-primary {\r\n  background-color: rgba(63, 87, 223, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-primary:hover,\r\na.bg-translucent-primary:focus,\r\nbutton.bg-translucent-primary:hover,\r\nbutton.bg-translucent-primary:focus {\r\n  background-color: rgba(42, 68, 219, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-secondary {\r\n  background-color: rgba(221, 234, 242, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-secondary:hover,\r\na.bg-translucent-secondary:focus,\r\nbutton.bg-translucent-secondary:hover,\r\nbutton.bg-translucent-secondary:focus {\r\n  background-color: rgba(202, 222, 235, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-success {\r\n  background-color: rgba(39, 177, 118, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-success:hover,\r\na.bg-translucent-success:focus,\r\nbutton.bg-translucent-success:hover,\r\nbutton.bg-translucent-success:focus {\r\n  background-color: rgba(34, 156, 104, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-info {\r\n  background-color: rgba(14, 177, 206, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-info:hover,\r\na.bg-translucent-info:focus,\r\nbutton.bg-translucent-info:hover,\r\nbutton.bg-translucent-info:focus {\r\n  background-color: rgba(12, 156, 183, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-warning {\r\n  background-color: rgba(250, 70, 29, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-warning:hover,\r\na.bg-translucent-warning:focus,\r\nbutton.bg-translucent-warning:hover,\r\nbutton.bg-translucent-warning:focus {\r\n  background-color: rgba(249, 51, 5, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-danger {\r\n  background-color: rgba(243, 20, 64, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-danger:hover,\r\na.bg-translucent-danger:focus,\r\nbutton.bg-translucent-danger:hover,\r\nbutton.bg-translucent-danger:focus {\r\n  background-color: rgba(227, 11, 54, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-light {\r\n  background-color: rgba(153, 163, 173, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-light:hover,\r\na.bg-translucent-light:focus,\r\nbutton.bg-translucent-light:hover,\r\nbutton.bg-translucent-light:focus {\r\n  background-color: rgba(139, 150, 162, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-dark {\r\n  background-color: rgba(17, 19, 21, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-dark:hover,\r\na.bg-translucent-dark:focus,\r\nbutton.bg-translucent-dark:hover,\r\nbutton.bg-translucent-dark:focus {\r\n  background-color: rgba(6, 6, 7, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-default {\r\n  background-color: rgba(15, 28, 50, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-default:hover,\r\na.bg-translucent-default:focus,\r\nbutton.bg-translucent-default:hover,\r\nbutton.bg-translucent-default:focus {\r\n  background-color: rgba(9, 17, 30, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-white {\r\n  background-color: rgba(237, 237, 237, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-white:hover,\r\na.bg-translucent-white:focus,\r\nbutton.bg-translucent-white:hover,\r\nbutton.bg-translucent-white:focus {\r\n  background-color: rgba(224, 224, 224, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-neutral {\r\n  background-color: rgba(237, 237, 237, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-neutral:hover,\r\na.bg-translucent-neutral:focus,\r\nbutton.bg-translucent-neutral:hover,\r\nbutton.bg-translucent-neutral:focus {\r\n  background-color: rgba(224, 224, 224, 0.6) !important;\r\n}\r\n\r\n.bg-translucent-darker {\r\n  background-color: rgba(0, 0, 0, 0.6) !important;\r\n}\r\n\r\na.bg-translucent-darker:hover,\r\na.bg-translucent-darker:focus,\r\nbutton.bg-translucent-darker:hover,\r\nbutton.bg-translucent-darker:focus {\r\n  background-color: rgba(0, 0, 0, 0.6) !important;\r\n}\r\n\r\n.section-primary {\r\n  background-color: #f8f9fe !important;\r\n}\r\n\r\na.section-primary:hover,\r\na.section-primary:focus,\r\nbutton.section-primary:hover,\r\nbutton.section-primary:focus {\r\n  background-color: #cbd3f8 !important;\r\n}\r\n\r\n.section-secondary {\r\n  background-color: #f7fafc !important;\r\n}\r\n\r\na.section-secondary:hover,\r\na.section-secondary:focus,\r\nbutton.section-secondary:hover,\r\nbutton.section-secondary:focus {\r\n  background-color: #d2e3ee !important;\r\n}\r\n\r\n.section-light {\r\n  background-color: #ced4da !important;\r\n}\r\n\r\na.section-light:hover,\r\na.section-light:focus,\r\nbutton.section-light:hover,\r\nbutton.section-light:focus {\r\n  background-color: #b1bbc4 !important;\r\n}\r\n\r\n.section-dark {\r\n  background-color: #212529 !important;\r\n}\r\n\r\na.section-dark:hover,\r\na.section-dark:focus,\r\nbutton.section-dark:hover,\r\nbutton.section-dark:focus {\r\n  background-color: #0a0c0d !important;\r\n}\r\n\r\n.section-darker {\r\n  background-color: black !important;\r\n}\r\n\r\na.section-darker:hover,\r\na.section-darker:focus,\r\nbutton.section-darker:hover,\r\nbutton.section-darker:focus {\r\n  background-color: black !important;\r\n}\r\n\r\n.bg-gradient-primary {\r\n  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;\r\n}\r\n\r\n.bg-gradient-secondary {\r\n  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;\r\n}\r\n\r\n.bg-gradient-success {\r\n  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;\r\n}\r\n\r\n.bg-gradient-info {\r\n  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;\r\n}\r\n\r\n.bg-gradient-warning {\r\n  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;\r\n}\r\n\r\n.bg-gradient-danger {\r\n  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;\r\n}\r\n\r\n.bg-gradient-light {\r\n  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;\r\n}\r\n\r\n.bg-gradient-dark {\r\n  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;\r\n}\r\n\r\n.bg-gradient-default {\r\n  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;\r\n}\r\n\r\n.bg-gradient-white {\r\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\r\n}\r\n\r\n.bg-gradient-neutral {\r\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\r\n}\r\n\r\n.bg-gradient-darker {\r\n  background: linear-gradient(87deg, black 0, black 100%) !important;\r\n}\r\n\r\n.fill-primary {\r\n  fill: #5e72e4;\r\n}\r\n\r\n.stroke-primary {\r\n  stroke: #5e72e4;\r\n}\r\n\r\n.fill-secondary {\r\n  fill: #f7fafc;\r\n}\r\n\r\n.stroke-secondary {\r\n  stroke: #f7fafc;\r\n}\r\n\r\n.fill-success {\r\n  fill: #2dce89;\r\n}\r\n\r\n.stroke-success {\r\n  stroke: #2dce89;\r\n}\r\n\r\n.fill-info {\r\n  fill: #11cdef;\r\n}\r\n\r\n.stroke-info {\r\n  stroke: #11cdef;\r\n}\r\n\r\n.fill-warning {\r\n  fill: #fb6340;\r\n}\r\n\r\n.stroke-warning {\r\n  stroke: #fb6340;\r\n}\r\n\r\n.fill-danger {\r\n  fill: #f5365c;\r\n}\r\n\r\n.stroke-danger {\r\n  stroke: #f5365c;\r\n}\r\n\r\n.fill-light {\r\n  fill: #adb5bd;\r\n}\r\n\r\n.stroke-light {\r\n  stroke: #adb5bd;\r\n}\r\n\r\n.fill-dark {\r\n  fill: #212529;\r\n}\r\n\r\n.stroke-dark {\r\n  stroke: #212529;\r\n}\r\n\r\n.fill-default {\r\n  fill: #172b4d;\r\n}\r\n\r\n.stroke-default {\r\n  stroke: #172b4d;\r\n}\r\n\r\n.fill-white {\r\n  fill: #fff;\r\n}\r\n\r\n.stroke-white {\r\n  stroke: #fff;\r\n}\r\n\r\n.fill-neutral {\r\n  fill: #fff;\r\n}\r\n\r\n.stroke-neutral {\r\n  stroke: #fff;\r\n}\r\n\r\n.fill-darker {\r\n  fill: black;\r\n}\r\n\r\n.stroke-darker {\r\n  stroke: black;\r\n}\r\n\r\n.fill-opacity-8 {\r\n  fill-opacity: 0.8;\r\n}\r\n\r\n.blur--hover {\r\n  position: relative;\r\n}\r\n\r\n.blur--hover .blur-item {\r\n  transition: 1s cubic-bezier(0.19, 1, 0.22, 1);\r\n  will-change: transform;\r\n  filter: blur(0);\r\n  opacity: 1;\r\n}\r\n\r\n.blur--hover .blur-hidden {\r\n  position: absolute;\r\n  top: calc(50% + 7px);\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  opacity: 0;\r\n  transition: all 0.15s ease;\r\n  z-index: 100;\r\n}\r\n\r\n.blur--hover:hover .blur-item {\r\n  opacity: 0.8;\r\n  filter: blur(10px);\r\n  transform: scale(0.95);\r\n  z-index: 1;\r\n}\r\n\r\n.blur--hover:hover .blur-hidden {\r\n  opacity: 1;\r\n  top: 50%;\r\n}\r\n\r\n.floating {\r\n  animation: floating 3s ease infinite;\r\n  will-change: transform;\r\n}\r\n\r\n.floating:hover {\r\n  animation-play-state: paused;\r\n}\r\n\r\n.floating-lg {\r\n  animation: floating-lg 3s ease infinite;\r\n}\r\n\r\n.floating-sm {\r\n  animation: floating-sm 3s ease infinite;\r\n}\r\n\r\n@keyframes floating-lg {\r\n  0% {\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  50% {\r\n    transform: translateY(15px);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@keyframes floating {\r\n  0% {\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  50% {\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@keyframes floating-sm {\r\n  0% {\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  50% {\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n.floatfix:before,\r\n.floatfix:after {\r\n  content: \"\";\r\n  display: table;\r\n}\r\n\r\n.floatfix:after {\r\n  clear: both;\r\n}\r\n\r\n.img-center {\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.opacity-1 {\r\n  opacity: 0.1 !important;\r\n}\r\n\r\n.opacity-2 {\r\n  opacity: 0.2 !important;\r\n}\r\n\r\n.opacity-3 {\r\n  opacity: 0.3 !important;\r\n}\r\n\r\n.opacity-4 {\r\n  opacity: 0.4 !important;\r\n}\r\n\r\n.opacity-5 {\r\n  opacity: 0.5 !important;\r\n}\r\n\r\n.opacity-6 {\r\n  opacity: 0.6 !important;\r\n}\r\n\r\n.opacity-7 {\r\n  opacity: 0.7 !important;\r\n}\r\n\r\n.opacity-8 {\r\n  opacity: 0.8 !important;\r\n}\r\n\r\n.opacity-8 {\r\n  opacity: 0.9 !important;\r\n}\r\n\r\n.opacity-10 {\r\n  opacity: 1 !important;\r\n}\r\n\r\n.overflow-visible {\r\n  overflow: visible !important;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.top-0 {\r\n  top: 0;\r\n}\r\n\r\n.right-0 {\r\n  right: 0;\r\n}\r\n\r\n.bottom-0 {\r\n  bottom: 0;\r\n}\r\n\r\n.left-0 {\r\n  left: 0;\r\n}\r\n\r\n.top-1 {\r\n  top: 0.25rem;\r\n}\r\n\r\n.right-1 {\r\n  right: 0.25rem;\r\n}\r\n\r\n.bottom-1 {\r\n  bottom: 0.25rem;\r\n}\r\n\r\n.left-1 {\r\n  left: 0.25rem;\r\n}\r\n\r\n.top-2 {\r\n  top: 0.5rem;\r\n}\r\n\r\n.right-2 {\r\n  right: 0.5rem;\r\n}\r\n\r\n.bottom-2 {\r\n  bottom: 0.5rem;\r\n}\r\n\r\n.left-2 {\r\n  left: 0.5rem;\r\n}\r\n\r\n.top-3 {\r\n  top: 1rem;\r\n}\r\n\r\n.right-3 {\r\n  right: 1rem;\r\n}\r\n\r\n.bottom-3 {\r\n  bottom: 1rem;\r\n}\r\n\r\n.left-3 {\r\n  left: 1rem;\r\n}\r\n\r\n.top-4 {\r\n  top: 1.5rem;\r\n}\r\n\r\n.right-4 {\r\n  right: 1.5rem;\r\n}\r\n\r\n.bottom-4 {\r\n  bottom: 1.5rem;\r\n}\r\n\r\n.left-4 {\r\n  left: 1.5rem;\r\n}\r\n\r\n.top-5 {\r\n  top: 3rem;\r\n}\r\n\r\n.right-5 {\r\n  right: 3rem;\r\n}\r\n\r\n.bottom-5 {\r\n  bottom: 3rem;\r\n}\r\n\r\n.left-5 {\r\n  left: 3rem;\r\n}\r\n\r\n.top--9 {\r\n  top: -10rem;\r\n}\r\n\r\n.right--9 {\r\n  right: -10rem;\r\n}\r\n\r\n.bottom--9 {\r\n  bottom: -10rem;\r\n}\r\n\r\n.left--9 {\r\n  left: -10rem;\r\n}\r\n\r\n.top--8 {\r\n  top: -8rem;\r\n}\r\n\r\n.right--8 {\r\n  right: -8rem;\r\n}\r\n\r\n.bottom--8 {\r\n  bottom: -8rem;\r\n}\r\n\r\n.left--8 {\r\n  left: -8rem;\r\n}\r\n\r\n.top--7 {\r\n  top: -6rem;\r\n}\r\n\r\n.right--7 {\r\n  right: -6rem;\r\n}\r\n\r\n.bottom--7 {\r\n  bottom: -6rem;\r\n}\r\n\r\n.left--7 {\r\n  left: -6rem;\r\n}\r\n\r\n.top--6 {\r\n  top: -4.5rem;\r\n}\r\n\r\n.right--6 {\r\n  right: -4.5rem;\r\n}\r\n\r\n.bottom--6 {\r\n  bottom: -4.5rem;\r\n}\r\n\r\n.left--6 {\r\n  left: -4.5rem;\r\n}\r\n\r\n.top--5 {\r\n  top: -3rem;\r\n}\r\n\r\n.right--5 {\r\n  right: -3rem;\r\n}\r\n\r\n.bottom--5 {\r\n  bottom: -3rem;\r\n}\r\n\r\n.left--5 {\r\n  left: -3rem;\r\n}\r\n\r\n.top--4 {\r\n  top: -1.5rem;\r\n}\r\n\r\n.right--4 {\r\n  right: -1.5rem;\r\n}\r\n\r\n.bottom--4 {\r\n  bottom: -1.5rem;\r\n}\r\n\r\n.left--4 {\r\n  left: -1.5rem;\r\n}\r\n\r\n.top--3 {\r\n  top: -1rem;\r\n}\r\n\r\n.right--3 {\r\n  right: -1rem;\r\n}\r\n\r\n.bottom--3 {\r\n  bottom: -1rem;\r\n}\r\n\r\n.left--3 {\r\n  left: -1rem;\r\n}\r\n\r\n.top--2 {\r\n  top: -0.5rem;\r\n}\r\n\r\n.right--2 {\r\n  right: -0.5rem;\r\n}\r\n\r\n.bottom--2 {\r\n  bottom: -0.5rem;\r\n}\r\n\r\n.left--2 {\r\n  left: -0.5rem;\r\n}\r\n\r\n.top--1 {\r\n  top: -0.25rem;\r\n}\r\n\r\n.right--1 {\r\n  right: -0.25rem;\r\n}\r\n\r\n.bottom--1 {\r\n  bottom: -0.25rem;\r\n}\r\n\r\n.left--1 {\r\n  left: -0.25rem;\r\n}\r\n\r\n.top-6 {\r\n  top: 4.5rem;\r\n}\r\n\r\n.right-6 {\r\n  right: 4.5rem;\r\n}\r\n\r\n.bottom-6 {\r\n  bottom: 4.5rem;\r\n}\r\n\r\n.left-6 {\r\n  left: 4.5rem;\r\n}\r\n\r\n.top-7 {\r\n  top: 6rem;\r\n}\r\n\r\n.right-7 {\r\n  right: 6rem;\r\n}\r\n\r\n.bottom-7 {\r\n  bottom: 6rem;\r\n}\r\n\r\n.left-7 {\r\n  left: 6rem;\r\n}\r\n\r\n.top-8 {\r\n  top: 8rem;\r\n}\r\n\r\n.right-8 {\r\n  right: 8rem;\r\n}\r\n\r\n.bottom-8 {\r\n  bottom: 8rem;\r\n}\r\n\r\n.left-8 {\r\n  left: 8rem;\r\n}\r\n\r\n.top-9 {\r\n  top: 10rem;\r\n}\r\n\r\n.right-9 {\r\n  right: 10rem;\r\n}\r\n\r\n.bottom-9 {\r\n  bottom: 10rem;\r\n}\r\n\r\n.left-9 {\r\n  left: 10rem;\r\n}\r\n\r\n.center {\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n[class*=\"shadow\"] {\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.shadow-sm--hover:hover {\r\n  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;\r\n}\r\n\r\n.shadow--hover:hover {\r\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\r\n}\r\n\r\n.shadow-lg--hover:hover {\r\n  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;\r\n}\r\n\r\n.shadow-none--hover:hover {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.h-100vh {\r\n  height: 100vh !important;\r\n}\r\n\r\n.row.row-grid>[class*=\"col-\"]+[class*=\"col-\"] {\r\n  margin-top: 3rem;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .row.row-grid>[class*=\"col-lg-\"]+[class*=\"col-lg-\"] {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .row.row-grid>[class*=\"col-md-\"]+[class*=\"col-md-\"] {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .row.row-grid>[class*=\"col-sm-\"]+[class*=\"col-sm-\"] {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n.row-grid+.row-grid {\r\n  margin-top: 3rem;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .mt--100 {\r\n    margin-top: -100px !important;\r\n  }\r\n\r\n  .mr--100 {\r\n    margin-right: -100px !important;\r\n  }\r\n\r\n  .mb--100 {\r\n    margin-bottom: -100px !important;\r\n  }\r\n\r\n  .ml--100 {\r\n    margin-left: -100px !important;\r\n  }\r\n\r\n  .mt--150 {\r\n    margin-top: -150px !important;\r\n  }\r\n\r\n  .mb--150 {\r\n    margin-bottom: -150px !important;\r\n  }\r\n\r\n  .mt--200 {\r\n    margin-top: -200px !important;\r\n  }\r\n\r\n  .mb--200 {\r\n    margin-bottom: -200px !important;\r\n  }\r\n\r\n  .mt--300 {\r\n    margin-top: -300px !important;\r\n  }\r\n\r\n  .mb--300 {\r\n    margin-bottom: -300px !important;\r\n  }\r\n\r\n  .pt-100 {\r\n    padding-top: 100px !important;\r\n  }\r\n\r\n  .pb-100 {\r\n    padding-bottom: 100px !important;\r\n  }\r\n\r\n  .pt-150 {\r\n    padding-top: 150px !important;\r\n  }\r\n\r\n  .pb-150 {\r\n    padding-bottom: 150px !important;\r\n  }\r\n\r\n  .pt-200 {\r\n    padding-top: 200px !important;\r\n  }\r\n\r\n  .pb-200 {\r\n    padding-bottom: 200px !important;\r\n  }\r\n\r\n  .pt-250 {\r\n    padding-top: 250px !important;\r\n  }\r\n\r\n  .pb-250 {\r\n    padding-bottom: 250px !important;\r\n  }\r\n\r\n  .pt-300 {\r\n    padding-top: 300px !important;\r\n  }\r\n\r\n  .pb-300 {\r\n    padding-bottom: 300px !important;\r\n  }\r\n}\r\n\r\n.font-weight-300 {\r\n  font-weight: 300 !important;\r\n}\r\n\r\n.font-weight-400 {\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.font-weight-500 {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.font-weight-600 {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.font-weight-700 {\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.font-weight-800 {\r\n  font-weight: 800 !important;\r\n}\r\n\r\n.font-weight-900 {\r\n  font-weight: 900 !important;\r\n}\r\n\r\n.text-underline {\r\n  text-decoration: underline;\r\n}\r\n\r\n.text-through {\r\n  text-decoration: line-through;\r\n}\r\n\r\n.text-xs {\r\n  font-size: 0.75rem !important;\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem !important;\r\n}\r\n\r\n.text-lg {\r\n  font-size: 1.25rem !important;\r\n}\r\n\r\n.text-xl {\r\n  font-size: 1.5rem !important;\r\n}\r\n\r\n.lh-100 {\r\n  line-height: 1;\r\n}\r\n\r\n.lh-110 {\r\n  line-height: 1.1;\r\n}\r\n\r\n.lh-120 {\r\n  line-height: 1.2;\r\n}\r\n\r\n.lh-130 {\r\n  line-height: 1.3;\r\n}\r\n\r\n.lh-140 {\r\n  line-height: 1.4;\r\n}\r\n\r\n.lh-150 {\r\n  line-height: 1.5;\r\n}\r\n\r\n.lh-160 {\r\n  line-height: 1.6;\r\n}\r\n\r\n.lh-170 {\r\n  line-height: 1.7;\r\n}\r\n\r\n.lh-180 {\r\n  line-height: 1.8;\r\n}\r\n\r\n.ls-1 {\r\n  letter-spacing: 0.0625rem;\r\n}\r\n\r\n.ls-15 {\r\n  letter-spacing: 0.09375rem;\r\n}\r\n\r\n.ls-2 {\r\n  letter-spacing: 0.125rem;\r\n}\r\n\r\n.text-blue {\r\n  color: #5e72e4 !important;\r\n}\r\n\r\na.text-blue:hover,\r\na.text-blue:focus {\r\n  color: #233dd2 !important;\r\n}\r\n\r\n.text-indigo {\r\n  color: #5603ad !important;\r\n}\r\n\r\na.text-indigo:hover,\r\na.text-indigo:focus {\r\n  color: #310262 !important;\r\n}\r\n\r\n.text-purple {\r\n  color: #8965e0 !important;\r\n}\r\n\r\na.text-purple:hover,\r\na.text-purple:focus {\r\n  color: #5a2acf !important;\r\n}\r\n\r\n.text-pink {\r\n  color: #f3a4b5 !important;\r\n}\r\n\r\na.text-pink:hover,\r\na.text-pink:focus {\r\n  color: #ea607e !important;\r\n}\r\n\r\n.text-red {\r\n  color: #f5365c !important;\r\n}\r\n\r\na.text-red:hover,\r\na.text-red:focus {\r\n  color: #d40b33 !important;\r\n}\r\n\r\n.text-orange {\r\n  color: #fb6340 !important;\r\n}\r\n\r\na.text-orange:hover,\r\na.text-orange:focus {\r\n  color: #ea3005 !important;\r\n}\r\n\r\n.text-yellow {\r\n  color: #ffd600 !important;\r\n}\r\n\r\na.text-yellow:hover,\r\na.text-yellow:focus {\r\n  color: #b39600 !important;\r\n}\r\n\r\n.text-green {\r\n  color: #2dce89 !important;\r\n}\r\n\r\na.text-green:hover,\r\na.text-green:focus {\r\n  color: #1f8f5f !important;\r\n}\r\n\r\n.text-teal {\r\n  color: #11cdef !important;\r\n}\r\n\r\na.text-teal:hover,\r\na.text-teal:focus {\r\n  color: #0b90a8 !important;\r\n}\r\n\r\n.text-cyan {\r\n  color: #2bffc6 !important;\r\n}\r\n\r\na.text-cyan:hover,\r\na.text-cyan:focus {\r\n  color: #00dea2 !important;\r\n}\r\n\r\n.text-white {\r\n  color: #fff !important;\r\n}\r\n\r\na.text-white:hover,\r\na.text-white:focus {\r\n  color: #d9d9d9 !important;\r\n}\r\n\r\n.text-gray {\r\n  color: #8898aa !important;\r\n}\r\n\r\na.text-gray:hover,\r\na.text-gray:focus {\r\n  color: #607286 !important;\r\n}\r\n\r\n.text-gray-dark {\r\n  color: #32325d !important;\r\n}\r\n\r\na.text-gray-dark:hover,\r\na.text-gray-dark:focus {\r\n  color: #17172b !important;\r\n}\r\n\r\n.text-light {\r\n  color: #ced4da !important;\r\n}\r\n\r\na.text-light:hover,\r\na.text-light:focus {\r\n  color: #a2aeb9 !important;\r\n}\r\n\r\n.text-lighter {\r\n  color: #e9ecef !important;\r\n}\r\n\r\na.text-lighter:hover,\r\na.text-lighter:focus {\r\n  color: #bdc6cf !important;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .transform-perspective-right {\r\n    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\r\n  }\r\n\r\n  .transform-perspective-left {\r\n    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);\r\n  }\r\n}\r\n\r\n.datepicker {\r\n  border-radius: 0.375rem;\r\n  direction: ltr;\r\n}\r\n\r\n.datepicker-inline {\r\n  width: 220px;\r\n}\r\n\r\n.datepicker-rtl {\r\n  direction: rtl;\r\n}\r\n\r\n.datepicker-rtl.dropdown-menu {\r\n  left: auto;\r\n}\r\n\r\n.datepicker-rtl table tr td span {\r\n  float: right;\r\n}\r\n\r\n.datepicker-dropdown {\r\n  top: 0;\r\n  left: 0;\r\n  padding: 20px 22px;\r\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),\r\n    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-left:before {\r\n  left: 6px;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-left:after {\r\n  left: 7px;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-right:before {\r\n  right: 6px;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-right:after {\r\n  right: 7px;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-bottom:before {\r\n  top: -7px;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-bottom:after {\r\n  top: -6px;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-top:before {\r\n  bottom: -7px;\r\n  border-bottom: 0;\r\n  border-top: 7px solid white;\r\n}\r\n\r\n.datepicker-dropdown.datepicker-orient-top:after {\r\n  bottom: -6px;\r\n  border-bottom: 0;\r\n  border-top: 6px solid #fff;\r\n}\r\n\r\n.datepicker table {\r\n  margin: 0;\r\n  -webkit-touch-callout: none;\r\n  user-select: none;\r\n}\r\n\r\n.datepicker table tr td {\r\n  border-radius: 50%;\r\n}\r\n\r\n.datepicker table tr th {\r\n  border-radius: 0.375rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.datepicker table tr td,\r\n.datepicker table tr th {\r\n  transition: all 0.15s ease;\r\n  width: 36px;\r\n  height: 36px;\r\n  border: none;\r\n  text-align: center;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.table-striped .datepicker table tr td,\r\n.table-striped .datepicker table tr th {\r\n  background-color: transparent;\r\n}\r\n\r\n.datepicker table tr td.old,\r\n.datepicker table tr td.new {\r\n  color: #adb5bd;\r\n}\r\n\r\n.datepicker table tr td.day:hover,\r\n.datepicker table tr td.focused {\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.datepicker table tr td.disabled,\r\n.datepicker table tr td.disabled:hover {\r\n  background: none;\r\n  color: #dee2e6;\r\n  cursor: default;\r\n}\r\n\r\n.datepicker table tr td.highlighted {\r\n  border-radius: 0;\r\n}\r\n\r\n.datepicker table tr td.highlighted.focused {\r\n  background: #5e72e4;\r\n}\r\n\r\n.datepicker table tr td.highlighted.disabled,\r\n.datepicker table tr td.highlighted.disabled:active {\r\n  background: #5e72e4;\r\n  color: #ced4da;\r\n}\r\n\r\n.datepicker table tr td.today {\r\n  background: white;\r\n}\r\n\r\n.datepicker table tr td.today.focused {\r\n  background: white;\r\n}\r\n\r\n.datepicker table tr td.today.disabled,\r\n.datepicker table tr td.today.disabled:active {\r\n  background: white;\r\n  color: #8898aa;\r\n}\r\n\r\n.datepicker table tr td.range {\r\n  background: #5e72e4;\r\n  color: #fff;\r\n  border-radius: 0;\r\n}\r\n\r\n.datepicker table tr td.range.focused {\r\n  background: #3b53de;\r\n}\r\n\r\n.datepicker table tr td.range.disabled,\r\n.datepicker table tr td.range.disabled:active,\r\n.datepicker table tr td.range.day.disabled:hover {\r\n  background: #324cdd;\r\n  color: #8a98eb;\r\n}\r\n\r\n.datepicker table tr td.range.highlighted.focused {\r\n  background: #cbd3da;\r\n}\r\n\r\n.datepicker table tr td.range.highlighted.disabled,\r\n.datepicker table tr td.range.highlighted.disabled:active {\r\n  background: #e9ecef;\r\n  color: #dee2e6;\r\n}\r\n\r\n.datepicker table tr td.range.today.disabled,\r\n.datepicker table tr td.range.today.disabled:active {\r\n  background: #5e72e4;\r\n  color: #fff;\r\n}\r\n\r\n.datepicker table tr td.day.range-start {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.datepicker table tr td.day.range-end {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.datepicker table tr td.day.range-start.range-end {\r\n  border-radius: 50%;\r\n}\r\n\r\n.datepicker table tr td.selected,\r\n.datepicker table tr td.selected.highlighted,\r\n.datepicker table tr td.selected:hover,\r\n.datepicker table tr td.selected.highlighted:hover,\r\n.datepicker table tr td.day.range:hover {\r\n  background: #5e72e4;\r\n  color: #fff;\r\n}\r\n\r\n.datepicker table tr td.active,\r\n.datepicker table tr td.active.highlighted,\r\n.datepicker table tr td.active:hover,\r\n.datepicker table tr td.active.highlighted:hover {\r\n  background: #5e72e4;\r\n  color: #fff;\r\n  box-shadow: none;\r\n}\r\n\r\n.datepicker table tr td span {\r\n  display: block;\r\n  width: 23%;\r\n  height: 54px;\r\n  line-height: 54px;\r\n  float: left;\r\n  margin: 1%;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\n.datepicker table tr td span:hover,\r\n.datepicker table tr td span.focused {\r\n  background: #e9ecef;\r\n}\r\n\r\n.datepicker table tr td span.disabled,\r\n.datepicker table tr td span.disabled:hover {\r\n  background: none;\r\n  color: #dee2e6;\r\n  cursor: default;\r\n}\r\n\r\n.datepicker table tr td span.active,\r\n.datepicker table tr td span.active:hover,\r\n.datepicker table tr td span.active.disabled,\r\n.datepicker table tr td span.active.disabled:hover {\r\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.datepicker table tr td span.old,\r\n.datepicker table tr td span.new {\r\n  color: #8898aa;\r\n}\r\n\r\n.datepicker .datepicker-switch {\r\n  width: 145px;\r\n}\r\n\r\n.datepicker .datepicker-switch,\r\n.datepicker .prev,\r\n.datepicker .next,\r\n.datepicker tfoot tr th {\r\n  cursor: pointer;\r\n}\r\n\r\n.datepicker .datepicker-switch:hover,\r\n.datepicker .prev:hover,\r\n.datepicker .next:hover,\r\n.datepicker tfoot tr th:hover {\r\n  background: #e9ecef;\r\n}\r\n\r\n.datepicker .prev.disabled,\r\n.datepicker .next.disabled {\r\n  visibility: hidden;\r\n}\r\n\r\n.datepicker .cw {\r\n  font-size: 10px;\r\n  width: 12px;\r\n  padding: 0 2px 0 5px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.bootstrap-tagsinput {\r\n  background-color: #fff;\r\n  border: 0 solid transparent;\r\n  display: inline-block;\r\n  padding: 0.25rem;\r\n  color: #8898aa;\r\n  vertical-align: middle;\r\n  border-radius: 0.25rem;\r\n  max-width: 100%;\r\n  cursor: text;\r\n}\r\n\r\n.bootstrap-tagsinput input {\r\n  border: none;\r\n  box-shadow: none;\r\n  outline: none;\r\n  background-color: transparent;\r\n  padding: 0 6px;\r\n  margin: 0;\r\n  width: auto;\r\n  max-width: inherit;\r\n}\r\n\r\n.bootstrap-tagsinput input::placeholder {\r\n  color: #adb5bd;\r\n  opacity: 1;\r\n}\r\n\r\n.bootstrap-tagsinput input:focus {\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.bootstrap-tagsinput .badge {\r\n  position: relative;\r\n  padding: 0.625rem 0.625rem 0.5rem;\r\n  margin: 0.125rem;\r\n  border-radius: 0.25rem;\r\n  background: #172b4d;\r\n  color: #fff;\r\n  line-height: 1.5;\r\n  box-shadow: 0 1px 2px rgba(68, 68, 68, 0.25);\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .bootstrap-tagsinput .badge {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.bootstrap-tagsinput .badge:hover {\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.bootstrap-tagsinput [data-role=\"remove\"] {\r\n  margin-left: 10px;\r\n  cursor: pointer;\r\n  color: #fff;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n.bootstrap-tagsinput [data-role=\"remove\"]:after {\r\n  content: \"×\";\r\n  font-size: 16px;\r\n}\r\n\r\n#chartjs-tooltip {\r\n  opacity: 1;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  border-radius: 3px;\r\n  transition: all 0.1s ease;\r\n  pointer-events: none;\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n.chartjs-tooltip-key {\r\n  display: inline-block;\r\n  width: 10px;\r\n  height: 10px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.dataTables_wrapper {\r\n  font-size: 0.875rem;\r\n}\r\n\r\ntable.dataTable {\r\n  margin-bottom: 1.25rem !important;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\ntable.dataTable tbody>tr.selected {\r\n  background-color: #5e72e4;\r\n}\r\n\r\n.dataTables_length,\r\n.dataTables_info,\r\n.dt-buttons {\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.dataTables_length .form-control {\r\n  margin: 0 0.375rem;\r\n}\r\n\r\n.dataTables_filter {\r\n  padding-right: 1.5rem;\r\n  display: inline-block;\r\n  float: right;\r\n}\r\n\r\n.dataTables_paginate {\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.dropzone {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.dz-message {\r\n  padding: 5rem 1rem;\r\n  background-color: #fff;\r\n  border: 1px dashed #dee2e6;\r\n  border-radius: 0.375rem;\r\n  text-align: center;\r\n  color: #8898aa;\r\n  transition: all 0.15s ease;\r\n  order: -1;\r\n  cursor: pointer;\r\n  z-index: 999;\r\n}\r\n\r\n.dz-message:hover {\r\n  border-color: #8898aa;\r\n  color: #525f7f;\r\n}\r\n\r\n.dz-drag-hover .dz-message {\r\n  border-color: #5e72e4;\r\n  color: #5e72e4;\r\n}\r\n\r\n.dropzone-multiple .dz-message {\r\n  padding-top: 2rem;\r\n  padding-bottom: 2rem;\r\n}\r\n\r\n.dropzone-single.dz-max-files-reached .dz-message {\r\n  background-color: rgba(0, 0, 0, 0.9);\r\n  color: white;\r\n  opacity: 0;\r\n}\r\n\r\n.dropzone-single.dz-max-files-reached .dz-message:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.dz-preview-single {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.dz-preview-cover {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.dz-preview-img {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.dz-preview-multiple .list-group-item:last-child {\r\n  padding-bottom: 0;\r\n  border-bottom: 0;\r\n}\r\n\r\n[data-dz-size] strong {\r\n  font-weight: 400;\r\n}\r\n\r\n.fc-header-toolbar {\r\n  display: none;\r\n}\r\n\r\n.fc-scroller {\r\n  height: auto !important;\r\n}\r\n\r\n.fc th {\r\n  padding: 0.75rem 1rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: #8898aa;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.fc div.fc-row {\r\n  margin-right: 0;\r\n  border: 0;\r\n}\r\n\r\n.fc button .fc-icon {\r\n  top: -5px;\r\n}\r\n\r\n.fc-unthemed td.fc-today {\r\n  background-color: transparent;\r\n}\r\n\r\n.fc-unthemed td.fc-today span {\r\n  color: #fb6340;\r\n}\r\n\r\n.fc-event {\r\n  padding: 0;\r\n  font-size: 0.75rem;\r\n  border-radius: 0.25rem;\r\n  border: 0;\r\n}\r\n\r\n.fc-event .fc-title {\r\n  padding: 0.4rem 0.5rem;\r\n  display: block;\r\n  color: #fff;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 600;\r\n}\r\n\r\n.fc-event .fc-time {\r\n  float: left;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  padding: 2px 6px;\r\n  margin: 0 0 0 -1px;\r\n}\r\n\r\n.fc-view,\r\n.fc-view>table {\r\n  border: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.fc-view>table>tbody>tr .ui-widget-content {\r\n  border-top: 0;\r\n}\r\n\r\n.fc-body {\r\n  border: 0;\r\n}\r\n\r\n.fc-icon {\r\n  font-family: NucleoIcons, sans-serif;\r\n  font-size: 1rem;\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 50%;\r\n  line-height: 35px;\r\n}\r\n\r\n.fc-icon:hover {\r\n  color: #5e72e4;\r\n}\r\n\r\n.fc-button {\r\n  border: 0;\r\n  background: transparent;\r\n  box-shadow: none;\r\n}\r\n\r\n.fc-button:focus,\r\n.fc-button:active {\r\n  outline: 0;\r\n}\r\n\r\n.calendar {\r\n  z-index: 0;\r\n}\r\n\r\n.calendar td,\r\n.calendar th {\r\n  border-color: #eff1f3;\r\n}\r\n\r\n.calendar .fc-toolbar {\r\n  height: 250px;\r\n  background-color: #fff;\r\n  border-radius: 0.375rem 0.375rem 0 0;\r\n  position: relative;\r\n  margin-bottom: -2px;\r\n  z-index: 2;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .calendar .fc-toolbar {\r\n    height: 135px;\r\n  }\r\n}\r\n\r\n.calendar .fc-day-number {\r\n  padding: 0.5rem 1rem;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .calendar .fc-day-number {\r\n    font-size: 0.875rem;\r\n    font-weight: 600;\r\n    color: #67779d;\r\n  }\r\n}\r\n\r\n.calendar .fc-day-header {\r\n  text-align: left;\r\n}\r\n\r\n.calendar .fc-day-grid-event {\r\n  margin: 1px 9px;\r\n}\r\n\r\n[data-calendar-month] {\r\n  background-size: contain;\r\n  transition: background-image 300ms;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  [data-calendar-month] {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.card-calendar .card-header {\r\n  border-bottom: 0;\r\n}\r\n\r\n.card-calendar table {\r\n  background: transparent;\r\n}\r\n\r\n.card-calendar table tr>td:first-child {\r\n  border-left-width: 0;\r\n}\r\n\r\n.card-calendar table tr>td:last-child {\r\n  border-right-width: 0;\r\n}\r\n\r\n.widget-calendar {\r\n  position: relative;\r\n  z-index: 0;\r\n}\r\n\r\n.widget-calendar td,\r\n.widget-calendar th {\r\n  border-color: transparent;\r\n  text-align: center;\r\n}\r\n\r\n.widget-calendar .fc-toolbar {\r\n  margin-top: 1.25rem;\r\n}\r\n\r\n.widget-calendar .fc-toolbar h2 {\r\n  font-size: 1rem;\r\n}\r\n\r\n.widget-calendar .fc-day-number {\r\n  text-align: center;\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.widget-calendar .fc table {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.widget-calendar .fc th {\r\n  padding: 0.75rem 0.5rem;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.vector-map {\r\n  position: relative;\r\n  height: 600px;\r\n}\r\n\r\n.vector-map-sm {\r\n  height: 280px;\r\n}\r\n\r\n.jvectormap-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.jvectormap-zoomin,\r\n.jvectormap-zoomout {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.jvectormap-zoomin {\r\n  bottom: 4.25rem;\r\n}\r\n\r\n.jvectormap-zoomout {\r\n  bottom: 2rem;\r\n}\r\n\r\n/*!\r\n * Lavalamp\r\n * http://lavalamp.magicmediamuse.com/\r\n */\r\n.lavalamp {\r\n  position: relative;\r\n}\r\n\r\n.lavalamp-item {\r\n  z-index: 5;\r\n  position: relative;\r\n}\r\n\r\n.lavalamp-object {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n/* Custom easing transitions */\r\n.lavalamp .lavalamp-object {\r\n  transition-property: transform, width, height;\r\n}\r\n\r\n.lavalamp .lavalamp-object.ease {\r\n  transition-timing-function: ease;\r\n}\r\n\r\n.lavalamp .lavalamp-object.ease-in {\r\n  transition-timing-function: ease-in;\r\n}\r\n\r\n.lavalamp .lavalamp-object.ease-out {\r\n  transition-timing-function: ease-out;\r\n}\r\n\r\n.lavalamp .lavalamp-object.ease-in-out {\r\n  transition-timing-function: ease-in-out;\r\n}\r\n\r\n.lavalamp .lavalamp-object.linear {\r\n  transition-timing-function: linear;\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInQuad {\r\n  transition-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInCubic {\r\n  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInQuart {\r\n  transition-timing-function: cubic-bezier(0.895, 0.03, 0.685, 0.22);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInQuint {\r\n  transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInSine {\r\n  transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInExpo {\r\n  transition-timing-function: cubic-bezier(0.95, 0.05, 0.795, 0.035);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInCirc {\r\n  transition-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.335);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInBack {\r\n  transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutQuad {\r\n  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutCubic {\r\n  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutQuart {\r\n  -webkit-transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\r\n  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutQuint {\r\n  -webkit-transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n  transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutSine {\r\n  -webkit-transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);\r\n  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutExpo {\r\n  -webkit-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\r\n  transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutCirc {\r\n  -webkit-transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\r\n  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeOutBack {\r\n  -webkit-transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  -moz-transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  -o-transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutQuad {\r\n  -webkit-transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -moz-transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  -o-transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  transition-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutCubic {\r\n  -webkit-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutQuart {\r\n  -webkit-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutQuint {\r\n  -webkit-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\r\n  -moz-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\r\n  -o-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\r\n  transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutSine {\r\n  -webkit-transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\r\n  -moz-transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\r\n  -o-transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\r\n  transition-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutExpo {\r\n  -webkit-transition-timing-function: cubic-bezier(1, 0, 0, 1);\r\n  -moz-transition-timing-function: cubic-bezier(1, 0, 0, 1);\r\n  -o-transition-timing-function: cubic-bezier(1, 0, 0, 1);\r\n  transition-timing-function: cubic-bezier(1, 0, 0, 1);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutCirc {\r\n  -webkit-transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);\r\n  -moz-transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);\r\n  -o-transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);\r\n  transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);\r\n}\r\n\r\n.lavalamp .lavalamp-object.easeInOutBack {\r\n  -webkit-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  -moz-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  -o-transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n.noUi-target,\r\n.noUi-target * {\r\n  -webkit-touch-callout: none;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n  -webkit-user-select: none;\r\n  touch-action: none;\r\n  user-select: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.noUi-target {\r\n  position: relative;\r\n  direction: ltr;\r\n}\r\n\r\n.noUi-base,\r\n.noUi-connects {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.noUi-connects {\r\n  overflow: hidden;\r\n  z-index: 0;\r\n}\r\n\r\n.noUi-connect,\r\n.noUi-origin {\r\n  will-change: transform;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  transform-origin: 0 0;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.noUi-vertical .noUi-origin {\r\n  width: 0;\r\n}\r\n\r\n.noUi-horizontal .noUi-origin {\r\n  height: 0;\r\n}\r\n\r\n.noUi-handle {\r\n  position: absolute;\r\n}\r\n\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.noUi-state-drag * {\r\n  cursor: inherit !important;\r\n}\r\n\r\n.noUi-horizontal {\r\n  height: 5px;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle {\r\n  width: 34px;\r\n  height: 28px;\r\n  left: -17px;\r\n  top: -6px;\r\n}\r\n\r\n.noUi-vertical {\r\n  width: 5px;\r\n}\r\n\r\n.noUi-vertical .noUi-handle {\r\n  width: 28px;\r\n  height: 34px;\r\n  left: -6px;\r\n  top: -17px;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -17px;\r\n  left: auto;\r\n}\r\n\r\n.noUi-connects {\r\n  border-radius: 3px;\r\n}\r\n\r\n.noUi-connect {\r\n  background: #5e72e4;\r\n}\r\n\r\n.noUi-draggable {\r\n  cursor: ew-resize;\r\n}\r\n\r\n.noUi-vertical .noUi-draggable {\r\n  cursor: ns-resize;\r\n}\r\n\r\n.noUi-handle {\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  cursor: default;\r\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\r\n  outline: none;\r\n}\r\n\r\n.noUi-active {\r\n  outline: none;\r\n}\r\n\r\n/* Disabled state;\r\n */\r\n[disabled] .noUi-connect {\r\n  background: #b8b8b8;\r\n}\r\n\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Base;\r\n *\r\n */\r\n.noUi-pips,\r\n.noUi-pips * {\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.noUi-pips {\r\n  position: absolute;\r\n  color: #999;\r\n}\r\n\r\n/* Values;\r\n *\r\n */\r\n.noUi-value {\r\n  position: absolute;\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n\r\n.noUi-value-sub {\r\n  color: #ccc;\r\n  font-size: 10px;\r\n}\r\n\r\n/* Markings;\r\n *\r\n */\r\n.noUi-marker {\r\n  position: absolute;\r\n  background: #ccc;\r\n}\r\n\r\n.noUi-marker-sub {\r\n  background: #aaa;\r\n}\r\n\r\n.noUi-marker-large {\r\n  background: #aaa;\r\n}\r\n\r\n/* Horizontal layout;\r\n *\r\n */\r\n.noUi-pips-horizontal {\r\n  padding: 10px 0;\r\n  height: 80px;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.noUi-value-horizontal {\r\n  transform: translate(-50%, 50%);\r\n}\r\n\r\n.noUi-rtl .noUi-value-horizontal {\r\n  transform: translate(50%, 50%);\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker {\r\n  margin-left: -1px;\r\n  width: 2px;\r\n  height: 5px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n  height: 10px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n  height: 15px;\r\n}\r\n\r\n/* Vertical layout;\r\n *\r\n */\r\n.noUi-pips-vertical {\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 100%;\r\n}\r\n\r\n.noUi-value-vertical {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%, 0);\r\n  padding-left: 25px;\r\n}\r\n\r\n.noUi-rtl .noUi-value-vertical {\r\n  -webkit-transform: translate(0, 50%);\r\n  transform: translate(0, 50%);\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker {\r\n  width: 5px;\r\n  height: 2px;\r\n  margin-top: -1px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n  width: 10px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-large {\r\n  width: 15px;\r\n}\r\n\r\n.noUi-tooltip {\r\n  display: block;\r\n  position: absolute;\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  color: #000;\r\n  padding: 5px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.noUi-horizontal .noUi-tooltip {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n  left: 50%;\r\n  bottom: 120%;\r\n}\r\n\r\n.noUi-vertical .noUi-tooltip {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  top: 50%;\r\n  right: 120%;\r\n}\r\n\r\n.noUi-target {\r\n  background: #eceeef;\r\n  border-radius: 5px;\r\n  border: 0;\r\n  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);\r\n  margin: 15px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.noUi-horizontal {\r\n  height: 5px;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -10px;\r\n}\r\n\r\n.noUi-vertical {\r\n  width: 5px;\r\n}\r\n\r\n.noUi-connect {\r\n  background: #5e72e4;\r\n  box-shadow: none;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle,\r\n.noUi-vertical .noUi-handle {\r\n  top: -5px;\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 100%;\r\n  box-shadow: none;\r\n  cursor: pointer;\r\n  background-color: #5e72e4;\r\n  border: 0;\r\n  transition: box-shadow 0.15s, transform 0.15s;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle.noUi-active,\r\n.noUi-vertical .noUi-handle.noUi-active {\r\n  box-shadow: 0px 0px 0px 2px #5e72e4;\r\n}\r\n\r\n.input-slider--cyan .noUi-connect {\r\n  background: #2bffc6;\r\n}\r\n\r\n/* Disabled state */\r\n[disabled] .noUi-connect,\r\n[disabled].noUi-connect {\r\n  background: #b2b2b2;\r\n}\r\n\r\n[disabled] .noUi-handle,\r\n[disabled].noUi-origin {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Range slider value labels */\r\n.range-slider-value {\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  background-color: rgba(33, 37, 41, 0.7);\r\n  color: #fff;\r\n  border-radius: 10px;\r\n  padding: 0.4em 0.8em 0.3em 0.85em;\r\n}\r\n\r\n.range-slider-wrapper .upper-info {\r\n  font-weight: 400;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.input-slider-value-output {\r\n  background: #333;\r\n  color: #fff;\r\n  padding: 4px 8px;\r\n  position: relative;\r\n  top: 12px;\r\n  font-size: 11px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.input-slider-value-output:after {\r\n  bottom: 100%;\r\n  left: 10px;\r\n  border: solid transparent;\r\n  content: \" \";\r\n  height: 0;\r\n  width: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n  border-color: rgba(136, 183, 213, 0);\r\n  border-bottom-color: #333;\r\n  border-width: 4px;\r\n  margin-left: -4px;\r\n}\r\n\r\n.input-slider-value-output.left:after {\r\n  left: 10px;\r\n  right: auto;\r\n}\r\n\r\n.input-slider-value-output.right:after {\r\n  right: 10px;\r\n  left: auto;\r\n}\r\n\r\n.ql-container {\r\n  font-family: Open Sans, sans-serif;\r\n}\r\n\r\n.ql-toolbar {\r\n  position: relative;\r\n  padding: 0.625rem 0.75rem;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.25rem 0.25rem 0 0;\r\n  color: #8898aa;\r\n}\r\n\r\n.ql-toolbar+.ql-container {\r\n  margin-top: -1px;\r\n}\r\n\r\n.ql-toolbar+.ql-container .ql-editor {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.ql-editor {\r\n  min-height: 6rem;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.625rem 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.25rem;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .ql-editor {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.ql-editor::-ms-expand {\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.ql-editor:focus {\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  border-color: #5e72e4;\r\n  outline: 0;\r\n  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.ql-editor:focus {\r\n  border-color: #dee2e6;\r\n}\r\n\r\n.ql-hidden {\r\n  position: absolute;\r\n  transform: scale(0);\r\n}\r\n\r\n.ql-editor.ql-blank::before {\r\n  top: 0.625rem;\r\n  left: 0.75rem;\r\n  font-style: normal;\r\n  color: #adb5bd;\r\n}\r\n\r\n.ql-editor:focus::before {\r\n  display: none;\r\n}\r\n\r\n.ql-formats {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.ql-formats:first-child {\r\n  padding-left: 0;\r\n}\r\n\r\n.ql-formats:last-child {\r\n  padding-right: 0;\r\n}\r\n\r\n.ql-toolbar button {\r\n  padding: 0 0.25rem;\r\n  background: none;\r\n  border: none;\r\n  color: #525f7f;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.ql-toolbar button:hover {\r\n  color: #5e72e4;\r\n}\r\n\r\n.ql-toolbar button:first-child {\r\n  margin-left: -0.25rem;\r\n}\r\n\r\n.ql-toolbar .ql-active {\r\n  color: #5e72e4;\r\n}\r\n\r\n.ql-toolbar button svg {\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n}\r\n\r\n.ql-toolbar .ql-stroke {\r\n  stroke: currentColor;\r\n  stroke-width: 2;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n  fill: none;\r\n}\r\n\r\n.ql-toolbar .ql-thin {\r\n  stroke-width: 1;\r\n}\r\n\r\n.ql-toolbar .ql-fill {\r\n  fill: currentColor;\r\n}\r\n\r\n.ql-toolbar input.ql-image {\r\n  position: absolute;\r\n  transform: scale(0);\r\n}\r\n\r\n.ql-tooltip {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  width: 18.5rem;\r\n  background-color: #fff;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 0.4375rem;\r\n  padding: 0.625rem 0.75rem;\r\n  margin-top: 0.6rem;\r\n  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.ql-tooltip:before,\r\n.ql-tooltip:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: 100%;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.ql-tooltip:before {\r\n  border-bottom: 0.6rem solid rgba(0, 0, 0, 0.05);\r\n  border-left: 0.6rem solid transparent;\r\n  border-right: 0.6rem solid transparent;\r\n}\r\n\r\n.ql-tooltip:after {\r\n  border-bottom: 0.5rem solid #fff;\r\n  border-left: 0.5rem solid transparent;\r\n  border-right: 0.5rem solid transparent;\r\n}\r\n\r\n.ql-container .ql-tooltip:hover {\r\n  display: flex !important;\r\n}\r\n\r\n.ql-tooltip .ql-preview {\r\n  width: 100%;\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\r\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .ql-tooltip .ql-preview {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.ql-tooltip.ql-editing .ql-preview {\r\n  display: none;\r\n}\r\n\r\n.ql-tooltip input {\r\n  display: none;\r\n  width: 100%;\r\n  padding-top: calc(0.25rem + 1px);\r\n  padding-bottom: calc(0.25rem + 1px);\r\n  background-color: transparent;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border: none;\r\n  color: #8898aa;\r\n}\r\n\r\n.ql-tooltip input:focus {\r\n  outline: none;\r\n}\r\n\r\n.ql-tooltip.ql-editing input {\r\n  display: block;\r\n}\r\n\r\n.ql-tooltip .ql-action,\r\n.ql-tooltip .ql-remove {\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.ql-tooltip .ql-action::before,\r\n.ql-tooltip .ql-remove::before {\r\n  display: inline-block;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  user-select: none;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\r\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .ql-tooltip .ql-action::before,\r\n  .ql-tooltip .ql-remove::before {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.ql-tooltip .ql-action::before:hover,\r\n.ql-tooltip .ql-action::before:focus,\r\n.ql-tooltip .ql-remove::before:hover,\r\n.ql-tooltip .ql-remove::before:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.ql-tooltip .ql-action::before:focus,\r\n.ql-tooltip .ql-action::before.focus,\r\n.ql-tooltip .ql-remove::before:focus,\r\n.ql-tooltip .ql-remove::before.focus {\r\n  outline: 0;\r\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.ql-tooltip .ql-action::before,\r\n.ql-tooltip.ql-editing .ql-action::before {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.ql-tooltip .ql-action::before:hover,\r\n.ql-tooltip.ql-editing .ql-action::before:hover {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.ql-tooltip .ql-action::before:focus,\r\n.ql-tooltip .ql-action::before.focus,\r\n.ql-tooltip.ql-editing .ql-action::before:focus,\r\n.ql-tooltip.ql-editing .ql-action::before.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.ql-tooltip .ql-action::before.disabled,\r\n.ql-tooltip .ql-action::before:disabled,\r\n.ql-tooltip.ql-editing .ql-action::before.disabled,\r\n.ql-tooltip.ql-editing .ql-action::before:disabled {\r\n  color: #fff;\r\n  background-color: #5e72e4;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.ql-tooltip .ql-action::before:not(:disabled):not(.disabled):active,\r\n.ql-tooltip .ql-action::before:not(:disabled):not(.disabled).active,\r\n.show>.ql-tooltip .ql-action::before.dropdown-toggle,\r\n.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled):active,\r\n.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled).active,\r\n.show>.ql-tooltip.ql-editing .ql-action::before.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #324cdd;\r\n  border-color: #5e72e4;\r\n}\r\n\r\n.ql-tooltip .ql-action::before:not(:disabled):not(.disabled):active:focus,\r\n.ql-tooltip .ql-action::before:not(:disabled):not(.disabled).active:focus,\r\n.show>.ql-tooltip .ql-action::before.dropdown-toggle:focus,\r\n.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled):active:focus,\r\n.ql-tooltip.ql-editing .ql-action::before:not(:disabled):not(.disabled).active:focus,\r\n.show>.ql-tooltip.ql-editing .ql-action::before.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);\r\n}\r\n\r\n.ql-tooltip .ql-action::before {\r\n  content: \"Edit\";\r\n}\r\n\r\n.ql-tooltip.ql-editing .ql-action::before {\r\n  content: \"Save\";\r\n}\r\n\r\n.ql-tooltip .ql-remove::before {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n  content: \"Remove\";\r\n  border-color: #dee2e6;\r\n}\r\n\r\n.ql-tooltip .ql-remove::before:hover {\r\n  color: #212529;\r\n  background-color: white;\r\n  border-color: white;\r\n}\r\n\r\n.ql-tooltip .ql-remove::before:focus,\r\n.ql-tooltip .ql-remove::before.focus {\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08),\r\n    0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.ql-tooltip .ql-remove::before.disabled,\r\n.ql-tooltip .ql-remove::before:disabled {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled):active,\r\n.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled).active,\r\n.show>.ql-tooltip .ql-remove::before.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #e6e6e6;\r\n  border-color: white;\r\n}\r\n\r\n.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled):active:focus,\r\n.ql-tooltip .ql-remove::before:not(:disabled):not(.disabled).active:focus,\r\n.show>.ql-tooltip .ql-remove::before.dropdown-toggle:focus {\r\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.ql-tooltip.ql-editing .ql-remove::before {\r\n  display: none;\r\n}\r\n\r\n.ql-editor blockquote {\r\n  margin-bottom: 1rem;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.ql-editor img {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.scroll-wrapper {\r\n  overflow: hidden !important;\r\n  padding: 0 !important;\r\n  position: relative;\r\n}\r\n\r\n.scroll-wrapper>.scroll-content {\r\n  border: none !important;\r\n  box-sizing: content-box !important;\r\n  height: auto;\r\n  left: 0;\r\n  margin: 0;\r\n  max-height: none;\r\n  max-width: none !important;\r\n  overflow: scroll !important;\r\n  padding: 0;\r\n  position: relative !important;\r\n  top: 0;\r\n  width: auto !important;\r\n}\r\n\r\n.scroll-wrapper>.scroll-content::-webkit-scrollbar {\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n.scroll-wrapper.scroll--rtl {\r\n  direction: rtl;\r\n}\r\n\r\n.scroll-element {\r\n  box-sizing: content-box;\r\n  display: none;\r\n}\r\n\r\n.scroll-element div {\r\n  box-sizing: content-box;\r\n}\r\n\r\n.scroll-element .scroll-bar,\r\n.scroll-element .scroll-arrow {\r\n  cursor: default;\r\n}\r\n\r\n.scroll-element.scroll-x.scroll-scrollx_visible,\r\n.scroll-element.scroll-y.scroll-scrolly_visible {\r\n  display: block;\r\n}\r\n\r\n.scroll-textarea {\r\n  border: 1px solid #cccccc;\r\n  border-top-color: #999999;\r\n}\r\n\r\n.scroll-textarea>.scroll-content {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.scroll-textarea>.scroll-content>textarea {\r\n  border: none !important;\r\n  box-sizing: border-box;\r\n  height: 100% !important;\r\n  margin: 0;\r\n  max-height: none !important;\r\n  max-width: none !important;\r\n  overflow: scroll !important;\r\n  outline: none;\r\n  padding: 2px;\r\n  position: relative !important;\r\n  top: 0;\r\n  width: 100% !important;\r\n}\r\n\r\n.scroll-textarea>.scroll-content>textarea::-webkit-scrollbar {\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n/*************** SIMPLE INNER SCROLLBAR ***************/\r\n.scrollbar-inner>.scroll-element,\r\n.scrollbar-inner>.scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element.scroll-x {\r\n  bottom: 2px;\r\n  height: 8px;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  right: 2px;\r\n  top: 0;\r\n  width: 8px;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element .scroll-element_outer {\r\n  overflow: hidden;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element .scroll-element_outer,\r\n.scrollbar-inner>.scroll-element .scroll-element_track,\r\n.scrollbar-inner>.scroll-element .scroll-bar {\r\n  -webkit-border-radius: 8px;\r\n  -moz-border-radius: 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element .scroll-element_track,\r\n.scrollbar-inner>.scroll-element .scroll-bar {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\r\n  filter: alpha(opacity=40);\r\n  opacity: 0.4;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element .scroll-element_track {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element .scroll-bar {\r\n  background-color: #c2c2c2;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element:hover .scroll-bar {\r\n  background-color: #919191;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element.scroll-draggable .scroll-bar {\r\n  background-color: #919191;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-inner>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -12px;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -12px;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -12px;\r\n}\r\n\r\n.scrollbar-inner>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -12px;\r\n}\r\n\r\n/*************** SIMPLE OUTER SCROLLBAR ***************/\r\n.scrollbar-outer>.scroll-element,\r\n.scrollbar-outer>.scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 12px;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  width: 12px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-x .scroll-element_outer {\r\n  height: 8px;\r\n  top: 2px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-y .scroll-element_outer {\r\n  left: 2px;\r\n  width: 8px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element .scroll-element_outer {\r\n  overflow: hidden;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element .scroll-element_track {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element .scroll-element_outer,\r\n.scrollbar-outer>.scroll-element .scroll-element_track,\r\n.scrollbar-outer>.scroll-element .scroll-bar {\r\n  -webkit-border-radius: 8px;\r\n  -moz-border-radius: 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element .scroll-bar {\r\n  background-color: #d9d9d9;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element .scroll-bar:hover {\r\n  background-color: #c2c2c2;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-draggable .scroll-bar {\r\n  background-color: #919191;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-outer>.scroll-content.scroll-scrolly_visible {\r\n  left: -12px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-content.scroll-scrollx_visible {\r\n  top: -12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-x .scroll-bar {\r\n  min-width: 10px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-y .scroll-bar {\r\n  min-height: 10px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-outer>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -14px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -14px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -14px;\r\n}\r\n\r\n.scrollbar-outer>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -14px;\r\n}\r\n\r\n/*************** SCROLLBAR MAC OS X ***************/\r\n.scrollbar-macosx>.scroll-element,\r\n.scrollbar-macosx>.scroll-element div {\r\n  background: none;\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element .scroll-element_track {\r\n  display: none;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element .scroll-bar {\r\n  background-color: #6c6e71;\r\n  display: block;\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\r\n  filter: alpha(opacity=0);\r\n  opacity: 0;\r\n  -webkit-border-radius: 7px;\r\n  -moz-border-radius: 7px;\r\n  border-radius: 7px;\r\n  -webkit-transition: opacity 0.2s linear;\r\n  -moz-transition: opacity 0.2s linear;\r\n  -o-transition: opacity 0.2s linear;\r\n  -ms-transition: opacity 0.2s linear;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.scrollbar-macosx:hover>.scroll-element .scroll-bar,\r\n.scrollbar-macosx>.scroll-element.scroll-draggable .scroll-bar {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\r\n  filter: alpha(opacity=70);\r\n  opacity: 0.7;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-x {\r\n  bottom: 0px;\r\n  height: 0px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  overflow: visible;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 0px;\r\n  top: 0;\r\n  width: 0px;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-macosx>.scroll-element.scroll-x .scroll-bar {\r\n  height: 7px;\r\n  min-width: 10px;\r\n  top: -9px;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-y .scroll-bar {\r\n  left: -9px;\r\n  min-height: 10px;\r\n  width: 7px;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-x .scroll-element_outer {\r\n  left: 2px;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-x .scroll-element_size {\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-y .scroll-element_outer {\r\n  top: 2px;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-macosx>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -11px;\r\n}\r\n\r\n.scrollbar-macosx>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -11px;\r\n}\r\n\r\n/*************** SCROLLBAR LIGHT ***************/\r\n.scrollbar-light>.scroll-element,\r\n.scrollbar-light>.scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-light>.scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-light>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-light>.scroll-element .scroll-element_outer {\r\n  -webkit-border-radius: 10px;\r\n  -moz-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element .scroll-element_size {\r\n  background: #dbdbdb;\r\n  background: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2RiZGJkYiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlOGU4ZTgiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+\");\r\n  background: -moz-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: -webkit-gradient(linear,\r\n      left top,\r\n      right top,\r\n      color-stop(0%, #dbdbdb),\r\n      color-stop(100%, #e8e8e8));\r\n  background: -webkit-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: -o-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: -ms-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: linear-gradient(to right, #dbdbdb 0%, #e8e8e8 100%);\r\n  -webkit-border-radius: 10px;\r\n  -moz-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 17px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  width: 17px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element .scroll-bar {\r\n  background: #fefefe;\r\n  background: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZlZmVmZSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmNWY1ZjUiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+\");\r\n  background: -moz-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: -webkit-gradient(linear,\r\n      left top,\r\n      right top,\r\n      color-stop(0%, #fefefe),\r\n      color-stop(100%, #f5f5f5));\r\n  background: -webkit-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: -o-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: -ms-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: linear-gradient(to right, #fefefe 0%, #f5f5f5 100%);\r\n  border: 1px solid #dbdbdb;\r\n  -webkit-border-radius: 10px;\r\n  -moz-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-light>.scroll-content.scroll-scrolly_visible {\r\n  left: -17px;\r\n  margin-left: 17px;\r\n}\r\n\r\n.scrollbar-light>.scroll-content.scroll-scrollx_visible {\r\n  top: -17px;\r\n  margin-top: 17px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-x .scroll-bar {\r\n  height: 10px;\r\n  min-width: 10px;\r\n  top: 0px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-y .scroll-bar {\r\n  left: 0px;\r\n  min-height: 10px;\r\n  width: 10px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-x .scroll-element_outer {\r\n  height: 12px;\r\n  left: 2px;\r\n  top: 2px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-x .scroll-element_size {\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-y .scroll-element_outer {\r\n  left: 2px;\r\n  top: 2px;\r\n  width: 12px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-light>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -19px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-light>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -19px;\r\n}\r\n\r\n/*************** SCROLLBAR RAIL ***************/\r\n.scrollbar-rail>.scroll-element,\r\n.scrollbar-rail>.scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element .scroll-element_size {\r\n  background-color: #999;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.scrollbar-rail>.scroll-element .scroll-element_outer:hover .scroll-element_size {\r\n  background-color: #666;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 12px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  padding: 3px 0 2px;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  padding: 0 2px 0 3px;\r\n  right: 0;\r\n  top: 0;\r\n  width: 12px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element .scroll-bar {\r\n  background-color: #d0b9a0;\r\n  -webkit-border-radius: 2px;\r\n  -moz-border-radius: 2px;\r\n  border-radius: 2px;\r\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.scrollbar-rail>.scroll-element .scroll-element_outer:hover .scroll-bar {\r\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-rail>.scroll-content.scroll-scrolly_visible {\r\n  left: -17px;\r\n  margin-left: 17px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-content.scroll-scrollx_visible {\r\n  margin-top: 17px;\r\n  top: -17px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-x .scroll-bar {\r\n  height: 10px;\r\n  min-width: 10px;\r\n  top: 1px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-y .scroll-bar {\r\n  left: 1px;\r\n  min-height: 10px;\r\n  width: 10px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-x .scroll-element_outer {\r\n  height: 15px;\r\n  left: 5px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-x .scroll-element_size {\r\n  height: 2px;\r\n  left: -10px;\r\n  top: 5px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-y .scroll-element_outer {\r\n  top: 5px;\r\n  width: 15px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-y .scroll-element_size {\r\n  left: 5px;\r\n  top: -10px;\r\n  width: 2px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-rail>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -25px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -25px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -25px;\r\n}\r\n\r\n.scrollbar-rail>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -25px;\r\n}\r\n\r\n/*************** SCROLLBAR DYNAMIC ***************/\r\n.scrollbar-dynamic>.scroll-element,\r\n.scrollbar-dynamic>.scroll-element div {\r\n  background: none;\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-x {\r\n  bottom: 2px;\r\n  height: 7px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 2px;\r\n  top: 0;\r\n  width: 7px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element .scroll-element_outer {\r\n  opacity: 0.3;\r\n  -webkit-border-radius: 12px;\r\n  -moz-border-radius: 12px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element .scroll-element_size {\r\n  background-color: #cccccc;\r\n  opacity: 0;\r\n  -webkit-border-radius: 12px;\r\n  -moz-border-radius: 12px;\r\n  border-radius: 12px;\r\n  -webkit-transition: opacity 0.2s;\r\n  -moz-transition: opacity 0.2s;\r\n  -o-transition: opacity 0.2s;\r\n  -ms-transition: opacity 0.2s;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element .scroll-bar {\r\n  background-color: #6c6e71;\r\n  -webkit-border-radius: 7px;\r\n  -moz-border-radius: 7px;\r\n  border-radius: 7px;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-dynamic>.scroll-element.scroll-x .scroll-bar {\r\n  bottom: 0;\r\n  height: 7px;\r\n  min-width: 24px;\r\n  top: auto;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-y .scroll-bar {\r\n  left: auto;\r\n  min-height: 24px;\r\n  right: 0;\r\n  width: 7px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-x .scroll-element_outer {\r\n  bottom: 0;\r\n  top: auto;\r\n  left: 2px;\r\n  -webkit-transition: height 0.2s;\r\n  -moz-transition: height 0.2s;\r\n  -o-transition: height 0.2s;\r\n  -ms-transition: height 0.2s;\r\n  transition: height 0.2s;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-y .scroll-element_outer {\r\n  left: auto;\r\n  right: 0;\r\n  top: 2px;\r\n  -webkit-transition: width 0.2s;\r\n  -moz-transition: width 0.2s;\r\n  -o-transition: width 0.2s;\r\n  -ms-transition: width 0.2s;\r\n  transition: width 0.2s;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-x .scroll-element_size {\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-dynamic>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -11px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -11px;\r\n}\r\n\r\n/* hover & drag */\r\n.scrollbar-dynamic>.scroll-element:hover .scroll-element_outer,\r\n.scrollbar-dynamic>.scroll-element.scroll-draggable .scroll-element_outer {\r\n  overflow: hidden;\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\r\n  filter: alpha(opacity=70);\r\n  opacity: 0.7;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element:hover .scroll-element_outer .scroll-element_size,\r\n.scrollbar-dynamic>.scroll-element.scroll-draggable .scroll-element_outer .scroll-element_size {\r\n  opacity: 1;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element:hover .scroll-element_outer .scroll-bar,\r\n.scrollbar-dynamic>.scroll-element.scroll-draggable .scroll-element_outer .scroll-bar {\r\n  height: 100%;\r\n  width: 100%;\r\n  -webkit-border-radius: 12px;\r\n  -moz-border-radius: 12px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-x:hover .scroll-element_outer,\r\n.scrollbar-dynamic>.scroll-element.scroll-x.scroll-draggable .scroll-element_outer {\r\n  height: 20px;\r\n  min-height: 7px;\r\n}\r\n\r\n.scrollbar-dynamic>.scroll-element.scroll-y:hover .scroll-element_outer,\r\n.scrollbar-dynamic>.scroll-element.scroll-y.scroll-draggable .scroll-element_outer {\r\n  min-width: 7px;\r\n  width: 20px;\r\n}\r\n\r\n/*************** SCROLLBAR GOOGLE CHROME ***************/\r\n.scrollbar-chrome>.scroll-element,\r\n.scrollbar-chrome>.scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element .scroll-element_track {\r\n  background: #f1f1f1;\r\n  border: 1px solid #dbdbdb;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 16px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  width: 16px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element .scroll-bar {\r\n  background-color: #d9d9d9;\r\n  border: 1px solid #bdbdbd;\r\n  cursor: default;\r\n  -webkit-border-radius: 2px;\r\n  -moz-border-radius: 2px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element .scroll-bar:hover {\r\n  background-color: #c2c2c2;\r\n  border-color: #a9a9a9;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-draggable .scroll-bar {\r\n  background-color: #919191;\r\n  border-color: #7e7e7e;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-chrome>.scroll-content.scroll-scrolly_visible {\r\n  left: -16px;\r\n  margin-left: 16px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-content.scroll-scrollx_visible {\r\n  top: -16px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-x .scroll-bar {\r\n  height: 8px;\r\n  min-width: 10px;\r\n  top: 3px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y .scroll-bar {\r\n  left: 3px;\r\n  min-height: 10px;\r\n  width: 8px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-x .scroll-element_outer {\r\n  border-left: 1px solid #dbdbdb;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-x .scroll-element_track {\r\n  height: 14px;\r\n  left: -3px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-x .scroll-element_size {\r\n  height: 14px;\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y .scroll-element_outer {\r\n  border-top: 1px solid #dbdbdb;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y .scroll-element_track {\r\n  top: -3px;\r\n  width: 14px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n  width: 14px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-chrome>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -19px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-chrome>.scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -19px;\r\n}\r\n\r\n.scrollbar-inner {\r\n  height: 100%;\r\n}\r\n\r\n.scrollbar-inner:not(:hover) .scroll-element {\r\n  opacity: 0;\r\n}\r\n\r\n.scrollbar-inner .scroll-element {\r\n  transition: opacity 300ms;\r\n  margin-right: 2px;\r\n}\r\n\r\n.scrollbar-inner .scroll-element .scroll-bar,\r\n.scrollbar-inner .scroll-element .scroll-element_track {\r\n  transition: background-color 300ms;\r\n}\r\n\r\n.scrollbar-inner .scroll-element .scroll-element_track {\r\n  background-color: transparent;\r\n}\r\n\r\n.scrollbar-inner .scroll-element:hover {\r\n  width: 4px;\r\n}\r\n\r\n.scrollbar-inner .scroll-element.scroll-y {\r\n  width: 3px;\r\n  right: 0;\r\n}\r\n\r\n.scrollbar-inner .scroll-element.scroll-x {\r\n  height: 3px;\r\n  bottom: 0;\r\n}\r\n\r\n.select2-selection__arrow {\r\n  display: none;\r\n}\r\n\r\n.select2.select2-container {\r\n  width: 100% !important;\r\n}\r\n\r\n.select2-container .select2-selection--single,\r\n.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.select2-container--default .select2-selection--multiple,\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n  display: block;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  padding: 0.625rem 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.25rem;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);\r\n  transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n\r\n  .select2-container .select2-selection--single,\r\n  .select2-container--default.select2-container--focus .select2-selection--multiple,\r\n  .select2-container--default .select2-selection--multiple,\r\n  .select2-container--default .select2-search--dropdown .select2-search__field {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.select2-container .select2-selection--single::-ms-expand,\r\n.select2-container--default.select2-container--focus .select2-selection--multiple::-ms-expand,\r\n.select2-container--default .select2-selection--multiple::-ms-expand,\r\n.select2-container--default .select2-search--dropdown .select2-search__field::-ms-expand {\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.select2-container .select2-selection--single:focus,\r\n.select2-container--default.select2-container--focus .select2-selection--multiple:focus,\r\n.select2-container--default .select2-selection--multiple:focus,\r\n.select2-container--default .select2-search--dropdown .select2-search__field:focus {\r\n  color: #8898aa;\r\n  background-color: #fff;\r\n  border-color: #5e72e4;\r\n  outline: 0;\r\n  box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(94, 114, 228, 0.1);\r\n}\r\n\r\n.select2-container .select2-selection--single::placeholder,\r\n.select2-container--default.select2-container--focus .select2-selection--multiple::placeholder,\r\n.select2-container--default .select2-selection--multiple::placeholder,\r\n.select2-container--default .select2-search--dropdown .select2-search__field::placeholder {\r\n  color: #adb5bd;\r\n  opacity: 1;\r\n}\r\n\r\n.select2-container .select2-selection--single:disabled,\r\n.select2-container .select2-selection--single[readonly],\r\n.select2-container--default.select2-container--focus .select2-selection--multiple:disabled,\r\n.select2-container--default.select2-container--focus .select2-selection--multiple[readonly],\r\n.select2-container--default .select2-selection--multiple:disabled,\r\n.select2-container--default .select2-selection--multiple[readonly],\r\n.select2-container--default .select2-search--dropdown .select2-search__field:disabled,\r\n.select2-container--default .select2-search--dropdown .select2-search__field[readonly] {\r\n  background-color: #e9ecef;\r\n  opacity: 1;\r\n}\r\n\r\n.select2-container .select2-selection--single .select2-selection__rendered {\r\n  padding: 0;\r\n  overflow: inherit;\r\n  text-overflow: inherit;\r\n  white-space: inherit;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n  color: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\n.select2-dropdown {\r\n  padding: 0.5rem 0;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n.select2-results__option {\r\n  padding: 0.5rem 0.75rem;\r\n  background-color: #fff;\r\n  color: #212529;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.select2-results__option:hover,\r\n.select2-results__option:focus {\r\n  color: #16181b;\r\n  text-decoration: none;\r\n  background-color: #f6f9fc;\r\n}\r\n\r\n.select2-container--default .select2-results__option--highlighted[aria-selected],\r\n.select2-container--default .select2-results__option[aria-selected=\"true\"] {\r\n  background-color: transparent;\r\n  color: #16181b;\r\n}\r\n\r\n.select2-container--default .select2-results__option[aria-disabled=\"true\"] {\r\n  color: #adb5bd;\r\n}\r\n\r\n.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.select2-container--default .select2-selection--multiple {\r\n  height: auto;\r\n  min-height: calc(1.5em + 1.25rem + 2px);\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\r\n  display: block;\r\n  margin: 0 0 -0.25rem -0.25rem;\r\n  padding: 0;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n  display: inline-flex;\r\n  padding: 0 0.5rem;\r\n  margin: 0 0 0.25rem 0.25rem;\r\n  background-color: #adb5bd;\r\n  border: none;\r\n  border-radius: 0.25rem;\r\n  line-height: 1.5rem;\r\n  font-size: 0.875rem;\r\n  color: #8898aa;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\r\n  order: 2;\r\n  margin-left: 0.5rem;\r\n  color: #8898aa;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {\r\n  color: #525f7f;\r\n}\r\n\r\n.select2-container .select2-search--inline {\r\n  display: none;\r\n}\r\n\r\n.select2-selection[aria-expanded=\"true\"] {\r\n  border-bottom-left-radius: 0 !important;\r\n  border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.select2-search--dropdown {\r\n  padding: 0.5rem 0.75rem;\r\n}\r\n\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.form-control-sm+.select2-container .select2-selection--single,\r\n.form-control-sm+.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-sm+.select2-container--default .select2-selection--multiple {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.form-control-sm+.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-sm+.select2-container--default .select2-selection--multiple {\r\n  min-height: calc(1.5em + 0.5rem + 2px);\r\n}\r\n\r\n.form-control-sm+.select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n  line-height: 1.3125rem;\r\n}\r\n\r\n.form-control-lg+.select2-container .select2-selection--single,\r\n.form-control-lg+.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-lg+.select2-container--default .select2-selection--multiple {\r\n  height: calc(1.5em + 1.75rem + 2px);\r\n  padding: 0.875rem 1rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n  border-radius: 0.4375rem;\r\n}\r\n\r\n.form-control-lg+.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-lg+.select2-container--default .select2-selection--multiple {\r\n  min-height: calc(1.5em + 1.75rem + 2px);\r\n}\r\n\r\n.form-control-lg+.select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n  line-height: 1.875rem;\r\n}\r\n\r\n.swal2-popup {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.swal2-popup .swal2-title {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.swal2-popup .swal2-content {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.swal2-popup .swal2-image {\r\n  max-width: 200px;\r\n}\r\n\r\n.sr-only,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\r\n.bootstrap-datetimepicker-widget .picker-switch::after,\r\n.bootstrap-datetimepicker-widget table th.prev::after,\r\n.bootstrap-datetimepicker-widget table th.next::after {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget {\r\n  list-style: none;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget a .btn:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu {\r\n  padding: 8px 6px;\r\n  width: 254px;\r\n  max-width: 254px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu .tim-icons {\r\n  opacity: 1;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu .picker-switch .table-condensed:hover {\r\n  background: #eee;\r\n  border-radius: 3px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed {\r\n  margin-top: 10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed .btn[data-action=\"togglePeriod\"]:hover,\r\n.bootstrap-datetimepicker-widget.dropdown-menu .timepicker-picker .table-condensed .separator {\r\n  color: #9a9a9a !important;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .month,\r\n.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .year,\r\n.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .decade {\r\n  color: #9a9a9a;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .month.active,\r\n.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .year.active,\r\n.bootstrap-datetimepicker-widget.dropdown-menu .table-condensed .decade.active {\r\n  color: #fff;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  right: auto;\r\n  border-bottom: 0.4em solid;\r\n  border-right: 0.4em solid transparent;\r\n  border-left: 0.4em solid transparent;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top:before {\r\n  display: none;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top:after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  top: auto;\r\n  bottom: -6px;\r\n  right: auto;\r\n  left: 10px;\r\n  color: #fff;\r\n  border-top: 0.4em solid;\r\n  border-right: 0.4em solid transparent;\r\n  border-left: 0.4em solid transparent;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\r\n  margin-top: auto;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\r\n  margin-top: auto;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\r\n  left: auto;\r\n  right: 6px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\r\n  left: auto;\r\n  right: 7px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .list-unstyled {\r\n  margin: 0;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget a[data-action] {\r\n  padding: 0;\r\n  border-width: 0;\r\n  color: #fff;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\r\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\r\n  color: #5e72e4;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget a[data-action]:active {\r\n  box-shadow: none;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .timepicker-hour,\r\n.bootstrap-datetimepicker-widget .timepicker-minute,\r\n.bootstrap-datetimepicker-widget .timepicker-second {\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  font-weight: 300;\r\n  font-size: 1.5em;\r\n  margin: 3px;\r\n  border-radius: 50%;\r\n  color: #9a9a9a;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget button[data-action] {\r\n  width: 38px;\r\n  height: 38px;\r\n  padding: 0;\r\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn {\r\n  margin: 0 !important;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\r\n  content: \"Increment Hours\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\r\n  content: \"Increment Minutes\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\r\n  content: \"Decrement Hours\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\r\n  content: \"Decrement Minutes\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\r\n  content: \"Show Hours\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\r\n  content: \"Show Minutes\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\r\n  content: \"Toggle AM/PM\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\r\n  content: \"Clear the picker\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\r\n  content: \"Set the date to today\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .picker-switch {\r\n  text-align: center;\r\n  border-radius: 3px;\r\n  color: #5e72e4;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .picker-switch::after {\r\n  content: \"Toggle Date and Time Screens\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .picker-switch td {\r\n  padding: 0;\r\n  margin: 0;\r\n  height: auto;\r\n  width: auto;\r\n  line-height: inherit;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .picker-switch td span {\r\n  line-height: 2.5;\r\n  height: 2.5em;\r\n  width: 100%;\r\n  border-radius: 3px;\r\n  margin: 2px 0px !important;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table {\r\n  width: 100%;\r\n  margin: 0;\r\n  text-align: center;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td>div,\r\n.bootstrap-datetimepicker-widget table th>div {\r\n  text-align: center;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th {\r\n  height: 20px;\r\n  line-height: 20px;\r\n  width: 20px;\r\n  font-weight: 300;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th.picker-switch {\r\n  width: 145px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th.disabled,\r\n.bootstrap-datetimepicker-widget table th.disabled:hover {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th.prev span,\r\n.bootstrap-datetimepicker-widget table th.next span {\r\n  border-radius: 4px;\r\n  height: 27px;\r\n  width: 27px;\r\n  line-height: 28px;\r\n  font-size: 12px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  color: #5e72e4;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th.prev::after {\r\n  content: \"Previous Month\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th.next::after {\r\n  content: \"Next Month\";\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table th.dow {\r\n  text-align: center;\r\n  color: #5e72e4;\r\n  padding-bottom: 5px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\r\n  background: #eee;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.cw>div {\r\n  font-size: 0.8em;\r\n  height: 20px;\r\n  line-height: 20px;\r\n  color: #cfcfca;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.day>div,\r\n.bootstrap-datetimepicker-widget table td.minute>div,\r\n.bootstrap-datetimepicker-widget table td.hour>div {\r\n  height: 30px;\r\n  line-height: 2.2;\r\n  width: 30px;\r\n  text-align: center;\r\n  padding: 0px;\r\n  border-radius: 50%;\r\n  margin: 0 auto;\r\n  z-index: -1;\r\n  color: #9a9a9a;\r\n  position: relative;\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n  border: none;\r\n  cursor: pointer;\r\n  -webkit-transition: all 300ms ease 0s;\r\n  -moz-transition: all 300ms ease 0s;\r\n  -o-transition: all 300ms ease 0s;\r\n  -ms-transition: all 300ms ease 0s;\r\n  transition: all 300ms ease 0s;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.day:hover>div,\r\n.bootstrap-datetimepicker-widget table td.hour:hover>div,\r\n.bootstrap-datetimepicker-widget table td.minute:hover>div,\r\n.bootstrap-datetimepicker-widget table td.second:hover>div {\r\n  background: #eee;\r\n  cursor: pointer;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.old>div,\r\n.bootstrap-datetimepicker-widget table td.new>div {\r\n  color: #172b4d;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.today,\r\n.bootstrap-datetimepicker-widget table td.day {\r\n  background: transparent !important;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.today>div:before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  border: 0 0 7px 7px solid transparent;\r\n  border-bottom-color: #68b3c8;\r\n  border-top-color: rgba(0, 0, 0, 0.2);\r\n  position: absolute;\r\n  bottom: 4px;\r\n  right: 4px;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.active>div,\r\n.bootstrap-datetimepicker-widget table td.active:hover>div {\r\n  background-color: #5e72e4;\r\n  color: #fff;\r\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.active.today:before>div {\r\n  border-bottom-color: #fff;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.disabled>div,\r\n.bootstrap-datetimepicker-widget table td.disabled:hover>div {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td span {\r\n  display: inline-block;\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  margin: 0 3px;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td span.active {\r\n  background-color: #5e72e4;\r\n  color: #ffffff;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td span.old {\r\n  color: #cfcfca;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td span.disabled,\r\n.bootstrap-datetimepicker-widget table td span.disabled:hover {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .timepicker-picker span,\r\n.bootstrap-datetimepicker-widget .timepicker-hours span,\r\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\r\n  height: 27px;\r\n  line-height: 27px;\r\n}\r\n\r\n.input-group.date .input-group-addon {\r\n  cursor: pointer;\r\n}\r\n\r\n.table-condensed>tbody>tr>td,\r\n.table-condensed>tbody>tr>th,\r\n.table-condensed>tfoot>tr>td,\r\n.table-condensed>tfoot>tr>th,\r\n.table-condensed>thead>tr>td,\r\n.table-condensed>thead>tr>th {\r\n  padding: 1px;\r\n  text-align: center;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .separator {\r\n  position: relative;\r\n  color: red;\r\n  width: auto;\r\n  height: auto;\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .picker-switch,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table th.prev span,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table th.next span,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.day>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget span,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .timepicker-hours span,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .timepicker-minutes span,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget .separator,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.minute>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.hour>div {\r\n  color: #9a9a9a;\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table th.dow {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.old>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.new>div {\r\n  color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget button[data-action] {\r\n  background-color: #fff;\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.active>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.active:hover>div {\r\n  background-color: #fff;\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td:not(.active).day:hover>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.hour:hover>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.minute:hover>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td.second:hover>div,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table td span:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,\r\ninput.datetimepicker[data-color]+.bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\ninput.datetimepicker[data-color=\"orange\"]+.bootstrap-datetimepicker-widget {\r\n  background-color: #5e72e4;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"orange\"]+.bootstrap-datetimepicker-widget table td.active>div,\r\ninput.datetimepicker[data-color=\"orange\"]+.bootstrap-datetimepicker-widget table td.active:hover>div,\r\ninput.datetimepicker[data-color=\"orange\"]+.bootstrap-datetimepicker-widget button[data-action],\r\ninput.datetimepicker[data-color=\"orange\"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,\r\ninput.datetimepicker[data-color=\"orange\"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\r\n  color: #5e72e4;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"blue\"]+.bootstrap-datetimepicker-widget {\r\n  background-color: #11cdef;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"blue\"]+.bootstrap-datetimepicker-widget table td.active>div,\r\ninput.datetimepicker[data-color=\"blue\"]+.bootstrap-datetimepicker-widget table td.active:hover>div,\r\ninput.datetimepicker[data-color=\"blue\"]+.bootstrap-datetimepicker-widget button[data-action],\r\ninput.datetimepicker[data-color=\"blue\"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,\r\ninput.datetimepicker[data-color=\"blue\"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\r\n  color: #11cdef;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"green\"]+.bootstrap-datetimepicker-widget {\r\n  background-color: #2dce89;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"green\"]+.bootstrap-datetimepicker-widget table td.active>div,\r\ninput.datetimepicker[data-color=\"green\"]+.bootstrap-datetimepicker-widget table td.active:hover>div,\r\ninput.datetimepicker[data-color=\"green\"]+.bootstrap-datetimepicker-widget button[data-action],\r\ninput.datetimepicker[data-color=\"green\"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,\r\ninput.datetimepicker[data-color=\"green\"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\r\n  color: #2dce89;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"red\"]+.bootstrap-datetimepicker-widget {\r\n  background-color: #f5365c;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"red\"]+.bootstrap-datetimepicker-widget table td.active>div,\r\ninput.datetimepicker[data-color=\"red\"]+.bootstrap-datetimepicker-widget table td.active:hover>div,\r\ninput.datetimepicker[data-color=\"red\"]+.bootstrap-datetimepicker-widget button[data-action],\r\ninput.datetimepicker[data-color=\"red\"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,\r\ninput.datetimepicker[data-color=\"red\"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\r\n  color: #f5365c;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"yellow\"]+.bootstrap-datetimepicker-widget {\r\n  background-color: #fb6340;\r\n}\r\n\r\ninput.datetimepicker[data-color=\"yellow\"]+.bootstrap-datetimepicker-widget table td.active>div,\r\ninput.datetimepicker[data-color=\"yellow\"]+.bootstrap-datetimepicker-widget table td.active:hover>div,\r\ninput.datetimepicker[data-color=\"yellow\"]+.bootstrap-datetimepicker-widget button[data-action],\r\ninput.datetimepicker[data-color=\"yellow\"]+.bootstrap-datetimepicker-widget.dropdown-menu.top:after,\r\ninput.datetimepicker[data-color=\"yellow\"]+.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\r\n  color: #fb6340;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .day,\r\n.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .minute {\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .day:hover,\r\n.bootstrap-datetimepicker-widget.dropdown-black .datepicker-days .minute:hover {\r\n  color: #212529;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black table td span,\r\n.bootstrap-datetimepicker-widget.dropdown-black table td.minute,\r\n.bootstrap-datetimepicker-widget.dropdown-black table td.hour {\r\n  color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black table td span:hover,\r\n.bootstrap-datetimepicker-widget.dropdown-black table td.minute:hover,\r\n.bootstrap-datetimepicker-widget.dropdown-black table td.hour:hover {\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black table td span:hover div,\r\n.bootstrap-datetimepicker-widget.dropdown-black table td.minute:hover div,\r\n.bootstrap-datetimepicker-widget.dropdown-black table td.hour:hover div {\r\n  background: transparent;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black table td .btn[data-action] {\r\n  color: #fff;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-black table td .btn[data-action=\"togglePeriod\"] {\r\n  background: transparent;\r\n}\r\n\r\n.dropzone .dz-button {\r\n  padding: 0;\r\n  border: none;\r\n  text-align: center;\r\n  color: #8898aa;\r\n  -webkit-transition: all 0.15s ease;\r\n  transition: all 0.15s ease;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.4;\r\n}\r\n\r\n.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {\r\n  float: right;\r\n}\r\n\r\n.fc-dayGrid-view .fc-body .fc-row {\r\n  min-height: 4em;\r\n}\r\n\r\n.fc.fc-theme-standard td,\r\n.fc.fc-theme-standard th,\r\n.fc.fc-theme-standard .fc-scrollgrid {\r\n  border-color: #eff1f3 !important;\r\n}\r\n\r\n.fc .fc-h-event {\r\n  border: none;\r\n}\r\n\r\n.fc .fc-col-header-cell.fc-day {\r\n  text-align: left;\r\n  padding: 0.75rem 1rem;\r\n}\r\n\r\n.fc .fc-col-header-cell.fc-day .fc-col-header-cell-cushion {\r\n  padding: 0;\r\n  color: #8898aa;\r\n}\r\n\r\n.fc .fc-day .fc-daygrid-day-top {\r\n  flex-direction: row;\r\n}\r\n\r\n.fc .fc-day .fc-daygrid-day-top .fc-daygrid-day-number {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #67779d;\r\n  padding: 0.5rem 1rem;\r\n}\r\n\r\n.fc .fc-daygrid-day.fc-day-today {\r\n  background-color: inherit !important;\r\n}\r\n\r\n.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number {\r\n  color: #fb6340;\r\n}\r\n\r\n.fc .fc-event {\r\n  margin: 2px 9px 1px !important;\r\n}\r\n\r\n.fc .fc-event-main {\r\n  padding: 0;\r\n  font-size: 0.75rem;\r\n  border-radius: 0.25rem;\r\n  border: 0;\r\n}\r\n\r\n.fc .fc-event-main .fc-event-title {\r\n  padding: 0.4rem 0.5rem;\r\n  display: block;\r\n  color: #fff;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 600;\r\n}\r\n\r\n.fc .fc-event-main .fc-time {\r\n  float: left;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  padding: 2px 6px;\r\n  margin: 0 0 0 -1px;\r\n}\r\n\r\n.noUi-target,\r\n.noUi-target * {\r\n  -webkit-touch-callout: none;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n  -webkit-user-select: none;\r\n  touch-action: none;\r\n  user-select: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.noUi-target {\r\n  position: relative;\r\n  direction: ltr;\r\n}\r\n\r\n.noUi-base,\r\n.noUi-connects {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n/* Wrapper for all connect elements.\r\n */\r\n.noUi-connects {\r\n  overflow: hidden;\r\n  z-index: 0;\r\n}\r\n\r\n.noUi-connect,\r\n.noUi-origin {\r\n  will-change: transform;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  -ms-transform-origin: 0 0;\r\n  -webkit-transform-origin: 0 0;\r\n  -webkit-transform-style: preserve-3d;\r\n  transform-origin: 0 0;\r\n  transform-style: flat;\r\n}\r\n\r\n.noUi-connect {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.noUi-origin {\r\n  height: 10%;\r\n  width: 10%;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.noUi-vertical .noUi-origin {\r\n  width: 0;\r\n}\r\n\r\n.noUi-horizontal .noUi-origin {\r\n  height: 0;\r\n}\r\n\r\n.noUi-handle {\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  position: absolute;\r\n}\r\n\r\n.noUi-touch-area {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n  -webkit-transition: transform 0.3s;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.noUi-state-drag * {\r\n  cursor: inherit !important;\r\n}\r\n\r\n.noUi-horizontal {\r\n  height: 5px;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle {\r\n  width: 34px;\r\n  height: 28px;\r\n  left: -17px;\r\n  top: -6px;\r\n}\r\n\r\n.noUi-vertical {\r\n  width: 5px;\r\n}\r\n\r\n.noUi-vertical .noUi-handle {\r\n  width: 28px;\r\n  height: 34px;\r\n  left: -6px;\r\n  top: -17px;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -17px;\r\n  left: auto;\r\n}\r\n\r\n.noUi-connects {\r\n  border-radius: 3px;\r\n}\r\n\r\n.noUi-connect {\r\n  background: #5e72e4;\r\n}\r\n\r\n.noUi-draggable {\r\n  cursor: ew-resize;\r\n}\r\n\r\n.noUi-vertical .noUi-draggable {\r\n  cursor: ns-resize;\r\n}\r\n\r\n.noUi-handle {\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  cursor: default;\r\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\r\n  outline: none;\r\n}\r\n\r\n.noUi-active {\r\n  outline: none;\r\n}\r\n\r\n/* Disabled state;\r\n */\r\n[disabled] .noUi-connect {\r\n  background: #b8b8b8;\r\n}\r\n\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Base;\r\n *\r\n */\r\n.noUi-pips,\r\n.noUi-pips * {\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.noUi-pips {\r\n  position: absolute;\r\n  color: #999;\r\n}\r\n\r\n/* Values;\r\n *\r\n */\r\n.noUi-value {\r\n  position: absolute;\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n\r\n.noUi-value-sub {\r\n  color: #ccc;\r\n  font-size: 10px;\r\n}\r\n\r\n/* Markings;\r\n *\r\n */\r\n.noUi-marker {\r\n  position: absolute;\r\n  background: #ccc;\r\n}\r\n\r\n.noUi-marker-sub {\r\n  background: #aaa;\r\n}\r\n\r\n.noUi-marker-large {\r\n  background: #aaa;\r\n}\r\n\r\n/* Horizontal layout;\r\n *\r\n */\r\n.noUi-pips-horizontal {\r\n  padding: 10px 0;\r\n  height: 80px;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.noUi-value-horizontal {\r\n  -webkit-transform: translate(-50%, 50%);\r\n  transform: translate(-50%, 50%);\r\n}\r\n\r\n.noUi-rtl .noUi-value-horizontal {\r\n  -webkit-transform: translate(50%, 50%);\r\n  transform: translate(50%, 50%);\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker {\r\n  margin-left: -1px;\r\n  width: 2px;\r\n  height: 5px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n  height: 10px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n  height: 15px;\r\n}\r\n\r\n/* Vertical layout;\r\n *\r\n */\r\n.noUi-pips-vertical {\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 100%;\r\n}\r\n\r\n.noUi-value-vertical {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%, 0);\r\n  padding-left: 25px;\r\n}\r\n\r\n.noUi-rtl .noUi-value-vertical {\r\n  -webkit-transform: translate(0, 50%);\r\n  transform: translate(0, 50%);\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker {\r\n  width: 5px;\r\n  height: 2px;\r\n  margin-top: -1px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n  width: 10px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-large {\r\n  width: 15px;\r\n}\r\n\r\n.noUi-tooltip {\r\n  display: block;\r\n  position: absolute;\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  color: #000;\r\n  padding: 5px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.noUi-horizontal .noUi-tooltip {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n  left: 50%;\r\n  bottom: 120%;\r\n}\r\n\r\n.noUi-vertical .noUi-tooltip {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  top: 50%;\r\n  right: 120%;\r\n}\r\n\r\n.noUi-target {\r\n  background: #eceeef;\r\n  border-radius: 5px;\r\n  border: 0;\r\n  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);\r\n  margin: 15px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.noUi-horizontal {\r\n  height: 5px;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -10px;\r\n}\r\n\r\n.noUi-vertical {\r\n  width: 5px;\r\n}\r\n\r\n.noUi-connect {\r\n  background: #5e72e4;\r\n  box-shadow: none;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle,\r\n.noUi-vertical .noUi-handle {\r\n  top: -5px;\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 100%;\r\n  box-shadow: none;\r\n  cursor: pointer;\r\n  background-color: #5e72e4;\r\n  border: 0;\r\n  transition: box-shadow 0.15s, transform 0.15s;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle.noUi-active,\r\n.noUi-vertical .noUi-handle.noUi-active {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.input-slider--cyan .noUi-connect {\r\n  background: #2bffc6;\r\n}\r\n\r\n.input-slider--cyan.noUi-horizontal .noUi-handle,\r\n.input-slider--cyan.noUi-vertical .noUi-handle {\r\n  background-color: #2bffc6;\r\n}\r\n\r\n.input-slider--red .noUi-connect {\r\n  background: #f5365c;\r\n}\r\n\r\n.input-slider--red.noUi-horizontal .noUi-handle,\r\n.input-slider--red.noUi-vertical .noUi-handle {\r\n  background-color: #f5365c;\r\n}\r\n\r\n.input-slider--green .noUi-connect {\r\n  background: #2dce89;\r\n}\r\n\r\n.input-slider--green.noUi-horizontal .noUi-handle,\r\n.input-slider--green.noUi-vertical .noUi-handle {\r\n  background-color: #2dce89;\r\n}\r\n\r\n.input-slider--yellow .noUi-connect {\r\n  background: #ffd600;\r\n}\r\n\r\n.input-slider--yellow.noUi-horizontal .noUi-handle,\r\n.input-slider--yellow.noUi-vertical .noUi-handle {\r\n  background-color: #ffd600;\r\n}\r\n\r\n.input-slider--pink .noUi-connect {\r\n  background: #f3a4b5;\r\n}\r\n\r\n.input-slider--pink.noUi-horizontal .noUi-handle,\r\n.input-slider--pink.noUi-vertical .noUi-handle {\r\n  background-color: #f3a4b5;\r\n}\r\n\r\n/* Disabled state */\r\n[disabled] .noUi-connect,\r\n[disabled].noUi-connect {\r\n  background: #b2b2b2;\r\n}\r\n\r\n[disabled] .noUi-handle,\r\n[disabled].noUi-origin {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Range slider value labels */\r\n.range-slider-value {\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  background-color: rgba(33, 37, 41, 0.7);\r\n  color: #fff;\r\n  border-radius: 10px;\r\n  padding: 0.4em 0.8em 0.3em 0.85em;\r\n}\r\n\r\n.range-slider-wrapper .upper-info {\r\n  font-weight: 400;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.input-slider-value-output {\r\n  background: #333;\r\n  color: #fff;\r\n  padding: 4px 8px;\r\n  position: relative;\r\n  top: 12px;\r\n  font-size: 11px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.input-slider-value-output:after {\r\n  bottom: 100%;\r\n  left: 10px;\r\n  border: solid transparent;\r\n  content: \" \";\r\n  height: 0;\r\n  width: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n  border-color: rgba(136, 183, 213, 0);\r\n  border-bottom-color: #333;\r\n  border-width: 4px;\r\n  margin-left: -4px;\r\n}\r\n\r\n.input-slider-value-output.left:after {\r\n  left: 10px;\r\n  right: auto;\r\n}\r\n\r\n.input-slider-value-output.right:after {\r\n  right: 10px;\r\n  left: auto;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .sweet-alert {\r\n    margin-top: 100px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .sweet-alert {\r\n    margin-top: 50px !important;\r\n  }\r\n}\r\n\r\n.react-bootstrap-table .table {\r\n  margin-bottom: 1.25rem;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.react-bootstrap-table th {\r\n  color: #000000;\r\n  background-color: #f6f9fc;\r\n}\r\n\r\n.react-bootstrap-table th.sortable {\r\n  position: relative;\r\n}\r\n\r\n.react-bootstrap-table .order-4:after,\r\n.react-bootstrap-table .caret-4-asc:after,\r\n.react-bootstrap-table .caret-4-desc:after {\r\n  right: 0.5em;\r\n  content: \"\\2193\";\r\n}\r\n\r\n.react-bootstrap-table .order-4:before,\r\n.react-bootstrap-table .caret-4-asc:before,\r\n.react-bootstrap-table .caret-4-desc:before {\r\n  right: 1em;\r\n  content: \"\\2191\";\r\n}\r\n\r\n.react-bootstrap-table .order-4:after,\r\n.react-bootstrap-table .order-4:before,\r\n.react-bootstrap-table .caret-4-asc:after,\r\n.react-bootstrap-table .caret-4-asc:before,\r\n.react-bootstrap-table .caret-4-desc:after,\r\n.react-bootstrap-table .caret-4-desc:before {\r\n  position: absolute;\r\n  bottom: 1.1em;\r\n  display: block;\r\n  opacity: 0.3;\r\n}\r\n\r\n.react-bootstrap-table .caret-4-asc:before {\r\n  opacity: 1;\r\n}\r\n\r\n.react-bootstrap-table .caret-4-desc:after {\r\n  opacity: 1;\r\n}\r\n\r\n.react-bootstrap-table-pagination .dataTables_length {\r\n  display: inline-block;\r\n}\r\n\r\n.react-bootstrap-table-pagination .dataTables_length label {\r\n  font-weight: normal;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.react-bootstrap-table-pagination .dataTables_length select {\r\n  width: auto;\r\n  display: inline-block;\r\n}\r\n\r\n.react-bootstrap-table-pagination .dataTables_length select.form-control-sm {\r\n  height: calc(1.8125rem + 6px);\r\n}\r\n\r\n.react-bootstrap-table-pagination .dataTables_length,\r\n.react-bootstrap-table-pagination .react-bootstrap-table-pagination-total {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.react-bootstrap-table-pagination .react-bootstrap-table-pagination-list .pagination {\r\n  justify-content: flex-end;\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.dataTables_filter {\r\n  font-weight: normal;\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  float: left;\r\n}\r\n\r\n.dataTables_filter input {\r\n  margin-left: 0.5em;\r\n  display: inline-block;\r\n  width: auto;\r\n}\r\n\r\n/*!\r\n* https://github.com/YouCanBookMe/react-datetime\r\n*/\r\n.rdt {\r\n  position: relative;\r\n}\r\n\r\n.rdt .rdtPicker {\r\n  -webkit-transition: all 150ms linear;\r\n  -moz-transition: all 150ms linear;\r\n  -o-transition: all 150ms linear;\r\n  -ms-transition: all 150ms linear;\r\n  transition: all 150ms linear;\r\n  margin-top: -20px;\r\n  visibility: hidden;\r\n  display: block;\r\n  opacity: 0;\r\n}\r\n\r\n.rdt.rdtOpen .rdtPicker {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  margin-top: 0;\r\n}\r\n\r\n.rdtPicker {\r\n  display: none;\r\n  position: absolute;\r\n  padding: 20px;\r\n  margin-top: 1px;\r\n  z-index: 99999 !important;\r\n  background: #fff;\r\n  border-radius: 0.375rem;\r\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n  -webkit-background-clip: padding-box;\r\n  background-clip: padding-box;\r\n  min-width: 292px;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .rdtPicker {\r\n    padding: 5px;\r\n    min-width: 262px;\r\n  }\r\n}\r\n\r\n.rdtPicker {\r\n  display: block;\r\n  top: 50px;\r\n}\r\n\r\n.rdtStatic .rdtPicker {\r\n  box-shadow: none;\r\n  position: static;\r\n}\r\n\r\n.rdtPicker .rdtTimeToggle {\r\n  text-align: center;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  visibility: hidden;\r\n  position: relative;\r\n}\r\n\r\n.rdtPicker .rdtTimeToggle:before {\r\n  visibility: visible;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font: normal normal normal 1em/1 \"Nucleo\";\r\n  font-size: 18px;\r\n  content: \"\\EA5E\";\r\n}\r\n\r\n.rdtPicker table {\r\n  width: 100%;\r\n  margin: 0;\r\n  border-color: #fff !important;\r\n}\r\n\r\n.rdtPicker td,\r\n.rdtPicker th {\r\n  text-align: center;\r\n  padding: 1px;\r\n}\r\n\r\n.rdtPicker td {\r\n  cursor: pointer;\r\n}\r\n\r\n.rdtDay {\r\n  font-size: 0.875rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  transition: all 0.15s ease;\r\n  text-align: center;\r\n  border: none;\r\n  border-radius: 50%;\r\n}\r\n\r\n.rdtDay.rdtToday.rdtActive,\r\n.rdtDay.rdtActive,\r\n.rdtDay.rdtActive:hover,\r\n.rdtDay.start-date,\r\n.rdtDay.end-date,\r\n.rdtDay.middle-date,\r\n.rdtDay.start-date:hover,\r\n.rdtDay.end-date:hover,\r\n.rdtDay.middle-date:hover {\r\n  background-color: #11cdef !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.rdtDay.start-date {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.rdtDay.middle-date {\r\n  border-radius: 0;\r\n}\r\n\r\n.rdtDay.end-date {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.rdtDays tr .dow {\r\n  text-align: center;\r\n  font-size: 12px;\r\n  font-weight: inherit;\r\n  padding-bottom: 5px;\r\n  padding-top: 10px;\r\n  font-weight: 300;\r\n  font-size: 0.875rem;\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.rdtDays tr .rdtDay {\r\n  color: #525f7f;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.rdtDays tr .rdtDay.rdtOld,\r\n.rdtDays tr .rdtDay.rdtNew {\r\n  color: #adb5bd;\r\n  font-weight: 300;\r\n}\r\n\r\n.rdtPicker td.rdtDay:hover,\r\n.rdtPicker td.rdtHour:hover,\r\n.rdtPicker td.rdtMinute:hover,\r\n.rdtPicker td.rdtSecond:hover,\r\n.rdtPicker .rdtTimeToggle:hover,\r\n.rdtPicker .rdtTimeToggle:hover:before {\r\n  background: #eeeeee;\r\n  cursor: pointer;\r\n}\r\n\r\n.rdtPicker td.rdtToday {\r\n  position: relative;\r\n}\r\n\r\n.rdtPicker td.rdtActive.rdtToday:before {\r\n  border-bottom-color: #fff;\r\n}\r\n\r\n.rdtPicker td.rdtDisabled,\r\n.rdtPicker td.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rdtPicker td span.rdtOld {\r\n  color: #999999;\r\n}\r\n\r\n.rdtPicker td span.rdtDisabled,\r\n.rdtPicker td span.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rdtPicker tr .dow {\r\n  width: 14.2857%;\r\n  border-bottom: none;\r\n  font-size: 0.875rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  transition: all 0.15s ease;\r\n  text-align: center;\r\n  border: none;\r\n  font-weight: 500;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.rdtPicker th.rdtSwitch {\r\n  font-weight: 500;\r\n  border-radius: 0.375rem;\r\n  font-size: 0.875rem;\r\n  width: 145px;\r\n  height: 36px;\r\n  transition: all 0.15s ease;\r\n  text-align: center;\r\n  border: none;\r\n}\r\n\r\n.rdtPicker th.rdtNext,\r\n.rdtPicker th.rdtPrev {\r\n  font-size: 0.875rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  transition: all 0.15s ease;\r\n  text-align: center;\r\n  border: none;\r\n  border-radius: 0.375rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.rdtPicker .dow,\r\n.rdtPicker th.rdtSwitch,\r\n.rdtPicker th.rdtNext,\r\n.rdtPicker th.rdtPrev,\r\n.rdtPicker .rdtTimeToggle {\r\n  color: #525f7f;\r\n}\r\n\r\n.rdtPrev span,\r\n.rdtNext span {\r\n  display: block;\r\n  -webkit-touch-callout: none;\r\n  /* iOS Safari */\r\n  -webkit-user-select: none;\r\n  /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none;\r\n  /* Konqueror */\r\n  -moz-user-select: none;\r\n  /* Firefox */\r\n  -ms-user-select: none;\r\n  /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n\r\n.rdtPicker th.rdtDisabled,\r\n.rdtPicker th.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rdtPicker thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n\r\n.rdtPicker thead tr:first-child th:hover {\r\n  background: #eeeeee;\r\n}\r\n\r\n.rdtPicker button {\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.rdtPicker button:hover {\r\n  background-color: #eee;\r\n}\r\n\r\n.rdtPicker thead button {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\ntd.rdtMonth,\r\ntd.rdtYear {\r\n  height: 50px;\r\n  width: 25%;\r\n  cursor: pointer;\r\n}\r\n\r\ntd.rdtMonth:hover,\r\ntd.rdtYear:hover {\r\n  background: #eee;\r\n}\r\n\r\n.rdtCounters {\r\n  display: inline-block;\r\n}\r\n\r\n.rdtCounters>div {\r\n  float: left;\r\n  width: 40px;\r\n  font-weight: inherit;\r\n  margin: 3px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.rdtCounters .rdtCounterSeparator {\r\n  width: 0;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.rdtCounter {\r\n  height: 100px;\r\n}\r\n\r\n.rdtCounter {\r\n  width: 40px;\r\n}\r\n\r\n.rdtCounter .rdtCount {\r\n  padding: 7px;\r\n  height: 40px;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.rdtCounters .rdtCounter:last-child .rdtCount {\r\n  color: #11cdef;\r\n  border-radius: 50%;\r\n  border: 1px solid #11cdef;\r\n}\r\n\r\n.rdtCounterSeparator {\r\n  padding: 7px;\r\n  line-height: 100px;\r\n}\r\n\r\n.rdtCounter .rdtBtn {\r\n  line-height: 40px;\r\n  cursor: pointer;\r\n  display: block;\r\n  border-radius: 50%;\r\n  color: #adb5bd;\r\n  -webkit-transition: all 60ms ease-in;\r\n  -moz-transition: all 60ms ease-in;\r\n  -o-transition: all 60ms ease-in;\r\n  -ms-transition: all 60ms ease-in;\r\n  transition: all 60ms ease-in;\r\n  -webkit-touch-callout: none;\r\n  /* iOS Safari */\r\n  -webkit-user-select: none;\r\n  /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none;\r\n  /* Konqueror */\r\n  -moz-user-select: none;\r\n  /* Firefox */\r\n  -ms-user-select: none;\r\n  /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n\r\n.rdtCounter .rdtBtn:hover {\r\n  background: #eee;\r\n  color: #797979;\r\n}\r\n\r\n.rdtCounter .rdtCount {\r\n  font-size: inherit;\r\n  line-height: 25px;\r\n}\r\n\r\n.rdtMilli {\r\n  vertical-align: middle;\r\n  padding-left: 8px;\r\n  width: 48px;\r\n}\r\n\r\n.rdtMilli input {\r\n  width: 100%;\r\n  font-size: inherit;\r\n  margin-top: 37px;\r\n}\r\n\r\n.rdtMonths,\r\n.rdtYears {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.rdtMonths .rdtMonth,\r\n.rdtMonths .rdtYear,\r\n.rdtYears .rdtMonth,\r\n.rdtYears .rdtYear {\r\n  display: inline-block;\r\n  width: 56px;\r\n  height: 56px;\r\n  line-height: 56px;\r\n  margin: 3px 3px;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n\r\n.rdtMonths .rdtMonth.rdtActive,\r\n.rdtMonths .rdtMonth.start-date,\r\n.rdtMonths .rdtMonth.end-date,\r\n.rdtMonths .rdtMonth.middle-date,\r\n.rdtMonths .rdtYear.rdtActive,\r\n.rdtMonths .rdtYear.start-date,\r\n.rdtMonths .rdtYear.end-date,\r\n.rdtMonths .rdtYear.middle-date,\r\n.rdtYears .rdtMonth.rdtActive,\r\n.rdtYears .rdtMonth.start-date,\r\n.rdtYears .rdtMonth.end-date,\r\n.rdtYears .rdtMonth.middle-date,\r\n.rdtYears .rdtYear.rdtActive,\r\n.rdtYears .rdtYear.start-date,\r\n.rdtYears .rdtYear.end-date,\r\n.rdtYears .rdtYear.middle-date {\r\n  background-color: #11cdef !important;\r\n  color: #fff;\r\n}\r\n\r\n.input-group .input-group-prepend+.rdt .form-control {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.input-group .input-group-prepend+.rdt .form-control {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.input-group>.rdt:not(:last-child) .form-control {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.form-group .rdt {\r\n  margin-bottom: 0;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.vector-map .jvectormap-zoomin,\r\n.vector-map .jvectormap-zoomout {\r\n  cursor: pointer;\r\n  margin-right: 0.5rem;\r\n  font-size: 0.75rem;\r\n  transition: all 0.15s ease;\r\n  letter-spacing: 0.025em;\r\n  text-transform: none;\r\n  will-change: transform;\r\n  line-height: 1.5;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  color: #fff;\r\n  border-color: #5e72e4;\r\n  background-color: #5e72e4;\r\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n  font-weight: 600;\r\n  display: inline-block;\r\n  user-select: none;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.rna-wrapper .alert {\r\n  display: flex !important;\r\n  max-width: 600px;\r\n  width: calc(100% - 30px);\r\n  padding-right: 80px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);\r\n  color: rgba(255, 255, 255, 0.85);\r\n}\r\n\r\n.rna-wrapper .alert:hover {\r\n  z-index: 1081 !important;\r\n}\r\n\r\n.rna-wrapper .alert:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) {\r\n  background-color: rgba(0, 0, 0, 0.95);\r\n}\r\n\r\n.rna-wrapper .alert:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close {\r\n  color: #ffd600;\r\n}\r\n\r\n.rna-wrapper .alert:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) .alert-notify-close:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.rna-wrapper .alert .ni[data-notify=\"icon\"] {\r\n  position: relative;\r\n  top: 4px;\r\n}\r\n\r\n.rna-wrapper .alert .alert-title {\r\n  display: block;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.rna-wrapper .alert .close {\r\n  top: 1rem !important;\r\n  right: 1.5rem !important;\r\n  transform: translateY(0);\r\n}\r\n\r\n.rna-wrapper .alert [data-notify=\"icon\"] {\r\n  font-size: 1.25rem;\r\n  margin-right: 1.25rem;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.ql-container {\r\n  position: relative;\r\n}\r\n\r\n.ql-tooltip {\r\n  z-index: 1050;\r\n}\r\n\r\n.ReactTable {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.ReactTable * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.ReactTable .rt-table {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: auto 1;\r\n  flex: auto 1;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-align: stretch;\r\n  -ms-flex-align: stretch;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  overflow: auto;\r\n}\r\n\r\n.ReactTable .rt-thead {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1 0 auto;\r\n  flex: 1 0 auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.ReactTable .rt-thead.-headerGroups {\r\n  background: rgba(0, 0, 0, 0.03);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-thead.-filters {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-thead.-filters input,\r\n.ReactTable .rt-thead.-filters select {\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  background: #fff;\r\n  padding: 5px 7px;\r\n  font-size: inherit;\r\n  border-radius: 3px;\r\n  font-weight: normal;\r\n  outline: none;\r\n}\r\n\r\n.ReactTable .rt-thead.-filters .rt-th {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.ReactTable .rt-thead.-header {\r\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.ReactTable .rt-thead .rt-tr {\r\n  text-align: center;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th,\r\n.ReactTable .rt-thead .rt-td {\r\n  padding: 5px 5px;\r\n  line-height: normal;\r\n  position: relative;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\r\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  box-shadow: inset 0 0 0 0 transparent;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th.-sort-asc,\r\n.ReactTable .rt-thead .rt-td.-sort-asc {\r\n  box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th.-sort-desc,\r\n.ReactTable .rt-thead .rt-td.-sort-desc {\r\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\r\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th:last-child,\r\n.ReactTable .rt-thead .rt-td:last-child {\r\n  border-right: 0;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th:focus {\r\n  outline: none;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-resizable-header {\r\n  overflow: visible;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-resizable-header:last-child {\r\n  overflow: hidden;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-resizable-header-content {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot {\r\n  border-right-color: #f7f7f7;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot:after,\r\n.ReactTable .rt-thead .rt-header-pivot:before {\r\n  left: 100%;\r\n  top: 50%;\r\n  border: solid transparent;\r\n  content: \" \";\r\n  height: 0;\r\n  width: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot:after {\r\n  border-color: rgba(255, 255, 255, 0);\r\n  border-left-color: #fff;\r\n  border-width: 8px;\r\n  margin-top: -8px;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot:before {\r\n  border-color: rgba(102, 102, 102, 0);\r\n  border-left-color: #f7f7f7;\r\n  border-width: 10px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.ReactTable .rt-tbody {\r\n  -webkit-box-flex: 99999;\r\n  -ms-flex: 99999 1 auto;\r\n  flex: 99999 1 auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-tr-group {\r\n  border-bottom: solid 1px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-tr-group:last-child {\r\n  border-bottom: 0;\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-td {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-td:last-child {\r\n  border-right: 0;\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-expandable {\r\n  cursor: pointer;\r\n  text-overflow: clip;\r\n}\r\n\r\n.ReactTable .rt-tr-group {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1 0 auto;\r\n  flex: 1 0 auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-align: stretch;\r\n  -ms-flex-align: stretch;\r\n  align-items: stretch;\r\n}\r\n\r\n.ReactTable .rt-tr {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1 0 auto;\r\n  flex: 1 0 auto;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n}\r\n\r\n.ReactTable .rt-th,\r\n.ReactTable .rt-td {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1 0 0px;\r\n  flex: 1 0 0;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  padding: 7px 5px;\r\n  overflow: hidden;\r\n  transition: 0.3s ease;\r\n  transition-property: width, min-width, padding, opacity;\r\n}\r\n\r\n.ReactTable .rt-th.-hidden,\r\n.ReactTable .rt-td.-hidden {\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  padding: 0 !important;\r\n  border: 0 !important;\r\n  opacity: 0 !important;\r\n}\r\n\r\n.ReactTable .rt-expander {\r\n  display: inline-block;\r\n  position: relative;\r\n  margin: 0;\r\n  color: transparent;\r\n  margin: 0 10px;\r\n}\r\n\r\n.ReactTable .rt-expander:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  top: 50%;\r\n  left: 50%;\r\n  -webkit-transform: translate(-50%, -50%) rotate(-90deg);\r\n  transform: translate(-50%, -50%) rotate(-90deg);\r\n  border-left: 5.04px solid transparent;\r\n  border-right: 5.04px solid transparent;\r\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\r\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  cursor: pointer;\r\n}\r\n\r\n.ReactTable .rt-expander.-open:after {\r\n  -webkit-transform: translate(-50%, -50%) rotate(0);\r\n  transform: translate(-50%, -50%) rotate(0);\r\n}\r\n\r\n.ReactTable .rt-resizer {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 36px;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: -18px;\r\n  cursor: col-resize;\r\n  z-index: 10;\r\n}\r\n\r\n.ReactTable .rt-tfoot {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1 0 auto;\r\n  flex: 1 0 auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.ReactTable .rt-tfoot .rt-td {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-tfoot .rt-td:last-child {\r\n  border-right: 0;\r\n}\r\n\r\n.ReactTable.-striped .rt-tr.-odd {\r\n  background: rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\r\n  background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .-pagination {\r\n  z-index: 1;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: stretch;\r\n  -ms-flex-align: stretch;\r\n  align-items: stretch;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  padding: 3px;\r\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);\r\n  border-top: 2px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.ReactTable .-pagination input,\r\n.ReactTable .-pagination select {\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  background: #fff;\r\n  padding: 5px 7px;\r\n  font-size: inherit;\r\n  border-radius: 3px;\r\n  font-weight: normal;\r\n  outline: none;\r\n}\r\n\r\n.ReactTable .-pagination .-btn {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n  border-radius: 3px;\r\n  padding: 6px;\r\n  font-size: 1em;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  background: rgba(0, 0, 0, 0.1);\r\n  transition: all 0.1s ease;\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n\r\n.ReactTable .-pagination .-btn[disabled] {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.ReactTable .-pagination .-btn:not([disabled]):hover {\r\n  background: rgba(0, 0, 0, 0.3);\r\n  color: #fff;\r\n}\r\n\r\n.ReactTable .-pagination .-previous,\r\n.ReactTable .-pagination .-next {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.ReactTable .-pagination .-center {\r\n  -webkit-box-flex: 1.5;\r\n  -ms-flex: 1.5;\r\n  flex: 1.5;\r\n  text-align: center;\r\n  margin-bottom: 0;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -ms-flex-pack: distribute;\r\n  justify-content: space-around;\r\n}\r\n\r\n.ReactTable .-pagination .-pageInfo {\r\n  display: inline-block;\r\n  margin: 3px 10px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ReactTable .-pagination .-pageJump {\r\n  display: inline-block;\r\n}\r\n\r\n.ReactTable .-pagination .-pageJump input {\r\n  width: 70px;\r\n  text-align: center;\r\n}\r\n\r\n.ReactTable .-pagination .-pageSizeOptions {\r\n  margin: 3px 10px;\r\n}\r\n\r\n.ReactTable .rt-noData {\r\n  display: block;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n  background: rgba(255, 255, 255, 0.8);\r\n  transition: all 0.3s ease;\r\n  z-index: 1;\r\n  pointer-events: none;\r\n  padding: 20px;\r\n  color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.ReactTable .-loading {\r\n  display: block;\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  transition: all 0.3s ease;\r\n  z-index: -1;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.ReactTable .-loading>div {\r\n  position: absolute;\r\n  display: block;\r\n  text-align: center;\r\n  width: 100%;\r\n  top: 50%;\r\n  left: 0;\r\n  font-size: 15px;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  -webkit-transform: translateY(-52%);\r\n  transform: translateY(-52%);\r\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.ReactTable .-loading.-active {\r\n  opacity: 1;\r\n  z-index: 2;\r\n  pointer-events: all;\r\n}\r\n\r\n.ReactTable .-loading.-active>div {\r\n  -webkit-transform: translateY(50%);\r\n  transform: translateY(50%);\r\n}\r\n\r\n.ReactTable .rt-resizing .rt-th,\r\n.ReactTable .rt-resizing .rt-td {\r\n  transition: none !important;\r\n  cursor: col-resize;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.bootstrap-tagsinput .tag a {\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-left: 10px;\r\n  cursor: pointer;\r\n  transform: translate(0, -50%);\r\n  color: #fff;\r\n}\r\n\r\n.bootstrap-tagsinput .tag a::after {\r\n  font-size: 16px;\r\n  content: \"×\";\r\n}\r\n\r\n.avatar-group .avatar {\r\n  margin-right: 0.2rem;\r\n}\r\n\r\n.badge+.badge {\r\n  margin-left: 4px;\r\n}\r\n\r\n.badge.badge-dot i {\r\n  margin-right: 0.6rem;\r\n}\r\n\r\n.btn+.btn {\r\n  margin-left: 4px;\r\n}\r\n\r\n.btn-group+.btn-group {\r\n  margin-left: 4px;\r\n}\r\n\r\n.btn.btn-sm.btn-.btn-icon-only.text-light,\r\n.btn-group-sm>.btn.btn-.btn-icon-only.text-light {\r\n  background-color: transparent;\r\n}\r\n\r\n.input-group .btn+.btn {\r\n  margin-left: -1px;\r\n}\r\n\r\n.custom-checkbox-primary .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-secondary .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-success .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-info .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-warning .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-danger .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-light .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-dark .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-default .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-white .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-neutral .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox-darker .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.icon-actions a i+span {\r\n  margin-left: 7px;\r\n}\r\n\r\n.icon-actions a+a {\r\n  margin-left: 4px;\r\n}\r\n\r\n.input-group.is-invalid~.invalid-feedback {\r\n  display: block;\r\n}\r\n\r\nbutton:focus,\r\n:focus {\r\n  outline: none;\r\n}\r\n\r\n@keyframes show-navbar-dropdown {\r\n  0% {\r\n    opacity: 0;\r\n    transition: visibility 0.25s, opacity 0.25s;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n","/*******************************************************************************\r\n *              bootstrap-rtl (version 3.3.4)\r\n *      Author: Morteza Ansarinia (http://github.com/morteza)\r\n *  Created on: August 13,2015\r\n *     Project: bootstrap-rtl\r\n *   Copyright: Unlicensed Public Domain\r\n *******************************************************************************/\r\n\r\nhtml.rtl {\r\n  direction: rtl;\r\n}\r\n.rtl {\r\n  body {\r\n    direction: rtl;\r\n  }\r\n  .flip.text-left {\r\n    text-align: right;\r\n  }\r\n  .flip.text-right {\r\n    text-align: left;\r\n  }\r\n  .list-unstyled {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n  }\r\n  .list-inline {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n    margin-right: -5px;\r\n    margin-left: 0;\r\n  }\r\n  dd {\r\n    margin-right: 0;\r\n    margin-left: initial;\r\n  }\r\n  @media (min-width: 768px) {\r\n    .dl-horizontal dt {\r\n      float: right;\r\n      clear: right;\r\n      text-align: left;\r\n    }\r\n    .dl-horizontal dd {\r\n      margin-right: 180px;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  blockquote {\r\n    border-right: 5px solid #eeeeee;\r\n    border-left: 0;\r\n  }\r\n  .blockquote-reverse,\r\n  blockquote.pull-left {\r\n    padding-left: 15px;\r\n    padding-right: 0;\r\n    border-left: 5px solid #eeeeee;\r\n    border-right: 0;\r\n    text-align: left;\r\n  }\r\n  .col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\r\n    position: relative;\r\n    min-height: 1px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n  .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {\r\n    float: right;\r\n  }\r\n  .col-xs-12 {\r\n    width: 100%;\r\n  }\r\n  .col-xs-11 {\r\n    width: 91.66666667%;\r\n  }\r\n  .col-xs-10 {\r\n    width: 83.33333333%;\r\n  }\r\n  .col-xs-9 {\r\n    width: 75%;\r\n  }\r\n  .col-xs-8 {\r\n    width: 66.66666667%;\r\n  }\r\n  .col-xs-7 {\r\n    width: 58.33333333%;\r\n  }\r\n  .col-xs-6 {\r\n    width: 50%;\r\n  }\r\n  .col-xs-5 {\r\n    width: 41.66666667%;\r\n  }\r\n  .col-xs-4 {\r\n    width: 33.33333333%;\r\n  }\r\n  .col-xs-3 {\r\n    width: 25%;\r\n  }\r\n  .col-xs-2 {\r\n    width: 16.66666667%;\r\n  }\r\n  .col-xs-1 {\r\n    width: 8.33333333%;\r\n  }\r\n  .col-xs-pull-12 {\r\n    left: 100%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-11 {\r\n    left: 91.66666667%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-10 {\r\n    left: 83.33333333%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-9 {\r\n    left: 75%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-8 {\r\n    left: 66.66666667%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-7 {\r\n    left: 58.33333333%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-6 {\r\n    left: 50%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-5 {\r\n    left: 41.66666667%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-4 {\r\n    left: 33.33333333%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-3 {\r\n    left: 25%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-2 {\r\n    left: 16.66666667%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-1 {\r\n    left: 8.33333333%;\r\n    right: auto;\r\n  }\r\n  .col-xs-pull-0 {\r\n    left: auto;\r\n    right: auto;\r\n  }\r\n  .col-xs-push-12 {\r\n    right: 100%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-11 {\r\n    right: 91.66666667%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-10 {\r\n    right: 83.33333333%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-9 {\r\n    right: 75%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-8 {\r\n    right: 66.66666667%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-7 {\r\n    right: 58.33333333%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-6 {\r\n    right: 50%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-5 {\r\n    right: 41.66666667%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-4 {\r\n    right: 33.33333333%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-3 {\r\n    right: 25%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-2 {\r\n    right: 16.66666667%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-1 {\r\n    right: 8.33333333%;\r\n    left: 0;\r\n  }\r\n  .col-xs-push-0 {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n  .col-xs-offset-12 {\r\n    margin-right: 100%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-11 {\r\n    margin-right: 91.66666667%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-10 {\r\n    margin-right: 83.33333333%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-9 {\r\n    margin-right: 75%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-8 {\r\n    margin-right: 66.66666667%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-7 {\r\n    margin-right: 58.33333333%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-6 {\r\n    margin-right: 50%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-5 {\r\n    margin-right: 41.66666667%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-4 {\r\n    margin-right: 33.33333333%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-3 {\r\n    margin-right: 25%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-2 {\r\n    margin-right: 16.66666667%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-1 {\r\n    margin-right: 8.33333333%;\r\n    margin-left: 0;\r\n  }\r\n  .col-xs-offset-0 {\r\n    margin-right: 0%;\r\n    margin-left: 0;\r\n  }\r\n  @media (min-width: 768px) {\r\n    .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {\r\n      float: right;\r\n    }\r\n    .col-sm-12 {\r\n      width: 100%;\r\n    }\r\n    .col-sm-11 {\r\n      width: 91.66666667%;\r\n    }\r\n    .col-sm-10 {\r\n      width: 83.33333333%;\r\n    }\r\n    .col-sm-9 {\r\n      width: 75%;\r\n    }\r\n    .col-sm-8 {\r\n      width: 66.66666667%;\r\n    }\r\n    .col-sm-7 {\r\n      width: 58.33333333%;\r\n    }\r\n    .col-sm-6 {\r\n      width: 50%;\r\n    }\r\n    .col-sm-5 {\r\n      width: 41.66666667%;\r\n    }\r\n    .col-sm-4 {\r\n      width: 33.33333333%;\r\n    }\r\n    .col-sm-3 {\r\n      width: 25%;\r\n    }\r\n    .col-sm-2 {\r\n      width: 16.66666667%;\r\n    }\r\n    .col-sm-1 {\r\n      width: 8.33333333%;\r\n    }\r\n    .col-sm-pull-12 {\r\n      left: 100%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-11 {\r\n      left: 91.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-10 {\r\n      left: 83.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-9 {\r\n      left: 75%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-8 {\r\n      left: 66.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-7 {\r\n      left: 58.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-6 {\r\n      left: 50%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-5 {\r\n      left: 41.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-4 {\r\n      left: 33.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-3 {\r\n      left: 25%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-2 {\r\n      left: 16.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-1 {\r\n      left: 8.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-sm-pull-0 {\r\n      left: auto;\r\n      right: auto;\r\n    }\r\n    .col-sm-push-12 {\r\n      right: 100%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-11 {\r\n      right: 91.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-10 {\r\n      right: 83.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-9 {\r\n      right: 75%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-8 {\r\n      right: 66.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-7 {\r\n      right: 58.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-6 {\r\n      right: 50%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-5 {\r\n      right: 41.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-4 {\r\n      right: 33.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-3 {\r\n      right: 25%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-2 {\r\n      right: 16.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-1 {\r\n      right: 8.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-sm-push-0 {\r\n      right: auto;\r\n      left: 0;\r\n    }\r\n    .col-sm-offset-12 {\r\n      margin-right: 100%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-11 {\r\n      margin-right: 91.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-10 {\r\n      margin-right: 83.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-9 {\r\n      margin-right: 75%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-8 {\r\n      margin-right: 66.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-7 {\r\n      margin-right: 58.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-6 {\r\n      margin-right: 50%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-5 {\r\n      margin-right: 41.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-4 {\r\n      margin-right: 33.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-3 {\r\n      margin-right: 25%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-2 {\r\n      margin-right: 16.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-1 {\r\n      margin-right: 8.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-sm-offset-0 {\r\n      margin-right: 0%;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  @media (min-width: 992px) {\r\n    .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {\r\n      float: right;\r\n    }\r\n    .col-md-12 {\r\n      width: 100%;\r\n    }\r\n    .col-md-11 {\r\n      width: 91.66666667%;\r\n    }\r\n    .col-md-10 {\r\n      width: 83.33333333%;\r\n    }\r\n    .col-md-9 {\r\n      width: 75%;\r\n    }\r\n    .col-md-8 {\r\n      width: 66.66666667%;\r\n    }\r\n    .col-md-7 {\r\n      width: 58.33333333%;\r\n    }\r\n    .col-md-6 {\r\n      width: 50%;\r\n    }\r\n    .col-md-5 {\r\n      width: 41.66666667%;\r\n    }\r\n    .col-md-4 {\r\n      width: 33.33333333%;\r\n    }\r\n    .col-md-3 {\r\n      width: 25%;\r\n    }\r\n    .col-md-2 {\r\n      width: 16.66666667%;\r\n    }\r\n    .col-md-1 {\r\n      width: 8.33333333%;\r\n    }\r\n    .col-md-pull-12 {\r\n      left: 100%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-11 {\r\n      left: 91.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-10 {\r\n      left: 83.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-9 {\r\n      left: 75%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-8 {\r\n      left: 66.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-7 {\r\n      left: 58.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-6 {\r\n      left: 50%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-5 {\r\n      left: 41.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-4 {\r\n      left: 33.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-3 {\r\n      left: 25%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-2 {\r\n      left: 16.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-1 {\r\n      left: 8.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-md-pull-0 {\r\n      left: auto;\r\n      right: auto;\r\n    }\r\n    .col-md-push-12 {\r\n      right: 100%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-11 {\r\n      right: 91.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-10 {\r\n      right: 83.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-9 {\r\n      right: 75%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-8 {\r\n      right: 66.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-7 {\r\n      right: 58.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-6 {\r\n      right: 50%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-5 {\r\n      right: 41.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-4 {\r\n      right: 33.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-3 {\r\n      right: 25%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-2 {\r\n      right: 16.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-1 {\r\n      right: 8.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-md-push-0 {\r\n      right: auto;\r\n      left: 0;\r\n    }\r\n    .col-md-offset-12 {\r\n      margin-right: 100%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-11 {\r\n      margin-right: 91.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-10 {\r\n      margin-right: 83.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-9 {\r\n      margin-right: 75%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-8 {\r\n      margin-right: 66.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-7 {\r\n      margin-right: 58.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-6 {\r\n      margin-right: 50%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-5 {\r\n      margin-right: 41.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-4 {\r\n      margin-right: 33.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-3 {\r\n      margin-right: 25%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-2 {\r\n      margin-right: 16.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-1 {\r\n      margin-right: 8.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-md-offset-0 {\r\n      margin-right: 0%;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  @media (min-width: 1200px) {\r\n    .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {\r\n      float: right;\r\n    }\r\n    .col-lg-12 {\r\n      width: 100%;\r\n    }\r\n    .col-lg-11 {\r\n      width: 91.66666667%;\r\n    }\r\n    .col-lg-10 {\r\n      width: 83.33333333%;\r\n    }\r\n    .col-lg-9 {\r\n      width: 75%;\r\n    }\r\n    .col-lg-8 {\r\n      width: 66.66666667%;\r\n    }\r\n    .col-lg-7 {\r\n      width: 58.33333333%;\r\n    }\r\n    .col-lg-6 {\r\n      width: 50%;\r\n    }\r\n    .col-lg-5 {\r\n      width: 41.66666667%;\r\n    }\r\n    .col-lg-4 {\r\n      width: 33.33333333%;\r\n    }\r\n    .col-lg-3 {\r\n      width: 25%;\r\n    }\r\n    .col-lg-2 {\r\n      width: 16.66666667%;\r\n    }\r\n    .col-lg-1 {\r\n      width: 8.33333333%;\r\n    }\r\n    .col-lg-pull-12 {\r\n      left: 100%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-11 {\r\n      left: 91.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-10 {\r\n      left: 83.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-9 {\r\n      left: 75%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-8 {\r\n      left: 66.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-7 {\r\n      left: 58.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-6 {\r\n      left: 50%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-5 {\r\n      left: 41.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-4 {\r\n      left: 33.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-3 {\r\n      left: 25%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-2 {\r\n      left: 16.66666667%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-1 {\r\n      left: 8.33333333%;\r\n      right: auto;\r\n    }\r\n    .col-lg-pull-0 {\r\n      left: auto;\r\n      right: auto;\r\n    }\r\n    .col-lg-push-12 {\r\n      right: 100%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-11 {\r\n      right: 91.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-10 {\r\n      right: 83.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-9 {\r\n      right: 75%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-8 {\r\n      right: 66.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-7 {\r\n      right: 58.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-6 {\r\n      right: 50%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-5 {\r\n      right: 41.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-4 {\r\n      right: 33.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-3 {\r\n      right: 25%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-2 {\r\n      right: 16.66666667%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-1 {\r\n      right: 8.33333333%;\r\n      left: 0;\r\n    }\r\n    .col-lg-push-0 {\r\n      right: auto;\r\n      left: 0;\r\n    }\r\n    .col-lg-offset-12 {\r\n      margin-right: 100%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-11 {\r\n      margin-right: 91.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-10 {\r\n      margin-right: 83.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-9 {\r\n      margin-right: 75%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-8 {\r\n      margin-right: 66.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-7 {\r\n      margin-right: 58.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-6 {\r\n      margin-right: 50%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-5 {\r\n      margin-right: 41.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-4 {\r\n      margin-right: 33.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-3 {\r\n      margin-right: 25%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-2 {\r\n      margin-right: 16.66666667%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-1 {\r\n      margin-right: 8.33333333%;\r\n      margin-left: 0;\r\n    }\r\n    .col-lg-offset-0 {\r\n      margin-right: 0%;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  caption {\r\n    text-align: right;\r\n  }\r\n  th {\r\n    text-align: right;\r\n  }\r\n  @media screen and (max-width: 767px) {\r\n    .table-responsive > .table-bordered {\r\n      border: 0;\r\n    }\r\n    .table-responsive > .table-bordered > thead > tr > th:first-child,\r\n    .table-responsive > .table-bordered > tbody > tr > th:first-child,\r\n    .table-responsive > .table-bordered > tfoot > tr > th:first-child,\r\n    .table-responsive > .table-bordered > thead > tr > td:first-child,\r\n    .table-responsive > .table-bordered > tbody > tr > td:first-child,\r\n    .table-responsive > .table-bordered > tfoot > tr > td:first-child {\r\n      border-right: 0;\r\n      border-left: initial;\r\n    }\r\n    .table-responsive > .table-bordered > thead > tr > th:last-child,\r\n    .table-responsive > .table-bordered > tbody > tr > th:last-child,\r\n    .table-responsive > .table-bordered > tfoot > tr > th:last-child,\r\n    .table-responsive > .table-bordered > thead > tr > td:last-child,\r\n    .table-responsive > .table-bordered > tbody > tr > td:last-child,\r\n    .table-responsive > .table-bordered > tfoot > tr > td:last-child {\r\n      border-left: 0;\r\n      border-right: initial;\r\n    }\r\n  }\r\n  .radio label,\r\n  .checkbox label {\r\n    padding-right: 20px;\r\n    padding-left: initial;\r\n  }\r\n  .radio input[type=\"radio\"],\r\n  .radio-inline input[type=\"radio\"],\r\n  .checkbox input[type=\"checkbox\"],\r\n  .checkbox-inline input[type=\"checkbox\"] {\r\n    margin-right: -20px;\r\n    margin-left: auto;\r\n  }\r\n  .radio-inline,\r\n  .checkbox-inline {\r\n    padding-right: 20px;\r\n    padding-left: 0;\r\n  }\r\n  .radio-inline + .radio-inline,\r\n  .checkbox-inline + .checkbox-inline {\r\n    margin-right: 10px;\r\n    margin-left: 0;\r\n  }\r\n  .has-feedback .form-control {\r\n    padding-left: 42.5px;\r\n    padding-right: 12px;\r\n  }\r\n  .form-control-feedback {\r\n    left: 0;\r\n    right: auto;\r\n  }\r\n  @media (min-width: 768px) {\r\n    .form-inline label {\r\n      padding-right: 0;\r\n      padding-left: initial;\r\n    }\r\n    .form-inline .radio input[type=\"radio\"],\r\n    .form-inline .checkbox input[type=\"checkbox\"] {\r\n      margin-right: 0;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n  @media (min-width: 768px) {\r\n    .form-horizontal .control-label {\r\n      text-align: left;\r\n    }\r\n  }\r\n  .form-horizontal .has-feedback .form-control-feedback {\r\n    left: 15px;\r\n    right: auto;\r\n  }\r\n  .caret {\r\n    margin-right: 2px;\r\n    margin-left: 0;\r\n  }\r\n  .dropdown-menu {\r\n    right: 0;\r\n    left: auto;\r\n    float: left;\r\n    text-align: right;\r\n  }\r\n  .dropdown-menu.pull-right {\r\n    left: 0;\r\n    right: auto;\r\n    float: right;\r\n  }\r\n  .dropdown-menu-right {\r\n    left: auto;\r\n    right: 0;\r\n  }\r\n  .dropdown-menu-left {\r\n    left: 0;\r\n    right: auto;\r\n  }\r\n  @media (min-width: 768px) {\r\n    .navbar-right .dropdown-menu {\r\n      left: auto;\r\n      right: 0;\r\n    }\r\n    .navbar-right .dropdown-menu-left {\r\n      left: 0;\r\n      right: auto;\r\n    }\r\n  }\r\n  .btn-group > .btn,\r\n  .btn-group-vertical > .btn {\r\n    float: right;\r\n  }\r\n  .btn-group .btn + .btn,\r\n  .btn-group .btn + .btn-group,\r\n  .btn-group .btn-group + .btn,\r\n  .btn-group .btn-group + .btn-group {\r\n    margin-right: -1px;\r\n    margin-left: 0px;\r\n  }\r\n  .btn-toolbar {\r\n    margin-right: -5px;\r\n    margin-left: 0px;\r\n  }\r\n  .btn-toolbar .btn-group,\r\n  .btn-toolbar .input-group {\r\n    float: right;\r\n  }\r\n  .btn-toolbar > .btn,\r\n  .btn-toolbar > .btn-group,\r\n  .btn-toolbar > .input-group {\r\n    margin-right: 5px;\r\n    margin-left: 0px;\r\n  }\r\n  .btn-group > .btn:first-child {\r\n    margin-right: 0;\r\n  }\r\n  .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\r\n    border-top-right-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n  }\r\n  .btn-group > .btn:last-child:not(:first-child),\r\n  .btn-group > .dropdown-toggle:not(:first-child) {\r\n    border-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n  }\r\n  .btn-group > .btn-group {\r\n    float: right;\r\n  }\r\n  .btn-group.btn-group-justified > .btn,\r\n  .btn-group.btn-group-justified > .btn-group {\r\n    float: none;\r\n  }\r\n  .btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\r\n    border-radius: 0;\r\n  }\r\n  .btn-group > .btn-group:first-child > .btn:last-child,\r\n  .btn-group > .btn-group:first-child > .dropdown-toggle {\r\n    border-top-right-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n  }\r\n  .btn-group > .btn-group:last-child > .btn:first-child {\r\n    border-top-left-radius: 4px;\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n  }\r\n  .btn .caret {\r\n    margin-right: 0;\r\n  }\r\n  .btn-group-vertical > .btn + .btn,\r\n  .btn-group-vertical > .btn + .btn-group,\r\n  .btn-group-vertical > .btn-group + .btn,\r\n  .btn-group-vertical > .btn-group + .btn-group {\r\n    margin-top: -1px;\r\n    margin-right: 0;\r\n  }\r\n  .input-group .form-control {\r\n    float: right;\r\n  }\r\n  .input-group .form-control:first-child,\r\n  .input-group-addon:first-child,\r\n  .input-group-btn:first-child > .btn,\r\n  .input-group-btn:first-child > .btn-group > .btn,\r\n  .input-group-btn:first-child > .dropdown-toggle,\r\n  .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\r\n  .input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\r\n    border-bottom-right-radius: 4px;\r\n    border-top-right-radius: 4px;\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n  }\r\n  .input-group-addon:first-child {\r\n    border-left: 0px;\r\n    border-right: 1px solid;\r\n  }\r\n  .input-group .form-control:last-child,\r\n  .input-group-addon:last-child,\r\n  .input-group-btn:last-child > .btn,\r\n  .input-group-btn:last-child > .btn-group > .btn,\r\n  .input-group-btn:last-child > .dropdown-toggle,\r\n  .input-group-btn:first-child > .btn:not(:first-child),\r\n  .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\r\n    border-bottom-left-radius: 4px;\r\n    border-top-left-radius: 4px;\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n  }\r\n  .input-group-addon:last-child {\r\n    border-left-width: 1px;\r\n    border-left-style: solid;\r\n    border-right: 0px;\r\n  }\r\n  .input-group-btn > .btn + .btn {\r\n    margin-right: -1px;\r\n    margin-left: auto;\r\n  }\r\n  .input-group-btn:first-child > .btn,\r\n  .input-group-btn:first-child > .btn-group {\r\n    margin-left: -1px;\r\n    margin-right: auto;\r\n  }\r\n  .input-group-btn:last-child > .btn,\r\n  .input-group-btn:last-child > .btn-group {\r\n    margin-right: -1px;\r\n    margin-left: auto;\r\n  }\r\n  .nav {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n  }\r\n  .nav-tabs > li {\r\n    float: right;\r\n  }\r\n  .nav-tabs > li > a {\r\n    margin-left: auto;\r\n    margin-right: -2px;\r\n    border-radius: 4px 4px 0 0;\r\n  }\r\n  .nav-pills > li {\r\n    float: right;\r\n  }\r\n  .nav-pills > li > a {\r\n    border-radius: 4px;\r\n  }\r\n  .nav-pills > li + li {\r\n    margin-right: 2px;\r\n    margin-left: auto;\r\n  }\r\n  .nav-stacked > li {\r\n    float: none;\r\n  }\r\n  .nav-stacked > li + li {\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n  }\r\n  .nav-justified > .dropdown .dropdown-menu {\r\n    right: auto;\r\n  }\r\n  .nav-tabs-justified > li > a {\r\n    margin-left: 0;\r\n    margin-right: auto;\r\n  }\r\n  @media (min-width: 768px) {\r\n    .nav-tabs-justified > li > a {\r\n      border-radius: 4px 4px 0 0;\r\n    }\r\n  }\r\n  @media (min-width: 768px) {\r\n    .navbar-header {\r\n      float: right;\r\n    }\r\n  }\r\n  .navbar-collapse {\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n  }\r\n  .navbar-brand {\r\n    float: right;\r\n  }\r\n  @media (min-width: 768px) {\r\n    .navbar > .container .navbar-brand,\r\n    .navbar > .container-fluid .navbar-brand {\r\n      margin-right: -15px;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n  .navbar-toggle {\r\n    float: left;\r\n    margin-left: 15px;\r\n    margin-right: auto;\r\n  }\r\n  @media (max-width: 767px) {\r\n    .navbar-nav .open .dropdown-menu > li > a,\r\n    .navbar-nav .open .dropdown-menu .dropdown-header {\r\n      padding: 5px 25px 5px 15px;\r\n    }\r\n  }\r\n  @media (min-width: 768px) {\r\n    .navbar-nav {\r\n      float: right;\r\n    }\r\n    .navbar-right {\r\n      float: left !important;\r\n    }\r\n    .navbar-left {\r\n      float: right !important;\r\n    }\r\n    .navbar-nav > li {\r\n      float: right !important;\r\n    }\r\n  }\r\n  @media (min-width: 768px) {\r\n    .navbar-left.flip {\r\n      float: right !important;\r\n    }\r\n    .navbar-right:last-child {\r\n      margin-left: -15px;\r\n      margin-right: auto;\r\n    }\r\n    .navbar-right.flip {\r\n      float: left !important;\r\n      margin-left: -15px;\r\n      margin-right: auto;\r\n    }\r\n    .navbar-right .dropdown-menu {\r\n      left: 0;\r\n      right: auto;\r\n    }\r\n  }\r\n  @media (min-width: 768px) {\r\n    .navbar-text {\r\n      float: right;\r\n    }\r\n    .navbar-text.navbar-right:last-child {\r\n      margin-left: 0;\r\n      margin-right: auto;\r\n    }\r\n  }\r\n  .pagination {\r\n    padding-right: 0;\r\n  }\r\n  .pagination > li > a,\r\n  .pagination > li > span {\r\n    float: right;\r\n    margin-right: -1px;\r\n    margin-left: 0px;\r\n  }\r\n  .pagination > li:first-child > a,\r\n  .pagination > li:first-child > span {\r\n    margin-left: 0;\r\n    border-bottom-right-radius: 4px;\r\n    border-top-right-radius: 4px;\r\n    border-bottom-left-radius: 0;\r\n    border-top-left-radius: 0;\r\n  }\r\n  .pagination > li:last-child > a,\r\n  .pagination > li:last-child > span {\r\n    margin-right: -1px;\r\n    border-bottom-left-radius: 4px;\r\n    border-top-left-radius: 4px;\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n  }\r\n  .pager {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n  }\r\n  .pager .next > a,\r\n  .pager .next > span {\r\n    float: left;\r\n  }\r\n  .pager .previous > a,\r\n  .pager .previous > span {\r\n    float: right;\r\n  }\r\n  .nav-pills > li > a > .badge {\r\n    margin-left: 0px;\r\n    margin-right: 3px;\r\n  }\r\n  .list-group-item > .badge {\r\n    float: left;\r\n  }\r\n  .list-group-item > .badge + .badge {\r\n    margin-left: 5px;\r\n    margin-right: auto;\r\n  }\r\n  .alert-dismissable,\r\n  .alert-dismissible {\r\n    padding-left: 35px;\r\n    padding-right: 15px;\r\n  }\r\n  .alert-dismissable .close,\r\n  .alert-dismissible .close {\r\n    right: auto;\r\n    left: -21px;\r\n  }\r\n  .progress-bar {\r\n    float: right;\r\n  }\r\n  .media > .pull-left {\r\n    margin-right: 10px;\r\n  }\r\n  .media > .pull-left.flip {\r\n    margin-right: 0;\r\n    margin-left: 10px;\r\n  }\r\n  .media > .pull-right {\r\n    margin-left: 10px;\r\n  }\r\n  .media > .pull-right.flip {\r\n    margin-left: 0;\r\n    margin-right: 10px;\r\n  }\r\n  .media-right,\r\n  .media > .pull-right {\r\n    padding-right: 10px;\r\n    padding-left: initial;\r\n  }\r\n  .media-left,\r\n  .media > .pull-left {\r\n    padding-left: 10px;\r\n    padding-right: initial;\r\n  }\r\n  .media-list {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n    list-style: none;\r\n  }\r\n  .list-group {\r\n    padding-right: 0;\r\n    padding-left: initial;\r\n  }\r\n  .panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\r\n  .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\r\n  .panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\r\n  .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 0;\r\n  }\r\n  .panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\r\n  .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\r\n  .panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\r\n  .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\r\n  .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\r\n    border-top-left-radius: 3px;\r\n    border-top-right-radius: 0;\r\n  }\r\n  .panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\r\n  .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\r\n  .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\r\n  .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\r\n    border-bottom-left-radius: 3px;\r\n    border-top-right-radius: 0;\r\n  }\r\n  .panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\r\n  .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\r\n  .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\r\n  .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\r\n  .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\r\n    border-bottom-right-radius: 3px;\r\n    border-top-left-radius: 0;\r\n  }\r\n  .panel > .table-bordered > thead > tr > th:first-child,\r\n  .panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\r\n  .panel > .table-bordered > tbody > tr > th:first-child,\r\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\r\n  .panel > .table-bordered > tfoot > tr > th:first-child,\r\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\r\n  .panel > .table-bordered > thead > tr > td:first-child,\r\n  .panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\r\n  .panel > .table-bordered > tbody > tr > td:first-child,\r\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\r\n  .panel > .table-bordered > tfoot > tr > td:first-child,\r\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\r\n    border-right: 0;\r\n    border-left: none;\r\n  }\r\n  .panel > .table-bordered > thead > tr > th:last-child,\r\n  .panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\r\n  .panel > .table-bordered > tbody > tr > th:last-child,\r\n  .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\r\n  .panel > .table-bordered > tfoot > tr > th:last-child,\r\n  .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\r\n  .panel > .table-bordered > thead > tr > td:last-child,\r\n  .panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\r\n  .panel > .table-bordered > tbody > tr > td:last-child,\r\n  .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\r\n  .panel > .table-bordered > tfoot > tr > td:last-child,\r\n  .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\r\n    border-right: none;\r\n    border-left: 0;\r\n  }\r\n  .embed-responsive .embed-responsive-item,\r\n  .embed-responsive iframe,\r\n  .embed-responsive embed,\r\n  .embed-responsive object {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n  .close {\r\n    float: left;\r\n  }\r\n  .modal-footer {\r\n    text-align: left;\r\n  }\r\n  .modal-footer.flip {\r\n    text-align: right;\r\n  }\r\n  .modal-footer .btn + .btn {\r\n    margin-left: auto;\r\n    margin-right: 5px;\r\n  }\r\n  .modal-footer .btn-group .btn + .btn {\r\n    margin-right: -1px;\r\n    margin-left: auto;\r\n  }\r\n  .modal-footer .btn-block + .btn-block {\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n  }\r\n  .popover {\r\n    left: auto;\r\n    text-align: right;\r\n  }\r\n  .popover.top > .arrow {\r\n    right: 50%;\r\n    left: auto;\r\n    margin-right: -11px;\r\n    margin-left: auto;\r\n  }\r\n  .popover.top > .arrow:after {\r\n    margin-right: -10px;\r\n    margin-left: auto;\r\n  }\r\n  .popover.bottom > .arrow {\r\n    right: 50%;\r\n    left: auto;\r\n    margin-right: -11px;\r\n    margin-left: auto;\r\n  }\r\n  .popover.bottom > .arrow:after {\r\n    margin-right: -10px;\r\n    margin-left: auto;\r\n  }\r\n  .carousel-control {\r\n    right: 0;\r\n    bottom: 0;\r\n  }\r\n  .carousel-control.left {\r\n    right: auto;\r\n    left: 0;\r\n    background-image: -webkit-linear-gradient(left, color-stop(rgba(0, 0, 0, 0.5) 0%), color-stop(rgba(0, 0, 0, 0.0001) 100%));\r\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\r\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\r\n  }\r\n  .carousel-control.right {\r\n    left: auto;\r\n    right: 0;\r\n    background-image: -webkit-linear-gradient(left, color-stop(rgba(0, 0, 0, 0.0001) 0%), color-stop(rgba(0, 0, 0, 0.5) 100%));\r\n    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\r\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\r\n    background-repeat: repeat-x;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\r\n  }\r\n  .carousel-control .icon-prev,\r\n  .carousel-control .glyphicon-chevron-left {\r\n    left: 50%;\r\n    right: auto;\r\n    margin-right: -10px;\r\n  }\r\n  .carousel-control .icon-next,\r\n  .carousel-control .glyphicon-chevron-right {\r\n    right: 50%;\r\n    left: auto;\r\n    margin-left: -10px;\r\n  }\r\n  .carousel-indicators {\r\n    right: 50%;\r\n    left: 0;\r\n    margin-right: -30%;\r\n    margin-left: 0;\r\n    padding-left: 0;\r\n  }\r\n  @media screen and (min-width: 768px) {\r\n    .carousel-control .glyphicon-chevron-left,\r\n    .carousel-control .icon-prev {\r\n      margin-left: 0;\r\n      margin-right: -15px;\r\n    }\r\n    .carousel-control .glyphicon-chevron-right,\r\n    .carousel-control .icon-next {\r\n      margin-left: 0;\r\n      margin-right: -15px;\r\n    }\r\n    .carousel-caption {\r\n      left: 20%;\r\n      right: 20%;\r\n      padding-bottom: 30px;\r\n    }\r\n  }\r\n  .pull-right.flip {\r\n    float: left !important;\r\n  }\r\n  .pull-left.flip {\r\n    float: right !important;\r\n  }\r\n  /*# sourceMappingURL=bootstrap-rtl.css.map */\r\n}\r\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","//\r\n// Variables\r\n//\r\n\r\n//\r\n// Base variables\r\n//\r\n\r\n// Global settings\r\n\r\n$enable-caret:              true !default;\r\n$enable-rounded:            true !default;\r\n$enable-gradients:          false !default;\r\n$enable-transitions:        true !default;\r\n$enable-grid-classes:       true !default;\r\n$enable-print-styles:       true !default;\r\n\r\n\r\n// Shadows\r\n\r\n$enable-shadows:            true !default;\r\n\r\n\r\n\r\n// Color system\r\n\r\n$white:    #fff !default;\r\n$gray-100: #f6f9fc !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #8898aa !default;   // Line footer color\r\n$gray-700: #525f7f !default;   // Line p color\r\n$gray-800: #32325d !default;   // Line heading color\r\n$gray-900: #212529 !default;\r\n$black:    #000 !default;\r\n\r\n$grays: () !default;\r\n$grays: map-merge((\r\n  \"100\": $gray-100,\r\n  \"200\": $gray-200,\r\n  \"300\": $gray-300,\r\n  \"400\": $gray-400,\r\n  \"500\": $gray-500,\r\n  \"600\": $gray-600,\r\n  \"700\": $gray-700,\r\n  \"800\": $gray-800,\r\n  \"900\": $gray-900\r\n), $grays);\r\n\r\n$blue:    #5e72e4 !default;\r\n$indigo:  #5603ad !default;\r\n$purple:  #8965e0 !default;\r\n$pink:    #f3a4b5 !default;\r\n$red:     #f5365c !default;\r\n$orange:  #fb6340 !default;\r\n$yellow:  #ffd600 !default;\r\n$green:   #2dce89 !default;\r\n$teal:    #11cdef !default;\r\n$cyan:    #2bffc6 !default;\r\n\r\n$colors: () !default;\r\n$colors: map-merge((\r\n  \"blue\":       $blue,\r\n  \"indigo\":     $indigo,\r\n  \"purple\":     $purple,\r\n  \"pink\":       $pink,\r\n  \"red\":        $red,\r\n  \"orange\":     $orange,\r\n  \"yellow\":     $yellow,\r\n  \"green\":      $green,\r\n  \"teal\":       $teal,\r\n  \"cyan\":       $cyan,\r\n  \"white\":      $white,\r\n  \"gray\":       $gray-600,\r\n  \"light\":      $gray-400,\r\n  \"lighter\":    $gray-200,\r\n  \"gray-dark\":  $gray-800\r\n), $colors);\r\n\r\n$default:       #172b4d !default;\r\n$primary:       #5e72e4 !default;\r\n$secondary:     #f7fafc !default;\r\n$success:       $green !default;\r\n$info:          $teal !default;\r\n$warning:       $orange !default;\r\n$danger:        $red !default;\r\n$light:         $gray-500 !default;\r\n$dark:          $gray-900 !default;\r\n$darker:        darken($gray-900, 15%) !default;\r\n\r\n$facebook:      #3b5999 !default;\r\n$twitter:       #1da1f2 !default;\r\n$google-plus:   #dd4b39 !default;\r\n$instagram:     #e4405f !default;\r\n$pinterest:     #bd081c !default;\r\n$youtube:       #cd201f !default;\r\n$slack:         #3aaf85 !default;\r\n$dribbble:      #ea4c89 !default;\r\n$github:        #222222 !default;\r\n$vimeo:         #04A0F0 !default;\r\n\r\n$theme-colors: () !default;\r\n$theme-colors: map-merge((\r\n  \"default\":      $default,\r\n  \"primary\":      $primary,\r\n  \"secondary\":    $secondary,\r\n  \"success\":      $success,\r\n  \"info\":         $info,\r\n  \"warning\":      $warning,\r\n  \"danger\":       $danger,\r\n  \"white\":        $white,\r\n  \"neutral\":      $white,\r\n  \"dark\":         $dark,\r\n  \"darker\":       $darker\r\n), $theme-colors);\r\n\r\n$brand-colors: () !default;\r\n$brand-colors: map-merge((\r\n  \"facebook\":     $facebook,\r\n  \"twitter\":      $twitter,\r\n  \"google-plus\":  $google-plus,\r\n  \"instagram\":    $instagram,\r\n  \"pinterest\":    $pinterest,\r\n  \"youtube\":      $youtube,\r\n  \"slack\":        $slack,\r\n  \"dribbble\":     $dribbble,\r\n  \"github\":       $github,\r\n  \"vimeo\":        $vimeo\r\n), $brand-colors);\r\n\r\n$shape-colors: () !default;\r\n$shape-colors: map-merge((\r\n  \"default\":      #32325d,\r\n  \"primary\":      #5533ff,\r\n  \"secondary\":    #24b47e,\r\n  \"neutral\":      #e9ecef,\r\n  \"blue-gray\":    #b2cbe1,\r\n\r\n), $shape-colors);\r\n\r\n$shapes-primary-colors: () !default;\r\n$shapes-primary-colors: map-merge((\r\n  \"step-1-gradient-bg\":         #281483,\r\n  \"step-2-gradient-bg\":         #8f6ed5,\r\n  \"step-3-gradient-bg\":         #d782d9,\r\n  \"span-1-bg\":                  #53f,\r\n  \"span-2-bg\":                  #4553ff,\r\n  \"span-3-bg\":                  #4f40ff,\r\n  \"span-4-bg\":                  #25ddf5,\r\n  \"span-5-bg\":                  #1fa2ff\r\n), $shapes-primary-colors);\r\n\r\n$shapes-default-colors: () !default;\r\n$shapes-default-colors: map-merge((\r\n  \"step-1-gradient-bg\":         #7795f8,\r\n  \"step-2-gradient-bg\":         #6772e5,\r\n  \"step-3-gradient-bg\":         #555abf,\r\n  \"span-1-bg\":                  #7795f8,\r\n  \"span-2-bg\":                  #7b9aff,\r\n  \"span-3-bg\":                  #6f8ff8,\r\n  \"span-4-bg\":                  #76eea7,\r\n  \"span-5-bg\":                  #6adaff\r\n), $shapes-default-colors);\r\n\r\n$shapes-light-colors: () !default;\r\n$shapes-light-colors: map-merge((\r\n  \"step-1-gradient-bg\":         #b2cbe1,\r\n  \"step-2-gradient-bg\":         #f6f9fc,\r\n  \"step-3-gradient-bg\":         #f6f9fc,\r\n  \"span-1-bg\":                  #b4cce1,\r\n  \"span-2-bg\":                  #c5dbef,\r\n  \"span-3-bg\":                  #b9d5ed,\r\n  \"span-4-bg\":                  #74e4a2,\r\n  \"span-5-bg\":                  #008169\r\n), $shapes-light-colors);\r\n\r\n$shapes-dark-colors: () !default;\r\n$shapes-dark-colors: map-merge((\r\n  \"step-1-gradient-bg\":         #32325d,\r\n  \"step-2-gradient-bg\":         #32325d,\r\n  \"step-3-gradient-bg\":         #32325d,\r\n  \"span-1-bg\":                  #2e2e57,\r\n  \"span-2-bg\":                  #2b2b58,\r\n  \"span-3-bg\":                  #25254d,\r\n  \"span-4-bg\":                  #d782d9,\r\n  \"span-5-bg\":                  #008169\r\n), $shapes-dark-colors);\r\n\r\n\r\n// Translucent color variations\r\n$translucent-color-opacity: .6 !default;\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval:      8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold:  200 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark:             $gray-900 !default;\r\n$yiq-text-light:            $white !default;\r\n\r\n// Action colors\r\n\r\n$star-rating-color: $gray-400 !default;\r\n$star-rating-color-active: $yellow !default;\r\n\r\n$favorite-color: $yellow !default;\r\n$like-color: $blue !default;\r\n$love-color: $red !default;\r\n\r\n\r\n// Body\r\n\r\n$body-bg:       #f8f9fe !default;\r\n$body-color:    $gray-700 !default;\r\n\r\n\r\n// Sections\r\n\r\n$section-colors: () !default;\r\n$section-colors: map-merge((\r\n  \"primary\":      $body-bg,\r\n  \"secondary\":    $secondary,\r\n  \"light\":        $gray-400,\r\n  \"dark\":         $dark,\r\n  \"darker\":       $darker\r\n), $section-colors);\r\n\r\n// Links\r\n\r\n$link-color:                $primary !default;\r\n$link-decoration:           none !default;\r\n$link-hover-color:          darken($link-color, 15%) !default;\r\n$link-hover-decoration:     none !default;\r\n\r\n\r\n\r\n// Grid breakpoints\r\n\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px\r\n);\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n\r\n\r\n// Spacing\r\n\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n$spacers: map-merge((\r\n  -9: -($spacer * 10),\r\n  -8: -($spacer * 8),\r\n  -7: -($spacer * 6),\r\n  -6: -($spacer * 4.5),\r\n  -5: -($spacer * 3),\r\n  -4: -($spacer * 1.5),\r\n  -3: -$spacer,\r\n  -2: -($spacer * .5),\r\n  -1: -($spacer * .25),\r\n  0: 0,\r\n  1: ($spacer * .25),\r\n  2: ($spacer * .5),\r\n  3: $spacer,\r\n  4: ($spacer * 1.5),\r\n  5: ($spacer * 3),\r\n  6: ($spacer * 4.5),\r\n  7: ($spacer * 6),\r\n  8: ($spacer * 8),\r\n  9: ($spacer * 10)\r\n), $spacers);\r\n\r\n\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n\r\n$sizes: () !default;\r\n$sizes: map-merge((\r\n  25: 25%,\r\n  50: 50%,\r\n  75: 75%,\r\n  100: 100%\r\n), $sizes);\r\n\r\n\r\n//\r\n// Components\r\n//\r\n\r\n$shape-height-xl:              1.5 !default;\r\n$shape-height-lg:              1.5 !default;\r\n$shape-height-sm:              1.5 !default;\r\n\r\n\r\n// Border\r\n\r\n$border-width:                1px !default;\r\n$border-color:                $gray-200 !default;\r\n\r\n$border-radius:               .375rem !default;\r\n$border-radius-xl:            .5rem !default;\r\n$border-radius-lg:            .4375rem !default;\r\n$border-radius-sm:            .25rem !default;\r\n\r\n$box-shadow-sm:               0 0 .5rem rgba($gray-600, .075) !default;\r\n$box-shadow:                  0 0 2rem 0 rgba($gray-600, .15) !default;\r\n$box-shadow-lg:               0 0 3rem rgba($gray-600, .175) !default;\r\n\r\n\r\n\r\n// Component - main styles for most of the components\r\n\r\n$component-active-color:        $white !default;\r\n$component-active-bg:           theme-color(\"primary\") !default;\r\n$component-active-border-color: theme-color(\"primary\") !default;\r\n\r\n$component-hover-color:        $gray-300 !default;\r\n$component-hover-bg:           $gray-300 !default;\r\n$component-hover-border-color: $gray-300 !default;\r\n\r\n\r\n\r\n// Caret\r\n\r\n$caret-width:                 .3em !default;\r\n\r\n\r\n\r\n// Transitions\r\n\r\n$transition-base-time:          .15s;\r\n$transition-base:               all $transition-base-time ease !default;\r\n$transition-fade:               opacity $transition-base-time linear !default;\r\n$transition-collapse:           height $transition-base-time * 2 ease !default;\r\n$transition-cubic-bezier:       all $transition-base-time cubic-bezier(.68, -0.55, .265, 1.55) !default;\r\n$transition-bg:                 background-color $transition-base-time * 2 linear !default;\r\n$transition-ease-in-out:        all $transition-base-time ease-in-out !default;\r\n\r\n\r\n\r\n// Fonts\r\n\r\n// Font icons\r\n\r\n$icon-font-family:           NucleoIcons, sans-serif !default;\r\n\r\n// Fonts\r\n\r\n$font-family-sans-serif: Open Sans, sans-serif !default;\r\n$font-family-base: $font-family-sans-serif !default;\r\n\r\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-xl:                ($font-size-base * 1.5);\r\n$font-size-lg:                ($font-size-base * 1.25);\r\n$font-size-sm:                ($font-size-base * .875);\r\n$font-size-xs:                ($font-size-base * .75);\r\n\r\n$font-weight-light:           300 !default;\r\n$font-weight-normal:          400 !default;\r\n$font-weight-bold:            600 !default;\r\n$font-weight-extra-bold:      700 !default;\r\n\r\n$font-weight-base:            $font-weight-normal !default;\r\n$line-height-base:            1.5 !default;\r\n$shape-height-base:           1.5 !default;\r\n\r\n$h1-font-size:                $font-size-base * 1.625 !default;\r\n$h2-font-size:                $font-size-base * 1.25 !default;\r\n$h3-font-size:                $font-size-base * 1.0625 !default;\r\n$h4-font-size:                $font-size-base * .9375 !default;\r\n$h5-font-size:                $font-size-base * .8125 !default;\r\n$h6-font-size:                $font-size-base * .625 !default;\r\n\r\n$headings-margin-bottom:      calc($spacer / 2);\r\n$headings-font-family:        inherit !default;\r\n$headings-font-weight:        $font-weight-bold !default;\r\n$headings-line-height:        1.5 !default;\r\n$headings-color:              $gray-800 !default;\r\n\r\n$heading-letter-spacing:      .025em !default;\r\n$heading-font-size:           .95rem !default;\r\n$heading-text-transform:      uppercase !default;\r\n$heading-font-weight:         $headings-font-weight !default;\r\n\r\n$heading-title-letter-spacing:      .025em !default;\r\n$heading-title-font-size:           1.375rem !default;\r\n$heading-title-font-weight:         $font-weight-bold !default;\r\n$heading-title-text-transform:      uppercase !default;\r\n\r\n$heading-section-letter-spacing:      .025em !default;\r\n$heading-section-font-size:           1.375rem !default;\r\n$heading-section-font-weight:         $font-weight-bold !default;\r\n$heading-section-text-transform:      uppercase !default;\r\n\r\n$display1-size:               3.3rem !default;\r\n$display2-size:               2.75rem !default;\r\n$display3-size:               2.1875rem !default;\r\n$display4-size:               1.6275rem !default;\r\n\r\n$display1-weight:             $font-weight-bold !default;\r\n$display2-weight:             $font-weight-bold !default;\r\n$display3-weight:             $font-weight-bold !default;\r\n$display4-weight:             $font-weight-bold !default;\r\n$display-line-height:         $headings-line-height !default;\r\n\r\n$paragraph-font-size:         1rem !default;\r\n$paragraph-font-weight:       300 !default;\r\n$paragraph-line-height:       1.7 !default;\r\n\r\n$lead-font-size:              ($paragraph-font-size * 1.25) !default;\r\n$lead-font-weight:            300 !default;\r\n\r\n$small-font-size:             80% !default;\r\n\r\n$text-muted:                  $gray-600 !default;\r\n\r\n$blockquote-small-color:      $gray-600 !default;\r\n$blockquote-font-size:        ($font-size-base * 1.25) !default;\r\n\r\n$hr-border-color:             rgba($black, .1);\r\n$hr-border-width:             $border-width !default;\r\n\r\n$mark-padding:                .2em !default;\r\n\r\n$dt-font-weight:              $font-weight-bold !default;\r\n\r\n$list-inline-padding:         .5rem !default;\r\n\r\n$mark-bg:                     #fcf8e3 !default;\r\n\r\n$hr-margin-y:                 $spacer * 2 !default;\r\n\r\n\r\n\r\n// Icons\r\n\r\n$icon-size: 3rem !default;\r\n$icon-size-xl: 5rem !default;\r\n$icon-size-lg: 4rem !default;\r\n$icon-size-sm: 2rem !default;\r\n$icon-size-xs: 1.25rem !default;\r\n\r\n\r\n\r\n// Tables\r\n\r\n$table-cell-padding:          1rem !default;\r\n$table-cell-padding-sm:       .5rem !default;\r\n\r\n$table-bg:                    transparent !default;\r\n$table-accent-bg:             rgba($gray-100, .3) !default;\r\n$table-hover-bg:              $gray-100 !default;\r\n$table-active-bg:             $table-hover-bg !default;\r\n\r\n$table-border-width:          $border-width !default;\r\n$table-border-color:          $gray-200 !default;\r\n\r\n$table-head-spacer-y:         .75rem !default;\r\n$table-head-spacer-x:         1rem !default;\r\n$table-head-font-size:        .65rem !default;\r\n$table-head-font-weight:      $font-weight-bold !default;\r\n$table-head-text-transform:   uppercase !default;\r\n$table-head-letter-spacing:   1px !default;\r\n$table-head-bg:               $gray-100 !default;\r\n$table-head-color:            $gray-600 !default;\r\n$table-action-color:          $gray-500 !default;\r\n\r\n$table-body-font-size:        .8125rem !default;\r\n\r\n$table-dark-bg:               theme-color(\"default\") !default;\r\n$table-dark-accent-bg:        rgba($white, .05) !default;\r\n$table-dark-hover-bg:         rgba($white, .075) !default;\r\n$table-dark-border-color:     lighten(theme-color(\"default\"), 7%) !default;\r\n$table-dark-color:            $body-bg !default;\r\n\r\n$table-dark-head-bg:          lighten(theme-color(\"default\"), 4%) !default;\r\n$table-dark-head-color:       lighten(theme-color(\"default\"), 35%) !default;\r\n$table-dark-action-color:     lighten(theme-color(\"default\"), 35%) !default;\r\n\r\n\r\n\r\n// Buttons + Forms\r\n\r\n$input-btn-padding-y:         .625rem !default;\r\n$input-btn-padding-x:         .75rem !default;\r\n$input-btn-line-height:       $shape-height-base !default;\r\n\r\n$input-btn-focus-width:       0 !default;\r\n$input-btn-focus-color:       rgba($component-active-bg, 1) !default;\r\n$input-btn-focus-box-shadow:  none !default;\r\n\r\n$input-btn-padding-y-sm:      .25rem !default;\r\n$input-btn-padding-x-sm:      .5rem !default;\r\n$input-btn-line-height-sm:    $shape-height-sm !default;\r\n\r\n$input-btn-padding-y-lg:      .875rem !default;\r\n$input-btn-padding-x-lg:      1rem !default;\r\n$input-btn-line-height-lg:    $shape-height-lg !default;\r\n\r\n$input-btn-border-width:      1px !default;\r\n\r\n$input-btn-font-size-sm:      .75rem !default;\r\n$input-btn-font-size:         .875rem !default;\r\n$input-btn-font-size-lg:         .875rem !default;\r\n\r\n\r\n\r\n// Forms\r\n\r\n$input-padding-y:                       $input-btn-padding-y !default;\r\n$input-padding-x:                       $input-btn-padding-x !default;\r\n$input-line-height:                     $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\r\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\r\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\r\n\r\n$input-border-radius:                   $border-radius-sm !default;\r\n$input-border-radius-xl:                $border-radius-xl !default;\r\n$input-border-radius-lg:                $border-radius-lg !default;\r\n$input-border-radius-sm:                $border-radius-sm !default;\r\n\r\n$input-bg:                              $white !default;\r\n$input-disabled-bg:                     $gray-200 !default;\r\n\r\n$input-muted-bg:                        #F7FAFE !default;\r\n$input-focus-muted-bg:                  lighten($input-muted-bg, 1%) !default;\r\n\r\n$input-color:                           $gray-600 !default;\r\n$input-border-color:                    $gray-300 !default;\r\n$input-border-width:                    $input-btn-border-width !default;\r\n$input-box-shadow:                      0 3px 2px rgba($gray-200, .05) !default;\r\n\r\n$input-focus-bg:                        $white !default;\r\n$input-focus-border-color:              $primary !default;\r\n$input-focus-color:                     $input-color !default;\r\n$input-focus-width:                     0 !default;\r\n$input-focus-box-shadow:                0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba($primary, .1) !default;\r\n\r\n$input-placeholder-color:               $gray-500 !default;\r\n$input-focus-placeholder-color:         $gray-500 !default;\r\n\r\n$input-height-border:                   $input-border-width * 2 !default;\r\n\r\n$input-transition:                      $transition-cubic-bezier !default;\r\n\r\n$input-alternative-box-shadow:          0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02) !default;\r\n$input-focus-alternative-box-shadow:    0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !default;\r\n\r\n// Form group\r\n\r\n$form-group-margin-bottom:              1.5rem !default;\r\n\r\n\r\n// Form validation\r\n\r\n$form-feedback-valid-bg:         lighten($success, 15%) !default;\r\n$form-feedback-valid-color:      theme-color(\"success\") !default;\r\n$form-feedback-invalid-bg:       lighten($warning, 15%) !default;\r\n$form-feedback-invalid-color:    theme-color(\"warning\") !default;\r\n\r\n\r\n\r\n// Input groups\r\n\r\n$input-group-addon-color:                   $input-placeholder-color !default;\r\n$input-group-addon-bg:                      $input-bg !default;\r\n$input-group-addon-border-color:            $input-border-color !default;\r\n\r\n$input-group-addon-focus-color:             $input-focus-color !default;\r\n$input-group-addon-focus-bg:                $input-focus-bg !default;\r\n$input-group-addon-focus-border-color:      $input-focus-border-color !default;\r\n\r\n\r\n\r\n// Custom forms\r\n\r\n$custom-control-gutter:                         1.75rem !default;\r\n$custom-control-spacer-x:                       1rem !default;\r\n$custom-control-indicator-size:                 1rem !default;\r\n\r\n$custom-control-indicator-bg:                   $input-bg !default;\r\n$custom-control-indicator-border-width:         1px !default;\r\n$custom-control-indicator-border-color:         $input-border-color !default;\r\n$custom-control-indicator-box-shadow:           $input-box-shadow !default;\r\n\r\n$custom-control-indicator-focus-box-shadow:     $custom-control-indicator-box-shadow !default;\r\n\r\n$custom-control-indicator-hover-color:          $component-hover-color !default;\r\n$custom-control-indicator-hover-bg:             $component-hover-bg !default;\r\n$custom-control-indicator-hover-border-color:   $component-hover-border-color !default;\r\n\r\n$custom-control-indicator-active-color:         $component-active-color !default;\r\n$custom-control-indicator-active-bg:            $component-active-bg !default;\r\n$custom-control-indicator-active-border-color:  $component-active-border-color !default;\r\n$custom-control-indicator-active-box-shadow:    $custom-control-indicator-box-shadow !default;\r\n\r\n$custom-control-indicator-checked-color:        $component-active-color !default;\r\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\r\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\r\n$custom-control-indicator-checked-box-shadow:   $custom-control-indicator-box-shadow !default;\r\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\r\n\r\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\r\n$custom-control-label-disabled-color:           $gray-600 !default;\r\n\r\n$custom-checkbox-indicator-border-radius:       $border-radius-sm !default;\r\n//$custom-checkbox-indicator-icon-checked:      str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n// Custom toggle\r\n\r\n$custom-toggle-width:                           52px !default;\r\n$custom-toggle-slider-bg:                       $gray-200 !default;\r\n$custom-toggle-checked-bg:                      theme-color(\"primary\") !default;\r\n$custom-toggle-border-color:                    $gray-400;\r\n\r\n\r\n\r\n// Buttons\r\n\r\n$btn-padding-y:               $input-btn-padding-y !default;\r\n$btn-padding-x:               $input-btn-padding-x + 0.5 !default;\r\n$btn-line-height:             $input-btn-line-height !default;\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\r\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\r\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width:            $input-btn-border-width !default;\r\n\r\n$btn-font-weight:             600 !default;\r\n$btn-letter-spacing:          .025em !default;\r\n$btn-text-transform:          none !default;\r\n$btn-box-shadow:              0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08) !default;\r\n$btn-hover-box-shadow:        0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08) !default;\r\n$btn-focus-box-shadow:        $btn-hover-box-shadow !default;\r\n$btn-focus-width:             $input-btn-focus-width !default;\r\n$btn-active-box-shadow:       none !default;\r\n$btn-hover-translate-y:       -1px !default;\r\n\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n\r\n$btn-border-radius:           $input-border-radius !default;\r\n$btn-border-radius-xl:        $input-border-radius-xl !default;\r\n$btn-border-radius-lg:        $input-border-radius-lg !default;\r\n$btn-border-radius-sm:        $input-border-radius !default;\r\n\r\n\r\n\r\n// Dropdown\r\n\r\n$dropdown-bg:                    $white !default;\r\n$dropdown-border-width:          0 !default;\r\n$dropdown-border-color:          rgba($black, .15) !default;\r\n$dropdown-border-radius:         $border-radius-lg !default;\r\n$dropdown-box-shadow:            0 50px 100px rgba(50, 50, 93, .1), 0 15px 35px rgba(50, 50, 93, .15), 0 5px 15px rgba(0, 0, 0, .1) !default;\r\n\r\n$dropdown-link-color:            $gray-900 !default;\r\n$dropdown-link-bg:               $white !default;\r\n\r\n$dropdown-link-hover-color:      darken($gray-900, 5%) !default;\r\n$dropdown-link-hover-bg:         $gray-100 !default;\r\n\r\n$dropdown-link-active-color:     $dropdown-link-hover-color !default;\r\n$dropdown-link-active-bg:        transparent !default;\r\n\r\n$dropdown-item-padding-y:        .5rem !default;\r\n$dropdown-item-padding-x:        1rem !default;\r\n\r\n\r\n\r\n// Map\r\n\r\n$map-height: 500px !default;\r\n\r\n\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y:                .25rem !default;\r\n$nav-link-padding-x:                .75rem !default;\r\n$nav-link-color:                    $gray-700 !default;\r\n$nav-link-hover-color:              theme-color(\"primary\") !default;\r\n$nav-link-disabled-color:           $gray-600 !default;\r\n\r\n$nav-pills-padding-y:               .75rem !default;\r\n$nav-pills-padding-x:               1rem !default;\r\n\r\n$nav-pills-space-x:                 1rem !default;\r\n\r\n$nav-pills-bg:                      $white !default;\r\n$nav-pills-border-width:            1px !default;\r\n$nav-pills-border-color:            theme-color(\"primary\") !default;\r\n$nav-pills-border-radius:           $border-radius !default;\r\n\r\n$nav-pills-link-color:              theme-color(\"primary\") !default;\r\n$nav-pills-link-hover-color:        darken(theme-color(\"primary\"), 5%) !default;\r\n$nav-pills-link-active-color:       color-yiq(theme-color(\"primary\")) !default;\r\n$nav-pills-link-active-bg:          theme-color(\"primary\") !default;\r\n$nav-pills-box-shadow:              $btn-box-shadow !default;\r\n\r\n\r\n\r\n// Navbar\r\n\r\n$navbar-padding-y:                         1rem !default;\r\n$navbar-padding-x:                         1rem !default;\r\n\r\n$navbar-nav-link-padding-x:                1rem !default;\r\n$navbar-nav-link-padding-y:                1rem !default;\r\n\r\n$navbar-nav-link-font-size:                .875rem !default;\r\n$navbar-nav-link-font-weight:              500 !default;\r\n$navbar-nav-link-text-transform:           normal !default;\r\n$navbar-nav-link-letter-spacing:           0 !default;\r\n$navbar-nav-link-border-radius:            $border-radius !default;\r\n\r\n$navbar-dark-bg:                           transparent !default;\r\n$navbar-dark-hover-bg:                     rgba(255, 255, 255, .1) !default;\r\n$navbar-dark-active-bg:                    rgba(255, 255, 255, .1) !default;\r\n$navbar-dark-border-color:                 rgba(255, 255, 255, .1) !default;\r\n$navbar-dark-color:                        rgba($white, .95) !default;\r\n$navbar-dark-hover-color:                  rgba($white, .65) !default;\r\n$navbar-dark-active-color:                 rgba($white, .65) !default;\r\n$navbar-dark-disabled-color:               rgba($white, .25) !default;\r\n$navbar-dark-toggler-border-color:         transparent !default;\r\n\r\n$navbar-light-bg:                          $gray-100 !default;\r\n$navbar-light-hover-bg:                    darken($gray-100, 5%) !default;\r\n$navbar-light-active-bg:                   darken($gray-100, 5%) !default;\r\n$navbar-light-border-color:                rgba($black, .05) !default;\r\n$navbar-light-color:                       rgba($black, .6) !default;\r\n$navbar-light-hover-color:                 rgba($black, .7) !default;\r\n$navbar-light-active-color:                rgba($black, .9) !default;\r\n$navbar-light-disabled-color:              rgba($black, .3) !default;\r\n$navbar-light-toggler-border-color:        transparent !default;\r\n\r\n\r\n// Vertical navbar\r\n\r\n$navbar-vertical-box-shadow:                0 0 2rem 0 rgba(136, 152, 170, .15) !default;\r\n$navbar-vertical-border-color:              rgba($black, .05) !default;\r\n$navbar-vertical-width:                     62px !default;\r\n$navbar-vertical-open-width:                250px !default;\r\n$navbar-vertical-padding-x:                 1.5rem !default;\r\n$navbar-vertical-nav-link-padding-x:        1.5rem !default;\r\n$navbar-vertical-nav-link-padding-y:        .675rem !default;\r\n\r\n$navbar-icon-min-width:                     2rem !default;\r\n\r\n$navbar-breadcrumb-padding-y:               $nav-link-padding-y !default;\r\n$navbar-breadcrumb-padding-x:               0 !default;\r\n\r\n$navbar-light-bg:                           $white !default;\r\n$navbar-light-border-color:                 $border-color !default;\r\n\r\n\r\n// Navbar search\r\n\r\n$navbar-search-width:                       250px !default;\r\n$navbar-search-focus-width:                 380px !default;\r\n$navbar-search-bg:                          transparent !default;\r\n$navbar-search-transition:                  $transition-cubic-bezier;\r\n\r\n$navbar-search-border-radius:               2rem !default;\r\n$navbar-search-border-width:                0 !default;\r\n\r\n$navbar-search-dark-bg:                     rgba($default, .8) !default;\r\n$navbar-search-dark-focus-bg:               rgba($default, .9) !default;\r\n$navbar-search-dark-border-color:           rgba(255, 255, 255, .6) !default;\r\n$navbar-search-dark-color:                  rgba(255, 255, 255, .6) !default;\r\n$navbar-search-dark-focus-border-color:     rgba(255, 255, 255, .9) !default;\r\n$navbar-search-dark-focus-color:            rgba(255, 255, 255, .9) !default;\r\n\r\n$navbar-search-light-bg:                    rgba(255, 255, 255, .9) !default;\r\n$navbar-search-light-focus-bg:              rgba(255, 255, 255, 1) !default;\r\n$navbar-search-light-border-color:          rgba(0, 0, 0, .6) !default;\r\n$navbar-search-light-color:                 rgba(0, 0, 0, .6) !default;\r\n$navbar-search-light-focus-border-color:    rgba(0, 0, 0, .9) !default;\r\n$navbar-search-light-focus-color:           rgba(0, 0, 0, .9) !default;\r\n\r\n\r\n\r\n// Content\r\n\r\n$main-content-padding-y: 40px !default;\r\n$main-content-padding-x: 15px !default;\r\n\r\n\r\n\r\n// Alerts\r\n\r\n$alert-padding-y: 1rem !default;\r\n$alert-padding-x: 1.5rem !default;\r\n$alert-border-radius: $border-radius !default;\r\n\r\n$alert-bg-level: -2 !default;\r\n$alert-border-level: -2 !default;\r\n$alert-color-level: 0 !default;\r\n\r\n\r\n\r\n// List group\r\n\r\n$list-group-bg:                     $white !default;\r\n$list-group-border-color:           $border-color !default; //rgba($black, .125);\r\n$list-group-border-width:           $border-width !default;\r\n$list-group-border-radius:          $border-radius !default;\r\n\r\n$list-group-item-padding-y:         1rem !default;\r\n$list-group-item-padding-x:         1rem !default;\r\n\r\n$list-group-hover-bg:               $gray-100 !default;\r\n$list-group-active-color:           $component-active-color !default;\r\n$list-group-active-bg:              $component-active-bg !default;\r\n$list-group-active-border-color:    $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color:         $gray-600 !default;\r\n$list-group-disabled-bg:            $list-group-bg !default;\r\n\r\n$list-group-action-color:           $gray-700 !default;\r\n$list-group-action-hover-color:     $list-group-action-color !default;\r\n\r\n$list-group-action-active-color:    $list-group-action-color !default;\r\n$list-group-action-active-bg:       $gray-200 !default;\r\n\r\n\r\n\r\n// Close\r\n\r\n$close-font-size:                   $font-size-base * 1.5 !default;\r\n$close-font-weight:                 $font-weight-bold !default;\r\n$close-bg:                          transparent !default;\r\n$close-hover-bg:                    transparent !default;\r\n$close-color:                       rgba(0, 0, 0, .6) !default !default;\r\n$close-hover-color:                 rgba(0, 0, 0, .9) !default;\r\n$close-text-shadow:                 none !default;\r\n\r\n\r\n\r\n// Popovers\r\n\r\n$popover-font-size:                 $font-size-sm !default;\r\n$popover-bg:                        $white !default;\r\n$popover-max-width:                 276px !default;\r\n$popover-border-width:              1px !default;\r\n$popover-border-color:              rgba($black, .05) !default;\r\n$popover-border-radius:             $border-radius-lg !default;\r\n$popover-box-shadow:                0px .5rem 2rem 0px rgba($black, .2) !default;\r\n\r\n$popover-header-bg:                 $popover-bg !default;\r\n$popover-header-color:              $headings-color !default;\r\n$popover-header-padding-y:          .5rem !default;\r\n$popover-header-padding-x:          .95rem !default;\r\n\r\n$popover-body-color:                $body-color !default;\r\n$popover-body-padding-y:            $popover-header-padding-y !default;\r\n$popover-body-padding-x:            $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width:               1rem !default;\r\n$popover-arrow-height:              .5rem !default;\r\n$popover-arrow-color:               $popover-bg !default;\r\n\r\n$popover-arrow-outer-color:         transparent !default;\r\n\r\n\r\n\r\n// Badges\r\n\r\n$badge-font-size:                   66% !default;\r\n$badge-font-weight:                 $font-weight-bold !default;\r\n$badge-padding-y:                   .35rem !default;\r\n$badge-padding-x:                   .375rem !default;\r\n$badge-border-radius:               $border-radius !default;\r\n$badge-text-transfom:               uppercase;\r\n\r\n$badge-pill-padding-x:              .875em !default;\r\n$badge-pill-border-radius:          10rem !default;\r\n\r\n$badge-circle-size:                 2rem !default;\r\n\r\n\r\n\r\n// Pagination\r\n\r\n$pagination-color:                  $gray-600 !default;\r\n$pagination-bg:                     $white  !default;\r\n$pagination-border-width:           $border-width !default;\r\n$pagination-border-color:           $gray-300 !default;\r\n\r\n$pagination-hover-color:            $gray-600 !default;\r\n$pagination-hover-bg:               $gray-300 !default;\r\n$pagination-hover-border-color:     $gray-300 !default;\r\n\r\n$pagination-active-color:           $component-active-color !default;\r\n$pagination-active-bg:              $component-active-bg !default;\r\n$pagination-active-border-color:    $pagination-active-bg !default;\r\n$pagination-active-box-shadow:      $btn-hover-box-shadow !default;\r\n\r\n$pagination-disabled-color:         $gray-600 !default;\r\n$pagination-disabled-bg:            $white !default;\r\n$pagination-disabled-border-color:  $gray-300 !default;\r\n\r\n\r\n\r\n// Cards\r\n\r\n$card-spacer-y:                     1.25rem !default;\r\n$card-spacer-x:                     1.5rem !default;\r\n$card-border-width:                 $border-width !default;\r\n$card-border-radius:                $border-radius !default;\r\n$card-border-color:                 rgba($black, .05) !default;\r\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width}) !default;\r\n$card-cap-bg:                       $white !default;\r\n$card-bg:                           $white !default;\r\n$card-box-shadow:                   $box-shadow !default;\r\n\r\n$card-img-overlay-padding:          1.25rem !default;\r\n\r\n$card-columns-count:                3 !default;\r\n$card-columns-gap:                  1.25rem !default;\r\n$card-columns-margin:               $card-spacer-y !default;\r\n\r\n\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size:                 $font-size-sm !default;\r\n\r\n\r\n\r\n// Modals\r\n\r\n$modal-inner-padding:               1.5rem !default;\r\n\r\n$modal-lg:                          800px !default;\r\n$modal-md:                          500px !default;\r\n$modal-sm:                          380px !default;\r\n\r\n$modal-title-font-size:             $h3-font-size !default;\r\n$modal-title-line-height:           1.1 !default;\r\n\r\n$modal-content-bg:                  $white !default;\r\n$modal-content-border-color:        rgba($black, .2) !default;\r\n$modal-content-border-width:        0 !default;\r\n$modal-content-border-radius:       $border-radius-lg !default;\r\n$modal-content-box-shadow-xs:       0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17) !default;\r\n$modal-content-box-shadow-sm-up:    0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17) !default;\r\n\r\n$modal-backdrop-bg:                 $black !default;\r\n$modal-backdrop-opacity:            .16 !default;\r\n$modal-header-border-color:         $gray-200 !default;\r\n$modal-footer-border-color:         $modal-header-border-color !default;\r\n$modal-header-border-width:         $modal-content-border-width !default;\r\n$modal-footer-border-width:         $modal-header-border-width !default;\r\n$modal-header-padding:              1.25rem !default;\r\n\r\n\r\n\r\n// Footer\r\n\r\n$footer-padding-y:              30px;\r\n$footer-padding-x:              0;\r\n\r\n$footer-link-font-size:         .85rem !default;\r\n$footer-bg:                     $body-bg !default;\r\n$footer-color:                  $gray-600 !default;\r\n$footer-link-color:             $gray-600 !default;\r\n$footer-link-hover-color:       $gray-700 !default;\r\n$footer-heading-color:          $gray-600 !default;\r\n$footer-heading-font-size:      $font-size-sm !default;\r\n\r\n\r\n\r\n//\r\n// Plugins\r\n//\r\n\r\n\r\n// Datepicker\r\n\r\n$datepicker-border-radius: $card-border-radius !default;\r\n$datepicker-dropdown-padding: 20px 22px !default;\r\n\r\n$datepicker-cell-transition: $transition-base !default;\r\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\r\n$datepicker-cell-border-radius: 50% !default;\r\n$datepicker-cell-width: 36px !default;\r\n$datepicker-cell-height: 36px !default;\r\n\r\n$datepicker-disabled-cell-color: $gray-300 !default;\r\n$datepicker-disabled-old-new-color: $gray-500 !default;\r\n\r\n$datepicker-header-cell-border-radius: $border-radius !default;\r\n\r\n$datepicker-active-color: $white !default;\r\n$datepicker-active-background: theme-color(\"primary\") !default;\r\n$datepicker-active-box-shadow:      none !default;\r\n\r\n$datepicker-range-background: theme-color(\"primary\") !default;\r\n$datepicker-range-cell-focused-background: darken($datepicker-range-background, 5%);\r\n$datepicker-range-color: $white !default;\r\n$datepicker-range-highlighted-bg: $gray-200 !default;\r\n\r\n$datepicker-dropdown-border: lighten($gray-400, 40%);\r\n$datepicker-dropdown-bg: $white !default;\r\n$datepicker-highlighted-bg: $datepicker-active-background !default;\r\n\r\n\r\n\r\n// NoUISlider\r\n\r\n$noui-target-bg:                  #eceeef !default;\r\n$noui-target-thickness:           5px !default;\r\n$noui-target-border-radius:       5px !default;\r\n$noui-target-border-color:        0 !default;\r\n$noui-target-box-shadow:          inset 0 1px 2px rgba(90,97,105,.1) !default;\r\n\r\n$noui-slider-connect-bg:          $primary !default;\r\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\r\n\r\n$noui-handle-width:               15px !default;\r\n$noui-handle-bg:                  theme-color(\"primary\") !default;\r\n$noui-handle-border:              0 !default;\r\n$noui-handle-border-radius:       100% !default;\r\n\r\n$noui-origin-border-radius:       2px !default;\r\n\r\n\r\n\r\n\r\n//\r\n// PRO components and plugins\r\n// Need more for your project? Check out the PRO version\r\n// URL:\r\n//\r\n\r\n\r\n\r\n\r\n// Breadcrumb\r\n\r\n$breadcrumb-padding-y:              .5rem !default;\r\n$breadcrumb-padding-x:              1rem !default;\r\n$breadcrumb-item-padding:           .5rem !default;\r\n$breadcrumb-margin-bottom:          1rem !default;\r\n$breadcrumb-bg:                     $gray-100 !default;\r\n$breadcrumb-divider-color:          $gray-600 !default;\r\n$breadcrumb-active-color:           $gray-600 !default;\r\n$breadcrumb-divider:                quote(\"-\") !default;\r\n$breadcrumb-border-radius:          $border-radius !default;\r\n\r\n$breadcrumb-dark-bg:                $default !default;\r\n$breadcrumb-dark-color:             $gray-100 !default;\r\n$breadcrumb-dark-hover-color:       $white !default;\r\n$breadcrumb-dark-active-color:      $gray-300 !default;\r\n$breadcrumb-dark-divider-color:     $gray-500 !default;\r\n\r\n\r\n\r\n// Timeline\r\n\r\n$timeline-axis-width: 2px !default;\r\n$timeline-axis-color: $border-color !default;\r\n\r\n$timeline-step-bg: $white !default;\r\n$timeline-step-border-width: 2px !default;\r\n$timeline-step-border-color: $timeline-axis-color !default;\r\n\r\n\r\n\r\n\r\n\r\n// Chart\r\n\r\n$chart-height: 350px !default;\r\n$chart-height-sm: 230px !default;\r\n\r\n$chart-legend-margin-top: 2.5rem !default;\r\n$chart-legend-font-size: $font-size-sm !default;\r\n$chart-legend-color: $text-muted !default;\r\n$chart-legend-height: $chart-legend-margin-top + $chart-legend-font-size * $line-height-base !default;\r\n\r\n\r\n\r\n// Sweet alert\r\n\r\n$swal2-width:               30em;\r\n$swal2-padding:             1.5rem;\r\n$swal2-title-font-size:     1.5rem;\r\n$swal2-content-font-size:   .875rem;\r\n\r\n\r\n\r\n// Tags\r\n\r\n$tags-input-border-width:           0;\r\n$tags-input-border-color:           transparent;\r\n$tags-input-color:                  $gray-600;\r\n\r\n$tag-bg:                            theme-color(\"default\");\r\n$tag-color:                         color-yiq(theme-color(\"default\"));\r\n$tag-close-color:                   color-yiq(theme-color(\"default\"));\r\n$tag-box-shadow:                    0 1px 2px rgba(68,68,68,0.25);\r\n\r\n\r\n// Import Bootstrap variable defaults\r\n\r\n@import \"~bootstrap/scss/variables\";\r\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @if (length($shadow) == 1) {\n      // We can pass `@include box-shadow(none);`\n      $result: $shadow;\n    } @else {\n      // Filter to avoid invalid properties for example `box-shadow: none, 1px 1px black;`\n      @for $i from 1 through length($shadow) {\n        @if nth($shadow, $i) != \"none\" {\n          $result: append($result, nth($shadow, $i), \"comma\");\n        }\n      }\n    }\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Hugo Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n@function color-yiq($color, $dark: $yiq-text-dark, $light: $yiq-text-light) {\n  $r: red($color);\n  $g: green($color);\n  $b: blue($color);\n\n  $yiq: (($r * 299) + ($g * 587) + ($b * 114)) * .001;\n\n  @if ($yiq >= $yiq-contrasted-threshold) {\n    @return $dark;\n  } @else {\n    @return $light;\n  }\n}\n\n// Retrieve color Sass maps\n@function color($key: \"blue\") {\n  @return map-get($colors, $key);\n}\n\n@function theme-color($key: \"primary\") {\n  @return map-get($theme-colors, $key);\n}\n\n@function gray($key: \"100\") {\n  @return map-get($grays, $key);\n}\n\n// Request a theme color level\n@function theme-color-level($color-name: \"primary\", $level: 0) {\n  $color: theme-color($color-name);\n  $color-base: if($level > 0, $black, $white);\n  $level: abs($level);\n\n  @return mix($color-base, $color, $level * $theme-color-interval);\n}\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@mixin form-control-focus($ignore-warning) {\r\n  &:focus {\r\n    color: $input-focus-color;\r\n    background-color: $input-focus-bg;\r\n    border-color: $input-focus-border-color;\r\n    outline: 0;\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $input-focus-box-shadow;\r\n    } @else {\r\n      box-shadow: $input-focus-box-shadow;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@mixin form-validation-state($state, $color, $icon) {\r\n  .#{$state}-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: $form-feedback-margin-top;\r\n    font-size: $form-feedback-font-size;\r\n    color: $color;\r\n  }\r\n\r\n  .#{$state}-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%; // Contain to parent when possible\r\n    padding: .5rem;\r\n    margin-top: .1rem;\r\n    font-size: .875rem;\r\n    line-height: 1;\r\n    color: #fff;\r\n    background-color: rgba($color, .8);\r\n    border-radius: .2rem;\r\n  }\r\n\r\n  .form-control,\r\n  .custom-select {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      border-color: $color;\r\n\r\n      &:focus {\r\n        border-color: $color;\r\n        //box-shadow: 0 1px $input-focus-width 0 rgba($color, .75);\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-check-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .form-check-label {\r\n        color: $color;\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custom-control-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-control-label {\r\n        color: $color;\r\n\r\n        &::before {\r\n          background-color: lighten($color, 25%);\r\n          border-color: lighten($color, 25%);\r\n        }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:checked {\r\n        ~ .custom-control-label::before {\r\n          @include gradient-bg(lighten($color, 10%));\r\n          border-color: lighten($color, 25%);\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-control-label::before {\r\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // custom file\r\n  .custom-file-input {\r\n    opacity: 1 !important;\r\n    width: 60% !important;\r\n    margin: 8px !important;\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-file-label {\r\n        border-color: $color;\r\n\r\n        &::before { border-color: inherit; }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-file-label {\r\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","@mixin button-variant($background, $border, $hover-background: darken($background, 0%), $hover-border: darken($border, 0%), $active-background: darken($background, 10%), $active-border: darken($border, 0%)) {\r\n    color: color-yiq($background);\r\n    @include gradient-bg($background);\r\n    border-color: $border;\r\n    @include box-shadow($btn-box-shadow);\r\n\r\n    @include hover {\r\n        color: color-yiq($hover-background);\r\n        @include gradient-bg($hover-background);\r\n        border-color: $hover-border;\r\n    }\r\n\r\n    &:focus,\r\n    &.focus {\r\n        // Avoid using mixin so we can pass custom focus shadow properly\r\n        @if $enable-shadows {\r\n            box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n        }\r\n        @else {\r\n            box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n        }\r\n    } // Disabled comes first so active can properly restyle\r\n    &.disabled,\r\n    &:disabled {\r\n        color: color-yiq($background);\r\n        background-color: $background;\r\n        border-color: $border;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active,\r\n    &:not(:disabled):not(.disabled).active,\r\n    .show>&.dropdown-toggle {\r\n        color: color-yiq($active-background);\r\n        background-color: $active-background;\r\n        @if $enable-gradients {\r\n            background-image: none; // Remove the gradient for the pressed/active state\r\n        }\r\n        border-color: $active-border;\r\n\r\n        &:focus {\r\n            // Avoid using mixin so we can pass custom focus shadow properly\r\n            @if $enable-shadows {\r\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n            }\r\n            @else {\r\n                box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\r\n    color: $color;\r\n    background-color: transparent;\r\n    background-image: none;\r\n    border-color: $color;\r\n\r\n    &:hover {\r\n        color: $color-hover;\r\n        background-color: $active-background;\r\n        border-color: $active-border;\r\n    }\r\n\r\n    &:focus,\r\n    &.focus {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled {\r\n        color: $color;\r\n        background-color: transparent;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active,\r\n    &:not(:disabled):not(.disabled).active,\r\n    .show>&.dropdown-toggle {\r\n        color: color-yiq($active-background);\r\n        background-color: $active-background;\r\n        border-color: $active-border;\r\n\r\n        &:focus {\r\n            // Avoid using mixin so we can pass custom focus shadow properly\r\n            @if $enable-shadows and $btn-active-box-shadow !=none {\r\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\r\n            }\r\n            @else {\r\n                box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Button sizes\r\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n    padding: $padding-y $padding-x;\r\n    font-size: $font-size;\r\n    line-height: $line-height; // Manually declare to provide an override to the browser default\r\n    @if $enable-rounded {\r\n        border-radius: $border-radius;\r\n    }\r\n    @else {\r\n        border-radius: 0;\r\n    }\r\n}\r\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\r\n\tcolor: saturate(darken($bg, 10%), 10);\r\n    background-color: lighten($bg, 32%);\r\n\r\n  \t&[href] {\r\n\t    @include hover-focus {\r\n\t        color: color-yiq($bg);\r\n\t        text-decoration: none;\r\n\t        background-color: darken($bg, 12%);\r\n\t    }\r\n\t}\r\n}\r\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\r\n    color: color-yiq($background);\r\n    border-color: $border;\r\n    @include gradient-bg($background);\r\n\r\n    a {\r\n        color: darken($background, 30%);\r\n        font-weight: 600;\r\n\r\n        &:hover {\r\n            color: color-yiq($background);\r\n        }\r\n    }\r\n\r\n    hr {\r\n        border-top-color: darken($border, 5%);\r\n    }\r\n\r\n    .alert-link {\r\n        color: darken($color, 10%);\r\n    }\r\n}\r\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// Contextual backgrounds\r\n@mixin bg-variant($parent, $color, $ignore-warning: true) {\r\n    #{$parent} {\r\n        background-color: $color !important;\r\n    }\r\n    a#{$parent},\r\n    button#{$parent} {\r\n        @include hover-focus {\r\n            background-color: darken($color, 10%) !important;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin bg-gradient-variant($parent, $color) {\r\n    #{$parent} {\r\n        background: linear-gradient(87deg, $color 0, adjust-hue($color, 25%) 100%) !important;\r\n    }\r\n}\r\n\r\n@mixin bg-translucent-variant($parent, $color) {\r\n    #{$parent} {\r\n        background-color: darken(rgba($color, $translucent-color-opacity), 7%) !important;\r\n    }\r\n    a#{$parent},\r\n    button#{$parent} {\r\n        @include hover-focus {\r\n            background-color: darken(rgba($color, $translucent-color-opacity), 12%) !important;\r\n        }\r\n    }\r\n}\r\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","//\r\n// Avatar\r\n//\r\n\r\n// General styles\r\n\r\n.avatar {\r\n\tcolor: $white;\r\n\tbackground-color: $gray-500;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tfont-size: 1rem;\r\n\tborder-radius: $border-radius;\r\n\theight: 48px;\r\n\twidth: 48px;\r\n\r\n    img {\r\n    \twidth: 100%;\r\n    \tborder-radius: $border-radius;\r\n    }\r\n\r\n\t&.rounded-circle {\r\n\t\timg {\r\n\t\t\t@extend .rounded-circle;\r\n\t\t}\r\n\t}\r\n\r\n    + .avatar-content {\r\n    \tdisplay: inline-block;\r\n    \tmargin-left: .75rem;\r\n    }\r\n}\r\n\r\n\r\n// Avatar size variations\r\n\r\n.avatar-xl {\r\n\twidth: 74px;\r\n\theight: 74px;\r\n}\r\n\r\n.avatar-lg {\r\n\twidth: 58px;\r\n\theight: 58px;\r\n\tfont-size: $font-size-sm;\r\n}\r\n\r\n.avatar-sm {\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\tfont-size: $font-size-sm;\r\n}\r\n\r\n.avatar-xs {\r\n\twidth: 24px;\r\n\theight: 24px;\r\n\tfont-size: $font-size-xs;\r\n}\r\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","//\r\n// Alert\r\n//\r\n\r\n.alert {\r\n\r\n    font-size: $font-size-sm;\r\n}\r\n\r\n// Alert heading\r\n\r\n.alert-heading {\r\n    font-weight: $font-weight-bold;\r\n    font-size: $h4-font-size;\r\n    margin-top: .15rem;\r\n}\r\n\r\n\r\n// Alert icon\r\n\r\n.alert-icon {\r\n    font-size: 1.25rem;\r\n    margin-right: 1.25rem;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n\r\n    i.ni {\r\n        position: relative;\r\n        top: 2px;\r\n    }\r\n}\r\n\r\n\r\n// Alert text next to an alert icon\r\n\r\n.alert-text {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n\r\n// Alert links\r\n\r\n[class*=\"alert-\"] {\r\n    .alert-link {\r\n        color: $white;\r\n        border-bottom: 1px dotted rgba($white, .5);\r\n    }\r\n}\r\n","//\r\n// Dismissible alert\r\n//\r\n\r\n.alert-dismissible {\r\n    .close {\r\n        top: 50%;\r\n        right: $alert-padding-x;\r\n        transform: translateY(-50%);\r\n        padding: 0;\r\n        opacity: 1;\r\n\r\n        @include media-breakpoint-down(xs) {\r\n            top: 1rem;\r\n            right: .5rem;\r\n        }\r\n\r\n        &>span:not(.sr-only) {\r\n            font-size: 1.5rem;\r\n            background-color: transparent;\r\n            color: rgba($white, .6);\r\n        }\r\n\r\n        &:hover,\r\n        &:focus {\r\n            &>span:not(.sr-only) {\r\n                background-color: transparent;\r\n                color: rgba($white, 1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.alert-secondary {\r\n    .close {\r\n        &>span:not(.sr-only) {\r\n            color: rgba(theme-color(\"default\"), .6);\r\n        }\r\n\r\n        &:hover,\r\n        &:focus {\r\n\r\n            &>span:not(.sr-only) {\r\n                color: rgba(theme-color(\"default\"), 1);\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Alert notify\r\n// work together with Bootstrap alerts and bootstrap-notify plugin\r\n//\r\n\r\n\r\n.alert-notify {\r\n    display: flex !important;\r\n    max-width: 600px;\r\n    width: calc(100% - 30px);\r\n    padding-right: 80px;\r\n    box-shadow: 0 3px 10px rgba($black, 0.15);\r\n    color: rgba($white, 0.85);\r\n\r\n    &:hover {\r\n        z-index: 1081 !important;\r\n    }\r\n\r\n    &:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) {\r\n        background-color: rgba($black, .95);\r\n\r\n        .alert-notify-close {\r\n            color: $yellow;\r\n\r\n            &:hover {\r\n            opacity: .8;\r\n            }\r\n        }\r\n    }\r\n\r\n    .alert-icon.ni {\r\n        position: relative;\r\n        top: 4px;\r\n    }\r\n\r\n    .alert-title {\r\n        display: block;\r\n        font-size: $font-size-base;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n\r\n    .close {\r\n        top: $alert-padding-y !important;\r\n        right: $alert-padding-x !important;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n","//\r\n// Avatar group\r\n//\r\n\r\n// General styles\r\n\r\n.avatar-group {\r\n\t.avatar {\r\n\t\tposition: relative;\r\n\t\tz-index: 2;\r\n\t\tborder: 2px solid $card-bg;\r\n\r\n\t\t&:hover {\r\n\t\t\tz-index: 3;\r\n\t\t}\r\n\t}\r\n\r\n\t.avatar + .avatar {\r\n\t\tmargin-left: -1rem;\r\n\r\n\t}\r\n}\r\n","//\r\n// Badge\r\n//\r\n\r\n\r\n// General styles\r\n\r\n.badge {\r\n    text-transform: $badge-text-transfom;\r\n\r\n    a {\r\n        color: $white;\r\n    }\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.badge-md {\r\n    padding: .65em 1em;\r\n}\r\n\r\n.badge-lg {\r\n    padding: .85em 1.375em;\r\n}\r\n\r\n\r\n// Multiple inline badges\r\n\r\n.badge-inline {\r\n    margin-right: .625rem;\r\n\r\n    + span {\r\n        top: 2px;\r\n        position: relative;\r\n\r\n        > a {\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Color fixes\r\n\r\n.badge-default {\r\n    color: $white;\r\n}\r\n\r\n.badge-secondary {\r\n    background-color: theme-color(\"secondary\");\r\n    color: color-yiq(theme-color(\"secondary\"));\r\n}\r\n\r\n\r\n// Badge spacing inside a btn with some text\r\n\r\n.btn {\r\n    .badge {\r\n        &:not(:first-child) {\r\n            margin-left: .5rem;\r\n        }\r\n        &:not(:last-child) {\r\n            margin-right: .5rem;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Circle badge\r\n//\r\n\r\n\r\n// General styles\r\n\r\n.badge-circle {\r\n    text-align: center;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    padding: 0 !important;\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n    font-size: .75rem;\r\n    font-weight: 600;\r\n\r\n    &.badge-md {\r\n        width: 1.5rem;\r\n        height: 1.5rem;\r\n    }\r\n\r\n    &.badge-lg {\r\n        width: 2rem;\r\n        height: 2rem;\r\n    }\r\n}\r\n","//\r\n// Dot badge\r\n//\r\n\r\n\r\n// General styles\r\n\r\n.badge-dot {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    background: transparent;\r\n    font-weight: $font-weight-normal;\r\n    font-size: $font-size-sm;\r\n    text-transform: none;\r\n\r\n    strong {\r\n        color: $gray-800;\r\n    }\r\n\r\n    i {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        width: .375rem;\r\n        height: .375rem;\r\n        border-radius: 50%;\r\n        margin-right: .375rem;\r\n    }\r\n\r\n    &.badge-md {\r\n        i {\r\n            width: .5rem;\r\n            height: .5rem;\r\n        }\r\n    }\r\n\r\n    &.badge-lg {\r\n        i {\r\n            width: .625rem;\r\n            height: .625rem;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Badge floating\r\n//\r\n\r\n\r\n.btn {\r\n    .badge-floating {\r\n        position: absolute;\r\n        top: -50%;\r\n        transform: translateY(50%);\r\n        border: 3px solid;\r\n\r\n        &.badge:not(.badge-circle) {\r\n            transform: translate(147%, 50%);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Breadcrumb\r\n//\r\n\r\n.breadcrumb-item {\r\n    font-size: $font-size-sm;\r\n}\r\n\r\n.breadcrumb-dark {\r\n    background-color: $breadcrumb-dark-bg;\r\n\r\n    .breadcrumb-item {\r\n        font-weight: 600;\r\n\r\n        a {\r\n            color: $breadcrumb-dark-color;\r\n\r\n            &:hover {\r\n                color: $breadcrumb-dark-hover-color;\r\n            }\r\n        }\r\n\r\n        + .breadcrumb-item {\r\n            &::before {\r\n                color: $breadcrumb-dark-divider-color;\r\n            }\r\n        }\r\n\r\n        &.active {\r\n            color: $breadcrumb-dark-active-color;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Links\r\n\r\n.breadcrumb-links {\r\n    padding: 0;\r\n    margin: 0;\r\n    background: transparent;\r\n}\r\n","//\r\n// Icon buttons\r\n//\r\n\r\n// General styles\r\n\r\n.btn {\r\n    position: relative;\r\n    text-transform: $btn-text-transform;\r\n    transition: $transition-base;\r\n    letter-spacing: $btn-letter-spacing;\r\n    font-size: $input-btn-font-size;\r\n    will-change: transform;\r\n\r\n    &:hover {\r\n        @include box-shadow($btn-hover-box-shadow);\r\n        transform: translateY($btn-hover-translate-y);\r\n    }\r\n\r\n    &:not(:last-child) {\r\n        margin-right: .5rem;\r\n    }\r\n\r\n   // Icons\r\n\r\n    i:not(:first-child),\r\n    svg:not(:first-child) {\r\n        margin-left: .5rem;\r\n    }\r\n\r\n    i:not(:last-child),\r\n    svg:not(:last-child) {\r\n        margin-right: .5rem;\r\n    }\r\n}\r\n\r\n\r\n// Remove translateY and margin animation when btn is included in a btn-group or input-group\r\n\r\n.btn-group,\r\n.input-group {\r\n    .btn {\r\n        margin-right: 0;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.btn-sm {\r\n    font-size: $input-btn-font-size-sm;\r\n}\r\n\r\n.btn-lg {\r\n    font-size: $input-btn-font-size-lg;\r\n}\r\n\r\n\r\n// Some quick fixes (to revise)\r\n\r\n// Fixes\r\n[class*=\"btn-outline-\"] {\r\n    border-width: 1px;\r\n}\r\n\r\n.btn-outline-secondary {\r\n    color: darken(theme-color(\"secondary\"), 50%);\r\n}\r\n\r\n.btn-inner--icon {\r\n    i:not(.fas):not(.fab) {\r\n        position: relative;\r\n        top: 2px;\r\n    }\r\n}\r\n\r\n.btn-link {\r\n    font-weight: $btn-font-weight;\r\n    box-shadow: none;\r\n\r\n    &:hover {\r\n        box-shadow: none;\r\n        transform: none;\r\n    }\r\n}\r\n\r\n.btn-neutral {\r\n    color: theme-color(\"primary\");\r\n}\r\n","//\r\n// Button group\r\n//\r\n\r\n// General\r\n\r\n.btn-group {\r\n    .btn {\r\n        box-shadow: none;\r\n    }\r\n}\r\n\r\n\r\n// Colors\r\n\r\n[data-toggle=\"buttons\"]:not(.btn-group-colors) {\r\n    & > .btn {\r\n        background-color: $gray-100;\r\n        cursor: pointer;\r\n        box-shadow: none;\r\n        border: 0;\r\n        margin: 0;\r\n\r\n        &:not(.active) {\r\n            color: $body-color;\r\n        }\r\n\r\n        &.active {\r\n            background-color: theme-color(\"primary\");\r\n            color: color-yiq(theme-color(\"primary\"));\r\n        }\r\n    }\r\n}\r\n\r\n.btn-group-colors {\r\n    & > .btn {\r\n        box-shadow: none;\r\n        border-radius: 50% !important;\r\n        width: 30px;\r\n        height: 30px;\r\n        padding: 0;\r\n        margin-right: .5rem;\r\n        margin-bottom: .25rem;\r\n        position: relative;\r\n\r\n        &:not([class*=\"bg-\"]) {\r\n            border-color: $gray-100 !important;\r\n        }\r\n\r\n        &:before {\r\n            position: absolute;\r\n            left: 0;\r\n            top: 0;\r\n            width: 100%;\r\n            height: 100%;\r\n            line-height: 28px;\r\n            color: $white;\r\n            transform: scale(0);\r\n            opacity: 0;\r\n            @include icon-font('\\ea26', 14px);\r\n            @include transition(transform 200ms, opacity 200ms);\r\n        }\r\n\r\n        &.btn:not([class*=\"bg-\"]) {\r\n            border: 1px solid darken($input-border-color, 5%);\r\n\r\n            &:before {\r\n                color: $body-color;\r\n            }\r\n        }\r\n\r\n        &.active {\r\n            &:before {\r\n                transform: scale(1);\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Icon buttons\r\n//\r\n\r\n.btn-icon {\r\n    .btn-inner--icon {\r\n        img {\r\n            width: 20px;\r\n        }\r\n   }\r\n\r\n   .btn-inner--text:not(:first-child) {\r\n       margin-left: 0.75em;\r\n   }\r\n\r\n   .btn-inner--text:not(:last-child) {\r\n       margin-right: 0.75em;\r\n   }\r\n}\r\n\r\n\r\n// Button only with icon and NO text\r\n\r\n.btn-icon-only {\r\n    width: 2.375rem;\r\n    height: 2.375rem;\r\n    padding: 0;\r\n}\r\n\r\na.btn-icon-only {\r\n    line-height: 2.5;\r\n}\r\n\r\n.btn-icon-only.btn-sm {\r\n    width: 2rem;\r\n    height: 2rem;\r\n}\r\n\r\n\r\n//\r\n// Clipboard button\r\n// dedicated element for copying icons\r\n//\r\n\r\n.btn-icon-clipboard {\r\n    margin: 0;\r\n    padding: 1.5rem;\r\n    font-size: $font-size-base;\r\n    font-weight: $font-weight-normal;\r\n    line-height: 1.25;\r\n    color: $gray-800;\r\n    background-color: $gray-100;\r\n    border-radius: $border-radius;\r\n    border: 0;\r\n    text-align: left;\r\n    font-family: inherit;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    text-decoration: none;\r\n    -moz-appearance: none;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    margin: .5rem 0;\r\n\r\n    &:hover {\r\n        background-color: $white;\r\n        box-shadow: rgba(0, 0, 0, .1) 0 0 0 1px, rgba(0, 0, 0, .1) 0 4px 16px;\r\n    }\r\n\r\n    > div {\r\n        align-items: center;\r\n        display: flex;\r\n    }\r\n\r\n    i {\r\n        box-sizing: content-box;\r\n        color: theme-color(\"primary\");\r\n        vertical-align: middle;\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    span {\r\n        display: inline-block;\r\n        font-size: 0.875rem;\r\n        line-height: 1.5;\r\n        margin-left: 16px;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        vertical-align: middle;\r\n    }\r\n}\r\n","//\r\n// Card\r\n//\r\n\r\n.card {\r\n    margin-bottom: $grid-gutter-width;\r\n\r\n    @if $enable-shadows {\r\n        box-shadow: $card-box-shadow;\r\n        border: 0;\r\n    }\r\n}\r\n\r\n.card-translucent {\r\n    background-color: rgba(18, 91, 152, 0.08);\r\n}\r\n\r\n.card-img-top {\r\n    @if ($enable-shadows == false) {\r\n        width: calc(100% + 2px);\r\n        margin-left: -1px;\r\n        margin-top: -1px;\r\n    }\r\n}\r\n\r\n.card-img-bottom {\r\n    @if ($enable-shadows == false) {\r\n        width: calc(100% + 2px);\r\n        margin-left: -1px;\r\n        margin-bottom: -1px;\r\n    }\r\n}\r\n\r\n// Card decks\r\n\r\n.card-deck  {\r\n    .card {\r\n        margin-bottom: $grid-gutter-width;\r\n    }\r\n}\r\n\r\n\r\n// Card with shdadow\r\n\r\n.card {\r\n    &.shadow {\r\n        border: 0 !important;\r\n    }\r\n}\r\n\r\n\r\n//\r\n// Columns\r\n//\r\n\r\n.card-columns {\r\n    @include media-breakpoint-up(sm) {\r\n        column-count: 1;\r\n    }\r\n\r\n    @include media-breakpoint-up(md) {\r\n        column-count: 2;\r\n    }\r\n\r\n    @include media-breakpoint-up(xl) {\r\n        column-count: $card-columns-count;\r\n        column-gap: $card-columns-gap;\r\n    }\r\n}\r\n","//\r\n// Card with hover animations\r\n//\r\n\r\n.card-lift--hover {\r\n    &:hover {\r\n        transform: translateY(-20px);\r\n        @include transition($transition-base);\r\n    }\r\n}\r\n","//\r\n// Card with blockquote\r\n//\r\n\r\n.card-blockquote {\r\n    padding: 2rem;\r\n    position: relative;\r\n\r\n    .svg-bg {\r\n        display: block;\r\n        width: 100%;\r\n        height: 95px;\r\n        position: absolute;\r\n        top: -94px;\r\n        left: 0;\r\n    }\r\n}\r\n","//\r\n// Money card\r\n// A visual representation of a credit/debit card\r\n//\r\n\r\n.card-serial-number {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: $h1-font-size;\r\n\r\n    > div:not(:last-child) {\r\n        display: flex;\r\n        flex: 1 1 auto;\r\n\r\n        &:after {\r\n            content: \"-\";\r\n            flex: 1 1 auto;\r\n            text-align: center;\r\n            position: relative;\r\n            left: -2px;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-down(xs) {\r\n        font-size: $h3-font-size;\r\n    }\r\n}\r\n","//\r\n// Pricing card\r\n//\r\n\r\n.card-pricing {\r\n    .card-header {\r\n        padding-top: 1.25rem;\r\n        padding-bottom: 1.25rem;\r\n    }\r\n    .list-unstyled li {\r\n        padding: .5rem 0;\r\n        color: $gray-600;\r\n    }\r\n}\r\n\r\n.card-pricing.popular {\r\n    z-index: 1;\r\n    border: 3px solid theme-color(\"primary\") !important;\r\n}\r\n\r\n@include media-breakpoint-up(md) {\r\n    .card-pricing.zoom-in {\r\n        z-index: 1;\r\n        transform: scale(1.1);\r\n    }\r\n}\r\n","//\r\n// Profile card\r\n//\r\n\r\n.card-profile-image {\r\n    position: relative;\r\n\r\n    img {\r\n        max-width: 140px;\r\n        border-radius: $border-radius;\r\n        border: 3px solid $card-bg;\r\n        transform: translate(-50%,-50%) scale(1);\r\n        position: absolute;\r\n        left: 50%;\r\n        transition: $transition-base;\r\n\r\n        &:hover {\r\n            transform: translate(-50%,-50%) scale(1.03);\r\n        }\r\n    }\r\n}\r\n\r\n.card-profile-stats {\r\n    padding: 1rem 0;\r\n\r\n    > div {\r\n        text-align: center;\r\n        margin-right: 1rem;\r\n        padding: .875rem;\r\n\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n\r\n        .heading {\r\n            font-size: 1.1rem;\r\n            font-weight: bold;\r\n            display: block;\r\n        }\r\n        .description {\r\n            font-size: .875rem;\r\n            color: $gray-500;\r\n        }\r\n    }\r\n}\r\n\r\n.card-profile-actions {\r\n    padding: .875rem;\r\n}\r\n","//\r\n// Card stats\r\n//\r\n\r\n.card-stats {\r\n    .card-body {\r\n        padding: 1rem 1.5rem;\r\n    }\r\n\r\n    .card-status-bullet {\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        transform: translate(50%, -50%);\r\n    }\r\n}\r\n","//\r\n// Chart\r\n//\r\n\r\n.chart {\r\n    position: relative;\r\n    height: $chart-height;\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.chart-sm {\r\n    height: $chart-height-sm;\r\n}\r\n\r\n\r\n// Legend\r\n\r\n.chart-legend {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: $chart-legend-margin-top;\r\n    font-size: $chart-legend-font-size;\r\n    text-align: center;\r\n    color: $chart-legend-color;\r\n}\r\n\r\n.chart-legend-item {\r\n    display: inline-flex;\r\n    align-items: center;\r\n\r\n    + .chart-legend-item {\r\n        margin-left: 1rem;\r\n    }\r\n}\r\n\r\n.chart-legend-indicator {\r\n    display: inline-block;\r\n    width: 0.5rem;\r\n    height: 0.5rem;\r\n    margin-right: 0.375rem;\r\n    border-radius: 50%;\r\n}\r\n\r\n\r\n// Tooltip\r\n\r\n#chart-tooltip {\r\n    z-index: 0;\r\n\r\n    .arrow {\r\n        top: 100%;\r\n        left: 50%;\r\n        transform: translateX(-50%) translateX(-.5rem);\r\n    }\r\n}\r\n\r\n\r\n// Chart info overlay\r\n\r\n.chart-info-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 5%;\r\n  max-width: 350px;\r\n  padding: 20px;\r\n  z-index: 1;\r\n}\r\n","//\r\n// Close\r\n//\r\n\r\n.close {\r\n    @if $enable-transitions {\r\n        transition: $transition-base;\r\n    }\r\n\r\n    &>span:not(.sr-only) {\r\n        background-color: $close-bg;\r\n        color: $close-color;\r\n        line-height: 17px;\r\n        height: 1.25rem;\r\n        width: 1.25rem;\r\n        border-radius: 50%;\r\n        font-size: 1.25rem;\r\n        display: block;\r\n        @if $enable-transitions {\r\n            transition: $transition-base;\r\n        }\r\n    }\r\n\r\n    &:hover,\r\n    &:focus {\r\n        background-color: $close-hover-bg;\r\n        color: $close-hover-color;\r\n        outline: none;\r\n\r\n        span:not(.sr-only) {\r\n            background-color: $close-hover-bg;\r\n        }\r\n    }\r\n}\r\n\r\n.close-dark {\r\n    &>span:not(.sr-only) {\r\n        color: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    &:hover,\r\n    &:focus {\r\n        &>span:not(.sr-only) {\r\n            color: rgba(255, 255, 255, 1);\r\n        }\r\n    }\r\n}\r\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","//\r\n// Accordion\r\n//\r\n\r\n\r\n.accordion {\r\n\t.card-header {\r\n\t\tposition: relative;\r\n\t\tcursor: pointer;\r\n\r\n\t\t&:after {\r\n\t\t\tcontent: \"\\ea0f\";\r\n\t\t\tposition: absolute;\r\n\t\t\tright: 1.5rem;\r\n\t\t\ttop: 50%;\r\n\t\t\ttransform: translateY(-50%);\r\n\t\t\tfont: normal normal normal 14px/1 NucleoIcons;\r\n            line-height: 0;\r\n            @include transition($transition-cubic-bezier);\r\n\t\t}\r\n\t}\r\n\r\n\t.card-header[aria-expanded=\"false\"] {\r\n\t\t&:after {\r\n\t\t\tcontent: \"\\ea0f\";\r\n\t\t}\r\n\t}\r\n\r\n\t.card-header[aria-expanded=\"true\"] {\r\n\t\t&:after {\r\n\t\t\ttransform: rotate(180deg);\r\n\t\t}\r\n\r\n\t\t.heading {\r\n\t\t\tcolor: theme-color(\"primary\");\r\n\t\t}\r\n\t}\r\n}\r\n",".main-content {\r\n    position: relative;\r\n\r\n    // Navbar\r\n    .navbar-top {\r\n        padding-left: 0 !important;\r\n        padding-right: 0 !important;\r\n    }\r\n\r\n    // Container\r\n    .container-fluid {\r\n        @include media-breakpoint-up(md) {\r\n            padding-left: ($main-content-padding-x + calc($grid-gutter-width / 2)) !important;\r\n            padding-right: ($main-content-padding-x + calc($grid-gutter-width / 2)) !important;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Custom checkbox\r\n//\r\n\r\n.custom-checkbox {\r\n    .custom-control-input ~ .custom-control-label {\r\n        cursor: pointer;\r\n        font-size: $font-size-sm;\r\n    }\r\n\r\n    .custom-control-input {\r\n        &:checked {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-checked-border-color;\r\n                }\r\n                &::after {\r\n                    background-image: $custom-checkbox-indicator-icon-checked;\r\n                }\r\n            }\r\n        }\r\n\r\n        &:disabled {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-disabled-bg;\r\n                }\r\n            }\r\n\r\n            &:checked {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-checked-disabled-bg;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Custom control\r\n// additional styles for custom checkboxes, radios and other\r\n//\r\n\r\n.custom-control-label {\r\n    // Background-color and (when enabled) gradient\r\n    &::before {\r\n        border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\r\n        @include transition($input-transition);\r\n        top:calc(($font-size-base * $line-height-base - $custom-control-indicator-size) / 2);\r\n        left: -($custom-control-gutter + $custom-control-indicator-size - 1rem);\r\n\r\n    }\r\n\r\n    &::after{\r\n      top:calc(($font-size-base * $line-height-base - $custom-control-indicator-size) / 2);\r\n      left: -($custom-control-gutter + $custom-control-indicator-size - 1rem);\r\n\r\n    }\r\n\r\n    span {\r\n        position: relative;\r\n        top: 2px;\r\n    }\r\n}\r\n\r\n.custom-control-label {\r\n    margin-bottom: 0;\r\n}\r\n\r\n\r\n// Alternative style\r\n\r\n.custom-control-alternative {\r\n    .custom-control-label {\r\n        // Background-color and (when enabled) gradient\r\n        &::before {\r\n            border: 0;\r\n            box-shadow: $input-alternative-box-shadow;\r\n        }\r\n    }\r\n\r\n    .custom-control-input {\r\n        &:checked {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    box-shadow: $input-focus-alternative-box-shadow;\r\n                }\r\n            }\r\n        }\r\n\r\n        &:active~.custom-control-label::before,\r\n        &:focus~.custom-control-label::before {\r\n            box-shadow: $input-alternative-box-shadow;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Custom checkbox\r\n//\r\n\r\n.custom-checkbox {\r\n    .custom-control-input ~ .custom-control-label {\r\n        cursor: pointer;\r\n        font-size: $font-size-sm;\r\n        height: $custom-control-indicator-size;\r\n    }\r\n\r\n    .custom-control-input {\r\n        &:checked {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-checked-border-color;\r\n                }\r\n                &::after {\r\n                    background-image: $custom-checkbox-indicator-icon-checked;\r\n                }\r\n            }\r\n        }\r\n\r\n        &:disabled {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-disabled-bg;\r\n                }\r\n            }\r\n\r\n            &:checked {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-checked-disabled-bg;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Color variations\r\n\r\n@each $color, $value in $theme-colors {\r\n    .custom-checkbox-#{$color} {\r\n        @include custom-checkbox-variant($value);\r\n    }\r\n}\r\n","@mixin custom-checkbox-variant($color) {\r\n    .custom-control-input {\r\n        &:checked {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $color;\r\n                    @include gradient-bg($color);\r\n                }\r\n                &::after {\r\n                    background-image: $color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@mixin custom-toggle-variant($color) {\r\n    input {\r\n        &:checked {\r\n             + .custom-toggle-slider {\r\n                border-color: $color;\r\n\r\n                &:before {\r\n                    background: $color;\r\n                }\r\n\r\n\r\n\t\t\t\t&:after {\r\n\t\t\t\t\tcolor: $color;\r\n\t\t\t\t}\r\n            }\r\n        }\r\n\r\n        &:disabled {\r\n            &:checked {\r\n                + .custom-toggle-slider {\r\n                    border-color: $color;\r\n\r\n                    &:before {\r\n                        background-color: lighten($color, 10%);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Custom radio\r\n//\r\n\r\n.custom-radio {\r\n    .custom-control-input ~ .custom-control-label {\r\n        cursor: pointer;\r\n        font-size: $font-size-sm;\r\n        height: $custom-control-indicator-size;\r\n    }\r\n\r\n    .custom-control-input {\r\n        &:checked {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-checked-border-color;\r\n                }\r\n                &::after {\r\n                    background-image: $custom-radio-indicator-icon-checked;\r\n                }\r\n            }\r\n        }\r\n\r\n        &:disabled {\r\n            ~ .custom-control-label {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-disabled-bg;\r\n                }\r\n            }\r\n\r\n            &:checked {\r\n                &::before {\r\n                    border-color: $custom-control-indicator-checked-disabled-bg;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Custom toggle\r\n//\r\n\r\n.custom-toggle {\r\n    position: relative;\r\n    display: inherit;\r\n    width: $custom-toggle-width;\r\n    height: 1.5rem;\r\n    margin: 0;\r\n    display: inline-block;\r\n\r\n    input {\r\n        display: none;\r\n\r\n        &:checked {\r\n             + .custom-toggle-slider {\r\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-checked-border-color;\r\n\r\n                &:before {\r\n                    background: $custom-toggle-checked-bg;\r\n                    transform: translateX(28px);\r\n                }\r\n            }\r\n        }\r\n\r\n        &:disabled {\r\n            + .custom-toggle-slider {\r\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\r\n            }\r\n\r\n            &:checked {\r\n                + .custom-toggle-slider {\r\n                    border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\r\n\r\n                    &:before {\r\n                        background-color: lighten($custom-control-indicator-checked-bg, 10%);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-toggle-slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border: $custom-control-indicator-border-width solid $custom-toggle-border-color;\r\n    border-radius: 34px !important;\r\n    background-color: transparent;\r\n\r\n\r\n    &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        height: 18px;\r\n        width: 18px;\r\n        left: 2px;\r\n        bottom: 2px;\r\n        border-radius: 50% !important;\r\n        background-color: $custom-toggle-slider-bg;\r\n        transition: $input-transition;\r\n    }\r\n}\r\n\r\n.custom-toggle-wrapper {\r\n    .custom-toggle + .custom-toggle {\r\n        margin-left: 1rem !important;\r\n    }\r\n}\r\n\r\n\r\n// Labeled toggles\r\n\r\n.custom-toggle {\r\n    input {\r\n        &:checked {\r\n             + .custom-toggle-slider {\r\n\r\n                &:after {\r\n                    content: attr(data-label-on);\r\n                    color: $custom-control-indicator-checked-border-color;\r\n                    right: auto;\r\n                    left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-toggle-slider {\r\n    &:after {\r\n        color: $custom-toggle-border-color;\r\n        content: attr(data-label-off);\r\n        display: block;\r\n        font-family: inherit;\r\n        font-weight: 600;\r\n        font-size: .75rem;\r\n        line-height: 24px;\r\n        position: absolute;\r\n        right: 0;\r\n        margin: 0 .21667rem;\r\n        top: 0;\r\n        text-align: center;\r\n        min-width: 1.66667rem;\r\n        overflow: hidden;\r\n        @include transition($transition-base);\r\n    }\r\n}\r\n\r\n\r\n// Color variations\r\n\r\n@each $color, $value in $theme-colors {\r\n    .custom-toggle-#{$color} {\r\n        @include custom-toggle-variant($value);\r\n    }\r\n}\r\n","//\r\n// Dropdown\r\n//\r\n\r\n// General styles\r\n\r\n.dropdown,\r\n.dropup,\r\n.dropright,\r\n.dropleft {\r\n    display: inline-block;\r\n}\r\n\r\n.dropdown-menu {\r\n    min-width: 12rem;\r\n\r\n    .dropdown-item {\r\n        padding: .5rem 1rem;\r\n        font-size: $font-size-sm;\r\n\r\n        > i,\r\n        > svg {\r\n            margin-right: 1rem;\r\n            font-size: 1rem;\r\n            vertical-align: -17%;\r\n        }\r\n\r\n        img {\r\n            margin-right: .5rem;\r\n        }\r\n    }\r\n}\r\n\r\n.dropdown-header {\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    // color: $gray-100;\r\n    font-size: .625rem;\r\n    text-transform: uppercase;\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n// Media components inside dropdown link\r\n\r\n.dropdown-menu {\r\n    a.media {\r\n\r\n        > div {\r\n            &:first-child {\r\n                line-height: 1;\r\n            }\r\n        }\r\n\r\n        p {\r\n            color: $gray-600;\r\n        }\r\n\r\n        &:hover {\r\n            .heading,\r\n            p {\r\n                color: theme-color(\"default\") !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.dropdown-menu-dark {\r\n    .h1, .h2, .h3, .h4, .h5, .h6, a {\r\n        color: white;\r\n    }\r\n}\r\n\r\n// Size variations\r\n\r\n.dropdown-menu-sm {\r\n    min-width: 100px;\r\n    border: $border-radius-lg;\r\n}\r\n\r\n.dropdown-menu-lg {\r\n    min-width: 320px;\r\n    border-radius: $border-radius-lg;\r\n}\r\n\r\n.dropdown-menu-xl {\r\n    min-width: 420px;\r\n    border-radius: $border-radius-lg;\r\n}\r\n","//\r\n// Footer\r\n//\r\n\r\n\r\n// General styles\r\n\r\n.footer {\r\n    background: $footer-bg;\r\n    padding: $footer-padding-y $footer-padding-x;\r\n\r\n    .col-footer {\r\n        .heading {\r\n            color: $footer-heading-color;\r\n            letter-spacing: 0;\r\n            font-size: $footer-heading-font-size;\r\n            text-transform: uppercase;\r\n            font-weight: $font-weight-bold;\r\n            margin-bottom: 1rem;\r\n        }\r\n    }\r\n\r\n    .nav .nav-item .nav-link,\r\n    .footer-link {\r\n        color: $footer-link-color !important;\r\n\r\n        &:hover {\r\n            color: $footer-link-hover-color !important;\r\n        }\r\n    }\r\n\r\n    .list-unstyled li a {\r\n        display: inline-block;\r\n        padding: .125rem 0;\r\n        color: $footer-link-color;\r\n        font-size: $footer-link-font-size;\r\n\r\n        &:hover {\r\n            color: $footer-link-hover-color;\r\n        }\r\n    }\r\n\r\n    .copyright {\r\n        font-size: $font-size-sm;\r\n    }\r\n}\r\n\r\n\r\n// Dark footer\r\n\r\n.footer-dark {\r\n    .col-footer .heading {\r\n        color: $white;\r\n    }\r\n}\r\n\r\n\r\n// Footer nav used for copyright and some links, but not limited to this\r\n\r\n.nav-footer {\r\n    .nav-link {\r\n        font-size: $font-size-sm;\r\n    }\r\n\r\n    .nav-item:last-child {\r\n        .nav-link {\r\n            padding-right: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Footer with cards over\r\n\r\n.footer.has-cards {\r\n    overflow: hidden;\r\n    padding-top: 500px;\r\n    margin-top: -420px;\r\n    position: relative;\r\n    background: transparent;\r\n    pointer-events: none;\r\n\r\n    &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 600px;\r\n        height: 2000px;\r\n        background: theme-color(\"secondary\");\r\n        transform: skew(0,-8deg);\r\n    }\r\n\r\n    .container {\r\n        pointer-events: auto;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n\r\n// Position the footer at the bottom of the page if the body is smaller than the window\r\n\r\n.footer-auto-bottom {\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n}\r\n","//\r\n// Forms\r\n//\r\n\r\n\r\n// Labels\r\n\r\n.form-control-label {\r\n    color: $gray-700;\r\n    font-size: $font-size-sm;\r\n    font-weight: $font-weight-bold;\r\n}\r\n\r\n\r\n// Text inputs\r\n\r\n.form-control {\r\n    font-size: $input-btn-font-size;\r\n    @include transition($transition-ease-in-out);\r\n    height:  calc(#{$input-line-height * 1em} + #{$input-padding-y * 2} + #{$input-height-border * 2.5});\r\n\r\n    &:focus {\r\n        &::placeholder {\r\n            color: $input-focus-placeholder-color;\r\n        }\r\n    }\r\n\r\n    \r\n}\r\n\r\n.form-control-lg{\r\n  height:  calc(#{$input-line-height * 1.5em} + #{$input-padding-y * 2} + #{$input-height-border * 2.5});\r\n\r\n}\r\n\r\n.form-control-sm{\r\n  height:  calc(#{$input-line-height * .3em} + #{$input-padding-y * 2} + #{$input-height-border * 2.5});\r\n\r\n}\r\n\r\n// Form control flush\r\n// Removes borders and paddings from inputs and text areas\r\n\r\n.form-control-flush {\r\n    padding: 0;\r\n    border-width: 0;\r\n    background-color: transparent;\r\n    box-shadow: none;\r\n\r\n    &:focus {\r\n        background-color: transparent;\r\n        box-shadow: none;\r\n        border-width: 0;\r\n    }\r\n}\r\n\r\n// Textarea\r\n\r\ntextarea[resize=\"none\"] {\r\n    resize: none!important;\r\n}\r\n\r\ntextarea[resize=\"both\"] {\r\n    resize: both!important;\r\n}\r\n\r\ntextarea[resize=\"vertical\"] {\r\n    resize: vertical!important;\r\n}\r\n\r\ntextarea[resize=\"horizontal\"] {\r\n    resize: horizontal!important;\r\n}\r\n\r\n\r\n// Form input variations\r\n\r\n// Muted input\r\n\r\n.form-control-muted {\r\n    background-color: $input-muted-bg;\r\n    border-color: $input-muted-bg;\r\n    box-shadow: none;\r\n\r\n    &:focus {\r\n        background-color: $input-focus-muted-bg;\r\n    }\r\n}\r\n\r\n\r\n// Alternative input\r\n\r\n.form-control-alternative {\r\n    box-shadow: $input-alternative-box-shadow;\r\n    border: 0;\r\n    transition: box-shadow .15s ease;\r\n\r\n    &:focus {\r\n        box-shadow: $input-focus-alternative-box-shadow;\r\n    }\r\n}\r\n\r\n// Size variations: Fixes to the bootstrap defaults\r\n\r\n.form-control-lg,\r\n.input-group-lg .form-control,\r\n.input-group-text {\r\n    font-size: $font-size-base !important;\r\n}\r\n","//\r\n// Input group\r\n//\r\n\r\n.custom-control{\r\n\tpadding-left: $custom-control-gutter + $custom-control-indicator-size - 1rem;\r\n\r\n}\r\n\r\n.input-group {\r\n\tbox-shadow: $input-box-shadow;\r\n\tborder-radius: $input-border-radius;\r\n\t@include transition($transition-ease-in-out);\r\n\r\n\t.form-control {\r\n\t\tbox-shadow: none;\r\n\r\n\t\t&:focus {\r\n\t\t\tbox-shadow: none;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.input-group-text {\r\n    @include transition($input-transition);\r\n\r\n\ti {\r\n\t\tfont-size: $font-size-sm;\r\n\t}\r\n\r\n\t.custom-control {\r\n\t\tline-height: 1;\r\n\t}\r\n}\r\n\r\n\r\n.input-group-prepend {\r\n\r\n\t// Should add the value of border right in variables.scss\r\n\t.input-group-text {\r\n\t\tborder-right: 0;\r\n\t}\r\n}\r\n\r\n.input-group-append {\r\n\r\n\t// Should add the value of border right in variables.scss\r\n\t.input-group-text {\r\n\t\tborder-left: 0;\r\n\t}\r\n}\r\n\r\n\r\n// Merged input group\r\n\r\n.input-group-merge {\r\n\t.form-control {\r\n\t\t&:not(:first-child) {\r\n\t\t    border-left: 0;\r\n\t\t    padding-left: 0;\r\n\t\t}\r\n\r\n\t\t&:not(:last-child) {\r\n\t\t\tborder-right: 0;\r\n\t\t\tpadding-right: 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Alternative input groups related to .form-control-alternative\r\n\r\n.input-group-alternative {\r\n    box-shadow: $input-alternative-box-shadow;\r\n    border: 0;\r\n    transition: box-shadow .15s ease;\r\n\r\n    .form-control,\r\n    .input-group-text {\r\n        border: 0;\r\n        box-shadow: none;\r\n    }\r\n}\r\n\r\n.focused {\r\n\t.input-group-alternative {\r\n        box-shadow: $input-focus-alternative-box-shadow !important;\r\n    }\r\n}\r\n\r\n\r\n// Remove borders and paddings\r\n\r\n.input-group-flush {\r\n\tbox-shadow: none;\r\n\r\n\t> .form-control {\r\n\t\tpadding: 0;\r\n\t\tborder-width: 0;\r\n\t\tbackground-color: transparent;\r\n\r\n\t}\r\n\r\n\t> .input-group-prepend,\r\n\t> .input-group-append {\r\n\r\n\t\t> .input-group-text {\r\n\t\t\tpadding: 0;\r\n\t\t\tpadding-right: 1rem;\r\n\t\t\tborder-width: 0;\r\n\t\t\tbackground-color: transparent;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n// .focus class is applied dinamycally from theme.js\r\n\r\n.focused {\r\n\t.input-group {\r\n\t\tbox-shadow: $input-focus-box-shadow;\r\n\t}\r\n\r\n\t.input-group-text {\r\n\t    color: $input-group-addon-focus-color;\r\n\t    background-color: $input-group-addon-focus-bg;\r\n\t    border-color: $input-group-addon-focus-border-color;\r\n\t}\r\n\r\n\t.form-control {\r\n\t\tborder-color: $input-group-addon-focus-border-color;\r\n\t}\r\n\r\n\t.input-group-flush {\r\n\t\tbox-shadow: none;\r\n\t}\r\n}\r\n","//\r\n// Form extend\r\n//\r\n\r\n\r\n// Color variations\r\n\r\n.form-primary {\r\n    .form-control {\r\n        color: color-yiq(theme-color(\"primary\"));\r\n        background-color: transparentize(darken(theme-color(\"primary\"), 10%), .5);\r\n        border-color: darken(theme-color(\"primary\"), 10%);\r\n\r\n        &:focus {\r\n            background-color: transparentize(darken(theme-color(\"primary\"), 12%), .3);\r\n            border: $input-border-width solid darken(theme-color(\"primary\"), 12%);\r\n        }\r\n\r\n        // Placeholder\r\n        &::placeholder {\r\n            color: transparentize(color-yiq(theme-color(\"primary\")), .2);\r\n        }\r\n    }\r\n\r\n    .input-group-text {\r\n        color: color-yiq(theme-color(\"primary\"));\r\n        background-color: transparentize(darken(theme-color(\"primary\"), 10%), .5);\r\n        border-color: darken(theme-color(\"primary\"), 10%);\r\n    }\r\n\r\n    .focused {\r\n        .input-group-text {\r\n            color: color-yiq(theme-color(\"primary\"));\r\n            background-color: transparentize(darken(theme-color(\"primary\"), 12%), .3);\r\n            border-color: darken(theme-color(\"primary\"), 12%);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Form validation\r\n//\r\n\r\n// Validation\r\n\r\n.has-success,\r\n.has-danger {\r\n    position: relative;\r\n\r\n    &:after, {\r\n        display: none; // remove in v1.1\r\n        //display: inline-block;\r\n        width: 19px;\r\n        height: 19px;\r\n        line-height: 19px;\r\n        text-align: center;\r\n        font-family: 'NucleoIcons';\r\n        position: absolute;\r\n        right: 15px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        border-radius: 50%;\r\n        font-size: 9px;\r\n        opacity: 1;\r\n    }\r\n\r\n    .input-group-prepend{\r\n      .input-group-text{\r\n        border-color: red;\r\n      }\r\n    }\r\n}\r\n\r\n.has-success {\r\n    &:after {\r\n        content: \"\\ea26\";\r\n        color: darken($form-feedback-valid-color, 18%);\r\n        background-color: $form-feedback-valid-bg;\r\n    }\r\n\r\n    .form-control {\r\n        background-color: $input-focus-bg;\r\n\r\n        &:focus {\r\n            //border-color: $input-focus-border-color;\r\n        }\r\n\r\n\r\n        // Placeholder\r\n\r\n        &::placeholder {\r\n            color: $form-feedback-valid-color;\r\n        }\r\n    }\r\n}\r\n\r\n.has-danger {\r\n    &:after {\r\n        content: \"\\ea53\";\r\n        color: darken($form-feedback-invalid-color, 18%);\r\n        background-color: $form-feedback-invalid-bg;\r\n    }\r\n\r\n    .form-control {\r\n        background-color: $input-focus-bg;\r\n\r\n        &:focus {\r\n            //border-color: $input-focus-border-color;\r\n        }\r\n\r\n        // Placeholder\r\n\r\n        &::placeholder {\r\n            color: $form-feedback-invalid-color;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Grid\r\n//\r\n\r\n\r\n// Example row\r\n\r\n.row-example {\r\n    > .col,\r\n    > [class^=\"col-\"] {\r\n        span {\r\n            display: block; \r\n            padding: .75rem;\r\n            color: rgb(57, 63, 73);\r\n            background-color: rgb(255, 255, 255);\r\n            box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\r\n            font-size: $font-size-sm;\r\n            border-radius: .25rem;\r\n            margin: 1rem 0;\r\n        }\r\n    }\r\n}\r\n\r\n.no-gutters {\r\n    > .col,\r\n    > [class^=\"col-\"] {\r\n        span {\r\n            border-radius: 0;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Header\r\n//\r\n\r\n.header {\r\n    position: relative;\r\n}\r\n","//\r\n// Icon\r\n//\r\n\r\n.icon {\r\n\twidth: $icon-size;\r\n\theight: $icon-size;\r\n\r\n\ti, svg {\r\n\t\tfont-size: $icon-size - .75;\r\n\t}\r\n\r\n    + .icon-text {\r\n    \tpadding-left: 1rem;\r\n    \twidth: calc(100% - #{$icon-size} - 1);\r\n    }\r\n}\r\n\r\n\r\n// Extra large icons\r\n\r\n.icon-xl {\r\n\twidth: $icon-size-xl;\r\n\theight: $icon-size-xl;\r\n\r\n\ti, svg {\r\n\t\tfont-size: $icon-size-xl - .75;\r\n\t}\r\n\r\n    + .icon-text {\r\n    \twidth: calc(100% - #{$icon-size-xl} - 1);\r\n    }\r\n}\r\n\r\n\r\n// Large icons\r\n\r\n.icon-lg {\r\n\twidth: $icon-size-lg;\r\n\theight: $icon-size-lg;\r\n\r\n\ti, svg {\r\n\t\tfont-size: $icon-size-lg - .75;\r\n\t}\r\n\r\n    + .icon-text {\r\n    \twidth: calc(100% - #{$icon-size-lg} - 1);\r\n    }\r\n}\r\n\r\n\r\n// Small icon\r\n\r\n.icon-sm {\r\n\twidth: $icon-size-sm;\r\n\theight: $icon-size-sm;\r\n\r\n\ti, svg {\r\n\t\tfont-size: $icon-size-sm - .75;\r\n\t}\r\n\r\n    + .icon-text {\r\n    \twidth: calc(100% - #{$icon-size-sm} - 1);\r\n    }\r\n}\r\n\r\n// Extra Small icon\r\n\r\n.icon-xs {\r\n\twidth: $icon-size-xs;\r\n\theight: $icon-size-xs;\r\n\r\n\ti, svg {\r\n\t\tfont-size: $icon-size-xs - .75;\r\n\t}\r\n\r\n    + .icon-text {\r\n    \twidth: calc(100% - #{$icon-size-xs} - 1);\r\n    }\r\n}\r\n","//\r\n// Icon action\r\n//\r\n\r\n\r\n.icon-actions {\r\n    > a {\r\n        display: inline-block;\r\n        margin-right: .75rem;\r\n        color: $gray-600;\r\n        font-size: .875rem;\r\n\r\n        &:last-of-type {\r\n            margin-right: 0;\r\n        }\r\n\r\n        span {\r\n            margin-left: .1875rem;\r\n            font-weight: $font-weight-bold;\r\n            color: $text-muted;\r\n        }\r\n\r\n        &:hover {\r\n            span {\r\n                color: darken($text-muted, 10%);\r\n            }\r\n        }\r\n    }\r\n\r\n    > a,\r\n    > a:hover,\r\n    > a.active {\r\n        color: $gray-800;\r\n    }\r\n\r\n    > .favorite:hover,\r\n    > .favorite.active {\r\n        color: $favorite-color;\r\n    }\r\n\r\n    > .love:hover,\r\n    > .love.active {\r\n        color: $love-color;\r\n    }\r\n\r\n    > .like:hover,\r\n    > .like.active {\r\n        color: $like-color;\r\n    }\r\n}\r\n\r\n.icon-actions-lg {\r\n    a {\r\n        font-size: 1.25rem;\r\n        margin-right: .875rem;\r\n    }\r\n}\r\n","//\r\n// Icon shape\r\n//\r\n\r\n\r\n.icon-shape {\r\n\tpadding: 12px;\r\n\ttext-align: center;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tborder-radius: 50%;\r\n\r\n\r\n\ti, svg {\r\n\t\tfont-size: 1.25rem;\r\n\t}\r\n\r\n\t&.icon-lg {\r\n\t\ti, svg {\r\n\t\t\tfont-size: 1.625rem;\r\n\t\t}\r\n\t}\r\n\r\n\t&.icon-sm {\r\n\t\ti, svg {\r\n\t\t\tfont-size: .875rem;\r\n\t\t}\r\n\t}\r\n\r\n\t&.icon-xs {\r\n\t\ti, svg {\r\n\t\t\tfont-size: .6rem;\r\n\t\t}\r\n\t}\r\n\r\n\tsvg {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t}\r\n\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n\t.icon-shape-#{$color} {\r\n\t\t@include icon-shape-variant(theme-color($color));\r\n\t}\r\n}\r\n","@mixin icon-shape-variant($color) {\r\n    color: saturate(darken($color, 10%), 10);\r\n    background-color: transparentize(lighten($color, 10%), .5);\r\n}\r\n\r\n@mixin icon-font($content, $font-size) {\r\n    content: $content;\r\n    font-family: $icon-font-family;\r\n    font-size: $font-size;\r\n}\r\n","//\r\n// List group\r\n//\r\n\r\n\r\n// Space list items\r\n\r\n.list-group-space {\r\n    .list-group-item {\r\n        margin-bottom: 1.5rem;\r\n        @include border-radius($list-group-border-radius);\r\n    }\r\n}\r\n\r\n\r\n// Extended list group components\r\n\r\n.list-group-img {\r\n    width: 3rem;\r\n    height: 3rem;\r\n    border-radius: 50%;\r\n    vertical-align: top;\r\n    margin: -.1rem 1.2rem 0 -.2rem;\r\n}\r\n\r\n.list-group-content {\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    > p {\r\n       color: $gray-500;\r\n       line-height: 1.5;\r\n       margin: .2rem 0 0;\r\n   }\r\n}\r\n\r\n.list-group-heading {\r\n    font-size: $font-size-base;\r\n    color: $gray-800;\r\n\r\n    > small {\r\n       float: right;\r\n       color: $gray-500;\r\n       font-weight: 500;\r\n   }\r\n}\r\n","//\r\n// Checklist\r\n// works with the [data-toggle=\"checklist\"] which inits the JS for item selection\r\n//\r\n\r\n\r\n// Checklist entry\r\n// is used in JS to get each entry and verify if it checked\r\n\r\n.checklist-entry {\r\n\r\n}\r\n\r\n\r\n// Checklist item\r\n// contains the checklist entry info and checkbox\r\n\r\n.checklist-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: relative;\r\n    padding-left: .75rem;\r\n\r\n    &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 3px;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        background-color: theme-color(\"primary\");\r\n        border-radius: 8px;\r\n    }\r\n}\r\n\r\n.checklist-item-checked {\r\n    .checklist-info * {\r\n        text-decoration: line-through;\r\n    }\r\n}\r\n\r\n\r\n// Color variations\r\n\r\n@each $color, $value in $theme-colors {\r\n    .checklist-item-#{$color} {\r\n        &:before {\r\n            background-color: theme-color($color);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Map\r\n//\r\n\r\n.map-canvas {\r\n    position: relative;\r\n    width: 100%;\r\n    height: $map-height;\r\n    border-radius: $border-radius;\r\n}\r\n","//\r\n// Mask\r\n//\r\n\r\n.mask {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    @include transition($transition-base);\r\n}\r\n\r\n\r\n// Backdrop\r\n\r\n.backdrop {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n    z-index: 1040; // navbar fixed has a z-index of 1030\r\n}\r\n\r\n.backdrop-dark {\r\n    background: rgba($black, .3);\r\n}\r\n\r\n.backdrop-light {\r\n    background: rgba($white, .3);\r\n}\r\n","//\r\n// Media comment\r\n//\r\n\r\n\r\n.media-comment {\r\n\tmargin-top: 2rem;\r\n}\r\n\r\n.media-comment-avatar {\r\n    margin-top: -1rem;\r\n    margin-right: -2rem;\r\n    position: relative;\r\n    z-index: 1;\r\n    border: 4px solid $white;\r\n    @include transition($transition-base);\r\n}\r\n\r\n.media-comment-text {\r\n\tborder-radius: $border-radius-lg;\r\n\tborder-top-left-radius: 0;\r\n\tposition: relative;\r\n\tbackground-color: $gray-100;\r\n\tpadding: 1rem 1.25rem 1rem 2.5rem;\r\n}\r\n\r\n.media-comment {\r\n\t&:hover {\r\n\t\t.media-comment-avatar {\r\n\t\t\ttransform: scale(1.1);\r\n\t\t}\r\n\t}\r\n}\r\n","//\r\n// Modal\r\n//\r\n\r\n\r\n.modal-title {\r\n    font-size: $modal-title-font-size;\r\n}\r\n\r\n\r\n// Fluid modal\r\n\r\n.modal-fluid {\r\n    .modal-dialog {\r\n        margin-top: 0;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .modal-content {\r\n        border-radius: 0;\r\n    }\r\n}\r\n\r\n\r\n// Background color variations\r\n\r\n@each $color, $value in $theme-colors {\r\n    .modal-#{$color} {\r\n        @include modal-variant($value);\r\n    }\r\n}\r\n","@mixin modal-variant($background) {\r\n\t.modal-title {\r\n\t\tcolor: color-yiq($background);\r\n\t}\r\n\r\n\t.modal-header,\r\n\t.modal-footer {\r\n\t\tborder-color: rgba(color-yiq($background), .075);\r\n\t}\r\n\r\n\t.modal-content {\r\n\t\tbackground-color: $background;\r\n\t\tcolor: color-yiq($background);\r\n\r\n\t\t.heading {\r\n\t\t\tcolor: color-yiq($background);\r\n\t\t}\r\n\t}\r\n\r\n\t.close {\r\n    \t& > span:not(.sr-only) {\r\n    \t\tcolor: $white;\r\n    \t}\r\n    }\r\n}\r\n","//\r\n// Navbar\r\n//\r\n\r\n\r\n// Navbar links\r\n\r\n.navbar-horizontal {\r\n    .navbar-nav {\r\n        .nav-link {\r\n            font-size: $navbar-nav-link-font-size;\r\n            font-weight: $navbar-nav-link-font-weight;\r\n            text-transform: $navbar-nav-link-text-transform;\r\n            letter-spacing: $navbar-nav-link-letter-spacing;\r\n            // @include transition($navbar-transition);\r\n\r\n            .nav-link-inner--text {\r\n                margin-left: .25rem;\r\n            }\r\n        }\r\n    }\r\n\r\n    .navbar-brand {\r\n        font-size: $font-size-sm;\r\n        font-weight: 600;\r\n        text-transform: uppercase;\r\n        font-size: .875rem;\r\n        letter-spacing: .05px;\r\n\r\n        img {\r\n            height: 30px;\r\n        }\r\n    }\r\n\r\n    .navbar-dark {\r\n        .navbar-brand {\r\n            color: $white;\r\n        }\r\n    }\r\n\r\n    .navbar-light {\r\n        .navbar-brand {\r\n            color: $gray-800;\r\n        }\r\n    }\r\n\r\n    .navbar-nav {\r\n      .nav-item {\r\n        .media:not(:last-child){\r\n          margin-bottom: 1.5rem;\r\n        }\r\n      }\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        // .navbar-main {\r\n        //     padding: 1rem 0;\r\n        // }\r\n\r\n        .navbar-nav {\r\n            .nav-item {\r\n                margin-right: .5rem;\r\n\r\n                [data-toggle=\"dropdown\"]::after {\r\n                    transition: $transition-base;\r\n                }\r\n\r\n                &.show {\r\n                    [data-toggle=\"dropdown\"]::after {\r\n                        transform: rotate(180deg);\r\n                    }\r\n                }\r\n            }\r\n            .nav-link {\r\n                padding-top: $navbar-nav-link-padding-y;\r\n                padding-bottom: $navbar-nav-link-padding-y;\r\n                border-radius: $navbar-nav-link-border-radius;\r\n\r\n                i {\r\n                    margin-right: .625rem;\r\n                }\r\n            }\r\n\r\n            .nav-link-icon {\r\n                padding-left: .5rem !important;\r\n                padding-right: .5rem !important;\r\n                font-size: 1rem;\r\n                border-radius: $navbar-nav-link-border-radius;\r\n\r\n                i {\r\n                    margin-right: 0;\r\n                }\r\n            }\r\n\r\n            // Dropdown menu\r\n            .dropdown-menu {\r\n                opacity: 0;\r\n                pointer-events: none;\r\n                margin: 0;\r\n\r\n                &:before {\r\n                    background: $dropdown-bg;\r\n                    box-shadow: none;\r\n                    content: '';\r\n                    display: block;\r\n                    height: 16px;\r\n                    width: 16px;\r\n                    left: 20px;\r\n                    position: absolute;\r\n                    bottom: 100%;\r\n                    transform: rotate(-45deg) translateY(1rem);\r\n                    z-index: -5;\r\n                    border-radius: $border-radius-sm;\r\n                }\r\n            }\r\n\r\n            .dropdown-menu-right {\r\n                &:before {\r\n                    right: 20px;\r\n                    left: auto;\r\n                }\r\n            }\r\n\r\n            &:not(.navbar-nav-hover) {\r\n                .dropdown-menu {\r\n                    &.show {\r\n                        opacity: 1;\r\n                        pointer-events: auto;\r\n                        animation: show-navbar-dropdown .25s ease forwards;\r\n                    }\r\n\r\n                    &.close {\r\n                        display: block;\r\n                        animation: hide-navbar-dropdown .15s ease backwards;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &.navbar-nav-hover {\r\n                .dropdown-menu {\r\n                    opacity: 0;\r\n                    display: block;\r\n                    pointer-events: none;\r\n                    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n                    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n                }\r\n\r\n                .nav-item.dropdown:hover > .dropdown-menu {\r\n                    display: block;\r\n                    opacity: 1;\r\n                    pointer-events: auto;\r\n                    visibility: visible;\r\n                    transform: translate(0, 0);\r\n                    animation: none;\r\n                }\r\n            }\r\n\r\n            .dropdown-menu-inner {\r\n                position: relative;\r\n                padding: 1rem;\r\n            }\r\n        }\r\n    }\r\n\r\n    // Transparent navbar\r\n    &.navbar-transparent {\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n        z-index: 100;\r\n        background-color: transparent;\r\n        border: 0;\r\n        box-shadow: none;\r\n\r\n        .navbar-brand {\r\n            color: rgba(255, 255, 255, 1);\r\n        }\r\n\r\n        .navbar-toggler {\r\n            color: rgba(255, 255, 255, 1);\r\n        }\r\n\r\n        .navbar-toggler-icon {\r\n            background-image: $navbar-dark-toggler-icon-bg;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-up(md) {\r\n        &.navbar-transparent {\r\n            .navbar-nav {\r\n                .nav-link {\r\n                    color: $navbar-dark-color;\r\n\r\n                    @include hover-focus {\r\n                        color: $navbar-dark-hover-color;\r\n                    }\r\n\r\n                    &.disabled {\r\n                        color: $navbar-dark-disabled-color;\r\n                    }\r\n                }\r\n\r\n                .show > .nav-link,\r\n                .active > .nav-link,\r\n                .nav-link.show,\r\n                .nav-link.active {\r\n                    color: $navbar-dark-active-color;\r\n                }\r\n            }\r\n\r\n            .navbar-brand {\r\n                color: $navbar-dark-color;\r\n\r\n                @include hover-focus {\r\n                    color: $navbar-dark-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // Collapse\r\n\r\n    .navbar-collapse-header {\r\n        display: none;\r\n    }\r\n\r\n    @include media-breakpoint-down(md) {\r\n        .navbar-nav {\r\n            .nav-link {\r\n                padding: .625rem 0;\r\n                color: theme-color(\"default\") !important;\r\n            }\r\n\r\n            .dropdown-menu {\r\n                box-shadow: none;\r\n                min-width: auto;\r\n\r\n                .media {\r\n                    svg {\r\n                        width: 30px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-collapse {\r\n            width: calc(100% - 1.4rem);\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            right: 0;\r\n            z-index: 1050;\r\n            margin: .7rem;\r\n            overflow-y: auto;\r\n            height: auto !important;\r\n            opacity: 0;\r\n\r\n            .navbar-toggler {\r\n                width: 20px;\r\n                height: 20px;\r\n                position: relative;\r\n                cursor: pointer;\r\n                display: inline-block;\r\n                padding: 0;\r\n\r\n                span {\r\n                    display: block;\r\n                    position: absolute;\r\n                    width: 100%;\r\n                    height: 2px;\r\n                    border-radius: 2px;\r\n                    opacity: 1;\r\n                    background: #283448;\r\n                }\r\n\r\n                :nth-child(1) {\r\n                    transform: rotate(135deg);\r\n                }\r\n\r\n                :nth-child(2) {\r\n                    transform: rotate(-135deg);\r\n                }\r\n            }\r\n\r\n            .navbar-collapse-header {\r\n                display: block;\r\n                padding-bottom: 1rem;\r\n                margin-bottom: 1rem;\r\n                border-bottom: 1px solid rgba(0, 0, 0, .1);\r\n            }\r\n\r\n            .collapse-brand {\r\n                img {\r\n                    height: 36px;\r\n                }\r\n            }\r\n\r\n            .collapse-close {\r\n                text-align: right;\r\n            }\r\n        }\r\n\r\n        .navbar-collapse.collapsing,\r\n        .navbar-collapse.show {\r\n            padding: 1.5rem;\r\n            border-radius: $border-radius;\r\n            background: #FFF;\r\n            box-shadow: 0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1);\r\n            animation: show-navbar-collapse .2s ease forwards;\r\n        }\r\n\r\n        .navbar-collapse.collapsing-out {\r\n            animation: hide-navbar-collapse .2s ease forwards;\r\n        }\r\n    }\r\n\r\n    // Keyframes\r\n\r\n    @keyframes show-navbar-collapse {\r\n        0% {\r\n            opacity: 0;\r\n            transform: scale(.95);\r\n            transform-origin: 100% 0;\r\n        }\r\n\r\n        100% {\r\n            opacity: 1;\r\n            transform: scale(1);\r\n        }\r\n    }\r\n\r\n    @keyframes hide-navbar-collapse {\r\n        from {\r\n            opacity: 1;\r\n            transform: scale(1);\r\n            transform-origin: 100% 0;\r\n        }\r\n\r\n        to {\r\n            opacity: 0;\r\n            transform: scale(.95);\r\n        }\r\n    }\r\n\r\n    @keyframes show-navbar-dropdown {\r\n        0% {\r\n            opacity: 0;\r\n            transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n            transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n        }\r\n\r\n        100% {\r\n            transform: translate(0, 0);\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    @keyframes hide-navbar-dropdown {\r\n        from {\r\n            opacity: 1;\r\n        }\r\n\r\n        to {\r\n            opacity: 0;\r\n            transform: translate(0, 10px);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Floating navbar\r\n//\r\n\r\n.navbar-floating-wrapper {\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 1;\r\n\r\n    .navbar {\r\n        border-radius: $border-radius;\r\n    }\r\n}\r\n","//\r\n// Vertical navbar + Sidenav\r\n//\r\n\r\n\r\n.navbar-vertical {\r\n    padding-top: 0;\r\n    border-width: 0 0 1px 0;\r\n    border-style: solid;\r\n    @if $enable-shadows {\r\n        box-shadow: $navbar-vertical-box-shadow;\r\n    }\r\n\r\n    // Navbar light\r\n\r\n    &.navbar-light {\r\n        background-color: $navbar-light-bg;\r\n        border-color: $navbar-light-border-color;\r\n    }\r\n\r\n\r\n    // Navbar dark\r\n\r\n    &.navbar-dark {\r\n        background-color: $navbar-dark-bg;\r\n        border-color: $navbar-dark-border-color;\r\n    }\r\n\r\n\r\n    // Navbar brand\r\n\r\n    .navbar-brand {\r\n        margin-right: 0;\r\n    }\r\n\r\n    .navbar-brand-img,\r\n    .navbar-brand > img {\r\n        max-width: 100%;\r\n        max-height: 2rem;\r\n    }\r\n\r\n\r\n    // Navbar collapse\r\n\r\n    @include media-breakpoint-up(md) {\r\n        .navbar-collapse {\r\n            margin-left: -$navbar-padding-x;\r\n            margin-right: -$navbar-padding-x;\r\n\r\n            &:before {\r\n                content: '';\r\n                display: block;\r\n                margin: calc($navbar-padding-y / 2);\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    // Navbar navigaton\r\n\r\n    .navbar-nav {\r\n        margin-left: -$navbar-padding-x;\r\n        margin-right: -$navbar-padding-x;\r\n\r\n\r\n        // Navbar link\r\n\r\n        .nav-link {\r\n            padding-left: $navbar-padding-x;\r\n            padding-right: $navbar-padding-x;\r\n            font-size: $navbar-nav-link-font-size;\r\n            font-weight: $navbar-nav-link-font-weight;\r\n\r\n            &.active {\r\n                position: relative;\r\n\r\n            }\r\n\r\n\r\n            // Icon\r\n\r\n            > i {\r\n                min-width: $navbar-icon-min-width;\r\n                font-size: .9375rem;\r\n                line-height: ($font-size-base * $line-height-base);\r\n            }\r\n\r\n\r\n            // Dropdown\r\n\r\n            .dropdown-menu {\r\n                border: none;\r\n\r\n                .dropdown-menu {\r\n                    margin-left: calc($dropdown-item-padding-x / 2);\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-sm {\r\n            .nav-link {\r\n                font-size: .8125rem;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    // Navbar navigation\r\n\r\n    .navbar-nav .nav-link {\r\n        display: flex;\r\n        align-items: center;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .navbar-nav .nav-link[data-toggle=\"collapse\"] {\r\n        &:after {\r\n            display: inline-block;\r\n            font-style: normal;\r\n            font-variant: normal;\r\n            text-rendering: auto;\r\n            -webkit-font-smoothing: antialiased;\r\n            font-family: 'Font Awesome 5 Free';\r\n            font-weight: 700;\r\n            content: \"\\f105\";\r\n            margin-left: auto;\r\n            color: $gray-400;\r\n            @include transition($transition-base);\r\n        }\r\n\r\n        // Expanded\r\n        &[aria-expanded=\"true\"] {\r\n            &:after {\r\n                color: theme-color(\"primary\");\r\n                transform: rotate(90deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    // Second level\r\n    .navbar-nav .nav .nav-link {\r\n        padding-left: $navbar-padding-x + $navbar-icon-min-width;\r\n    }\r\n\r\n    // Third level\r\n    .navbar-nav .nav .nav .nav-link {\r\n        padding-left: $navbar-padding-x * 1.5 + $navbar-icon-min-width;\r\n    }\r\n\r\n\r\n    // Navbar heading\r\n    .navbar-heading {\r\n        padding-top: $nav-link-padding-y;\r\n        padding-bottom: $nav-link-padding-y;\r\n        font-size: $font-size-xs;\r\n        text-transform: uppercase;\r\n        letter-spacing: .04em;\r\n    }\r\n\r\n\r\n    // Expanded navbar specific styles\r\n\r\n    &.navbar-expand {\r\n        @each $breakpoint, $dimension in $grid-breakpoints {\r\n            &-#{$breakpoint} {\r\n                @include media-breakpoint-up(#{$breakpoint}) {\r\n                    display: block;\r\n                    position: fixed;\r\n                    top: 0;\r\n                    bottom: 0;\r\n                    width: 100%;\r\n                    max-width: $navbar-vertical-width;\r\n                    overflow-y: auto;\r\n                    padding-left: 0;\r\n                    padding-right: 0;\r\n\r\n                    .navbar-inner {\r\n                        padding-left: $navbar-vertical-padding-x;\r\n                        padding-right: $navbar-vertical-padding-x;\r\n                    }\r\n\r\n                    // Container\r\n                    >[class*=\"container\"] {\r\n                        flex-direction: column;\r\n                        align-items: stretch;\r\n                        min-height: 100%;\r\n                        padding-left: 0;\r\n                        padding-right: 0; // Target IE 10 & 11\r\n                        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n                            min-height: none;\r\n                            height: 100%;\r\n                        }\r\n                    }\r\n\r\n\r\n                    // Fixes the vertical navbar to the left\r\n                    &.fixed-left {\r\n                        left: 0;\r\n                        border-width: 0 1px 0 0;\r\n                    }\r\n\r\n\r\n                    // Fixed the vertical navbar to the right\r\n                    &.fixed-right {\r\n                        right: 0;\r\n                        border-width: 0 0 0 1px;\r\n                    }\r\n\r\n\r\n                    // Navbar collapse\r\n                    .navbar-collapse {\r\n                        flex: 1;\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                        align-items: stretch;\r\n                        margin-left: -$navbar-vertical-padding-x;\r\n                        margin-right: -$navbar-vertical-padding-x;\r\n                        padding-left: $navbar-vertical-padding-x;\r\n                        padding-right: $navbar-vertical-padding-x;\r\n\r\n                        > * {\r\n                            min-width: 100%;\r\n                        }\r\n                    }\r\n\r\n\r\n                    // Navbar navigation\r\n\r\n                    .navbar-nav {\r\n                        flex-direction: column;\r\n                        margin-left: -$navbar-vertical-padding-x;\r\n                        margin-right: -$navbar-vertical-padding-x;\r\n                    }\r\n\r\n                    .navbar-nav .nav-link {\r\n                        padding: $navbar-vertical-nav-link-padding-y $navbar-vertical-nav-link-padding-x;\r\n                    }\r\n\r\n                    .navbar-nav > .nav-item {\r\n                        margin-top: 2px;\r\n\r\n                        > .nav-link {\r\n                            &.active {\r\n                                background: $gray-100;\r\n                                margin-right: .5rem;\r\n                                margin-left: .5rem;\r\n                                padding-left: 1rem;\r\n                                padding-right: 1rem;\r\n                                border-radius: $border-radius;\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .lavalamp-object {\r\n                        width: calc(100% - 1rem) !important;\r\n                        background: theme-color(\"primary\");\r\n                        color: color-yiq($primary);\r\n                        margin-right: .5rem;\r\n                        margin-left: .5rem;\r\n                        padding-left: 1rem;\r\n                        padding-right: 1rem;\r\n                        border-radius: $border-radius;\r\n                    }\r\n\r\n                    // Second level\r\n                    .navbar-nav .nav .nav-link {\r\n                        padding-top: calc($navbar-vertical-nav-link-padding-y / 1.5);\r\n                        padding-bottom: calc($navbar-vertical-nav-link-padding-y / 1.5);\r\n                        padding-left: 15px;\r\n                        span.sidenav-normal{\r\n                          padding-left: 8px;\r\n                          transition: all .1s ease 0s;\r\n                        }\r\n\r\n                        span.sidenav-mini-icon{\r\n                          width: 34px;\r\n                          text-align: center;\r\n                          transition: all .1s ease 0s;\r\n                        }\r\n                    }\r\n\r\n\r\n                    // Third level\r\n                    .navbar-nav .nav .nav .nav-link {\r\n                        padding-left: $navbar-vertical-padding-x * 1.5 + $navbar-icon-min-width;\r\n\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n}\r\n\r\n\r\n// Offsets the main content depending on the sidebar positioning\r\n\r\n.navbar-vertical.navbar-expand {\r\n    @each $breakpoint, $dimension in $grid-breakpoints {\r\n        &-#{$breakpoint} {\r\n            @include media-breakpoint-up(#{$breakpoint}) {\r\n                &.fixed-left + .main-content {\r\n                    margin-left: $navbar-vertical-width;\r\n                }\r\n                &.fixed-right + .main-content {\r\n                    margin-right: $navbar-vertical-width;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.sidenav {\r\n    &.fixed-left + .main-content {\r\n        margin-left: $navbar-vertical-width;\r\n        @include transition($transition-base);\r\n    }\r\n    &.fixed-right + .main-content {\r\n        margin-right: $navbar-vertical-width;\r\n        @include transition($transition-base);\r\n    }\r\n}\r\n\r\n.g-sidenav-pinned {\r\n    .sidenav {\r\n        @include media-breakpoint-up(xl) {\r\n            &.fixed-left + .main-content {\r\n                margin-left: $navbar-vertical-open-width;\r\n            }\r\n            &.fixed-right + .main-content {\r\n                margin-right: $navbar-vertical-open-width;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n//\r\n// Sidenav\r\n//\r\n\r\n.sidenav {\r\n    z-index: 1050;\r\n    transition: all 0.4s ease;\r\n\r\n    @include media-breakpoint-up(xl) {\r\n        &:hover {\r\n            max-width: $navbar-vertical-open-width;\r\n        }\r\n\r\n        .sidenav-toggler {\r\n            padding: 1.5rem;\r\n        }\r\n    }\r\n\r\n    .navbar-brand,\r\n    .navbar-heading .docs-normal {\r\n      display: none;\r\n    }\r\n\r\n    .navbar-heading .docs-mini{\r\n      padding-left: 3px;\r\n    }\r\n\r\n    .navbar-heading{\r\n      transition: all .1s ease;\r\n    }\r\n\r\n    .navbar-brand{\r\n      padding: 1.5rem;\r\n    }\r\n}\r\n\r\n.sidenav-header {\r\n    height: 78px;\r\n}\r\n\r\n\r\n// Sidenav states\r\n\r\n.g-sidenav-show {\r\n    .sidenav {\r\n        .navbar-brand,\r\n        .navbar-heading .docs-normal {\r\n            display: block;\r\n        }\r\n        .navbar-heading .docs-mini {\r\n          display: none;\r\n        }\r\n\r\n\r\n        .nav-item .collapse {\r\n            height: auto;\r\n            @include transition($transition-base);\r\n        }\r\n\r\n        .nav-link-text{\r\n          transition: 0.3s ease;\r\n          opacity: 1;\r\n        }\r\n\r\n        .nav-item .sidenav-mini-icon{\r\n          opacity: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.g-sidenav-pinned {\r\n    .sidenav {\r\n        max-width: $navbar-vertical-open-width !important;\r\n\r\n        .navbar-brand,\r\n        .navbar-heading {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.g-sidenav-hidden:not(.g-sidenav-show) {\r\n    .sidenav {\r\n        .navbar-nav > .nav-item {\r\n            > .nav-link {\r\n                &:after {\r\n                    content: '';\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-item .collapse .sidenav-normal {\r\n            display: none !important;\r\n        }\r\n\r\n        .nav-link-text {\r\n            opacity: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.g-sidenav-hide {\r\n    .sidenav {\r\n        .navbar-nav > .nav-item {\r\n            > .nav-link {\r\n                &:after {\r\n                    content: '';\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-item .collapse .sidenav-normal {\r\n            display: none !important;\r\n        }\r\n\r\n        .nav-link-text {\r\n            opacity: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Media fixes for iPhone 5 like resolutions\r\n\r\n@include media-breakpoint-down(lg) {\r\n    .sidenav {\r\n        transform: translateX(-$navbar-vertical-width);\r\n\r\n        &.fixed-left + .main-content {\r\n            margin-left: 0 !important;\r\n        }\r\n    }\r\n\r\n    .g-sidenav-pinned {\r\n        .sidenav {\r\n            transform: translateX(0);\r\n        }\r\n    }\r\n}\r\n\r\n// Sidenav toggler\r\n\r\n.sidenav-toggler-inner,\r\n.sidenav-toggler-line {\r\n    width: 18px;\r\n    @include transition($transition-base);\r\n}\r\n\r\n.sidenav-toggler-inner {\r\n    position: relative;\r\n\r\n    &:before {\r\n        content: '';\r\n        position: absolute;\r\n        width: 40px;\r\n        height: 40px;\r\n        left: -11px;\r\n        top: -14px;\r\n        // background-color: rgba($primary, .15);\r\n        border-radius: 50%;\r\n        transform: scale(0);\r\n        @include transition($transition-cubic-bezier);\r\n    }\r\n}\r\n\r\n.sidenav-toggler-line {\r\n    height: 2px;\r\n    background-color: theme-color(\"default\");\r\n    display: block;\r\n    position: relative;\r\n\r\n    &:not(:last-child) {\r\n        margin-bottom: 3px;\r\n    }\r\n}\r\n\r\n.sidenav-toggler-dark {\r\n    .sidenav-toggler-line {\r\n        background-color: $white;\r\n    }\r\n}\r\n\r\n.sidenav-toggler {\r\n    cursor: pointer;\r\n\r\n    &.active {\r\n        .sidenav-toggler-inner {\r\n            &:before {\r\n                transform: scale(1);\r\n            }\r\n        }\r\n\r\n        .sidenav-toggler-line {\r\n            background-color: theme-color(\"primary]\");\r\n\r\n            &:first-child {\r\n                width: 13px;\r\n                transform: translateX(5px);\r\n            }\r\n\r\n            &:last-child {\r\n                width: 13px;\r\n                transform: translateX(5px);\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Navbar search\r\n//\r\n\r\n.navbar-search {\r\n    .input-group {\r\n        border-radius: $navbar-search-border-radius;\r\n        border: $navbar-search-border-width solid;\r\n        @include transition($transition-bg);\r\n        transition-delay: $transition-base-time;\r\n\r\n        .input-group-text {\r\n            background-color: transparent;\r\n            padding-left: 1rem;\r\n            border: 0;\r\n        }\r\n    }\r\n\r\n    .form-control {\r\n        width: $navbar-search-width;\r\n        background-color: transparent;\r\n        border: 0;\r\n        @include transition($navbar-search-transition);\r\n    }\r\n\r\n    .focused {\r\n        .input-group {\r\n            .form-control {\r\n                width: $navbar-search-focus-width;\r\n            }\r\n        }\r\n    }\r\n\r\n    .close {\r\n        display: none;\r\n    }\r\n}\r\n\r\n\r\n// Search variations\r\n\r\n.navbar-search-dark {\r\n    .input-group {\r\n        background-color: $navbar-search-dark-bg;\r\n        border-color: $navbar-search-dark-border-color;\r\n    }\r\n\r\n    .input-group-text {\r\n        color: $navbar-search-dark-color;\r\n    }\r\n\r\n    .form-control {\r\n        color: $navbar-search-dark-focus-color;\r\n\r\n        &::placeholder {\r\n            color: $navbar-search-dark-color;\r\n        }\r\n    }\r\n\r\n    .focused {\r\n        .input-group {\r\n            background-color: $navbar-search-dark-focus-bg;\r\n            border-color: $navbar-search-dark-focus-border-color;\r\n        }\r\n    }\r\n}\r\n\r\n.navbar-search-light {\r\n    .input-group {\r\n        background-color: $navbar-search-light-bg;\r\n        border-color: $navbar-search-light-border-color;\r\n    }\r\n\r\n    .input-group-text {\r\n        color: $navbar-search-light-color;\r\n    }\r\n\r\n    .form-control {\r\n        color: $navbar-search-light-focus-color;\r\n\r\n        &::placeholder {\r\n            color: $navbar-search-light-color;\r\n        }\r\n    }\r\n\r\n    .focused {\r\n        .input-group {\r\n            background-color: $navbar-search-light-focus-bg;\r\n            border-color: $navbar-search-light-focus-border-color;\r\n        }\r\n    }\r\n}\r\n\r\n// When navbar search is open on xs\r\n@include media-breakpoint-down(xs) {\r\n    .navbar-search {\r\n        display: none;\r\n        width: 100%;\r\n        transform: translateX(-150%);\r\n        @include transition($transition-cubic-bezier);\r\n\r\n        .form-group {\r\n            width: 100%;\r\n        }\r\n\r\n        .form-control {\r\n            width: auto;\r\n        }\r\n\r\n        .focused {\r\n            .input-group {\r\n                .form-control {\r\n                    width: auto;\r\n                }\r\n            }\r\n        }\r\n\r\n        .close {\r\n            display: none;\r\n            opacity: 0;\r\n\r\n            span {\r\n                width: auto;\r\n                height: auto;\r\n            }\r\n        }\r\n    }\r\n\r\n    .navbar-top {\r\n        .navbar-nav {\r\n            @include transition($transition-base);\r\n        }\r\n    }\r\n\r\n    .g-navbar-search-showing {\r\n        .navbar-search {\r\n            .close {\r\n                display: block;\r\n            }\r\n        }\r\n\r\n        .navbar-top {\r\n            .navbar-nav {\r\n                display: flex;\r\n                opacity: 1;\r\n                transform: translateX(150%);\r\n            }\r\n        }\r\n    }\r\n\r\n    .g-navbar-search-show {\r\n        // Search\r\n        .navbar-search {\r\n            display: block;\r\n\r\n            .form-control {\r\n                width: auto;\r\n            }\r\n\r\n            .close {\r\n                color: white;\r\n                position: absolute;\r\n                top: 0;\r\n                right: 0;\r\n                width: 46px;\r\n                height: 46px;\r\n                text-align: center;\r\n                line-height: 46px;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n\r\n        // Navbar\r\n        .navbar-top {\r\n            .navbar-nav {\r\n                display: none;\r\n            }\r\n\r\n            // Collapse\r\n            .navbar-collapse {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    .g-navbar-search-shown {\r\n        .navbar-search {\r\n            transform: translateX(0);\r\n\r\n            .close {\r\n                display: block;\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n\r\n    .g-navbar-search-hiding {\r\n        // Navbar\r\n        .navbar-top {\r\n            .navbar-nav {\r\n                display: flex;\r\n                opacity: 0;\r\n                transform: translateX(150%);\r\n            }\r\n        }\r\n    }\r\n\r\n    .g-navbar-search-hidden {\r\n        .navbar-top {\r\n            .navbar-nav {\r\n                opacity: 1;\r\n                transform: translateX(0);\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Navbar dropdown\r\n//\r\n\r\n\r\n.navbar {\r\n    .dropdown-menu {\r\n        opacity: 0;\r\n        pointer-events: none;\r\n        margin: 0;\r\n    }\r\n\r\n    .dropdown-menu-arrow {\r\n        &:before {\r\n            background: $dropdown-bg;\r\n            box-shadow: none;\r\n            content: '';\r\n            display: block;\r\n            height: 12px;\r\n            width: 12px;\r\n            left: 20px;\r\n            position: absolute;\r\n            bottom: 100%;\r\n            transform: rotate(-45deg) translateY(12px);\r\n            z-index: -5;\r\n            border-radius: 2px;\r\n        }\r\n    }\r\n\r\n    .dropdown-menu-right {\r\n        &:before {\r\n            right: 20px;\r\n            left: auto;\r\n        }\r\n    }\r\n\r\n    &:not(.navbar-nav-hover) {\r\n        .dropdown-menu {\r\n            &.show {\r\n                opacity: 1;\r\n                pointer-events: auto;\r\n                animation: show-navbar-dropdown .25s ease forwards;\r\n            }\r\n\r\n            &.close {\r\n                display: block;\r\n                animation: hide-navbar-dropdown .15s ease backwards;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.navbar-nav-hover {\r\n        .dropdown-menu {\r\n            opacity: 0;\r\n            display: block;\r\n            pointer-events: none;\r\n            transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n            transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n        }\r\n\r\n        .nav-item.dropdown:hover > .dropdown-menu {\r\n            display: block;\r\n            opacity: 1;\r\n            pointer-events: auto;\r\n            visibility: visible;\r\n            transform: translate(0, 0);\r\n            animation: none;\r\n        }\r\n    }\r\n\r\n    .dropdown-menu-inner {\r\n        position: relative;\r\n        padding: 1rem;\r\n    }\r\n\r\n\r\n    // Keyframes\r\n\r\n    @keyframes show-navbar-dropdown {\r\n        0% {\r\n            opacity: 0;\r\n            // transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\r\n            transform: translate(0, 10px) perspective(200px);\r\n            transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\r\n        }\r\n\r\n        100% {\r\n            transform: translate(0, 0);\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    @keyframes hide-navbar-dropdown {\r\n        from {\r\n            opacity: 1;\r\n        }\r\n\r\n        to {\r\n            opacity: 0;\r\n            transform: translate(0, 10px)\r\n            // transform: translate(0, 10px) perspective(0) rotateX(0);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Navabar collapse\r\n//\r\n\r\n// Collapse\r\n\r\n.navbar-collapse-header {\r\n    display: none;\r\n}\r\n\r\n\r\n\r\n@keyframes show-navbar-collapse {\r\n    0% {\r\n        opacity: 0;\r\n        transform: scale(.95);\r\n        transform-origin: 100% 0;\r\n    }\r\n\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes hide-navbar-collapse {\r\n    from {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n        transform-origin: 100% 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        transform: scale(.95);\r\n    }\r\n}\r\n","//\r\n// Navbar top (Topbar)\r\n//\r\n\r\n\r\n.navbar-top {\r\n    border: 0;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n\r\n    .container,\r\n    .container-fluid {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n\r\n    @include media-breakpoint-up(sm) {\r\n        .navbar-brand {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-down(xs) {\r\n        .navbar-collapse {\r\n            width: 100%;\r\n        }\r\n\r\n        .nav-item {\r\n            position: static;\r\n\r\n            .dropdown-menu {\r\n                position: absolute;\r\n                width: 94%;\r\n                min-width: auto;\r\n                left: 3%;\r\n                right: auto;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.border-bottom {\r\n        &.navbar-dark {\r\n            border-color: rgba(255, 255, 255, .08) !important;\r\n        }\r\n\r\n        &.navbar-light {\r\n            border-color: rgba(0, 0, 0, .04) !important;\r\n        }\r\n    }\r\n}\r\n\r\n.sidenav-pinned {\r\n    .navbar-top {\r\n        .navbar-brand {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Nav\r\n//\r\n\r\n\r\n// Nav wrapper (container)\r\n\r\n// Nav wrapper\r\n.nav-wrapper {\r\n    padding: 1rem 0;\r\n    @include border-top-radius($card-border-radius);\r\n\r\n    + .card {\r\n        @include border-top-radius(0);\r\n        @include border-bottom-radius($card-border-radius);\r\n    }\r\n}\r\n\r\n\r\n// Nav links\r\n\r\n.nav-link {\r\n    color: $nav-link-color;\r\n\r\n    &:hover {\r\n        color: $nav-link-hover-color;\r\n    }\r\n\r\n    i.ni {\r\n        position: relative;\r\n        top: 2px;\r\n    }\r\n}\r\n","//\r\n// Nav pills\r\n//\r\n\r\n\r\n// General styles\r\n\r\n.nav-pills {\r\n    .nav-item:not(:last-child) {\r\n        padding-right: $nav-pills-space-x;\r\n    }\r\n\r\n    .nav-link {\r\n    \tpadding: $nav-pills-padding-y $nav-pills-padding-x;\r\n        color: $nav-pills-link-color;\r\n        font-weight: 500;\r\n        font-size: $font-size-sm;\r\n        box-shadow: $nav-pills-box-shadow;\r\n        background-color: $nav-pills-bg;\r\n        transition: $transition-base;\r\n\r\n        &:hover {\r\n        \tcolor: $nav-pills-link-hover-color;\r\n        }\r\n    }\r\n\r\n    .nav-link.active,\r\n    .show > .nav-link {\r\n        color: $nav-pills-link-active-color;\r\n        background-color: $nav-pills-link-active-bg;\r\n    }\r\n\r\n    @include media-breakpoint-down(xs) {\r\n        .nav-item {\r\n            margin-bottom: $spacer;\r\n        }\r\n    }\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n    .nav-pills:not(.nav-pills-circle) {\r\n        .nav-item {\r\n            padding-right: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Rounded circle nav pills\r\n\r\n.nav-pills-circle {\r\n    .nav-link {\r\n        text-align: center;\r\n        height: 60px;\r\n        width: 60px;\r\n        padding: 0;\r\n        line-height: 60px;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .nav-link-icon {\r\n        i, svg {\r\n            font-size: 1rem;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Pagination\r\n//\r\n\r\n\r\n.page-item {\r\n    &.active .page-link {\r\n        box-shadow: $pagination-active-box-shadow;\r\n    }\r\n\r\n    .page-link,\r\n    span {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        padding: 0;\r\n        margin: 0 3px;\r\n        border-radius: 50% !important;\r\n        width: 36px;\r\n\t\theight: 36px;\r\n\t\tfont-size: $font-size-sm;\r\n    }\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.pagination-lg {\r\n    .page-item {\r\n        .page-link,\r\n        span {\r\n            width: 46px;\r\n            height: 46px;\r\n            line-height: 46px;\r\n        }\r\n    }\r\n}\r\n\r\n.pagination-sm {\r\n    .page-item {\r\n        .page-link,\r\n        span {\r\n            width: 30px;\r\n            height: 30px;\r\n            line-height: 30px;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Popover\r\n//\r\n\r\n\r\n.popover {\r\n    border: 0;\r\n}\r\n\r\n.popover-header {\r\n\tfont-weight: $font-weight-bold;\r\n}\r\n\r\n\r\n// Alternative colors\r\n\r\n@each $color, $value in $theme-colors {\r\n    .popover-#{$color} {\r\n        @include popover-variant($value);\r\n    }\r\n}\r\n","@mixin popover-variant($background) {\r\n\r\n\tbackground-color: $background;\r\n\r\n\t.popover-header {\r\n\t\tbackground-color: $background;\r\n\t\tcolor: color-yiq($background);\r\n\t}\r\n\r\n\t.popover-body {\r\n\t\tcolor: color-yiq($background);\r\n\t}\r\n\t.popover-header{\r\n\t\tborder-color: rgba(color-yiq($background), .2);\r\n\t}\r\n\t&.bs-popover-top {\r\n\t\t.arrow::after {\r\n\t\t\tborder-top-color: $background;\r\n\t\t}\r\n\t}\r\n\t&.bs-popover-right {\r\n\t\t.arrow::after {\r\n\t\t\tborder-right-color: $background;\r\n\t\t}\r\n\t}\r\n\t&.bs-popover-bottom {\r\n\t\t.arrow::after {\r\n\t\t\tborder-bottom-color: $background;\r\n\t\t}\r\n\t}\r\n\t&.bs-popover-left {\r\n\t\t.arrow::after {\r\n\t\t\tborder-left-color: $background;\r\n\t\t}\r\n\t}\r\n}","//\r\n// Progress\r\n//\r\n\r\n\r\n// Progress container\r\n\r\n.progress-wrapper {\r\n    position: relative;\r\n    padding-top: 1.5rem;\r\n}\r\n\r\n\r\n// General styles\r\n\r\n.progress {\r\n    height: 8px;\r\n    margin-bottom: $spacer;\r\n    overflow: hidden;\r\n    border-radius: $border-radius-sm;\r\n    background-color: $progress-bg;\r\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\r\n\r\n    .sr-only {\r\n        width: auto;\r\n        height: 20px;\r\n        margin: 0 0 0 30px;\r\n        left: 0;\r\n        clip: auto;\r\n        line-height: 20px;\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.progress-sm {\r\n    height: 5px;\r\n}\r\n\r\n.progress-xs {\r\n    height: 3px;\r\n}\r\n\r\n// Progress inner elements\r\n\r\n.progress-heading {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    margin: 0 0 2px;\r\n    padding: 0;\r\n}\r\n\r\n.progress-bar {\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    height: auto;\r\n}\r\n\r\n.progress-info{\r\n    margin-bottom: .5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.progress-label {\r\n    span {\r\n        display: inline-block;\r\n        color: $primary;\r\n        font-size: .625rem;\r\n        font-weight: 600;\r\n        text-transform: uppercase;\r\n        background: rgba($primary, .1);\r\n        padding: .25rem 1rem;\r\n        border-radius: 30px;\r\n    }\r\n}\r\n\r\n.progress-percentage {\r\n    text-align: right;\r\n    span {\r\n        display: inline-block;\r\n        color: $gray-600;\r\n        font-size: .875rem;\r\n        font-weight: 600;\r\n    }\r\n}\r\n",".rtl{\r\n  &.g-sidenav-pinned .sidenav + .main-content{\r\n    margin-right: 250px;\r\n  }\r\n\r\n  .sidenav + .main-content{\r\n    margin-right: 62px;\r\n  }\r\n\r\n  .sidenav{\r\n    // direction: initial;\r\n    .navbar-nav{\r\n      padding-right: 0;\r\n    }\r\n    .navbar-nav .nav-link > i{\r\n      min-width: auto;\r\n      margin-left: 1rem;\r\n    }\r\n\r\n    .navbar-nav .nav-link[data-toggle=\"collapse\"]:after {\r\n      margin-right: auto;\r\n      margin-left: initial;\r\n      transform: rotate(180deg);\r\n    }\r\n\r\n    .navbar-nav .nav-link[data-toggle=\"collapse\"][aria-expanded=\"true\"]:after{\r\n      transform: rotate(90deg) !important;\r\n    }\r\n\r\n    .navbar-nav .nav .nav-link{\r\n      padding-right: 15px;\r\n    }\r\n    .sidenav-toggler.active .sidenav-toggler-line:first-child{\r\n      transform: translateX(0);\r\n    }\r\n    .sidenav-toggler.active .sidenav-toggler-line:last-child{\r\n      transform: translateX(0);\r\n    }\r\n    .navbar-heading{\r\n      text-align: right;\r\n    }\r\n    .scrollbar-inner{\r\n      direction: initial;\r\n      .navbar-nav{\r\n        direction: rtl;\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  .sidenav .navbar-heading .docs-mini{\r\n    padding-left: 0;\r\n    padding-right: 3px;\r\n  }\r\n\r\n  .navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link span.sidenav-normal{\r\n    padding-right: 8px;\r\n  }\r\n\r\n  .dropdown-menu-left{\r\n    text-align: right;\r\n  }\r\n\r\n  .card .card-body{\r\n    text-align: right;\r\n  }\r\n\r\n  @media (max-width: 1199.98px){\r\n    .sidenav{\r\n      transform: translateX(62px);\r\n      & + .main-content{\r\n        margin-right: 0 !important;\r\n      }\r\n    }\r\n\r\n    .sidenav-toggler.active .sidenav-toggler-line:first-child{\r\n      transform: translateX(0);\r\n    }\r\n\r\n    .sidenav-toggler.active .sidenav-toggler-line:last-child{\r\n      transform: translateX(0);\r\n    }\r\n\r\n    &.g-sidenav-pinned .sidenav{\r\n      transform: translateX(0) !important;\r\n    }\r\n  }\r\n\r\n  @media(max-width: 576px){\r\n    .navbar-expand .navbar-nav .nav-link{\r\n      padding-left: 0;\r\n    }\r\n    &.g-navbar-search-show .navbar-search .close{\r\n      left: 0;\r\n      right: auto;\r\n    }\r\n    .navbar-search{\r\n      transform: translateX(150%);\r\n    }\r\n\r\n    &.g-navbar-search-shown .navbar-search{\r\n      transform: translateX(0);\r\n    }\r\n  }\r\n}\r\n","//\r\n// Separator\r\n// add svg on top or bottom of a section for a more stylish visual\r\n//\r\n\r\n\r\n.separator {\r\n    position: absolute;\r\n    top: auto;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 150px;\r\n    transform: translateZ(0);\r\n    overflow: hidden;\r\n    pointer-events: none;\r\n\r\n    svg {\r\n        position: absolute;\r\n        pointer-events: none;\r\n    }\r\n}\r\n\r\n.separator-top {\r\n    top: 0;\r\n    bottom: auto;\r\n\r\n    svg {\r\n        top: 0;\r\n    }\r\n}\r\n\r\n.separator-bottom {\r\n    top: auto;\r\n    bottom: 0;\r\n\r\n    svg {\r\n        bottom: 0;\r\n    }\r\n}\r\n\r\n.separator-inverse {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n// Styles\r\n\r\n.separator-skew {\r\n    height: 60px;\r\n\r\n    @include media-breakpoint-up(xl) {\r\n        height: 70px;\r\n    }\r\n}\r\n",".section-nucleo-icons {\r\n\r\n    --icon-size: 5rem;\r\n    --icon-sm-size: 3.75rem;\r\n    --gutter: 7rem;\r\n\r\n    .icons-container {\r\n        position: relative;\r\n        max-width: 100%;\r\n        height: 360px;\r\n        margin: 0 auto;\r\n        z-index: 1;\r\n\r\n        i {\r\n            position: absolute;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            border-radius: 50%;\r\n            background: $white;\r\n            z-index: 1;\r\n            transform: translate(-50%, -50%);\r\n            @include box-shadow($box-shadow);\r\n            transition: all .2s cubic-bezier(.25,.65,.9,.75);\r\n\r\n            &.icon {\r\n                width: var(--icon-size);\r\n                height: var(--icon-size);\r\n                font-size: 1.7em;\r\n            }\r\n\r\n            &.icon-sm {\r\n                width: var(--icon-sm-size);\r\n                height: var(--icon-sm-size);\r\n                font-size: 1.5em;\r\n            }\r\n\r\n            &:nth-child(1) {\r\n                font-size: 42px;\r\n                color: theme-color(\"warning\");\r\n                z-index: 2;\r\n            }\r\n        }\r\n\r\n        i {\r\n            opacity: 1;\r\n\r\n            &:nth-child(1) {\r\n                left: 50%;\r\n                top: 50%;\r\n                font-size: 42px;\r\n                color: theme-color(\"warning\");\r\n            }\r\n\r\n            &:nth-child(2) {\r\n                left: calc(50% + (var(--gutter) * 1.7));\r\n                top: 50%;\r\n            }\r\n\r\n            &:nth-child(3) {\r\n                left: calc(50% + var(--gutter));\r\n                top: calc(50% + var(--gutter));\r\n            }\r\n\r\n            &:nth-child(4) {\r\n                left: calc(50% + var(--gutter));\r\n                top: calc(50% - var(--gutter));\r\n            }\r\n\r\n            &:nth-child(5) {\r\n                left: calc(50% + (var(--gutter) * 4));\r\n                top: 50%;\r\n            }\r\n\r\n            &:nth-child(6) {\r\n                left: calc(50% + (var(--gutter) * 2.7));\r\n                top: calc(50% + (var(--gutter) * 1.5));\r\n            }\r\n\r\n            &:nth-child(7) {\r\n                left: calc(50% + (var(--gutter) * 2.7));\r\n                top: calc(50% - (var(--gutter) * 1.5));\r\n            }\r\n\r\n            &:nth-child(8) {\r\n                left: calc(50% - (var(--gutter) * 1.7));\r\n                top: 50%;\r\n            }\r\n\r\n            &:nth-child(9) {\r\n                left: calc(50% - var(--gutter));\r\n                top: calc(50% + var(--gutter));\r\n            }\r\n\r\n            &:nth-child(10) {\r\n                left: calc(50% - var(--gutter));\r\n                top: calc(50% - var(--gutter));\r\n            }\r\n\r\n            &:nth-child(11) {\r\n                left: calc(50% - (var(--gutter) * 4));\r\n                top: 50%;\r\n            }\r\n\r\n            &:nth-child(12) {\r\n                left: calc(50% - (var(--gutter) * 2.7));\r\n                top: calc(50% + (var(--gutter) * 1.5));\r\n            }\r\n\r\n            &:nth-child(13) {\r\n                left: calc(50% - (var(--gutter) * 2.7));\r\n                top: calc(50% - (var(--gutter) * 1.5));\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n","//\r\n// Shortcut\r\n//\r\n\r\n.shortcuts {\r\n\r\n}\r\n\r\n.shortcut-media {\r\n    @include transition($transition-cubic-bezier);\r\n}\r\n\r\n.shortcut-item {\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n    text-align: center;\r\n\r\n    small {\r\n        display: block;\r\n        margin-top: .75rem;\r\n        font-size: $h5-font-size;\r\n        font-weight: $heading-font-weight;\r\n    }\r\n\r\n    &:hover {\r\n        .shortcut-media {\r\n            transform: scale(1.1);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Table\r\n//\r\n\r\n\r\n// General styles\r\n\r\n.table {\r\n    thead th {\r\n        padding-top: $table-head-spacer-y;\r\n        padding-bottom: $table-head-spacer-y;\r\n        font-size: $table-head-font-size;\r\n        text-transform: $table-head-text-transform;\r\n        letter-spacing: $table-head-letter-spacing;\r\n        border-bottom: $table-border-width solid $table-border-color;\r\n    }\r\n\r\n    th {\r\n        font-weight: $table-head-font-weight;\r\n    }\r\n\r\n    td {\r\n        .progress {\r\n            height: 3px;\r\n            width: 120px;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    td,\r\n    th {\r\n        font-size: $table-body-font-size;\r\n        white-space: nowrap;\r\n    }\r\n\r\n\r\n    // Vetical align table content\r\n\r\n    &.align-items-center {\r\n        td,\r\n        th {\r\n            vertical-align: middle;\r\n        }\r\n    }\r\n\r\n\r\n   // Styles for dark table\r\n\r\n   .thead-dark {\r\n        th {\r\n            background-color: $table-dark-head-bg;\r\n            color: $table-dark-head-color;\r\n\r\n            a {\r\n                color: $table-dark-head-color;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    // Styles for light table\r\n\r\n    .thead-light {\r\n        th {\r\n            background-color: $table-head-bg;\r\n            color: $table-head-color;\r\n\r\n            a {\r\n                color: $table-head-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Add transition for hover state\r\n\r\n.table-hover {\r\n    tr {\r\n        @include transition($transition-base);\r\n    }\r\n}\r\n\r\n\r\n// Flush tables\r\n\r\n.table-flush {\r\n    td,\r\n    th {\r\n        border-left: 0;\r\n        border-right: 0;\r\n    }\r\n\r\n    tbody {\r\n        tr {\r\n            &:first-child {\r\n                td,\r\n                th {\r\n                    border-top: 0;\r\n                }\r\n            }\r\n\r\n            &:last-child {\r\n                td,\r\n                th {\r\n                    border-bottom: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Tables inside cards\r\n\r\n.card {\r\n    .table {\r\n        margin-bottom: 0;\r\n\r\n        td,\r\n        th {\r\n            padding-left: $card-spacer-x;\r\n            padding-right: $card-spacer-x;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Fixes for custom elements inside tables\r\n\r\n.table {\r\n    .custom-toggle {\r\n        display: block;\r\n    }\r\n}\r\n","//\r\n// Table actions\r\n//\r\n\r\n.table-action {\r\n    font-size: $font-size-sm;\r\n    color: $table-action-color;\r\n    margin: 0 .25rem;\r\n\r\n    &:hover {\r\n        color: darken($table-action-color, 10%);\r\n    }\r\n}\r\n\r\n.table-action-delete {\r\n    &:hover {\r\n        color: theme-color(\"danger\");\r\n    }\r\n}\r\n\r\n.table-dark {\r\n    .table-action {\r\n        color: $table-dark-action-color;\r\n    }\r\n}\r\n","//\r\n// Sortable tables with list.js\r\n//\r\n\r\n.table  {\r\n    [data-sort] {\r\n        cursor: pointer;\r\n    }\r\n    \r\n    .thead-dark {\r\n        [data-sort] {\r\n            &::after {\r\n                content: str-replace(url(\"data:image/svg+xml;utf8,<svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z' fill='#{$table-dark-head-color}'/></svg>\"), \"#\", \"%23\");\r\n                margin-left: .25rem;\r\n            }\r\n        }\r\n    }\r\n\r\n    .thead-light {\r\n        [data-sort] {\r\n            &::after {\r\n                content: str-replace(url(\"data:image/svg+xml;utf8,<svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z' fill='#{$table-head-color}'/></svg>\"), \"#\", \"%23\");\r\n                margin-left: .25rem;\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Timeline\r\n//\r\n\r\n\r\n.timeline {\r\n    position: relative;\r\n\r\n    // Axis\r\n\r\n    &:before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: 1rem;\r\n        height: 100%;\r\n        border-right: $timeline-axis-width solid $timeline-axis-color;\r\n    }\r\n}\r\n\r\n// Axis style variations\r\n\r\n[data-timeline-axis-style=\"dashed\"] {\r\n    &:before {\r\n        border-right-style: dashed !important;\r\n    }\r\n}\r\n\r\n[data-timeline-axis-style=\"dotted\"] {\r\n    &:before {\r\n        border-right-style: dotted !important;\r\n    }\r\n}\r\n\r\n// Timeline blocks\r\n\r\n.timeline-block {\r\n    position: relative;\r\n    margin: 2em 0;\r\n\r\n    &:after {\r\n        content: \"\";\r\n        display: table;\r\n        clear: both;\r\n    }\r\n\r\n    &:first-child {\r\n        margin-top: 0;\r\n    }\r\n\r\n    &:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n// Timeline steps\r\n\r\n.timeline-step {\r\n    position: absolute;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    left: 0;\r\n    width: 33px;\r\n    height: 33px;\r\n    border-radius: 50%;\r\n    // background: $timeline-step-bg;\r\n    // border: $timeline-step-border-width solid $timeline-step-border-color;\r\n    text-align: center;\r\n    transform: translateX(-50%);\r\n    font-size: 1rem;\r\n    font-weight: $font-weight-bold;\r\n    z-index: 1;\r\n\r\n    svg, i {\r\n        line-height: 1.4;\r\n    }\r\n}\r\n\r\n.timeline-step-icon {\r\n    background: $white;\r\n    border: $timeline-step-border-width solid $timeline-step-border-color;\r\n}\r\n\r\n.timeline-step-xs {\r\n    width: 17px;\r\n    height: 17px;\r\n    font-size: .75rem;\r\n}\r\n\r\n.timeline-step-sm {\r\n    width: 23px;\r\n    height: 23px;\r\n    font-size: .75rem;\r\n}\r\n\r\n.timeline-step-lg {\r\n    width: 47px;\r\n    height: 47px;\r\n    font-size: 1.75rem;\r\n}\r\n\r\n// Timeline content and body\r\n.timeline-content {\r\n    position: relative;\r\n    margin-left: 60px;\r\n    padding-top: .5rem;\r\n    position: relative;\r\n    top: -6px;\r\n\r\n    &:after {\r\n        content: \"\";\r\n        display: table;\r\n        clear: both;\r\n    }\r\n}\r\n\r\n.timeline-body {\r\n    padding: 1.5rem;\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n    .timeline {\r\n        &:before {\r\n            left: 50%;\r\n            margin-left: -2px;\r\n        }\r\n    }\r\n\r\n    .timeline-step {\r\n        left: 50%;\r\n    }\r\n\r\n    .timeline-content {\r\n\r\n        width: 38%;\r\n    }\r\n\r\n    .timeline-body {\r\n        padding: 1.5rem;\r\n    }\r\n\r\n    .timeline-block:nth-child(even) .timeline-content {\r\n        float: right;\r\n    }\r\n\r\n    // Timeline axis colors\r\n\r\n    @each $color, $value in $theme-colors {\r\n        [data-timeline-axis-color=\"#{$color}\"]  {\r\n            &:before {\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// One side timeline\r\n\r\n.timeline-one-side {\r\n    &:before {\r\n        left: 1rem;\r\n    }\r\n\r\n    .timeline-step {\r\n        left: 1rem;\r\n    }\r\n\r\n    .timeline-content {\r\n        width: auto;\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        .timeline-content {\r\n            max-width: 30rem;\r\n        }\r\n    }\r\n}\r\n\r\n.timeline-one-side .timeline-block:nth-child(even) .timeline-content {\r\n    float: none;\r\n}\r\n","//\r\n// Type\r\n//\r\n\r\n\r\n// Paragraphs\r\n\r\np {\r\n\tfont-size: $paragraph-font-size;\r\n\tfont-weight: $paragraph-font-weight;\r\n\tline-height: $paragraph-line-height;\r\n}\r\n\r\n.lead {\r\n\tfont-size: $lead-font-size;\r\n  \tfont-weight: $lead-font-weight;\r\n\tline-height: $paragraph-line-height;\r\n\tmargin-top: 1.5rem;\r\n\r\n\t+ .btn-wrapper {\r\n\t\tmargin-top: 3rem;\r\n\t}\r\n}\r\n\r\n.description {\r\n\tfont-size: $font-size-sm;\r\n}\r\n","//\r\n// Article\r\n// \r\n\r\narticle {\r\n\th4:not(:first-child),\r\n\th5:not(:first-child) {\r\n\t\tmargin-top: 3rem;\r\n\t}\r\n\r\n\th4, h5 {\r\n\t\tmargin-bottom: 1.5rem;\r\n\t}\r\n\r\n\tfigure {\r\n\t\tmargin: 3rem 0;\r\n\t}\r\n\r\n\th5 + figure {\r\n\t\tmargin-top: 0;\r\n\t}\r\n}\r\n","//\r\n// Display\r\n//\r\n\r\n\r\n.display-1,\r\n.display-2,\r\n.display-3,\r\n.display-4 {\r\n\tspan {\r\n\t\tdisplay: block;\r\n\t\tfont-weight: $font-weight-light;\r\n\t}\r\n}\r\n","//\r\n// Heading\r\n//\r\n\r\n\r\n// General styles\r\n\r\nh1>a, h2>a, h3>a, h4>a, h5>a, h6>a {\r\n\tcolor: inherit;\r\n}\r\n\r\n.heading {\r\n\tletter-spacing: $heading-letter-spacing;\r\n\tfont-size: $heading-font-size;\r\n\ttext-transform: $heading-text-transform;\r\n\tfont-weight: $heading-font-weight;\r\n}\r\n\r\n\r\n// Heading variations\r\n\r\n.heading-small {\r\n\tpadding-top: .25rem;\r\n\tpadding-bottom: .25rem;\r\n\tfont-size: .75rem;\r\n\ttext-transform: uppercase;\r\n\tletter-spacing: .04em;\r\n}\r\n\r\n.heading-title {\r\n\tletter-spacing: $heading-title-letter-spacing;\r\n\tfont-size: $heading-title-font-size;\r\n\tfont-weight: $heading-title-font-weight;\r\n\ttext-transform: $heading-title-text-transform;\r\n}\r\n\r\n.heading-section {\r\n\tletter-spacing: $heading-section-letter-spacing;\r\n\tfont-size: $heading-section-font-size;\r\n\tfont-weight: $heading-section-font-weight;\r\n\ttext-transform: $heading-section-text-transform;\r\n\r\n\timg {\r\n\t\tdisplay: block;\r\n\t\twidth: 72px;\r\n\t\theight: 72px;\r\n\t\tmargin-bottom: 1.5rem;\r\n\t}\r\n\r\n\t&.text-center {\r\n\t\timg {\r\n\t\t\tmargin-left: auto;\r\n\t\t\tmargin-right: auto;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Surtitles\r\n\r\n.surtitle {\r\n\ttext-transform: uppercase;\r\n\tcolor: $gray-600;\r\n\tletter-spacing: 2px;\r\n\tmargin-bottom: 0;\r\n}\r\n","//\r\n// Backgrounds\r\n//\r\n\r\n\r\n@each $color, $value in $colors {\r\n\t@include bg-variant(\".bg-#{$color}\", $value);\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n}\r\n\r\n@each $color, $value in $colors {\r\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n}\r\n\r\n\r\n// Background colors with transparency\r\n\r\n@each $color, $value in $theme-colors {\r\n    @include bg-translucent-variant(\".bg-translucent-#{$color}\", $value);\r\n}\r\n\r\n\r\n// Sections backgrounds\r\n\r\n@each $color, $value in $section-colors {\r\n    @include bg-variant(\".section-#{$color}\", $value);\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n}\r\n\r\n\r\n// Shape (svg) fill colors\r\n\r\n@each $color, $value in $theme-colors {\r\n    .fill-#{$color}  {\r\n        fill: $value;\r\n    }\r\n\r\n    .stroke-#{$color}  {\r\n        stroke: $value;\r\n    }\r\n}\r\n\r\n.fill-opacity-8 {\r\n\tfill-opacity: .8;\r\n}\r\n","//\r\n// Blurable\r\n// add a blue effect on hover on any element with .blur--hover class\r\n//\r\n\r\n.blur--hover {\r\n    position: relative;\r\n\r\n    .blur-item {\r\n        transition: 1s cubic-bezier(.19,1,.22,1);\r\n        will-change: transform;\r\n        filter: blur(0);\r\n        opacity: 1;\r\n    }\r\n\r\n    .blur-hidden {\r\n        position: absolute;\r\n        top: calc(50% + 7px);\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n        opacity: 0;\r\n        transition: $transition-base;\r\n        z-index: 100;\r\n    }\r\n    &:hover {\r\n        .blur-item {\r\n            opacity: .8;\r\n            filter: blur(10px);\r\n            transform: scale(.95);\r\n            z-index: 1;\r\n        }\r\n        .blur-hidden {\r\n            opacity: 1;\r\n            top: 50%;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Floating\r\n// floating animation utility class\r\n//\r\n\r\n\r\n.floating {\r\n\tanimation: floating 3s ease infinite;\r\n\twill-change: transform;\r\n\r\n\t&:hover {\r\n        animation-play-state: paused;\r\n    }\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.floating-lg {\r\n\tanimation: floating-lg 3s ease infinite;\r\n}\r\n\r\n.floating-sm {\r\n\tanimation: floating-sm 3s ease infinite;\r\n}\r\n\r\n\r\n// Keyframes\r\n\r\n@keyframes floating-lg {\r\n    0% {\r\n        transform: translateY(0px)\r\n    }\r\n    50% {\r\n        transform: translateY(15px)\r\n    }\r\n    100% {\r\n        transform: translateY(0px)\r\n    }\r\n}\r\n\r\n@keyframes floating {\r\n    0% {\r\n        transform: translateY(0px)\r\n    }\r\n    50% {\r\n        transform: translateY(10px)\r\n    }\r\n    100% {\r\n        transform: translateY(0px)\r\n    }\r\n}\r\n\r\n@keyframes floating-sm {\r\n    0% {\r\n        transform: translateY(0px)\r\n    }\r\n    50% {\r\n        transform: translateY(5px)\r\n    }\r\n    100% {\r\n        transform: translateY(0px)\r\n    }\r\n}\r\n","//\r\n// Helper\r\n// helper classes for different cases\r\n//\r\n\r\n\r\n// Clearfix for sections that use float property\r\n\r\n.floatfix {\r\n    &:before,\r\n    &:after {\r\n        content: '';\r\n        display: table;\r\n    }\r\n    &:after {\r\n        clear: both;\r\n    }\r\n}\r\n","//\r\n// Image\r\n//\r\n\r\n.img-center {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n","//\r\n// Opacity\r\n// modify the transparency of an element with this quick modifier classes\r\n//\r\n\r\n.opacity-1 {\r\n    opacity: .1 !important;\r\n}\r\n.opacity-2 {\r\n    opacity: .2 !important;\r\n}\r\n.opacity-3 {\r\n    opacity: .3 !important;\r\n}\r\n.opacity-4 {\r\n    opacity: .4 !important;\r\n}\r\n.opacity-5 {\r\n    opacity: .5 !important;\r\n}\r\n.opacity-6 {\r\n    opacity: .6 !important;\r\n}\r\n.opacity-7 {\r\n    opacity: .7 !important;\r\n}\r\n.opacity-8 {\r\n    opacity: .8 !important;\r\n}\r\n.opacity-8 {\r\n    opacity: .9 !important;\r\n}\r\n.opacity-10 {\r\n    opacity: 1 !important;\r\n}\r\n","//\r\n// Overflow\r\n//\r\n\r\n.overflow-visible {\r\n    overflow: visible !important;\r\n}\r\n\r\n.overflow-hidden {\r\n    overflow: hidden !important;\r\n}\r\n","//\r\n// Position\r\n// modifier classes to be applied on an abosolute positioned element\r\n// use it next to .position-absolute class\r\n//\r\n\r\n@each $size, $value in $spacers {\r\n\t.top-#{$size} {\r\n\t\ttop: $value;\r\n\t}\r\n\t.right-#{$size} {\r\n\t\tright: $value;\r\n\t}\r\n\t.bottom-#{$size} {\r\n\t\tbottom: $value;\r\n\t}\r\n\t.left-#{$size} {\r\n\t\tleft: $value;\r\n\t}\r\n}\r\n\r\n.center {\r\n\tleft: 50%;\r\n\ttransform: translateX(-50%);\r\n}\r\n","//\r\n// Shadows\r\n//\r\n\r\n// General styles\r\n[class*=\"shadow\"] {\r\n\t@if $enable-transitions {\r\n        transition: $transition-base;\r\n    }\r\n}\r\n\r\n\r\n// Size variations\r\n.shadow-sm--hover:hover {\r\n\tbox-shadow: $box-shadow-sm !important;\r\n}\r\n\r\n.shadow--hover:hover {\r\n\tbox-shadow: $box-shadow !important;\r\n}\r\n\r\n.shadow-lg--hover:hover {\r\n\tbox-shadow: $box-shadow-lg !important;\r\n}\r\n\r\n.shadow-none--hover:hover {\r\n\tbox-shadow: none !important;\r\n}\r\n","//\r\n// Height\r\n//\r\n\r\n.h-100vh {\r\n\theight: 100vh !important;\r\n}\r\n","//\r\n// Spacing\r\n//\r\n\r\n.row.row-grid > [class*=\"col-\"] + [class*=\"col-\"] {\r\n    margin-top: 3rem;\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n    .row.row-grid > [class*=\"col-lg-\"] + [class*=\"col-lg-\"] {\r\n        margin-top: 0;\r\n    }\r\n}\r\n@include media-breakpoint-up(md) {\r\n    .row.row-grid > [class*=\"col-md-\"] + [class*=\"col-md-\"] {\r\n        margin-top: 0;\r\n    }\r\n}\r\n@include media-breakpoint-up(sm) {\r\n    .row.row-grid > [class*=\"col-sm-\"] + [class*=\"col-sm-\"] {\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n.row-grid + .row-grid {\r\n    margin-top: 3rem;\r\n}\r\n\r\n\r\n// Negative margins and paddings\r\n\r\n@media(min-width: 992px) {\r\n    [class*=\"mt--\"],\r\n    [class*=\"mr--\"],\r\n    [class*=\"mb--\"],\r\n    [class*=\"ml--\"] {\r\n        \r\n    }\r\n\r\n\r\n    // Large negative margins in pixels\r\n\r\n    .mt--100 {\r\n        margin-top: -100px !important;\r\n    }\r\n    .mr--100 {\r\n        margin-right: -100px !important;\r\n    }\r\n    .mb--100 {\r\n        margin-bottom: -100px !important;\r\n    }\r\n    .ml--100 {\r\n        margin-left: -100px !important;\r\n    }\r\n    .mt--150 {\r\n        margin-top: -150px !important;\r\n    }\r\n    .mb--150 {\r\n        margin-bottom: -150px !important;\r\n    }\r\n    .mt--200 {\r\n        margin-top: -200px !important;\r\n    }\r\n    .mb--200 {\r\n        margin-bottom: -200px !important;\r\n    }\r\n    .mt--300 {\r\n        margin-top: -300px !important;\r\n    }\r\n    .mb--300 {\r\n        margin-bottom: -300px !important;\r\n    }\r\n\r\n\r\n    // Large margins in pixels\r\n\r\n    .pt-100 {\r\n        padding-top: 100px !important;\r\n    }\r\n    .pb-100 {\r\n        padding-bottom: 100px !important;\r\n    }\r\n    .pt-150 {\r\n        padding-top: 150px !important;\r\n    }\r\n    .pb-150 {\r\n        padding-bottom: 150px !important;\r\n    }\r\n    .pt-200 {\r\n        padding-top: 200px !important;\r\n    }\r\n    .pb-200 {\r\n        padding-bottom: 200px !important;\r\n    }\r\n    .pt-250 {\r\n        padding-top: 250px !important;\r\n    }\r\n    .pb-250 {\r\n        padding-bottom: 250px !important;\r\n    }\r\n    .pt-300 {\r\n        padding-top: 300px!important;\r\n    }\r\n    .pb-300 {\r\n        padding-bottom: 300px!important;\r\n    }\r\n}\r\n","// Weight and italics\r\n\r\n.font-weight-300 { font-weight: 300 !important; }\r\n.font-weight-400 { font-weight: 400 !important; }\r\n.font-weight-500 { font-weight: 500 !important; }\r\n.font-weight-600 { font-weight: 600 !important; }\r\n.font-weight-700 { font-weight: 700 !important; }\r\n.font-weight-800 { font-weight: 800 !important; }\r\n.font-weight-900 { font-weight: 900 !important; }\r\n\r\n\r\n// Text decorations\r\n\r\n.text-underline { text-decoration: underline; }\r\n.text-through { text-decoration: line-through; }\r\n\r\n\r\n// Text size\r\n\r\n.text-xs { font-size: $font-size-xs !important; }\r\n.text-sm { font-size: $font-size-sm !important; }\r\n.text-lg { font-size: $font-size-lg !important; }\r\n.text-xl { font-size: $font-size-xl !important; }\r\n\r\n\r\n// Line heights\r\n\r\n.lh-100 { line-height: 1; }\r\n.lh-110 { line-height: 1.1; }\r\n.lh-120 { line-height: 1.2; }\r\n.lh-130 { line-height: 1.3; }\r\n.lh-140 { line-height: 1.4; }\r\n.lh-150 { line-height: 1.5; }\r\n.lh-160 { line-height: 1.6; }\r\n.lh-170 { line-height: 1.7; }\r\n.lh-180 { line-height: 1.8; }\r\n\r\n\r\n// Letter spacings\r\n\r\n.ls-1 { letter-spacing: .0625rem; }\r\n.ls-15 { letter-spacing: .09375rem; }\r\n.ls-2 { letter-spacing: 0.125rem; }\r\n\r\n// Color variations\r\n\r\n@each $color, $value in $colors {\r\n\t@include text-emphasis-variant(\".text-#{$color}\", $value, $ignore-warning: true);\r\n}\r\n","//\r\n// Tranform\r\n//\r\n\r\n\r\n@include media-breakpoint-up(lg) {\r\n\t.transform-perspective-right {\r\n\t\ttransform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\r\n\t}\r\n\t.transform-perspective-left{\r\n\t\ttransform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg)\r\n\t}\r\n}\r\n","//\r\n// Bootstrap datepicker\r\n//\r\n\r\n\r\n.datepicker {\r\n    border-radius: $datepicker-border-radius;\r\n\r\n    &-inline {\r\n        width: 220px;\r\n    }\r\n\r\n    direction: ltr;\r\n\r\n    &-rtl {\r\n        direction: rtl;\r\n        &.dropdown-menu {\r\n            left: auto;\r\n        }\r\n        table tr td span {\r\n            float: right;\r\n        }\r\n    }\r\n\r\n    &-dropdown {\r\n        top: 0;\r\n        left: 0;\r\n        padding: $datepicker-dropdown-padding;\r\n        @include box-shadow($dropdown-box-shadow);\r\n\r\n        &.datepicker-orient-left:before {\r\n            left: 6px;\r\n        }\r\n        &.datepicker-orient-left:after {\r\n            left: 7px;\r\n        }\r\n        &.datepicker-orient-right:before {\r\n            right: 6px;\r\n        }\r\n        &.datepicker-orient-right:after {\r\n            right: 7px;\r\n        }\r\n        &.datepicker-orient-bottom:before {\r\n            top: -7px;\r\n        }\r\n        &.datepicker-orient-bottom:after {\r\n            top: -6px;\r\n        }\r\n\r\n        &.datepicker-orient-top:before {\r\n            bottom: -7px;\r\n            border-bottom: 0;\r\n            border-top: 7px solid $datepicker-dropdown-border;\r\n        }\r\n\r\n        &.datepicker-orient-top:after {\r\n            bottom: -6px;\r\n            border-bottom: 0;\r\n            border-top: 6px solid $datepicker-dropdown-bg;\r\n        }\r\n    }\r\n\r\n    table {\r\n        margin: 0;\r\n        -webkit-touch-callout: none;\r\n        user-select: none;\r\n\r\n        tr {\r\n            td {\r\n                border-radius: $datepicker-cell-border-radius;\r\n            }\r\n\r\n            th {\r\n                border-radius: $datepicker-header-cell-border-radius;\r\n                font-weight: 500;\r\n            }\r\n\r\n            td,\r\n            th {\r\n                transition: $datepicker-cell-transition;\r\n                width: $datepicker-cell-width;\r\n                height: $datepicker-cell-height;\r\n                border: none;\r\n                text-align: center;\r\n                font-size: $font-size-sm;\r\n            }\r\n        }\r\n    }\r\n\r\n    // Inline display inside a table presents some problems with\r\n    // border and background colors.\r\n    .table-striped & table tr {\r\n        td,\r\n        th {\r\n            background-color: transparent;\r\n        }\r\n    }\r\n\r\n    table tr td {\r\n        &.old,\r\n        &.new {\r\n            color: $datepicker-disabled-old-new-color;\r\n        }\r\n\r\n        &.day:hover,\r\n        &.focused {\r\n            background: $datepicker-cell-hover-background;\r\n            cursor: pointer;\r\n        }\r\n\r\n        &.disabled,\r\n        &.disabled:hover {\r\n            background: none;\r\n            color: $datepicker-disabled-cell-color;\r\n            cursor: default;\r\n        }\r\n\r\n        &.highlighted {\r\n            border-radius: 0;\r\n\r\n            &.focused {\r\n                background: $datepicker-highlighted-bg\r\n            }\r\n\r\n            &.disabled,\r\n            &.disabled:active {\r\n                background: $datepicker-highlighted-bg;\r\n                color: $gray-400;\r\n            }\r\n        }\r\n\r\n        &.today {\r\n            background: lighten($datepicker-active-background, 45%);\r\n            &.focused {\r\n                background: lighten($gray-400, 58%);\r\n            }\r\n\r\n            &.disabled,\r\n            &.disabled:active {\r\n                background: lighten($gray-400, 58%);\r\n                color: $btn-link-disabled-color;\r\n            }\r\n        }\r\n\r\n        // Range selection\r\n        &.range {\r\n            background: $datepicker-range-background;\r\n            color: $datepicker-range-color;\r\n            border-radius: 0;\r\n\r\n            &.focused {\r\n                background: darken($datepicker-range-cell-focused-background, 3%);\r\n            }\r\n\r\n            &.disabled,\r\n            &.disabled:active,\r\n            &.day.disabled:hover {\r\n                background: darken($datepicker-active-background, 10%);\r\n                color: lighten($datepicker-active-background, 10%);\r\n            }\r\n        }\r\n\r\n        &.range.highlighted {\r\n            &.focused {\r\n                background: darken($datepicker-range-highlighted-bg, 10%);\r\n            }\r\n\r\n            &.disabled,\r\n            &.disabled:active {\r\n                background: $datepicker-range-highlighted-bg;\r\n                color: $datepicker-disabled-cell-color;\r\n            }\r\n        }\r\n\r\n        &.range.today {\r\n            &.disabled,\r\n            &.disabled:active {\r\n                background: $blue;\r\n                color: $white;\r\n            }\r\n        }\r\n\r\n        &.day.range-start {\r\n            border-top-right-radius: 0;\r\n            border-bottom-right-radius: 0;\r\n        }\r\n\r\n        &.day.range-end {\r\n            border-top-left-radius: 0;\r\n            border-bottom-left-radius: 0;\r\n        }\r\n\r\n        &.day.range-start.range-end {\r\n            border-radius: $datepicker-cell-border-radius;\r\n        }\r\n\r\n        &.selected,\r\n        &.selected.highlighted,\r\n        &.selected:hover,\r\n        &.selected.highlighted:hover,\r\n        &.day.range:hover {\r\n            background: $datepicker-active-background;\r\n            color: $datepicker-active-color;\r\n        }\r\n\r\n        &.active,\r\n        &.active.highlighted,\r\n        &.active:hover,\r\n        &.active.highlighted:hover {\r\n            background: $datepicker-active-background;\r\n            color: $datepicker-active-color;\r\n            box-shadow: $datepicker-active-box-shadow;\r\n        }\r\n\r\n        span {\r\n            display: block;\r\n            width: 23%;\r\n            height: 54px;\r\n            line-height: 54px;\r\n            float: left;\r\n            margin: 1%;\r\n            cursor: pointer;\r\n            border-radius: 4px;\r\n\r\n            &:hover,\r\n            &.focused {\r\n                background: $gray-200;\r\n            }\r\n\r\n            &.disabled,\r\n            &.disabled:hover {\r\n                background: none;\r\n                color: $datepicker-disabled-cell-color;\r\n                cursor: default;\r\n            }\r\n\r\n            &.active,\r\n            &.active:hover,\r\n            &.active.disabled,\r\n            &.active.disabled:hover {\r\n                text-shadow: 0 -1px 0 rgba(0, 0, 0, .25);\r\n            }\r\n\r\n            &.old,\r\n            &.new {\r\n                color: $btn-link-disabled-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    .datepicker-switch {\r\n        width: 145px;\r\n    }\r\n\r\n    .datepicker-switch,\r\n    .prev,\r\n    .next,\r\n    tfoot tr th {\r\n        cursor: pointer;\r\n        &:hover {\r\n            background: $gray-200;\r\n        }\r\n    }\r\n\r\n    .prev,\r\n    .next {\r\n        &.disabled {\r\n            visibility: hidden;\r\n        }\r\n    }\r\n\r\n    // Basic styling for calendar-week cells\r\n    .cw {\r\n        font-size: 10px;\r\n        width: 12px;\r\n        padding: 0 2px 0 5px;\r\n        vertical-align: middle;\r\n    }\r\n}\r\n","//\r\n// Bootstrap tags input\r\n//\r\n\r\n\r\n.bootstrap-tagsinput {\r\n    background-color: $input-bg;\r\n    border: $tags-input-border-width solid $tags-input-border-color;\r\n    display: inline-block;\r\n    padding: .25rem;\r\n    color: $tags-input-color;\r\n    vertical-align: middle;\r\n    border-radius: $input-border-radius;\r\n    max-width: 100%;\r\n    cursor: text;\r\n\r\n    input {\r\n        border: none;\r\n        box-shadow: none;\r\n        outline: none;\r\n        background-color: transparent;\r\n        padding: 0 6px;\r\n        margin: 0;\r\n        width: auto;\r\n        max-width: inherit;\r\n\r\n        &::placeholder {\r\n            color: $input-placeholder-color;\r\n            opacity: 1;\r\n        }\r\n\r\n        &:focus {\r\n            border: none;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n\r\n    .badge {\r\n        position: relative;\r\n        padding: .625rem .625rem .5rem;\r\n        margin: .125rem;\r\n        border-radius: $input-border-radius;\r\n        background: $tag-bg;\r\n        color: $tag-color;\r\n        line-height: 1.5;\r\n        @include box-shadow($tag-box-shadow);\r\n        @include transition($transition-base);\r\n\r\n        &:hover {\r\n            padding-right: 1.5rem;\r\n        }\r\n    }\r\n\r\n    [data-role=\"remove\"] {\r\n        margin-left: 10px;\r\n        cursor: pointer;\r\n        color: $tag-close-color;\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translate(0, -50%);\r\n\r\n        &:after {\r\n            content: \"×\";\r\n            font-size: 16px;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Chart.js\r\n//\r\n\r\n\r\n#chartjs-tooltip {\r\n\topacity: 1;\r\n\tposition: absolute;\r\n\tbackground: rgba(0, 0, 0, .7);\r\n\tcolor: white;\r\n\tborder-radius: 3px;\r\n\ttransition: all .1s ease;\r\n\tpointer-events: none;\r\n\ttransform: translate(-50%, 0);\r\n}\r\n\r\n.chartjs-tooltip-key {\r\n\tdisplay: inline-block;\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tmargin-right: 10px;\r\n}\r\n","//\r\n// Datatables\r\n//\r\n\r\n.dataTables_wrapper {\r\n    font-size: $font-size-sm;\r\n}\r\n\r\ntable.dataTable {\r\n    margin-bottom: $card-spacer-y !important;\r\n    border-bottom: 1px solid $table-border-color;\r\n\r\n    tbody {\r\n        > tr.selected {\r\n            background-color: theme-color(\"primary\");\r\n        }\r\n    }\r\n}\r\n\r\n.dataTables_length,\r\n.dataTables_info,\r\n.dt-buttons {\r\n    padding-left: $card-spacer-x;\r\n}\r\n\r\n.dataTables_length {\r\n    .form-control {\r\n        margin: 0 .375rem;\r\n    }\r\n}\r\n\r\n.dataTables_filter {\r\n    padding-right: $card-spacer-x;\r\n    display: inline-block;\r\n    float: right;\r\n}\r\n\r\n.dataTables_paginate {\r\n    padding-right: $card-spacer-x;\r\n}\r\n","//\r\n// Dropzone\r\n//\r\n\r\n.dropzone {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.dz-message {\r\n    padding: 5rem 1rem;\r\n    background-color: $input-bg;\r\n    border: $input-border-width dashed $input-border-color;\r\n    border-radius: $border-radius;\r\n    text-align: center;\r\n    color: $text-muted;\r\n    transition: $transition-base;\r\n    order: -1;\r\n    cursor: pointer;\r\n    z-index: 999;\r\n\r\n    &:hover {\r\n        border-color: $text-muted;\r\n        color: $body-color;\r\n    }\r\n}\r\n\r\n.dz-drag-hover .dz-message {\r\n    border-color: theme-color(\"primary\");\r\n    color: theme-color(\"primary\");\r\n}\r\n\r\n.dropzone-multiple .dz-message {\r\n    padding-top: 2rem;\r\n    padding-bottom: 2rem;\r\n}\r\n\r\n.dropzone-single.dz-max-files-reached .dz-message {\r\n    background-color: fade-out($black, .1);\r\n    color: white;\r\n    opacity: 0;\r\n\r\n    &:hover {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.dz-preview-single {\r\n    position: absolute;\r\n    top: 0; right: 0; bottom: 0; left: 0;\r\n    border-radius: $border-radius;\r\n}\r\n\r\n.dz-preview-cover {\r\n    position: absolute;\r\n    top: 0; right: 0; bottom: 0; left: 0;\r\n    border-radius: $border-radius;\r\n}\r\n\r\n.dz-preview-img {\r\n    object-fit: cover;\r\n    width: 100%; height: 100%;\r\n    border-radius: $border-radius;\r\n}\r\n\r\n.dz-preview-multiple .list-group-item:last-child {\r\n    padding-bottom: 0;\r\n    border-bottom: 0;\r\n}\r\n\r\n[data-dz-size] strong {\r\n    font-weight: $font-weight-normal;\r\n}\r\n","//\r\n// Full Calendar\r\n//\r\n\r\n\r\n.fc-header-toolbar {\r\n    display: none;\r\n}\r\n\r\n.fc-scroller {\r\n    height: auto !important;\r\n}\r\n\r\n.fc {\r\n    th {\r\n        padding: $table-head-spacer-y $table-head-spacer-x;\r\n        font-size: $font-size-xs;\r\n        font-weight: $table-head-font-weight;\r\n        color: $table-head-color;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n\r\n\r\n    div.fc-row {\r\n        margin-right: 0;\r\n        border: 0;\r\n    }\r\n\r\n    button {\r\n        .fc-icon {\r\n            top: -5px;\r\n        }\r\n    }\r\n}\r\n\r\n.fc-unthemed {\r\n    td.fc-today {\r\n        background-color: transparent;\r\n\r\n        span {\r\n            color: $orange;\r\n        }\r\n    }\r\n}\r\n\r\n.fc-event {\r\n    padding: 0;\r\n    font-size: $font-size-xs;\r\n    border-radius: $border-radius-sm;\r\n    border: 0;\r\n\r\n    .fc-title {\r\n        padding: .4rem .5rem;\r\n        display: block;\r\n        color: $white;\r\n        @include text-truncate();\r\n        font-weight: $font-weight-bold;\r\n    }\r\n\r\n    .fc-time {\r\n        float: left;\r\n        background: rgba($black,0.2);\r\n        padding: 2px 6px;\r\n        margin: 0 0 0 -1px;\r\n    }\r\n}\r\n\r\n.fc-view {\r\n    &, & > table {\r\n        border: 0;\r\n        overflow: hidden;\r\n    }\r\n    & > table {\r\n        & > tbody {\r\n            & > tr {\r\n                .ui-widget-content {\r\n                    border-top: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fc-body {\r\n    border: 0;\r\n}\r\n\r\n.fc-icon {\r\n    font-family: $icon-font-family;\r\n    font-size: $font-size-base;\r\n    width: 35px;\r\n    height: 35px;\r\n    border-radius: 50%;\r\n    line-height: 35px;\r\n\r\n    &:hover {\r\n        color: theme-color(\"primary\");\r\n    }\r\n}\r\n\r\n.fc-button {\r\n    border: 0;\r\n    background: transparent;\r\n    box-shadow: none;\r\n\r\n    &:focus,\r\n    &:active {\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n\r\n// Main Calendar\r\n\r\n.calendar {\r\n    z-index: 0;\r\n    td, th {\r\n        border-color: lighten($table-border-color,2%);\r\n    }\r\n\r\n    .fc-toolbar {\r\n        height: 250px;\r\n        background-color: $white;\r\n        border-radius: $border-radius $border-radius 0 0;\r\n        position: relative;\r\n        margin-bottom: -2px;\r\n        z-index: 2;\r\n        @include media-breakpoint-down(xs) {\r\n            height: 135px;\r\n        }\r\n    }\r\n\r\n    .fc-day-number {\r\n        padding: .5rem 1rem;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n        @include media-breakpoint-up(sm) {\r\n            font-size: $font-size-sm;\r\n            font-weight: $font-weight-bold;\r\n            color: lighten($body-color,10%);\r\n        }\r\n    }\r\n    .fc-day-header {\r\n        text-align: left;\r\n    }\r\n    .fc-day-grid-event {\r\n        margin: 1px 9px;\r\n    }\r\n}\r\n\r\n\r\n// Main Calendar Seasonal headers\r\n\r\n[data-calendar-month] {\r\n    background-size: contain;\r\n    @include transition(background-image 300ms);\r\n}\r\n\r\n// [data-calendar-month=\"0\"] {\r\n//     background-image: url('../img/calendar/january.jpg');\r\n// }\r\n// [data-calendar-month=\"1\"] {\r\n//     background-image: url('../img/calendar/february.jpg');\r\n// }\r\n// [data-calendar-month=\"2\"] {\r\n//     background-image: url('../img/calendar/march.jpg');\r\n// }\r\n// [data-calendar-month=\"3\"] {\r\n//     background-image: url('../img/calendar/april.jpg');\r\n// }\r\n// [data-calendar-month=\"4\"] {\r\n//     background-image: url('../img/calendar/may.jpg');\r\n// }\r\n// [data-calendar-month=\"5\"] {\r\n//     background-image: url('../img/calendar/june.jpg');\r\n// }\r\n// [data-calendar-month=\"6\"] {\r\n//     background-image: url('../img/calendar/july.jpg');\r\n// }\r\n// [data-calendar-month=\"7\"] {\r\n//     background-image: url('../img/calendar/august.jpg');\r\n// }\r\n// [data-calendar-month=\"8\"] {\r\n//     background-image: url('../img/calendar/september.jpg');\r\n// }\r\n// [data-calendar-month=\"9\"] {\r\n//     background-image: url('../img/calendar/october.jpg');\r\n// }\r\n// [data-calendar-month=\"10\"] {\r\n//     background-image: url('../img/calendar/november.jpg');\r\n// }\r\n// [data-calendar-month=\"11\"] {\r\n//     background-image: url('../img/calendar/december.jpg');\r\n// }\r\n\r\n\r\n// Calendar used inside a card\r\n\r\n.card-calendar {\r\n    .card-header {\r\n        border-bottom: 0;\r\n    }\r\n\r\n    table {\r\n        background: transparent;\r\n        tr {\r\n            & > td {\r\n                &:first-child {\r\n                    border-left-width: 0;\r\n                }\r\n                &:last-child {\r\n                    border-right-width: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Widget\r\n\r\n.widget-calendar {\r\n    position: relative;\r\n    z-index: 0;\r\n\r\n    td, th {\r\n        border-color: transparent;\r\n        text-align: center;\r\n    }\r\n\r\n    .fc-toolbar {\r\n        margin-top: 1.25rem;\r\n\r\n        h2 {\r\n            font-size: $font-size-base;\r\n        }\r\n    }\r\n\r\n    .fc-day-number {\r\n        text-align: center;\r\n        width: 100%;\r\n        padding: 0;\r\n    }\r\n\r\n    .fc {\r\n        table {\r\n            font-size: $font-size-sm;\r\n        }\r\n        th {\r\n            padding: .75rem .5rem;\r\n            font-size: $font-size-xs;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Jvector Map\r\n//\r\n\r\n\r\n.vector-map {\r\n    position: relative;\r\n    height: 600px;\r\n}\r\n\r\n\r\n// Size variations\r\n\r\n.vector-map-sm {\r\n    height: 280px; \r\n}\r\n\r\n\r\n// Vendor overrides\r\n\r\n.jvectormap-container {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.jvectormap-zoomin,\r\n.jvectormap-zoomout {\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n}\r\n\r\n.jvectormap-zoomin {\r\n    bottom: 4.25rem;\r\n}\r\n\r\n.jvectormap-zoomout {\r\n    bottom: 2rem;\r\n}\r\n","//\r\n// Lavalamp\r\n//\r\n\r\n\r\n/*!\r\n * Lavalamp\r\n * http://lavalamp.magicmediamuse.com/\r\n */\r\n\r\n.lavalamp {\r\n\tposition: relative;\r\n}\r\n.lavalamp-item {\r\n\tz-index: 5;\r\n\tposition: relative;\r\n}\r\n.lavalamp-object {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n}\r\n\r\n/* Custom easing transitions */\r\n\r\n.lavalamp .lavalamp-object {\r\n\ttransition-property:transform, width, height;\r\n}\r\n.lavalamp .lavalamp-object.ease {\r\n\ttransition-timing-function: ease;\r\n}\r\n.lavalamp .lavalamp-object.ease-in {\r\n\ttransition-timing-function: ease-in;\r\n}\r\n.lavalamp .lavalamp-object.ease-out {\r\n\ttransition-timing-function: ease-out;\r\n}\r\n.lavalamp .lavalamp-object.ease-in-out {\r\n\ttransition-timing-function: ease-in-out;\r\n}\r\n.lavalamp .lavalamp-object.linear {\r\n\ttransition-timing-function: linear;\r\n}\r\n.lavalamp .lavalamp-object.easeInQuad {\r\n\ttransition-timing-function: cubic-bezier(0.550, 0.085, 0.680, 0.530);\r\n}\r\n.lavalamp .lavalamp-object.easeInCubic {\r\n\ttransition-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\r\n}\r\n.lavalamp .lavalamp-object.easeInQuart {\r\n\ttransition-timing-function: cubic-bezier(0.895, 0.030, 0.685, 0.220);\r\n}\r\n.lavalamp .lavalamp-object.easeInQuint {\r\n\ttransition-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);\r\n}\r\n.lavalamp .lavalamp-object.easeInSine {\r\n\ttransition-timing-function: cubic-bezier(0.470, 0.000, 0.745, 0.715);\r\n}\r\n.lavalamp .lavalamp-object.easeInExpo {\r\n\ttransition-timing-function: cubic-bezier(0.950, 0.050, 0.795, 0.035);\r\n}\r\n.lavalamp .lavalamp-object.easeInCirc {\r\n\ttransition-timing-function: cubic-bezier(0.600, 0.040, 0.980, 0.335);\r\n}\r\n.lavalamp .lavalamp-object.easeInBack {\r\n\ttransition-timing-function: cubic-bezier(0.600, -0.280, 0.735, 0.045);\r\n}\r\n.lavalamp .lavalamp-object.easeOutQuad {\r\n\ttransition-timing-function: cubic-bezier(0.250, 0.460, 0.450, 0.940);\r\n}\r\n.lavalamp .lavalamp-object.easeOutCubic {\r\n\ttransition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeOutQuart {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.165, 0.840, 0.440, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.165, 0.840, 0.440, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.165, 0.840, 0.440, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.165, 0.840, 0.440, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeOutQuint {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.230, 1.000, 0.320, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeOutSine {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.390, 0.575, 0.565, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.390, 0.575, 0.565, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.390, 0.575, 0.565, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.390, 0.575, 0.565, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeOutExpo {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeOutCirc {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.075, 0.820, 0.165, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.075, 0.820, 0.165, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.075, 0.820, 0.165, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.075, 0.820, 0.165, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeOutBack {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1.275);\r\n\t-moz-transition-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1.275);\r\n\t-o-transition-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1.275);\r\n\ttransition-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1.275);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutQuad {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.455, 0.030, 0.515, 0.955);\r\n\t-moz-transition-timing-function: cubic-bezier(0.455, 0.030, 0.515, 0.955);\r\n\t-o-transition-timing-function: cubic-bezier(0.455, 0.030, 0.515, 0.955);\r\n\ttransition-timing-function: cubic-bezier(0.455, 0.030, 0.515, 0.955);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutCubic {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutQuart {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutQuint {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n\ttransition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutSine {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.445, 0.050, 0.550, 0.950);\r\n\t-moz-transition-timing-function: cubic-bezier(0.445, 0.050, 0.550, 0.950);\r\n\t-o-transition-timing-function: cubic-bezier(0.445, 0.050, 0.550, 0.950);\r\n\ttransition-timing-function: cubic-bezier(0.445, 0.050, 0.550, 0.950);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutExpo {\r\n\t-webkit-transition-timing-function: cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n\t-moz-transition-timing-function: cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n\t-o-transition-timing-function: cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n\ttransition-timing-function: cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutCirc {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.785, 0.135, 0.150, 0.860);\r\n\t-moz-transition-timing-function: cubic-bezier(0.785, 0.135, 0.150, 0.860);\r\n\t-o-transition-timing-function: cubic-bezier(0.785, 0.135, 0.150, 0.860);\r\n\ttransition-timing-function: cubic-bezier(0.785, 0.135, 0.150, 0.860);\r\n}\r\n.lavalamp .lavalamp-object.easeInOutBack {\r\n\t-webkit-transition-timing-function: cubic-bezier(0.680, -0.550, 0.265, 1.550);\r\n\t-moz-transition-timing-function: cubic-bezier(0.680, -0.550, 0.265, 1.550);\r\n\t-o-transition-timing-function: cubic-bezier(0.680, -0.550, 0.265, 1.550);\r\n\ttransition-timing-function: cubic-bezier(0.680, -0.550, 0.265, 1.550);\r\n}\r\n","//\r\n// NoUi Slider\r\n//\r\n\r\n\r\n// Original styles\r\n\r\n.noUi-target,\r\n.noUi-target * {\r\n    -webkit-touch-callout: none;\r\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n    -webkit-user-select: none;\r\n    touch-action: none;\r\n    user-select: none;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.noUi-target {\r\n    position: relative;\r\n    direction: ltr;\r\n}\r\n\r\n.noUi-base,\r\n.noUi-connects {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n\r\n// Wrapper for all connect elements\r\n\r\n.noUi-connects {\r\n    overflow: hidden;\r\n    z-index: 0;\r\n}\r\n\r\n.noUi-connect,\r\n.noUi-origin {\r\n    will-change: transform;\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    transform-origin: 0 0;\r\n}\r\n\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n\r\n.noUi-vertical .noUi-origin {\r\n    width: 0;\r\n}\r\n\r\n.noUi-horizontal .noUi-origin {\r\n    height: 0;\r\n}\r\n\r\n.noUi-handle {\r\n    position: absolute;\r\n}\r\n\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n    transition: transform .3s;\r\n}\r\n\r\n.noUi-state-drag * {\r\n    cursor: inherit !important;\r\n}\r\n\r\n.noUi-horizontal {\r\n    height: $noui-target-thickness;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle {\r\n    width: 34px;\r\n    height: 28px;\r\n    left: -17px;\r\n    top: -6px;\r\n}\r\n\r\n.noUi-vertical {\r\n    width: $noui-target-thickness;\r\n}\r\n\r\n.noUi-vertical .noUi-handle {\r\n    width: 28px;\r\n    height: 34px;\r\n    left: -6px;\r\n    top: -17px;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n    right: -17px;\r\n    left: auto;\r\n}\r\n\r\n.noUi-connects {\r\n    border-radius: 3px;\r\n}\r\n\r\n.noUi-connect {\r\n    background: $noui-slider-connect-bg;\r\n}\r\n\r\n.noUi-draggable {\r\n    cursor: ew-resize;\r\n}\r\n\r\n.noUi-vertical .noUi-draggable {\r\n    cursor: ns-resize;\r\n}\r\n\r\n.noUi-handle {\r\n    border: 1px solid #D9D9D9;\r\n    border-radius: 3px;\r\n    background: #FFF;\r\n    cursor: default;\r\n    box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\r\n    outline: none;\r\n}\r\n\r\n.noUi-active {\r\n    outline: none;\r\n}\r\n\r\n\r\n/* Disabled state;\r\n */\r\n\r\n[disabled] .noUi-connect {\r\n    background: #B8B8B8;\r\n}\r\n\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n    cursor: not-allowed;\r\n}\r\n\r\n\r\n/* Base;\r\n *\r\n */\r\n\r\n.noUi-pips,\r\n.noUi-pips * {\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.noUi-pips {\r\n    position: absolute;\r\n    color: #999;\r\n}\r\n\r\n\r\n/* Values;\r\n *\r\n */\r\n\r\n.noUi-value {\r\n    position: absolute;\r\n    white-space: nowrap;\r\n    text-align: center;\r\n}\r\n\r\n.noUi-value-sub {\r\n    color: #ccc;\r\n    font-size: 10px;\r\n}\r\n\r\n\r\n/* Markings;\r\n *\r\n */\r\n\r\n.noUi-marker {\r\n    position: absolute;\r\n    background: #CCC;\r\n}\r\n\r\n.noUi-marker-sub {\r\n    background: #AAA;\r\n}\r\n\r\n.noUi-marker-large {\r\n    background: #AAA;\r\n}\r\n\r\n\r\n/* Horizontal layout;\r\n *\r\n */\r\n\r\n.noUi-pips-horizontal {\r\n    padding: 10px 0;\r\n    height: 80px;\r\n    top: 100%;\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.noUi-value-horizontal {\r\n    transform: translate(-50%, 50%);\r\n}\r\n\r\n.noUi-rtl .noUi-value-horizontal {\r\n    transform: translate(50%, 50%);\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker {\r\n    margin-left: -1px;\r\n    width: 2px;\r\n    height: 5px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n    height: 10px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n    height: 15px;\r\n}\r\n\r\n\r\n/* Vertical layout;\r\n *\r\n */\r\n\r\n.noUi-pips-vertical {\r\n    padding: 0 10px;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 100%;\r\n}\r\n\r\n.noUi-value-vertical {\r\n    -webkit-transform: translate(0, -50%);\r\n    transform: translate(0, -50%, 0);\r\n    padding-left: 25px;\r\n}\r\n\r\n.noUi-rtl .noUi-value-vertical {\r\n    -webkit-transform: translate(0, 50%);\r\n    transform: translate(0, 50%);\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker {\r\n    width: 5px;\r\n    height: 2px;\r\n    margin-top: -1px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n    width: 10px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-large {\r\n    width: 15px;\r\n}\r\n\r\n.noUi-tooltip {\r\n    display: block;\r\n    position: absolute;\r\n    border: 1px solid #D9D9D9;\r\n    border-radius: 3px;\r\n    background: #fff;\r\n    color: #000;\r\n    padding: 5px;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n}\r\n\r\n.noUi-horizontal .noUi-tooltip {\r\n    -webkit-transform: translate(-50%, 0);\r\n    transform: translate(-50%, 0);\r\n    left: 50%;\r\n    bottom: 120%;\r\n}\r\n\r\n.noUi-vertical .noUi-tooltip {\r\n    -webkit-transform: translate(0, -50%);\r\n    transform: translate(0, -50%);\r\n    top: 50%;\r\n    right: 120%;\r\n}\r\n\r\n\r\n//  Custom styles\r\n\r\n.noUi-target {\r\n    background: $noui-target-bg;\r\n    border-radius: $noui-target-border-radius;\r\n    border: 0;\r\n    box-shadow: $noui-target-box-shadow;\r\n    margin: 15px 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.noUi-horizontal {\r\n    height: $noui-target-thickness;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n    right: -10px;\r\n}\r\n\r\n.noUi-vertical {\r\n    width: $noui-target-thickness;\r\n}\r\n\r\n.noUi-connect {\r\n    background: theme-color(\"primary\");\r\n    box-shadow: none;\r\n}\r\n\r\n.noUi-handle {\r\n\r\n}\r\n\r\n.noUi-horizontal .noUi-handle,\r\n.noUi-vertical .noUi-handle {\r\n    top: -$noui-target-thickness;\r\n    width: $noui-handle-width;\r\n    height: $noui-handle-width;\r\n    border-radius: 100%;\r\n    box-shadow: none;\r\n    cursor: pointer;\r\n    background-color: $noui-handle-bg;\r\n    border: $noui-handle-border;\r\n    transition: box-shadow .15s, transform .15s;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle.noUi-active,\r\n.noUi-vertical .noUi-handle.noUi-active {\r\n    box-shadow: 0px 0px 0px 2px rgba($noui-handle-bg, 1);\r\n}\r\n\r\n.input-slider--cyan .noUi-connect {\r\n    background: $cyan;\r\n}\r\n\r\n\r\n/* Disabled state */\r\n\r\n[disabled] .noUi-connect,\r\n[disabled].noUi-connect {\r\n    background: $noui-slider-connect-disabled-bg;\r\n}\r\n\r\n[disabled] .noUi-handle,\r\n[disabled].noUi-origin {\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Range slider value labels */\r\n\r\n.range-slider-value {\r\n    font-size: $font-size-xs;\r\n    font-weight: 500;\r\n    background-color: rgba($dark, .7);\r\n    color: color-yiq($dark);\r\n    border-radius: 10px;\r\n    padding: .4em .8em .3em .85em;\r\n}\r\n\r\n.range-slider-wrapper .upper-info {\r\n    font-weight: 400;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.input-slider-value-output {\r\n    background: #333;\r\n    color: #fff;\r\n    padding: 4px 8px;\r\n    position: relative;\r\n    top: 12px;\r\n    font-size: 11px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.input-slider-value-output:after {\r\n    bottom: 100%;\r\n    left: 10px;\r\n    border: solid transparent;\r\n    content: \" \";\r\n    height: 0;\r\n    width: 0;\r\n    position: absolute;\r\n    pointer-events: none;\r\n    border-color: rgba(136, 183, 213, 0);\r\n    border-bottom-color: #333;\r\n    border-width: 4px;\r\n    margin-left: -4px;\r\n}\r\n\r\n.input-slider-value-output.left:after {\r\n    left: 10px;\r\n    right: auto;\r\n}\r\n\r\n.input-slider-value-output.right:after {\r\n    right: 10px;\r\n    left: auto;\r\n}\r\n","//\r\n// Quill\r\n//\r\n\r\n.ql-container {\r\n    font-family: $font-family-base;\r\n}\r\n\r\n.ql-toolbar {\r\n    position: relative;\r\n    padding: $input-padding-y $input-padding-x;\r\n    background-color: $input-bg;\r\n    border: $input-border-width solid $input-border-color;\r\n    border-radius: $input-border-radius $input-border-radius 0 0;\r\n    color: $input-color;\r\n}\r\n\r\n.ql-toolbar + .ql-container {\r\n    margin-top: -$border-width;\r\n}\r\n\r\n.ql-toolbar + .ql-container .ql-editor {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n\r\n.ql-editor {\r\n    min-height: $line-height-base * $font-size-base * 4;\r\n    display: block;\r\n    width: 100%;\r\n    padding: $input-padding-y $input-padding-x;\r\n    font-size: $font-size-base;\r\n    line-height: $input-line-height;\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n    background-clip: padding-box;\r\n    border: $input-border-width solid $input-border-color;\r\n\r\n    // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\r\n    @if $enable-rounded {\r\n        // Manually use the if/else instead of the mixin to account for iOS override\r\n        border-radius: $input-border-radius;\r\n    } @else {\r\n        // Otherwise undo the iOS default\r\n        border-radius: 0;\r\n    }\r\n\r\n    @include box-shadow($input-box-shadow);\r\n    @include transition($input-transition);\r\n\r\n    // Unstyle the caret on `<select>`s in IE10+.\r\n    &::-ms-expand {\r\n        background-color: transparent;\r\n        border: 0;\r\n    }\r\n\r\n    // Customize the `:focus` state to imitate native WebKit styles.\r\n    @include form-control-focus($ignore-warning: true);\r\n\r\n    &:focus {\r\n        border-color: $input-border-color;\r\n    }\r\n}\r\n\r\n.ql-hidden {\r\n    position: absolute;\r\n    transform: scale(0);\r\n}\r\n\r\n\r\n// Placeholder\r\n\r\n.ql-editor.ql-blank::before {\r\n    top: $input-padding-y; left: $input-padding-x;\r\n    font-style: normal;\r\n    color: $input-placeholder-color;\r\n}\r\n\r\n.ql-editor:focus::before {\r\n    display: none;\r\n}\r\n\r\n\r\n// Toolbar\r\n\r\n.ql-formats {\r\n    padding-left: .5rem;\r\n    padding-right: .5rem;\r\n\r\n    &:first-child {\r\n        padding-left: 0;\r\n    }\r\n\r\n    &:last-child {\r\n        padding-right: 0;\r\n    }\r\n}\r\n\r\n.ql-toolbar button {\r\n    padding: 0 .25rem;\r\n    background: none; border: none;\r\n    color: $body-color;\r\n    cursor: pointer;\r\n    transition: $transition-base;\r\n\r\n    &:hover {\r\n        color: $primary;\r\n    }\r\n\r\n    &:first-child {\r\n        margin-left: -.25rem;\r\n    }\r\n}\r\n\r\n.ql-toolbar .ql-active {\r\ncolor: $primary;\r\n}\r\n\r\n.ql-toolbar button svg {\r\n    height: $font-size-lg; width: $font-size-lg;\r\n}\r\n\r\n.ql-toolbar .ql-stroke {\r\n    stroke: currentColor;\r\n    stroke-width: 2;\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n    fill: none;\r\n}\r\n\r\n.ql-toolbar .ql-thin {\r\n    stroke-width: 1;\r\n}\r\n\r\n.ql-toolbar .ql-fill {\r\n    fill: currentColor;\r\n}\r\n\r\n.ql-toolbar input.ql-image {\r\n    position: absolute;\r\n    transform: scale(0);\r\n}\r\n\r\n\r\n// Tooltip\r\n\r\n.ql-tooltip {\r\n    position: absolute;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    width: 18.5rem;\r\n    background-color: $popover-bg;\r\n    border: $popover-border-width solid $popover-border-color;\r\n    border-radius: $popover-border-radius;\r\n    padding: $input-padding-y $input-padding-x;\r\n    margin-top: .6rem; // arrow width\r\n    box-shadow: $popover-box-shadow;\r\n\r\n    // Arrow\r\n\r\n    &:before, &:after {\r\n        content: '';\r\n        position: absolute;\r\n        left: 50%; bottom: 100%;\r\n        transform: translateX(-50%);\r\n    }\r\n\r\n    &:before {\r\n        border-bottom: .6rem solid $popover-border-color;\r\n        border-left: .6rem solid transparent;\r\n        border-right: .6rem solid transparent;\r\n    }\r\n\r\n    &:after {\r\n        border-bottom: .5rem solid $popover-bg;\r\n        border-left: .5rem solid transparent;\r\n        border-right: .5rem solid transparent;\r\n    }\r\n}\r\n\r\n.ql-container .ql-tooltip:hover {\r\n    display: flex !important;\r\n}\r\n\r\n.ql-tooltip .ql-preview {\r\n    width: 100%;\r\n    @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\r\n    @include transition($btn-transition);\r\n}\r\n\r\n.ql-tooltip.ql-editing .ql-preview {\r\n    display: none;\r\n}\r\n\r\n.ql-tooltip input {\r\n    display: none;\r\n    width: 100%;\r\n    padding-top: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n    padding-bottom: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n    background-color: transparent;\r\n    font-size: $font-size-sm;\r\n    line-height: $input-line-height-sm;\r\n    border: none;\r\n    color: $input-color;\r\n\r\n    &:focus {\r\n    outline: none;\r\n    }\r\n}\r\n\r\n.ql-tooltip.ql-editing input {\r\n    display: block;\r\n}\r\n\r\n\r\n.ql-tooltip .ql-action,\r\n.ql-tooltip .ql-remove {\r\n    margin-left: .25rem;\r\n}\r\n\r\n.ql-tooltip .ql-action::before,\r\n.ql-tooltip .ql-remove::before {\r\n    display: inline-block;\r\n    font-weight: $btn-font-weight;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    user-select: none;\r\n    border: $btn-border-width solid transparent;\r\n    cursor: pointer;\r\n    @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\r\n    @include transition($btn-transition);\r\n\r\n    // Share hover and focus styles\r\n    @include hover-focus {\r\n        text-decoration: none;\r\n    }\r\n\r\n    &:focus,\r\n    &.focus {\r\n        outline: 0;\r\n        box-shadow: $btn-focus-box-shadow;\r\n    }\r\n}\r\n\r\n.ql-tooltip .ql-action::before,\r\n.ql-tooltip.ql-editing .ql-action::before {\r\n    @include button-variant($primary, $primary);\r\n}\r\n\r\n.ql-tooltip .ql-action::before {\r\n    content: 'Edit';\r\n}\r\n\r\n.ql-tooltip.ql-editing .ql-action::before {\r\n    content: 'Save';\r\n}\r\n\r\n.ql-tooltip .ql-remove::before {\r\n    @include button-variant($white, $white);\r\n    content: 'Remove';\r\n    border-color: $gray-300;\r\n}\r\n\r\n.ql-tooltip.ql-editing .ql-remove::before {\r\n    display: none;\r\n}\r\n\r\n\r\n// Formatting\r\n\r\n.ql-editor blockquote {\r\n    margin-bottom: $spacer;\r\n    font-size: $blockquote-font-size;\r\n}\r\n\r\n.ql-editor img {\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n","//\r\n// Jquery scrollbar\r\n// default styles\r\n//\r\n\r\n.scroll-wrapper {\r\n  overflow: hidden !important;\r\n  padding: 0 !important;\r\n  position: relative;\r\n}\r\n.scroll-wrapper > .scroll-content {\r\n  border: none !important;\r\n  box-sizing: content-box !important;\r\n  height: auto;\r\n  left: 0;\r\n  margin: 0;\r\n  max-height: none;\r\n  max-width: none !important;\r\n  overflow: scroll !important;\r\n  padding: 0;\r\n  position: relative !important;\r\n  top: 0;\r\n  width: auto !important;\r\n}\r\n.scroll-wrapper > .scroll-content::-webkit-scrollbar {\r\n  height: 0;\r\n  width: 0;\r\n}\r\n.scroll-wrapper.scroll--rtl {\r\n  direction: rtl;\r\n}\r\n\r\n.scroll-element {\r\n  box-sizing: content-box;\r\n  display: none;\r\n}\r\n.scroll-element div {\r\n  box-sizing: content-box;\r\n}\r\n.scroll-element .scroll-bar,\r\n.scroll-element .scroll-arrow {\r\n  cursor: default;\r\n}\r\n.scroll-element.scroll-x.scroll-scrollx_visible, .scroll-element.scroll-y.scroll-scrolly_visible {\r\n  display: block;\r\n}\r\n\r\n.scroll-textarea {\r\n  border: 1px solid #cccccc;\r\n  border-top-color: #999999;\r\n}\r\n.scroll-textarea > .scroll-content {\r\n  overflow: hidden !important;\r\n}\r\n.scroll-textarea > .scroll-content > textarea {\r\n  border: none !important;\r\n  box-sizing: border-box;\r\n  height: 100% !important;\r\n  margin: 0;\r\n  max-height: none !important;\r\n  max-width: none !important;\r\n  overflow: scroll !important;\r\n  outline: none;\r\n  padding: 2px;\r\n  position: relative !important;\r\n  top: 0;\r\n  width: 100% !important;\r\n}\r\n.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n/*************** SIMPLE INNER SCROLLBAR ***************/\r\n.scrollbar-inner > .scroll-element,\r\n.scrollbar-inner > .scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element.scroll-x {\r\n  bottom: 2px;\r\n  height: 8px;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  right: 2px;\r\n  top: 0;\r\n  width: 8px;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element .scroll-element_outer {\r\n  overflow: hidden;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element .scroll-element_outer,\r\n.scrollbar-inner > .scroll-element .scroll-element_track,\r\n.scrollbar-inner > .scroll-element .scroll-bar {\r\n  -webkit-border-radius: 8px;\r\n  -moz-border-radius: 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element .scroll-element_track,\r\n.scrollbar-inner > .scroll-element .scroll-bar {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\r\n  filter: alpha(opacity=40);\r\n  opacity: 0.4;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element .scroll-element_track {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element .scroll-bar {\r\n  background-color: #c2c2c2;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element:hover .scroll-bar {\r\n  background-color: #919191;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar {\r\n  background-color: #919191;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -12px;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -12px;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -12px;\r\n}\r\n\r\n.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -12px;\r\n}\r\n\r\n/*************** SIMPLE OUTER SCROLLBAR ***************/\r\n.scrollbar-outer > .scroll-element,\r\n.scrollbar-outer > .scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 12px;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  width: 12px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-x .scroll-element_outer {\r\n  height: 8px;\r\n  top: 2px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-y .scroll-element_outer {\r\n  left: 2px;\r\n  width: 8px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element .scroll-element_outer {\r\n  overflow: hidden;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element .scroll-element_track {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element .scroll-element_outer,\r\n.scrollbar-outer > .scroll-element .scroll-element_track,\r\n.scrollbar-outer > .scroll-element .scroll-bar {\r\n  -webkit-border-radius: 8px;\r\n  -moz-border-radius: 8px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element .scroll-bar {\r\n  background-color: #d9d9d9;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element .scroll-bar:hover {\r\n  background-color: #c2c2c2;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-draggable .scroll-bar {\r\n  background-color: #919191;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-outer > .scroll-content.scroll-scrolly_visible {\r\n  left: -12px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-content.scroll-scrollx_visible {\r\n  top: -12px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-x .scroll-bar {\r\n  min-width: 10px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-y .scroll-bar {\r\n  min-height: 10px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-outer > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -14px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -14px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -14px;\r\n}\r\n\r\n.scrollbar-outer > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -14px;\r\n}\r\n\r\n/*************** SCROLLBAR MAC OS X ***************/\r\n.scrollbar-macosx > .scroll-element,\r\n.scrollbar-macosx > .scroll-element div {\r\n  background: none;\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element .scroll-element_track {\r\n  display: none;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element .scroll-bar {\r\n  background-color: #6C6E71;\r\n  display: block;\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\r\n  filter: alpha(opacity=0);\r\n  opacity: 0;\r\n  -webkit-border-radius: 7px;\r\n  -moz-border-radius: 7px;\r\n  border-radius: 7px;\r\n  -webkit-transition: opacity 0.2s linear;\r\n  -moz-transition: opacity 0.2s linear;\r\n  -o-transition: opacity 0.2s linear;\r\n  -ms-transition: opacity 0.2s linear;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.scrollbar-macosx:hover > .scroll-element .scroll-bar,\r\n.scrollbar-macosx > .scroll-element.scroll-draggable .scroll-bar {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\r\n  filter: alpha(opacity=70);\r\n  opacity: 0.7;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-x {\r\n  bottom: 0px;\r\n  height: 0px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  overflow: visible;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 0px;\r\n  top: 0;\r\n  width: 0px;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-macosx > .scroll-element.scroll-x .scroll-bar {\r\n  height: 7px;\r\n  min-width: 10px;\r\n  top: -9px;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-y .scroll-bar {\r\n  left: -9px;\r\n  min-height: 10px;\r\n  width: 7px;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-x .scroll-element_outer {\r\n  left: 2px;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-x .scroll-element_size {\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-y .scroll-element_outer {\r\n  top: 2px;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-macosx > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -11px;\r\n}\r\n\r\n.scrollbar-macosx > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -11px;\r\n}\r\n\r\n/*************** SCROLLBAR LIGHT ***************/\r\n.scrollbar-light > .scroll-element,\r\n.scrollbar-light > .scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-light > .scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-light > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-light > .scroll-element .scroll-element_outer {\r\n  -webkit-border-radius: 10px;\r\n  -moz-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element .scroll-element_size {\r\n  background: #dbdbdb;\r\n  background: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2RiZGJkYiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlOGU4ZTgiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+\");\r\n  background: -moz-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: -webkit-gradient(linear, left top, right top, color-stop(0%, #dbdbdb), color-stop(100%, #e8e8e8));\r\n  background: -webkit-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: -o-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: -ms-linear-gradient(left, #dbdbdb 0%, #e8e8e8 100%);\r\n  background: linear-gradient(to right, #dbdbdb 0%, #e8e8e8 100%);\r\n  -webkit-border-radius: 10px;\r\n  -moz-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 17px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  width: 17px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element .scroll-bar {\r\n  background: #fefefe;\r\n  background: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZlZmVmZSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmNWY1ZjUiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+\");\r\n  background: -moz-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: -webkit-gradient(linear, left top, right top, color-stop(0%, #fefefe), color-stop(100%, #f5f5f5));\r\n  background: -webkit-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: -o-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: -ms-linear-gradient(left, #fefefe 0%, #f5f5f5 100%);\r\n  background: linear-gradient(to right, #fefefe 0%, #f5f5f5 100%);\r\n  border: 1px solid #dbdbdb;\r\n  -webkit-border-radius: 10px;\r\n  -moz-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-light > .scroll-content.scroll-scrolly_visible {\r\n  left: -17px;\r\n  margin-left: 17px;\r\n}\r\n\r\n.scrollbar-light > .scroll-content.scroll-scrollx_visible {\r\n  top: -17px;\r\n  margin-top: 17px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-x .scroll-bar {\r\n  height: 10px;\r\n  min-width: 10px;\r\n  top: 0px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-y .scroll-bar {\r\n  left: 0px;\r\n  min-height: 10px;\r\n  width: 10px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-x .scroll-element_outer {\r\n  height: 12px;\r\n  left: 2px;\r\n  top: 2px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-x .scroll-element_size {\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-y .scroll-element_outer {\r\n  left: 2px;\r\n  top: 2px;\r\n  width: 12px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-light > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -19px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-light > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -19px;\r\n}\r\n\r\n/*************** SCROLLBAR RAIL ***************/\r\n.scrollbar-rail > .scroll-element,\r\n.scrollbar-rail > .scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element .scroll-element_size {\r\n  background-color: #999;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.scrollbar-rail > .scroll-element .scroll-element_outer:hover .scroll-element_size {\r\n  background-color: #666;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 12px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  padding: 3px 0 2px;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  padding: 0 2px 0 3px;\r\n  right: 0;\r\n  top: 0;\r\n  width: 12px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element .scroll-bar {\r\n  background-color: #d0b9a0;\r\n  -webkit-border-radius: 2px;\r\n  -moz-border-radius: 2px;\r\n  border-radius: 2px;\r\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.scrollbar-rail > .scroll-element .scroll-element_outer:hover .scroll-bar {\r\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-rail > .scroll-content.scroll-scrolly_visible {\r\n  left: -17px;\r\n  margin-left: 17px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-content.scroll-scrollx_visible {\r\n  margin-top: 17px;\r\n  top: -17px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-x .scroll-bar {\r\n  height: 10px;\r\n  min-width: 10px;\r\n  top: 1px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-y .scroll-bar {\r\n  left: 1px;\r\n  min-height: 10px;\r\n  width: 10px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-x .scroll-element_outer {\r\n  height: 15px;\r\n  left: 5px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-x .scroll-element_size {\r\n  height: 2px;\r\n  left: -10px;\r\n  top: 5px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-y .scroll-element_outer {\r\n  top: 5px;\r\n  width: 15px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-y .scroll-element_size {\r\n  left: 5px;\r\n  top: -10px;\r\n  width: 2px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-rail > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -25px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -25px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -25px;\r\n}\r\n\r\n.scrollbar-rail > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -25px;\r\n}\r\n\r\n/*************** SCROLLBAR DYNAMIC ***************/\r\n.scrollbar-dynamic > .scroll-element,\r\n.scrollbar-dynamic > .scroll-element div {\r\n  background: none;\r\n  border: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-x {\r\n  bottom: 2px;\r\n  height: 7px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 2px;\r\n  top: 0;\r\n  width: 7px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element .scroll-element_outer {\r\n  opacity: 0.3;\r\n  -webkit-border-radius: 12px;\r\n  -moz-border-radius: 12px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element .scroll-element_size {\r\n  background-color: #cccccc;\r\n  opacity: 0;\r\n  -webkit-border-radius: 12px;\r\n  -moz-border-radius: 12px;\r\n  border-radius: 12px;\r\n  -webkit-transition: opacity 0.2s;\r\n  -moz-transition: opacity 0.2s;\r\n  -o-transition: opacity 0.2s;\r\n  -ms-transition: opacity 0.2s;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element .scroll-bar {\r\n  background-color: #6c6e71;\r\n  -webkit-border-radius: 7px;\r\n  -moz-border-radius: 7px;\r\n  border-radius: 7px;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-dynamic > .scroll-element.scroll-x .scroll-bar {\r\n  bottom: 0;\r\n  height: 7px;\r\n  min-width: 24px;\r\n  top: auto;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-y .scroll-bar {\r\n  left: auto;\r\n  min-height: 24px;\r\n  right: 0;\r\n  width: 7px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-x .scroll-element_outer {\r\n  bottom: 0;\r\n  top: auto;\r\n  left: 2px;\r\n  -webkit-transition: height 0.2s;\r\n  -moz-transition: height 0.2s;\r\n  -o-transition: height 0.2s;\r\n  -ms-transition: height 0.2s;\r\n  transition: height 0.2s;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-y .scroll-element_outer {\r\n  left: auto;\r\n  right: 0;\r\n  top: 2px;\r\n  -webkit-transition: width 0.2s;\r\n  -moz-transition: width 0.2s;\r\n  -o-transition: width 0.2s;\r\n  -ms-transition: width 0.2s;\r\n  transition: width 0.2s;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-x .scroll-element_size {\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-dynamic > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -11px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -11px;\r\n}\r\n\r\n/* hover & drag */\r\n.scrollbar-dynamic > .scroll-element:hover .scroll-element_outer,\r\n.scrollbar-dynamic > .scroll-element.scroll-draggable .scroll-element_outer {\r\n  overflow: hidden;\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=70)\";\r\n  filter: alpha(opacity=70);\r\n  opacity: 0.7;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element:hover .scroll-element_outer .scroll-element_size,\r\n.scrollbar-dynamic > .scroll-element.scroll-draggable .scroll-element_outer .scroll-element_size {\r\n  opacity: 1;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element:hover .scroll-element_outer .scroll-bar,\r\n.scrollbar-dynamic > .scroll-element.scroll-draggable .scroll-element_outer .scroll-bar {\r\n  height: 100%;\r\n  width: 100%;\r\n  -webkit-border-radius: 12px;\r\n  -moz-border-radius: 12px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-x:hover .scroll-element_outer,\r\n.scrollbar-dynamic > .scroll-element.scroll-x.scroll-draggable .scroll-element_outer {\r\n  height: 20px;\r\n  min-height: 7px;\r\n}\r\n\r\n.scrollbar-dynamic > .scroll-element.scroll-y:hover .scroll-element_outer,\r\n.scrollbar-dynamic > .scroll-element.scroll-y.scroll-draggable .scroll-element_outer {\r\n  min-width: 7px;\r\n  width: 20px;\r\n}\r\n\r\n/*************** SCROLLBAR GOOGLE CHROME ***************/\r\n.scrollbar-chrome > .scroll-element,\r\n.scrollbar-chrome > .scroll-element div {\r\n  border: none;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element div {\r\n  display: block;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element .scroll-element_track {\r\n  background: #f1f1f1;\r\n  border: 1px solid #dbdbdb;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-x {\r\n  bottom: 0;\r\n  height: 16px;\r\n  left: 0;\r\n  min-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  width: 16px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element .scroll-bar {\r\n  background-color: #d9d9d9;\r\n  border: 1px solid #bdbdbd;\r\n  cursor: default;\r\n  -webkit-border-radius: 2px;\r\n  -moz-border-radius: 2px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element .scroll-bar:hover {\r\n  background-color: #c2c2c2;\r\n  border-color: #a9a9a9;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-draggable .scroll-bar {\r\n  background-color: #919191;\r\n  border-color: #7e7e7e;\r\n}\r\n\r\n/* scrollbar height/width & offset from container borders */\r\n.scrollbar-chrome > .scroll-content.scroll-scrolly_visible {\r\n  left: -16px;\r\n  margin-left: 16px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-content.scroll-scrollx_visible {\r\n  top: -16px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-x .scroll-bar {\r\n  height: 8px;\r\n  min-width: 10px;\r\n  top: 3px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y .scroll-bar {\r\n  left: 3px;\r\n  min-height: 10px;\r\n  width: 8px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-x .scroll-element_outer {\r\n  border-left: 1px solid #dbdbdb;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-x .scroll-element_track {\r\n  height: 14px;\r\n  left: -3px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-x .scroll-element_size {\r\n  height: 14px;\r\n  left: -4px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y .scroll-element_outer {\r\n  border-top: 1px solid #dbdbdb;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y .scroll-element_track {\r\n  top: -3px;\r\n  width: 14px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y .scroll-element_size {\r\n  top: -4px;\r\n  width: 14px;\r\n}\r\n\r\n/* update scrollbar offset if both scrolls are visible */\r\n.scrollbar-chrome > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size {\r\n  top: -19px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track {\r\n  left: -19px;\r\n}\r\n\r\n.scrollbar-chrome > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track {\r\n  top: -19px;\r\n}\r\n\r\n\r\n//\r\n// Custom styles\r\n//\r\n\r\n.scrollbar-inner {\r\n    height: 100%;\r\n\r\n    &:not(:hover) .scroll-element {\r\n        opacity: 0;\r\n    }\r\n\r\n    .scroll-element {\r\n        transition: opacity 300ms;\r\n        margin-right: 2px;\r\n\r\n        .scroll-bar,\r\n        .scroll-element_track {\r\n            transition: background-color 300ms;\r\n        }\r\n\r\n        .scroll-element_track {\r\n            background-color: transparent;\r\n        }\r\n\r\n        &:hover {\r\n            width: 4px;\r\n        }\r\n    }\r\n\r\n    .scroll-element.scroll-y {\r\n        width: 3px;\r\n        right: 0;\r\n    }\r\n\r\n    .scroll-element.scroll-x {\r\n        height: 3px;\r\n        bottom: 0;\r\n    }\r\n}\r\n","//\r\n// select2.scss\r\n// Select2 plugin overrides\r\n//\r\n\r\n.select2-selection__arrow {\r\n  display: none;\r\n}\r\n\r\n.select2.select2-container {\r\n  width: 100% !important;\r\n}\r\n\r\n.select2-container .select2-selection--single,\r\n.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.select2-container--default .select2-selection--multiple,\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n  display: block;\r\n  width: 100%;\r\n  height: $input-height;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-size: $font-size-base;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n\r\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\r\n  @if $enable-rounded {\r\n    // Manually use the if/else instead of the mixin to account for iOS override\r\n    border-radius: $input-border-radius;\r\n  } @else {\r\n    // Otherwise undo the iOS default\r\n    border-radius: 0;\r\n  }\r\n\r\n  @include box-shadow($input-box-shadow);\r\n  @include transition($input-transition);\r\n\r\n  // Unstyle the caret on `<select>`s in IE10+.\r\n  &::-ms-expand {\r\n    background-color: transparent;\r\n    border: 0;\r\n  }\r\n\r\n  // Customize the `:focus` state to imitate native WebKit styles.\r\n  @include form-control-focus($ignore-warning: true);\r\n\r\n  // Placeholder\r\n  &::placeholder {\r\n    color: $input-placeholder-color;\r\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\r\n    opacity: 1;\r\n  }\r\n\r\n  // Disabled and read-only inputs\r\n  //\r\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\r\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\r\n  // don't honor that edge case; we style them as disabled anyway.\r\n  &:disabled,\r\n  &[readonly] {\r\n    background-color: $input-disabled-bg;\r\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.select2-container .select2-selection--single .select2-selection__rendered {\r\n  padding: 0;\r\n  overflow: inherit;\r\n  text-overflow: inherit;\r\n  white-space: inherit;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n  color: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\n.select2-dropdown {\r\n  padding: $dropdown-padding-y 0;\r\n  background-color: $dropdown-bg;\r\n  border: 1px solid $input-border-color;\r\n  border-radius: $dropdown-border-radius;\r\n}\r\n\r\n.select2-results__option {\r\n  padding: $dropdown-item-padding-y $input-padding-x;\r\n  background-color: $dropdown-link-bg;\r\n  color: $dropdown-link-color;\r\n  font-size: $font-size-sm;\r\n\r\n  @include hover-focus {\r\n    color: $dropdown-link-hover-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-hover-bg);\r\n  }\r\n}\r\n\r\n.select2-container--default .select2-results__option--highlighted[aria-selected],\r\n.select2-container--default .select2-results__option[aria-selected=\"true\"] {\r\n  background-color: $dropdown-link-active-bg;\r\n  color: $dropdown-link-active-color;\r\n}\r\n\r\n.select2-container--default .select2-results__option[aria-disabled=true] {\r\n  color: $dropdown-link-disabled-color;\r\n}\r\n\r\n.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.select2-container--default .select2-selection--multiple {\r\n  height: auto;\r\n  min-height: $input-height;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\r\n  display: block;\r\n  margin: 0 0 -.25rem -.25rem;\r\n  padding: 0;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n  display: inline-flex;\r\n  padding: 0 .5rem;\r\n  margin: 0 0 .25rem .25rem;\r\n  background-color: $light;\r\n  border: none;\r\n  border-radius: $border-radius-sm;\r\n  line-height: ($input-line-height * $font-size-base);\r\n  font-size: $font-size-sm;\r\n  color: $input-color;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\r\n  order: 2;\r\n  margin-left: .5rem;\r\n  color: $text-muted;\r\n\r\n  &:hover {\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.select2-container .select2-search--inline {\r\n  display: none;\r\n}\r\n\r\n.select2-selection[aria-expanded=\"true\"] {\r\n  border-bottom-left-radius: 0 !important;\r\n  border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n// Search bar\r\n\r\n.select2-search--dropdown {\r\n  padding: $dropdown-item-padding-y $input-padding-x;\r\n}\r\n\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n  // height: $input-height-sm;\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\n\r\n// Sizing\r\n//\r\n// Makes the select2 containers respect the .form-control-sm and .form-control-lg classes\r\n\r\n.form-control-sm + .select2-container .select2-selection--single,\r\n.form-control-sm + .select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-sm + .select2-container--default .select2-selection--multiple {\r\n  height: $input-height-sm;\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\n.form-control-sm + .select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-sm + .select2-container--default .select2-selection--multiple {\r\n  min-height: $input-height-sm;\r\n}\r\n\r\n.form-control-sm + .select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n  line-height: ($input-line-height-sm * $font-size-sm);\r\n}\r\n\r\n.form-control-lg + .select2-container .select2-selection--single,\r\n.form-control-lg + .select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-lg + .select2-container--default .select2-selection--multiple {\r\n  height: $input-height-lg;\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n  @include border-radius($input-border-radius-lg);\r\n}\r\n\r\n.form-control-lg + .select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.form-control-lg + .select2-container--default .select2-selection--multiple {\r\n  min-height: $input-height-lg;\r\n}\r\n\r\n.form-control-lg + .select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n  line-height: ($input-line-height-lg * $font-size-lg);\r\n}\r\n","//\r\n// Sweet alert 2\r\n// Sweet alert 2 plugin overrides\r\n//\r\n\r\n\r\n.swal2-popup {\r\n\r\n    padding: $swal2-padding;\r\n\r\n    .swal2-title {\r\n        font-size: $swal2-title-font-size;\r\n    }\r\n\r\n    .swal2-content {\r\n        font-size: $swal2-content-font-size;\r\n    }\r\n\r\n    .swal2-image {\r\n        max-width: 200px;\r\n    }\r\n}\r\n",".sr-only,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\r\n.bootstrap-datetimepicker-widget .picker-switch::after,\r\n.bootstrap-datetimepicker-widget table th.prev::after,\r\n.bootstrap-datetimepicker-widget table th.next::after {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget {\r\n  list-style: none;\r\n}\r\n.bootstrap-datetimepicker-widget a .btn:hover {\r\n  background-color: transparent;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu {\r\n  padding: 8px 6px;\r\n  width: 254px;\r\n  max-width: 254px;\r\n  .tim-icons{\r\n      opacity: 1;\r\n  }\r\n\r\n  .picker-switch {\r\n    .table-condensed {\r\n      &:hover {\r\n        background: #eee;\r\n        border-radius: 3px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .timepicker-picker {\r\n    .table-condensed {\r\n      margin-top: 10px;\r\n      margin-bottom: 5px;\r\n\r\n      .btn[data-action=\"togglePeriod\"]:hover,\r\n      .separator {\r\n        color: #9A9A9A !important;\r\n      }\r\n    }\r\n  }\r\n  .table-condensed {\r\n    .month,\r\n    .year,\r\n    .decade {\r\n       color: #9A9A9A;\r\n\r\n      &.active {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n}\r\n@include media-breakpoint-up(md){\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n@include media-breakpoint-up(lg){\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n@include media-breakpoint-up(xl){\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    vertical-align: middle;\r\n    content: \"\";\r\n    right: auto;\r\n    border-bottom: .4em solid;\r\n    border-right: .4em solid transparent;\r\n    border-left: .4em solid transparent;\r\n\r\n\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top:before{\r\n    display: none;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top:after{\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    vertical-align: middle;\r\n    content: \"\";\r\n    top: auto;\r\n    bottom: -6px;\r\n    right: auto;\r\n    left: 10px;\r\n    color: $white;\r\n    border-top: .4em solid;\r\n    border-right: .4em solid transparent;\r\n    border-left: .4em solid transparent;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\r\n  margin-top: auto;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\r\n  margin-top: auto;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\r\n  left: auto;\r\n  right: 6px;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\r\n  left: auto;\r\n  right: 7px;\r\n}\r\n.bootstrap-datetimepicker-widget .list-unstyled {\r\n  margin: 0;\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action] {\r\n  padding: 0;\r\n  border-width: 0;\r\n  color: #fff;\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\r\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\r\n    color: $primary;\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action]:active {\r\n  box-shadow: none;\r\n}\r\n.bootstrap-datetimepicker-widget .timepicker-hour,\r\n.bootstrap-datetimepicker-widget .timepicker-minute,\r\n.bootstrap-datetimepicker-widget .timepicker-second {\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  font-weight: 300;\r\n  font-size: 1.5em;\r\n  margin: 3px;\r\n  border-radius: 50%;\r\n  color: #9A9A9A;\r\n}\r\n.bootstrap-datetimepicker-widget button[data-action] {\r\n  width: 38px;\r\n  height: 38px;\r\n  padding: 0;\r\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn{\r\n    margin: 0 !important;\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\r\n  content: \"Increment Hours\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\r\n  content: \"Increment Minutes\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\r\n  content: \"Decrement Hours\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\r\n  content: \"Decrement Minutes\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\r\n  content: \"Show Hours\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\r\n  content: \"Show Minutes\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\r\n  content: \"Toggle AM/PM\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\r\n  content: \"Clear the picker\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\r\n  content: \"Set the date to today\";\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch {\r\n  text-align: center;\r\n  border-radius: 3px;\r\n  color: $primary;\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch::after {\r\n  content: \"Toggle Date and Time Screens\";\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch td {\r\n  padding: 0;\r\n  margin: 0;\r\n  height: auto;\r\n  width: auto;\r\n  line-height: inherit;\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch td span {\r\n  line-height: 2.5;\r\n  height: 2.5em;\r\n  width: 100%;\r\n  border-radius: 3px;\r\n  margin: 2px 0px !important;\r\n}\r\n.bootstrap-datetimepicker-widget table {\r\n  width: 100%;\r\n  margin: 0;\r\n  text-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {\r\n  text-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table th {\r\n  height: 20px;\r\n  line-height: 20px;\r\n  width: 20px;\r\n  font-weight: 300;\r\n}\r\n.bootstrap-datetimepicker-widget table th.picker-switch {\r\n  width: 145px;\r\n}\r\n.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {\r\n  border-radius: 4px;\r\n  height: 27px;\r\n  width: 27px;\r\n  line-height: 28px;\r\n  font-size: 12px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  color: $primary;\r\n}\r\n.bootstrap-datetimepicker-widget table th.prev::after {\r\n  content: \"Previous Month\";\r\n}\r\n.bootstrap-datetimepicker-widget table th.next::after {\r\n  content: \"Next Month\";\r\n}\r\n.bootstrap-datetimepicker-widget table th.dow {\r\n  text-align: center;\r\n  color: $primary;\r\n  padding-bottom: 5px;\r\n  padding-top: 10px;\r\n}\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\r\n  background: #eee;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.cw > div {\r\n  font-size: .8em;\r\n  height: 20px;\r\n  line-height: 20px;\r\n  color: #cfcfca;\r\n}\r\n.bootstrap-datetimepicker-widget table td.day > div,\r\n.bootstrap-datetimepicker-widget table td.minute > div,\r\n.bootstrap-datetimepicker-widget table td.hour > div {\r\n  height: 30px;\r\n  line-height: 2.2;\r\n  width: 30px;\r\n  text-align: center;\r\n  padding: 0px;\r\n  border-radius: 50%;\r\n  margin: 0 auto;\r\n  z-index: -1;\r\n  color: #9A9A9A;\r\n  position: relative;\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n  border: none;\r\n  cursor: pointer;\r\n  -webkit-transition: all 300ms ease 0s;\r\n  -moz-transition: all 300ms ease 0s;\r\n  -o-transition: all 300ms ease 0s;\r\n  -ms-transition: all 300ms ease 0s;\r\n  transition: all 300ms ease 0s;\r\n}\r\n.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {\r\n  background: #eee;\r\n  cursor: pointer;\r\n}\r\n.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {\r\n  color: $default;\r\n}\r\n.bootstrap-datetimepicker-widget table {\r\n  td.today, td.day{\r\n    background: transparent !important;\r\n  }\r\n}\r\n.bootstrap-datetimepicker-widget table td.today > div:before {\r\n  content: '';\r\n  display: inline-block;\r\n  border: 0 0 7px 7px solid transparent;\r\n  border-bottom-color: #68B3C8;\r\n  border-top-color: rgba(0, 0, 0, 0.2);\r\n  position: absolute;\r\n  bottom: 4px;\r\n  right: 4px;\r\n}\r\n.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {\r\n  background-color: $primary;\r\n  color: $white;\r\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\r\n}\r\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\r\n  border-bottom-color: $white;\r\n}\r\n.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n.bootstrap-datetimepicker-widget table td span {\r\n  display: inline-block;\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  margin: 0 3px;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td span.active {\r\n  background-color: $primary;\r\n  color: #FFFFFF;\r\n}\r\n.bootstrap-datetimepicker-widget table td span.old {\r\n  color: #cfcfca;\r\n}\r\n.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n.bootstrap-datetimepicker-widget .timepicker-picker span,\r\n.bootstrap-datetimepicker-widget .timepicker-hours span,\r\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\r\n  border-radius: 50% !important;\r\n}\r\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\r\n  height: 27px;\r\n  line-height: 27px;\r\n}\r\n\r\n.input-group.date .input-group-addon {\r\n  cursor: pointer;\r\n}\r\n\r\n.table-condensed > tbody > tr > td,\r\n.table-condensed > tbody > tr > th,\r\n.table-condensed > tfoot > tr > td,\r\n.table-condensed > tfoot > tr > th,\r\n.table-condensed > thead > tr > td,\r\n.table-condensed > thead > tr > th {\r\n  padding: 1px;\r\n  text-align: center;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .separator{\r\n    position: relative;\r\n    color: red;\r\n    width: auto;\r\n    height: auto;\r\n\r\n}\r\n\r\ninput.datetimepicker[data-color] + .bootstrap-datetimepicker-widget{\r\n    .picker-switch,\r\n    table th.prev span,\r\n    table th.next span,\r\n    table td.day > div,\r\n    a[data-action=\"togglePicker\"],\r\n    a[data-action=\"togglePicker\"]:hover,\r\n    span,\r\n    .timepicker-hours span,\r\n    .timepicker-minutes span,\r\n    .separator,\r\n    table td.minute > div,\r\n    table td.hour > div{\r\n        color: #9A9A9A;\r\n    }\r\n\r\n\r\n\r\n    table th.dow{\r\n         color: rgba(255,255,255, .8)\r\n    }\r\n\r\n    table td.old > div,\r\n    table td.new > div{\r\n        color: rgba(255,255,255, .4);\r\n    }\r\n\r\n    button[data-action]{\r\n        background-color: $white;\r\n    }\r\n\r\n    table td.active > div,\r\n    table td.active:hover > div{\r\n        background-color: $white;\r\n    }\r\n\r\n    table td:not(.active).day:hover > div,\r\n    table td.hour:hover > div,\r\n    table td.minute:hover > div,\r\n    table td.second:hover > div,\r\n    table td span:hover{\r\n         background: rgba(255,255,255, .2);\r\n    }\r\n\r\n    table thead tr:first-child th:hover span,\r\n    table thead tr:first-child th.picker-switch:hover{\r\n         background-color: rgba(255,255,255, .2);\r\n    }\r\n}\r\n\r\n\r\ninput.datetimepicker[data-color=\"orange\"] + .bootstrap-datetimepicker-widget{\r\n    background-color: $primary;\r\n\r\n    table td.active > div,\r\n    table td.active:hover > div,\r\n    button[data-action],\r\n    &.dropdown-menu.top:after,\r\n    &.dropdown-menu.bottom:before{\r\n        color: $primary;\r\n    }\r\n}\r\n\r\ninput.datetimepicker[data-color=\"blue\"] + .bootstrap-datetimepicker-widget{\r\n    background-color: $info;\r\n\r\n    table td.active > div,\r\n    table td.active:hover > div,\r\n    button[data-action],\r\n    &.dropdown-menu.top:after,\r\n    &.dropdown-menu.bottom:before{\r\n        color: $info;\r\n    }\r\n}\r\n\r\ninput.datetimepicker[data-color=\"green\"] + .bootstrap-datetimepicker-widget{\r\n    background-color: $success;\r\n\r\n    table td.active > div,\r\n    table td.active:hover > div,\r\n    button[data-action],\r\n    &.dropdown-menu.top:after,\r\n    &.dropdown-menu.bottom:before{\r\n        color: $success;\r\n    }\r\n}\r\n\r\ninput.datetimepicker[data-color=\"red\"] + .bootstrap-datetimepicker-widget{\r\n    background-color: $danger;\r\n\r\n    table td.active > div,\r\n    table td.active:hover > div,\r\n    button[data-action],\r\n    &.dropdown-menu.top:after,\r\n    &.dropdown-menu.bottom:before{\r\n        color: $danger;\r\n    }\r\n}\r\n\r\ninput.datetimepicker[data-color=\"yellow\"] + .bootstrap-datetimepicker-widget{\r\n    background-color: $warning;\r\n\r\n    table td.active > div,\r\n    table td.active:hover > div,\r\n    button[data-action],\r\n    &.dropdown-menu.top:after,\r\n    &.dropdown-menu.bottom:before{\r\n        color: $warning;\r\n    }\r\n}\r\n\r\n\r\n.bootstrap-datetimepicker-widget {\r\n  &.dropdown-black {\r\n    .datepicker-days {\r\n      .day, .minute{\r\n        color: rgba(255, 255, 255, 0.7);\r\n\r\n        &:hover {\r\n          color: #212529;\r\n        }\r\n      }\r\n    }\r\n\r\n    table td span, table td.minute, table td.hour{\r\n      color: rgba(255, 255, 255, 0.7);\r\n    }\r\n    table td span:hover, table td.minute:hover, table td.hour:hover {\r\n      background: transparent;\r\n      color: rgba(255, 255, 255, 0.4);\r\n\r\n    div{\r\n      background: transparent;\r\n    }\r\n\r\n    }\r\n\r\n    table td .btn[data-action] {\r\n      color: $white;\r\n    }\r\n\r\n    table td .btn[data-action=\"togglePeriod\"] {\r\n      background: transparent;\r\n    }\r\n  }\r\n}\r\n",".dropzone {\r\n  .dz-button {\r\n    padding: 0;\r\n    border: none;\r\n    text-align: center;\r\n    color: $gray-600;\r\n    -webkit-transition: all .15s ease;\r\n    transition: all .15s ease;\r\n    cursor: pointer;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.4;\r\n  }\r\n}\r\n",".fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {\r\n  float: right;\r\n}\r\n.fc-dayGrid-view .fc-body .fc-row {\r\n  min-height: 4em;\r\n}\r\n.fc {\r\n  &.fc-theme-standard td, &.fc-theme-standard th, &.fc-theme-standard .fc-scrollgrid {\r\n    border-color: lighten($table-border-color,2%) !important;\r\n  }\r\n  .fc-h-event {\r\n    border: none;\r\n  }\r\n  .fc-col-header-cell.fc-day  {\r\n    text-align: left;\r\n    padding: .75rem 1rem;\r\n    .fc-col-header-cell-cushion {\r\n      padding: 0;\r\n      color: $gray-600;\r\n    }\r\n  }\r\n  .fc-day .fc-daygrid-day-top {\r\n    flex-direction: row;\r\n    .fc-daygrid-day-number {\r\n      font-size: $font-size-sm;\r\n      font-weight: $font-weight-bold;\r\n      color: lighten($body-color,10%);\r\n      padding: .5rem 1rem;\r\n    }\r\n  }\r\n  .fc-daygrid-day.fc-day-today{\r\n    background-color: inherit !important;\r\n    .fc-daygrid-day-top {\r\n      .fc-daygrid-day-number {\r\n        color: $orange;\r\n      }\r\n    }\r\n  }\r\n  .fc-event {\r\n    margin: 2px 9px 1px !important;\r\n  }\r\n  .fc-event-main {\r\n      padding: 0;\r\n      font-size: $font-size-xs;\r\n      border-radius: $border-radius-sm;\r\n      border: 0;\r\n\r\n      .fc-event-title {\r\n          padding: .4rem .5rem;\r\n          display: block;\r\n          color: $white;\r\n          @include text-truncate();\r\n          font-weight: $font-weight-bold;\r\n      }\r\n\r\n      .fc-time {\r\n          float: left;\r\n          background: rgba($black,0.2);\r\n          padding: 2px 6px;\r\n          margin: 0 0 0 -1px;\r\n      }\r\n  }\r\n}\r\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// Original styles\r\n.noUi-target,\r\n.noUi-target * {\r\n    -webkit-touch-callout: none;\r\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n    -webkit-user-select: none;\r\n    touch-action: none;\r\n    user-select: none;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.noUi-target {\r\n    position: relative;\r\n    direction: ltr;\r\n}\r\n\r\n.noUi-base,\r\n.noUi-connects {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n/* Wrapper for all connect elements.\r\n */\r\n\r\n.noUi-connects {\r\n    overflow: hidden;\r\n    z-index: 0;\r\n}\r\n\r\n.noUi-connect,\r\n.noUi-origin {\r\n  will-change: transform;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  -ms-transform-origin: 0 0;\r\n  -webkit-transform-origin: 0 0;\r\n  -webkit-transform-style: preserve-3d;\r\n  transform-origin: 0 0;\r\n  transform-style: flat;\r\n}\r\n\r\n.noUi-connect {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.noUi-origin {\r\n  height: 10%;\r\n  width: 10%;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n\r\n.noUi-vertical .noUi-origin {\r\n    width: 0;\r\n}\r\n\r\n.noUi-horizontal .noUi-origin {\r\n    height: 0;\r\n}\r\n\r\n.noUi-handle {\r\n  -webkit-backface-visibility: hidden;\r\n   backface-visibility: hidden;\r\n   position: absolute;\r\n}\r\n\r\n.noUi-touch-area {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n  -webkit-transition: transform 0.3s;\r\n   transition: transform 0.3s;\r\n}\r\n\r\n.noUi-state-drag * {\r\n    cursor: inherit !important;\r\n}\r\n\r\n.noUi-horizontal {\r\n    height: $noui-target-thickness;\r\n}\r\n\r\n.noUi-horizontal .noUi-handle {\r\n    width: 34px;\r\n    height: 28px;\r\n    left: -17px;\r\n    top: -6px;\r\n}\r\n\r\n.noUi-vertical {\r\n    width: $noui-target-thickness;\r\n}\r\n\r\n.noUi-vertical .noUi-handle {\r\n    width: 28px;\r\n    height: 34px;\r\n    left: -6px;\r\n    top: -17px;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n    right: -17px;\r\n    left: auto;\r\n}\r\n\r\n.noUi-connects {\r\n    border-radius: 3px;\r\n}\r\n\r\n.noUi-connect {\r\n    background: $noui-slider-connect-bg;\r\n}\r\n\r\n.noUi-draggable {\r\n    cursor: ew-resize;\r\n}\r\n\r\n.noUi-vertical .noUi-draggable {\r\n    cursor: ns-resize;\r\n}\r\n\r\n.noUi-handle {\r\n    border: 1px solid #D9D9D9;\r\n    border-radius: 3px;\r\n    background: #FFF;\r\n    cursor: default;\r\n    box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\r\n    outline: none;\r\n}\r\n\r\n.noUi-active {\r\n    outline: none;\r\n    //box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\r\n}\r\n\r\n\r\n/* Disabled state;\r\n */\r\n\r\n[disabled] .noUi-connect {\r\n    background: #B8B8B8;\r\n}\r\n\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n    cursor: not-allowed;\r\n}\r\n\r\n\r\n/* Base;\r\n *\r\n */\r\n\r\n.noUi-pips,\r\n.noUi-pips * {\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.noUi-pips {\r\n    position: absolute;\r\n    color: #999;\r\n}\r\n\r\n\r\n/* Values;\r\n *\r\n */\r\n\r\n.noUi-value {\r\n    position: absolute;\r\n    white-space: nowrap;\r\n    text-align: center;\r\n}\r\n\r\n.noUi-value-sub {\r\n    color: #ccc;\r\n    font-size: 10px;\r\n}\r\n\r\n\r\n/* Markings;\r\n *\r\n */\r\n\r\n.noUi-marker {\r\n    position: absolute;\r\n    background: #CCC;\r\n}\r\n\r\n.noUi-marker-sub {\r\n    background: #AAA;\r\n}\r\n\r\n.noUi-marker-large {\r\n    background: #AAA;\r\n}\r\n\r\n\r\n/* Horizontal layout;\r\n *\r\n */\r\n\r\n.noUi-pips-horizontal {\r\n    padding: 10px 0;\r\n    height: 80px;\r\n    top: 100%;\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.noUi-value-horizontal {\r\n  -webkit-transform: translate(-50%, 50%);\r\n    transform: translate(-50%, 50%);\r\n}\r\n\r\n.noUi-rtl .noUi-value-horizontal {\r\n  -webkit-transform: translate(50%, 50%);\r\n  transform: translate(50%, 50%);\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker {\r\n    margin-left: -1px;\r\n    width: 2px;\r\n    height: 5px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n    height: 10px;\r\n}\r\n\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n    height: 15px;\r\n}\r\n\r\n\r\n/* Vertical layout;\r\n *\r\n */\r\n\r\n.noUi-pips-vertical {\r\n    padding: 0 10px;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 100%;\r\n}\r\n\r\n.noUi-value-vertical {\r\n    -webkit-transform: translate(0, -50%);\r\n    transform: translate(0, -50%, 0);\r\n    padding-left: 25px;\r\n}\r\n\r\n.noUi-rtl .noUi-value-vertical {\r\n    -webkit-transform: translate(0, 50%);\r\n    transform: translate(0, 50%);\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker {\r\n    width: 5px;\r\n    height: 2px;\r\n    margin-top: -1px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n    width: 10px;\r\n}\r\n\r\n.noUi-marker-vertical.noUi-marker-large {\r\n    width: 15px;\r\n}\r\n\r\n.noUi-tooltip {\r\n    display: block;\r\n    position: absolute;\r\n    border: 1px solid #D9D9D9;\r\n    border-radius: 3px;\r\n    background: #fff;\r\n    color: #000;\r\n    padding: 5px;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n}\r\n\r\n.noUi-horizontal .noUi-tooltip {\r\n    -webkit-transform: translate(-50%, 0);\r\n    transform: translate(-50%, 0);\r\n    left: 50%;\r\n    bottom: 120%;\r\n}\r\n\r\n.noUi-vertical .noUi-tooltip {\r\n    -webkit-transform: translate(0, -50%);\r\n    transform: translate(0, -50%);\r\n    top: 50%;\r\n    right: 120%;\r\n}\r\n\r\n\r\n//  Custom styles\r\n\r\n.noUi-target {\r\n    background: $noui-target-bg;\r\n    border-radius: $noui-target-border-radius;\r\n    border: 0;\r\n    box-shadow: $noui-target-box-shadow;\r\n    margin: 15px 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.noUi-horizontal {\r\n    height: $noui-target-thickness;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n    right: -10px;\r\n}\r\n\r\n.noUi-vertical {\r\n    width: $noui-target-thickness;\r\n}\r\n\r\n.noUi-connect {\r\n    background: theme-color(\"primary\");\r\n    box-shadow: none;\r\n}\r\n\r\n.noUi-handle {\r\n\r\n}\r\n\r\n.noUi-horizontal .noUi-handle,\r\n.noUi-vertical .noUi-handle {\r\n    top: -$noui-target-thickness;\r\n    width: $noui-handle-width;\r\n    height: $noui-handle-width;\r\n    border-radius: 100%;\r\n    box-shadow: none;\r\n    cursor: pointer;\r\n    background-color: $noui-handle-bg;\r\n    border: $noui-handle-border;\r\n    transition: box-shadow .15s, transform .15s;\r\n}\r\n\r\n\r\n.noUi-horizontal .noUi-handle.noUi-active,\r\n.noUi-vertical .noUi-handle.noUi-active {\r\n    transform: scale(1.2);\r\n}\r\n\r\n.noUi-horizontal .noUi-active,\r\n.noUi-vertical .noUi-active {\r\n    //box-shadow: 0 0 3px 1px rgba(0, 0, 0, .1);\r\n}\r\n\r\n.input-slider--cyan .noUi-connect {\r\n    background: $cyan;\r\n}\r\n\r\n.input-slider--cyan.noUi-horizontal .noUi-handle,\r\n.input-slider--cyan.noUi-vertical .noUi-handle {\r\n    background-color: $cyan;\r\n}\r\n\r\n.input-slider--red .noUi-connect {\r\n    background: $red;\r\n}\r\n\r\n.input-slider--red.noUi-horizontal .noUi-handle,\r\n.input-slider--red.noUi-vertical .noUi-handle {\r\n    background-color: $red;\r\n}\r\n\r\n.input-slider--green .noUi-connect {\r\n    background: $green;\r\n}\r\n\r\n.input-slider--green.noUi-horizontal .noUi-handle,\r\n.input-slider--green.noUi-vertical .noUi-handle {\r\n    background-color: $green;\r\n}\r\n\r\n.input-slider--yellow .noUi-connect {\r\n    background: $yellow;\r\n}\r\n\r\n.input-slider--yellow.noUi-horizontal .noUi-handle,\r\n.input-slider--yellow.noUi-vertical .noUi-handle {\r\n    background-color: $yellow;\r\n}\r\n\r\n.input-slider--pink .noUi-connect {\r\n    background: $pink;\r\n}\r\n\r\n.input-slider--pink.noUi-horizontal .noUi-handle,\r\n.input-slider--pink.noUi-vertical .noUi-handle {\r\n    background-color: $pink;\r\n}\r\n/* Disabled state */\r\n[disabled] .noUi-connect,\r\n[disabled].noUi-connect {\r\n    background: $noui-slider-connect-disabled-bg;\r\n}\r\n\r\n[disabled] .noUi-handle,\r\n[disabled].noUi-origin {\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Range slider value labels */\r\n.range-slider-value {\r\n    font-size: $font-size-xs;\r\n    font-weight: 500;\r\n    background-color: rgba($dark, .7);\r\n    color: color-yiq($dark);\r\n    border-radius: 10px;\r\n    padding: .4em .8em .3em .85em;\r\n}\r\n\r\n.range-slider-wrapper .upper-info {\r\n    font-weight: 400;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.input-slider-value-output {\r\n    background: #333;\r\n    color: #fff;\r\n    padding: 4px 8px;\r\n    position: relative;\r\n    top: 12px;\r\n    font-size: 11px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.input-slider-value-output:after {\r\n    bottom: 100%;\r\n    left: 10px;\r\n    border: solid transparent;\r\n    content: \" \";\r\n    height: 0;\r\n    width: 0;\r\n    position: absolute;\r\n    pointer-events: none;\r\n    border-color: rgba(136, 183, 213, 0);\r\n    border-bottom-color: #333;\r\n    border-width: 4px;\r\n    margin-left: -4px;\r\n}\r\n\r\n.input-slider-value-output.left:after {\r\n    left: 10px;\r\n    right: auto;\r\n}\r\n\r\n.input-slider-value-output.right:after {\r\n    right: 10px;\r\n    left: auto;\r\n}\r\n",".react-bootstrap-table{\r\n  .table{\r\n    margin-bottom: 1.25rem;\r\n    border-bottom: 1px solid $gray-200;\r\n  }\r\n  th{\r\n    color: $gray-600;\r\n    background-color: $gray-100;\r\n    &.sortable{\r\n      position: relative;\r\n    }\r\n  }\r\n  .order-4,.caret-4-asc,.caret-4-desc{\r\n    &:after{\r\n      right: 0.5em;\r\n      content: \"\\2193\";\r\n    }\r\n    &:before{\r\n      right: 1em;\r\n      content: \"\\2191\";\r\n    }\r\n    &:after,&:before{\r\n      position: absolute;\r\n      bottom: 1.1em;\r\n      display: block;\r\n      opacity: 0.3;\r\n    }\r\n  }\r\n  .caret-4-asc:before{\r\n    opacity: 1;\r\n  }\r\n  .caret-4-desc:after{\r\n    opacity: 1;\r\n  }\r\n}\r\n.react-bootstrap-table-pagination{\r\n  .dataTables_length{\r\n    display: inline-block;\r\n    label {\r\n      font-weight: normal;\r\n      text-align: left;\r\n      white-space: nowrap;\r\n      display: inline-block;\r\n      margin-bottom: .5rem;\r\n    }\r\n    select {\r\n      width: auto;\r\n      display: inline-block;\r\n      &.form-control-sm{\r\n        height: calc(1.8125rem + 6px);\r\n      }\r\n    }\r\n  }\r\n  .dataTables_length,.react-bootstrap-table-pagination-total{\r\n    font-size: .875rem;\r\n  }\r\n  .react-bootstrap-table-pagination-list{\r\n    .pagination {\r\n      justify-content: flex-end;\r\n      padding-right: 1.5rem;\r\n    }\r\n  }\r\n}\r\n.dataTables_filter{\r\n  font-weight: normal;\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  float: left;\r\n  input {\r\n    margin-left: 0.5em;\r\n    display: inline-block;\r\n    width: auto;\r\n  }\r\n}\r\n","/*!\r\n* https://github.com/YouCanBookMe/react-datetime\r\n*/\r\n.rdt {\r\n  position: relative;\r\n\r\n  .rdtPicker {\r\n    -webkit-transition: all 150ms linear;\r\n    -moz-transition: all 150ms linear;\r\n    -o-transition: all 150ms linear;\r\n    -ms-transition: all 150ms linear;\r\n    transition: all 150ms linear;\r\n    margin-top: -20px;\r\n    visibility: hidden;\r\n    display: block;\r\n    opacity: 0;\r\n  }\r\n  &.rdtOpen {\r\n    .rdtPicker {\r\n      opacity: 1;\r\n      visibility: visible;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n.rdtPicker {\r\n  display: none;\r\n  position: absolute;\r\n  padding: 20px;\r\n  margin-top: 1px;\r\n  z-index: 99999 !important;\r\n  background: #fff;\r\n  border-radius: .375rem;\r\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n  -webkit-background-clip: padding-box;\r\n  background-clip: padding-box;\r\n  min-width: 292px;\r\n  @include media-breakpoint-down(xs) {\r\n    padding: 5px;\r\n    min-width: 262px;\r\n  }\r\n}\r\n\r\n.rdtPicker {\r\n  display: block;\r\n  top: 50px;\r\n}\r\n.rdtStatic .rdtPicker {\r\n  box-shadow: none;\r\n  position: static;\r\n}\r\n\r\n.rdtPicker .rdtTimeToggle {\r\n  text-align: center;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  visibility: hidden;\r\n  position: relative;\r\n  &:before {\r\n    visibility: visible;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 3px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font: normal normal normal 1em/1 \"Nucleo\";\r\n    font-size: 18px;\r\n    content: \"\\EA5E\";\r\n  }\r\n}\r\n\r\n.rdtPicker table {\r\n  width: 100%;\r\n  margin: 0;\r\n  border-color: $white !important;\r\n}\r\n.rdtPicker td,\r\n.rdtPicker th {\r\n  text-align: center;\r\n  padding: 1px;\r\n}\r\n.rdtPicker td {\r\n  cursor: pointer;\r\n}\r\n.rdtDay {\r\n  font-size: .875rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  transition: all .15s ease;\r\n  text-align: center;\r\n  border: none;\r\n  border-radius: 50%;\r\n  &.rdtToday.rdtActive,\r\n  &.rdtActive,\r\n  &.rdtActive:hover,\r\n  &.start-date,\r\n  &.end-date,\r\n  &.middle-date,\r\n  &.start-date:hover,\r\n  &.end-date:hover,\r\n  &.middle-date:hover {\r\n    background-color: $info !important;\r\n    color: $white !important;\r\n  }\r\n  &.start-date{\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n  &.middle-date{\r\n    border-radius: 0;\r\n  }\r\n  &.end-date{\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n}\r\n.rdtDays {\r\n  tr {\r\n    .dow {\r\n      text-align: center;\r\n      font-size: 12px;\r\n      font-weight: inherit;\r\n      padding-bottom: 5px;\r\n      padding-top: 10px;\r\n      font-weight: 300;\r\n      font-size: .875rem;\r\n      width: 20px;\r\n      height: 20px;\r\n    }\r\n    .rdtDay {\r\n      color: $gray-700;\r\n      font-size: .875rem;\r\n      &.rdtOld,\r\n      &.rdtNew {\r\n        color: $gray-500;\r\n        font-weight: 300;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.rdtPicker td.rdtDay:hover,\r\n.rdtPicker td.rdtHour:hover,\r\n.rdtPicker td.rdtMinute:hover,\r\n.rdtPicker td.rdtSecond:hover,\r\n.rdtPicker .rdtTimeToggle:hover,\r\n.rdtPicker .rdtTimeToggle:hover:before {\r\n  background: #eeeeee;\r\n  cursor: pointer;\r\n}\r\n.rdtPicker td.rdtToday {\r\n  position: relative;\r\n}\r\n.rdtPicker td.rdtActive.rdtToday:before {\r\n  border-bottom-color: #fff;\r\n}\r\n.rdtPicker td.rdtDisabled,\r\n.rdtPicker td.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rdtPicker td span.rdtOld {\r\n  color: #999999;\r\n}\r\n.rdtPicker td span.rdtDisabled,\r\n.rdtPicker td span.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n.rdtPicker tr .dow {\r\n  width: 14.2857%;\r\n  border-bottom: none;\r\n  font-size: .875rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  transition: all .15s ease;\r\n  text-align: center;\r\n  border: none;font-weight: 500;\r\n  border-radius: .375rem;\r\n}\r\n.rdtPicker th.rdtSwitch {\r\n  font-weight: 500;\r\n  border-radius: .375rem;\r\n  font-size: .875rem;\r\n  width: 145px;\r\n  height: 36px;\r\n  transition: all .15s ease;\r\n  text-align: center;\r\n  border: none;\r\n}\r\n.rdtPicker th.rdtNext,\r\n.rdtPicker th.rdtPrev {\r\n  font-size: .875rem;\r\n  width: 36px;\r\n  height: 36px;\r\n  transition: all .15s ease;\r\n  text-align: center;\r\n  border: none;\r\n  border-radius: .375rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.rdtPicker {\r\n  .dow,\r\n  th.rdtSwitch,\r\n  th.rdtNext,\r\n  th.rdtPrev,\r\n  .rdtTimeToggle {\r\n    color: $gray-700;\r\n  }\r\n}\r\n\r\n.rdtPrev span,\r\n.rdtNext span {\r\n  display: block;\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none; /* Konqueror */\r\n  -moz-user-select: none; /* Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n\r\n.rdtPicker th.rdtDisabled,\r\n.rdtPicker th.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n.rdtPicker thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n.rdtPicker thead tr:first-child th:hover {\r\n  background: #eeeeee;\r\n}\r\n\r\n.rdtPicker button {\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n.rdtPicker button:hover {\r\n  background-color: #eee;\r\n}\r\n\r\n.rdtPicker thead button {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\ntd.rdtMonth,\r\ntd.rdtYear {\r\n  height: 50px;\r\n  width: 25%;\r\n  cursor: pointer;\r\n}\r\ntd.rdtMonth:hover,\r\ntd.rdtYear:hover {\r\n  background: #eee;\r\n}\r\n\r\n.rdtCounters {\r\n  display: inline-block;\r\n}\r\n\r\n.rdtCounters {\r\n  > div {\r\n    float: left;\r\n    width: 40px;\r\n    font-weight: inherit;\r\n    margin: 3px;\r\n    border-radius: 50%;\r\n  }\r\n  .rdtCounterSeparator {\r\n    width: 0;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n\r\n.rdtCounter {\r\n  height: 100px;\r\n}\r\n\r\n.rdtCounter {\r\n  width: 40px;\r\n  .rdtCount {\r\n    padding: 7px;\r\n    height: 40px;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n.rdtCounters {\r\n  .rdtCounter:last-child {\r\n    .rdtCount {\r\n      color: $info;\r\n      border-radius: 50%;\r\n      border: 1px solid $info;\r\n    }\r\n  }\r\n}\r\n\r\n.rdtCounterSeparator {\r\n  padding: 7px;\r\n  line-height: 100px;\r\n}\r\n.rdtCounter .rdtBtn {\r\n  line-height: 40px;\r\n  cursor: pointer;\r\n  display: block;\r\n  border-radius: 50%;\r\n  color: $gray-500;\r\n  -webkit-transition: all 60ms ease-in;\r\n  -moz-transition: all 60ms ease-in;\r\n  -o-transition: all 60ms ease-in;\r\n  -ms-transition: all 60ms ease-in;\r\n  transition: all 60ms ease-in;\r\n\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none; /* Konqueror */\r\n  -moz-user-select: none; /* Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n.rdtCounter .rdtBtn:hover {\r\n  background: #eee;\r\n  color: #797979;\r\n}\r\n.rdtCounter .rdtCount {\r\n  font-size: inherit;\r\n  line-height: 25px;\r\n}\r\n\r\n.rdtMilli {\r\n  vertical-align: middle;\r\n  padding-left: 8px;\r\n  width: 48px;\r\n}\r\n\r\n.rdtMilli input {\r\n  width: 100%;\r\n  font-size: inherit;\r\n  margin-top: 37px;\r\n}\r\n.rdtMonths,\r\n.rdtYears {\r\n  padding-bottom: 10px;\r\n  .rdtMonth,\r\n  .rdtYear {\r\n    display: inline-block;\r\n    width: 56px;\r\n    height: 56px;\r\n    line-height: 56px;\r\n    margin: 3px 3px;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n\r\n    &.rdtActive,\r\n    &.start-date,\r\n    &.end-date,\r\n    &.middle-date {\r\n      background-color: $info !important;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n.input-group .input-group-prepend + .rdt .form-control{\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n.input-group .input-group-prepend + .rdt .form-control{\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n.input-group > .rdt:not(:last-child) .form-control{\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.form-group .rdt {\r\n  margin-bottom: 0;\r\n  flex: 1 1 auto;\r\n}\r\n",".vector-map{\r\n  .jvectormap-zoomin,\r\n  .jvectormap-zoomout {\r\n    cursor: pointer;\r\n    margin-right: .5rem;\r\n    font-size: .75rem;\r\n    transition: all .15s ease;\r\n    letter-spacing: .025em;\r\n    text-transform: none;\r\n    will-change: transform;\r\n    line-height: 1.5;\r\n    padding: .25rem .5rem;\r\n    border-radius: .25rem;\r\n    color: #fff;\r\n    border-color: #5e72e4;\r\n    background-color: #5e72e4;\r\n    box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);\r\n    font-weight: 600;\r\n    display: inline-block;\r\n    user-select: none;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    white-space: nowrap;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n",".rna-wrapper {\r\n  .alert {\r\n    display: flex !important;\r\n    max-width: 600px;\r\n    width: calc(100% - 30px);\r\n    padding-right: 80px;\r\n    box-shadow: 0 3px 10px rgba($black, 0.15);\r\n    color: rgba($white, 0.85);\r\n\r\n    &:hover {\r\n      z-index: 1081 !important;\r\n    }\r\n\r\n    &:not(.alert-info):not(.alert-success):not(.alert-warning):not(.alert-danger) {\r\n      background-color: rgba($black, .95);\r\n\r\n      .alert-notify-close {\r\n        color: $yellow;\r\n\r\n        &:hover {\r\n          opacity: .8;\r\n        }\r\n      }\r\n    }\r\n\r\n    .ni[data-notify=\"icon\"] {\r\n      position: relative;\r\n      top: 4px;\r\n    }\r\n\r\n    .alert-title {\r\n      display: block;\r\n      font-size: $font-size-base;\r\n      font-weight: $font-weight-bold;\r\n    }\r\n\r\n    .close {\r\n      top: $alert-padding-y !important;\r\n      right: $alert-padding-x !important;\r\n      transform: translateY(0);\r\n    }\r\n    [data-notify=\"icon\"] {\r\n      font-size: 1.25rem;\r\n      margin-right: 1.25rem;\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n}\r\n",".ql-container {\r\n  position: relative;\r\n}\r\n.ql-tooltip {\r\n  z-index: 1050;\r\n}\r\n",".ReactTable {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.ReactTable * {\r\n    box-sizing: border-box\r\n}\r\n\r\n.ReactTable .rt-table {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: auto 1;\r\n    flex: auto 1;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-align: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-items: stretch;\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    overflow: auto\r\n}\r\n\r\n.ReactTable .rt-thead {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1 0 auto;\r\n    flex: 1 0 auto;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n.ReactTable .rt-thead.-headerGroups {\r\n    background: rgba(0, 0, 0, 0.03);\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05)\r\n}\r\n\r\n.ReactTable .rt-thead.-filters {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-thead.-filters input,\r\n.ReactTable .rt-thead.-filters select {\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n    background: #fff;\r\n    padding: 5px 7px;\r\n    font-size: inherit;\r\n    border-radius: 3px;\r\n    font-weight: normal;\r\n    outline: none\r\n}\r\n\r\n.ReactTable .rt-thead.-filters .rt-th {\r\n    border-right: 1px solid rgba(0, 0, 0, 0.02)\r\n}\r\n\r\n.ReactTable .rt-thead.-header {\r\n    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15)\r\n}\r\n\r\n.ReactTable .rt-thead .rt-tr {\r\n    text-align: center\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th,\r\n.ReactTable .rt-thead .rt-td {\r\n    padding: 5px 5px;\r\n    line-height: normal;\r\n    position: relative;\r\n    border-right: 1px solid rgba(0, 0, 0, 0.05);\r\n    transition: box-shadow .3s cubic-bezier(.175, .885, .32, 1.275);\r\n    box-shadow: inset 0 0 0 0 transparent;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th.-sort-asc,\r\n.ReactTable .rt-thead .rt-td.-sort-asc {\r\n    box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6)\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th.-sort-desc,\r\n.ReactTable .rt-thead .rt-td.-sort-desc {\r\n    box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6)\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\r\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\r\n    cursor: pointer\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th:last-child,\r\n.ReactTable .rt-thead .rt-td:last-child {\r\n    border-right: 0\r\n}\r\n\r\n.ReactTable .rt-thead .rt-th:focus {\r\n    outline: none\r\n}\r\n\r\n.ReactTable .rt-thead .rt-resizable-header {\r\n    overflow: visible;\r\n}\r\n\r\n.ReactTable .rt-thead .rt-resizable-header:last-child {\r\n    overflow: hidden\r\n}\r\n\r\n.ReactTable .rt-thead .rt-resizable-header-content {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot {\r\n    border-right-color: #f7f7f7\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot:after,\r\n.ReactTable .rt-thead .rt-header-pivot:before {\r\n    left: 100%;\r\n    top: 50%;\r\n    border: solid transparent;\r\n    content: \" \";\r\n    height: 0;\r\n    width: 0;\r\n    position: absolute;\r\n    pointer-events: none\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot:after {\r\n    border-color: rgba(255, 255, 255, 0);\r\n    border-left-color: #fff;\r\n    border-width: 8px;\r\n    margin-top: -8px\r\n}\r\n\r\n.ReactTable .rt-thead .rt-header-pivot:before {\r\n    border-color: rgba(102, 102, 102, 0);\r\n    border-left-color: #f7f7f7;\r\n    border-width: 10px;\r\n    margin-top: -10px\r\n}\r\n\r\n.ReactTable .rt-tbody {\r\n    -webkit-box-flex: 99999;\r\n    -ms-flex: 99999 1 auto;\r\n    flex: 99999 1 auto;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-tr-group {\r\n    border-bottom: solid 1px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-tr-group:last-child {\r\n    border-bottom: 0\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-td {\r\n    border-right: 1px solid rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-td:last-child {\r\n    border-right: 0\r\n}\r\n\r\n.ReactTable .rt-tbody .rt-expandable {\r\n    cursor: pointer;\r\n    text-overflow: clip\r\n}\r\n\r\n.ReactTable .rt-tr-group {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1 0 auto;\r\n    flex: 1 0 auto;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-align: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-items: stretch\r\n}\r\n\r\n.ReactTable .rt-tr {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1 0 auto;\r\n    flex: 1 0 auto;\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex\r\n}\r\n\r\n.ReactTable .rt-th,\r\n.ReactTable .rt-td {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1 0 0px;\r\n    flex: 1 0 0;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    padding: 7px 5px;\r\n    overflow: hidden;\r\n    transition: .3s ease;\r\n    transition-property: width, min-width, padding, opacity;\r\n}\r\n\r\n.ReactTable .rt-th.-hidden,\r\n.ReactTable .rt-td.-hidden {\r\n    width: 0 !important;\r\n    min-width: 0 !important;\r\n    padding: 0 !important;\r\n    border: 0 !important;\r\n    opacity: 0 !important\r\n}\r\n\r\n.ReactTable .rt-expander {\r\n    display: inline-block;\r\n    position: relative;\r\n    margin: 0;\r\n    color: transparent;\r\n    margin: 0 10px;\r\n}\r\n\r\n.ReactTable .rt-expander:after {\r\n    content: '';\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%) rotate(-90deg);\r\n    transform: translate(-50%, -50%) rotate(-90deg);\r\n    border-left: 5.04px solid transparent;\r\n    border-right: 5.04px solid transparent;\r\n    border-top: 7px solid rgba(0, 0, 0, 0.8);\r\n    transition: all .3s cubic-bezier(.175, .885, .32, 1.275);\r\n    cursor: pointer\r\n}\r\n\r\n.ReactTable .rt-expander.-open:after {\r\n    -webkit-transform: translate(-50%, -50%) rotate(0);\r\n    transform: translate(-50%, -50%) rotate(0)\r\n}\r\n\r\n.ReactTable .rt-resizer {\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 36px;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: -18px;\r\n    cursor: col-resize;\r\n    z-index: 10\r\n}\r\n\r\n.ReactTable .rt-tfoot {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1 0 auto;\r\n    flex: 1 0 auto;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.ReactTable .rt-tfoot .rt-td {\r\n    border-right: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ReactTable .rt-tfoot .rt-td:last-child {\r\n    border-right: 0\r\n}\r\n\r\n.ReactTable.-striped .rt-tr.-odd {\r\n    background: rgba(0, 0, 0, 0.03)\r\n}\r\n\r\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\r\n    background: rgba(0, 0, 0, 0.05)\r\n}\r\n\r\n.ReactTable .-pagination {\r\n    z-index: 1;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    -webkit-box-align: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-items: stretch;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    padding: 3px;\r\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);\r\n    border-top: 2px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.ReactTable .-pagination input,\r\n.ReactTable .-pagination select {\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n    background: #fff;\r\n    padding: 5px 7px;\r\n    font-size: inherit;\r\n    border-radius: 3px;\r\n    font-weight: normal;\r\n    outline: none\r\n}\r\n\r\n.ReactTable .-pagination .-btn {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n    border-radius: 3px;\r\n    padding: 6px;\r\n    font-size: 1em;\r\n    color: rgba(0, 0, 0, 0.6);\r\n    background: rgba(0, 0, 0, 0.1);\r\n    transition: all .1s ease;\r\n    cursor: pointer;\r\n    outline: none;\r\n}\r\n\r\n.ReactTable .-pagination .-btn[disabled] {\r\n    opacity: .5;\r\n    cursor: default\r\n}\r\n\r\n.ReactTable .-pagination .-btn:not([disabled]):hover {\r\n    background: rgba(0, 0, 0, 0.3);\r\n    color: #fff\r\n}\r\n\r\n.ReactTable .-pagination .-previous,\r\n.ReactTable .-pagination .-next {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1;\r\n    flex: 1;\r\n    text-align: center\r\n}\r\n\r\n.ReactTable .-pagination .-center {\r\n    -webkit-box-flex: 1.5;\r\n    -ms-flex: 1.5;\r\n    flex: 1.5;\r\n    text-align: center;\r\n    margin-bottom: 0;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -ms-flex-pack: distribute;\r\n    justify-content: space-around\r\n}\r\n\r\n.ReactTable .-pagination .-pageInfo {\r\n    display: inline-block;\r\n    margin: 3px 10px;\r\n    white-space: nowrap\r\n}\r\n\r\n.ReactTable .-pagination .-pageJump {\r\n    display: inline-block;\r\n}\r\n\r\n.ReactTable .-pagination .-pageJump input {\r\n    width: 70px;\r\n    text-align: center\r\n}\r\n\r\n.ReactTable .-pagination .-pageSizeOptions {\r\n    margin: 3px 10px\r\n}\r\n\r\n.ReactTable .rt-noData {\r\n    display: block;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    background: rgba(255, 255, 255, 0.8);\r\n    transition: all .3s ease;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n    padding: 20px;\r\n    color: rgba(0, 0, 0, 0.5)\r\n}\r\n\r\n.ReactTable .-loading {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    transition: all .3s ease;\r\n    z-index: -1;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.ReactTable .-loading > div {\r\n    position: absolute;\r\n    display: block;\r\n    text-align: center;\r\n    width: 100%;\r\n    top: 50%;\r\n    left: 0;\r\n    font-size: 15px;\r\n    color: rgba(0, 0, 0, 0.6);\r\n    -webkit-transform: translateY(-52%);\r\n    transform: translateY(-52%);\r\n    transition: all .3s cubic-bezier(.25, .46, .45, .94)\r\n}\r\n\r\n.ReactTable .-loading.-active {\r\n    opacity: 1;\r\n    z-index: 2;\r\n    pointer-events: all;\r\n}\r\n\r\n.ReactTable .-loading.-active > div {\r\n    -webkit-transform: translateY(50%);\r\n    transform: translateY(50%)\r\n}\r\n\r\n.ReactTable .rt-resizing .rt-th,\r\n.ReactTable .rt-resizing .rt-td {\r\n    transition: none !important;\r\n    cursor: col-resize;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none\r\n}\r\n",".bootstrap-tagsinput .tag a{\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-left: 10px;\r\n  cursor: pointer;\r\n  transform: translate(0, -50%);\r\n  color: #fff;\r\n\r\n  &::after {\r\n    font-size: 16px;\r\n    content: \"×\";\r\n  }\r\n}\r\n",".badge + .badge {\r\n  margin-left: 4px;\r\n}\r\n.badge.badge-dot i {\r\n  margin-right: .6rem;\r\n}\r\n",".btn + .btn {\r\n  margin-left: 4px;\r\n}\r\n.btn-group + .btn-group {\r\n  margin-left: 4px;\r\n}\r\n.btn.btn-sm.btn-.btn-icon-only.text-light{\r\n  background-color: transparent;\r\n}\r\n.input-group {\r\n  .btn + .btn {\r\n    margin-left: -1px;\r\n  }\r\n}\r\n","@each $color, $value in $theme-colors {\r\n    .custom-checkbox-#{$color} .custom-control-input:checked ~ .custom-control-label::after {\r\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\r\n    }\r\n}\r\n",".icon-actions {\r\n  a i + span{\r\n    margin-left: 7px;\r\n  }\r\n  a + a {\r\n    margin-left: 4px;\r\n  }\r\n}\r\n","button:focus, :focus {\r\n  outline: none;\r\n}\r\n","@keyframes show-navbar-dropdown {\r\n  0% {\r\n    opacity: 0;\r\n    transition: visibility 0.25s, opacity 0.25s;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
